/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 * 
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 * 
 */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("jquery")) : "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof exports ? exports.OktaSignIn = e(require("jquery")) : t.OktaSignIn = e(t.jQuery);
}("undefined" != typeof self ? self : this, function (t) {
  return function (t) {
    function e(r) {
      if (n[r]) return n[r].exports;
      var i = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
    }
    var n = {};
    return e.m = t, e.c = n, e.d = function (t, n, r) {
      e.o(t, n) || Object.defineProperty(t, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 272);
  }([function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    var i = n(77),
      o = r(i),
      a = n(89),
      s = r(a),
      u = n(167),
      c = r(u); /*! THIS FILE IS GENERATED FROM PACKAGE @okta/courage@4.6.0-beta.3298.g75d547c */
    t.exports = function (t) {
      function e(r) {
        if (n[r]) return n[r].exports;
        var i = n[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return t[r].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
      }
      var n = {};
      return e.m = t, e.c = n, e.d = function (t, n, r) {
        e.o(t, n) || (0, c.default)(t, n, {
          configurable: !1,
          enumerable: !0,
          get: r
        });
      }, e.n = function (t) {
        var n = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return e.d(n, "a", n), n;
      }, e.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, e.p = "", e(e.s = 33);
    }([function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(5),
        i = n.n(r),
        o = n(35),
        a = n.n(o),
        s = a.a.noConflict();
      s.mixin({
        resultCtx: function resultCtx(t, e, n, r) {
          var i = s.isObject(t) ? t[e] : void 0;
          return s.isFunction(i) && (i = i.call(n || t)), i || (s.isUndefined(r) ? i : r);
        },
        isInteger: function isInteger(t) {
          return s.isNumber(t) && t % 1 == 0;
        },
        template: function template(t, e) {
          var n = i.a.compile(t);
          return e ? n(e) : function (t) {
            return n(t);
          };
        }
      }), e.default = s;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(6),
        i = n.n(r),
        o = n(0),
        a = n(22),
        u = n(4),
        c = o.default.clone(i.a.Events),
        l = {
          constructor: function constructor() {
            a.a.apply(this, arguments), this.module && this.$el.attr("data-view", this.module.id);
          },
          empty: function empty() {
            return this.removeChildren();
          },
          compileTemplate: u.default.tpl,
          broadcast: function broadcast() {
            return c.trigger.apply(c, arguments), this;
          },
          listen: function listen(t, e) {
            return c.off(t, e), this.listenTo(c, t, e), this;
          },
          notify: function notify(t, e, n) {
            return this.broadcast("notification", o.default.defaults({
              message: e,
              level: t
            }, n)), this;
          },
          confirm: function confirm(t, e, n, r) {
            var i = void 0;
            return i = "object" === (void 0 === t ? "undefined" : (0, s.default)(t)) ? t : 2 === arguments.length && o.default.isFunction(e) ? {
              title: "Okta",
              subtitle: t,
              ok: e
            } : {
              title: t,
              subtitle: e,
              ok: n,
              cancelFn: r
            }, o.default.isFunction(i.ok) && (i.ok = o.default.bind(i.ok, this)), o.default.isFunction(i.cancelFn) && (i.cancelFn = o.default.bind(i.cancelFn, this)), this.broadcast("confirmation", i), this;
          },
          alert: function alert(t) {
            return o.default.isString(t) && (t = {
              subtitle: t
            }), this.confirm(o.default.extend({}, t, {
              noCancelButton: !0
            })), this;
          }
        };
      e.default = a.a.extend(l, {
        decorate: function decorate(t) {
          var e = t.extend({});
          return o.default.defaults(e.prototype, l), e;
        }
      });
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(12),
        i = n.n(r);
      i.a.ajaxSetup({
        beforeSend: function beforeSend(t) {
          t.setRequestHeader("X-Okta-XsrfToken", i()("#_xsrfToken").text());
        },
        converters: {
          "text secureJSON": function textSecureJSON(t) {
            return "while(1){};" === t.substring(0, 11) && (t = t.substring(11)), JSON.parse(t);
          }
        }
      }), window.jQueryCourage = i.a, e.default = i.a;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(2),
        i = n(0),
        a = n(39),
        s = n.n(a),
        u = {
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'",
          "&#039;": "'",
          "&#x2F;": "/"
        },
        c = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?!-)((\[?[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\]?)|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        l = {
          sprintf: function sprintf() {
            function t() {
              throw new Error("Mismatch number of variables: " + arguments[0] + ", " + (0, o.default)(e));
            }
            for (var e = Array.prototype.slice.apply(arguments), n = e.shift(), r = n, i = 0, a = e.length; i < a; i++) {
              var s = e[i];
              n = n.replace("{" + i + "}", s), void 0 !== s && null !== s && n !== r || t(), r = n;
            }
            return /\{[\d+]\}/.test(n) && t(), n;
          },
          parseQuery: function parseQuery(t) {
            for (var e = {}, n = decodeURIComponent(t.replace(/\+/g, " ")).split("&"), r = 0; r < n.length; r++) {
              var i = n[r],
                o = i.split("=");
              e[o.shift()] = o.join("=");
            }
            return e;
          },
          encodeJSObject: function encodeJSObject(t) {
            return encodeURIComponent((0, o.default)(t));
          },
          decodeJSObject: function decodeJSObject(t) {
            try {
              return JSON.parse(decodeURIComponent(t));
            } catch (t) {
              return null;
            }
          },
          unescapeHtml: function unescapeHtml(t) {
            return String(t).replace(/&[\w#\d]{2,};/g, function (t) {
              return u[t] || t;
            });
          },
          getTemplate: function getTemplate(t, e) {
            var n = e ? s.a[e] : s.a[i.default.keys(s.a)[0]];
            return n ? n[t] || "L10N_ERROR[" + t + "]" : "L10N_ERROR[" + e + "]";
          },
          localize: function localize(t, e, n) {
            var r = e ? s.a[e] : s.a[i.default.keys(s.a)[0]];
            if (!r) return "L10N_ERROR[" + e + "]";
            var o = r[t];
            try {
              n = n && n.slice ? n.slice(0) : [], n.unshift(o), o = l.sprintf.apply(null, n);
            } catch (t) {
              o = null;
            }
            return o || "L10N_ERROR[" + t + "]";
          },
          parseFloat: function (t) {
            function e(e) {
              return t.apply(this, arguments);
            }
            return e.toString = function () {
              return t.toString();
            }, e;
          }(function (t) {
            var e = +t;
            return "string" == typeof t && e === parseFloat(t) ? e : t;
          }),
          parseInt: function (t) {
            function e(e) {
              return t.apply(this, arguments);
            }
            return e.toString = function () {
              return t.toString();
            }, e;
          }(function (t) {
            var e = +t;
            return i.default.isString(t) && e === parseInt(t, 10) ? e : t;
          }),
          parseObject: function parseObject(t) {
            if (!i.default.isString(t)) return t;
            try {
              var e = JSON.parse(t);
              return r.default.isPlainObject(e) ? e : t;
            } catch (e) {
              return t;
            }
          },
          randomString: function randomString(t) {
            var e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
            if (void 0 === t) t = i.default.random(e.length);else if (0 === t) return "";
            for (var n = []; t--;) n.push(e[i.default.random(e.length - 1)]);
            return n.join("");
          },
          endsWith: function endsWith(t, e) {
            return t += "", e += "", t.length >= e.length && t.substring(t.length - e.length) === e;
          },
          isEmail: function isEmail(t) {
            var e = r.default.trim(t);
            return !i.default.isEmpty(e) && c.test(e);
          }
        };
      e.default = l;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(5),
        i = n.n(r),
        o = n(0);
      e.default = {
        tpl: o.default.memoize(function (t) {
          return i.a.compile(t);
        })
      };
    }, function (t, e) {
      t.exports = n(233);
    }, function (t, e) {
      t.exports = n(492);
    }, function (t, e, n) {
      function r(t, e) {
        window.console && window.okta && window.okta.debug && window.console[t].apply(window.console, e);
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = {
        trace: function trace() {
          return r("trace", arguments);
        },
        dir: function dir() {
          return r("dir", arguments);
        },
        time: function time() {
          return r("time", arguments);
        },
        timeEnd: function timeEnd() {
          return r("timeEnd", arguments);
        },
        group: function group() {
          return r("group", arguments);
        },
        groupEnd: function groupEnd() {
          return r("groupEnd", arguments);
        },
        assert: function assert() {
          return r("assert", arguments);
        },
        log: function log() {
          return r("log", arguments);
        },
        info: function info() {
          return r("info", arguments);
        },
        warn: function warn() {
          return r("warn", arguments);
        },
        error: function error() {
          return r("error", arguments);
        }
      };
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = {
        UP: 38,
        DOWN: 40,
        DEL: 46,
        TAB: 9,
        RETURN: 13,
        ENTER: 13,
        ESC: 27,
        COMMA: 188,
        PAGEUP: 33,
        PAGEDOWN: 34,
        SPACE: 32,
        BACKSPACE: 8,
        __isKey: function __isKey(t, e) {
          return (t.which || t.keyCode) === this[e];
        },
        isEnter: function isEnter(t) {
          return this.__isKey(t, "ENTER");
        },
        isEsc: function isEsc(t) {
          return this.__isKey(t, "ESC");
        },
        isSpaceBar: function isSpaceBar(t) {
          return this.__isKey(t, "SPACE");
        }
      };
    }, function (t, e, n) {
      function r(t) {
        if (t && !t.__edit__) return s.default.extend({
          __edit__: s.default.constant(!0)
        }, t);
      }
      function i(t) {
        t = s.default.pick(t || {}, "action", "id", "className", "text", "type");
        var e = void 0,
          n = void 0,
          r = void 0;
        return p.default.extend({
          tagName: "input",
          className: "button",
          events: {
            click: function click() {
              t.action && !this.disabled() && t.action.call(this);
            },
            keyup: function keyup(e) {
              u.default.isEnter(e) && t.action && !this.disabled() && t.action.call(this);
            }
          },
          disabled: function disabled() {
            return !0 === this.$el.prop("disabled");
          },
          disable: function disable() {
            this.$el.prop("disabled", !0), this.$el.addClass("btn-disabled");
          },
          enable: function enable() {
            this.$el.prop("disabled", !1), this.$el.removeClass("btn-disabled");
          },
          initialize: function initialize() {
            var r = this;
            this.$el.attr("type", "save" === t.type ? "submit" : "button"), this.$el.val(t.text), t.id && this.$el.attr("id", t.id), t.className && this.$el.addClass(t.className), t.type && this.$el.attr("data-type", t.type), this.$el.mousedown(function () {
              r.model.set("__pending__", !0);
            }), this.$el.mouseup(function () {
              r.model.set("__pending__", !1);
            }), this.listenTo(this.model, "form:set-saving-state", function () {
              this.disable(), "save" === t.type && (e = setTimeout(s.default.bind(this.__changeSaveText, this), 1e3));
            }), this.listenTo(this.model, "form:clear-saving-state", function () {
              this.enable(), "save" === t.type && (clearTimeout(e), clearInterval(n), this.$el.val(t.text));
            });
          },
          __changeSaveText: function __changeSaveText() {
            r = 0, n = setInterval(s.default.bind(this.__showLoadingText, this), 200);
          },
          __showLoadingText: function __showLoadingText() {
            this.$el.val(_[r++ % _.length]);
          }
        });
      }
      function o(t, e) {
        if (t || (t = {}), "label" === t.type) return void (t.label || c.default.warn('A label input must have a "label" parameter', t));
        if ("button" === t.type) return t.title || t.icon || c.default.warn('A button input must have a "title" and/or an "icon" parameter', t), void (t.click || t.href || c.default.warn('A button input must have a "click" and/or an "href" parameter', t));
        if (t.name || t.input || c.default.warn('Missing "name" or "input" parameters', t), s.default.isArray(t.name) && s.default.isArray(t.input)) throw new Error('Not allowed to have both "name" and "input" defined as array.');
        if ("list" !== t.type && t.name && e && e.allows) {
          var n = [];
          s.default.isArray(t.name) ? n = t.name : n.push(t.name), s.default.each(n, function (n) {
            if (!e.allows(n)) throw new Error("field not allowed: " + t.name);
          });
        }
        s.default.isArray(t.input) && "list" !== t.type && s.default.each(t.input, function (t) {
          o(t, e);
        });
        var r = s.default.keys(t),
          i = s.default.intersection(r, y);
        if (s.default.size(i) !== s.default.size(t)) {
          var a = s.default.clone(y);
          a.unshift(r), c.default.warn("Invalid input parameters", s.default.without.apply(null, a), t);
        }
      }
      function a(t, e, n) {
        t = s.default.clone(t), s.default.contains(["list", "group"], t.type) && (t.params = s.default.defaults({
          create: n,
          inputs: s.default.map(s.default.isArray(t.input) ? t.input : [t.input], function (t) {
            return s.default.first(a(t, e, n));
          })
        }, t.params || {}), delete t.input);
        var r = s.default.isArray(t.input) ? s.default.clone(t.input) : [t];
        return s.default.map(r, function (n) {
          var r = s.default.defaults({
            model: e.model
          }, n, s.default.omit(t, "input", "inputs"), e.options, {
            id: s.default.uniqueId("input"),
            readOnly: e.isReadOnly(),
            read: e.hasReadMode()
          });
          return e.isReadOnly() && (r.read = r.readOnly = !0), r;
        });
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var s = n(0),
        u = n(8),
        c = n(7),
        l = n(3),
        f = n(24),
        p = n(1),
        d = ["model", "id", "inputId", "type", "label", "sublabel", "tooltip", "name"],
        h = ["wide", "multi", "input", "label-top", "explain", "explain-top", "customExplain", "model", "name", "type", "autoRender"],
        m = ["model", "name", "label-top", "readOnly", "events", "initialize", "showWhen", "bindings", "render", "className", "data-se", "toggleWhen"],
        g = ["model", "name", "inputId", "type", "input", "placeholder", "label", "readOnly", "read", "disabled", "readModeString", "options", "deps", "from", "to", "autoRender", "inlineValidation", "validateOnlyIfDirty", "ariaLabel", "params"],
        v = ["errorField"],
        y = s.default.uniq(s.default.union(d, h, m, g, v)),
        _ = ["•         ", "•  •      ", "•  •  •   ", "•  •  •  •", "   •  •  •", "      •  •", "         •", "          ", "          ", "          "];
      e.default = {
        LABEL_OPTIONS: d,
        CONTAINER_OPTIONS: h,
        WRAPPER_OPTIONS: m,
        INPUT_OPTIONS: g,
        generateInputOptions: a,
        changeEventString: function changeEventString(t) {
          return "change:" + t.join(" change:");
        },
        createReadFormButton: function createReadFormButton(t) {
          var e = void 0,
            n = void 0,
            r = void 0;
          return "cancel" === t.type ? (n = r = l.default.localize("oform.cancel", "courage"), e = function e() {
            this.model.trigger("form:cancel");
          }) : (n = l.default.localize("oform.edit", "courage"), r = n + " " + t.formTitle, e = function e() {
            this.model.set("__edit__", !0);
          }), p.default.extend({
            tagName: "a",
            attributes: {
              href: "#",
              "aria-label": r
            },
            template: function template() {
              return s.default.escape(n);
            },
            events: {
              click: function click(t) {
                t.preventDefault(), e.call(this);
              }
            }
          });
        },
        createButton: function createButton(t) {
          switch (t = s.default.clone(t), t.type) {
            case "save":
              s.default.defaults(t, {
                className: "button-primary"
              });
              break;
            case "cancel":
              s.default.defaults(t, {
                text: l.default.localize("oform.cancel", "courage"),
                action: function action() {
                  this.model.trigger("form:cancel");
                }
              });
              break;
            case "previous":
              s.default.defaults(t, {
                text: l.default.localize("oform.previous", "courage"),
                action: function action() {
                  this.model.trigger("form:previous");
                }
              });
          }
          return i(t);
        },
        validateInput: o,
        applyShowWhen: function applyShowWhen(t, e) {
          var n = function n(e) {
            return function () {
              t.$el.toggle(e), t.model.trigger("form:resize");
            };
          };
          f.a.applyDoWhen(t, r(e), function (e, r) {
            r.animate ? t.$el["slide" + (e ? "Down" : "Up")](200, n(e)) : t.$el.toggle(e);
          });
        },
        applyToggleWhen: function applyToggleWhen(t, e) {
          f.a.applyDoWhen(t, r(e), function (e, n) {
            t.$el.toggle(e), t.model.trigger("form:resize"), n.animate && t.render();
          });
        }
      };
    }, function (t, e, n) {
      var r = n(2),
        i = n(0),
        o = n(23),
        a = n(3),
        s = n(1),
        u = n(29);
      e.a = s.default.extend({
        tagName: "span",
        attributes: function attributes() {
          return {
            "data-se": "o-form-input-" + this.getNameString()
          };
        },
        defaultPlaceholder: "",
        constructor: function constructor(t) {
          t = i.default.defaults(t || {}, {
            inputId: t.id || i.default.uniqueId("input"),
            placeholder: this.defaultPlaceholder,
            inlineValidation: !0,
            validateOnlyIfDirty: !1
          }), delete t.id;
          var e = this;
          i.default.each({
            enable: "removeClass",
            disable: "addClass"
          }, function (t, n) {
            e[n] = i.default.wrap(e[n], function (n) {
              n.apply(e, arguments), e.$el[t]("o-form-disabled");
            });
          }), s.default.call(this, t), !0 !== i.default.result(t, "readOnly") && !0 === i.default.result(t, "read") && this.listenTo(this.model, "change:__edit__", this.render), i.default.isFunction(this.focus) && (this.focus = i.default.debounce(i.default.bind(this.focus, this), 50)), i.default.result(t, "validateOnlyIfDirty") || this.addInlineValidation(), this.addModelListeners(), this.$el.addClass("o-form-input-name-" + this.getNameString());
        },
        addAriaLabel: function addAriaLabel() {
          var t = this.options.ariaLabel;
          t && this.$(":input").attr("aria-label", t);
        },
        addInlineValidation: function addInlineValidation() {
          i.default.result(this.options, "inlineValidation") && this.$el.on("focusout", ":input", i.default.bind(this.validate, this));
        },
        toModelValue: function toModelValue() {
          var t = this.val();
          return i.default.isFunction(this.to) && (t = this.to.call(this, t)), i.default.isFunction(this.options.to) && (t = this.options.to.call(this, t)), t;
        },
        __getDependencyCalloutBtn: function __getDependencyCalloutBtn(t) {
          var e = this,
            n = i.default.clone(t),
            a = n.click || function () {};
          return n.click = function () {
            Object(r.default)(window).one("focus.dependency", function () {
              e.__showInputDependencies();
            }), a.call(e);
          }, new (s.default.extend({
            children: [o.default.create(n)]
          }))();
        },
        getCalloutParent: function getCalloutParent() {
          return this.$('input[value="' + this.getModelValue() + '"]').parent();
        },
        __getCalloutMsgContainer: function __getCalloutMsgContainer(t) {
          return s.default.extend({
            template: '        <span class="o-form-explain">           {{msg}}        </span>        ',
            getTemplateData: function getTemplateData() {
              return {
                msg: t
              };
            }
          });
        },
        showCallout: function showCallout(t, e) {
          var n = i.default.clone(t);
          n.className = "dependency-callout", n.btn && (n.content = this.__getDependencyCalloutBtn(n.btn), delete n.btn);
          var r = u.default.create(n);
          e || r.add(this.__getCalloutMsgContainer(a.default.localize("dependency.callout.msg", "courage"))), this.getCalloutParent().append(r.render().el), "success" === n.type && i.default.delay(function () {
            r.$el.fadeOut(800);
          }, 1e3);
        },
        removeCallout: function removeCallout() {
          this.$el.find(".dependency-callout").remove();
        },
        __evaluateCalloutObject: function __evaluateCalloutObject(t, e) {
          return t ? {
            title: a.default.localize("dependency.action.completed", "courage"),
            size: "large",
            type: "success"
          } : {
            title: a.default.localize("dependency.action.required", "courage", [e]),
            size: "large",
            type: "warning"
          };
        },
        __handleDependency: function __handleDependency(t, e) {
          var n = this,
            r = i.default.isFunction(e) ? e(t) : i.default.extend({}, e, n.__evaluateCalloutObject(t.resolved, e.title));
          n.removeCallout(), n.showCallout(r, t.resolved);
        },
        __showInputDependencies: function __showInputDependencies() {
          var t = this,
            e = t.options.deps[t.getModelValue()];
          e && i.default.isFunction(e.func) ? e.func().done(function (n) {
            t.__handleDependency({
              resolved: !0,
              data: n
            }, e.callout);
          }).fail(function (n) {
            t.__handleDependency({
              resolved: !1,
              data: n
            }, e.callout);
          }) : t.removeCallout();
        },
        _isEdited: !1,
        update: function update() {
          !this._isEdited && i.default.result(this.options, "validateOnlyIfDirty") && (this._isEdited = !0, this.addInlineValidation()), this.model.set(this.options.name, this.toModelValue()), this.options.deps && this.__showInputDependencies();
        },
        isEditMode: function isEditMode() {
          return !i.default.result(this.options, "readOnly") && (!0 !== i.default.result(this.options, "read") || !0 === this.model.get("__edit__"));
        },
        render: function render() {
          this.preRender();
          var t = this.options.params;
          return this.options.params = i.default.resultCtx(this.options, "params", this), this.isEditMode() ? (this.editMode(), i.default.resultCtx(this.options, "disabled", this) ? this.disable() : this.enable()) : this.readMode(), this.options.params = t, this.addAriaLabel(), this.postRender(), this;
        },
        validate: function validate() {
          if (!this.model.get("__pending__") && this.isEditMode() && i.default.isFunction(this.model.validateField)) {
            var t = this.model.validateField(this.options.name);
            t && i.default.delay(function () {
              this.model.trigger("form:clear-error:" + this.options.name), this.model.trigger("invalid", this.model, t, !1);
            }.bind(this), 100);
          }
        },
        addModelListeners: function addModelListeners() {
          this.listenTo(this.model, "form:field-error", function (t) {
            this.options.name === t && this.__markError();
          }), this.listenTo(this.model, "form:clear-errors change:" + this.options.name, this.__clearError), this.listenTo(this.model, "form:clear-error:" + this.options.name, this.__clearError);
        },
        val: function val() {
          throw new Error("val() is an abstract method");
        },
        focus: function focus() {
          throw new Error("focus() is an abstract method");
        },
        defaultValue: function defaultValue() {
          return "";
        },
        editMode: function editMode() {
          var t = i.default.extend({}, this.options, {
            value: this.getModelValue()
          });
          return this.$el.html(this.template(t)), this.options.multi && this.$el.removeClass("margin-r"), this;
        },
        readMode: function readMode() {
          return this.$el.text(this.getReadModeString()), this.$el.removeClass("error-field"), this.options.multi && this.$el.addClass("margin-r"), this;
        },
        getReadModeString: function getReadModeString() {
          var t = i.default.resultCtx(this.options, "readModeString", this);
          return t || this.toStringValue();
        },
        getModelValue: function getModelValue() {
          var t = this.model.get(this.options.name);
          return i.default.isFunction(this.from) && (t = this.from.call(this, t)), i.default.isFunction(this.options.from) && (t = this.options.from.call(this, t)), t;
        },
        toStringValue: function toStringValue() {
          var t = this.getModelValue();
          return this.options.options && (t = this.options.options[t]), t || this.defaultValue();
        },
        resize: function resize() {
          this.model.trigger("form:resize");
        },
        disable: function disable() {
          this.$(":input").prop("disabled", !0);
        },
        enable: function enable() {
          this.$(":input").prop("disabled", !1);
        },
        changeType: function changeType(t) {
          this.$(":input").prop("type", t), this.options.type = t;
        },
        getNameString: function getNameString() {
          return i.default.isArray(this.options.name) ? this.options.name.join("-") : this.options.name;
        },
        getParams: function getParams(t) {
          var e = t || this.options || {};
          return i.default.clone(i.default.resultCtx(e, "params", this) || {});
        },
        getParam: function getParam(t, e) {
          var n = i.default.resultCtx(this.getParams(), t, this);
          return i.default.isUndefined(n) ? e : n;
        },
        getParamOrAttribute: function getParamOrAttribute(t) {
          return this.getParam(t) || i.default.result(this, t);
        },
        __markError: function __markError() {
          this.$el.addClass("o-form-has-errors");
        },
        __clearError: function __clearError() {
          this.$el.removeClass("o-form-has-errors");
        }
      });
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(0),
        i = n(37);
      e.default = i.a.extend({
        secureJSON: !1,
        _builtInLocalProps: {
          __edit__: "boolean",
          __pending__: "boolean"
        },
        constructor: function constructor() {
          this.local = r.default.defaults({}, r.default.result(this, "local"), this._builtInLocalProps), r.default.result(this, "secureJSON") && (this.sync = r.default.wrap(this.sync, function (t, e, n, i) {
            return t.call(this, e, n, r.default.extend({
              dataType: "secureJSON"
            }, i));
          })), i.a.apply(this, arguments);
        }
      });
    }, function (t, e) {
      t.exports = n(120);
    }, function (t, e, n) {
      var r = n(0),
        i = n(3),
        o = i.default.localize,
        a = {
          STRING: "string",
          NUMBER: "number",
          INTEGER: "integer",
          BOOLEAN: "boolean",
          OBJECT: "object",
          FORMATDISPLAYTYPE: {
            "date-time": "date",
            uri: "uri",
            email: "email",
            "country-code": "country-code",
            "language-code": "language-code",
            country_code: "country_code",
            language_code: "language_code",
            locale: "locale",
            timezone: "timezone",
            "ref-id": "reference"
          },
          ARRAYDISPLAYTYPE: {
            arrayofobject: "arrayofobject",
            arrayofstring: "arrayofstring",
            arrayofnumber: "arrayofnumber",
            arrayofinteger: "arrayofinteger",
            "arrayofref-id": "arrayofref-id"
          },
          DISPLAYTYPES: {
            date: {
              type: "string",
              format: "date-time"
            },
            uri: {
              type: "string",
              format: "uri"
            },
            email: {
              type: "string",
              format: "email"
            },
            "country-code": {
              type: "string",
              format: "country-code"
            },
            "language-code": {
              type: "string",
              format: "language-code"
            },
            country_code: {
              type: "string"
            },
            language_code: {
              type: "string"
            },
            locale: {
              type: "string",
              format: "locale"
            },
            timezone: {
              type: "string",
              format: "timezone"
            },
            string: {
              type: "string"
            },
            number: {
              type: "number"
            },
            boolean: {
              type: "boolean"
            },
            integer: {
              type: "integer"
            },
            reference: {
              type: "string",
              format: "ref-id"
            },
            arrayofobject: {
              type: "array",
              items: {
                type: "object"
              }
            },
            arrayofstring: {
              type: "array",
              items: {
                type: "string"
              }
            },
            arrayofnumber: {
              type: "array",
              items: {
                type: "number"
              }
            },
            arrayofinteger: {
              type: "array",
              items: {
                type: "integer"
              }
            },
            "arrayofref-id": {
              type: "array",
              items: {
                type: "string",
                format: "ref-id"
              }
            },
            image: {
              type: "image"
            },
            password: {
              type: "string"
            }
          },
          SUPPORTSMINMAX: ["string", "number", "integer", "password"],
          SUPPORTENUM: ["string", "number", "integer", "object", "arrayofstring", "arrayofnumber", "arrayofinteger", "arrayofobject"],
          DATATYPE: {
            string: "string",
            number: "number",
            boolean: "boolean",
            integer: "integer",
            date: "datetime",
            object: "object",
            arrayofobject: "object array",
            arrayofstring: "string array",
            arrayofnumber: "number array",
            arrayofinteger: "integer array",
            "arrayofref-id": "reference array",
            "country-code": "country code",
            "language-code": "language code",
            country_code: "country code",
            language_code: "language code",
            reference: "reference",
            timezone: "timezone",
            image: "image"
          },
          MUTABILITY: {
            READONLY: "READ_ONLY",
            WRITEONLY: "WRITE_ONLY",
            READWRITE: "READ_WRITE",
            IMMUTABLE: "IMMUTABLE"
          },
          SCOPE: {
            NONE: "NONE",
            SELF: "SELF",
            SYSTEM: "SYSTEM"
          },
          DISPLAYSCOPE: {
            SELF: "User personal",
            SYSTEM: "System",
            NA: "None"
          },
          UNION: {
            DISABLE: "DISABLE",
            ENABLE: "ENABLE"
          },
          UNION_OPTIONS: {
            DISABLE: o("universal-directory.profiles.attribute.form.union.enable.display", "courage"),
            ENABLE: o("universal-directory.profiles.attribute.form.union.disable.display", "courage")
          },
          PERMISSION: {
            HIDE: "HIDE",
            READ_ONLY: "READ_ONLY",
            WRITE_ONLY: "WRITE_ONLY",
            READ_WRITE: "READ_WRITE"
          },
          ENDUSER_ATTRIBUTE_PERMISSION_OPTIONS: {
            HIDE: o("universal-directory.profiles.attribute.enduser.permission.hide", "courage"),
            READ_ONLY: o("universal-directory.profiles.attribute.enduser.permission.readonly", "courage"),
            READ_WRITE: o("universal-directory.profiles.attribute.enduser.permission.readwrite", "courage")
          },
          ATTRIBUTE_LEVEL_MASTERING_OPTIONS: {
            INHERIT: o("universal-directory.profiles.attribute.master.inherit", "courage"),
            OKTA_MASTERED: o("universal-directory.profiles.attribute.master.oktamastered", "courage"),
            OVERRIDE: o("universal-directory.profiles.attribute.master.override", "courage")
          },
          USERNAMETYPE: {
            NONE: "non-username",
            OKTA_TO_APP: "okta-to-app-username",
            OKTA_TO_AD: "okta-to-ad-username",
            APP_TO_OKTA: "app-to-okta-username",
            IDP_TO_OKTA: "idp-to-okta-username"
          },
          LOGINPATTERNFORMAT: {
            EMAIL: "EMAIL",
            CUSTOM: "CUSTOM",
            NONE: "NONE"
          },
          UNIQUENESS: {
            NOT_UNIQUE: "NOT_UNIQUE",
            PENDING_UNIQUENESS: "PENDING_UNIQUENESS",
            UNIQUE_VALIDATED: "UNIQUE_VALIDATED"
          },
          getDisplayType: function getDisplayType(t, e, n, r) {
            var i = void 0;
            return t && (i = e ? this.FORMATDISPLAYTYPE[e] : n ? this.ARRAYDISPLAYTYPE[t + "of" + n] : t), i || (i = void 0 === r ? "" : r), i;
          },
          getSourceUsernameType: function getSourceUsernameType(t, e, n) {
            var r = this.USERNAMETYPE.NONE;
            return "oktaToApp" === t ? "userName" === e ? r = this.USERNAMETYPE.OKTA_TO_APP : "cn" === e && (r = this.USERNAMETYPE.OKTA_TO_AD) : "appToOkta" === t && "login" === e && (r = "saml_idp" === n ? this.USERNAMETYPE.IDP_TO_OKTA : this.USERNAMETYPE.APP_TO_OKTA), r;
          },
          isArrayDataType: function isArrayDataType(t) {
            return r.default.contains(r.default.values(this.ARRAYDISPLAYTYPE), t);
          },
          isObjectDataType: function isObjectDataType(t) {
            return this.DATATYPE.object === t;
          }
        };
      e.a = a;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(0),
        i = n(36);
      e.default = i.a.extend({
        secureJSON: !1,
        constructor: function constructor() {
          r.default.result(this, "secureJSON") && (this.sync = r.default.wrap(this.sync, function (t, e, n, i) {
            return t.call(this, e, n, r.default.extend({
              dataType: "secureJSON"
            }, i));
          })), i.a.apply(this, arguments);
        }
      });
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(0),
        i = n(11),
        o = function o(t) {
          var e = r.default.omit(t.local, r.default.keys(t._builtInLocalProps));
          return r.default.size(t.props) + r.default.size(e) > 0;
        },
        a = i.default.extend({
          flat: !1,
          constructor: function constructor() {
            i.default.apply(this, arguments), this.on("sync", this._setSynced);
          },
          allows: function allows() {
            return !o(this) || i.default.prototype.allows.apply(this, arguments);
          },
          set: function set(t, e) {
            var n = void 0;
            return "object" === (void 0 === t ? "undefined" : (0, s.default)(t)) ? n = t : (n = {})[t] = e, Object(r.default)(n).each(function (t, e) {
              t && r.default.isArray(t.__attributes) && this.on("change:" + t.__attributes.join(" change:"), function () {
                var t = this.get(e);
                t !== this.__schema__.computedProperties[e] && (this.__schema__.computedProperties[e] = t, this.trigger("change:" + e, t));
              }, this);
            }, this), i.default.prototype.set.apply(this, arguments);
          },
          get: function get() {
            var t = i.default.prototype.get.apply(this, arguments);
            return r.default.isFunction(t) ? t.apply(this, r.default.map(t.__attributes || [], this.get, this)) : t;
          },
          toJSON: function toJSON(t) {
            t || (t = {});
            var e = i.default.prototype.toJSON.apply(this, arguments);
            return Object(r.default)(e).each(function (n, r) {
              "function" == typeof n && (t.verbose ? e[r] = this.get(r) : delete e[r]);
            }, this), t.verbose || Object(r.default)(e).each(function (t, n) {
              /^__\w+__$/.test(n) && delete e[n];
            }), e;
          },
          sanitizeAttributes: function sanitizeAttributes(t) {
            var e = {};
            return r.default.each(t, function (t, n) {
              r.default.isFunction(t) || (e[n] = t);
            }), e;
          },
          reset: function reset(t) {
            this.clear(t), this.set(this.sanitizeAttributes(this.defaults), t);
          },
          clear: function clear(t) {
            var e = {};
            return r.default.each(this.sanitizeAttributes(this.attributes), function (t, n) {
              e[n] = void 0;
            }), this.set(e, r.default.extend({}, t, {
              unset: !0
            }));
          },
          _setSynced: function _setSynced(t) {
            this._syncedData = t && r.default.isFunction(t.toJSON) ? t.toJSON() : {};
          },
          _getSynced: function _getSynced() {
            return this._syncedData;
          },
          isSynced: function isSynced() {
            return r.default.isEqual(this._getSynced(), this.toJSON());
          }
        }, {
          ComputedProperty: function ComputedProperty() {
            var t = r.default.toArray(arguments),
              e = t.pop();
            return e.__attributes = t.pop(), e;
          }
        });
      e.default = a;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(0),
        i = n(1);
      e.default = {
        redirect: function redirect(t) {
          window.location = t;
        },
        reloadPage: function reloadPage() {
          window.location.reload();
        },
        constantError: function constantError(t) {
          return function () {
            throw new Error(t);
          };
        },
        getUrlQueryString: function getUrlQueryString(t) {
          r.default.isObject(t) || (t = {});
          var e = r.default.without(r.default.map(t, function (t, e) {
            if (void 0 !== t && null !== t) return e + "=" + encodeURIComponent(t);
          }), void 0).join("&");
          return r.default.isEmpty(e) ? "" : "?" + e;
        },
        isABaseView: function isABaseView(t) {
          return t instanceof i.default || t.prototype instanceof i.default || t === i.default;
        }
      };
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(2),
        i = n(0),
        a = n(14),
        s = n(15),
        u = n(7),
        c = n(13),
        l = n(3),
        f = n(18),
        p = l.default.localize,
        d = c.a.STRING,
        h = c.a.NUMBER,
        m = c.a.INTEGER,
        g = c.a.OBJECT,
        v = function v(t, e) {
          return t + "of" + e;
        },
        y = s.default.extend({
          defaults: {
            description: void 0,
            minLength: void 0,
            maxLength: void 0,
            format: void 0
          },
          parse: function parse(t) {
            if (i.default.isString(t.format)) {
              var e = /^\/(.+)\/$/.exec(t.format);
              e && (t.format = e[1]);
            }
            return t;
          }
        }),
        _ = a.default.extend({
          model: y
        }),
        b = _.extend({
          _type: "allOf"
        }),
        w = _.extend({
          _type: "oneOf"
        }),
        S = _.extend({
          _type: "noneOf"
        }),
        x = {
          string: p("schema.validation.field.value.must.string", "courage"),
          number: p("schema.validation.field.value.must.number", "courage"),
          integer: p("schema.validation.field.value.must.integer", "courage"),
          object: p("schema.validation.field.value.must.object", "courage")
        },
        E = /[^a-zA-Z0-9-]/,
        T = s.default.extend({
          constraintHandlers: {
            between: "_checkBetweenConstraints",
            greaterThan: "_checkGreaterThanConstraint",
            lessThan: "_checkLessThanConstraint",
            equals: "_checkEqualsConstraint"
          },
          idAttribute: "name",
          local: {
            __oneOf__: {
              type: "array",
              minItems: 1
            }
          },
          defaults: {
            name: "",
            title: void 0,
            type: void 0,
            description: void 0,
            required: !1,
            format: void 0,
            union: void 0,
            subSchemas: void 0,
            settings: {
              permissions: {
                SELF: c.a.PERMISSION.READ_ONLY
              }
            },
            unique: void 0,
            __metadata__: void 0,
            __isSensitive__: s.default.ComputedProperty(["settings"], function (t) {
              return !(!t || !t.sensitive);
            }),
            __unique__: !1,
            __isUniqueValidated__: s.default.ComputedProperty(["unique"], function (t) {
              return t === c.a.UNIQUENESS.UNIQUE_VALIDATED;
            }),
            __isPendingUniqueness__: s.default.ComputedProperty(["unique"], function (t) {
              return t === c.a.UNIQUENESS.PENDING_UNIQUENESS;
            }),
            __isUniqueness__: s.default.ComputedProperty(["__isUniqueValidated__", "__isPendingUniqueness__"], function (t, e) {
              return t || e;
            }),
            __canBeSensitive__: s.default.ComputedProperty(["__metadata__"], function (t) {
              return !(!t || !t.sensitivizable);
            }),
            __userPermission__: c.a.PERMISSION.READ_ONLY,
            __displayType__: void 0,
            __displayTypeLabel__: s.default.ComputedProperty(["__displayType__"], function (t) {
              return c.a.DATATYPE[t] || t;
            }),
            __supportsMinMax__: !1,
            __isReadOnly__: s.default.ComputedProperty(["mutability"], function (t) {
              return t === c.a.MUTABILITY.READONLY;
            }),
            __isWriteOnly__: s.default.ComputedProperty(["mutability"], function (t) {
              return t === c.a.MUTABILITY.WRITEONLY;
            }),
            __displayScope__: void 0,
            __isScopeSelf__: s.default.ComputedProperty(["scope"], function (t) {
              return t === c.a.SCOPE.SELF;
            }),
            __isNoneScopeArrayType__: s.default.ComputedProperty(["__isScopeSelf__", "__displayType__"], function (t, e) {
              return !t && c.a.isArrayDataType(e);
            }),
            __isImported__: s.default.ComputedProperty(["externalName"], function (t) {
              return !!t;
            }),
            __isFromBaseSchema__: s.default.ComputedProperty(["__schemaMeta__"], function (t) {
              return t && "base" === t.name;
            }),
            __enumDefined__: !1,
            __supportEnum__: s.default.ComputedProperty(["__displayType__"], function (t) {
              return i.default.contains(c.a.SUPPORTENUM, t);
            }),
            __isNumberTypeEnum__: s.default.ComputedProperty(["__displayType__"], function (t) {
              return i.default.contains([c.a.NUMBER, c.a.ARRAYDISPLAYTYPE.arrayofnumber], t);
            }),
            __isIntegerTypeEnum__: s.default.ComputedProperty(["__displayType__"], function (t) {
              return i.default.contains([c.a.INTEGER, c.a.ARRAYDISPLAYTYPE.arrayofinteger], t);
            }),
            __isObjectTypeEnum__: s.default.ComputedProperty(["__displayType__"], function (t) {
              return i.default.contains([c.a.OBJECT, c.a.ARRAYDISPLAYTYPE.arrayofobject], t);
            }),
            __isStringTypeEnum__: s.default.ComputedProperty(["__displayType__"], function (t) {
              return i.default.contains([c.a.STRING, c.a.ARRAYDISPLAYTYPE.arrayofstring], t);
            }),
            __enumConstraintType__: s.default.ComputedProperty(["__isStringTypeEnum__", "__isNumberTypeEnum__", "__isIntegerTypeEnum__", "__isObjectTypeEnum__"], function (t, e, n, r) {
              return t ? d : e ? h : n ? m : r ? g : void 0;
            }),
            __isEnumDefinedAndSupported__: s.default.ComputedProperty(["__enumDefined__", "__supportEnum__"], function (t, e) {
              return t && e;
            }),
            __isLoginOfBaseSchema__: s.default.ComputedProperty(["__isFromBaseSchema__", "name"], function (t, e) {
              return t && "login" === e;
            }),
            __isLoginFormatRestrictionToEmail__: s.default.ComputedProperty(["__loginFormatRestriction__"], function (t) {
              return t === c.a.LOGINPATTERNFORMAT.EMAIL;
            })
          },
          initialize: function initialize() {
            s.default.prototype.initialize.apply(this, arguments), this.listenTo(this, "change:__displayType__", this._updateTypeFormatConstraints), this.listenTo(this, "change:type change:format change:items", this._updateDisplayType), this.listenTo(this, "change:__minVal__ change:__maxVal__", this._updateMinMax), this.listenTo(this, "change:__equals__", this._convertEqualsToMinMax), this.listenTo(this, "change:__constraint__", this._setConstraintText), this._setConstraintText(), this._setLoginPattern();
          },
          parse: function parse(t) {
            return t = i.default.clone(t), "object" === t.type && "image" === t.extendedType && (t.type = "image"), t.__displayType__ = c.a.getDisplayType(t.type, t.format, t.items ? t.items.format ? t.items.format : t.items.type : void 0), this._setRangeConstraints(t), t.__supportsMinMax__ = -1 !== c.a.SUPPORTSMINMAX.indexOf(t.__displayType__), t.__displayScope__ = c.a.DISPLAYSCOPE[t.scope] || c.a.DISPLAYSCOPE.NA, t.settings && t.settings.permissions && t.settings.permissions.SELF && (t.__userPermission__ = t.settings.permissions.SELF), this._setMasterOverride(t), this._setSubSchemas(t), this._setUniqueness(t), t;
          },
          validate: function validate() {
            var t = this._validateEnumOneOf();
            if (t) return t;
            if (this.get("__supportsMinMax__") && this.get("__constraint__")) {
              var e = this.get("__constraint__"),
                n = this[this.constraintHandlers[e]];
              return i.default.isFunction(n) ? n.call(this) : void u.default.warn("No constraint handler found for: " + e);
            }
          },
          _checkBetweenConstraints: function _checkBetweenConstraints() {
            var t = this.get("__minVal__"),
              e = this.get("__maxVal__");
            if (t || e) {
              if (!t) return {
                __minVal__: "Min value is required"
              };
              if (!e) return {
                __maxVal__: "Max value is required"
              };
              var n = this._checkIntegerConstraints("__minVal__", "Min value");
              return n || (n = this._checkIntegerConstraints("__maxVal__", "Max value")) || (+t >= +e ? {
                __maxVal__: "Max val must be greater than min val"
              } : void 0);
            }
          },
          _checkGreaterThanConstraint: function _checkGreaterThanConstraint() {
            if (this.get("__minVal__")) {
              var t = this._checkIntegerConstraints("__minVal__", "Min value");
              return t || void 0;
            }
          },
          _checkLessThanConstraint: function _checkLessThanConstraint() {
            if (this.get("__maxVal__")) {
              var t = this._checkIntegerConstraints("__maxVal__", "Max value");
              return t || void 0;
            }
          },
          _checkEqualsConstraint: function _checkEqualsConstraint() {
            if (this.get("__equals__")) {
              var t = this._checkIntegerConstraints("__equals__", "Constraint");
              return t || void 0;
            }
          },
          _checkIntegerConstraints: function _checkIntegerConstraints(t, e) {
            var n = this.get(t),
              r = {};
            return isNaN(n) ? (r[t] = e + " must be a number", r) : +n < 0 ? (r[t] = e + " must be greater than 0", r) : void 0;
          },
          _setMasterOverride: function _setMasterOverride(t) {
            if (t.settings && t.settings.masterOverride && t.settings.masterOverride) {
              var e = t.settings.masterOverride.value;
              i.default.isArray(e) && !i.default.isEmpty(e) ? (t.__masterOverrideType__ = "OVERRIDE", t.__masterOverrideValue__ = e || []) : t.__masterOverrideType__ = t.settings.masterOverride.type;
            } else t.__masterOverrideType__ = "INHERIT";
          },
          _setRangeConstraints: function _setRangeConstraints(t) {
            t.__displayType__ === d ? (t.__minVal__ = t.minLength, t.__maxVal__ = t.maxLength) : t.__displayType__ !== m && t.__displayType__ !== h || (t.__minVal__ = t.minimum, t.__maxVal__ = t.maximum), t.__minVal__ && t.__maxVal__ ? t.__minVal__ === t.__maxVal__ ? (t.__constraint__ = "equals", t.__equals__ = t.__minVal__) : t.__constraint__ = "between" : !t.__minVal__ && t.__maxVal__ ? t.__constraint__ = "lessThan" : !t.__maxVal__ && t.__minVal__ && (t.__constraint__ = "greaterThan");
          },
          _setSubSchemas: function _setSubSchemas(t) {
            t.allOf ? t.subSchemas = new b(t.allOf, {
              parse: !0
            }) : t.oneOf ? t.subSchemas = new w(t.oneOf, {
              parse: !0
            }) : t.noneOf && (t.subSchemas = new S(t.noneOf, {
              parse: !0
            }));
          },
          _setUniqueness: function _setUniqueness(t) {
            var e = t && t.unique;
            t.__unique__ = !(!e || e !== c.a.UNIQUENESS.UNIQUE_VALIDATED && e !== c.a.UNIQUENESS.PENDING_UNIQUENESS);
          },
          _setLoginPattern: function _setLoginPattern() {
            if (this.get("__isLoginOfBaseSchema__")) {
              var t = this.get("pattern");
              ".+" === t ? this.set("__loginFormatRestriction__", c.a.LOGINPATTERNFORMAT.NONE) : t ? (this.set("__loginFormatRestriction__", c.a.LOGINPATTERNFORMAT.CUSTOM), this.set("__loginFormatRestrictionCustom__", this._extractLoginPattern(t))) : this.set("__loginFormatRestriction__", c.a.LOGINPATTERNFORMAT.EMAIL);
            }
          },
          _updateDisplayType: function _updateDisplayType() {
            var t = this.get("type");
            if (t === d && this.get("format")) this.set("__displayType__", c.a.FORMATDISPLAYTYPE[this.get("format")]);else {
              var e = this.get("items"),
                n = e && (e.format ? e.format : e.type);
              t && n ? this.set("__displayType__", c.a.ARRAYDISPLAYTYPE[v(t, n)]) : this.set("__displayType__", t);
            }
          },
          _validateEnumOneOf: function _validateEnumOneOf() {
            if (this.get("__isEnumDefinedAndSupported__")) {
              var t = this.get("__oneOf__") || [];
              if (i.default.isEmpty(t)) return {
                __oneOf__: p("model.validation.field.blank", "courage")
              };
              if (!this._isValidateOneOfConstraint(t)) {
                var e = this.get("__enumConstraintType__");
                return {
                  __oneOf__: x[e]
                };
              }
            }
          },
          _isValidateOneOfConstraint: function _isValidateOneOfConstraint(t) {
            var e = this.get("__enumConstraintType__");
            return i.default.all(t, function (t) {
              return f.a.isConstraintValueMatchType(t.const, e);
            });
          },
          toJSON: function toJSON() {
            var t = s.default.prototype.toJSON.apply(this, arguments);
            return t.settings = {
              permissions: {}
            }, t.settings.permissions.SELF = this.get("__userPermission__"), this.get("__isSensitive__") && (t.settings.sensitive = this.get("__isSensitive__")), "image" === this.get("type") && (t.type = "object", t.extendedType = "image"), t = this._enumAssignment(t), t = this._attributeOverrideToJson(t), t = this._normalizeUnionValue(t), t = this._patternAssignment(t), t = this._uniquenessAssignment(t);
          },
          _attributeOverrideToJson: function _attributeOverrideToJson(t) {
            var e = this.get("__masterOverrideType__"),
              n = this.get("__masterOverrideValue__");
            return "OKTA_MASTERED" === e ? t.settings.masterOverride = {
              type: "OKTA_MASTERED"
            } : "OVERRIDE" === e && (t.settings.masterOverride = {
              type: "ORDERED_LIST",
              value: []
            }, n instanceof a.default ? i.default.each(n.toJSON(), function (e) {
              t.settings.masterOverride.value.push(e.id);
            }) : n instanceof Array && (t.settings.masterOverride.value = n), i.default.isEmpty(t.settings.masterOverride.value) && delete t.settings.masterOverride), "INHERIT" === e && delete t.settings.masterOverride, t;
          },
          _normalizeUnionValue: function _normalizeUnionValue(t) {
            return this.get("__isNoneScopeArrayType__") || (t.union = void 0), t;
          },
          _enumAssignment: function _enumAssignment(t) {
            if (!this.get("__isEnumDefinedAndSupported__")) return t;
            var e = this._getEnumOneOfWithTitleCheck();
            return "array" === this.get("type") ? (delete t.items.enum, t.items.oneOf = e) : (delete t.enum, t.oneOf = e), t;
          },
          _patternAssignment: function _patternAssignment(t) {
            if (!this.get("__isLoginOfBaseSchema__") || !this.get("__loginFormatRestriction__")) return t;
            switch (this.get("__loginFormatRestriction__")) {
              case c.a.LOGINPATTERNFORMAT.EMAIL:
                delete t.pattern;
                break;
              case c.a.LOGINPATTERNFORMAT.CUSTOM:
                t.pattern = this._buildLoginPattern(this.get("__loginFormatRestrictionCustom__"));
                break;
              case c.a.LOGINPATTERNFORMAT.NONE:
                t.pattern = ".+";
            }
            return t;
          },
          _uniquenessAssignment: function _uniquenessAssignment(t) {
            return this.get("__unique__") ? this.get("__isUniqueness__") || (t.unique = c.a.UNIQUENESS.UNIQUE_VALIDATED) : delete t.unique, t;
          },
          _escapedRegexChar: function _escapedRegexChar(t, e) {
            var n = t.charAt(e);
            return E.test(n) ? "\\" + n : n;
          },
          _buildLoginPattern: function _buildLoginPattern(t) {
            for (var e = "", n = 0; n < t.length; n++) e += this._escapedRegexChar(t, n);
            return "[" + e + "]+";
          },
          _extractLoginPattern: function _extractLoginPattern(t) {
            var e = /^\[(.*)\]\+/,
              n = t.match(e);
            return n ? n[1].replace(/\\(.)/g, "$1") : t;
          },
          _getEnumOneOfWithTitleCheck: function _getEnumOneOfWithTitleCheck() {
            var t = this.get("__oneOf__");
            return i.default.map(t, function (t) {
              return "" !== r.default.trim(t.title) ? t : (t.title = i.default.isString(t.const) ? t.const : (0, o.default)(t.const), t);
            });
          },
          _updateTypeFormatConstraints: function _updateTypeFormatConstraints() {
            var t = this.get("__displayType__");
            this.unset("format", {
              silent: !0
            }), this.unset("items", {
              silent: !0
            }), this.set(c.a.DISPLAYTYPES[t]), t !== h && t !== m && (this.unset("minimum"), this.unset("maximum")), t !== d && (this.unset("minLength"), this.unset("maxLength")), this.unset("__minVal__"), this.unset("__maxVal__"), this.unset("__equals__"), this.set("__supportsMinMax__", -1 !== c.a.SUPPORTSMINMAX.indexOf(this.get("__displayType__")));
          },
          _updateMinMax: function _updateMinMax() {
            var t = void 0,
              e = void 0,
              n = this.get("__displayType__");
            n === d ? (t = "minLength", e = "maxLength") : n !== m && n !== h || (t = "minimum", e = "maximum"), this.get("__minVal__") ? this.set(t, parseInt(this.get("__minVal__"), 10)) : this.unset(t), this.get("__maxVal__") ? this.set(e, parseInt(this.get("__maxVal__"), 10)) : this.unset(e);
          },
          _convertEqualsToMinMax: function _convertEqualsToMinMax() {
            var t = this.get("__equals__");
            t && (this.set("__minVal__", t), this.set("__maxVal__", t));
          },
          _setConstraintText: function _setConstraintText() {
            var t = this.get("__constraint__"),
              e = this.get("__minVal__"),
              n = this.get("__maxVal__"),
              r = this.get("__equals__");
            switch (t) {
              case "between":
                this.set("__constraintText__", "Between " + e + " and " + n);
                break;
              case "greaterThan":
                this.set("__constraintText__", "Greater than " + e);
                break;
              case "lessThan":
                this.set("__constraintText__", "Less than " + n);
                break;
              case "equals":
                this.set("__constraintText__", "Equals " + r);
                break;
              default:
                this.set("__constraintText__", "");
            }
          },
          cleanup: function cleanup() {
            "lessThan" === this.get("__constraint__") ? this.unset("__minVal__") : "greaterThan" === this.get("__constraint__") && this.unset("__maxVal__"), this.get("scope") !== c.a.SCOPE.SYSTEM && (!0 === this.get("__isScopeSelf__") ? this.set({
              scope: c.a.SCOPE.SELF
            }, {
              silent: !0
            }) : this.unset("scope")), this.get("__unique__") || this.unset("unique");
          },
          isEnumType: function isEnumType() {
            return !!this.getEnumValues();
          },
          getEnumValues: function getEnumValues() {
            return this.get("oneOf") || this.get("enum") || this.get("items") && this.get("items").oneOf || this.get("items") && this.get("items").enum;
          },
          detectHasEnumDefined: function detectHasEnumDefined() {
            var t = this.getEnumValues();
            t && (this.set("__oneOf__", f.a.convertToOneOf(t)), this.set("__enumDefined__", !0));
          }
        }),
        k = a.default.extend({
          model: T,
          clone: function clone() {
            return new this.constructor(this.toJSON({
              verbose: !0
            }), {
              parse: !0
            });
          },
          areAllReadOnly: function areAllReadOnly() {
            return i.default.all(this.pluck("__isReadOnly__"));
          },
          createModelProperties: function createModelProperties() {
            return this.reduce(function (t, e) {
              var n = e.get("type");
              return t[e.id] = i.default.clone(c.a.DISPLAYTYPES[n]), -1 !== c.a.SUPPORTSMINMAX.indexOf(n) && (t[e.id].minLength = e.get("minLength"), t[e.id].maxLength = e.get("maxLength")), "string" === n && (t[e.id].format = e.get("format")), t;
            }, {});
          }
        });
      e.default = {
        Model: T,
        Collection: k
      };
    }, function (t, e, n) {
      function r(t) {
        var e = s(t.enumValues),
          n = {
            name: t.name,
            label: t.title,
            readOnly: t.readOnly,
            customExplain: t.explain,
            params: {
              enumOneOf: e
            },
            options: a(e)
          };
        return E.a.isArrayDataType(t.displayType) ? (n.type = "checkboxset", n.to = m, n.from = g) : (n.type = "select", n.to = h, n.from = d), n.input = null, n;
      }
      function i(t) {
        return x.default.isArray(t) ? a(s(t)) : {};
      }
      function a(t) {
        return u(t) ? x.default.reduce(t, function (t, e, n) {
          return t[p(n)] = e.title, t;
        }, {}) : {};
      }
      function s(t) {
        return x.default.all(t, S.default.isPlainObject) ? u(t) ? t : f(t) : c(t);
      }
      function u(t) {
        return x.default.isArray(t) && x.default.all(t, function (t) {
          return x.default.has(t, "const") && x.default.has(t, "title");
        });
      }
      function c(t) {
        return x.default.map(t, function (t) {
          return {
            const: t,
            title: l(t)
          };
        });
      }
      function l(t) {
        return x.default.isObject(t) ? (0, o.default)(t) : x.default.isNumber(t) ? t + "" : t;
      }
      function f(t) {
        var e = x.default.partial(x.default.has, x.default, k);
        return x.default.all(t, e) ? x.default.chain(t).filter(function (t) {
          return S.default.isPlainObject(t) && x.default.has(t, k);
        }).map(function (t) {
          return {
            const: t,
            title: t[k]
          };
        }).value() : c(t);
      }
      function p(t) {
        return "" + A + t;
      }
      function d(t) {
        var e = x.default.findIndex(this.options.params.enumOneOf, function (e) {
          return x.default.isObject(t) ? x.default.isEqual(e.const, t) : e.const === t;
        });
        return e > -1 ? p(e) : t;
      }
      function h(t) {
        if (!x.default.isString(t) || 0 !== t.indexOf(A)) return t;
        var e = t.replace(A, ""),
          n = this.options.params && x.default.isArray(this.options.params.enumOneOf) ? this.options.params.enumOneOf[e] : null;
        return x.default.has(n, "const") ? n.const : n;
      }
      function m(t) {
        return x.default.map(t, h.bind(this));
      }
      function g(t) {
        return x.default.map(t, d.bind(this));
      }
      function v(t) {
        return x.default.isString(t) && "" !== S.default.trim(t);
      }
      function y(t) {
        return x.default.isNumber(t) || x.default.isNumber(T.default.parseFloat(S.default.trim(t)));
      }
      function _(t) {
        var e = x.default.isNumber(t) ? t : T.default.parseInt(S.default.trim(t));
        return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
      }
      function b(t) {
        if (x.default.isObject(t) && !x.default.isArray(t)) return !0;
        var e = T.default.parseObject(S.default.trim(t));
        return x.default.isObject(e) && !x.default.isArray(e);
      }
      function w(t, e) {
        switch (e) {
          case E.a.STRING:
            return v(t);
          case E.a.NUMBER:
            return y(t);
          case E.a.INTEGER:
            return _(t);
          case E.a.OBJECT:
            return b(t);
        }
      }
      var S = n(2),
        x = n(0),
        E = n(13),
        T = n(3),
        k = "name",
        A = "_enum_";
      e.a = {
        getEnumInputOptions: r,
        getDropdownOptions: i,
        convertToOneOf: s,
        isConstraintValueMatchType: w
      };
    }, function (t, e, n) {
      function r(t, e) {
        var n = s.default.result(t, "root") || "";
        return n && s.default.isString(e) ? [n, e].join("/").replace(/\/{2,}/g, "/") : e;
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i = n(6),
        o = n.n(i),
        a = n(2),
        s = n(0),
        u = n(7),
        c = n(20),
        l = n(21),
        f = n.n(l),
        p = n(41);
      e.default = o.a.Router.extend({
        root: "",
        listen: p.a.prototype.listen,
        constructor: function constructor(t) {
          t || (t = {}), this.el = t.el, this.settings = new c.a(s.default.omit(t, "el")), t.root && (this.root = t.root), o.a.Router.apply(this, arguments), this.listen("notification", this._notify), this.listen("confirmation", this._confirm);
        },
        _confirm: function _confirm(t) {
          t || (t = {});
          var e = f.a.extend(s.default.pick(t, "title", "subtitle", "save", "ok", "cancel", "cancelFn", "noCancelButton", "content", "danger", "type", "closeOnOverlayClick")),
            n = new e({
              model: this.settings
            });
          return n.render(), n;
        },
        _notify: function _notify(t) {
          var e = new p.a(t);
          return Object(a.default)("#content").prepend(e.render().el), e;
        },
        render: function render(t, e) {
          this.unload(), e = s.default.extend(s.default.pick(this, "settings", "el"), e || {}), this.controller = new t(e), this.controller.render();
        },
        start: function start() {
          var t = arguments;
          Object(a.default)(function () {
            if (o.a.History.started) return void u.default.error("History has already been started");
            o.a.history.start.apply(o.a.history, t);
          });
        },
        unload: function unload() {
          this.controller && (this.stopListening(this.controller), this.stopListening(this.controller.state), this.controller.remove());
        },
        route: function route(t, e, n) {
          return o.a.Router.prototype.route.call(this, r(this, t), e, n);
        },
        navigate: function navigate(t, e) {
          return o.a.Router.prototype.navigate.call(this, r(this, t), e);
        }
      });
    }, function (t, e, n) {
      var r = n(0),
        i = n(11);
      e.a = i.default.extend({
        local: function local() {
          var t = window.okta && window.okta.settings || {};
          return {
            orgId: ["string", !1, t.orgId],
            orgName: ["string", !1, t.orgName],
            serverStatus: ["string", !1, t.serverStatus],
            persona: ["string", !1, t.persona],
            isDeveloperConsole: ["boolean", !1, t.isDeveloperConsole],
            isPreview: ["boolean", !1, t.isPreview],
            permissions: ["array", !0, t.permissions || []]
          };
        },
        extraProperties: !0,
        constructor: function constructor() {
          this.features = window._features || [], i.default.apply(this, arguments);
        },
        hasFeature: function hasFeature(t) {
          return window._possibleFeatures && !r.default.contains(window._possibleFeatures, t) && window.okta && window.okta.logHasFeatureError && window.okta.logHasFeatureError(t), r.default.contains(this.features, t);
        },
        hasAnyFeature: function hasAnyFeature(t) {
          return r.default.some(t, this.hasFeature, this);
        },
        hasPermission: function hasPermission(t) {
          return r.default.contains(this.get("permissions"), t);
        }
      });
    }, function (t, e, n) {
      var r;
      void 0 !== (r = function () {}.call(e, n, e, t)) && (t.exports = r);
    }, function (t, e, n) {
      function r(t, e) {
        for (var n = 0; n < t[l].length; n++) if (e.cid === t[l][n].cid) return n;
      }
      function i() {}
      function o(t) {
        t[f] = !0;
        var e = t.renderTemplate(t.template);
        e ? t.$el.html(e) : t.length && t.$el.empty(), t.each(function (t) {
          t[d]();
        });
      }
      function a(t) {
        var e = /^(?!(?:delegate|undelegate|_))([a-zA-Z0-9]+)(?:Events)$/;
        s.default.each(s.default.allKeys(t), function (n) {
          var r = n.match(e);
          if (r) {
            var i = s.default.result(t, n),
              o = t.options[r[1]] || t[r[1]];
            o && s.default.isObject(i) && s.default.isFunction(o.trigger) && s.default.each(i, function (e, n) {
              var r = s.default.isFunction(e) ? [e] : s.default.reduce(e.split(/\s+/), function (e, n) {
                return s.default.isFunction(t[n]) && e.push(t[n]), e;
              }, []);
              s.default.each(r, function (e) {
                t.listenTo(o, n, e);
              });
            });
          }
        });
      }
      var s = n(0),
        u = n(6),
        c = n.n(u),
        l = "__children__",
        f = "__rendered__",
        p = "__parent__",
        d = "__add_to_container__",
        h = c.a.View.extend({
          constructor: function constructor(t) {
            this.options = t || {}, s.default.extend(this, s.default.pick(this.options, "state", "settings")), this[l] = [], this[f] = !1, this[p] = null, this.__children_definitions__ = this.children;
            var e = this.initialize;
            if (this.initialize = i, c.a.View.apply(this, arguments), s.default.each(s.default.result(this, "__children_definitions__"), function (t) {
              this.add.apply(this, s.default.isArray(t) ? t : [t]);
            }, this), delete this.__children_definitions__, this.autoRender && this.model) {
              var n = s.default.isArray(this.autoRender) ? s.default.map(this.autoRender, function (t) {
                return "change:" + t;
              }).join(" ") : "change";
              this.listenTo(this.model, n, function () {
                this.render();
              });
            }
            this.initialize = e, this.initialize.apply(this, arguments), a(this);
          },
          unregister: function unregister(t) {
            this.stopListening(t);
            var e = r(this, t);
            s.default.isNumber(e) && this[l].splice(e, 1);
          },
          autoRender: !1,
          template: null,
          children: [],
          add: function add(t, e, n, i, o) {
            var a = {},
              u = s.default.toArray(arguments);
            if (s.default.isObject(e) ? (a = e, e = a.selector, n = a.bubble, i = a.prepend, o = a.options) : s.default.isObject(n) && (a = n, n = a.bubble, i = a.prepend, o = a.options), s.default.isString(t) && (t = function (t) {
              return h.extend({
                constructor: function constructor() {
                  try {
                    var e = c.a.$(t);
                    if (1 != e.length) throw "invalid Element";
                    var n = /&(\w+|#x\d+);/g;
                    if (e.prop("outerHTML").replace(n, " ").length !== t.replace(n, " ").length) throw "invalid Element";
                    this.template = e.html(), this.el = e.empty()[0];
                  } catch (e) {
                    this.template = t;
                  }
                  h.apply(this, arguments);
                }
              });
            }(t)), t.prototype && t.prototype instanceof h) {
              var f = s.default.omit(s.default.extend({}, this.options, o), "el");
              return u[0] = new t(f), this.add.apply(this, u);
            }
            if (s.default.isNumber(r(this, t))) throw new Error("Duplicate child");
            return t[p] = this, t[d] = function (e) {
              return function () {
                if (e && 1 != t[p].$(e).length) throw new Error("Invalid selector: " + e);
                var n = e ? this[p].$(e) : this[p].$el;
                this.render(), this.delegateEvents(), i ? n.prepend(this.el) : n.append(this.el);
              };
            }.call(t, e), n && this.listenTo(t, "all", function () {
              this.trigger.apply(this, arguments);
            }), this.rendered() && t[d](), this[l].push(t), this;
          },
          removeChildren: function removeChildren() {
            return this.each(function (t) {
              t.remove();
            }), this;
          },
          remove: function remove() {
            return this.removeChildren(), this[p] && this[p].unregister(this), c.a.View.prototype.remove.apply(this, arguments);
          },
          compileTemplate: function compileTemplate(t) {
            return s.default.template(t);
          },
          renderTemplate: function renderTemplate(t) {
            if (s.default.isString(t) && (t = this.compileTemplate(t)), s.default.isFunction(t)) return t(this.getTemplateData());
          },
          getTemplateData: function getTemplateData() {
            var t = this.model && this.model.toJSON({
                verbose: !0
              }) || {},
              e = s.default.omit(this.options, ["state", "settings", "model", "collection"]);
            return s.default.defaults({}, t, e);
          },
          render: function render() {
            return this.preRender(), o(this), this.postRender(), this;
          },
          preRender: i,
          postRender: i,
          rendered: function rendered() {
            return this[f];
          },
          getChildren: function getChildren() {
            return this.toArray();
          },
          at: function at(t) {
            return this.getChildren()[t];
          },
          invoke: function invoke(t) {
            var e = s.default.toArray(arguments);
            return this.each(function (n) {
              n.size() && n.invoke.apply(n, e), s.default.isFunction(n[t]) && n[t].apply(n, e.slice(1));
            }), this;
          }
        }),
        m = ["each", "map", "reduce", "reduceRight", "find", "filter", "reject", "every", "some", "contains", "toArray", "size", "first", "initial", "rest", "last", "without", "indexOf", "shuffle", "lastIndexOf", "isEmpty", "chain", "where", "findWhere"];
      s.default.each(m, function (t) {
        h.prototype[t] = function () {
          var e = s.default.toArray(arguments);
          return e.unshift(s.default.toArray(this[l])), s.default[t].apply(s.default, e);
        };
      }, this), e.a = h;
    }, function (t, e, n) {
      function r(t) {
        var e = i.default.extend(t.click ? {
            click: t.click
          } : {}, t.events || {}),
          n = {};
        return i.default.each(e, function (e, r) {
          n[r] = function (n) {
            t.href || (n.preventDefault(), n.stopPropagation()), e.apply(this, arguments);
          };
        }), n;
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i = n(0),
        o = n(43);
      e.default = {
        create: function create(t) {
          return t = i.default.clone(t), t.attrs = t.attributes, delete t.attributes, o.a.extend(i.default.extend(t, {
            events: r(t)
          }));
        }
      };
    }, function (t, e, n) {
      function r(t) {
        return "change:" + a.default.keys(t).join(" change:");
      }
      function i(t, e) {
        var n = this.model.get(e);
        return a.default.isFunction(t) ? t.call(this, n) : t === n;
      }
      function o(t, e, n) {
        var i = a.default.bind(n, t, t, e);
        t.render = a.default.wrap(t.render, function (e) {
          var n = e.call(t);
          return i({
            animate: !1
          }), n;
        }), t.listenTo(t.model, r(e), function () {
          i({
            animate: !0
          });
        });
      }
      var a = n(0);
      e.a = {
        applyDoWhen: function applyDoWhen(t, e, n) {
          t.model && a.default.isObject(e) && a.default.size(e) && a.default.isFunction(n) && o(t, e, function (t, e, r) {
            var o = a.default.every(a.default.map(e, i, t));
            n.call(t, o, r);
          });
        }
      };
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(0),
        i = n(1),
        o = n(9);
      e.default = i.default.extend({
        className: "o-form-button-bar",
        initialize: function initialize(t) {
          this.addButton({
            type: "save",
            text: r.default.resultCtx(t, "save", this),
            id: r.default.resultCtx(t, "saveId", this),
            className: r.default.resultCtx(t, "saveClassName", this)
          }), t.noCancelButton || this.addButton({
            type: "cancel",
            text: r.default.resultCtx(t, "cancel", this)
          }), t.hasPrevStep && this.addButton({
            type: "previous"
          }, {
            prepend: !0
          });
        },
        addButton: function addButton(t, e) {
          return this.add(o.default.createButton(t), e);
        }
      });
    }, function (t, e, n) {
      function r(t) {
        return i.default.isFunction(t) ? i.default.isFunction(t.prototype.editMode) && i.default.isFunction(t.prototype.readMode) : i.default.isObject(t) && i.default.isFunction(t.editMode) && i.default.isFunction(t.readMode);
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i = n(0),
        o = {};
      e.default = {
        isBaseInput: r,
        register: function register(t, e) {
          o[t] = e;
        },
        get: function get(t) {
          var e = o[t.type];
          return e && (r(e) ? e : e(t));
        },
        unregister: function unregister(t) {
          delete o[t];
        }
      };
    }, function (t, e) {
      t.exports = n(168);
    }, function (t, e, n) {
      function r(t) {
        return this.params.autoWidth ? t.call(this) : u.default.defer(u.default.bind(t, this));
      }
      function i(t) {
        t.$select.hide();
        var e = Object(s.default)(t.$select[0]).hide();
        Object(s.default)("body").append(e);
        var n = t.params.width = 1.2 * e.width() + "px";
        return t.$el.append(e.show()), n;
      }
      function o(t, e, n) {
        var r = n.offset();
        t.css({
          left: r.left,
          top: r.top
        });
        var i = Object(s.default)(window),
          o = e.outerHeight(),
          a = o + e.offset().top - i.scrollTop(),
          u = i.height() - m,
          c = Math.min(o + u - a, g);
        e.css("max-height", c);
      }
      function a(t) {
        var e = t.next(".chzn-container"),
          n = e.clone(),
          r = e.find(".chzn-results");
        n.css("visibility", "hidden"), n.removeAttr("id"), n.find("li").removeAttr("id");
        var i = {
          left: e.css("left"),
          top: e.css("top"),
          position: e.css("position"),
          float: e.css("float"),
          "z-index": e.css("z-index")
        };
        r.hide();
        var a = u.default.debounce(function () {
          o(e, r, n);
        }, 10);
        t.off(".fixChosen"), t.on("liszt:showing_dropdown.fixChosen", function () {
          e.width(e.width()), t.after(n), e.css({
            position: "absolute",
            float: "none",
            "z-index": v,
            top: -999999
          }), Object(s.default)("body").append(e), r.show(), o(e, r, n), t.parents().scroll(a), Object(s.default)(window).on("resize scroll", a);
        }), t.on("liszt:hiding_dropdown.fixChosen remove.fixChosen", function () {
          t.parents().off("scroll", a), Object(s.default)(window).off("resize scroll", a), e.css(i), r.hide(), r.css("max-height", g), n.remove(), t.after(e);
        });
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var s = n(2),
        u = n(0),
        c = n(8),
        l = n(4),
        f = n(67),
        p = (n.n(f), n(10)),
        d = l.default.tpl('<select id="{{inputId}}" name="{{name}}"></select>'),
        h = l.default.tpl('<option value="{{key}}">{{value}}</option>'),
        m = 20,
        g = 240,
        v = 5e4;
      e.default = p.a.extend({
        className: "o-form-select",
        events: {
          "change select": "update",
          "keyup .chzn-search > :text": function keyupChznSearchText(t) {
            c.default.isEsc(t) && (this.$(".chzn-search > :text").val(""), t.stopPropagation());
          }
        },
        constructor: function constructor() {
          this.template = d, this.option = h, p.a.apply(this, arguments), this.params = this.options.params || {};
        },
        editMode: function editMode() {
          this.$el.html(d(this.options)), this.$select = this.$("select");
          var t = this.getOptions();
          u.default.each(t, function (t, e) {
            this.$select.append(h({
              key: e,
              value: t
            }));
          }, this);
          var e = this.getModelValue();
          return e ? this.$select.val(e) : this.$("option:first-child").prop("selected", !0), this.$el.addClass("o-form-control"), !1 !== this.params.chosen && this.__applyChosen(), this;
        },
        __applyChosen: function __applyChosen(t) {
          var e = this.options.wide ? "100%" : this.params.width || "62%";
          this.params.autoWidth && (e = i(this)), r.call(this, function () {
            var n = this.getParam("searchThreshold", 10);
            u.default.result(this.options, "autoRender") || !1 === t || this.update(), this.$select.chosen({
              width: e,
              disable_search_threshold: n,
              placeholder_text: this.options.placeholder,
              search_contains: !0
            }), a(this.$select), this.params.autoWidth && this.$el.width(0), this.model.trigger("form:resize");
          });
        },
        val: function val() {
          return this.$select && this.$select.val();
        },
        focus: function focus() {
          if (this.$select) return this.$select.focus();
        },
        toStringValue: function toStringValue() {
          var t = this.getModelValue(),
            e = t,
            n = this.getOptions();
          return u.default.isEmpty(n) || (e = n[t]), u.default.isUndefined(e) && (e = this.defaultValue()), e || "";
        },
        getOptions: function getOptions() {
          var t = this.options.options;
          return u.default.isFunction(t) && (t = t.call(this)), u.default.isObject(t) ? t : {};
        },
        remove: function remove() {
          return this.$select && this.$select.trigger("remove"), p.a.prototype.remove.apply(this, arguments);
        }
      });
    }, function (t, e, n) {
      function r(t, e) {
        return o.default.resultCtx(t.options, e, t) || o.default.result(t, e);
      }
      function i(t) {
        var e = "infobox clearfix infobox-" + r(t, "type");
        switch (r(t, "size")) {
          case "standard":
            e += "";
            break;
          case "slim":
            e += " infobox-slim";
            break;
          case "compact":
            e += " infobox-compact";
            break;
          case "large":
            e += " infobox-md";
        }
        return r(t, "dismissible") && (e += " infobox-dismiss"), e;
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o = n(0),
        a = n(30),
        s = n(1),
        u = {
          "click .infobox-dismiss-link": function clickInfoboxDismissLink(t) {
            var e = this;
            t.preventDefault(), this.$el.fadeOut(a.a.UNLOADING_FADE, function () {
              e.trigger("dismissed"), e.remove();
            });
          }
        },
        c = s.default.extend({
          attributes: {
            "data-se": "callout"
          },
          content: null,
          size: "standard",
          type: "info",
          dismissible: !1,
          title: null,
          subtitle: null,
          bullets: null,
          constructor: function constructor() {
            this.events = o.default.defaults(this.events || {}, u), s.default.apply(this, arguments), this.$el.addClass(i(this)), this.template = '    {{#if dismissible}}      <a data-se="dismiss-link" class="infobox-dismiss-link" title="Dismiss" href="#">        <span data-se="icon" class="dismiss-icon"></span>      </a>    {{/if}}    <span data-se="icon" class="icon {{icon}}"></span>    {{#if title}}<h3 data-se="header">{{title}}</h3>{{/if}}    {{#if subtitle}}<p data-se="sub-header">{{subtitle}}</p>{{/if}}    {{#if bullets}}      <ul data-se="list" class="bullets">      {{#each bullets}}<li data-se="list-item">{{this}}</li>{{/each}}      </ul>    {{/if}}  ';
            var t = r(this, "content");
            t && this.add(t);
          },
          getTemplateData: function getTemplateData() {
            var t = r(this, "type"),
              e = r(this, "size");
            switch ("tip" === t && (t = "light-bulb"), e) {
              case "slim":
                t = "";
                break;
              case "large":
                t = [t, "-", "24"].join("");
                break;
              default:
                t = [t, "-", "16"].join("");
            }
            return {
              icon: t,
              title: r(this, "title"),
              subtitle: r(this, "subtitle"),
              bullets: r(this, "bullets"),
              dismissible: r(this, "dismissible")
            };
          }
        });
      e.default = {
        create: function create(t) {
          return new c(t);
        }
      };
    }, function (t, e, n) {
      e.a = {
        DEBOUNCE_DELAY: 200,
        LOADING_FADE: 400,
        UNLOADING_FADE: 400,
        ROW_EXPANDER_TRANSITION: 150,
        HIDE_ADD_MAPPING_FORM: 300
      };
    }, function (t, e, n) {
      var r, i;
      r = [n(12)], void 0 !== (i = function (t) {
        var e = t;
        t.fn.customInput = function () {
          return e(this).each(function () {
            if (e(this).is("[type=checkbox],[type=radio]")) {
              var t = e(this),
                n = t.siblings('label[for="' + t.attr("id") + '"]:first');
              n.length || (n = t.closest('label[for="' + t.attr("id") + '"]:first')), t.add(n).wrapAll('<div class="custom-' + t.attr("type") + '"></div>'), n.hover(function () {
                e(this).addClass("hover");
              }, function () {
                e(this).removeClass("hover");
              }), t.bind("updateState", function () {
                t.is(":checked") ? n.addClass("checked") : n.removeClass("checked checkedHover checkedFocus");
              }).trigger("updateState").click(function () {
                e('input[name="' + e(this).attr("name") + '"]').trigger("updateState");
              }).focus(function () {
                n.addClass("focus"), t.is(":checked") && e(this).addClass("checkedFocus");
              }).blur(function () {
                n.removeClass("focus checkedFocus");
              });
            }
          });
        };
      }.apply(e, r)) && (t.exports = i);
    }, function (t, e, n) {
      function r(t) {
        var e = t.title,
          n = t.text;
        return e && n && e !== n;
      }
      function i(t) {
        return r(t) ? t : {
          text: t.text || t
        };
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o = n(2),
        a = n(27),
        s = (n.n(a), n(8)),
        u = n(4),
        c = n(72),
        l = (n.n(c), n(10)),
        f = "okta-form-input-field input-fix";
      e.default = l.a.extend({
        template: u.default.tpl('      {{#if params.innerTooltip}}        <span class="input-tooltip icon form-help-16"></span>      {{/if}}      {{#if params.icon}}        <span class="icon input-icon {{params.icon}}"></span>      {{/if}}      <input type="{{type}}" placeholder="{{placeholder}}" name="{{name}}" id="{{inputId}}"       value="{{value}}" aria-label="{{placeholder}}" autocomplete="off"/>      {{#if params.iconDivider}}        <span class="input-icon-divider"></span>      {{/if}}      '),
        events: {
          "input input": "update",
          "change input": "update",
          "keydown input": "update",
          "keyup input": function keyupInput(t) {
            s.default.isEnter(t) ? this.model.trigger("form:save") : s.default.isEsc(t) && this.model.trigger("form:cancel");
          }
        },
        constructor: function constructor() {
          l.a.apply(this, arguments), this.$el.addClass("o-form-control");
        },
        editMode: function editMode() {
          this.$el.addClass(f), l.a.prototype.editMode.apply(this, arguments), this.$("input").placeholder();
        },
        readMode: function readMode() {
          l.a.prototype.readMode.apply(this, arguments), "password" === this.options.type && this.$el.text("********"), this.$el.removeClass(f);
        },
        val: function val() {
          var t = this.$('input[type="' + this.options.type + '"]').val();
          return "password" !== this.options.type && (t = o.default.trim(t)), t;
        },
        focus: function focus() {
          return this.$("input").focus();
        },
        postRender: function postRender() {
          var t = this.options.params,
            e = void 0;
          t && t.innerTooltip && (e = i(t.innerTooltip), this.$(".input-tooltip").qtip({
            content: e,
            style: {
              classes: "okta-tooltip qtip-custom qtip-shadow"
            },
            position: {
              my: "bottom left",
              target: "mouse",
              adjust: {
                method: "flip",
                mouse: !0,
                y: -5,
                x: 5
              },
              viewport: Object(o.default)("body")
            }
          }));
        }
      });
    }, function (t, e, n) {
      t.exports = n(34);
    }, function (t, e, n) {
      function r(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }
      var i = n(14),
        o = r(i),
        a = n(15),
        s = r(a),
        u = n(38),
        c = r(u),
        l = n(11),
        f = r(l),
        p = n(17),
        d = r(p),
        h = n(40),
        m = r(h),
        g = n(19),
        v = r(g),
        y = n(23),
        _ = r(y),
        b = n(44),
        w = r(b),
        S = n(45),
        x = r(S),
        E = n(8),
        T = r(E),
        k = n(7),
        A = r(k),
        O = n(3),
        C = r(O),
        I = n(4),
        R = r(I),
        P = n(16),
        N = r(P),
        M = n(47),
        L = r(M),
        F = n(2),
        D = r(F),
        j = n(0),
        U = r(j),
        B = n(54),
        V = r(B),
        q = n(1),
        H = r(q),
        W = n(56),
        $ = r(W),
        z = n(57),
        G = r(z),
        K = n(25),
        Y = r(K),
        J = n(9),
        Q = r(J),
        X = n(26),
        Z = r(X),
        tt = n(65),
        et = r(tt),
        nt = n(70),
        rt = r(nt),
        it = n(71),
        ot = r(it),
        at = n(73),
        st = r(at),
        ut = n(28),
        ct = r(ut),
        lt = n(32),
        ft = r(lt),
        pt = n(29),
        dt = r(pt),
        ht = n(6),
        mt = r(ht),
        gt = {
          Backbone: mt.default,
          $: D.default,
          _: U.default,
          Handlebars: L.default,
          loc: C.default.localize,
          createButton: _.default.create,
          createCallout: dt.default.create,
          registerInput: Z.default.register,
          tpl: R.default.tpl,
          Model: f.default,
          BaseModel: s.default,
          Collection: o.default,
          View: H.default,
          ListView: V.default,
          Router: v.default,
          Controller: m.default,
          Form: G.default,
          internal: {
            util: {
              Util: N.default,
              Cookie: x.default,
              Logger: A.default,
              Class: w.default,
              Keys: T.default
            },
            views: {
              components: {
                BaseDropDown: $.default
              },
              forms: {
                helpers: {
                  FormUtil: Q.default,
                  SchemaFormFactory: et.default
                },
                components: {
                  Toolbar: Y.default
                },
                inputs: {
                  TextBox: ft.default,
                  PasswordBox: ot.default,
                  CheckBox: rt.default,
                  Radio: st.default,
                  Select: ct.default
                }
              }
            },
            models: {
              BaseSchema: c.default,
              SchemaProperty: d.default
            }
          }
        };
      gt.registerInput("text", ft.default), gt.registerInput("password", ot.default), gt.registerInput("checkbox", rt.default), gt.registerInput("radio", st.default), gt.registerInput("select", ct.default), t.exports = gt;
    }, function (t, e) {
      t.exports = n(151);
    }, function (t, e, n) {
      function r(t, e) {
        try {
          var n = a(e.getResponseHeader("link"));
          t[l].set(f, !0), t.setPagination(n.next.href);
        } catch (e) {
          t[l].get(f) && t.setPagination(null);
        }
      }
      function i(t) {
        for (var e = {}, n = t && t.split("?")[1], r = n && decodeURIComponent(n.split("#")[0]).replace(/\+/g, " "), i = r ? r.split("&") : [], o = 0; o < i.length; o++) {
          var a = i[o].split("=");
          e[a.shift()] = a.join("=");
        }
        return e;
      }
      function o(t) {
        return '"' == t.charAt(0) && '"' == t.charAt(t.length - 1) ? t.substring(1, t.length - 1) : t;
      }
      function a(t) {
        for (var e = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"\/[\]?={} \t]+=(([^()<>@,;:"\/[\]?={} \t]+)|("[^"]*")))*(,|$)/g, n = /[^()<>@,;:"\/[\]?={} \t]+=(([^()<>@,;:"\/[\]?={} \t]+)|("[^"]*"))/g, r = t.match(e), i = {}, a = 0; a < r.length; a++) {
          var s = r[a].split(">"),
            u = s[0].substring(1),
            c = {};
          c.href = u;
          for (var l = s[1].match(n), f = 0; f < l.length; f++) {
            var p = l[f].split("=");
            c[p[0]] = o(p[1]);
          }
          void 0 !== c.rel && (i[c.rel] = c);
        }
        return i;
      }
      var s = n(0),
        u = n(6),
        c = n.n(u),
        l = "__STATE__",
        f = "LINK_BY_HEADER";
      e.a = c.a.Collection.extend({
        params: {},
        constructor: function constructor(t, e) {
          (this[l] = new c.a.Model()).set("DEFAULT_PARAMS", s.default.defaults(e && e.params || {}, this.params || {})), c.a.Collection.apply(this, arguments);
        },
        sync: function sync(t, e, n) {
          var i = this,
            o = n.success;
          return n.success = function (t, e, n) {
            r(i, n), o.apply(null, arguments);
          }, c.a.Collection.prototype.sync.call(this, t, e, n);
        },
        fetch: function fetch(t) {
          t || (t = {});
          var e = this[l],
            n = e.get("XHR");
          return t.data = s.default.extend({}, e.get("DEFAULT_PARAMS"), t.data || {}), t.fromFetch = !0, e.set("FETCH_DATA", t.data), n && n.abort && !1 !== t.abort && n.abort(), n = c.a.Collection.prototype.fetch.call(this, t), e.set("XHR", n), n;
        },
        setPagination: function setPagination(t, e) {
          s.default.isString(t) && t && (t = i(t)), s.default.isObject(t) && !s.default.isArray(t) && s.default.size(t) ? e && e.fromFetch && (t = s.default.extend({}, this.getFetchData(), t)) : t = null, this[l].set("PAGINATION_DATA", t);
        },
        getFetchData: function getFetchData() {
          return this[l].get("FETCH_DATA") || {};
        },
        getPaginationData: function getPaginationData() {
          return this[l].get("PAGINATION_DATA") || {};
        },
        hasMore: function hasMore() {
          return s.default.size(this.getPaginationData()) > 0;
        },
        fetchMore: function fetchMore() {
          if (!this.hasMore()) throw new Error("Invalid Request");
          return this.fetch({
            data: this.getPaginationData(),
            add: !0,
            remove: !1,
            update: !0
          });
        },
        reset: function reset(t, e) {
          return e || (e = {}), e.fromFetch || this.setPagination(null), c.a.Collection.prototype.reset.apply(this, arguments);
        },
        where: function where(t, e) {
          return s.default.isEmpty(t) ? e ? void 0 : [] : this[e ? "find" : "filter"](function (e) {
            for (var n in t) if (t[n] !== e.get(n)) return !1;
            return !0;
          });
        },
        create: function create(t, e) {
          return e || (e = {}), s.default.result(t, "urlRoot") || (e.url = s.default.result(this, "url")), c.a.Collection.prototype.create.call(this, t, e);
        }
      });
    }, function (t, e, n) {
      function r(t, e, n, i) {
        var o = m.default.contains(e, n);
        return i || (i = {}), o || !m.default.isObject(t) || m.default.isArray(t) || m.default.isFunction(t) ? void 0 !== n && (i[n] = t) : m.default.each(t, function (t, o) {
          r(t, e, n ? n + "." + o : o, i);
        }), i;
      }
      function i(t) {
        return m.default.each(t, function (t, e, n) {
          if (-1 != e.indexOf(".")) {
            for (var r, i = n, o = e.split("."); void 0 !== (r = o.shift());) i[r] || (i[r] = o.length ? {} : t), i = i[r];
            delete n[e];
          }
        }), t;
      }
      function o(t, e) {
        var n = {};
        return n[t.name] = e, n;
      }
      function a(t, e) {
        var n;
        return n = m.default.isString(t) ? {
          type: t
        } : m.default.isArray(t) ? {
          type: t[0],
          required: t[1],
          value: t[2]
        } : m.default.clone(t), m.default.defaults(n, {
          required: !1,
          name: e
        }), n;
      }
      function u(t) {
        return t.toLowerCase().replace(/\b[a-z]/g, function (t) {
          return t.toUpperCase();
        });
      }
      function c(t, e, n) {
        if (!e.test(t)) return n;
      }
      function l(t, e) {
        var n = _[t.format];
        if (t.format && !n) throw new TypeError(t.format + " is not a supported string format");
        return n && n(e);
      }
      function f(t, e) {
        var n = m.default.partial(o, t),
          r = l(t, e);
        return r ? n(r) : e && t.minLength && e.length < t.minLength ? n(h.ERROR_STRING_STRING_MIN_LENGTH, e.length) : e && t.maxLength && e.length > t.maxLength ? n(h.ERROR_STRING_STRING_MAX_LENGTH, e.length) : void 0;
      }
      function p(t, e) {
        var n,
          r,
          i = m.default.partial(o, t),
          a = !m.default.isUndefined(e) && !m.default.isNull(e);
        {
          if (!Array.isArray(t.validate)) {
            if (t.required && (!a || m.default.isNull(e) || "" === e)) return i(h.ERROR_BLANK);
            if (n = m.default["is" + u(t.type)], a && "any" != t.type && (!m.default.isFunction(n) || !n(e))) return i(h.ERROR_WRONG_TYPE);
            if (e && "string" == t.type) {
              var s = f(t, e);
              if (s) return s;
            }
            if (a && t.values && !m.default.contains(t.values, e)) return i(h.ERROR_NOT_ALLOWED);
            if (m.default.isFunction(t.validate)) {
              var c = t.validate(e);
              if (m.default.isString(c) && c) return i(c);
              if (!1 === c) return i(h.ERROR_INVALID);
            }
            return a && "array" == t.type && (r = d(t, e)) ? i(r) : void 0;
          }
          var l = [],
            p = !1,
            g = void 0;
          if (t.validate.forEach(function (t) {
            if (e) switch (t.type.toLowerCase()) {
              case "regex":
                g = new RegExp(t.value.pattern, t.value.flags || "").test(e);
                break;
              default:
                g = !1;
            } else g = !1;
            p = p || !g, l.push({
              message: t.hasOwnProperty("message") ? t.message : "",
              passed: g
            });
          }), p) return i(l);
        }
      }
      function d(t, e) {
        if (t.minItems && e.length < t.minItems) return "model.validation.field.array.minItems";
        if (t.maxItems && e.length > t.maxItems) return "model.validation.field.array.maxItems";
        if (t.uniqueItems && e.length > m.default.uniq(e).length) return h.ERROR_IARRAY_UNIQUE;
        if (t.items) for (var n = a(t.items, "placeholder"), r = 0; r < e.length; r++) {
          var i = e[r],
            o = p(n, i);
          if (o) return o.placeholder;
        }
      }
      var h,
        m = n(0),
        g = n(6),
        v = n.n(g),
        y = n(7),
        _ = {
          email: function email(t) {
            return c(t, /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, h.ERROR_INVALID_FORMAT_EMAIL);
          },
          uri: function uri(t) {
            return c(t, /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[\/?#]\S*)?$/i, h.ERROR_INVALID_FORMAT_URI);
          },
          ipv4: function ipv4(t) {
            return c(t, /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, h.ERROR_INVALID_FORMAT_IPV4);
          },
          hostname: function hostname(t) {
            return c(t, /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/, h.ERROR_INVALID_FORMAT_HOSTNAME);
          }
        };
      h = v.a.Model.extend({
        props: {},
        derived: {},
        local: {},
        flat: !0,
        defaults: {},
        constructor: function constructor(t) {
          this.options = t || {};
          var e = this.__schema__ = {},
            n = [];
          e.computedProperties = {}, e.props = m.default.clone(m.default.result(this, "props") || {}), e.derived = m.default.clone(m.default.result(this, "derived") || {}), e.local = m.default.clone(m.default.result(this, "local") || {});
          var i = {};
          if (m.default.each(m.default.extend({}, e.props, e.local), function (t, e) {
            var r = a(t, e);
            m.default.isUndefined(r.value) || (i[e] = r.value), "object" === r.type && n.push(e);
          }, this), m.default.size(i)) {
            var o = m.default.result(this, "defaults");
            this.defaults = function () {
              return m.default.defaults({}, i, o);
            };
          }
          this.validate = m.default.wrap(this.validate, function (t) {
            var e = m.default.rest(arguments),
              n = m.default.extend(this._validateSchema.apply(this, e), t.apply(this, e));
            return m.default.size(n) && n || void 0;
          }), this.parse = m.default.wrap(this.parse, function (t) {
            var e = t.apply(this, m.default.rest(arguments));
            return this.flat && (e = r(e, n)), e;
          }), v.a.Model.apply(this, arguments), m.default.each(e.derived, function (t, n) {
            e.computedProperties[n] = this.__getDerivedValue(n);
            var r = t.deps || [];
            r.length && this.on("cache:clear change:" + r.join(" change:"), function () {
              var t = this.__getDerivedValue(n);
              t !== e.computedProperties[n] && (e.computedProperties[n] = t, this.trigger("change:" + n, this, t));
            }, this);
          }, this), this.on("sync", function () {
            this.__syncedData = this.toJSON();
          }, this);
        },
        validate: function validate() {},
        allows: function allows(t) {
          var e = this.__schema__,
            n = m.default.extend({}, e.props, e.local);
          return m.default.has(n, t) || y.default.warn("Field not defined in schema", t), !0;
        },
        getPropertySchema: function getPropertySchema(t) {
          var e = this.__schema__;
          return m.default.reduce([e.props, e.local], function (e, n) {
            return e || a(n[t], t);
          }, null);
        },
        set: function set(t, e) {
          var n;
          "object" === (void 0 === t ? "undefined" : (0, s.default)(t)) ? n = t : (n = {})[t] = e, m.default.each(n, function (t, e) {
            if (m.default.has(this.__schema__.derived, e)) throw "overriding derived properties is not supported: " + e;
          }, this);
          var r = [];
          if (m.default.each(n, function (t, e) {
            this.allows(e) || r.push(e);
          }, this), r.length) throw "field not allowed: " + r.join(", ");
          return v.a.Model.prototype.set.apply(this, arguments);
        },
        get: function get(t) {
          var e = this.__schema__;
          return m.default.has(e.derived, t) ? !1 !== e.derived[t].cache ? e.computedProperties[t] : this.__getDerivedValue(t) : v.a.Model.prototype.get.apply(this, arguments);
        },
        toJSON: function toJSON(t) {
          t || (t = {});
          var e = m.default.clone(v.a.Model.prototype.toJSON.apply(this, arguments)),
            n = this.__schema__;
          return t.verbose ? m.default.each(n.derived, function (t, n) {
            e[n] = this.get(n);
          }, this) : e = m.default.omit(e, m.default.keys(n.local)), this.flat && (e = i(e)), e;
        },
        reset: function reset(t) {
          this.clear(t), this.set(m.default.result(this, "defaults"), t);
        },
        isSynced: function isSynced() {
          return m.default.isEqual(this.__syncedData, this.toJSON());
        },
        validateField: function validateField(t) {
          var e = t && this.getPropertySchema(t);
          return e && p(e, this.get(t));
        },
        _validateSchema: function _validateSchema() {
          var t = this.__schema__;
          return m.default.reduce(m.default.extend({}, t.props, t.local), function (t, e, n) {
            return m.default.extend(t, this.validateField(n) || {});
          }, {}, this);
        },
        __getDerivedValue: function __getDerivedValue(t) {
          var e = this.__schema__.derived[t];
          if (m.default.isString(e)) {
            var n = e;
            e = {
              deps: [n],
              fn: function fn() {
                return this.get(n);
              }
            };
          }
          var r = e.deps || [];
          return e.fn.apply(this, m.default.map(r, this.get, this));
        }
      }, {
        ERROR_BLANK: "model.validation.field.blank",
        ERROR_WRONG_TYPE: "model.validation.field.wrong.type",
        ERROR_NOT_ALLOWED: "model.validation.field.value.not.allowed",
        ERROR_INVALID: "model.validation.field.invalid",
        ERROR_IARRAY_UNIQUE: "model.validation.field.array.unique",
        ERROR_INVALID_FORMAT_EMAIL: "model.validation.field.invalid.format.email",
        ERROR_INVALID_FORMAT_URI: "model.validation.field.invalid.format.uri",
        ERROR_INVALID_FORMAT_IPV4: "model.validation.field.invalid.format.ipv4",
        ERROR_INVALID_FORMAT_HOSTNAME: "model.validation.field.invalid.format.hostname",
        ERROR_STRING_STRING_MIN_LENGTH: "model.validation.field.string.minLength",
        ERROR_STRING_STRING_MAX_LENGTH: "model.validation.field.string.maxLength"
      }), e.a = h;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(0),
        i = n(14),
        o = n(15),
        a = n(17),
        s = function s(t) {
          var e = r.default.pick(t, "id", "name", "displayName"),
            n = r.default.map(t.schema.properties, function (t, e) {
              return r.default.extend({
                name: e
              }, t);
            });
          return r.default.each(n, function (t) {
            t.__schemaMeta__ = e, t.__metadata && (t.__metadata__ = t.__metadata, delete t.__metadata);
          }), n;
        },
        u = o.default.extend({
          defaults: {
            id: void 0,
            displayName: void 0,
            name: void 0
          },
          constructor: function constructor() {
            this.properties = new a.default.Collection(), o.default.apply(this, arguments);
          },
          getProperties: function getProperties() {
            return this.properties;
          },
          clone: function clone() {
            var t = o.default.prototype.clone.apply(this, arguments);
            return t.getProperties().set(this.getProperties().toJSON({
              verbose: !0
            })), t;
          },
          parse: function parse(t) {
            var e = s(t);
            return this.properties.set(e, {
              parse: !0
            }), r.default.omit(t, "schema");
          },
          trimProperty: function trimProperty(t) {
            return r.default.omit(t, "name");
          },
          toJSON: function toJSON() {
            var t = o.default.prototype.toJSON.apply(this, arguments);
            return t.schema = {
              properties: {}
            }, this.getProperties().each(function (e) {
              var n = e.toJSON();
              t.schema.properties[n.name] = this.trimProperty(n);
            }, this), t;
          },
          save: function save() {
            return this.getProperties().each(function (t) {
              t.cleanup();
            }), o.default.prototype.save.apply(this, arguments);
          }
        }),
        c = i.default.extend({
          model: u
        });
      e.default = {
        parseProperties: s,
        Model: u,
        Collection: c
      };
    }, function (t, e) {
      t.exports = n(121);
    }, function (t, e, n) {
      function r(t) {
        var e = {};
        return o.default.each(t, function (t, n) {
          o.default.isNull(t) || (e[n] = t);
        }), e;
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i = n(2),
        o = n(0),
        a = n(19),
        s = n(20),
        u = n(42),
        c = n(1);
      e.default = c.default.extend({
        constructor: function constructor(t) {
          if (t || (t = {}), t.state instanceof u.a || this.state instanceof u.a) this.state = t.state || this.state;else {
            var e = o.default.defaults(r(t.state), this.state || {});
            this.state = new u.a(e), delete t.state;
          }
          t.settings ? this.settings = t.settings : (this.settings = t.settings = new s.a(o.default.omit(t || {}, "el")), this.listen("notification", a.default.prototype._notify), this.listen("confirmation", a.default.prototype._confirm)), c.default.call(this, t), this.listenTo(this.state, "__invoke__", function () {
            var t = o.default.toArray(arguments),
              e = t.shift();
            o.default.isFunction(this[e]) && this[e].apply(this, t);
          }), this.View && this.add(new this.View(this.toJSON()));
        },
        state: {},
        View: null,
        render: function render() {
          var t = arguments,
            e = this;
          return Object(i.default)(function () {
            c.default.prototype.render.apply(e, t);
          }), this;
        },
        toJSON: function toJSON(t) {
          return o.default.extend(o.default.pick(this, "state", "settings", "collection", "model"), t || {});
        },
        remove: function remove() {
          return this.removeChildren(), this.stopListening(), this.$el.empty(), this;
        }
      });
    }, function (t, e, n) {
      var r = n(2),
        i = n(0),
        o = n(1),
        a = {
          level: "success",
          message: "Great Success!",
          hide: !0,
          fade: 400,
          delay: 3e3,
          width: 0,
          dismissable: !1
        };
      e.a = o.default.extend({
        className: "infobox infobox-confirm infobox-confirm-fixed",
        events: {
          "click .infobox-dismiss-link": function clickInfoboxDismissLink(t) {
            t.preventDefault(), this.fadeOut();
          }
        },
        template: '      {{#if dismissable}}      <a class="infobox-dismiss-link" title="Dismiss" href="#">        <span class="dismiss-icon"></span>      </a>      {{/if}}      <span class="icon {{level}}-16"></span>      {{#if title}}<h3>{{title}}</h3>{{/if}}      <p>{{message}}</p>    ',
        initialize: function initialize() {
          this.options = i.default.defaults({}, this.options, a), this.$el.addClass("infobox-" + this.options.level), this.options.width && this.$el.width(this.options.width).css({
            "margin-left": "0px",
            left: Math.round((Object(r.default)(window).width() - this.options.width) / 2)
          });
        },
        getTemplateData: function getTemplateData() {
          return i.default.extend(i.default.pick(this.options, "level", "message", "title"), {
            dismissable: !1 === this.options.hide || !0 === this.options.dismissable
          });
        },
        postRender: function postRender() {
          this.options.hide && i.default.delay(i.default.bind(this.fadeOut, this), this.options.delay);
        },
        fadeOut: function fadeOut() {
          this.$el.fadeOut(this.options.fade, i.default.bind(this.remove, this));
        }
      });
    }, function (t, e, n) {
      var r = n(0),
        i = n(11);
      e.a = i.default.extend({
        extraProperties: !0,
        invoke: function invoke() {
          var t = r.default.toArray(arguments);
          t.unshift("__invoke__"), this.trigger.apply(this, t);
        }
      });
    }, function (t, e, n) {
      var r = n(0),
        i = n(24),
        o = n(1),
        a = {
          click: function click(t) {
            t.preventDefault(), t.stopPropagation();
          }
        };
      e.a = o.default.extend({
        attributes: function attributes() {
          var t = {
              "data-se": "button"
            },
            e = this.__getAttribute("attrs");
          return r.default.extend(t, e);
        },
        tagName: "a",
        template: '{{#if icon}}<span class="icon {{icon}}"></span>{{/if}}{{#if title}}{{title}}{{/if}}',
        visible: !0,
        enabled: !0,
        enableWhen: {},
        showWhen: {},
        constructor: function constructor(t) {
          this.options = t || {};
          var e = this.getTemplateData();
          this.disabled = !1, o.default.apply(this, arguments), this.$el.addClass("link-button"), e.icon && (this.$el.addClass("link-button-icon"), e.title || this.$el.addClass("icon-only"));
        },
        getTemplateData: function getTemplateData() {
          return {
            href: this.__getAttribute("href"),
            title: this.__getAttribute("title"),
            icon: this.__getAttribute("icon")
          };
        },
        initialize: function initialize() {
          i.a.applyDoWhen(this, r.default.resultCtx(this, "enableWhen", this), this.toggle), i.a.applyDoWhen(this, r.default.resultCtx(this, "showWhen", this), this.toggleVisible);
        },
        render: function render() {
          o.default.prototype.render.apply(this, arguments), r.default.result(this, "enabled") || this.toggle(!1), r.default.result(this, "visible") || this.toggleVisible(!1);
          var t = this.getTemplateData();
          return this.$el.attr("href", t.href || "#"), this;
        },
        __getAttribute: function __getAttribute(t, e) {
          var n = r.default.resultCtx(this.options, t, this);
          return r.default.isUndefined(n) && (n = r.default.result(this, t)), r.default.isUndefined(n) ? e : n;
        },
        enable: function enable() {
          this.toggle(!0);
        },
        disable: function disable() {
          this.toggle(!1);
        },
        show: function show() {
          this.toggleVisible(!0);
        },
        hide: function hide() {
          this.toggleVisible(!1);
        },
        toggle: function toggle(t) {
          var e = !!t && r.default.result(this, "enabled");
          this.disabled = !e, this.$el.toggleClass("link-button-disabled btn-disabled disabled", this.disabled), this.delegateEvents(this.disabled ? a : null);
        },
        toggleVisible: function toggleVisible(t) {
          var e = !t || !r.default.result(this, "visible");
          this.$el.toggleClass("hide", e);
        }
      });
    }, function (t, e, n) {
      function r(t) {
        this.options = a.default.clone(t || {}), this.cid = a.default.uniqueId("class"), this.initialize.apply(this, arguments);
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i = n(6),
        o = n.n(i),
        a = n(0);
      a.default.extend(r.prototype, o.a.Events, {
        initialize: function initialize() {}
      }), r.extend = o.a.Model.extend, e.default = r;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(0),
        i = n(46),
        o = n.n(i),
        a = /^https/.test(window.location.href);
      e.default = {
        setCookie: function setCookie(t, e, n) {
          o.a.set(t, e, r.default.defaults(n || {}, {
            secure: a,
            path: "/"
          }));
        },
        getCookie: function getCookie() {
          return o.a.get.apply(o.a, arguments);
        },
        removeCookie: function removeCookie() {
          return o.a.remove.apply(o.a, arguments);
        }
      };
    }, function (t, e, n) {
      var r, i; /*!
                * JavaScript Cookie v2.1.0
                * https://github.com/js-cookie/js-cookie
                *
                * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
                * Released under the MIT license
                */
      !function (o) {
        r = o, void 0 !== (i = "function" == typeof r ? r.call(e, n, e, t) : r) && (t.exports = i);
      }(function () {
        function t() {
          for (var t = 0, e = {}; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n) e[r] = n[r];
          }
          return e;
        }
        function e(n) {
          function r(e, i, a) {
            var s;
            if (arguments.length > 1) {
              if (a = t({
                path: "/"
              }, r.defaults, a), "number" == typeof a.expires) {
                var u = new Date();
                u.setMilliseconds(u.getMilliseconds() + 864e5 * a.expires), a.expires = u;
              }
              try {
                s = (0, o.default)(i), /^[\{\[]/.test(s) && (i = s);
              } catch (t) {}
              return i = n.write ? n.write(i, e) : encodeURIComponent(String(i)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), e = encodeURIComponent(String(e)), e = e.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent), e = e.replace(/[\(\)]/g, escape), document.cookie = [e, "=", i, a.expires && "; expires=" + a.expires.toUTCString(), a.path && "; path=" + a.path, a.domain && "; domain=" + a.domain, a.secure ? "; secure" : ""].join("");
            }
            e || (s = {});
            for (var c = document.cookie ? document.cookie.split("; ") : [], l = /(%[0-9A-Z]{2})+/g, f = 0; f < c.length; f++) {
              var p = c[f].split("="),
                d = p[0].replace(l, decodeURIComponent),
                h = p.slice(1).join("=");
              '"' === h.charAt(0) && (h = h.slice(1, -1));
              try {
                if (h = n.read ? n.read(h, d) : n(h, d) || h.replace(l, decodeURIComponent), this.json) try {
                  h = JSON.parse(h);
                } catch (t) {}
                if (e === d) {
                  s = h;
                  break;
                }
                e || (s[d] = h);
              } catch (t) {}
            }
            return s;
          }
          return r.get = r.set = r, r.getJSON = function () {
            return r.apply({
              json: !0
            }, [].slice.call(arguments));
          }, r.defaults = {}, r.remove = function (e, n) {
            r(e, "", t(n, {
              expires: -1
            }));
          }, r.withConverter = e, r;
        }
        return e(function () {});
      });
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(5),
        i = n.n(r);
      n(48), n(49), n(50), n(51), n(53);
      e.default = i.a;
    }, function (t, e, n) {
      function r(t, e) {
        return s.a.utc(e).utcOffset("-07:00").format(t);
      }
      var i = n(5),
        o = n.n(i),
        a = n(21),
        s = n.n(a),
        u = n(0);
      o.a.registerHelper("shortDate", u.default.partial(r, "MMM Do")), o.a.registerHelper("mediumDate", u.default.partial(r, "MMMM DD, YYYY")), o.a.registerHelper("longDate", u.default.partial(r, "MMMM DD, YYYY, h:mma")), o.a.registerHelper("formatDate", r);
      o.a;
    }, function (t, e, n) {
      function r(t) {
        return t && t.replace(/^\s+|\s+$/g, "");
      }
      var i = n(5),
        o = n.n(i),
        a = n(0),
        s = n(3);
      o.a.registerHelper("i18n", function (t) {
        var e = void 0,
          n = r(t.hash.code),
          i = r(t.hash.bundle),
          o = r(t.hash.arguments);
        return o && (e = a.default.map(r(o).split(";"), function (t) {
          t = r(t);
          var e = void 0,
            n = this;
          return a.default.each(t.split("."), function (t) {
            e = e ? e[t] : n[t];
          }), e;
        }, this)), s.default.localize(n, i, e);
      });
      o.a;
    }, function (t, e, n) {
      function r(t) {
        return 0 === t.indexOf(s) ? t : s + t;
      }
      var i = n(5),
        o = n.n(i),
        a = n(0),
        s = "/assets";
      o.a.registerHelper("img", function (t) {
        var e = "undefined" != typeof okta && okta.cdnUrlHostname || "",
          n = a.default.pick(t.hash, ["src", "alt", "width", "height", "class", "title"]);
        n.src = "" + e + r(n.src);
        var i = a.default.map(n, function (t, e) {
          return e + '="' + o.a.Utils.escapeExpression(t) + '"';
        });
        return new o.a.SafeString("<img " + i.join(" ") + "/>");
      });
      o.a;
    }, function (t, e, n) {
      var r = n(5),
        i = n.n(r),
        o = n(52);
      i.a.registerHelper("markdown", function (t) {
        return Object(o.a)(i.a, t);
      });
      i.a;
    }, function (t, e, n) {
      function r(t, e) {
        var n = t.compile('<a href="{{href}}">{{text}}</a>'),
          r = void 0;
        return r = i.default.isString(e) ? t.Utils.escapeExpression(e).replace(u, "").replace(o, function (t) {
          return n({
            href: t.match(a)[1],
            text: t.match(s)[1]
          });
        }) : "", new t.SafeString(r);
      }
      e.a = r;
      var i = n(0),
        o = /\[[^\]]*\]\([^)]*\)/gi,
        a = /\]\(([^)]*)\)/i,
        s = /\[([^\]]*)\]/i,
        u = /javascript:/gi;
    }, function (t, e, n) {
      var r = n(5),
        i = n.n(r),
        o = n(2);
      i.a.registerHelper("xsrfTokenInput", function () {
        return new i.a.SafeString('<input type="hidden" class="hide" name="_xsrfToken" value="' + Object(o.default)("#_xsrfToken").text() + '">');
      });
      i.a;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(55),
        i = n(1);
      e.default = i.default.decorate(r.a);
    }, function (t, e, n) {
      var r = n(22),
        i = n(0);
      e.a = r.a.extend({
        constructor: function constructor() {
          if (r.a.apply(this, arguments), !this.collection) throw new Error("Missing collection");
          this.listenTo(this.collection, "reset sort", this.reset), this.listenTo(this.collection, "add", this.addItem), this.fetchCollection ? this.collection.fetch() : this.collection.each(this.addItem, this);
        },
        item: null,
        itemSelector: null,
        reset: function reset() {
          var t = this;
          return this.removeChildren(), this.collection.each(function (e, n) {
            t.addItem(e, n);
          }), this;
        },
        addItem: function addItem(t) {
          var e = this.add(this.item, this.itemSelector, {
            options: {
              model: t
            }
          }).last();
          return this.state && this.state.get("trackItemAdded") && this.state.trigger("itemAdded", e), e.listenTo(t, "destroy remove", e.remove), this;
        },
        addShowMore: i.default.noop
      });
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(2),
        i = n(0),
        o = n(4),
        a = n(1),
        s = o.default.tpl('    <a href="" class="icon-16 {{className}}" data-se="{{seleniumId}}">      {{#if icon}}      <span class="icon {{icon}}"></span>      {{/if}}      {{#if title}}      {{title}}      {{/if}}      {{#if subtitle}}        <p class="option-subtitle">{{subtitle}}</p>      {{/if}}   </a>   '),
        u = a.default.extend({
          tagName: "li",
          events: {
            click: function click(t) {
              t.preventDefault(), this.action && this.action.call(this);
            }
          },
          constructor: function constructor() {
            a.default.apply(this, arguments), this.$el.addClass("okta-dropdown-option option");
          },
          render: function render() {
            return this.$el.html(s({
              icon: i.default.result(this, "icon"),
              className: i.default.result(this, "className") || "",
              title: i.default.result(this, "title"),
              subtitle: i.default.result(this, "subtitle"),
              seleniumId: i.default.result(this, "seleniumId")
            })), i.default.result(this, "disabled") && this.disable(), this;
          },
          disable: function disable() {
            this.$el.addClass("option-disabled"), this.$el.find("a").attr("tabindex", "-1");
          }
        });
      e.default = a.default.extend({
        events: {
          "click a.option-selected": function clickAOptionSelected(t) {
            t.preventDefault(), i.default.result(this, "disabled") && t.stopPropagation();
          },
          "click .dropdown-disabled": function clickDropdownDisabled(t) {
            t.preventDefault(), t.stopPropagation();
          }
        },
        items: [],
        constructor: function constructor() {
          var t = this.className;
          this.className = null, a.default.apply(this, arguments), this.className = t, this.$el.addClass("dropdown more-actions float-l"), i.default.each(i.default.result(this, "items"), function (t) {
            this.addOption(t, this.options);
          }, this);
        },
        template: '      <a href="#" class="link-button {{className}} link-button-icon option-selected center"        aria-expanded="false" aria-controls="okta-dropdown-options">        {{#if icon}}        <span class="icon {{icon}}"></span>        {{/if}}        {{#if screenReaderText}}        <span class="off-screen">{{screenReaderText}}</span>        {{/if}}        <span class="option-selected-text">{{title}}</span>        <span class="icon-dm"></span>      </a>      <div id="okta-dropdown-options" class="options clearfix" style="display: none;">      <ul class="okta-dropdown-list options-wrap clearfix"></ul>      </div>    ',
        getTemplateData: function getTemplateData() {
          var t = [i.default.result(this, "className") || "", i.default.result(this, "disabled") ? "dropdown-disabled" : ""];
          return {
            icon: i.default.result(this, "icon"),
            className: r.default.trim(t.join(" ")),
            title: i.default.result(this, "title"),
            screenReaderText: i.default.result(this, "screenReaderText")
          };
        },
        addOption: function addOption(t, e) {
          this.add(u.extend(t), "ul.options-wrap", {
            options: e || {}
          });
        }
      });
    }, function (t, e, n) {
      function r(t) {
        if (!y && this.$el.hasClass("o-form-saving")) {
          var e = Object(i.default)(t.currentTarget);
          e.css("display", "none");
          var n = document.elementFromPoint(t.clientX, t.clientY);
          return e.css("display", "block"), t.target = n, Object(i.default)(n).trigger(t), !1;
        }
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i = n(2),
        o = n(0),
        a = n(3),
        s = n(4),
        u = n(1),
        c = n(58),
        l = n(25),
        f = n(59),
        p = n(60),
        d = n(9),
        h = n(61),
        m = n(62),
        g = n(63),
        v = n(64),
        y = "auto" === Object(i.default)("<div>").css({
          "pointer-events": "auto"
        })[0].style.pointerEvents,
        _ = {
          submit: function submit(t) {
            t.preventDefault(), this.__save();
          }
        };
      o.default.each(["click", "dblclick", "mousedown", "mouseup"], function (t) {
        _[t + " .o-form-input"] = r;
      });
      var b = function b(t) {
          t || (t = {});
          var e = t && t.collection || {};
          return {
            method: "POST",
            action: o.default.result(t, "urlRoot") || o.default.result(e, "url") || window.location.pathname,
            "data-se": "o-form",
            slot: "content"
          };
        },
        w = function w(t, e) {
          t || (t = "");
          var n = [];
          return o.default.isString(t) && (n = t.split(" ")), n = o.default.union(n, e), n.join(" ");
        },
        S = function S() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return Array.isArray(t.errorCauses) && t.errorCauses.length > 0 ? t.errorCauses[0].errorSummary : t.errorSummary;
        };
      e.default = u.default.extend({
        constructor: function constructor(t) {
          t || (t = {}), this.options = t, this.id = o.default.uniqueId("form"), this.tagName = "form", o.default.defaults(this.events, _), o.default.defaults(this.attributes, b(t.model)), this.__buttons = [], this.__errorFields = {}, this.__saveModelState(t.model), this.step && (this.save || (this.save = this.totalSteps && this.step !== this.totalSteps ? "Next" : "Finish"), this.className += " wizard"), this.className += " o-form", this.__toolbar = this.__createToolbar(t), u.default.call(this, t), o.default.each(o.default.result(this, "inputs") || [], function (t) {
            this.__addLayoutItem(t);
          }, this), this.add(this.__toolbar, ""), this.listenTo(this.model, "change:__edit__", this.__applyMode), this.listenTo(this.model, "invalid error", o.default.throttle(function (t, e, n) {
            this.__showErrors(t, e, !1 !== n);
          }, 100, {
            trailing: !1
          })), this.listenTo(this.model, "form:resize", function () {
            this.trigger("resize");
          }), this.listenTo(this.model, "form:cancel", o.default.throttle(this.__cancel, 100, {
            trailing: !1
          })), this.listenTo(this.model, "form:previous", o.default.throttle(this.__previous, 100, {
            trailing: !1
          })), this.__save = o.default.throttle(this.__save, 200, {
            trailing: !1
          }), this.listenTo(this.model, "form:save", function () {
            this.$el.submit();
          }), this.listenTo(this.model, "sync", function () {
            this.model.get("__edit__") && this.model.set("__edit__", !1, {
              silent: !0
            }), this.__saveModelState(this.model), this.render();
          });
          var e = this.getAttribute("hasSavingState");
          if (this.getAttribute("autoSave") && (this.listenTo(this, "save", function (t) {
            var e = this,
              n = t.save();
            n && n.done && n.done(function () {
              e.trigger("saved", t);
            });
          }), o.default.isUndefined(e) && (e = !0)), e) {
            var n = this.getAttribute("customSavingState", {});
            this.listenTo(this.model, w(n.start || "", ["request"]), this.__setSavingState), this.listenTo(this.model, w(n.stop || "", ["error", "sync"]), this.__clearSavingState);
          }
        },
        __createToolbar: function __createToolbar(t) {
          var e = this.getAttribute("danger"),
            n = !0 === e ? "button-error" : "button-primary",
            r = new l.default(o.default.extend({
              save: this.save || a.default.localize("oform.save", "courage"),
              saveId: this.saveId,
              saveClassName: n,
              cancel: this.cancel || a.default.localize("oform.cancel", "courage"),
              noCancelButton: this.noCancelButton || !1,
              hasPrevStep: this.step && this.step > 1
            }, t || this.options));
          return o.default.each(this.__buttons, function (t) {
            r.addButton.apply(r, t);
          }), r;
        },
        className: "",
        attributes: {},
        events: {},
        inputs: [],
        template: null,
        read: !1,
        readOnly: !1,
        noButtonBar: !1,
        noCancelButton: !1,
        save: null,
        cancel: null,
        danger: !1,
        layout: "",
        step: void 0,
        totalSteps: void 0,
        title: null,
        subtitle: null,
        autoSave: !1,
        scrollOnError: !0,
        showErrors: !0,
        resizeSelector: ".o-form-content",
        getAttribute: function getAttribute(t, e) {
          var n = o.default.resultCtx(this.options, t, this);
          return o.default.isUndefined(n) && (n = o.default.result(this, t)), o.default.isUndefined(n) ? e : n;
        },
        hasReadMode: function hasReadMode() {
          return !!this.getAttribute("read");
        },
        isReadOnly: function isReadOnly() {
          return !!this.getAttribute("readOnly");
        },
        hasButtonBar: function hasButtonBar() {
          return !(this.getAttribute("noButtonBar") || this.isReadOnly());
        },
        render: function render() {
          if (this.__readModeBar && this.__readModeBar.remove(), this.hasReadMode() && !this.isReadOnly()) {
            var t = c.a.extend({
              formTitle: this.getAttribute("title", "")
            });
            this.__readModeBar = this.add(t, ".o-form-title-bar").last();
          }
          var e = s.default.tpl('    {{#if hasReadMode}}      <h2 class="o-form-title-bar" data-se="o-form-title-bar">        {{title}}      </h2>    {{/if}}    <div data-se="o-form-content" class="o-form-content {{layout}} clearfix">      {{#unless hasReadMode}}        {{#if title}}          <h2 data-se="o-form-head" class="okta-form-title o-form-head">{{title}}</h2>        {{/if}}      {{/unless}}      {{#if subtitle}}        <p class="okta-form-subtitle o-form-explain" data-se="o-form-explain">{{subtitle}}</p>      {{/if}}      <div class="o-form-error-container" data-se="o-form-error-container"></div>      <div class="o-form-fieldset-container" data-se="o-form-fieldset-container"></div>    </div>  ')({
            layout: this.getAttribute("layout", ""),
            title: this.getAttribute("title", "", !0),
            subtitle: this.getAttribute("subtitle", "", !0),
            hasReadMode: this.hasReadMode()
          });
          return this.$el.html(e), delete this.template, u.default.prototype.render.apply(this, arguments), this.__applyMode(), this;
        },
        __setSavingState: function __setSavingState() {
          this.model.trigger("form:set-saving-state"), this.$el.addClass("o-form-saving");
        },
        __clearSavingState: function __clearSavingState() {
          this.model.trigger("form:clear-saving-state"), this.$el.removeClass("o-form-saving");
        },
        __toggleToolbar: function __toggleToolbar() {
          this.__toolbar && this.__toolbar.remove(), this.hasButtonBar() && this._editMode() && (this.__toolbar = this.__createToolbar(), this.add(this.__toolbar, "")), this.trigger("resize");
        },
        __cancel: function __cancel() {
          var t = this.model.get("__edit__");
          this.model.clear({
            silent: !0
          });
          var e = void 0;
          e = this.model.sanitizeAttributes ? this.model.sanitizeAttributes(this.__originalModel) : o.default.clone(this.__originalModel), this.model.set(e, {
            silent: !0
          }), this.trigger("cancel", this.model), this.model.trigger("cache:clear"), t && (this.model.set("__edit__", !1, {
            silent: !0
          }), this.model.trigger("change:__edit__", this.model, !1)), this.clearErrors();
        },
        isValid: function isValid() {
          function t(t) {
            return o.default.reduce(t, function (t, e) {
              return o.default.extend(t, n.model.validateField(e));
            }, {});
          }
          var e = void 0,
            n = this;
          return o.default.isUndefined(this.validate) ? this.model.isValid() : (o.default.isFunction(this.validate) ? e = this.validate() : o.default.isArray(this.validate) ? e = t(this.validate) : "local" === this.validate && (e = t(this.getInputs().map(function (t) {
            return t.options.name;
          }))), !!o.default.isEmpty(e) || (this.model.trigger("invalid", this.model, e), !1));
        },
        __save: function __save() {
          this.clearErrors(), this.isValid() && this.trigger("save", this.model);
        },
        __previous: function __previous() {
          this.trigger("previous", this.model);
        },
        __applyMode: function __applyMode() {
          this.clearErrors(), this.__toggleToolbar(), this._editMode() ? (this.$el.addClass("o-form-edit-mode"), this.$el.removeClass("o-form-read-mode"), this.$(".o-form-content").removeClass("rounded-btm-4"), this.focus()) : (this.$el.removeClass("o-form-edit-mode"), this.$el.addClass("o-form-read-mode"), this.$(".o-form-content").addClass("rounded-btm-4"));
        },
        _editMode: function _editMode() {
          return this.model.get("__edit__") || !this.hasReadMode();
        },
        parseErrorMessage: o.default.identity,
        __showErrors: function __showErrors(t, e, n) {
          if (this.trigger("error", t), this.getAttribute("showErrors")) {
            var r = void 0,
              s = p.a.getResponseJSON(e),
              u = p.a.parseFieldErrors(e);
            if (o.default.size(u) ? o.default.each(u, function (t, e) {
              this.model.trigger("form:field-error", this.__errorFields[e] || e, o.default.map(t, function (t) {
                return /^model\.validation/.test(t) ? a.default.localize(t, "courage") : t;
              }));
            }, this) : (s = this.parseErrorMessage(s), r = S(s)), n && (this.$(".o-form-error-container").addClass("o-form-has-errors"), this.add(f.a, ".o-form-error-container", {
              options: {
                errorSummary: r
              }
            })), this.getAttribute("scrollOnError")) {
              var c = Object(i.default)("#" + this.id + " .o-form-error-container");
              c.length && Object(i.default)("html, body").animate({
                scrollTop: c.offset().top
              }, 400);
            }
            this.model.trigger("form:resize");
          }
        },
        clearErrors: function clearErrors() {
          this.$(".o-form-error-container").removeClass("o-form-has-errors"), this.model.trigger("form:clear-errors"), this.model.trigger("form:resize");
        },
        toggle: function toggle() {
          return this.model.set("__edit__", !this.hasReadMode() || !this.model.get("__edit__")), this;
        },
        __addLayoutItem: function __addLayoutItem(t) {
          m.a.supports(t) ? this.addInput(t) : this.__addNonInputLayoutItem(t);
        },
        __addNonInputLayoutItem: function __addNonInputLayoutItem(t) {
          var e = o.default.omit(t, "type");
          switch (t.type) {
            case "sectionTitle":
              this.addSectionTitle(t.title, o.default.omit(e, "title"));
              break;
            case "divider":
              this.addDivider(e);
              break;
            default:
              throw new Error("unknown input: " + t.type);
          }
        },
        addButton: function addButton(t, e) {
          this.__toolbar && this.__toolbar.addButton(t, e), this.__buttons.push([t, e]);
        },
        addDivider: function addDivider(t) {
          return this.add('<div class="okta-form-divider form-divider"></div>'), d.default.applyShowWhen(this.last(), t && t.showWhen), d.default.applyToggleWhen(this.last(), t && t.toggleWhen), this;
        },
        addSectionTitle: function addSectionTitle(t, e) {
          return this.add(s.default.tpl('<h2 class="o-form-head">{{title}}</h2>')({
            title: t
          })), d.default.applyShowWhen(this.last(), e && e.showWhen), d.default.applyToggleWhen(this.last(), e && e.toggleWhen), this;
        },
        addInput: function addInput(t) {
          t = o.default.clone(t), d.default.validateInput(t, this.model);
          var e = d.default.generateInputOptions(t, this, this.__createInput).reverse();
          o.default.isEmpty(this.getInputs().toArray()) && o.default.extend(e[0], {
            validateOnlyIfDirty: !0
          });
          var n = o.default.map(e, this.__createInput, this);
          o.default.each(e, function (t) {
            t.errorField && (this.__errorFields[t.errorField] = t.name);
          }, this);
          var r = {
            inputId: o.default.last(n).options.inputId,
            input: n,
            multi: e.length > 1 ? e.length : void 0
          };
          o.default.extend(r, o.default.omit(this.options, "input"), o.default.omit(t, "input"));
          var i = this.__createWrapper(r);
          !1 !== r.label && i.add(this.__createLabel(r)), i.add(this._createContainer(r)), i.type = r.type || r.input.type || "custom";
          var a = [i].concat(o.default.rest(arguments));
          return this.add.apply(this, a);
        },
        __createInput: function __createInput(t) {
          return t = o.default.pick(t, d.default.INPUT_OPTIONS), m.a.create(t);
        },
        __createWrapper: function __createWrapper(t) {
          return t = o.default.pick(t, d.default.WRAPPER_OPTIONS), new v.a(t);
        },
        __createLabel: function __createLabel(t) {
          return t = o.default.pick(t, d.default.LABEL_OPTIONS), new g.a(t);
        },
        _createContainer: function _createContainer(t) {
          return t = o.default.pick(t, d.default.CONTAINER_OPTIONS), new h.a(t);
        },
        __saveModelState: function __saveModelState(t) {
          this.__originalModel = i.default.extend(!0, {}, t.attributes);
        },
        add: function add() {
          var t = o.default.toArray(arguments);
          return void 0 === t[1] && (t[1] = "> div.o-form-content > .o-form-fieldset-container"), u.default.prototype.add.apply(this, t);
        },
        focus: function focus() {
          var t = this.getInputs().first();
          return t && t.focus && t.focus(), this;
        },
        disable: function disable() {
          return this.invoke("disable"), this;
        },
        enable: function enable() {
          this.invoke("enable");
        },
        contentHeight: function contentHeight(t) {
          var e = this.$(".o-form-content");
          if (!o.default.isNumber(t)) return e.height();
          e.css("max-height", t);
        },
        getInputs: function getInputs() {
          return Object(o.default)(this.filter(function (t) {
            return t instanceof v.a;
          }));
        }
      });
    }, function (t, e, n) {
      var r = n(1),
        i = n(9);
      e.a = r.default.extend({
        el: '<span class="o-form-toggle" data-type="header-btn"></span>',
        formTitle: "",
        modelEvents: {
          "change:__edit__": "toggle"
        },
        initialize: function initialize() {
          this.addButton();
        },
        addButton: function addButton() {
          this.model.get("__edit__") ? this.add(i.default.createReadFormButton({
            type: "cancel"
          })) : this.add(i.default.createReadFormButton({
            type: "edit",
            formTitle: this.formTitle
          }));
        },
        toggle: function toggle() {
          this.removeChildren(), this.addButton();
        }
      });
    }, function (t, e, n) {
      var r = n(1);
      e.a = r.default.extend({
        template: '    <div class="okta-form-infobox-error infobox infobox-error" role="alert">      <span class="icon error-16"></span>      {{#if errorSummary}}        <p>{{errorSummary}}</p>      {{else}}        <p>{{i18n code="oform.errorbanner.title" bundle="courage"}}</p>      {{/if}}    </div>  ',
        modelEvents: {
          "form:clear-errors": "remove"
        }
      });
    }, function (t, e, n) {
      var r = n(0),
        i = n(3),
        o = /^([\S]+): (.+)$/;
      e.a = {
        getResponseJSON: function getResponseJSON(t) {
          try {
            return t.responseJSON || JSON.parse(t.responseText);
          } catch (t) {
            return;
          }
        },
        parseErrorSummary: function parseErrorSummary(t) {
          var e = t.match(o);
          if (e) return [e[1], e[2]];
        },
        parseErrorCauseObject: function parseErrorCauseObject(t) {
          if (t.property && t.errorSummary) {
            var e = i.default.localize(t.reason),
              n = t.errorSummary;
            return [t.property, -1 === e.indexOf("L10N_ERROR[") ? e : n];
          }
        },
        parseErrors: function parseErrors(t) {
          var e = this.getResponseJSON(t);
          return r.default.map(e && e.errorCauses || [], function (t) {
            return ("" + t.errorSummary).replace(o, "$2");
          });
        },
        parseFieldErrors: function parseFieldErrors(t) {
          var e = this.getResponseJSON(t),
            n = {};
          return e ? r.default.each(e.errorCauses || [], function (t) {
            var e = [];
            if (e = t.property && t.errorSummary ? this.parseErrorCauseObject(t) : this.parseErrorSummary(t && t.errorSummary || "")) {
              var r = e[0],
                i = e[1];
              n[r] || (n[r] = []), n[r].push(i);
            }
          }, this) : r.default.isObject(t) && r.default.size(t) && r.default.each(t, function (t, e) {
            n[e] = [t];
          }), r.default.size(n) ? n : void 0;
        }
      };
    }, function (t, e, n) {
      var r = n(0),
        i = n(7),
        o = n(4),
        a = n(16),
        s = n(3),
        u = n(1),
        c = a.default.isABaseView;
      e.a = u.default.extend({
        attributes: function attributes() {
          return {
            "data-se": "o-form-input-container"
          };
        },
        className: function className() {
          var t = "o-form-input";
          if (this.options.wide && (t += " o-form-wide"), r.default.contains([1, 2, 3, 4], this.options.multi) && (t += " o-form-multi-input-" + this.options.multi, r.default.isArray(this.options.input))) {
            r.default.find(this.options.input, function (t) {
              return r.default.contains(["text+select", "select+text"], t.options.type);
            }) && (t += " o-form-multi-input-group-" + this.options.multi);
          }
          return t;
        },
        _getNames: function _getNames() {
          var t = r.default.isArray(this.options.name) ? this.options.name : [this.options.name];
          return "group" === this.options.type ? t.push.apply(t, r.default.pluck(this.options.input[0].options.params.inputs, "name")) : r.default.isArray(this.options.name) ? this.options.input && this.options.input.options && this.options.input.options.name && t.push(this.options.input.options.name) : this.options.input && (r.default.isArray(this.options.input) ? r.default.each(this.options.input, function (e) {
            t.push(e.options.name);
          }) : t.push(this.options.input.options.name)), r.default.uniq(r.default.compact(t));
        },
        constructor: function constructor() {
          u.default.apply(this, arguments);
          var t = this.options["explain-top"] && this.options["label-top"];
          this.options.input && (r.default.isArray(this.options.input) ? r.default.each(this.options.input, function (e) {
            this.add(e, {
              prepend: !t
            });
          }, this) : this.add(this.options.input, {
            prepend: !t
          })), this.__setExplain(this.options);
          var e = this._getNames();
          this.listenTo(this.model, "form:field-error", function (n, i) {
            r.default.contains(e, n) && this.__setError(i, t);
          }), this.listenTo(this.model, "form:clear-errors change:" + e.join(" change:"), this.__clearError), this.listenTo(this.model, "form:clear-error:" + e.join(" form:clear-error:"), this.__clearError), r.default.resultCtx(this.options, "autoRender", this) && this.listenTo(this.model, "change:" + this.options.name, this.render), this.__errorState = !1;
        },
        __setExplain: function __setExplain(t) {
          var e = void 0;
          if (t.customExplain) return i.default.warn("Deprecated - use explain instead of customExplain"), void this.add(this.options.customExplain);
          e = t.explain, r.default.isFunction(e) && !c(e) && (e = r.default.resultCtx(this.options, "explain", this)), e && (c(e) ? (this.template = '<p class="o-form-explain"></p>', this.add(e, ".o-form-explain")) : this.template = '<p class="o-form-explain">{{explain}}</p>');
        },
        __setError: function __setError(t, e) {
          this.__errorState = !0, this.$el.addClass("o-form-has-errors");
          var n = r.default.uniqueId("input-container-error"),
            i = ['<p id="{{errorId}}" class="okta-form-input-error o-form-input-error o-form-explain" role="alert">', '<span class="icon icon-16 error-16-small" role="img" aria-label="{{iconLabel}}"></span>', "{{text}}", "</p>"].join(""),
            a = s.default.localize("oform.error.icon.ariaLabel", "courage"),
            u = o.default.tpl(i)({
              errorId: n,
              iconLabel: a,
              text: t.join(", ")
            }),
            c = this.$(".o-form-explain").not(".o-form-input-error").first();
          c.length && !e ? c.before(u) : this.$el.append(u), this.$el.attr("aria-describedby", n);
        },
        __clearError: function __clearError() {
          var t = this;
          this.__errorState && (this.$(".o-form-input-error").remove(), this.$el.attr("aria-describedby", null), this.$el.removeClass("o-form-has-errors"), this.__errorState = !1, r.default.defer(function () {
            t.model.trigger("form:resize");
          }));
        },
        focus: function focus() {
          return this.each(function (t) {
            if (t.focus) return t.focus();
          }), this;
        }
      });
    }, function (t, e, n) {
      function r(t, e) {
        return s.default.isBaseInput(t) && t.prototype ? new t(a.default.omit(e, "input")) : t;
      }
      function i(t) {
        if (t = a.default.clone(t), t.input) return r(t.input, t);
        var e = s.default.get(t);
        if (!e) throw new Error("unknown input: " + t.type);
        return r(e, t);
      }
      function o(t) {
        return !!t.input || !!s.default.get(t);
      }
      var a = n(0),
        s = n(26);
      e.a = {
        create: i,
        supports: o
      };
    }, function (t, e, n) {
      var r = n(0),
        i = n(27),
        o = (n.n(i), n(4)),
        a = n(1);
      e.a = a.default.extend({
        className: "okta-form-label o-form-label",
        attributes: {
          "data-se": "o-form-label"
        },
        constructor: function constructor(t) {
          r.default.defaults(t, {
            inputId: t.id
          }), delete t.id, a.default.apply(this, arguments);
          var e = void 0;
          e = this._isLabelView(t.label) ? '<label for="{{inputId}}"></label>' : r.default.contains(["radio", "checkbox"], t.type) || !t.label ? "{{label}}" : '<label for="{{inputId}}">{{label}}&nbsp;</label>', t.sublabel && (e += '<span class="o-form-explain">{{sublabel}}</span>'), t.tooltip && (r.default.isString(t.tooltip) && (t.tooltip = {
            text: t.tooltip
          }), e += '<span class="o-form-tooltip icon-16 icon-only form-help-16" title="{{tooltip.text}}"></span>'), this.template = o.default.tpl(e);
        },
        getTemplateData: function getTemplateData() {
          var t = {
            label: ""
          };
          return r.default.each(["inputId", "label", "sublabel", "tooltip"], function (e) {
            t[e] = r.default.resultCtx(this.options, e, this);
          }, this), t;
        },
        _isLabelView: function _isLabelView(t) {
          return !r.default.isUndefined(t) && t instanceof a.default;
        },
        postRender: function postRender() {
          var t = this.getTemplateData();
          this._isLabelView(t.label) && (this.removeChildren(), this.add(t.label, "label")), t.tooltip && this.$(".o-form-tooltip").qtip(r.default.extend({
            style: {
              classes: "qtip-custom qtip-shadow"
            },
            position: {
              my: "bottom left",
              at: "top center"
            },
            hide: {
              fixed: !0
            },
            show: {
              delay: 0
            }
          }, t.tooltip.options));
        }
      });
    }, function (t, e, n) {
      function r(t, e) {
        t.apply(this, o.default.map(e.split(/\s+/), function (t) {
          return this.model.get(t);
        }, this));
      }
      function i(t, e) {
        o.default.isFunction(t) && t.call(e);
      }
      var o = n(0),
        a = n(1),
        s = n(9);
      e.a = a.default.extend({
        className: function className() {
          var t = "o-form-fieldset";
          return this.options["label-top"] && (t += " o-form-label-top"), this.options.readOnly && (t += " o-form-read-mode"), t;
        },
        attributes: function attributes() {
          return {
            "data-se": this.options["data-se"] || "o-form-fieldset"
          };
        },
        constructor: function constructor(t) {
          t.className && (this.inputWrapperClassName = this.className, this.optionsClassName = t.className, t.className = function () {
            return o.default.result(this, "inputWrapperClassName", "") + " " + o.default.result(this, "optionsClassName");
          }), a.default.apply(this, arguments), o.default.each(t.events || {}, function (t, e) {
            this.listenTo(this.model, e, t);
          }, this), o.default.each(t.bindings || {}, function (t, e) {
            this.listenTo(this.model, s.default.changeEventString(e.split(/\s+/)), o.default.bind(r, this, t, e));
          }, this), s.default.applyShowWhen(this, t.showWhen), s.default.applyToggleWhen(this, t.toggleWhen), i(t.initialize, this);
        },
        postRender: function postRender() {
          o.default.each(this.options.bindings || {}, r, this), i(this.options.render, this);
        },
        getLabel: function getLabel() {
          return this.size() > 1 ? this.at(0) : null;
        },
        getInput: function getInput() {
          return this.getInputContainer();
        },
        getInputContainer: function getInputContainer() {
          return this.at(this.size() > 1 ? 1 : 0);
        },
        getInputs: function getInputs() {
          return this.getInputContainer().toArray();
        },
        focus: function focus() {
          return this.getInput().focus();
        }
      });
    }, function (t, e, n) {
      function r(t) {
        var e = t.get("__displayType__"),
          n = t.get("__possibleValues__"),
          r = t.get("name"),
          i = t.get("title"),
          a = {
            type: "text",
            name: r,
            label: i || r
          };
        switch (e) {
          case "arrayofstring":
            a.input = g.a, a.params = {
              itemType: "string"
            };
            break;
          case "arrayofnumber":
            a.input = g.a, a.params = {
              itemType: "number"
            };
            break;
          case "arrayofinteger":
            a.input = g.a, a.params = {
              itemType: "integer"
            };
            break;
          case "arrayofobject":
            a.input = g.a, a.params = {
              itemType: t.get("items").type
            };
            break;
          case "arrayofref-id":
            a.input = g.a, a.params = {
              itemType: t.get("items").format
            };
            break;
          case "boolean":
            a.input = m.a;
            break;
          case "integer":
          case "number":
            a.to = o;
            break;
          case "reference":
            a.type = "select", a.options = s(n);
            break;
          case "image":
            a.readOnly = !0, a.from = function (t) {
              return d.default.isEmpty(t) ? "" : h.default.localize("user.profile.image.image_set", "courage");
            };
            break;
          case "password":
            a.type = "password";
            break;
          case "date":
            a.type = "date";
            break;
          case "uri":
          case "country-code":
          case "country_code":
          case "language-code":
          case "language_code":
          case "email":
          case "locale":
          case "timezone":
          case "string":
          case "object":
            break;
          default:
            throw new Error("unknown type: " + e);
        }
        return a;
      }
      function i(t) {
        var e = {},
          n = t.get("name"),
          r = t.get("__displayType__"),
          i = t.get("__possibleValues__"),
          o = t.get("__fieldNamePrefix__");
        if (o && (e.name = o + n, e.errorField = n), t.isEnumType()) {
          var u = {
            displayType: r,
            title: t.get("title"),
            enumValues: t.getEnumValues()
          };
          e = d.default.extend({}, v.a.getEnumInputOptions(u), e);
        } else a(r) && i && (e.type = "checkboxset", e.input = null, e.options = s(i));
        return e;
      }
      function o(t) {
        var e = h.default.parseFloat(t);
        return "" === t ? null : e;
      }
      function a(t) {
        return t && t.indexOf("array") >= 0;
      }
      function s(t) {
        return d.default.object(t, t);
      }
      function u(t) {
        var e = t.get("items");
        return e ? e.objectName : t.get("objectName");
      }
      function c(t, e, n) {
        var r = t.get("name"),
          i = n.__nestedProperty__,
          o = e[r],
          a = n.get(r),
          s = void 0,
          c = void 0;
        i && t.set("__fieldNamePrefix__", i), s = e[u(t)], o && a && (o = d.default.union(o, a)), s && s.length ? c = s : o && o.length && (c = o), t.set("__possibleValues__", c);
      }
      function l(t, e, n) {
        return t.each(function (t) {
          c(t, e, n);
        }), t;
      }
      function f(t, e) {
        return t.filter(function (t) {
          return p(t, e);
        });
      }
      function p(t, e) {
        var n = u(t),
          r = e[n];
        return !n || !Object(d.default)(r).isEmpty();
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var d = n(0),
        h = n(3),
        m = n(66),
        g = n(68),
        v = n(18);
      e.default = {
        createInputOptions: function createInputOptions(t) {
          var e = i(t),
            n = r(t);
          return e.params && n.params && (e.params = d.default.defaults(e.params, n.params)), d.default.defaults(e, n);
        },
        hasValidSchemaProps: function hasValidSchemaProps(t, e) {
          return !d.default.isEmpty(t) && !!f(t, e).length;
        },
        prepareSchema: function prepareSchema(t, e, n) {
          return t.reset(f(t, e)), l(t, e, n);
        },
        augmentSchemaProps: l,
        augmentSchemaProp: c
      };
    }, function (t, e, n) {
      var r = n(28),
        i = {
          undefined: "undefined",
          true: "true",
          false: "false"
        },
        o = function o(t) {
          return t ? "true" : !1 === t ? "false" : "undefined";
        },
        a = function a(t) {
          switch (t) {
            case "undefined":
              return null;
            case "true":
              return !0;
            case "false":
              return !1;
            default:
              return null;
          }
        };
      e.a = r.default.extend({
        initialize: function initialize() {
          this.options.options = i, this.options.from = o, this.options.to = a;
        }
      });
    }, function (t, e, n) {
      var r, i;
      r = [n(12)], void 0 !== (i = function (t) {
        (function () {
          var t;
          t = function () {
            function t() {
              this.options_index = 0, this.parsed = [];
            }
            return t.prototype.add_node = function (t) {
              return "OPTGROUP" === t.nodeName.toUpperCase() ? this.add_group(t) : this.add_option(t);
            }, t.prototype.add_group = function (t) {
              var e, n, r, i, o, a;
              for (e = this.parsed.length, this.parsed.push({
                array_index: e,
                group: !0,
                label: t.label,
                children: 0,
                disabled: t.disabled
              }), o = t.childNodes, a = [], r = 0, i = o.length; r < i; r++) n = o[r], a.push(this.add_option(n, e, t.disabled));
              return a;
            }, t.prototype.add_option = function (t, e, n) {
              if ("OPTION" === t.nodeName.toUpperCase()) return "" !== t.text ? (null != e && (this.parsed[e].children += 1), this.parsed.push({
                array_index: this.parsed.length,
                options_index: this.options_index,
                value: t.value,
                text: t.text,
                html: t.innerHTML,
                selected: t.selected,
                disabled: !0 === n ? n : t.disabled,
                group_array_index: e,
                classes: t.className,
                style: t.style.cssText
              })) : this.parsed.push({
                array_index: this.parsed.length,
                options_index: this.options_index,
                empty: !0
              }), this.options_index += 1;
            }, t;
          }(), t.select_to_array = function (e) {
            var n, r, i, o, a;
            for (r = new t(), a = e.childNodes, i = 0, o = a.length; i < o; i++) n = a[i], r.add_node(n);
            return r.parsed;
          }, this.SelectParser = t;
        }).call(this), function () {
          var t, e;
          e = this, t = function () {
            function t(e, n) {
              this.form_field = e, this.options = null != n ? n : {}, t.browser_is_supported() && (this.is_multiple = this.form_field.multiple, this.set_default_text(), this.set_default_values(), this.setup(), this.set_up_html(), this.register_observers(), this.finish_setup());
            }
            return t.prototype.set_default_values = function () {
              var t = this;
              return this.click_test_action = function (e) {
                return t.test_active_click(e);
              }, this.activate_action = function (e) {
                return t.activate_field(e);
              }, this.active_field = !1, this.mouse_on_container = !1, this.results_showing = !1, this.result_highlighted = null, this.result_single_selected = null, this.allow_single_deselect = null != this.options.allow_single_deselect && null != this.form_field.options[0] && "" === this.form_field.options[0].text && this.options.allow_single_deselect, this.disable_search_threshold = this.options.disable_search_threshold || 0, this.disable_search = this.options.disable_search || !1, this.enable_split_word_search = null == this.options.enable_split_word_search || this.options.enable_split_word_search, this.search_contains = this.options.search_contains || !1, this.single_backstroke_delete = this.options.single_backstroke_delete || !1, this.max_selected_options = this.options.max_selected_options || 1 / 0, this.inherit_select_classes = this.options.inherit_select_classes || !1;
            }, t.prototype.set_default_text = function () {
              return this.form_field.getAttribute("data-placeholder") ? this.default_text = this.form_field.getAttribute("data-placeholder") : this.is_multiple ? this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || t.default_multiple_text : this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || t.default_single_text, this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || t.default_no_result_text;
            }, t.prototype.mouse_enter = function () {
              return this.mouse_on_container = !0;
            }, t.prototype.mouse_leave = function () {
              return this.mouse_on_container = !1;
            }, t.prototype.input_focus = function (t) {
              var e = this;
              if (this.is_multiple) {
                if (!this.active_field) return setTimeout(function () {
                  return e.container_mousedown();
                }, 50);
              } else if (!this.active_field) return this.activate_field();
            }, t.prototype.input_blur = function (t) {
              var e = this;
              if (!this.mouse_on_container) return this.active_field = !1, setTimeout(function () {
                return e.blur_test();
              }, 100);
            }, t.prototype.result_add_option = function (t) {
              var e, n;
              return t.dom_id = this.container_id + "_o_" + t.array_index, e = [], t.disabled || t.selected && this.is_multiple || e.push("active-result"), !t.disabled || t.selected && this.is_multiple || e.push("disabled-result"), t.selected && e.push("result-selected"), null != t.group_array_index && e.push("group-option"), "" !== t.classes && e.push(t.classes), n = "" !== t.style.cssText ? ' style="' + t.style + '"' : "", '<li id="' + t.dom_id + '" class="' + e.join(" ") + '"' + n + ">" + t.html + "</li>";
            }, t.prototype.results_update_field = function () {
              return this.set_default_text(), this.is_multiple || this.results_reset_cleanup(), this.result_clear_highlight(), this.result_single_selected = null, this.results_build();
            }, t.prototype.results_toggle = function () {
              return this.results_showing ? this.results_hide() : this.results_show();
            }, t.prototype.results_search = function (t) {
              return this.results_showing ? this.winnow_results() : this.results_show();
            }, t.prototype.choices_count = function () {
              var t, e, n, r;
              if (null != this.selected_option_count) return this.selected_option_count;
              for (this.selected_option_count = 0, r = this.form_field.options, e = 0, n = r.length; e < n; e++) t = r[e], t.selected && (this.selected_option_count += 1);
              return this.selected_option_count;
            }, t.prototype.choices_click = function (t) {
              if (t.preventDefault(), !this.results_showing && !this.is_disabled) return this.results_show();
            }, t.prototype.keyup_checker = function (t) {
              var e, n;
              switch (e = null != (n = t.which) ? n : t.keyCode, this.search_field_scale(), e) {
                case 8:
                  if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) return this.keydown_backstroke();
                  if (!this.pending_backstroke) return this.result_clear_highlight(), this.results_search();
                  break;
                case 13:
                  if (t.preventDefault(), this.results_showing) return this.result_select(t);
                  break;
                case 27:
                  return this.results_showing && this.results_hide(), !0;
                case 9:
                case 38:
                case 40:
                case 16:
                case 91:
                case 17:
                  break;
                default:
                  return this.results_search();
              }
            }, t.prototype.generate_field_id = function () {
              var t;
              return t = this.generate_random_id(), this.form_field.id = t, t;
            }, t.prototype.generate_random_char = function () {
              var t, e;
              return t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", e = Math.floor(Math.random() * t.length), t.substring(e, e + 1);
            }, t.prototype.container_width = function () {
              return null != this.options.width ? this.options.width : this.form_field.offsetWidth + "px";
            }, t.browser_is_supported = function () {
              var t;
              return "Microsoft Internet Explorer" !== window.navigator.appName || null !== (t = document.documentMode) && t >= 8;
            }, t.default_multiple_text = "Select Some Options", t.default_single_text = "Select an Option", t.default_no_result_text = "No results match", t;
          }(), e.AbstractChosen = t;
        }.call(this), function () {
          var e,
            n,
            r,
            i,
            o = {}.hasOwnProperty,
            a = function a(t, e) {
              function n() {
                this.constructor = t;
              }
              for (var r in e) o.call(e, r) && (t[r] = e[r]);
              return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
            };
          r = this;
          var s = r.AbstractChosen;
          e = t, e.fn.extend({
            chosen: function chosen(t) {
              return s.browser_is_supported() ? this.each(function (r) {
                var i;
                if (i = e(this), !i.hasClass("chzn-done")) return i.data("chosen", new n(this, t));
              }) : this;
            }
          }), n = function (t) {
            function n() {
              return i = n.__super__.constructor.apply(this, arguments);
            }
            return a(n, t), n.prototype.setup = function () {
              return this.form_field_jq = e(this.form_field), this.current_selectedIndex = this.form_field.selectedIndex, this.is_rtl = this.form_field_jq.hasClass("chzn-rtl");
            }, n.prototype.finish_setup = function () {
              return this.form_field_jq.addClass("chzn-done");
            }, n.prototype.set_up_html = function () {
              var t, n;
              return this.container_id = this.form_field.id.length ? this.form_field.id.replace(/[^\w]/g, "_") : this.generate_field_id(), this.container_id += "_chzn", t = ["chzn-container"], t.push("chzn-container-" + (this.is_multiple ? "multi" : "single")), this.inherit_select_classes && this.form_field.className && t.push(this.form_field.className), this.is_rtl && t.push("chzn-rtl"), n = {
                id: this.container_id,
                class: t.join(" "),
                style: "width: " + this.container_width() + ";",
                title: this.form_field.title
              }, this.container = e("<div />", n), this.is_multiple ? this.container.html('<ul class="chzn-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chzn-drop"><ul class="chzn-results"></ul></div>') : this.container.html('<a href="javascript:void(0)" class="chzn-single chzn-default" tabindex="-1"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chzn-drop"><div class="chzn-search"><input type="text" autocomplete="off" /></div><ul class="chzn-results"></ul></div>'), this.form_field_jq.hide().after(this.container), this.dropdown = this.container.find("div.chzn-drop").first(), this.search_field = this.container.find("input").first(), this.search_results = this.container.find("ul.chzn-results").first(), this.search_field_scale(), this.search_no_results = this.container.find("li.no-results").first(), this.is_multiple ? (this.search_choices = this.container.find("ul.chzn-choices").first(), this.search_container = this.container.find("li.search-field").first()) : (this.search_container = this.container.find("div.chzn-search").first(), this.selected_item = this.container.find(".chzn-single").first()), this.results_build(), this.set_tab_index(), this.set_label_behavior(), this.form_field_jq.trigger("liszt:ready", {
                chosen: this
              });
            }, n.prototype.register_observers = function () {
              var t = this;
              return this.container.mousedown(function (e) {
                t.container_mousedown(e);
              }), this.container.mouseup(function (e) {
                t.container_mouseup(e);
              }), this.container.mouseenter(function (e) {
                t.mouse_enter(e);
              }), this.container.mouseleave(function (e) {
                t.mouse_leave(e);
              }), this.search_results.mouseup(function (e) {
                t.search_results_mouseup(e);
              }), this.search_results.mouseover(function (e) {
                t.search_results_mouseover(e);
              }), this.search_results.mouseout(function (e) {
                t.search_results_mouseout(e);
              }), this.search_results.bind("mousewheel DOMMouseScroll", function (e) {
                t.search_results_mousewheel(e);
              }), this.form_field_jq.bind("liszt:updated", function (e) {
                t.results_update_field(e);
              }), this.form_field_jq.bind("liszt:activate", function (e) {
                t.activate_field(e);
              }), this.form_field_jq.bind("liszt:open", function (e) {
                t.container_mousedown(e);
              }), this.search_field.blur(function (e) {
                t.input_blur(e);
              }), this.search_field.keyup(function (e) {
                t.keyup_checker(e);
              }), this.search_field.keydown(function (e) {
                t.keydown_checker(e);
              }), this.search_field.focus(function (e) {
                t.input_focus(e);
              }), this.is_multiple ? this.search_choices.click(function (e) {
                t.choices_click(e);
              }) : this.container.click(function (t) {
                t.preventDefault();
              });
            }, n.prototype.search_field_disabled = function () {
              return this.is_disabled = this.form_field_jq[0].disabled, this.is_disabled ? (this.container.addClass("chzn-disabled"), this.search_field[0].disabled = !0, this.is_multiple || this.selected_item.unbind("focus", this.activate_action), this.close_field()) : (this.container.removeClass("chzn-disabled"), this.search_field[0].disabled = !1, this.is_multiple ? void 0 : this.selected_item.bind("focus", this.activate_action));
            }, n.prototype.container_mousedown = function (t) {
              if (!this.is_disabled && (t && "mousedown" === t.type && !this.results_showing && t.preventDefault(), null == t || !e(t.target).hasClass("search-choice-close"))) return this.active_field ? this.is_multiple || !t || e(t.target)[0] !== this.selected_item[0] && !e(t.target).parents("a.chzn-single").length || (t.preventDefault(), this.results_toggle()) : (this.is_multiple && this.search_field.val(""), e(document).click(this.click_test_action), this.results_show()), this.activate_field();
            }, n.prototype.container_mouseup = function (t) {
              if ("ABBR" === t.target.nodeName && !this.is_disabled) return this.results_reset(t);
            }, n.prototype.search_results_mousewheel = function (t) {
              var e, n, r;
              if (null != (e = -(null != (n = t.originalEvent) ? n.wheelDelta : void 0) || (null != (r = t.originialEvent) ? r.detail : void 0))) return t.preventDefault(), "DOMMouseScroll" === t.type && (e *= 40), this.search_results.scrollTop(e + this.search_results.scrollTop());
            }, n.prototype.blur_test = function (t) {
              if (!this.active_field && this.container.hasClass("chzn-container-active")) return this.close_field();
            }, n.prototype.close_field = function () {
              return e(document).unbind("click", this.click_test_action), this.active_field = !1, this.results_hide(), this.container.removeClass("chzn-container-active"), this.clear_backstroke(), this.show_search_field_default(), this.search_field_scale();
            }, n.prototype.activate_field = function () {
              return this.container.addClass("chzn-container-active"), this.active_field = !0, this.search_field.val(this.search_field.val()), this.search_field.focus();
            }, n.prototype.test_active_click = function (t) {
              return e(t.target).parents("#" + this.container_id).length ? this.active_field = !0 : this.close_field();
            }, n.prototype.results_build = function () {
              var t, e, n, i, o;
              for (this.parsing = !0, this.selected_option_count = null, this.results_data = r.SelectParser.select_to_array(this.form_field), this.is_multiple ? this.search_choices.find("li.search-choice").remove() : this.is_multiple || (this.selected_item.addClass("chzn-default").find("span").text(this.default_text), this.disable_search || this.form_field.options.length <= this.disable_search_threshold ? (this.search_field[0].readOnly = !0, this.container.addClass("chzn-container-single-nosearch")) : (this.search_field[0].readOnly = !1, this.container.removeClass("chzn-container-single-nosearch"))), t = "", o = this.results_data, n = 0, i = o.length; n < i; n++) e = o[n], e.group ? t += this.result_add_group(e) : e.empty || (t += this.result_add_option(e), e.selected && this.is_multiple ? this.choice_build(e) : e.selected && !this.is_multiple && (this.selected_item.removeClass("chzn-default").find("span").text(e.text), this.allow_single_deselect && this.single_deselect_control_build()));
              return this.search_field_disabled(), this.show_search_field_default(), this.search_field_scale(), this.search_results.html(t), this.parsing = !1;
            }, n.prototype.result_add_group = function (t) {
              return t.dom_id = this.container_id + "_g_" + t.array_index, '<li id="' + t.dom_id + '" class="group-result">' + e("<div />").text(t.label).html() + "</li>";
            }, n.prototype.result_do_highlight = function (t) {
              var e, n, r, i, o;
              if (t.length) {
                if (this.result_clear_highlight(), this.result_highlight = t, this.result_highlight.addClass("highlighted"), r = parseInt(this.search_results.css("maxHeight"), 10), o = this.search_results.scrollTop(), i = r + o, n = this.result_highlight.position().top + this.search_results.scrollTop(), (e = n + this.result_highlight.outerHeight()) >= i) return this.search_results.scrollTop(e - r > 0 ? e - r : 0);
                if (n < o) return this.search_results.scrollTop(n);
              }
            }, n.prototype.result_clear_highlight = function () {
              return this.result_highlight && this.result_highlight.removeClass("highlighted"), this.result_highlight = null;
            }, n.prototype.results_show = function () {
              return this.is_multiple && this.max_selected_options <= this.choices_count() ? (this.form_field_jq.trigger("liszt:maxselected", {
                chosen: this
              }), !1) : (this.container.addClass("chzn-with-drop"), this.form_field_jq.trigger("liszt:showing_dropdown", {
                chosen: this
              }), this.results_showing = !0, this.search_field.focus(), this.search_field.val(this.search_field.val()), this.winnow_results());
            }, n.prototype.results_hide = function () {
              return this.results_showing && (this.result_clear_highlight(), this.container.removeClass("chzn-with-drop"), this.form_field_jq.trigger("liszt:hiding_dropdown", {
                chosen: this
              })), this.results_showing = !1;
            }, n.prototype.set_tab_index = function (t) {
              var e;
              if (this.form_field_jq.attr("tabindex")) return e = this.form_field_jq.attr("tabindex"), this.form_field_jq.attr("tabindex", -1), this.search_field.attr("tabindex", e);
            }, n.prototype.set_label_behavior = function () {
              var t = this;
              if (this.form_field_label = this.form_field_jq.parents("label"), !this.form_field_label.length && this.form_field.id.length && (this.form_field_label = e("label[for='" + this.form_field.id + "']")), this.form_field_label.length > 0) return this.form_field_label.click(function (e) {
                return t.is_multiple ? t.container_mousedown(e) : t.activate_field();
              });
            }, n.prototype.show_search_field_default = function () {
              return this.is_multiple && this.choices_count() < 1 && !this.active_field ? (this.search_field.val(this.default_text), this.search_field.addClass("default")) : (this.search_field.val(""), this.search_field.removeClass("default"));
            }, n.prototype.search_results_mouseup = function (t) {
              var n;
              if (n = e(t.target).hasClass("active-result") ? e(t.target) : e(t.target).parents(".active-result").first(), n.length) return this.result_highlight = n, this.result_select(t), this.search_field.focus();
            }, n.prototype.search_results_mouseover = function (t) {
              var n;
              if (n = e(t.target).hasClass("active-result") ? e(t.target) : e(t.target).parents(".active-result").first()) return this.result_do_highlight(n);
            }, n.prototype.search_results_mouseout = function (t) {
              if (e(t.target).hasClass("active-result")) return this.result_clear_highlight();
            }, n.prototype.choice_build = function (t) {
              var n,
                r,
                i = this;
              return n = e("<li />", {
                class: "search-choice"
              }).html("<span>" + t.html + "</span>"), t.disabled ? n.addClass("search-choice-disabled") : (r = e("<a />", {
                href: "#",
                class: "search-choice-close",
                rel: t.array_index
              }), r.click(function (t) {
                return i.choice_destroy_link_click(t);
              }), n.append(r)), this.search_container.before(n);
            }, n.prototype.choice_destroy_link_click = function (t) {
              if (t.preventDefault(), t.stopPropagation(), !this.is_disabled) return this.choice_destroy(e(t.target));
            }, n.prototype.choice_destroy = function (t) {
              if (this.result_deselect(t.attr("rel"))) return this.show_search_field_default(), this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1 && this.results_hide(), t.parents("li").first().remove(), this.search_field_scale();
            }, n.prototype.results_reset = function () {
              if (this.form_field.options[0].selected = !0, this.selected_option_count = null, this.selected_item.find("span").text(this.default_text), this.is_multiple || this.selected_item.addClass("chzn-default"), this.show_search_field_default(), this.results_reset_cleanup(), this.form_field_jq.trigger("change"), this.active_field) return this.results_hide();
            }, n.prototype.results_reset_cleanup = function () {
              return this.current_selectedIndex = this.form_field.selectedIndex, this.selected_item.find("abbr").remove();
            }, n.prototype.result_select = function (t) {
              var e, n, r, i;
              if (this.result_highlight) return e = this.result_highlight, n = e.attr("id"), this.result_clear_highlight(), this.is_multiple && this.max_selected_options <= this.choices_count() ? (this.form_field_jq.trigger("liszt:maxselected", {
                chosen: this
              }), !1) : (this.is_multiple ? e.removeClass("active-result") : (this.search_results.find(".result-selected").removeClass("result-selected"), this.result_single_selected = e, this.selected_item.removeClass("chzn-default")), e.addClass("result-selected"), i = n.substr(n.lastIndexOf("_") + 1), r = this.results_data[i], r.selected = !0, this.form_field.options[r.options_index].selected = !0, this.selected_option_count = null, this.is_multiple ? this.choice_build(r) : (this.selected_item.find("span").first().text(r.text), this.allow_single_deselect && this.single_deselect_control_build()), (t.metaKey || t.ctrlKey) && this.is_multiple || this.results_hide(), this.search_field.val(""), (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) && this.form_field_jq.trigger("change", {
                selected: this.form_field.options[r.options_index].value
              }), this.current_selectedIndex = this.form_field.selectedIndex, this.search_field_scale());
            }, n.prototype.result_activate = function (t, e) {
              return e.disabled ? t.addClass("disabled-result") : this.is_multiple && e.selected ? t.addClass("result-selected") : t.addClass("active-result");
            }, n.prototype.result_deactivate = function (t) {
              return t.removeClass("active-result result-selected disabled-result");
            }, n.prototype.result_deselect = function (t) {
              var n, r;
              return r = this.results_data[t], !this.form_field.options[r.options_index].disabled && (r.selected = !1, this.form_field.options[r.options_index].selected = !1, this.selected_option_count = null, n = e("#" + this.container_id + "_o_" + t), n.removeClass("result-selected").addClass("active-result").show(), this.result_clear_highlight(), this.winnow_results(), this.form_field_jq.trigger("change", {
                deselected: this.form_field.options[r.options_index].value
              }), this.search_field_scale(), !0);
            }, n.prototype.single_deselect_control_build = function () {
              if (this.allow_single_deselect) return this.selected_item.find("abbr").length || this.selected_item.find("span").first().after('<abbr class="search-choice-close"></abbr>'), this.selected_item.addClass("chzn-single-with-deselect");
            }, n.prototype.winnow_results = function () {
              var t, n, r, i, o, a, s, u, c, l, f, p, d, h, m, g, v, y;
              for (this.no_results_clear(), c = 0, l = this.search_field.val() === this.default_text ? "" : e("<div/>").text(e.trim(this.search_field.val())).html(), a = this.search_contains ? "" : "^", o = new RegExp(a + l.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), "i"), d = new RegExp(l.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), "i"), y = this.results_data, h = 0, g = y.length; h < g; h++) if (n = y[h], !n.empty) if (n.group) e("#" + n.dom_id).css("display", "none");else {
                if (t = !1, u = n.dom_id, s = e("#" + u), o.test(n.html)) t = !0, c += 1;else if (this.enable_split_word_search && (n.html.indexOf(" ") >= 0 || 0 === n.html.indexOf("[")) && (i = n.html.replace(/\[|\]/g, "").split(" "), i.length)) for (m = 0, v = i.length; m < v; m++) r = i[m], o.test(r) && (t = !0, c += 1);
                t ? (l.length ? (f = n.html.search(d), p = n.html.substr(0, f + l.length) + "</em>" + n.html.substr(f + l.length), p = p.substr(0, f) + "<em>" + p.substr(f)) : p = n.html, s.html(p), this.result_activate(s, n), null != n.group_array_index && e("#" + this.results_data[n.group_array_index].dom_id).css("display", "list-item")) : (this.result_highlight && u === this.result_highlight.attr("id") && this.result_clear_highlight(), this.result_deactivate(s));
              }
              return c < 1 && l.length ? this.no_results(l) : this.winnow_results_set_highlight();
            }, n.prototype.winnow_results_set_highlight = function () {
              var t, e;
              if (!this.result_highlight && (e = this.is_multiple ? [] : this.search_results.find(".result-selected.active-result"), null != (t = e.length ? e.first() : this.search_results.find(".active-result").first()))) return this.result_do_highlight(t);
            }, n.prototype.no_results = function (t) {
              var n;
              return n = e('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>'), n.find("span").first().html(t), this.search_results.append(n);
            }, n.prototype.no_results_clear = function () {
              return this.search_results.find(".no-results").remove();
            }, n.prototype.keydown_arrow = function () {
              var t;
              return this.results_showing && this.result_highlight ? (t = this.result_highlight.nextAll("li.active-result").first()) ? this.result_do_highlight(t) : void 0 : this.results_show();
            }, n.prototype.keyup_arrow = function () {
              var t;
              return this.results_showing || this.is_multiple ? this.result_highlight ? (t = this.result_highlight.prevAll("li.active-result"), t.length ? this.result_do_highlight(t.first()) : (this.choices_count() > 0 && this.results_hide(), this.result_clear_highlight())) : void 0 : this.results_show();
            }, n.prototype.keydown_backstroke = function () {
              var t;
              return this.pending_backstroke ? (this.choice_destroy(this.pending_backstroke.find("a").first()), this.clear_backstroke()) : (t = this.search_container.siblings("li.search-choice").last(), t.length && !t.hasClass("search-choice-disabled") ? (this.pending_backstroke = t, this.single_backstroke_delete ? this.keydown_backstroke() : this.pending_backstroke.addClass("search-choice-focus")) : void 0);
            }, n.prototype.clear_backstroke = function () {
              return this.pending_backstroke && this.pending_backstroke.removeClass("search-choice-focus"), this.pending_backstroke = null;
            }, n.prototype.keydown_checker = function (t) {
              var e, n;
              switch (e = null != (n = t.which) ? n : t.keyCode, this.search_field_scale(), 8 !== e && this.pending_backstroke && this.clear_backstroke(), e) {
                case 8:
                  this.backstroke_length = this.search_field.val().length;
                  break;
                case 9:
                  this.results_showing && !this.is_multiple && this.result_select(t), this.mouse_on_container = !1;
                  break;
                case 13:
                  t.preventDefault();
                  break;
                case 38:
                  t.preventDefault(), this.keyup_arrow();
                  break;
                case 40:
                  t.preventDefault(), this.keydown_arrow();
              }
            }, n.prototype.search_field_scale = function () {
              var t, n, r, i, o, a, s;
              if (this.is_multiple) {
                for (0, o = 0, r = "position:absolute; left: -1000px; top: -1000px; display:none;", i = ["font-size", "font-style", "font-weight", "font-family", "line-height", "text-transform", "letter-spacing"], a = 0, s = i.length; a < s; a++) n = i[a], r += n + ":" + this.search_field.css(n) + ";";
                return t = e("<div />", {
                  style: r
                }), t.text(this.search_field.val()), e("body").append(t), o = t.width() + 25, t.remove(), this.f_width || (this.f_width = this.container.outerWidth()), o > this.f_width - 10 && (o = this.f_width - 10), this.search_field.css({
                  width: o + "px"
                });
              }
            }, n.prototype.generate_random_id = function () {
              var t;
              for (t = "sel" + this.generate_random_char() + this.generate_random_char() + this.generate_random_char(); e("#" + t).length > 0;) t += this.generate_random_char();
              return t;
            }, n;
          }(s), r.Chosen = n;
        }.call(this);
      }.apply(e, r)) && (t.exports = i);
    }, function (t, e, n) {
      var r = n(0),
        i = n(13),
        o = n(10),
        a = n(69);
      e.a = o.a.extend({
        className: "array-input",
        template: '<a href="#" class="array-inputs-button link-button">Add Another</a>',
        params: {
          itemType: "string"
        },
        events: {
          "click .array-inputs-button": function clickArrayInputsButton(t) {
            t.preventDefault(), this.isEditMode() && this.addNewElement();
          }
        },
        initialize: function initialize(t) {
          t || (t = {}), this.params = r.default.defaults(t.params || {}, this.params), this.uniqueIdPrefix = "array";
        },
        from: function from(t) {
          return r.default.isArray(t) ? t : [];
        },
        editMode: function editMode() {
          return this._setArrayObject(), this.$el.html(this.template), r.default.each(this.arrayObject, r.default.bind(this._addDeletableBox, this)), this;
        },
        readMode: function readMode() {
          this.editMode(), this.$(".array-inputs-button").addClass("link-button-disabled");
        },
        val: function val() {
          var t = r.default.values(this.arrayObject);
          return r.default.contains([i.a.DATATYPE.number, i.a.DATATYPE.integer], this.params.itemType) && (t = r.default.filter(t, r.default.isNumber)), t;
        },
        focus: function focus() {},
        addNewElement: function addNewElement() {
          var t = r.default.uniqueId(this.uniqueIdPrefix);
          this.arrayObject[t] = "", this._addDeletableBox("", t), this.update();
        },
        _addDeletableBox: function _addDeletableBox(t, e) {
          var n = new a.a(r.default.extend(r.default.pick(this.options, "read", "readOnly", "model"), {
            key: e,
            value: t,
            itemType: this.params.itemType
          }));
          return this.listenTo(n, "updateArray", function (t) {
            r.default.isNull(t) ? (delete this.arrayObject[e], this.stopListening(n)) : this.arrayObject[e] = t, this.update();
          }), n.render().$el.hide(), this.$(".array-inputs-button").before(n.el), n.$el.slideDown(), n;
        },
        _setArrayObject: function _setArrayObject() {
          var t = this.model.get(this.options.name);
          if (this.arrayObject = {}, r.default.isArray(t) && !r.default.isEmpty(t)) {
            var e = [],
              n = this;
            Object(r.default)(t.length).times(function () {
              e.push(r.default.uniqueId(n.uniqueIdPrefix));
            }), this.arrayObject = r.default.object(e, t);
          }
        }
      });
    }, function (t, e, n) {
      var r = n(0),
        i = n(13),
        o = n(3),
        a = n(4),
        s = n(30),
        u = n(1),
        c = function c(t) {
          return /^[aeiou]/.test(t);
        },
        l = function l(t) {
          return c(t) ? "an" : "a";
        },
        f = a.default.tpl('    <div class="o-form-input-group-controls">      <span class="input-fix o-form-control">        <input type="text" class="o-form-text" name="{{key}}" id="{{key}}" value="{{value}}"         placeholder="{{placeholder}}"/>      </span>      <a href="#" class="link-button link-button-icon icon-only">        <span class="icon clear-input-16 "></span>      </a>    </div>    <p class="o-form-input-error o-form-explain">      <span class="icon icon-16 error-16-small"></span> {{errorExplain}}    </p>  ');
      e.a = u.default.extend({
        tagName: "div",
        className: "o-form-input-group",
        events: {
          "click a": function clickA(t) {
            t.preventDefault(), this.remove();
          },
          "keyup input": function keyupInput() {
            this.update();
          }
        },
        isEditMode: function isEditMode() {
          return !this.options.readOnly && (!0 !== this.options.read || !0 === this.model.get("__edit__"));
        },
        initialize: function initialize() {
          this.template = f(r.default.extend(this.options, {
            placeholder: this.getPlaceholderText(),
            errorExplain: this.getErrorExplainText()
          })), this.update = r.default.debounce(this.update, this.options.debounceDelay || s.a.DEBOUNCE_DELAY);
        },
        render: function render() {
          return this.isEditMode() ? this.$el.html(this.template) : (this.$el.text(this.options.value), this.$("a").hide()), this;
        },
        remove: function remove() {
          var t = this,
            e = arguments;
          this.trigger("updateArray", null), this.$el.slideUp(function () {
            u.default.prototype.remove.call(t, e);
          });
        },
        update: function update() {
          var t = this.$("input").val(),
            e = r.default.object([i.a.DATATYPE.number, i.a.DATATYPE.integer], [o.default.parseFloat, this.parseInt]);
          r.default.has(e, this.options.itemType) && (t = e[this.options.itemType](t), r.default.isNumber(t) ? this.clearInvalid() : this.markInvalid()), this.trigger("updateArray", t);
        },
        markInvalid: function markInvalid() {
          this.$el.addClass("o-form-has-errors");
        },
        clearInvalid: function clearInvalid() {
          this.$el.removeClass("o-form-has-errors");
        },
        getPlaceholderText: function getPlaceholderText() {
          var t = ["Enter"];
          return t.push(l(this.options.itemType)), t.push(this.options.itemType.toLowerCase()), t.join(" ");
        },
        getErrorExplainText: function getErrorExplainText() {
          var t = ["Value must be"];
          return t.push(l(this.options.itemType)), t.push(this.options.itemType.toLowerCase()), t.join(" ");
        },
        parseInt: function (t) {
          function e(e) {
            return t.apply(this, arguments);
          }
          return e.toString = function () {
            return t.toString();
          }, e;
        }(function (t) {
          if (/^-?\d+$/.test(t)) {
            var e = parseInt(t, 10);
            return r.default.isNaN(e) ? t : e;
          }
          return t;
        })
      });
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(0),
        i = n(8),
        o = n(4),
        a = n(31),
        s = (n.n(a), n(10)),
        u = o.default.tpl('    <input type="checkbox" name="{{name}}" id="{{inputId}}"/>    <label for="{{inputId}}" data-se-for-name="{{name}}">{{placeholder}}</label>  ');
      e.default = s.a.extend({
        template: u,
        events: {
          "change :checkbox": "update",
          keyup: function keyup(t) {
            i.default.isSpaceBar(t) ? this.$(":checkbox").click() : i.default.isEnter(t) && this.model.trigger("form:save");
          }
        },
        editMode: function editMode() {
          var t = r.default.resultCtx(this.options, "placeholder", this);
          return "" === t ? t = r.default.resultCtx(this.options, "label", this) : !1 === t && (t = ""), this.$el.html(this.template(r.default.extend(r.default.omit(this.options, "placeholder"), {
            placeholder: t
          }))), this.$(":checkbox").prop("checked", this.getModelValue() || !1), this.$("input").customInput(), this.model.trigger("form:resize"), this;
        },
        readMode: function readMode() {
          return this.editMode(), this.$(":checkbox").prop("disabled", !0), this;
        },
        val: function val() {
          return this.$(":checkbox").prop("checked");
        },
        focus: function focus() {
          return this.$(":checkbox").focus();
        }
      });
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(0),
        i = n(4),
        o = n(32),
        a = i.default.tpl('      <span class="password-toggle">        <span class="eyeicon visibility-16 button-show"></span>        <span class="eyeicon visibility-off-16 button-hide"></span>      </span>  ');
      e.default = o.default.extend({
        initialize: function initialize() {
          this.__showPasswordToggle() && (this.events["click .password-toggle .button-show"] = "__showPassword", this.events["click .password-toggle .button-hide"] = "__hidePassword"), this.delegateEvents();
        },
        postRender: function postRender() {
          this.isEditMode() && this.__showPasswordToggle() && (this.$el.append(a), this.$el.find('input[type="password"]').addClass("password-with-toggle")), o.default.prototype.postRender.apply(this, arguments);
        },
        __showPasswordToggle: function __showPasswordToggle() {
          return this.options.params && this.options.params.showPasswordToggle;
        },
        __showPassword: function __showPassword() {
          var t = this;
          o.default.prototype.changeType.apply(this, ["text"]), this.$(".password-toggle .button-show").hide(), this.$(".password-toggle .button-hide").show(), this.passwordToggleTimer = r.default.delay(function () {
            t.__hidePassword();
          }, 3e4);
        },
        __hidePassword: function __hidePassword() {
          o.default.prototype.changeType.apply(this, ["password"]), this.$(".password-toggle .button-show").show(), this.$(".password-toggle .button-hide").hide(), this.passwordToggleTimer && clearTimeout(this.passwordToggleTimer);
        }
      });
    }, function (t, e, n) {
      var r, i;
      r = [n(12)], void 0 !== (i = function (t) {
        function e(e) {
          var n = {},
            r = /^jQuery\d+$/;
          return t.each(e.attributes, function (t, e) {
            e.specified && !r.test(e.name) && (n[e.name] = e.value);
          }), n;
        }
        function n(e, n) {
          var r = this,
            i = t(r);
          if (r.value == i.attr("placeholder") && i.hasClass("placeholder")) if (i.data("placeholder-password")) {
            if (i = i.hide().next().show().attr("id", i.removeAttr("id").data("placeholder-id")), !0 === e) return i[0].value = n;
            i.focus();
          } else r.value = "", i.removeClass("placeholder"), r == document.activeElement && r.select();
        }
        function r() {
          var r,
            i = this,
            o = t(i),
            a = this.id;
          if ("" == i.value) {
            if ("password" == i.type) {
              if (!o.data("placeholder-textinput")) {
                try {
                  r = o.clone().attr({
                    type: "text"
                  });
                } catch (n) {
                  r = t("<input>").attr(t.extend(e(this), {
                    type: "text"
                  }));
                }
                r.removeAttr("name").data({
                  "placeholder-password": !0,
                  "placeholder-id": a
                }).bind("focus.placeholder", n), o.data({
                  "placeholder-textinput": r,
                  "placeholder-id": a
                }).before(r);
              }
              o = o.removeAttr("id").hide().prev().attr("id", a).show();
            }
            o.addClass("placeholder"), o[0].value = o.attr("placeholder");
          } else o.removeClass("placeholder");
        }
        var i,
          o,
          a = ("placeholder" in document.createElement("input")),
          s = ("placeholder" in document.createElement("textarea")),
          u = t.fn,
          c = t.valHooks;
        a && s ? (o = u.placeholder = function () {
          return this;
        }, o.input = o.textarea = !0) : (o = u.placeholder = function () {
          var t = this;
          return t.filter((a ? "textarea" : ":input") + "[placeholder]").not(".placeholder").bind({
            "focus.placeholder": n,
            "blur.placeholder": r
          }).data("placeholder-enabled", !0).trigger("blur.placeholder"), t;
        }, o.input = a, o.textarea = s, i = {
          get: function get(e) {
            var n = t(e);
            return n.data("placeholder-enabled") && n.hasClass("placeholder") ? "" : e.value;
          },
          set: function set(e, i) {
            var o = t(e);
            return o.data("placeholder-enabled") ? ("" == i ? (e.value = i, e != document.activeElement && r.call(e)) : o.hasClass("placeholder") ? n.call(e, !0, i) || (e.value = i) : e.value = i, o) : e.value = i;
          }
        }, a || (c.input = i), s || (c.textarea = i), t(function () {
          t(document).delegate("form", "submit.placeholder", function () {
            var e = t(".placeholder", this).each(n);
            setTimeout(function () {
              e.each(r);
            }, 10);
          });
        }), t(window).bind("beforeunload.placeholder", function () {
          t(".placeholder").each(function () {
            this.value = "";
          });
        }));
      }.apply(e, r)) && (t.exports = i);
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(2),
        i = n(0),
        o = n(8),
        a = n(16),
        s = n(1),
        u = n(31),
        c = (n.n(u), n(10)),
        l = a.default.isABaseView,
        f = s.default.extend({
          template: '      <input type="radio" name="{{name}}" data-se-name="{{realName}}" value="{{value}}" id="{{optionId}}">      <label for="{{optionId}}" data-se-for-name="{{realName}}" class="radio-label">        {{label}}      </label>    ',
          initialize: function initialize(t) {
            var e = void 0;
            e = t.explain, i.default.isFunction(e) && !l(e) && (e = i.default.resultCtx(this.options, "explain", this)), e && (l(e) ? (this.add('<p class="o-form-explain"></p>', ".radio-label"), this.add(e, ".o-form-explain")) : this.add('<p class="o-form-explain">{{explain}}</p>', ".radio-label"));
          }
        });
      e.default = c.a.extend({
        events: {
          "change :radio": "update",
          keyup: function keyup(t) {
            o.default.isSpaceBar(t) ? Object(r.default)(t.target).click() : o.default.isEnter(t) && this.model.trigger("form:save");
          }
        },
        editMode: function editMode() {
          var t = [];
          this.$el.empty(), i.default.each(this.options.options, function (e, n) {
            var r = {
              optionId: i.default.uniqueId("option"),
              name: this.options.inputId,
              realName: this.options.name,
              value: n
            };
            i.default.isObject(e) || (e = {
              label: e
            }), i.default.extend(r, e), t.push(new f(r).render().el);
          }, this), this.$el.append(t);
          var e = this.getModelValue();
          return e && this.$(":radio[value=" + e + "]").prop("checked", !0), this.$("input").customInput(), this.model.trigger("form:resize"), !0 === this.getParam("inline") && this.$("div.custom-radio").addClass("inline"), this;
        },
        readMode: function readMode() {
          return this.editMode(), this.$(":radio").prop("disabled", !0), this;
        },
        val: function val() {
          return this.$(":radio:checked").val();
        },
        focus: function focus() {
          return this.$("label:eq(0)").focus();
        }
      });
    }]);
  }, function (t, e, n) {
    var r = n(5),
      i = n(34),
      o = n(25),
      a = n(26),
      s = n(35),
      u = function u(t, e, n) {
        var c,
          l,
          f,
          p,
          d = t & u.F,
          h = t & u.G,
          m = t & u.S,
          g = t & u.P,
          v = t & u.B,
          y = h ? r : m ? r[e] || (r[e] = {}) : (r[e] || {}).prototype,
          _ = h ? i : i[e] || (i[e] = {}),
          b = _.prototype || (_.prototype = {});
        h && (n = e);
        for (c in n) l = !d && y && void 0 !== y[c], f = (l ? y : n)[c], p = v && l ? s(f, r) : g && "function" == typeof f ? s(Function.call, f) : f, y && a(y, c, f, t & u.U), _[c] != f && o(_, c, p), g && b[c] != f && (b[c] = f);
      };
    r.core = i, u.F = 1, u.G = 2, u.S = 4, u.P = 8, u.B = 16, u.W = 32, u.U = 64, u.R = 128, t.exports = u;
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(4), n(83), n(96)], void 0 !== (i = function (t, e, n, r) {
      var i = t.internal.views.forms.components.Toolbar,
        o = t.internal.views.forms.helpers.FormUtil,
        a = t._,
        s = t.Form.extend({
          layout: "o-form-theme",
          noCancelButton: !0,
          constructor: function constructor(n) {
            t.Form.call(this, n), a.each(a.result(this, "formChildren") || [], function (n) {
              switch (n.type) {
                case e.INPUT:
                  this.addInput(a.extend({
                    label: !1,
                    "label-top": !0
                  }, n.viewOptions));
                  break;
                case e.BUTTON:
                  this.add(t.createButton(a.extend({
                    model: this.model
                  }, n.viewOptions)), n.addOptions), o.applyShowWhen(this.last(), n.viewOptions && n.viewOptions.showWhen);
                  break;
                case e.DIVIDER:
                  this.addDivider(n.viewOptions);
                  break;
                case e.TOOLBAR:
                  this.add(i, {
                    options: n.viewOptions
                  }), o.applyShowWhen(this.last(), n.viewOptions && n.viewOptions.showWhen);
                  break;
                case e.VIEW:
                  this.add(n.viewOptions.View, n.addOptions), o.applyShowWhen(this.last(), n.viewOptions.showWhen);
                  break;
                default:
                  throw new Error("Unrecognized child type: " + n.type);
              }
            }, this);
          }
        });
      return n.extend({
        constructor: function constructor() {
          var t = this.initialize;
          if (this.initialize = function () {}, n.apply(this, arguments), this.Model && this.Form) {
            var e = r.extend(a.extend({
              parse: function parse(t) {
                return this.settings = t.settings, this.appState = t.appState, a.omit(t, ["settings", "appState"]);
              }
            }, a.result(this, "Model")));
            this.model = new e({
              settings: this.settings,
              appState: this.options.appState
            }, {
              parse: !0
            });
            var i = s.extend(a.result(this, "Form", this));
            this.form = new i(this.toJSON()), this.add(this.form);
          }
          this.Footer && this.addFooter(this.Footer), this.addListeners(), t.apply(this, arguments);
        },
        addFooter: function addFooter(t, e) {
          this.footer = new t(a.extend(this.toJSON(), e || {})), this.add(this.footer);
        },
        toJSON: function toJSON() {
          var t = n.prototype.toJSON.apply(this, arguments);
          return a.extend(a.pick(this.options, "appState"), t);
        },
        back: function back() {
          this.footer && this.footer.back && this.footer.back();
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    var r = n(8);
    t.exports = function (t) {
      if (!r(t)) throw TypeError(t + " is not an object!");
      return t;
    };
  }, function (t, e, n) {
    "use strict";

    var r;
    void 0 !== (r = function () {
      function t(t) {
        return function (e, n) {
          return {
            type: t,
            viewOptions: e,
            addOptions: n
          };
        };
      }
      return {
        Input: t("INPUT"),
        Button: t("BUTTON"),
        Divider: t("DIVIDER"),
        Toolbar: t("TOOLBAR"),
        View: t("VIEW"),
        INPUT: "INPUT",
        BUTTON: "BUTTON",
        DIVIDER: "DIVIDER",
        TOOLBAR: "TOOLBAR",
        VIEW: "VIEW"
      };
    }.call(e, n, e, t)) && (t.exports = r);
  }, function (t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (t, e, n) {
    "use strict";

    t.exports = {
      API_RATE_LIMIT: 3e4,
      WIDGET_CONTAINER_ID: "okta-sign-in",
      WIDGET_CONFIG_COLORS_ID: "okta-sign-in-config-colors",
      DIRECTION_BACK: "DIRECTION_BACK",
      RECOVERY_TYPE_PASSWORD: "PASSWORD",
      RECOVERY_TYPE_UNLOCK: "UNLOCK",
      RECOVERY_FACTOR_TYPE_SMS: "SMS",
      RECOVERY_FACTOR_TYPE_EMAIL: "EMAIL",
      RECOVERY_FACTOR_TYPE_CALL: "CALL",
      SUCCESS: "SUCCESS",
      FORGOT_PASSWORD_EMAIL_SENT: "FORGOT_PASSWORD_EMAIL_SENT",
      UNLOCK_ACCOUNT_EMAIL_SENT: "UNLOCK_ACCOUNT_EMAIL_SENT",
      CONFIG_ERROR: "CONFIG_ERROR",
      UNSUPPORTED_BROWSER_ERROR: "UNSUPPORTED_BROWSER_ERROR",
      OAUTH_ERROR: "OAUTH_ERROR",
      AUTH_STOP_POLL_INITIATION_ERROR: "AUTH_STOP_POLL_INITIATION_ERROR",
      U2F_ERROR: "U2F_ERROR",
      WEB_AUTHN_ERROR: "WEB_AUTHN_ERROR",
      WEBAUTHN_ABORT_ERROR: "WEBAUTHN_ABORT_ERROR",
      ALL_OPTIONAL_NONE_ENROLLED: "ALL_OPTIONAL_NONE_ENROLLED",
      ALL_OPTIONAL_SOME_ENROLLED: "ALL_OPTIONAL_SOME_ENROLLED",
      HAS_REQUIRED_NONE_ENROLLED: "HAS_REQUIRED_NONE_ENROLLED",
      HAS_REQUIRED_SOME_REQUIRED_ENROLLED: "HAS_REQUIRED_SOME_REQUIRED_ENROLLED",
      HAS_REQUIRED_ALL_REQUIRED_ENROLLED: "HAS_REQUIRED_ALL_REQUIRED_ENROLLED",
      PRIMARY_AUTH: "PRIMARY_AUTH",
      FORGOT_PASSWORD: "FORGOT_PASSWORD",
      UNLOCK_ACCOUNT: "UNLOCK_ACCOUNT",
      SESSION_SSO: "SESSION_SSO",
      SESSION_STEP_UP: "SESSION_STEP_UP",
      ACTIVATION_EMAIL_SENT: "ACTIVATION_EMAIL_SENT",
      REGISTRATION_COMPLETE: "REGISTRATION_COMPLETE",
      REGISTRATION_FAILED: "REGISTRATION_FAILED",
      IDP_DISCOVERY: "IDP_DISCOVERY"
    };
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == typeof t ? null !== t : "function" == typeof t;
    };
  }, function (t, e) {
    var n = t.exports = {
      version: "2.6.9"
    };
    "number" == typeof __e && (__e = n);
  }, function (t, e, n) {
    var r = n(84)("wks"),
      i = n(61),
      o = n(5).Symbol,
      a = "function" == typeof o;
    (t.exports = function (t) {
      return r[t] || (r[t] = a && o[t] || (a ? o : i)("Symbol." + t));
    }).store = r;
  }, function (t, e, n) {
    var r = n(37),
      i = Math.min;
    t.exports = function (t) {
      return t > 0 ? i(r(t), 9007199254740991) : 0;
    };
  }, function (t, e, n) {
    t.exports = !n(7)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(17), n(0), n(57), n(6), n(496)], void 0 !== (i = function (t, e, n, r, i) {
      function o(t) {
        for (var e = [t], n = t.split("-"); n.pop() && n.length > 0;) e.push(n.join("-"));
        return e;
      }
      var a = {},
        s = e._,
        u = i.default.start,
        c = function c(t, e) {
          var n = document.createElement("input");
          return n.name = t, n.value = decodeURIComponent(e), n.type = "hidden", n;
        },
        l = function l() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
            e = arguments[1],
            n = t.split("#"),
            r = n[1],
            i = (n[0] || "").split("?"),
            o = i[1],
            a = i[0];
          r && (a += "#" + r);
          var s = document.createElement("form");
          if (s.method = e, s.setAttribute("style", "display: none;"), s.action = a, o && o.length) {
            o.split("&").forEach(function (t) {
              var e = t.split("="),
                n = c(e[0], e[1]);
              s.appendChild(n);
            });
          }
          return s;
        };
      return a.hasTokensInHash = function (t) {
        return /((id|access)_token=)/i.test(t);
      }, a.transformErrorXHR = function (t) {
        if (0 === t.status && s.isEmpty(t.responseJSON)) return t.responseJSON = {
          errorSummary: e.loc("error.network.connection", "login")
        }, t;
        if (!t.responseJSON) {
          if (!t.responseText) return t.responseJSON = {
            errorSummary: e.loc("oform.error.unexpected", "login")
          }, t;
          t.responseJSON = t.responseText;
        }
        if (t.responseJSON && t.responseJSON.errorCauses && t.responseJSON.errorCauses.length && (t.responseJSON.errorSummary = t.responseJSON.errorCauses[0].errorSummary), !s.isEmpty(t.responseJSON)) {
          var n = e.loc("errors." + t.responseJSON.errorCode, "login");
          -1 === n.indexOf("L10N_ERROR[") && (t.responseJSON.errorSummary = n, t.responseJSON && t.responseJSON.errorCauses && t.responseJSON.errorCauses.length && delete t.responseJSON.errorCauses);
        }
        return t;
      }, a.toLower = function (t) {
        return s.map(t, function (t) {
          return t.toLowerCase();
        });
      }, a.expandLanguages = function (t) {
        return s.chain(t).map(o).flatten().uniq().value();
      }, a.callAfterTimeout = function (t, e) {
        return setTimeout(t, e);
      }, a.debugMessage = function (t) {
        t.replace(/^(\s)+/gm, "");
      }, a.triggerAfterError = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        !e.statusCode && e.xhr && e.xhr.status && (e.statusCode = e.xhr.status);
        var n = s.isFunction(t.className) ? t.className() : t.className,
          r = s.pick(e, "name", "message", "statusCode", "xhr");
        t.trigger("afterError", {
          controller: n
        }, r);
      }, a.redirect = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window;
        if (!t) return void n.error("Cannot redirect to empty URL: (" + t + ")");
        e.location.href = t;
      }, a.redirectWithFormGet = function (t) {
        a.redirectWithForm(t, "get");
      }, a.redirectWithForm = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "post";
        if (!t) return void n.error("Cannot redirect to empty URL: (" + t + ")");
        var i = document.getElementById(r.WIDGET_CONTAINER_ID);
        if (!i) return void n.error("Cannot find okta-sign-in container append to which a form");
        var o = l(t, e);
        i.appendChild(o), o.submit();
      }, a.createInputExplain = function (t, n, r, i, o) {
        var a = i ? e.loc(t, r, i) : e.loc(t, r);
        return a !== (o ? e.loc(n, r, o) : e.loc(n, r)) && a;
      }, a.isV1StateToken = function (t) {
        return !!(t && s.isString(t) && t.startsWith("00"));
      }, a.introspectToken = function (e, n) {
        var r,
          i = n.baseUrl,
          o = n.stateToken;
        r = this.isV1StateToken(o) ? e.tx.introspect({
          stateToken: n.stateToken
        }) : u({
          domain: i,
          stateHandle: o
        });
        var a = t.defer();
        return t.isPromiseAlike(r) && r.then(function (t) {
          a.resolve(t);
        }).catch(function (t) {
          a.reject(t);
        }), a.promise;
      }, a;
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(58), n(168)], void 0 !== (i = function (t, e) {
      var n = t.internal.views.forms.inputs.TextBox;
      return n.extend({
        postRender: function postRender() {
          if ("number" === this.options.type) {
            this.$("input").attr({
              pattern: "[0-9]*",
              inputmode: "numeric"
            });
          }
          n.prototype.postRender.apply(this, arguments);
        },
        focus: function focus() {
          if (!e.isIE()) return n.prototype.focus.apply(this, arguments);
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    var r = n(3),
      i = n(183),
      o = n(41),
      a = Object.defineProperty;
    e.f = n(12) ? Object.defineProperty : function (t, e, n) {
      if (r(t), e = o(e, !0), r(n), i) try {
        return a(t, e, n);
      } catch (t) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
      return "value" in n && (t[e] = n.value), t;
    };
  }, function (t, e, n) {
    var r = n(42);
    t.exports = function (t) {
      return Object(r(t));
    };
  }, function (t, e, n) {
    /*!
    *
    * Copyright 2009-2012 Kris Kowal under the terms of the MIT
    * license found at http://github.com/kriskowal/q/raw/master/LICENSE
    *
    * With parts by Tyler Close
    * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
    * at http://www.opensource.org/licenses/mit-license.html
    * Forked at ref_send.js version: 2009-05-11
    *
    * With parts by Mark Miller
    * Copyright (C) 2011 Google Inc.
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    * http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    *
    */
    !function (e) {
      "use strict";

      if ("function" == typeof bootstrap) bootstrap("promise", e);else {
        t.exports = e();
      }
    }(function () {
      "use strict";

      function t(t) {
        return function () {
          return z.apply(t, arguments);
        };
      }
      function e(t) {
        return t === Object(t);
      }
      function n(t) {
        return "[object StopIteration]" === tt(t) || t instanceof q;
      }
      function r(t, e) {
        if (B && e.stack && "object" == typeof t && null !== t && t.stack && -1 === t.stack.indexOf(et)) {
          for (var n = [], r = e; r; r = r.source) r.stack && n.unshift(r.stack);
          n.unshift(t.stack);
          var o = n.join("\n" + et + "\n");
          t.stack = i(o);
        }
      }
      function i(t) {
        for (var e = t.split("\n"), n = [], r = 0; r < e.length; ++r) {
          var i = e[r];
          s(i) || o(i) || !i || n.push(i);
        }
        return n.join("\n");
      }
      function o(t) {
        return -1 !== t.indexOf("(module.js:") || -1 !== t.indexOf("(node.js:");
      }
      function a(t) {
        var e = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(t);
        if (e) return [e[1], Number(e[2])];
        var n = /at ([^ ]+):(\d+):(?:\d+)$/.exec(t);
        if (n) return [n[1], Number(n[2])];
        var r = /.*@(.+):(\d+)$/.exec(t);
        return r ? [r[1], Number(r[2])] : void 0;
      }
      function s(t) {
        var e = a(t);
        if (!e) return !1;
        var n = e[0],
          r = e[1];
        return n === V && r >= H && r <= at;
      }
      function u() {
        if (B) try {
          throw new Error();
        } catch (r) {
          var t = r.stack.split("\n"),
            e = t[0].indexOf("@") > 0 ? t[1] : t[2],
            n = a(e);
          if (!n) return;
          return V = n[0], n[1];
        }
      }
      function c(t) {
        return t instanceof d ? t : v(t) ? k(t) : T(t);
      }
      function l() {
        function t(t) {
          e = t, o.source = t, K(n, function (e, n) {
            c.nextTick(function () {
              t.promiseDispatch.apply(t, n);
            });
          }, void 0), n = void 0, r = void 0;
        }
        var e,
          n = [],
          r = [],
          i = Q(l.prototype),
          o = Q(d.prototype);
        if (o.promiseDispatch = function (t, i, o) {
          var a = G(arguments);
          n ? (n.push(a), "when" === i && o[1] && r.push(o[1])) : c.nextTick(function () {
            e.promiseDispatch.apply(e, a);
          });
        }, o.valueOf = function () {
          if (n) return o;
          var t = m(e);
          return g(t) && (e = t), t;
        }, o.inspect = function () {
          return e ? e.inspect() : {
            state: "pending"
          };
        }, c.longStackSupport && B) try {
          throw new Error();
        } catch (t) {
          o.stack = t.stack.substring(t.stack.indexOf("\n") + 1);
        }
        return i.promise = o, i.resolve = function (n) {
          e || t(c(n));
        }, i.fulfill = function (n) {
          e || t(T(n));
        }, i.reject = function (n) {
          e || t(E(n));
        }, i.notify = function (t) {
          e || K(r, function (e, n) {
            c.nextTick(function () {
              n(t);
            });
          }, void 0);
        }, i;
      }
      function f(t) {
        if ("function" != typeof t) throw new TypeError("resolver must be a function.");
        var e = l();
        try {
          t(e.resolve, e.reject, e.notify);
        } catch (t) {
          e.reject(t);
        }
        return e.promise;
      }
      function p(t) {
        return f(function (e, n) {
          for (var r = 0, i = t.length; r < i; r++) c(t[r]).then(e, n);
        });
      }
      function d(t, e, n) {
        void 0 === e && (e = function e(t) {
          return E(new Error("Promise does not support operation: " + t));
        }), void 0 === n && (n = function n() {
          return {
            state: "unknown"
          };
        });
        var r = Q(d.prototype);
        if (r.promiseDispatch = function (n, i, o) {
          var a;
          try {
            a = t[i] ? t[i].apply(r, o) : e.call(r, i, o);
          } catch (t) {
            a = E(t);
          }
          n && n(a);
        }, r.inspect = n, n) {
          var i = n();
          "rejected" === i.state && (r.exception = i.reason), r.valueOf = function () {
            var t = n();
            return "pending" === t.state || "rejected" === t.state ? r : t.value;
          };
        }
        return r;
      }
      function h(t, e, n, r) {
        return c(t).then(e, n, r);
      }
      function m(t) {
        if (g(t)) {
          var e = t.inspect();
          if ("fulfilled" === e.state) return e.value;
        }
        return t;
      }
      function g(t) {
        return t instanceof d;
      }
      function v(t) {
        return e(t) && "function" == typeof t.then;
      }
      function y(t) {
        return g(t) && "pending" === t.inspect().state;
      }
      function _(t) {
        return !g(t) || "fulfilled" === t.inspect().state;
      }
      function b(t) {
        return g(t) && "rejected" === t.inspect().state;
      }
      function w() {
        nt.length = 0, rt.length = 0, ot || (ot = !0);
      }
      function S(t, e) {
        ot && ("object" == typeof process && "function" == typeof process.emit && c.nextTick.runAfter(function () {
          -1 !== Y(rt, t) && (process.emit("unhandledRejection", e, t), it.push(t));
        }), rt.push(t), e && void 0 !== e.stack ? nt.push(e.stack) : nt.push("(no stack) " + e));
      }
      function x(t) {
        if (ot) {
          var e = Y(rt, t);
          -1 !== e && ("object" == typeof process && "function" == typeof process.emit && c.nextTick.runAfter(function () {
            var n = Y(it, t);
            -1 !== n && (process.emit("rejectionHandled", nt[e], t), it.splice(n, 1));
          }), rt.splice(e, 1), nt.splice(e, 1));
        }
      }
      function E(t) {
        var e = d({
          when: function when(e) {
            return e && x(this), e ? e(t) : this;
          }
        }, function () {
          return this;
        }, function () {
          return {
            state: "rejected",
            reason: t
          };
        });
        return S(e, t), e;
      }
      function T(t) {
        return d({
          when: function when() {
            return t;
          },
          get: function get(e) {
            return t[e];
          },
          set: function set(e, n) {
            t[e] = n;
          },
          delete: function _delete(e) {
            delete t[e];
          },
          post: function post(e, n) {
            return null === e || void 0 === e ? t.apply(void 0, n) : t[e].apply(t, n);
          },
          apply: function apply(e, n) {
            return t.apply(e, n);
          },
          keys: function keys() {
            return Z(t);
          }
        }, void 0, function () {
          return {
            state: "fulfilled",
            value: t
          };
        });
      }
      function k(t) {
        var e = l();
        return c.nextTick(function () {
          try {
            t.then(e.resolve, e.reject, e.notify);
          } catch (t) {
            e.reject(t);
          }
        }), e.promise;
      }
      function A(t) {
        return d({
          isDef: function isDef() {}
        }, function (e, n) {
          return N(t, e, n);
        }, function () {
          return c(t).inspect();
        });
      }
      function O(t, e, n) {
        return c(t).spread(e, n);
      }
      function C(t) {
        return function () {
          function e(t, e) {
            var a;
            if ("undefined" == typeof StopIteration) {
              try {
                a = r[t](e);
              } catch (t) {
                return E(t);
              }
              return a.done ? c(a.value) : h(a.value, i, o);
            }
            try {
              a = r[t](e);
            } catch (t) {
              return n(t) ? c(t.value) : E(t);
            }
            return h(a, i, o);
          }
          var r = t.apply(this, arguments),
            i = e.bind(e, "next"),
            o = e.bind(e, "throw");
          return i();
        };
      }
      function I(t) {
        c.done(c.async(t)());
      }
      function R(t) {
        throw new q(t);
      }
      function P(t) {
        return function () {
          return O([this, M(arguments)], function (e, n) {
            return t.apply(e, n);
          });
        };
      }
      function N(t, e, n) {
        return c(t).dispatch(e, n);
      }
      function M(t) {
        return h(t, function (t) {
          var e = 0,
            n = l();
          return K(t, function (r, i, o) {
            var a;
            g(i) && "fulfilled" === (a = i.inspect()).state ? t[o] = a.value : (++e, h(i, function (r) {
              t[o] = r, 0 == --e && n.resolve(t);
            }, n.reject, function (t) {
              n.notify({
                index: o,
                value: t
              });
            }));
          }, void 0), 0 === e && n.resolve(t), n.promise;
        });
      }
      function L(t) {
        if (0 === t.length) return c.resolve();
        var e = c.defer(),
          n = 0;
        return K(t, function (r, i, o) {
          function a(t) {
            e.resolve(t);
          }
          function s() {
            0 === --n && e.reject(new Error("Can't get fulfillment value from any promise, all promises were rejected."));
          }
          function u(t) {
            e.notify({
              index: o,
              value: t
            });
          }
          var c = t[o];
          n++, h(c, a, s, u);
        }, void 0), e.promise;
      }
      function F(t) {
        return h(t, function (t) {
          return t = J(t, c), h(M(J(t, function (t) {
            return h(t, W, W);
          })), function () {
            return t;
          });
        });
      }
      function D(t) {
        return c(t).allSettled();
      }
      function j(t, e) {
        return c(t).then(void 0, void 0, e);
      }
      function U(t, e) {
        return c(t).nodeify(e);
      }
      var B = !1;
      try {
        throw new Error();
      } catch (t) {
        B = !!t.stack;
      }
      var V,
        q,
        H = u(),
        W = function W() {},
        $ = function () {
          function t() {
            for (var t, r; n.next;) n = n.next, t = n.task, n.task = void 0, r = n.domain, r && (n.domain = void 0, r.enter()), e(t, r);
            for (; s.length;) t = s.pop(), e(t);
            i = !1;
          }
          function e(e, n) {
            try {
              e();
            } catch (e) {
              if (a) throw n && n.exit(), setTimeout(t, 0), n && n.enter(), e;
              setTimeout(function () {
                throw e;
              }, 0);
            }
            n && n.exit();
          }
          var n = {
              task: void 0,
              next: null
            },
            r = n,
            i = !1,
            o = void 0,
            a = !1,
            s = [];
          if ($ = function $(t) {
            r = r.next = {
              task: t,
              domain: a && process.domain,
              next: null
            }, i || (i = !0, o());
          }, "object" == typeof process && "[object process]" === process.toString() && process.nextTick) a = !0, o = function o() {
            process.nextTick(t);
          };else if ("function" == typeof setImmediate) o = "undefined" != typeof window ? setImmediate.bind(window, t) : function () {
            setImmediate(t);
          };else if ("undefined" != typeof MessageChannel) {
            var u = new MessageChannel();
            u.port1.onmessage = function () {
              o = c, u.port1.onmessage = t, t();
            };
            var c = function c() {
              u.port2.postMessage(0);
            };
            o = function o() {
              setTimeout(t, 0), c();
            };
          } else o = function o() {
            setTimeout(t, 0);
          };
          return $.runAfter = function (t) {
            s.push(t), i || (i = !0, o());
          }, $;
        }(),
        z = Function.call,
        G = t(Array.prototype.slice),
        K = t(Array.prototype.reduce || function (t, e) {
          var n = 0,
            r = this.length;
          if (1 === arguments.length) for (;;) {
            if (n in this) {
              e = this[n++];
              break;
            }
            if (++n >= r) throw new TypeError();
          }
          for (; n < r; n++) n in this && (e = t(e, this[n], n));
          return e;
        }),
        Y = t(Array.prototype.indexOf || function (t) {
          for (var e = 0; e < this.length; e++) if (this[e] === t) return e;
          return -1;
        }),
        J = t(Array.prototype.map || function (t, e) {
          var n = this,
            r = [];
          return K(n, function (i, o, a) {
            r.push(t.call(e, o, a, n));
          }, void 0), r;
        }),
        Q = Object.create || function (t) {
          function e() {}
          return e.prototype = t, new e();
        },
        X = t(Object.prototype.hasOwnProperty),
        Z = Object.keys || function (t) {
          var e = [];
          for (var n in t) X(t, n) && e.push(n);
          return e;
        },
        tt = t(Object.prototype.toString);
      q = "undefined" != typeof ReturnValue ? ReturnValue : function (t) {
        this.value = t;
      };
      var et = "From previous event:";
      c.resolve = c, c.nextTick = $, c.longStackSupport = !1, "object" == typeof process && process && process.env && process.env.Q_DEBUG && (c.longStackSupport = !0), c.defer = l, l.prototype.makeNodeResolver = function () {
        var t = this;
        return function (e, n) {
          e ? t.reject(e) : arguments.length > 2 ? t.resolve(G(arguments, 1)) : t.resolve(n);
        };
      }, c.Promise = f, c.promise = f, f.race = p, f.all = M, f.reject = E, f.resolve = c, c.passByCopy = function (t) {
        return t;
      }, d.prototype.passByCopy = function () {
        return this;
      }, c.join = function (t, e) {
        return c(t).join(e);
      }, d.prototype.join = function (t) {
        return c([this, t]).spread(function (t, e) {
          if (t === e) return t;
          throw new Error("Can't join: not the same: " + t + " " + e);
        });
      }, c.race = p, d.prototype.race = function () {
        return this.then(c.race);
      }, c.makePromise = d, d.prototype.toString = function () {
        return "[object Promise]";
      }, d.prototype.then = function (t, e, n) {
        function i(e) {
          try {
            return "function" == typeof t ? t(e) : e;
          } catch (t) {
            return E(t);
          }
        }
        function o(t) {
          if ("function" == typeof e) {
            r(t, s);
            try {
              return e(t);
            } catch (t) {
              return E(t);
            }
          }
          return E(t);
        }
        function a(t) {
          return "function" == typeof n ? n(t) : t;
        }
        var s = this,
          u = l(),
          f = !1;
        return c.nextTick(function () {
          s.promiseDispatch(function (t) {
            f || (f = !0, u.resolve(i(t)));
          }, "when", [function (t) {
            f || (f = !0, u.resolve(o(t)));
          }]);
        }), s.promiseDispatch(void 0, "when", [void 0, function (t) {
          var e,
            n = !1;
          try {
            e = a(t);
          } catch (t) {
            if (n = !0, !c.onerror) throw t;
            c.onerror(t);
          }
          n || u.notify(e);
        }]), u.promise;
      }, c.tap = function (t, e) {
        return c(t).tap(e);
      }, d.prototype.tap = function (t) {
        return t = c(t), this.then(function (e) {
          return t.fcall(e).thenResolve(e);
        });
      }, c.when = h, d.prototype.thenResolve = function (t) {
        return this.then(function () {
          return t;
        });
      }, c.thenResolve = function (t, e) {
        return c(t).thenResolve(e);
      }, d.prototype.thenReject = function (t) {
        return this.then(function () {
          throw t;
        });
      }, c.thenReject = function (t, e) {
        return c(t).thenReject(e);
      }, c.nearer = m, c.isPromise = g, c.isPromiseAlike = v, c.isPending = y, d.prototype.isPending = function () {
        return "pending" === this.inspect().state;
      }, c.isFulfilled = _, d.prototype.isFulfilled = function () {
        return "fulfilled" === this.inspect().state;
      }, c.isRejected = b, d.prototype.isRejected = function () {
        return "rejected" === this.inspect().state;
      };
      var nt = [],
        rt = [],
        it = [],
        ot = !0;
      c.resetUnhandledRejections = w, c.getUnhandledReasons = function () {
        return nt.slice();
      }, c.stopUnhandledRejectionTracking = function () {
        w(), ot = !1;
      }, w(), c.reject = E, c.fulfill = T, c.master = A, c.spread = O, d.prototype.spread = function (t, e) {
        return this.all().then(function (e) {
          return t.apply(void 0, e);
        }, e);
      }, c.async = C, c.spawn = I, c.return = R, c.promised = P, c.dispatch = N, d.prototype.dispatch = function (t, e) {
        var n = this,
          r = l();
        return c.nextTick(function () {
          n.promiseDispatch(r.resolve, t, e);
        }), r.promise;
      }, c.get = function (t, e) {
        return c(t).dispatch("get", [e]);
      }, d.prototype.get = function (t) {
        return this.dispatch("get", [t]);
      }, c.set = function (t, e, n) {
        return c(t).dispatch("set", [e, n]);
      }, d.prototype.set = function (t, e) {
        return this.dispatch("set", [t, e]);
      }, c.del = c.delete = function (t, e) {
        return c(t).dispatch("delete", [e]);
      }, d.prototype.del = d.prototype.delete = function (t) {
        return this.dispatch("delete", [t]);
      }, c.mapply = c.post = function (t, e, n) {
        return c(t).dispatch("post", [e, n]);
      }, d.prototype.mapply = d.prototype.post = function (t, e) {
        return this.dispatch("post", [t, e]);
      }, c.send = c.mcall = c.invoke = function (t, e) {
        return c(t).dispatch("post", [e, G(arguments, 2)]);
      }, d.prototype.send = d.prototype.mcall = d.prototype.invoke = function (t) {
        return this.dispatch("post", [t, G(arguments, 1)]);
      }, c.fapply = function (t, e) {
        return c(t).dispatch("apply", [void 0, e]);
      }, d.prototype.fapply = function (t) {
        return this.dispatch("apply", [void 0, t]);
      }, c.try = c.fcall = function (t) {
        return c(t).dispatch("apply", [void 0, G(arguments, 1)]);
      }, d.prototype.fcall = function () {
        return this.dispatch("apply", [void 0, G(arguments)]);
      }, c.fbind = function (t) {
        var e = c(t),
          n = G(arguments, 1);
        return function () {
          return e.dispatch("apply", [this, n.concat(G(arguments))]);
        };
      }, d.prototype.fbind = function () {
        var t = this,
          e = G(arguments);
        return function () {
          return t.dispatch("apply", [this, e.concat(G(arguments))]);
        };
      }, c.keys = function (t) {
        return c(t).dispatch("keys", []);
      }, d.prototype.keys = function () {
        return this.dispatch("keys", []);
      }, c.all = M, d.prototype.all = function () {
        return M(this);
      }, c.any = L, d.prototype.any = function () {
        return L(this);
      }, c.allResolved = function (t, e, n) {
        return function () {
          return "undefined" != typeof console && console.warn, t.apply(t, arguments);
        };
      }(F, "allResolved", "allSettled"), d.prototype.allResolved = function () {
        return F(this);
      }, c.allSettled = D, d.prototype.allSettled = function () {
        return this.then(function (t) {
          return M(J(t, function (t) {
            function e() {
              return t.inspect();
            }
            return t = c(t), t.then(e, e);
          }));
        });
      }, c.fail = c.catch = function (t, e) {
        return c(t).then(void 0, e);
      }, d.prototype.fail = d.prototype.catch = function (t) {
        return this.then(void 0, t);
      }, c.progress = j, d.prototype.progress = function (t) {
        return this.then(void 0, void 0, t);
      }, c.fin = c.finally = function (t, e) {
        return c(t).finally(e);
      }, d.prototype.fin = d.prototype.finally = function (t) {
        return t = c(t), this.then(function (e) {
          return t.fcall().then(function () {
            return e;
          });
        }, function (e) {
          return t.fcall().then(function () {
            throw e;
          });
        });
      }, c.done = function (t, e, n, r) {
        return c(t).done(e, n, r);
      }, d.prototype.done = function (t, e, n) {
        var i = function i(t) {
            c.nextTick(function () {
              if (r(t, o), !c.onerror) throw t;
              c.onerror(t);
            });
          },
          o = t || e || n ? this.then(t, e, n) : this;
        "object" == typeof process && process && process.domain && (i = process.domain.bind(i)), o.then(void 0, i);
      }, c.timeout = function (t, e, n) {
        return c(t).timeout(e, n);
      }, d.prototype.timeout = function (t, e) {
        var n = l(),
          r = setTimeout(function () {
            e && "string" != typeof e || (e = new Error(e || "Timed out after " + t + " ms"), e.code = "ETIMEDOUT"), n.reject(e);
          }, t);
        return this.then(function (t) {
          clearTimeout(r), n.resolve(t);
        }, function (t) {
          clearTimeout(r), n.reject(t);
        }, n.notify), n.promise;
      }, c.delay = function (t, e) {
        return void 0 === e && (e = t, t = void 0), c(t).delay(e);
      }, d.prototype.delay = function (t) {
        return this.then(function (e) {
          var n = l();
          return setTimeout(function () {
            n.resolve(e);
          }, t), n.promise;
        });
      }, c.nfapply = function (t, e) {
        return c(t).nfapply(e);
      }, d.prototype.nfapply = function (t) {
        var e = l(),
          n = G(t);
        return n.push(e.makeNodeResolver()), this.fapply(n).fail(e.reject), e.promise;
      }, c.nfcall = function (t) {
        var e = G(arguments, 1);
        return c(t).nfapply(e);
      }, d.prototype.nfcall = function () {
        var t = G(arguments),
          e = l();
        return t.push(e.makeNodeResolver()), this.fapply(t).fail(e.reject), e.promise;
      }, c.nfbind = c.denodeify = function (t) {
        var e = G(arguments, 1);
        return function () {
          var n = e.concat(G(arguments)),
            r = l();
          return n.push(r.makeNodeResolver()), c(t).fapply(n).fail(r.reject), r.promise;
        };
      }, d.prototype.nfbind = d.prototype.denodeify = function () {
        var t = G(arguments);
        return t.unshift(this), c.denodeify.apply(void 0, t);
      }, c.nbind = function (t, e) {
        var n = G(arguments, 2);
        return function () {
          function r() {
            return t.apply(e, arguments);
          }
          var i = n.concat(G(arguments)),
            o = l();
          return i.push(o.makeNodeResolver()), c(r).fapply(i).fail(o.reject), o.promise;
        };
      }, d.prototype.nbind = function () {
        var t = G(arguments, 0);
        return t.unshift(this), c.nbind.apply(void 0, t);
      }, c.nmapply = c.npost = function (t, e, n) {
        return c(t).npost(e, n);
      }, d.prototype.nmapply = d.prototype.npost = function (t, e) {
        var n = G(e || []),
          r = l();
        return n.push(r.makeNodeResolver()), this.dispatch("post", [t, n]).fail(r.reject), r.promise;
      }, c.nsend = c.nmcall = c.ninvoke = function (t, e) {
        var n = G(arguments, 2),
          r = l();
        return n.push(r.makeNodeResolver()), c(t).dispatch("post", [e, n]).fail(r.reject), r.promise;
      }, d.prototype.nsend = d.prototype.nmcall = d.prototype.ninvoke = function (t) {
        var e = G(arguments, 1),
          n = l();
        return e.push(n.makeNodeResolver()), this.dispatch("post", [t, e]).fail(n.reject), n.promise;
      }, c.nodeify = U, d.prototype.nodeify = function (t) {
        if (!t) return this;
        this.then(function (e) {
          c.nextTick(function () {
            t(null, e);
          });
        }, function (e) {
          c.nextTick(function () {
            t(e);
          });
        });
      }, c.noConflict = function () {
        throw new Error("Q.noConflict only works when Q is used as a global");
      };
      var at = u();
      return c;
    });
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(551)], void 0 !== (i = function (t, e) {
      var n = t._,
        r = {},
        i = {
          OKTA_VERIFY: {
            label: "factor.totpSoft.oktaVerify",
            description: "factor.totpSoft.description",
            iconClassName: "mfa-okta-verify",
            sortOrder: 1
          },
          OKTA_VERIFY_PUSH: {
            label: "factor.oktaVerifyPush",
            description: "factor.push.description",
            iconClassName: "mfa-okta-verify",
            sortOrder: 1
          },
          U2F: {
            label: "factor.u2f",
            description: function description(t) {
              return t ? "factor.u2f.description.specific" : "factor.u2f.description.generic";
            },
            iconClassName: "mfa-u2f",
            sortOrder: 2
          },
          WEBAUTHN: {
            label: "factor.webauthn.biometric",
            description: "factor.webauthn.biometric.description",
            iconClassName: "mfa-webauthn",
            sortOrder: 2
          },
          WINDOWS_HELLO: {
            label: "factor.windowsHello",
            description: function description(t) {
              return t ? "factor.windowsHello.signin.description.specific" : "factor.windowsHello.signin.description.generic";
            },
            iconClassName: "mfa-windows-hello",
            sortOrder: 3
          },
          YUBIKEY: {
            label: "factor.totpHard.yubikey",
            description: "factor.totpHard.yubikey.description",
            iconClassName: "mfa-yubikey",
            sortOrder: 4
          },
          GOOGLE_AUTH: {
            label: "factor.totpSoft.googleAuthenticator",
            description: "factor.totpSoft.description",
            iconClassName: "mfa-google-auth",
            sortOrder: 5
          },
          CUSTOM_HOTP: {
            label: "",
            description: "factor.hotp.description",
            iconClassName: "mfa-hotp",
            sortOrder: 6
          },
          SMS: {
            label: "factor.sms",
            description: "factor.sms.description",
            iconClassName: "mfa-okta-sms",
            sortOrder: 7
          },
          CALL: {
            label: "factor.call",
            description: "factor.call.description",
            iconClassName: "mfa-okta-call",
            sortOrder: 8
          },
          EMAIL: {
            label: "factor.email",
            description: "factor.email.description",
            iconClassName: "mfa-okta-email",
            sortOrder: 9
          },
          QUESTION: {
            label: "factor.securityQuestion",
            description: "factor.securityQuestion.description",
            iconClassName: "mfa-okta-security-question",
            sortOrder: 10
          },
          DUO: {
            label: "factor.duo",
            description: "factor.duo.description",
            iconClassName: "mfa-duo",
            sortOrder: 11
          },
          SYMANTEC_VIP: {
            label: "factor.totpHard.symantecVip",
            description: "factor.totpHard.description",
            iconClassName: "mfa-symantec",
            sortOrder: 12
          },
          RSA_SECURID: {
            label: "factor.totpHard.rsaSecurId",
            description: "factor.totpHard.description",
            iconClassName: "mfa-rsa",
            sortOrder: 13
          },
          ON_PREM: {
            label: "",
            description: "factor.totpHard.description",
            iconClassName: "mfa-onprem",
            sortOrder: 14
          },
          PASSWORD: {
            label: "factor.password",
            description: "",
            iconClassName: "mfa-okta-password",
            sortOrder: 15
          },
          CUSTOM_CLAIMS: {
            label: "",
            description: "factor.customFactor.description",
            iconClassName: "mfa-custom-factor",
            sortOrder: 16
          },
          GENERIC_SAML: {
            label: "",
            description: function description(t) {
              return t ? "factor.customFactor.description.specific" : "factor.customFactor.description.generic";
            },
            iconClassName: "mfa-custom-factor",
            sortOrder: 17
          },
          GENERIC_OIDC: {
            label: "",
            description: function description(t) {
              return t ? "factor.customFactor.description.specific" : "factor.customFactor.description.generic";
            },
            iconClassName: "mfa-custom-factor",
            sortOrder: 18
          }
        };
      return r.getFactorName = function (t, e) {
        return "OKTA" === t && "token:software:totp" === e ? "OKTA_VERIFY" : "OKTA" === t && "push" === e ? "OKTA_VERIFY_PUSH" : "GOOGLE" === t ? "GOOGLE_AUTH" : "SYMANTEC" === t && "token" === e ? "SYMANTEC_VIP" : "RSA" === t && "token" === e ? "RSA_SECURID" : "DEL_OATH" === t && "token" === e ? "ON_PREM" : "DUO" === t && "web" === e ? "DUO" : "YUBICO" === t && "token:hardware" === e ? "YUBIKEY" : "OKTA" === t && "sms" === e ? "SMS" : "OKTA" === t && "call" === e ? "CALL" : "OKTA" === t && "question" === e ? "QUESTION" : "OKTA" === t && "email" === e ? "EMAIL" : "OKTA" === t && "password" === e ? "PASSWORD" : "GENERIC_SAML" === t && "assertion:saml2" === e ? "GENERIC_SAML" : "GENERIC_OIDC" === t && "assertion:oidc" === e ? "GENERIC_OIDC" : r.getFactorNameForFactorType.call(this, e);
      }, r.getFactorNameForFactorType = function (t) {
        return "u2f" === t ? "U2F" : "token:software:totp" === t ? "OKTA_VERIFY" : "webauthn" === t ? this.settings.get("features.webauthn") ? "WEBAUTHN" : "WINDOWS_HELLO" : "token:hotp" === t ? "CUSTOM_HOTP" : "claims_provider" === t ? "CUSTOM_CLAIMS" : void 0;
      }, r.isOktaVerify = function (t, e) {
        return "OKTA" === t && ("token:software:totp" === e || "push" === e);
      }, r.getFactorLabel = function (e, n) {
        var o = i[r.getFactorName.apply(this, [e, n])].label;
        return t.loc(o, "login");
      }, r.getFactorDescription = function (e, o) {
        var a = i[r.getFactorName.apply(this, [e, o])].description;
        if (n.isFunction(a)) {
          var s = this.settings.get("brandName"),
            u = a(s);
          return s ? t.loc(u, "login", [s]) : t.loc(u, "login");
        }
        return t.loc(a, "login");
      }, r.getFactorIconClassName = function (t, e) {
        return i[r.getFactorName.apply(this, [t, e])].iconClassName;
      }, r.getFactorSortOrder = function (t, e) {
        return i[r.getFactorName.apply(this, [t, e])].sortOrder;
      }, r.getRememberDeviceValue = function (t) {
        return t && t.get("rememberDeviceByDefault");
      }, r.getSecurityQuestionLabel = function (e) {
        var n = t.loc("security." + e.question);
        return n.indexOf("L10N_ERROR") < 0 ? n : e.questionText;
      }, r.getPasswordComplexityDescription = function (r) {
        var i = [];
        if (r.complexity) {
          var o = {
              minLength: {
                i18n: "password.complexity.length",
                args: !0
              },
              minLowerCase: {
                i18n: "password.complexity.lowercase"
              },
              minUpperCase: {
                i18n: "password.complexity.uppercase"
              },
              minNumber: {
                i18n: "password.complexity.number"
              },
              minSymbol: {
                i18n: "password.complexity.symbol"
              },
              excludeUsername: {
                i18n: "password.complexity.no_username"
              },
              excludeFirstName: {
                i18n: "password.complexity.no_first_name"
              },
              excludeLastName: {
                i18n: "password.complexity.no_last_name"
              }
            },
            a = function (t) {
              var e = t.excludeAttributes;
              return t.excludeFirstName = n.contains(e, "firstName"), t.excludeLastName = n.contains(e, "lastName"), n.omit(t, "excludeAttributes");
            }(r.complexity),
            s = n.map(a, function (e, n) {
              if (!(e <= 0)) {
                var r = o[n];
                return r.args ? t.loc(r.i18n, "login", [e]) : t.loc(r.i18n, "login");
              }
            });
          s = n.compact(s), s.length && (s = n.reduce(s, function (e, n) {
            return e ? e + t.loc("password.complexity.list.element", "login", [n]) : n;
          }), i.push(t.loc("password.complexity.requirements", "login", [s])));
        }
        if (r.age && r.age.historyCount > 0 && i.push(t.loc("password.complexity.history", "login", [r.age.historyCount])), r.age && r.age.minAgeMinutes > 0) {
          var u = e.getTimeInHighestRelevantUnit(r.age.minAgeMinutes, "MINUTE"),
            c = function (e) {
              var n;
              switch (e.unit) {
                case "DAY":
                  n = "password.complexity.minAgeDays";
                  break;
                case "HOUR":
                  n = "password.complexity.minAgeHours";
                  break;
                case "MINUTE":
                  n = "password.complexity.minAgeMinutes";
              }
              return t.loc(n, "login", [e.time]);
            }(u);
          i.push(c);
        }
        return i.join(" ");
      }, r.getCardinalityText = function (e, n, r) {
        if (r) {
          if (e) return 1 === r.enrolled ? "" : t.loc("enroll.choices.cardinality.setup", "login", [r.enrolled]);
          if (n && r.maximum > 1) return t.loc("enroll.choices.cardinality.setup.remaining", "login", [r.enrolled, r.minimum]);
        }
        return "";
      }, r.findFactorInFactorsArray = function (t, e, n) {
        var r = t.findWhere({
          provider: e,
          factorType: n
        });
        return void 0 === r && (r = t.findWhere({
          factorType: n
        })), r;
      }, r;
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(6)], void 0 !== (i = function (t, e) {
      return t.View.extend({
        template: '      <a href="#" class="link help js-back" data-se="back-link">        {{i18n code="mfa.backToFactors" bundle="login"}}      </a>    ',
        className: "auth-footer",
        events: {
          "click .js-back": function clickJsBack(t) {
            t.preventDefault(), this.options.appState.trigger("backToFactors"), this.back();
          }
        },
        back: function back() {
          this.state.set("navigateDir", e.DIRECTION_BACK), this.options.appState.get("prevLink") ? this.model.doTransaction(function (t) {
            return t.prev();
          }) : this.options.appState.trigger("navigate", "signin/enroll");
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    };
  }, function (t, e, n) {
    var r = n(22),
      i = n(9),
      o = n(78),
      a = n(71),
      s = n(72),
      u = function u(t, e, n) {
        var c,
          l,
          f,
          p = t & u.F,
          d = t & u.G,
          h = t & u.S,
          m = t & u.P,
          g = t & u.B,
          v = t & u.W,
          y = d ? i : i[e] || (i[e] = {}),
          _ = y.prototype,
          b = d ? r : h ? r[e] : (r[e] || {}).prototype;
        d && (n = e);
        for (c in n) (l = !p && b && void 0 !== b[c]) && s(y, c) || (f = l ? b[c] : n[c], y[c] = d && "function" != typeof b[c] ? n[c] : g && l ? o(f, r) : v && b[c] == f ? function (t) {
          var e = function e(_e, n, r) {
            if (this instanceof t) {
              switch (arguments.length) {
                case 0:
                  return new t();
                case 1:
                  return new t(_e);
                case 2:
                  return new t(_e, n);
              }
              return new t(_e, n, r);
            }
            return t.apply(this, arguments);
          };
          return e.prototype = t.prototype, e;
        }(f) : m && "function" == typeof f ? o(Function.call, f) : f, m && ((y.virtual || (y.virtual = {}))[c] = f, t & u.R && _ && !_[c] && a(_, c, f)));
      };
    u.F = 1, u.G = 2, u.S = 4, u.P = 8, u.B = 16, u.W = 32, u.U = 64, u.R = 128, t.exports = u;
  }, function (t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (t, e, n) {
    var r = n(161)("wks"),
      i = n(116),
      o = n(22).Symbol,
      a = "function" == typeof o;
    (t.exports = function (t) {
      return r[t] || (r[t] = a && o[t] || (a ? o : i)("Symbol." + t));
    }).store = r;
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(153), n(13), n(6), n(58), n(33), n(587)], void 0 !== (i = function (t, e, n, r, i, o, a) {
      var s = {},
        u = t.tpl("signin/verify/{{provider}}/{{factorType}}"),
        c = t.tpl("signin/verify/{{provider}}/{{factorType}}/{{factorIndex}}"),
        l = t.tpl("signin/verify/{{factorType}}"),
        f = t.tpl("signin/enroll/{{provider}}/{{factorType}}"),
        p = t.tpl("signin/enroll-activate/{{provider}}/{{factorType}}{{#if step}}/{{step}}{{/if}}"),
        d = t.tpl("signin/recovery/{{recoveryToken}}"),
        h = t.tpl("signin/refresh-auth-state{{#if token}}/{{token}}{{/if}}"),
        m = t.tpl("{{baseUrl}}/login/sessionCookieRedirect?checkAccountSetupComplete=true&token={{{token}}}&redirectUrl={{{redirectUrl}}}");
      return s.isHostBackgroundChromeTab = function () {
        return !!(navigator.userAgent.match(/Android/) && navigator.userAgent.match(/Chrome/) && document.hidden);
      }, s.isDocumentVisible = function () {
        return "visible" === document.visibilityState;
      }, s.createVerifyUrl = function (t, e, n) {
        return t && n ? c({
          provider: encodeURIComponent(t.toLowerCase()),
          factorType: encodeURIComponent(e),
          factorIndex: encodeURIComponent(n)
        }) : t ? u({
          provider: encodeURIComponent(t.toLowerCase()),
          factorType: encodeURIComponent(e)
        }) : l({
          factorType: encodeURIComponent(e)
        });
      }, s.createEnrollFactorUrl = function (t, e) {
        return f({
          provider: encodeURIComponent(t.toLowerCase()),
          factorType: encodeURIComponent(e)
        });
      }, s.createActivateFactorUrl = function (t, e, n) {
        return p({
          provider: encodeURIComponent(t.toLowerCase()),
          factorType: encodeURIComponent(e),
          step: !!n && encodeURIComponent(n)
        });
      }, s.createRecoveryUrl = function (t) {
        return d({
          recoveryToken: encodeURIComponent(t)
        });
      }, s.createRefreshUrl = function (t) {
        var e = t ? encodeURIComponent(t) : null;
        return h({
          token: e
        });
      }, s.routeAfterAuthStatusChangeError = function (e, s) {
        if (s) return s.xhr && i.corsIsNotEnabled(s.xhr) ? void e.settings.callGlobalError(new o.UnsupportedBrowserError(t.loc("error.enabled.cors"))) : s.errorCode === a.INVALID_TOKEN_EXCEPTION ? (e.appState.set("flashError", s), e.controller.state.set("navigateDir", r.DIRECTION_BACK), void e.navigate("", {
          trigger: !0
        })) : void n.triggerAfterError(e.controller, s);
      }, s.routeAfterAuthStatusChange = function (t, e) {
        if (!e || !e.status) return void t.appState.clearLastAuthResponse();
        t.appState.setAuthResponse(e), t.controller && t.controller.trapAuthResponse(e) || s.handleResponseStatus(t, e);
      }, s.handleResponseStatus = function (n, i) {
        switch (i.status) {
          case "SUCCESS":
            if (i.recoveryType === r.RECOVERY_TYPE_UNLOCK) return void n.navigate("signin/account-unlocked", {
              trigger: !0
            });
            if (n.settings.get("oauth2Enabled")) return void e.getTokens(n.settings, {
              sessionToken: i.sessionToken
            }, n.controller);
            var o = {
              user: i._embedded.user,
              type: i.type || r.SESSION_SSO
            };
            i.relayState && (o.relayState = i.relayState);
            var a = n.settings.get("redirectUtilFn"),
              u = i._links && (i._links.original && i._links.original.href || i._links.next && i._links.next.href);
            if (i.type === r.SESSION_STEP_UP) {
              var c = i._links && i._links.next && i._links.next.href;
              o.stepUp = {
                url: c,
                finish: function finish() {
                  a(c);
                }
              };
            } else u ? o.next = function () {
              a(u);
            } : (o.type = r.SESSION_SSO, o.session = {
              token: i.sessionToken,
              setCookieAndRedirect: function setCookieAndRedirect(t) {
                a(m({
                  baseUrl: n.settings.get("baseUrl"),
                  token: encodeURIComponent(i.sessionToken),
                  redirectUrl: encodeURIComponent(t)
                }));
              }
            });
            return void (n.settings.get("features.restrictRedirectToForeground") && s.isHostBackgroundChromeTab() ? document.addEventListener("visibilitychange", function t() {
              s.isDocumentVisible() && (document.removeEventListener("visibilitychange", t), n.settings.callGlobalSuccess(r.SUCCESS, o));
            }) : n.settings.callGlobalSuccess(r.SUCCESS, o));
          case "CONSENT_REQUIRED":
            return void (n.settings.get("features.consent") && n.navigate("signin/consent", {
              trigger: !0
            }));
          case "FACTOR_REQUIRED":
          case "FACTOR_CHALLENGE":
          case "MFA_REQUIRED":
            var l = n.appState.get("lastFailedChallengeFactorData");
            l && l.factor && (n.appState.get("factors").lastUsedFactor = l.factor);
            var f = n.appState.get("factors").getDefaultFactor(),
              p = s.createVerifyUrl(f.get("provider"), f.get("factorType"));
            return n.navigate(p, {
              trigger: !0
            }), void n.appState.clearLastFailedChallengeFactorData();
          case "POLL":
            ;
            return void n.navigate("signin/poll", {
              trigger: !0
            });
          case "MFA_CHALLENGE":
            return n.appState.get("isFactorResultFailed") && n.appState.setLastFailedChallengeFactorData(), void n.appState.get("transaction").prev().then(function (t) {
              n.appState.set("transaction", t);
            }).done();
          case "MFA_ENROLL":
          case "FACTOR_ENROLL":
            return void n.navigate("signin/enroll", {
              trigger: !0
            });
          case "MFA_ENROLL_ACTIVATE":
          case "FACTOR_ENROLL_ACTIVATE":
            var d = s.createActivateFactorUrl(n.appState.get("activatedFactorProvider"), n.appState.get("activatedFactorType"));
            return void n.navigate(d, {
              trigger: !0
            });
          case "PASSWORD_WARN":
          case "PASSWORD_EXPIRED":
            return void (n.settings.get("features.customExpiredPassword") && !n.appState.get("isPwdManagedByOkta") ? n.navigate("signin/custom-password-expired", {
              trigger: !0
            }) : n.navigate("signin/password-expired", {
              trigger: !0
            }));
          case "RECOVERY_CHALLENGE":
            var h = i.factorType.toLowerCase() === r.RECOVERY_FACTOR_TYPE_EMAIL.toLowerCase(),
              g = i.recoveryType === r.RECOVERY_TYPE_PASSWORD,
              v = i.recoveryType === r.RECOVERY_TYPE_UNLOCK;
            return void (g && h ? n.navigate("signin/recovery-emailed", {
              trigger: !0
            }) : v && h ? n.navigate("signin/unlock-emailed", {
              trigger: !0
            }) : n.navigate("signin/recovery-challenge", {
              trigger: !0
            }));
          case "RECOVERY":
            return void n.navigate("signin/recovery-question", {
              trigger: !0
            });
          case "PASSWORD_RESET":
            return void n.navigate("signin/password-reset", {
              trigger: !0
            });
          case "LOCKED_OUT":
            return void (n.settings.get("features.selfServiceUnlock") ? n.navigate("signin/unlock", {
              trigger: !0
            }) : n.controller.model.trigger("error", n.controller.model, {
              responseJSON: {
                errorCauses: [],
                errorSummary: t.loc("error.auth.lockedOut", "login")
              }
            }));
          case "PROFILE_REQUIRED":
            return void n.navigate("signin/enroll-user", {
              trigger: !0
            });
          case "UNAUTHENTICATED":
            if (n.appState.get("promptForFactorInUnauthenticated")) {
              var y = n.appState.get("factors").getDefaultFactor(),
                _ = s.createVerifyUrl(y.get("provider"), y.get("factorType"));
              return void n.navigate(_, {
                trigger: !0
              });
            }
            return void n.navigate("", {
              trigger: !0
            });
          default:
            throw new Error("Unknown status: " + i.status);
        }
      }, s;
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    var r = n(15),
      i = n(60);
    t.exports = n(12) ? function (t, e, n) {
      return r.f(t, e, i(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e, n) {
    var r = n(5),
      i = n(25),
      o = n(29),
      a = n(61)("src"),
      s = n(276),
      u = ("" + s).split("toString");
    n(34).inspectSource = function (t) {
      return s.call(t);
    }, (t.exports = function (t, e, n, s) {
      var c = "function" == typeof n;
      c && (o(n, "name") || i(n, "name", e)), t[e] !== n && (c && (o(n, a) || i(n, a, t[e] ? "" + t[e] : u.join(String(e)))), t === r ? t[e] = n : s ? t[e] ? t[e] = n : i(t, e, n) : (delete t[e], i(t, e, n)));
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && this[a] || s.call(this);
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(7),
      o = n(42),
      a = /"/g,
      s = function s(t, e, n, r) {
        var i = String(o(t)),
          s = "<" + e;
        return "" !== n && (s += " " + n + '="' + String(r).replace(a, "&quot;") + '"'), s + ">" + i + "</" + e + ">";
      };
    t.exports = function (t, e) {
      var n = {};
      n[t] = e(s), r(r.P + r.F * i(function () {
        var e = ""[t]('"');
        return e !== e.toLowerCase() || e.split('"').length > 3;
      }), "String", n);
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(0),
      i = n(651),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(i);
    e.default = r.Form.extend({
      layout: "o-form-theme",
      className: "ion-form",
      hasSavingState: !0,
      autoSave: !1,
      noCancelButton: !0,
      title: "Authenticate",
      save: (0, r.loc)("oform.next", "login"),
      initialize: function initialize() {
        var t = this,
          e = this.getUISchema(),
          n = e.map(o.default.create);
        this.addCallouts(), n.forEach(function (e) {
          t.addInputOrView(e);
        }), this.listenTo(this, "save", this.saveForm);
      },
      saveForm: function saveForm(t) {
        this.$el.find(".o-form-error-container").empty(), this.options.appState.trigger("saveForm", t);
      },
      getUISchema: function getUISchema() {
        return Array.isArray(this.options.currentViewState.uiSchema) ? this.options.currentViewState.uiSchema : [];
      },
      addInputOrView: function addInputOrView(t) {
        t.View ? this.add(t.View, {
          options: t.options
        }) : this.addInput(t);
      },
      addCallouts: function addCallouts() {
        var t = this.options.appState.get("messages");
        if (t && t.value.length) {
          var e = (0, r.createCallout)({
            content: t.value[0].message,
            type: "warning"
          });
          this.add(e, ".o-form-error-container");
        }
      }
    });
  }, function (t, e) {
    var n = {}.hasOwnProperty;
    t.exports = function (t, e) {
      return n.call(t, e);
    };
  }, function (t, e, n) {
    var r = n(85),
      i = n(42);
    t.exports = function (t) {
      return r(i(t));
    };
  }, function (t, e, n) {
    var r = n(86),
      i = n(60),
      o = n(30),
      a = n(41),
      s = n(29),
      u = n(183),
      c = Object.getOwnPropertyDescriptor;
    e.f = n(12) ? c : function (t, e) {
      if (t = o(t), e = a(e, !0), u) try {
        return c(t, e);
      } catch (t) {}
      if (s(t, e)) return i(!r.f.call(t, e), t[e]);
    };
  }, function (t, e, n) {
    var r = n(29),
      i = n(16),
      o = n(126)("IE_PROTO"),
      a = Object.prototype;
    t.exports = Object.getPrototypeOf || function (t) {
      return t = i(t), r(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? a : null;
    };
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(6)], void 0 !== (i = function (t, e) {
      function n(n) {
        this.name = e.CONFIG_ERROR, this.message = n || t.loc("error.config");
      }
      function r(n) {
        this.name = e.UNSUPPORTED_BROWSER_ERROR, this.message = n || t.loc("error.unsupported.browser");
      }
      function i(t) {
        this.name = e.OAUTH_ERROR, this.message = t;
      }
      function o(t) {
        this.name = e.REGISTRATION_FAILED, this.message = t;
      }
      function a() {
        this.name = e.AUTH_STOP_POLL_INITIATION_ERROR;
      }
      function s(t) {
        this.name = e.U2F_ERROR, this.message = t.xhr.responseJSON.errorSummary, this.xhr = t.xhr;
      }
      function u(t) {
        this.name = e.WEB_AUTHN_ERROR, this.message = t.xhr.responseJSON.errorSummary, this.xhr = t.xhr;
      }
      function c() {
        this.name = e.WEBAUTHN_ABORT_ERROR;
      }
      return n.prototype = new Error(), r.prototype = new Error(), i.prototype = new Error(), o.prototype = new Error(), a.prototype = new Error(), s.prototype = new Error(), u.prototype = new Error(), c.prototype = new Error(), {
        ConfigError: n,
        UnsupportedBrowserError: r,
        OAuthError: i,
        RegistrationError: o,
        AuthStopPollInitiationError: a,
        U2FError: s,
        WebAuthnError: u,
        WebauthnAbortError: c
      };
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e) {
    var n = t.exports = {
      version: "2.6.9"
    };
    "number" == typeof __e && (__e = n);
  }, function (t, e, n) {
    var r = n(20);
    t.exports = function (t, e, n) {
      if (r(t), void 0 === e) return t;
      switch (n) {
        case 1:
          return function (n) {
            return t.call(e, n);
          };
        case 2:
          return function (n, r) {
            return t.call(e, n, r);
          };
        case 3:
          return function (n, r, i) {
            return t.call(e, n, r, i);
          };
      }
      return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e) {
    var n = {}.toString;
    t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  }, function (t, e) {
    var n = Math.ceil,
      r = Math.floor;
    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(7);
    t.exports = function (t, e) {
      return !!t && r(function () {
        e ? t.call(null, function () {}, 1) : t.call(null);
      });
    };
  }, function (t, e, n) {
    t.exports = !n(79)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(0),
      o = n(28),
      a = r(o),
      s = n(653),
      u = r(s),
      c = n(266),
      l = r(c),
      f = n(59),
      p = r(f);
    e.default = i.View.extend({
      Header: l.default,
      Body: a.default,
      Footer: p.default,
      className: "siw-main-view",
      template: '<div class="siw-main-header"></div><div class="siw-main-body"></div><div class="siw-main-footer"></div>',
      initialize: function initialize() {
        var t = this.createModelClass(),
          e = new t({
            formName: this.options.currentViewState.name
          });
        this.add(this.Header, {
          selector: ".siw-main-header"
        }), this.add(this.Body, {
          selector: ".siw-main-body",
          options: {
            model: e
          }
        }), this.add(this.Footer, {
          selector: ".siw-main-footer"
        });
      },
      postRender: function postRender() {
        var t = this.options.appState;
        this.$el.find(".js-sign-up").click(function () {
          return t.trigger("invokeAction", "select-enroll-profile"), !1;
        });
      },
      createModelClass: function createModelClass() {
        return u.default.create(this.options.currentViewState);
      }
    });
  }, function (t, e, n) {
    var r = n(8);
    t.exports = function (t, e) {
      if (!r(t)) return t;
      var n, i;
      if (e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
      if ("function" == typeof (n = t.valueOf) && !r(i = n.call(t))) return i;
      if (!e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);
      return t;
    };
  }, function (t, e, n) {
    var r = n(1),
      i = n(34),
      o = n(7);
    t.exports = function (t, e) {
      var n = (i.Object || {})[t] || Object[t],
        a = {};
      a[t] = e(n), r(r.S + r.F * o(function () {
        n(1);
      }), "Object", a);
    };
  }, function (t, e, n) {
    var r = n(35),
      i = n(85),
      o = n(16),
      a = n(11),
      s = n(142);
    t.exports = function (t, e) {
      var n = 1 == t,
        u = 2 == t,
        c = 3 == t,
        l = 4 == t,
        f = 6 == t,
        p = 5 == t || f,
        d = e || s;
      return function (e, s, h) {
        for (var m, g, v = o(e), y = i(v), _ = r(s, h, 3), b = a(y.length), w = 0, S = n ? d(e, b) : u ? d(e, 0) : void 0; b > w; w++) if ((p || w in y) && (m = y[w], g = _(m, w, v), t)) if (n) S[w] = g;else if (g) switch (t) {
          case 3:
            return !0;
          case 5:
            return m;
          case 6:
            return w;
          case 2:
            S.push(m);
        } else if (l) return !1;
        return f ? -1 : c || l ? l : S;
      };
    };
  }, function (t, e, n) {
    var r = n(46);
    t.exports = function (t) {
      if (!r(t)) throw TypeError(t + " is not an object!");
      return t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == typeof t ? null !== t : "function" == typeof t;
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(552),
      __esModule: !0
    };
  }, function (t, e, n) {
    "use strict";

    if (n(12)) {
      var r = n(53),
        i = n(5),
        o = n(7),
        a = n(1),
        s = n(111),
        u = n(150),
        c = n(35),
        l = n(67),
        f = n(60),
        p = n(25),
        d = n(69),
        h = n(37),
        m = n(11),
        g = n(211),
        v = n(63),
        y = n(41),
        _ = n(29),
        b = n(74),
        w = n(8),
        S = n(16),
        x = n(139),
        E = n(64),
        T = n(32),
        k = n(65).f,
        A = n(141),
        O = n(61),
        C = n(10),
        I = n(44),
        R = n(101),
        P = n(88),
        N = n(144),
        M = n(76),
        L = n(106),
        F = n(66),
        D = n(143),
        j = n(200),
        U = n(15),
        B = n(31),
        V = U.f,
        q = B.f,
        H = i.RangeError,
        W = i.TypeError,
        $ = i.Uint8Array,
        z = Array.prototype,
        G = u.ArrayBuffer,
        K = u.DataView,
        Y = I(0),
        J = I(2),
        Q = I(3),
        X = I(4),
        Z = I(5),
        tt = I(6),
        et = R(!0),
        nt = R(!1),
        rt = N.values,
        it = N.keys,
        ot = N.entries,
        at = z.lastIndexOf,
        st = z.reduce,
        ut = z.reduceRight,
        ct = z.join,
        lt = z.sort,
        ft = z.slice,
        pt = z.toString,
        dt = z.toLocaleString,
        ht = C("iterator"),
        mt = C("toStringTag"),
        gt = O("typed_constructor"),
        vt = O("def_constructor"),
        yt = s.CONSTR,
        _t = s.TYPED,
        bt = s.VIEW,
        wt = I(1, function (t, e) {
          return kt(P(t, t[vt]), e);
        }),
        St = o(function () {
          return 1 === new $(new Uint16Array([1]).buffer)[0];
        }),
        xt = !!$ && !!$.prototype.set && o(function () {
          new $(1).set({});
        }),
        Et = function Et(t, e) {
          var n = h(t);
          if (n < 0 || n % e) throw H("Wrong offset!");
          return n;
        },
        Tt = function Tt(t) {
          if (w(t) && _t in t) return t;
          throw W(t + " is not a typed array!");
        },
        kt = function kt(t, e) {
          if (!(w(t) && gt in t)) throw W("It is not a typed array constructor!");
          return new t(e);
        },
        At = function At(t, e) {
          return Ot(P(t, t[vt]), e);
        },
        Ot = function Ot(t, e) {
          for (var n = 0, r = e.length, i = kt(t, r); r > n;) i[n] = e[n++];
          return i;
        },
        Ct = function Ct(t, e, n) {
          V(t, e, {
            get: function get() {
              return this._d[n];
            }
          });
        },
        It = function It(t) {
          var e,
            n,
            r,
            i,
            o,
            a,
            s = S(t),
            u = arguments.length,
            l = u > 1 ? arguments[1] : void 0,
            f = void 0 !== l,
            p = A(s);
          if (void 0 != p && !x(p)) {
            for (a = p.call(s), r = [], e = 0; !(o = a.next()).done; e++) r.push(o.value);
            s = r;
          }
          for (f && u > 2 && (l = c(l, arguments[2], 2)), e = 0, n = m(s.length), i = kt(this, n); n > e; e++) i[e] = f ? l(s[e], e) : s[e];
          return i;
        },
        Rt = function Rt() {
          for (var t = 0, e = arguments.length, n = kt(this, e); e > t;) n[t] = arguments[t++];
          return n;
        },
        Pt = !!$ && o(function () {
          dt.call(new $(1));
        }),
        Nt = function Nt() {
          return dt.apply(Pt ? ft.call(Tt(this)) : Tt(this), arguments);
        },
        Mt = {
          copyWithin: function copyWithin(t, e) {
            return j.call(Tt(this), t, e, arguments.length > 2 ? arguments[2] : void 0);
          },
          every: function every(t) {
            return X(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          fill: function fill(t) {
            return D.apply(Tt(this), arguments);
          },
          filter: function filter(t) {
            return At(this, J(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0));
          },
          find: function find(t) {
            return Z(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          findIndex: function findIndex(t) {
            return tt(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          forEach: function forEach(t) {
            Y(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          indexOf: function indexOf(t) {
            return nt(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          includes: function includes(t) {
            return et(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          join: function join(t) {
            return ct.apply(Tt(this), arguments);
          },
          lastIndexOf: function lastIndexOf(t) {
            return at.apply(Tt(this), arguments);
          },
          map: function map(t) {
            return wt(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          reduce: function reduce(t) {
            return st.apply(Tt(this), arguments);
          },
          reduceRight: function reduceRight(t) {
            return ut.apply(Tt(this), arguments);
          },
          reverse: function reverse() {
            for (var t, e = this, n = Tt(e).length, r = Math.floor(n / 2), i = 0; i < r;) t = e[i], e[i++] = e[--n], e[n] = t;
            return e;
          },
          some: function some(t) {
            return Q(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          sort: function sort(t) {
            return lt.call(Tt(this), t);
          },
          subarray: function subarray(t, e) {
            var n = Tt(this),
              r = n.length,
              i = v(t, r);
            return new (P(n, n[vt]))(n.buffer, n.byteOffset + i * n.BYTES_PER_ELEMENT, m((void 0 === e ? r : v(e, r)) - i));
          }
        },
        Lt = function Lt(t, e) {
          return At(this, ft.call(Tt(this), t, e));
        },
        Ft = function Ft(t) {
          Tt(this);
          var e = Et(arguments[1], 1),
            n = this.length,
            r = S(t),
            i = m(r.length),
            o = 0;
          if (i + e > n) throw H("Wrong length!");
          for (; o < i;) this[e + o] = r[o++];
        },
        Dt = {
          entries: function entries() {
            return ot.call(Tt(this));
          },
          keys: function keys() {
            return it.call(Tt(this));
          },
          values: function values() {
            return rt.call(Tt(this));
          }
        },
        jt = function jt(t, e) {
          return w(t) && t[_t] && "symbol" != typeof e && e in t && String(+e) == String(e);
        },
        Ut = function Ut(t, e) {
          return jt(t, e = y(e, !0)) ? f(2, t[e]) : q(t, e);
        },
        Bt = function Bt(t, e, n) {
          return !(jt(t, e = y(e, !0)) && w(n) && _(n, "value")) || _(n, "get") || _(n, "set") || n.configurable || _(n, "writable") && !n.writable || _(n, "enumerable") && !n.enumerable ? V(t, e, n) : (t[e] = n.value, t);
        };
      yt || (B.f = Ut, U.f = Bt), a(a.S + a.F * !yt, "Object", {
        getOwnPropertyDescriptor: Ut,
        defineProperty: Bt
      }), o(function () {
        pt.call({});
      }) && (pt = dt = function dt() {
        return ct.call(this);
      });
      var Vt = d({}, Mt);
      d(Vt, Dt), p(Vt, ht, Dt.values), d(Vt, {
        slice: Lt,
        set: Ft,
        constructor: function constructor() {},
        toString: pt,
        toLocaleString: Nt
      }), Ct(Vt, "buffer", "b"), Ct(Vt, "byteOffset", "o"), Ct(Vt, "byteLength", "l"), Ct(Vt, "length", "e"), V(Vt, mt, {
        get: function get() {
          return this[_t];
        }
      }), t.exports = function (t, e, n, u) {
        u = !!u;
        var c = t + (u ? "Clamped" : "") + "Array",
          f = "get" + t,
          d = "set" + t,
          h = i[c],
          v = h || {},
          y = h && T(h),
          _ = !h || !s.ABV,
          S = {},
          x = h && h.prototype,
          A = function A(t, n) {
            var r = t._d;
            return r.v[f](n * e + r.o, St);
          },
          O = function O(t, n, r) {
            var i = t._d;
            u && (r = (r = Math.round(r)) < 0 ? 0 : r > 255 ? 255 : 255 & r), i.v[d](n * e + i.o, r, St);
          },
          C = function C(t, e) {
            V(t, e, {
              get: function get() {
                return A(this, e);
              },
              set: function set(t) {
                return O(this, e, t);
              },
              enumerable: !0
            });
          };
        _ ? (h = n(function (t, n, r, i) {
          l(t, h, c, "_d");
          var o,
            a,
            s,
            u,
            f = 0,
            d = 0;
          if (w(n)) {
            if (!(n instanceof G || "ArrayBuffer" == (u = b(n)) || "SharedArrayBuffer" == u)) return _t in n ? Ot(h, n) : It.call(h, n);
            o = n, d = Et(r, e);
            var v = n.byteLength;
            if (void 0 === i) {
              if (v % e) throw H("Wrong length!");
              if ((a = v - d) < 0) throw H("Wrong length!");
            } else if ((a = m(i) * e) + d > v) throw H("Wrong length!");
            s = a / e;
          } else s = g(n), a = s * e, o = new G(a);
          for (p(t, "_d", {
            b: o,
            o: d,
            l: a,
            e: s,
            v: new K(o)
          }); f < s;) C(t, f++);
        }), x = h.prototype = E(Vt), p(x, "constructor", h)) : o(function () {
          h(1);
        }) && o(function () {
          new h(-1);
        }) && L(function (t) {
          new h(), new h(null), new h(1.5), new h(t);
        }, !0) || (h = n(function (t, n, r, i) {
          l(t, h, c);
          var o;
          return w(n) ? n instanceof G || "ArrayBuffer" == (o = b(n)) || "SharedArrayBuffer" == o ? void 0 !== i ? new v(n, Et(r, e), i) : void 0 !== r ? new v(n, Et(r, e)) : new v(n) : _t in n ? Ot(h, n) : It.call(h, n) : new v(g(n));
        }), Y(y !== Function.prototype ? k(v).concat(k(y)) : k(v), function (t) {
          t in h || p(h, t, v[t]);
        }), h.prototype = x, r || (x.constructor = h));
        var I = x[ht],
          R = !!I && ("values" == I.name || void 0 == I.name),
          P = Dt.values;
        p(h, gt, !0), p(x, _t, c), p(x, bt, !0), p(x, vt, h), (u ? new h(1)[mt] == c : mt in x) || V(x, mt, {
          get: function get() {
            return c;
          }
        }), S[c] = h, a(a.G + a.W + a.F * (h != v), S), a(a.S, c, {
          BYTES_PER_ELEMENT: e
        }), a(a.S + a.F * o(function () {
          v.of.call(h, 1);
        }), c, {
          from: It,
          of: Rt
        }), "BYTES_PER_ELEMENT" in x || p(x, "BYTES_PER_ELEMENT", e), a(a.P, c, Mt), F(c), a(a.P + a.F * xt, c, {
          set: Ft
        }), a(a.P + a.F * !R, c, Dt), r || x.toString == pt || (x.toString = pt), a(a.P + a.F * o(function () {
          new h(1).slice();
        }), c, {
          slice: Lt
        }), a(a.P + a.F * (o(function () {
          return [1, 2].toLocaleString() != new h([1, 2]).toLocaleString();
        }) || !o(function () {
          x.toLocaleString.call([1, 2]);
        })), c, {
          toLocaleString: Nt
        }), M[c] = R ? I : P, r || R || p(x, ht, P);
      };
    } else t.exports = function () {};
  }, function (t, e, n) {
    var r = n(206),
      i = n(1),
      o = n(84)("metadata"),
      a = o.store || (o.store = new (n(209))()),
      s = function s(t, e, n) {
        var i = a.get(t);
        if (!i) {
          if (!n) return;
          a.set(t, i = new r());
        }
        var o = i.get(e);
        if (!o) {
          if (!n) return;
          i.set(e, o = new r());
        }
        return o;
      },
      u = function u(t, e, n) {
        var r = s(e, n, !1);
        return void 0 !== r && r.has(t);
      },
      c = function c(t, e, n) {
        var r = s(e, n, !1);
        return void 0 === r ? void 0 : r.get(t);
      },
      l = function l(t, e, n, r) {
        s(n, r, !0).set(t, e);
      },
      f = function f(t, e) {
        var n = s(t, e, !1),
          r = [];
        return n && n.forEach(function (t, e) {
          r.push(e);
        }), r;
      },
      p = function p(t) {
        return void 0 === t || "symbol" == typeof t ? t : String(t);
      },
      d = function d(t) {
        i(i.S, "Reflect", t);
      };
    t.exports = {
      store: a,
      map: s,
      has: u,
      get: c,
      set: l,
      keys: f,
      key: p,
      exp: d
    };
  }, function (t, e, n) {
    var r = n(45),
      i = n(221),
      o = n(157),
      a = Object.defineProperty;
    e.f = n(39) ? Object.defineProperty : function (t, e, n) {
      if (r(t), e = o(e, !0), r(n), i) try {
        return a(t, e, n);
      } catch (t) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
      return "value" in n && (t[e] = n.value), t;
    };
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(6)], void 0 !== (i = function (t, e) {
      var n = t.internal.util.Util,
        r = t._;
      return t.View.extend({
        template: '      <a href="#" class="link {{linkClassName}}" data-se="signout-link">        {{linkText}}      </a>    ',
        className: "auth-footer clearfix",
        events: {
          "click a": function clickA(t) {
            t.preventDefault(), this.options.appState.trigger("signOut");
            var r = this;
            this.model.doTransaction(function (t) {
              return t.cancel();
            }).then(function () {
              r.settings.get("signOutLink") ? n.redirect(r.settings.get("signOutLink")) : (r.state.set("navigateDir", e.DIRECTION_BACK), r.options.appState.trigger("navigate", ""));
            });
          }
        },
        getTemplateData: function getTemplateData() {
          return {
            linkClassName: r.isUndefined(this.options.linkClassName) ? "goto" : this.options.linkClassName,
            linkText: this.options.linkText || t.loc("signout", "login")
          };
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      return t.View.extend({
        template: '    <span class="icon error-24"></span>    <h4><strong>{{{message}}}</strong></h4>  ',
        className: "okta-infobox-error infobox infobox-error infobox-md margin-btm-25",
        attributes: {
          "data-se": "o-form-error-html"
        },
        message: "",
        initialize: function initialize(t) {
          t && t.message && (this.message = t.message);
        },
        getTemplateData: function getTemplateData() {
          return {
            message: this.message
          };
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e) {
    t.exports = !1;
  }, function (t, e, n) {
    var r = n(61)("meta"),
      i = n(8),
      o = n(29),
      a = n(15).f,
      s = 0,
      u = Object.isExtensible || function () {
        return !0;
      },
      c = !n(7)(function () {
        return u(Object.preventExtensions({}));
      }),
      l = function l(t) {
        a(t, r, {
          value: {
            i: "O" + ++s,
            w: {}
          }
        });
      },
      f = function f(t, e) {
        if (!i(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
        if (!o(t, r)) {
          if (!u(t)) return "F";
          if (!e) return "E";
          l(t);
        }
        return t[r].i;
      },
      p = function p(t, e) {
        if (!o(t, r)) {
          if (!u(t)) return !0;
          if (!e) return !1;
          l(t);
        }
        return t[r].w;
      },
      d = function d(t) {
        return c && h.NEED && u(t) && !o(t, r) && l(t), t;
      },
      h = t.exports = {
        KEY: r,
        NEED: !1,
        fastKey: f,
        getWeak: p,
        onFreeze: d
      };
  }, function (t, e, n) {
    var r = n(10)("unscopables"),
      i = Array.prototype;
    void 0 == i[r] && n(25)(i, r, {}), t.exports = function (t) {
      i[r][t] = !0;
    };
  }, function (t, e, n) {
    var r = n(225),
      i = n(155);
    t.exports = function (t) {
      return r(i(t));
    };
  }, function (t, e, n) {
    "use strict";

    var r;
    void 0 !== (r = function () {
      function t(t, e) {
        "error" === t && window.console[t].apply(window.console, e);
      }
      return {
        trace: function trace() {
          return t("trace", arguments);
        },
        dir: function dir() {
          return t("dir", arguments);
        },
        time: function time() {
          return t("time", arguments);
        },
        timeEnd: function timeEnd() {
          return t("timeEnd", arguments);
        },
        group: function group() {
          return t("group", arguments);
        },
        groupEnd: function groupEnd() {
          return t("groupEnd", arguments);
        },
        assert: function assert() {
          return t("assert", arguments);
        },
        log: function log() {
          return t("log", arguments);
        },
        info: function info() {
          return t("info", arguments);
        },
        warn: function warn() {
          return t("warn", arguments);
        },
        error: function error() {
          return t("error", arguments);
        },
        deprecate: function deprecate(e) {
          return t("warn", ["[okta-signin-widget] DEPRECATED:", e]);
        }
      };
    }.call(e, n, e, t)) && (t.exports = r);
  }, function (t, e, n) {
    "use strict";

    var r;
    void 0 !== (r = function () {
      var t = {},
        e = ("withCredentials" in new window.XMLHttpRequest()),
        n = "undefined" != typeof XDomainRequest;
      return t.corsIsNotSupported = function () {
        return !(e || n);
      }, t.corsIsNotEnabled = function (t) {
        return 0 === t.status;
      }, t.localStorageIsNotSupported = function () {
        try {
          return localStorage.setItem("test", "test"), localStorage.removeItem("test"), !1;
        } catch (t) {
          return !0;
        }
      }, t.supportsPushState = function (t) {
        return t = t || window, !(!t.history || !t.history.pushState);
      }, t.isIE = function () {
        return /(msie|trident)/i.test(navigator.userAgent);
      }, t.isFirefox = function () {
        return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
      }, t.isEdge = function () {
        return navigator.userAgent.toLowerCase().indexOf("edge") > -1;
      }, t.isSafari = function () {
        return navigator.userAgent.toLowerCase().indexOf("safari") > -1 && -1 === navigator.userAgent.toLowerCase().indexOf("chrome");
      }, t.isMac = function () {
        return navigator.platform.toUpperCase().indexOf("MAC") >= 0;
      }, t.getUserLanguages = function () {
        var t, e;
        return navigator.languages ? navigator.languages : (t = [], e = ["language", "userLanguage", "browserLanguage", "systemLanguage"], e.forEach(function (e) {
          navigator[e] && t.push(navigator[e]);
        }), t);
      }, t;
    }.call(e, n, e, t)) && (t.exports = r);
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(0),
      i = n(654),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(i);
    e.default = r.View.extend({
      className: "auth-footer",
      links: [],
      initialize: function initialize() {
        var t = this,
          e = r._.resultCtx(this, "links", this);
        this.options.appState.get("showSignoutLink") && (e = e.concat([{
          actionPath: "cancel",
          label: "Sign out",
          name: "cancel",
          type: "link"
        }])), e.forEach(function (e) {
          t.add(o.default, {
            options: e
          });
        });
      }
    });
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    };
  }, function (t, e) {
    var n = 0,
      r = Math.random();
    t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
    };
  }, function (t, e, n) {
    var r = n(185),
      i = n(127);
    t.exports = Object.keys || function (t) {
      return r(t, i);
    };
  }, function (t, e, n) {
    var r = n(37),
      i = Math.max,
      o = Math.min;
    t.exports = function (t, e) {
      return t = r(t), t < 0 ? i(t + e, 0) : o(t, e);
    };
  }, function (t, e, n) {
    var r = n(3),
      i = n(186),
      o = n(127),
      a = n(126)("IE_PROTO"),
      s = function s() {},
      _u = function u() {
        var t,
          e = n(124)("iframe"),
          r = o.length;
        for (e.style.display = "none", n(128).appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write("<script>document.F=Object<\/script>"), t.close(), _u = t.F; r--;) delete _u.prototype[o[r]];
        return _u();
      };
    t.exports = Object.create || function (t, e) {
      var n;
      return null !== t ? (s.prototype = r(t), n = new s(), s.prototype = null, n[a] = t) : n = _u(), void 0 === e ? n : i(n, e);
    };
  }, function (t, e, n) {
    var r = n(185),
      i = n(127).concat("length", "prototype");
    e.f = Object.getOwnPropertyNames || function (t) {
      return r(t, i);
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(5),
      i = n(15),
      o = n(12),
      a = n(10)("species");
    t.exports = function (t) {
      var e = r[t];
      o && e && !e[a] && i.f(e, a, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    };
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      if (!(t instanceof e) || void 0 !== r && r in t) throw TypeError(n + ": incorrect invocation!");
      return t;
    };
  }, function (t, e, n) {
    var r = n(35),
      i = n(198),
      o = n(139),
      a = n(3),
      s = n(11),
      u = n(141),
      c = {},
      l = {},
      e = t.exports = function (t, e, n, f, p) {
        var d,
          h,
          m,
          g,
          v = p ? function () {
            return t;
          } : u(t),
          y = r(n, f, e ? 2 : 1),
          _ = 0;
        if ("function" != typeof v) throw TypeError(t + " is not iterable!");
        if (o(v)) {
          for (d = s(t.length); d > _; _++) if ((g = e ? y(a(h = t[_])[0], h[1]) : y(t[_])) === c || g === l) return g;
        } else for (m = v.call(t); !(h = m.next()).done;) if ((g = i(m, y, h.value, e)) === c || g === l) return g;
      };
    e.BREAK = c, e.RETURN = l;
  }, function (t, e, n) {
    var r = n(26);
    t.exports = function (t, e, n) {
      for (var i in e) r(t, i, e[i], n);
      return t;
    };
  }, function (t, e, n) {
    var r = n(8);
    t.exports = function (t, e) {
      if (!r(t) || t._t !== e) throw TypeError("Incompatible receiver, " + e + " required!");
      return t;
    };
  }, function (t, e, n) {
    var r = n(50),
      i = n(92);
    t.exports = n(39) ? function (t, e, n) {
      return r.f(t, e, i(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e) {
    var n = {}.hasOwnProperty;
    t.exports = function (t, e) {
      return n.call(t, e);
    };
  }, function (t, e, n) {
    var r = n(15).f,
      i = n(29),
      o = n(10)("toStringTag");
    t.exports = function (t, e, n) {
      t && !i(t = n ? t : t.prototype, o) && r(t, o, {
        configurable: !0,
        value: e
      });
    };
  }, function (t, e, n) {
    var r = n(36),
      i = n(10)("toStringTag"),
      o = "Arguments" == r(function () {
        return arguments;
      }()),
      a = function a(t, e) {
        try {
          return t[e];
        } catch (t) {}
      };
    t.exports = function (t) {
      var e, n, s;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = a(e = Object(t), i)) ? n : o ? r(e) : "Object" == (s = r(e)) && "function" == typeof e.callee ? "Arguments" : s;
    };
  }, function (t, e, n) {
    var r = n(1),
      i = n(42),
      o = n(7),
      a = n(130),
      s = "[" + a + "]",
      u = "​",
      c = RegExp("^" + s + s + "*"),
      l = RegExp(s + s + "*$"),
      f = function f(t, e, n) {
        var i = {},
          s = o(function () {
            return !!a[t]() || u[t]() != u;
          }),
          c = i[t] = s ? e(p) : a[t];
        n && (i[n] = c), r(r.P + r.F * s, "String", i);
      },
      p = f.trim = function (t, e) {
        return t = String(i(t)), 1 & e && (t = t.replace(c, "")), 2 & e && (t = t.replace(l, "")), t;
      };
    t.exports = f;
  }, function (t, e) {
    t.exports = {};
  }, function (t, e, n) {
    t.exports = {
      default: n(476),
      __esModule: !0
    };
  }, function (t, e, n) {
    var r = n(115);
    t.exports = function (t, e, n) {
      if (r(t), void 0 === e) return t;
      switch (n) {
        case 1:
          return function (n) {
            return t.call(e, n);
          };
        case 2:
          return function (n, r) {
            return t.call(e, n, r);
          };
        case 3:
          return function (n, r, i) {
            return t.call(e, n, r, i);
          };
      }
      return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, e) {
    t.exports = {};
  }, function (t, e, n) {
    var r = n(224),
      i = n(162);
    t.exports = Object.keys || function (t) {
      return r(t, i);
    };
  }, function (t, e, n) {
    var r = n(155);
    t.exports = function (t) {
      return Object(r(t));
    };
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(17)], void 0 !== (i = function (t, e) {
      function n(e) {
        return r.find(e.getChildren(), function (e) {
          return e instanceof t.Form;
        });
      }
      var r = t._;
      return t.Controller.extend({
        addListeners: function addListeners() {
          this.listenTo(this.model, "save", function () {
            var t = n(this);
            t.disableSubmitButton && !t.disableSubmitButton() || this.toggleButtonState(!0);
          }), this.listenTo(this.model, "error", function () {
            this.toggleButtonState(!1);
          }), this.addModelListeners(this.model);
        },
        addModelListeners: function addModelListeners(t) {
          var e = r.bind(function (t) {
              this.options.appState.set("transaction", t);
            }, this),
            n = r.bind(function (t) {
              this.options.appState.set("transactionError", t);
            }, this);
          this.listenTo(t, "setTransaction", e), this.listenTo(t, "setTransactionError", n);
          var i = t.get("backupFactor");
          i && (this.listenTo(i, "setTransaction", e), this.listenTo(i, "setTransactionError", n));
        },
        fetchInitialData: function fetchInitialData() {
          return e();
        },
        trapAuthResponse: function trapAuthResponse() {
          return !1;
        },
        toJSON: function toJSON() {
          var e = t.Controller.prototype.toJSON.apply(this, arguments);
          return r.extend(r.pick(this.options, "appState"), e);
        },
        toggleButtonState: function toggleButtonState(t) {
          this.$el.find(".button").toggleClass("link-button-disabled", t).prop("disabled", t);
        },
        postRenderAnimation: function postRenderAnimation() {
          this.trigger("pageRendered", {
            page: this.className
          }), this.trigger("afterRender", {
            controller: this.className
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    var r = n(34),
      i = n(5),
      o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
    (t.exports = function (t, e) {
      return o[t] || (o[t] = void 0 !== e ? e : {});
    })("versions", []).push({
      version: r.version,
      mode: n(53) ? "pure" : "global",
      copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
    });
  }, function (t, e, n) {
    var r = n(36);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == r(t) ? t.split("") : Object(t);
    };
  }, function (t, e) {
    e.f = {}.propertyIsEnumerable;
  }, function (t, e, n) {
    "use strict";

    var r = n(3);
    t.exports = function () {
      var t = r(this),
        e = "";
      return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
    };
  }, function (t, e, n) {
    var r = n(3),
      i = n(20),
      o = n(10)("species");
    t.exports = function (t, e) {
      var n,
        a = r(t).constructor;
      return void 0 === a || void 0 == (n = r(a)[o]) ? e : i(n);
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    e.__esModule = !0;
    var i = n(219),
      o = r(i),
      a = n(228),
      s = r(a),
      u = "function" == typeof s.default && "symbol" == typeof o.default ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof s.default && t.constructor === s.default && t !== s.default.prototype ? "symbol" : typeof t;
      };
    e.default = "function" == typeof s.default && "symbol" === u(o.default) ? function (t) {
      return void 0 === t ? "undefined" : u(t);
    } : function (t) {
      return t && "function" == typeof s.default && t.constructor === s.default && t !== s.default.prototype ? "symbol" : void 0 === t ? "undefined" : u(t);
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(478)(!0);
    n(220)(String, "String", function (t) {
      this._t = String(t), this._i = 0;
    }, function () {
      var t,
        e = this._t,
        n = this._i;
      return n >= e.length ? {
        value: void 0,
        done: !0
      } : (t = r(e, n), this._i += t.length, {
        value: t,
        done: !1
      });
    });
  }, function (t, e) {
    t.exports = !0;
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    };
  }, function (t, e) {
    var n = {}.toString;
    t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  }, function (t, e) {
    e.f = {}.propertyIsEnumerable;
  }, function (t, e, n) {
    var r = n(21),
      i = n(9),
      o = n(79);
    t.exports = function (t, e) {
      var n = (i.Object || {})[t] || Object[t],
        a = {};
      a[t] = e(n), r(r.S + r.F * o(function () {
        n(1);
      }), "Object", a);
    };
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(17), n(6)], void 0 !== (i = function (t, e, n) {
      var r = t._,
        i = ["OAuthError", "AuthSdkError", "AuthPollStopError", "AuthApiError"];
      return t.Model.extend({
        doTransaction: function doTransaction(t, e) {
          var o = this;
          return t.call(this, this.appState.get("transaction")).then(function (t) {
            return o.trigger("setTransaction", t), t;
          }).fail(function (t) {
            if ("AuthPollStopError" !== t.name && t.name !== n.AUTH_STOP_POLL_INITIATION_ERROR && t.name !== n.WEBAUTHN_ABORT_ERROR && (o.trigger("error", o, t.xhr), o.trigger("setTransactionError", t), e || -1 === r.indexOf(i, t.name))) throw t;
          });
        },
        manageTransaction: function manageTransaction(t) {
          var i = this,
            o = t.call(this, this.appState.get("transaction"), r.bind(this.setTransaction, this));
          return e.isPromiseAlike(o) ? o.fail(function (t) {
            "AuthPollStopError" !== t.name && t.name !== n.AUTH_STOP_POLL_INITIATION_ERROR && t.name !== n.WEBAUTHN_ABORT_ERROR && (i.trigger("error", i, t.xhr), i.trigger("setTransactionError", t));
          }) : e.resolve(o);
        },
        startTransaction: function startTransaction(t) {
          var n = this,
            r = t.call(this, this.settings.getAuthClient());
          return e.isPromiseAlike(r) ? r.then(function (t) {
            return n.trigger("setTransaction", t), t;
          }).fail(function (t) {
            throw n.trigger("error", n, t.xhr), n.trigger("setTransactionError", t), t;
          }) : e.resolve(r);
        },
        setTransaction: function setTransaction(t) {
          this.appState.set("transaction", t);
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r,
      i,
      o = n(576),
      a = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(o);
    r = [n(0), n(17), n(179)], void 0 !== (i = function (t, e, n) {
      function r(t) {
        return new e(t);
      }
      function i(t, e, n) {
        return e = e.map(function (t) {
          return {
            type: "FIDO_2_0",
            algorithm: t.algorithm
          };
        }), r(window.msCredentials.makeCredential(t, e, n).then(function (t) {
          return (0, a.default)({
            credential: {
              id: t.id
            },
            publicKey: JSON.parse(t.publicKey),
            attestation: t.attestation
          });
        }));
      }
      function o(t, e) {
        var n = e.map(function (t) {
            return {
              type: "FIDO_2_0",
              id: t.id
            };
          }),
          i = {
            accept: n
          };
        return r(window.msCredentials.getAssertion(t, i).then(function (t) {
          var e = t.signature;
          return (0, a.default)({
            credential: {
              id: t.id
            },
            clientData: e.clientData,
            authenticatorData: e.authnrData,
            signature: e.signature
          });
        }));
      }
      return {
        makeCredential: i,
        getAssertion: o,
        isAvailable: function isAvailable() {
          return window.hasOwnProperty("msCredentials");
        },
        isNewApiAvailable: function isNewApiAvailable() {
          return navigator && navigator.credentials && navigator.credentials.create;
        },
        isWebauthnOrU2fAvailable: function isWebauthnOrU2fAvailable() {
          return this.isNewApiAvailable() || n.isU2fAvailable();
        }
      };
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      var e = {};
      return e.validateUsername = function (e) {
        var n = e.get("username");
        if (n && n.length > 256) return {
          username: t.loc("model.validation.field.username", "login")
        };
      }, e.validateFieldsMatch = function (t, e, n, r) {
        if (t.get(e) !== t.get(n)) {
          var i = {};
          return i[n] = r, i;
        }
      }, e.validatePasswordMatch = function (n) {
        return e.validateFieldsMatch(n, "newPassword", "confirmPassword", t.loc("password.error.match", "login"));
      }, e;
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(40),
      o = r(i),
      a = n(266),
      s = r(a),
      u = n(663),
      c = r(u);
    e.default = o.default.extend({
      Header: s.default.extend({
        HeaderBeacon: c.default
      })
    });
  }, function (t, e) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == typeof window && (n = window);
    }
    t.exports = n;
  }, function (t, e, n) {
    var r = n(30),
      i = n(11),
      o = n(63);
    t.exports = function (t) {
      return function (e, n, a) {
        var s,
          u = r(e),
          c = i(u.length),
          l = o(a, c);
        if (t && n != n) {
          for (; c > l;) if ((s = u[l++]) != s) return !0;
        } else for (; c > l; l++) if ((t || l in u) && u[l] === n) return t || l || 0;
        return !t && -1;
      };
    };
  }, function (t, e) {
    e.f = Object.getOwnPropertySymbols;
  }, function (t, e, n) {
    var r = n(36);
    t.exports = Array.isArray || function (t) {
      return "Array" == r(t);
    };
  }, function (t, e, n) {
    var r = n(37),
      i = n(42);
    t.exports = function (t) {
      return function (e, n) {
        var o,
          a,
          s = String(i(e)),
          u = r(n),
          c = s.length;
        return u < 0 || u >= c ? t ? "" : void 0 : (o = s.charCodeAt(u), o < 55296 || o > 56319 || u + 1 === c || (a = s.charCodeAt(u + 1)) < 56320 || a > 57343 ? t ? s.charAt(u) : o : t ? s.slice(u, u + 2) : a - 56320 + (o - 55296 << 10) + 65536);
      };
    };
  }, function (t, e, n) {
    var r = n(8),
      i = n(36),
      o = n(10)("match");
    t.exports = function (t) {
      var e;
      return r(t) && (void 0 !== (e = t[o]) ? !!e : "RegExp" == i(t));
    };
  }, function (t, e, n) {
    var r = n(10)("iterator"),
      i = !1;
    try {
      var o = [7][r]();
      o.return = function () {
        i = !0;
      }, Array.from(o, function () {
        throw 2;
      });
    } catch (t) {}
    t.exports = function (t, e) {
      if (!e && !i) return !1;
      var n = !1;
      try {
        var o = [7],
          a = o[r]();
        a.next = function () {
          return {
            done: n = !0
          };
        }, o[r] = function () {
          return a;
        }, t(o);
      } catch (t) {}
      return n;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(74),
      i = RegExp.prototype.exec;
    t.exports = function (t, e) {
      var n = t.exec;
      if ("function" == typeof n) {
        var o = n.call(t, e);
        if ("object" != typeof o) throw new TypeError("RegExp exec method returned something other than an Object or null");
        return o;
      }
      if ("RegExp" !== r(t)) throw new TypeError("RegExp#exec called on incompatible receiver");
      return i.call(t, e);
    };
  }, function (t, e, n) {
    "use strict";

    n(202);
    var r = n(26),
      i = n(25),
      o = n(7),
      a = n(42),
      s = n(10),
      u = n(145),
      c = s("species"),
      l = !o(function () {
        var t = /./;
        return t.exec = function () {
          var t = [];
          return t.groups = {
            a: "7"
          }, t;
        }, "7" !== "".replace(t, "$<a>");
      }),
      f = function () {
        var t = /(?:)/,
          e = t.exec;
        t.exec = function () {
          return e.apply(this, arguments);
        };
        var n = "ab".split(t);
        return 2 === n.length && "a" === n[0] && "b" === n[1];
      }();
    t.exports = function (t, e, n) {
      var p = s(t),
        d = !o(function () {
          var e = {};
          return e[p] = function () {
            return 7;
          }, 7 != ""[t](e);
        }),
        h = d ? !o(function () {
          var e = !1,
            n = /a/;
          return n.exec = function () {
            return e = !0, null;
          }, "split" === t && (n.constructor = {}, n.constructor[c] = function () {
            return n;
          }), n[p](""), !e;
        }) : void 0;
      if (!d || !h || "replace" === t && !l || "split" === t && !f) {
        var m = /./[p],
          g = n(a, p, ""[t], function (t, e, n, r, i) {
            return e.exec === u ? d && !i ? {
              done: !0,
              value: m.call(e, n, r)
            } : {
              done: !0,
              value: t.call(n, e, r)
            } : {
              done: !1
            };
          }),
          v = g[0],
          y = g[1];
        r(String.prototype, t, v), i(RegExp.prototype, p, 2 == e ? function (t, e) {
          return y.call(t, this, e);
        } : function (t) {
          return y.call(t, this);
        });
      }
    };
  }, function (t, e, n) {
    var r = n(5),
      i = r.navigator;
    t.exports = i && i.userAgent || "";
  }, function (t, e, n) {
    "use strict";

    var r = n(5),
      i = n(1),
      o = n(26),
      a = n(69),
      s = n(54),
      u = n(68),
      c = n(67),
      l = n(8),
      f = n(7),
      p = n(106),
      d = n(73),
      h = n(131);
    t.exports = function (t, e, n, m, g, v) {
      var y = r[t],
        _ = y,
        b = g ? "set" : "add",
        w = _ && _.prototype,
        S = {},
        x = function x(t) {
          var e = w[t];
          o(w, t, "delete" == t ? function (t) {
            return !(v && !l(t)) && e.call(this, 0 === t ? 0 : t);
          } : "has" == t ? function (t) {
            return !(v && !l(t)) && e.call(this, 0 === t ? 0 : t);
          } : "get" == t ? function (t) {
            return v && !l(t) ? void 0 : e.call(this, 0 === t ? 0 : t);
          } : "add" == t ? function (t) {
            return e.call(this, 0 === t ? 0 : t), this;
          } : function (t, n) {
            return e.call(this, 0 === t ? 0 : t, n), this;
          });
        };
      if ("function" == typeof _ && (v || w.forEach && !f(function () {
        new _().entries().next();
      }))) {
        var E = new _(),
          T = E[b](v ? {} : -0, 1) != E,
          k = f(function () {
            E.has(1);
          }),
          A = p(function (t) {
            new _(t);
          }),
          O = !v && f(function () {
            for (var t = new _(), e = 5; e--;) t[b](e, e);
            return !t.has(-0);
          });
        A || (_ = e(function (e, n) {
          c(e, _, t);
          var r = h(new y(), e, _);
          return void 0 != n && u(n, g, r[b], r), r;
        }), _.prototype = w, w.constructor = _), (k || O) && (x("delete"), x("has"), g && x("get")), (O || T) && x(b), v && w.clear && delete w.clear;
      } else _ = m.getConstructor(e, t, g, b), a(_.prototype, n), s.NEED = !0;
      return d(_, t), S[t] = _, i(i.G + i.W + i.F * (_ != y), S), v || m.setStrong(_, t, g), _;
    };
  }, function (t, e, n) {
    for (var r, i = n(5), o = n(25), a = n(61), s = a("typed_array"), u = a("view"), c = !(!i.ArrayBuffer || !i.DataView), l = c, f = 0, p = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); f < 9;) (r = i[p[f++]]) ? (o(r.prototype, s, !0), o(r.prototype, u, !0)) : l = !1;
    t.exports = {
      ABV: c,
      CONSTR: l,
      TYPED: s,
      VIEW: u
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = n(53) || !n(7)(function () {
      var t = Math.random();
      __defineSetter__.call(null, t, function () {}), delete n(5)[t];
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1);
    t.exports = function (t) {
      r(r.S, t, {
        of: function of() {
          for (var t = arguments.length, e = new Array(t); t--;) e[t] = arguments[t];
          return new this(e);
        }
      });
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(20),
      o = n(35),
      a = n(68);
    t.exports = function (t) {
      r(r.S, t, {
        from: function from(t) {
          var e,
            n,
            r,
            s,
            u = arguments[1];
          return i(this), e = void 0 !== u, e && i(u), void 0 == t ? new this() : (n = [], e ? (r = 0, s = o(u, arguments[2], 2), a(t, !1, function (t) {
            n.push(s(t, r++));
          })) : a(t, !1, n.push, n), new this(n));
        }
      });
    };
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    };
  }, function (t, e) {
    var n = 0,
      r = Math.random();
    t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
    };
  }, function (t, e, n) {
    var r = n(50).f,
      i = n(72),
      o = n(23)("toStringTag");
    t.exports = function (t, e, n) {
      t && !i(t = n ? t : t.prototype, o) && r(t, o, {
        configurable: !0,
        value: e
      });
    };
  }, function (t, e, n) {
    n(482);
    for (var r = n(22), i = n(71), o = n(80), a = n(23)("toStringTag"), s = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), u = 0; u < s.length; u++) {
      var c = s[u],
        l = r[c],
        f = l && l.prototype;
      f && !f[a] && i(f, a, c), o[c] = o.Array;
    }
  }, function (t, e, n) {
    e.f = n(23);
  }, function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    "use strict";

    var r,
      i,
      o = n(77),
      a = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(o);
    r = [n(120), n(151), n(233), n(17), n(494), n(495), n(57), n(152), n(58)], void 0 !== (i = function (t, e, n, r, i, o, s, u, c) {
      function l(t) {
        if (!t) return {};
        var n = {};
        return e.each(e.keys(t), function (e) {
          n[e.toLowerCase()] = t[e];
        }), e.mapObject(n, function (t) {
          var n = {
            login: {},
            country: {}
          };
          if (!e.isObject(t)) throw new Error('Invalid format for "i18n"');
          return e.each(t, function (t, e) {
            var r = e.split(/^country\./);
            r.length > 1 ? n.country[r[1]] = t : n.login[r[0]] = t;
          }), n;
        });
      }
      function f() {
        var t = JSON.parse(localStorage.getItem(m));
        return t && t.version === u.version || (t = {
          version: u.version
        }), t;
      }
      function p(t, e, n) {
        var r = f();
        r[t] = {
          login: e,
          country: n
        }, localStorage.setItem(m, (0, a.default)(r));
      }
      function d(e, n, r) {
        var i, o;
        return i = n.replace("-", "_"), o = r.rewrite(g({
          bundle: e,
          languageCode: i
        })), t.ajax({
          url: r.baseUrl + o,
          dataType: "jsonp",
          cache: !0,
          timeout: 5e3,
          jsonpCallback: "jsonp_" + e
        });
      }
      function h(t, n) {
        if ("en" === t || !e.contains(u.supportedLanguages, t)) return r({});
        var i = !c.localStorageIsNotSupported();
        if (i) {
          var o = f();
          if (o[t]) return r(o[t]);
        }
        return r.all([d("login", t, n), d("country", t, n)]).spread(function (e, n) {
          return i && p(t, e, n), {
            login: e,
            country: n
          };
        }).fail(function () {
          return {};
        });
      }
      var m = "osw.languages",
        g = n.compile("/labels/jsonp/{{bundle}}_{{languageCode}}.jsonp");
      return {
        login: i,
        country: o,
        courage: i,
        currentLanguage: null,
        isLoaded: function isLoaded(t) {
          return this.currentLanguage === t;
        },
        remove: function remove() {
          this.currentLanguage = null;
        },
        loadLanguage: function loadLanguage(t, n, r) {
          var a = l(n),
            s = t.toLowerCase();
          return h(t, r).then(e.bind(function (n) {
            this.login = e.extend({}, i, n.login), this.country = e.extend({}, o, n.country), this.courage = e.extend({}, i, n.login), a[s] && (e.extend(this.login, a[s].login), e.extend(this.country, a[s].country), e.extend(this.courage, a[s].login)), this.currentLanguage = t;
          }, this));
        }
      };
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(17), n(18), n(13), n(33), n(96)], void 0 !== (i = function (t, e, n, r, i, o) {
      var a = t._,
        s = o.extend({
          extraProperties: !0,
          flat: !1,
          props: {
            id: "string",
            factorType: {
              type: "string",
              values: ["sms", "call", "email", "token", "token:software:totp", "token:hotp", "token:hardware", "question", "push", "u2f", "password", "assertion:saml2", "assertion:oidc", "claims_provider", "webauthn"]
            },
            provider: {
              type: "string",
              values: ["OKTA", "RSA", "DEL_OATH", "SYMANTEC", "GOOGLE", "YUBICO", "FIDO", "CUSTOM", "GENERIC_SAML", "GENERIC_OIDC"]
            },
            enrollment: {
              type: "string",
              values: ["OPTIONAL", "REQUIRED"]
            },
            status: {
              type: "string",
              values: ["NOT_SETUP", "ACTIVE"]
            },
            profile: ["object"],
            vendorName: "string",
            policy: ["object"],
            profiles: ["object"]
          },
          local: {
            answer: "string",
            password: "string",
            backupFactor: "object",
            showAnswer: "boolean",
            rememberDevice: "boolean",
            autoPush: ["boolean", !0, !1]
          },
          derived: {
            isOktaFactor: {
              deps: ["provider"],
              fn: function fn(t) {
                return "OKTA" === t;
              }
            },
            factorName: {
              deps: ["provider", "factorType"],
              fn: n.getFactorName
            },
            factorLabel: {
              deps: ["provider", "factorType", "vendorName"],
              fn: function fn(t, e, r) {
                return a.contains(["DEL_OATH", "GENERIC_SAML", "GENERIC_OIDC", "CUSTOM"], t) ? r : n.getFactorLabel.apply(this, [t, e]);
              }
            },
            factorDescription: {
              deps: ["provider", "factorType"],
              fn: n.getFactorDescription
            },
            sortOrder: {
              deps: ["provider", "factorType"],
              fn: n.getFactorSortOrder
            },
            iconClassName: {
              deps: ["provider", "factorType"],
              fn: n.getFactorIconClassName
            },
            securityQuestion: {
              deps: ["profile", "factorType"],
              fn: function fn(t, e) {
                return "question" !== e ? null : t && n.getSecurityQuestionLabel(t);
              }
            },
            phoneNumber: {
              deps: ["profile", "factorType"],
              fn: function fn(t, e) {
                return a.contains(["sms", "call"], e) ? t && t.phoneNumber : null;
              }
            },
            email: {
              deps: ["profile", "factorType"],
              fn: function fn(t, e) {
                return "email" === e ? t && t.email : null;
              }
            },
            deviceName: {
              deps: ["profile", "factorType"],
              fn: function fn(t, e) {
                return "push" !== e ? null : t && t.name;
              }
            },
            enrolled: {
              deps: ["status"],
              fn: function fn(t) {
                return "ACTIVE" === t;
              }
            },
            cardinality: {
              deps: ["policy", "profiles"],
              fn: function fn(t, e) {
                if (e && e.length > 0) {
                  var n = e[0],
                    r = n._embedded.enrolledFactors.length,
                    i = a.findWhere(n._embedded.features, {
                      type: "adoption"
                    });
                  return !(!i || !i.cardinality) && {
                    enrolled: r,
                    minimum: i.cardinality.min,
                    maximum: i.cardinality.max
                  };
                }
                return !(!t || !t.enrollment) && t.enrollment;
              }
            },
            additionalEnrollment: {
              deps: ["cardinality"],
              fn: function fn(t) {
                return !!t && 0 !== t.enrolled && t.enrolled < t.maximum;
              }
            },
            required: {
              deps: ["enrollment"],
              fn: function fn(t) {
                return "REQUIRED" === t;
              }
            },
            canUseResend: {
              deps: ["provider", "factorType"],
              fn: function fn(t, e) {
                return "OKTA" === t && a.contains(["push", "sms", "call", "email"], e);
              }
            },
            isAnswerRequired: {
              deps: ["factorType"],
              fn: function fn(t) {
                return a.contains(["sms", "call", "email", "token", "token:software:totp", "question"], t);
              }
            },
            isFactorTypeVerification: {
              deps: ["provider", "id"],
              fn: function fn(t, e) {
                return void 0 === t && void 0 === e;
              }
            }
          },
          parse: function parse(t) {
            return this.settings = t.settings, this.appState = t.appState, t.rememberDevice = n.getRememberDeviceValue(this.appState), this.setCustomHotpVendorName(t), a.omit(t, ["settings", "appState"]);
          },
          validate: function validate() {
            return this.get("isAnswerRequired") && !this.get("answer") ? {
              answer: t.loc("model.validation.field.blank")
            } : "password" !== this.get("factorType") || this.get("password") ? void 0 : {
              password: t.loc("error.password.required")
            };
          },
          needsPasscode: function needsPasscode() {
            return !(this.options.appState.get("isIdxStateToken") && "email" === this.get("factorType"));
          },
          resend: function resend() {
            return this.trigger("form:clear-errors"), this.manageTransaction(function (t) {
              var e = t.data._links.resend[0];
              return t.resend(e.name);
            });
          },
          save: function save() {
            var t = !!this.get("rememberDevice"),
              n = this;
            return this.manageTransaction(function (o, a) {
              var s = {
                rememberDevice: t
              };
              "question" === this.get("factorType") ? s.answer = this.get("answer") : "password" === this.get("factorType") ? s.password = this.get("password") : this.needsPasscode() && (s.passCode = this.get("answer")), this.pushFactorHasAutoPush() && (s.autoPush = this.get("autoPush"));
              var u;
              if ("MFA_REQUIRED" === o.status || "FACTOR_REQUIRED" === o.status || this.appState.get("promptForFactorInUnauthenticated")) {
                u = this._findFactor(o).verify(s);
              } else if (this.get("canUseResend") && !this.get("answer") && o.resend) {
                var c = o.data._links.resend[0];
                u = o.resend(c.name);
              } else u = o.verify(s);
              return this.trigger("save"), u.then(function (t) {
                var o = {
                  delay: 4e3,
                  transactionCallBack: function transactionCallBack(t) {
                    n.options.appState.set("lastAuthResponse", t);
                  }
                };
                if (a(t), "MFA_CHALLENGE" === t.status && t.poll || "FACTOR_CHALLENGE" === t.status && t.poll) {
                  var s = e.defer(),
                    u = r.callAfterTimeout(s.resolve, 4e3);
                  return n.listenToOnce(n.options.appState, "factorSwitched", function () {
                    clearTimeout(u), s.reject(new i.AuthStopPollInitiationError());
                  }), s.promise.then(function () {
                    return n.stopListening(n.options.appState, "factorSwitched"), n.pushFactorHasAutoPush() && (o.autoPush = function () {
                      return n.get("autoPush");
                    }, o.rememberDevice = function () {
                      return n.get("rememberDevice");
                    }), t.poll(o).then(function (t) {
                      n.options.appState.set("lastAuthResponse", t.data), a(t);
                    });
                  });
                }
              });
            });
          },
          _findFactor: function _findFactor(t) {
            var e;
            return t.factorTypes && (e = a.findWhere(t.factorTypes, {
              factorType: this.get("factorType")
            })), e || (e = a.findWhere(t.factors, {
              id: this.get("id")
            })), e;
          },
          pushFactorHasAutoPush: function pushFactorHasAutoPush() {
            return this.settings.get("features.autoPush") && "push" === this.get("factorType");
          },
          setCustomHotpVendorName: function setCustomHotpVendorName(t) {
            if ("token:hotp" === t.factorType && t.profiles) if ("NOT_SETUP" === t.status) t.vendorName = t.profiles[0].name;else if ("ACTIVE" === t.status) {
              var e = t.profiles.filter(function (t) {
                return t._embedded.enrolledFactors.length > 0;
              });
              t.vendorName = e[0].name;
            }
            return t;
          }
        }),
        u = t.Collection.extend({
          model: s,
          comparator: "sortOrder",
          parse: function parse(t) {
            this.lastUsedFactor = t[0];
            var e,
              n = a.findWhere(t, {
                provider: "OKTA",
                factorType: "push"
              });
            if (e = a.where(t, {
              factorType: "push"
            }).length > 1 ? a.findWhere(t, {
              factorType: "token:software:totp"
            }) : a.findWhere(t, {
              provider: "OKTA",
              factorType: "token:software:totp"
            }), !n || !e) return t;
            var r = e === t[0],
              i = a.reduce(t, function (t, r) {
                var i = "OKTA" === r.provider,
                  o = i && "token:software:totp" === r.factorType,
                  a = i && "push" === r.factorType,
                  u = "ACTIVE" !== r.status,
                  c = o && (u || "ACTIVE" === n.status),
                  l = a && u && "ACTIVE" === e.status;
                return c || l ? t : (a && (r.backupFactor = new s(e, {
                  parse: !0
                })), t.push(r), t);
              }, []);
            return r && (this.lastUsedFactor = n), i;
          },
          getDefaultFactor: function getDefaultFactor() {
            var t = a.pick(this.lastUsedFactor, "factorType", "provider");
            return this.findWhere(t);
          },
          getFirstUnenrolledRequiredFactor: function getFirstUnenrolledRequiredFactor() {
            return this.findWhere({
              required: !0,
              enrolled: !1
            });
          },
          _getFactorsOfType: function _getFactorsOfType(t) {
            return this.where({
              factorType: t
            });
          },
          getFactorIndex: function getFactorIndex(t, e) {
            return this._getFactorsOfType(t).findIndex(function (t) {
              return t.get("id") === e;
            });
          },
          hasMultipleFactorsOfSameType: function hasMultipleFactorsOfSameType(t) {
            return this._getFactorsOfType(t).length > 1;
          },
          getFactorByTypeAndIndex: function getFactorByTypeAndIndex(t, e) {
            return this._getFactorsOfType(t)[e];
          }
        });
      return {
        Model: s,
        Collection: u
      };
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(17), n(6)], void 0 !== (i = function (t, e) {
      function n(e, n, r) {
        var i = t.defer();
        return e.animate({
          "text-indent": 1
        }, {
          duration: 200,
          easing: "swing",
          step: function step(t, i) {
            i.start = n, i.end = r, e.css("transform", "scale(" + t + ", " + t + ")");
          },
          always: function always() {
            i.resolve(e);
          }
        }), i.promise;
      }
      function r(e, n, r) {
        var i = t.defer();
        return e.animate({
          "text-indent": 1
        }, {
          duration: 150,
          easing: "swing",
          step: function step(t, i) {
            i.start = n, i.end = r, e.css("transform", "rotate(" + t + "deg)");
          },
          always: function always() {
            i.resolve(e);
          }
        }), i.promise;
      }
      var i = {};
      return i.swapPages = function (n) {
        var r = t.defer(),
          i = n.$parent,
          o = n.$oldRoot,
          a = n.$newRoot,
          s = n.success,
          u = n.ctx,
          c = "transition-from-right";
        return n.dir && n.dir === e.DIRECTION_BACK && (c = "transition-from-left"), a.addClass(c), i.append(a), i.addClass("animation-container-overflow"), a.animate({
          left: "0px",
          top: "0px",
          opacity: 1
        }, 200, function () {
          i.removeClass("animation-container-overflow"), a.removeClass(c), a.removeAttr("style"), s.call(u), r.resolve();
        }), o.animate({
          height: a.height(),
          opacity: 0
        }, 160), r.promise;
      }, i.swapBeacons = function (t) {
        var e = t.$el,
          n = t.swap,
          r = t.ctx;
        return this.implode(e).then(function () {
          return n.call(r), e;
        }).then(this.explode);
      }, i.explode = function (t) {
        return n(t, 0, 1);
      }, i.implode = function (t) {
        return n(t, 1, 0);
      }, i.radialProgressBar = function (t) {
        var e = t.$el,
          n = t.swap,
          i = e.children();
        return r(i, 0, 180).then(function () {
          e.css({
            clip: "auto"
          });
        }).then(function () {
          var t = i.eq(0);
          return n(), r(t, 180, 360);
        }).then(function () {
          e.css({
            clip: "rect(0px, 96px, 96px, 48px)"
          }), i.css({
            transform: "rotate(0deg)",
            "text-indent": "1px"
          });
        });
      }, i;
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    var r = n(8),
      i = n(5).document,
      o = r(i) && r(i.createElement);
    t.exports = function (t) {
      return o ? i.createElement(t) : {};
    };
  }, function (t, e, n) {
    var r = n(5),
      i = n(34),
      o = n(53),
      a = n(184),
      s = n(15).f;
    t.exports = function (t) {
      var e = i.Symbol || (i.Symbol = o ? {} : r.Symbol || {});
      "_" == t.charAt(0) || t in e || s(e, t, {
        value: a.f(t)
      });
    };
  }, function (t, e, n) {
    var r = n(84)("keys"),
      i = n(61);
    t.exports = function (t) {
      return r[t] || (r[t] = i(t));
    };
  }, function (t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, e, n) {
    var r = n(5).document;
    t.exports = r && r.documentElement;
  }, function (t, e, n) {
    var r = n(8),
      i = n(3),
      o = function o(t, e) {
        if (i(t), !r(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
      };
    t.exports = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, r) {
        try {
          r = n(35)(Function.call, n(31).f(Object.prototype, "__proto__").set, 2), r(t, []), e = !(t instanceof Array);
        } catch (t) {
          e = !0;
        }
        return function (t, n) {
          return o(t, n), e ? t.__proto__ = n : r(t, n), t;
        };
      }({}, !1) : void 0),
      check: o
    };
  }, function (t, e) {
    t.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  }, function (t, e, n) {
    var r = n(8),
      i = n(129).set;
    t.exports = function (t, e, n) {
      var o,
        a = e.constructor;
      return a !== n && "function" == typeof a && (o = a.prototype) !== n.prototype && r(o) && i && i(t, o), t;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(37),
      i = n(42);
    t.exports = function (t) {
      var e = String(i(this)),
        n = "",
        o = r(t);
      if (o < 0 || o == 1 / 0) throw RangeError("Count can't be negative");
      for (; o > 0; (o >>>= 1) && (e += e)) 1 & o && (n += e);
      return n;
    };
  }, function (t, e) {
    t.exports = Math.sign || function (t) {
      return 0 == (t = +t) || t != t ? t : t < 0 ? -1 : 1;
    };
  }, function (t, e) {
    var n = Math.expm1;
    t.exports = !n || n(10) > 22025.465794806718 || n(10) < 22025.465794806718 || -2e-17 != n(-2e-17) ? function (t) {
      return 0 == (t = +t) ? t : t > -1e-6 && t < 1e-6 ? t + t * t / 2 : Math.exp(t) - 1;
    } : n;
  }, function (t, e, n) {
    "use strict";

    var r = n(53),
      i = n(1),
      o = n(26),
      a = n(25),
      s = n(76),
      u = n(136),
      c = n(73),
      l = n(32),
      f = n(10)("iterator"),
      p = !([].keys && "next" in [].keys()),
      d = function d() {
        return this;
      };
    t.exports = function (t, e, n, h, m, g, v) {
      u(n, e, h);
      var y,
        _,
        b,
        w = function w(t) {
          if (!p && t in T) return T[t];
          switch (t) {
            case "keys":
            case "values":
              return function () {
                return new n(this, t);
              };
          }
          return function () {
            return new n(this, t);
          };
        },
        S = e + " Iterator",
        x = "values" == m,
        E = !1,
        T = t.prototype,
        k = T[f] || T["@@iterator"] || m && T[m],
        A = k || w(m),
        O = m ? x ? w("entries") : A : void 0,
        C = "Array" == e ? T.entries || k : k;
      if (C && (b = l(C.call(new t()))) !== Object.prototype && b.next && (c(b, S, !0), r || "function" == typeof b[f] || a(b, f, d)), x && k && "values" !== k.name && (E = !0, A = function A() {
        return k.call(this);
      }), r && !v || !p && !E && T[f] || a(T, f, A), s[e] = A, s[S] = d, m) if (y = {
        values: x ? A : w("values"),
        keys: g ? A : w("keys"),
        entries: O
      }, v) for (_ in y) _ in T || o(T, _, y[_]);else i(i.P + i.F * (p || E), e, y);
      return y;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(64),
      i = n(60),
      o = n(73),
      a = {};
    n(25)(a, n(10)("iterator"), function () {
      return this;
    }), t.exports = function (t, e, n) {
      t.prototype = r(a, {
        next: i(1, n)
      }), o(t, e + " Iterator");
    };
  }, function (t, e, n) {
    var r = n(105),
      i = n(42);
    t.exports = function (t, e, n) {
      if (r(e)) throw TypeError("String#" + n + " doesn't accept regex!");
      return String(i(t));
    };
  }, function (t, e, n) {
    var r = n(10)("match");
    t.exports = function (t) {
      var e = /./;
      try {
        "/./"[t](e);
      } catch (n) {
        try {
          return e[r] = !1, !"/./"[t](e);
        } catch (t) {}
      }
      return !0;
    };
  }, function (t, e, n) {
    var r = n(76),
      i = n(10)("iterator"),
      o = Array.prototype;
    t.exports = function (t) {
      return void 0 !== t && (r.Array === t || o[i] === t);
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(15),
      i = n(60);
    t.exports = function (t, e, n) {
      e in t ? r.f(t, e, i(0, n)) : t[e] = n;
    };
  }, function (t, e, n) {
    var r = n(74),
      i = n(10)("iterator"),
      o = n(76);
    t.exports = n(34).getIteratorMethod = function (t) {
      if (void 0 != t) return t[i] || t["@@iterator"] || o[r(t)];
    };
  }, function (t, e, n) {
    var r = n(365);
    t.exports = function (t, e) {
      return new (r(t))(e);
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(16),
      i = n(63),
      o = n(11);
    t.exports = function (t) {
      for (var e = r(this), n = o(e.length), a = arguments.length, s = i(a > 1 ? arguments[1] : void 0, n), u = a > 2 ? arguments[2] : void 0, c = void 0 === u ? n : i(u, n); c > s;) e[s++] = t;
      return e;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(55),
      i = n(201),
      o = n(76),
      a = n(30);
    t.exports = n(135)(Array, "Array", function (t, e) {
      this._t = a(t), this._i = 0, this._k = e;
    }, function () {
      var t = this._t,
        e = this._k,
        n = this._i++;
      return !t || n >= t.length ? (this._t = void 0, i(1)) : "keys" == e ? i(0, n) : "values" == e ? i(0, t[n]) : i(0, [n, t[n]]);
    }, "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries");
  }, function (t, e, n) {
    "use strict";

    var r = n(87),
      i = RegExp.prototype.exec,
      o = String.prototype.replace,
      a = i,
      s = function () {
        var t = /a/,
          e = /b*/g;
        return i.call(t, "a"), i.call(e, "a"), 0 !== t.lastIndex || 0 !== e.lastIndex;
      }(),
      u = void 0 !== /()??/.exec("")[1];
    (s || u) && (a = function a(t) {
      var e,
        n,
        a,
        c,
        l = this;
      return u && (n = new RegExp("^" + l.source + "$(?!\\s)", r.call(l))), s && (e = l.lastIndex), a = i.call(l, t), s && a && (l.lastIndex = l.global ? a.index + a[0].length : e), u && a && a.length > 1 && o.call(a[0], n, function () {
        for (c = 1; c < arguments.length - 2; c++) void 0 === arguments[c] && (a[c] = void 0);
      }), a;
    }), t.exports = a;
  }, function (t, e, n) {
    "use strict";

    var r = n(104)(!0);
    t.exports = function (t, e, n) {
      return e + (n ? r(t, e).length : 1);
    };
  }, function (t, e, n) {
    var r,
      i,
      o,
      a = n(35),
      s = n(191),
      u = n(128),
      c = n(124),
      l = n(5),
      f = l.process,
      p = l.setImmediate,
      d = l.clearImmediate,
      h = l.MessageChannel,
      m = l.Dispatch,
      g = 0,
      v = {},
      y = function y() {
        var t = +this;
        if (v.hasOwnProperty(t)) {
          var e = v[t];
          delete v[t], e();
        }
      },
      _ = function _(t) {
        y.call(t.data);
      };
    p && d || (p = function p(t) {
      for (var e = [], n = 1; arguments.length > n;) e.push(arguments[n++]);
      return v[++g] = function () {
        s("function" == typeof t ? t : Function(t), e);
      }, r(g), g;
    }, d = function d(t) {
      delete v[t];
    }, "process" == n(36)(f) ? r = function r(t) {
      f.nextTick(a(y, t, 1));
    } : m && m.now ? r = function r(t) {
      m.now(a(y, t, 1));
    } : h ? (i = new h(), o = i.port2, i.port1.onmessage = _, r = a(o.postMessage, o, 1)) : l.addEventListener && "function" == typeof postMessage && !l.importScripts ? (r = function r(t) {
      l.postMessage(t + "", "*");
    }, l.addEventListener("message", _, !1)) : r = "onreadystatechange" in c("script") ? function (t) {
      u.appendChild(c("script")).onreadystatechange = function () {
        u.removeChild(this), y.call(t);
      };
    } : function (t) {
      setTimeout(a(y, t, 1), 0);
    }), t.exports = {
      set: p,
      clear: d
    };
  }, function (t, e, n) {
    var r = n(5),
      i = n(147).set,
      o = r.MutationObserver || r.WebKitMutationObserver,
      a = r.process,
      s = r.Promise,
      u = "process" == n(36)(a);
    t.exports = function () {
      var t,
        e,
        n,
        c = function c() {
          var r, i;
          for (u && (r = a.domain) && r.exit(); t;) {
            i = t.fn, t = t.next;
            try {
              i();
            } catch (r) {
              throw t ? n() : e = void 0, r;
            }
          }
          e = void 0, r && r.enter();
        };
      if (u) n = function n() {
        a.nextTick(c);
      };else if (!o || r.navigator && r.navigator.standalone) {
        if (s && s.resolve) {
          var l = s.resolve(void 0);
          n = function n() {
            l.then(c);
          };
        } else n = function n() {
          i.call(r, c);
        };
      } else {
        var f = !0,
          p = document.createTextNode("");
        new o(c).observe(p, {
          characterData: !0
        }), n = function n() {
          p.data = f = !f;
        };
      }
      return function (r) {
        var i = {
          fn: r,
          next: void 0
        };
        e && (e.next = i), t || (t = i, n()), e = i;
      };
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      var e, n;
      this.promise = new t(function (t, r) {
        if (void 0 !== e || void 0 !== n) throw TypeError("Bad Promise constructor");
        e = t, n = r;
      }), this.resolve = i(e), this.reject = i(n);
    }
    // 25.4.1.5 NewPromiseCapability(C)
    var i = n(20);
    t.exports.f = function (t) {
      return new r(t);
    };
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n) {
      var r,
        i,
        o,
        a = new Array(n),
        s = 8 * n - e - 1,
        u = (1 << s) - 1,
        c = u >> 1,
        l = 23 === e ? j(2, -24) - j(2, -77) : 0,
        f = 0,
        p = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
      for (t = D(t), t != t || t === L ? (i = t != t ? 1 : 0, r = u) : (r = U(B(t) / V), t * (o = j(2, -r)) < 1 && (r--, o *= 2), t += r + c >= 1 ? l / o : l * j(2, 1 - c), t * o >= 2 && (r++, o /= 2), r + c >= u ? (i = 0, r = u) : r + c >= 1 ? (i = (t * o - 1) * j(2, e), r += c) : (i = t * j(2, c - 1) * j(2, e), r = 0)); e >= 8; a[f++] = 255 & i, i /= 256, e -= 8);
      for (r = r << e | i, s += e; s > 0; a[f++] = 255 & r, r /= 256, s -= 8);
      return a[--f] |= 128 * p, a;
    }
    function i(t, e, n) {
      var r,
        i = 8 * n - e - 1,
        o = (1 << i) - 1,
        a = o >> 1,
        s = i - 7,
        u = n - 1,
        c = t[u--],
        l = 127 & c;
      for (c >>= 7; s > 0; l = 256 * l + t[u], u--, s -= 8);
      for (r = l & (1 << -s) - 1, l >>= -s, s += e; s > 0; r = 256 * r + t[u], u--, s -= 8);
      if (0 === l) l = 1 - a;else {
        if (l === o) return r ? NaN : c ? -L : L;
        r += j(2, e), l -= a;
      }
      return (c ? -1 : 1) * r * j(2, l - e);
    }
    function o(t) {
      return t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0];
    }
    function a(t) {
      return [255 & t];
    }
    function s(t) {
      return [255 & t, t >> 8 & 255];
    }
    function u(t) {
      return [255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255];
    }
    function c(t) {
      return r(t, 52, 8);
    }
    function l(t) {
      return r(t, 23, 4);
    }
    function f(t, e, n) {
      k(t[C], e, {
        get: function get() {
          return this[n];
        }
      });
    }
    function p(t, e, n, r) {
      var i = +n,
        o = E(i);
      if (o + e > t[H]) throw M(I);
      var a = t[q]._b,
        s = o + t[W],
        u = a.slice(s, s + e);
      return r ? u : u.reverse();
    }
    function d(t, e, n, r, i, o) {
      var a = +n,
        s = E(a);
      if (s + e > t[H]) throw M(I);
      for (var u = t[q]._b, c = s + t[W], l = r(+i), f = 0; f < e; f++) u[c + f] = l[o ? f : e - f - 1];
    }
    var h = n(5),
      m = n(12),
      g = n(53),
      v = n(111),
      y = n(25),
      _ = n(69),
      b = n(7),
      w = n(67),
      S = n(37),
      x = n(11),
      E = n(211),
      T = n(65).f,
      k = n(15).f,
      A = n(143),
      O = n(73),
      C = "prototype",
      I = "Wrong index!",
      _R2 = h.ArrayBuffer,
      _P = h.DataView,
      N = h.Math,
      M = h.RangeError,
      L = h.Infinity,
      F = _R2,
      D = N.abs,
      j = N.pow,
      U = N.floor,
      B = N.log,
      V = N.LN2,
      q = m ? "_b" : "buffer",
      H = m ? "_l" : "byteLength",
      W = m ? "_o" : "byteOffset";
    if (v.ABV) {
      if (!b(function () {
        _R2(1);
      }) || !b(function () {
        new _R2(-1);
      }) || b(function () {
        return new _R2(), new _R2(1.5), new _R2(NaN), "ArrayBuffer" != _R2.name;
      })) {
        _R2 = function R(t) {
          return w(this, _R2), new F(E(t));
        };
        for (var $, z = _R2[C] = F[C], G = T(F), K = 0; G.length > K;) ($ = G[K++]) in _R2 || y(_R2, $, F[$]);
        g || (z.constructor = _R2);
      }
      var Y = new _P(new _R2(2)),
        J = _P[C].setInt8;
      Y.setInt8(0, 2147483648), Y.setInt8(1, 2147483649), !Y.getInt8(0) && Y.getInt8(1) || _(_P[C], {
        setInt8: function setInt8(t, e) {
          J.call(this, t, e << 24 >> 24);
        },
        setUint8: function setUint8(t, e) {
          J.call(this, t, e << 24 >> 24);
        }
      }, !0);
    } else _R2 = function _R(t) {
      w(this, _R2, "ArrayBuffer");
      var e = E(t);
      this._b = A.call(new Array(e), 0), this[H] = e;
    }, _P = function P(t, e, n) {
      w(this, _P, "DataView"), w(t, _R2, "DataView");
      var r = t[H],
        i = S(e);
      if (i < 0 || i > r) throw M("Wrong offset!");
      if (n = void 0 === n ? r - i : x(n), i + n > r) throw M("Wrong length!");
      this[q] = t, this[W] = i, this[H] = n;
    }, m && (f(_R2, "byteLength", "_l"), f(_P, "buffer", "_b"), f(_P, "byteLength", "_l"), f(_P, "byteOffset", "_o")), _(_P[C], {
      getInt8: function getInt8(t) {
        return p(this, 1, t)[0] << 24 >> 24;
      },
      getUint8: function getUint8(t) {
        return p(this, 1, t)[0];
      },
      getInt16: function getInt16(t) {
        var e = p(this, 2, t, arguments[1]);
        return (e[1] << 8 | e[0]) << 16 >> 16;
      },
      getUint16: function getUint16(t) {
        var e = p(this, 2, t, arguments[1]);
        return e[1] << 8 | e[0];
      },
      getInt32: function getInt32(t) {
        return o(p(this, 4, t, arguments[1]));
      },
      getUint32: function getUint32(t) {
        return o(p(this, 4, t, arguments[1])) >>> 0;
      },
      getFloat32: function getFloat32(t) {
        return i(p(this, 4, t, arguments[1]), 23, 4);
      },
      getFloat64: function getFloat64(t) {
        return i(p(this, 8, t, arguments[1]), 52, 8);
      },
      setInt8: function setInt8(t, e) {
        d(this, 1, t, a, e);
      },
      setUint8: function setUint8(t, e) {
        d(this, 1, t, a, e);
      },
      setInt16: function setInt16(t, e) {
        d(this, 2, t, s, e, arguments[2]);
      },
      setUint16: function setUint16(t, e) {
        d(this, 2, t, s, e, arguments[2]);
      },
      setInt32: function setInt32(t, e) {
        d(this, 4, t, u, e, arguments[2]);
      },
      setUint32: function setUint32(t, e) {
        d(this, 4, t, u, e, arguments[2]);
      },
      setFloat32: function setFloat32(t, e) {
        d(this, 4, t, l, e, arguments[2]);
      },
      setFloat64: function setFloat64(t, e) {
        d(this, 8, t, c, e, arguments[2]);
      }
    });
    O(_R2, "ArrayBuffer"), O(_P, "DataView"), y(_P[C], v.VIEW, !0), e.ArrayBuffer = _R2, e.DataView = _P;
  }, function (t, e, n) {
    var r, i; //     Underscore.js 1.8.3
    //     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    //     Underscore may be freely distributed under the MIT license.
    (function () {
      function n(t) {
        function e(e, n, r, i, o, a) {
          for (; o >= 0 && o < a; o += t) {
            var s = i ? i[o] : o;
            r = n(r, e[s], s, e);
          }
          return r;
        }
        return function (n, r, i, o) {
          r = x(r, o, 4);
          var a = !I(n) && S.keys(n),
            s = (a || n).length,
            u = t > 0 ? 0 : s - 1;
          return arguments.length < 3 && (i = n[a ? a[u] : u], u += t), e(n, r, i, a, u, s);
        };
      }
      function o(t) {
        return function (e, n, r) {
          n = E(n, r);
          for (var i = C(e), o = t > 0 ? 0 : i - 1; o >= 0 && o < i; o += t) if (n(e[o], o, e)) return o;
          return -1;
        };
      }
      function a(t, e, n) {
        return function (r, i, o) {
          var a = 0,
            s = C(r);
          if ("number" == typeof o) t > 0 ? a = o >= 0 ? o : Math.max(o + s, a) : s = o >= 0 ? Math.min(o + 1, s) : o + s + 1;else if (n && o && s) return o = n(r, i), r[o] === i ? o : -1;
          if (i !== i) return o = e(h.call(r, a, s), S.isNaN), o >= 0 ? o + a : -1;
          for (o = t > 0 ? a : s - 1; o >= 0 && o < s; o += t) if (r[o] === i) return o;
          return -1;
        };
      }
      function s(t, e) {
        var n = L.length,
          r = t.constructor,
          i = S.isFunction(r) && r.prototype || f,
          o = "constructor";
        for (S.has(t, o) && !S.contains(e, o) && e.push(o); n--;) (o = L[n]) in t && t[o] !== i[o] && !S.contains(e, o) && e.push(o);
      }
      var u = this,
        c = u._,
        l = Array.prototype,
        f = Object.prototype,
        p = Function.prototype,
        d = l.push,
        h = l.slice,
        m = f.toString,
        g = f.hasOwnProperty,
        v = Array.isArray,
        y = Object.keys,
        _ = p.bind,
        b = Object.create,
        w = function w() {},
        S = function S(t) {
          return t instanceof S ? t : this instanceof S ? void (this._wrapped = t) : new S(t);
        };
      void 0 !== t && t.exports && (e = t.exports = S), e._ = S, S.VERSION = "1.8.3";
      var x = function x(t, e, n) {
          if (void 0 === e) return t;
          switch (null == n ? 3 : n) {
            case 1:
              return function (n) {
                return t.call(e, n);
              };
            case 2:
              return function (n, r) {
                return t.call(e, n, r);
              };
            case 3:
              return function (n, r, i) {
                return t.call(e, n, r, i);
              };
            case 4:
              return function (n, r, i, o) {
                return t.call(e, n, r, i, o);
              };
          }
          return function () {
            return t.apply(e, arguments);
          };
        },
        E = function E(t, e, n) {
          return null == t ? S.identity : S.isFunction(t) ? x(t, e, n) : S.isObject(t) ? S.matcher(t) : S.property(t);
        };
      S.iteratee = function (t, e) {
        return E(t, e, 1 / 0);
      };
      var T = function T(t, e) {
          return function (n) {
            var r = arguments.length;
            if (r < 2 || null == n) return n;
            for (var i = 1; i < r; i++) for (var o = arguments[i], a = t(o), s = a.length, u = 0; u < s; u++) {
              var c = a[u];
              e && void 0 !== n[c] || (n[c] = o[c]);
            }
            return n;
          };
        },
        k = function k(t) {
          if (!S.isObject(t)) return {};
          if (b) return b(t);
          w.prototype = t;
          var e = new w();
          return w.prototype = null, e;
        },
        A = function A(t) {
          return function (e) {
            return null == e ? void 0 : e[t];
          };
        },
        O = Math.pow(2, 53) - 1,
        C = A("length"),
        I = function I(t) {
          var e = C(t);
          return "number" == typeof e && e >= 0 && e <= O;
        };
      S.each = S.forEach = function (t, e, n) {
        e = x(e, n);
        var r, i;
        if (I(t)) for (r = 0, i = t.length; r < i; r++) e(t[r], r, t);else {
          var o = S.keys(t);
          for (r = 0, i = o.length; r < i; r++) e(t[o[r]], o[r], t);
        }
        return t;
      }, S.map = S.collect = function (t, e, n) {
        e = E(e, n);
        for (var r = !I(t) && S.keys(t), i = (r || t).length, o = Array(i), a = 0; a < i; a++) {
          var s = r ? r[a] : a;
          o[a] = e(t[s], s, t);
        }
        return o;
      }, S.reduce = S.foldl = S.inject = n(1), S.reduceRight = S.foldr = n(-1), S.find = S.detect = function (t, e, n) {
        var r;
        if (void 0 !== (r = I(t) ? S.findIndex(t, e, n) : S.findKey(t, e, n)) && -1 !== r) return t[r];
      }, S.filter = S.select = function (t, e, n) {
        var r = [];
        return e = E(e, n), S.each(t, function (t, n, i) {
          e(t, n, i) && r.push(t);
        }), r;
      }, S.reject = function (t, e, n) {
        return S.filter(t, S.negate(E(e)), n);
      }, S.every = S.all = function (t, e, n) {
        e = E(e, n);
        for (var r = !I(t) && S.keys(t), i = (r || t).length, o = 0; o < i; o++) {
          var a = r ? r[o] : o;
          if (!e(t[a], a, t)) return !1;
        }
        return !0;
      }, S.some = S.any = function (t, e, n) {
        e = E(e, n);
        for (var r = !I(t) && S.keys(t), i = (r || t).length, o = 0; o < i; o++) {
          var a = r ? r[o] : o;
          if (e(t[a], a, t)) return !0;
        }
        return !1;
      }, S.contains = S.includes = S.include = function (t, e, n, r) {
        return I(t) || (t = S.values(t)), ("number" != typeof n || r) && (n = 0), S.indexOf(t, e, n) >= 0;
      }, S.invoke = function (t, e) {
        var n = h.call(arguments, 2),
          r = S.isFunction(e);
        return S.map(t, function (t) {
          var i = r ? e : t[e];
          return null == i ? i : i.apply(t, n);
        });
      }, S.pluck = function (t, e) {
        return S.map(t, S.property(e));
      }, S.where = function (t, e) {
        return S.filter(t, S.matcher(e));
      }, S.findWhere = function (t, e) {
        return S.find(t, S.matcher(e));
      }, S.max = function (t, e, n) {
        var r,
          i,
          o = -1 / 0,
          a = -1 / 0;
        if (null == e && null != t) {
          t = I(t) ? t : S.values(t);
          for (var s = 0, u = t.length; s < u; s++) (r = t[s]) > o && (o = r);
        } else e = E(e, n), S.each(t, function (t, n, r) {
          ((i = e(t, n, r)) > a || i === -1 / 0 && o === -1 / 0) && (o = t, a = i);
        });
        return o;
      }, S.min = function (t, e, n) {
        var r,
          i,
          o = 1 / 0,
          a = 1 / 0;
        if (null == e && null != t) {
          t = I(t) ? t : S.values(t);
          for (var s = 0, u = t.length; s < u; s++) (r = t[s]) < o && (o = r);
        } else e = E(e, n), S.each(t, function (t, n, r) {
          ((i = e(t, n, r)) < a || i === 1 / 0 && o === 1 / 0) && (o = t, a = i);
        });
        return o;
      }, S.shuffle = function (t) {
        for (var e, n = I(t) ? t : S.values(t), r = n.length, i = Array(r), o = 0; o < r; o++) e = S.random(0, o), e !== o && (i[o] = i[e]), i[e] = n[o];
        return i;
      }, S.sample = function (t, e, n) {
        return null == e || n ? (I(t) || (t = S.values(t)), t[S.random(t.length - 1)]) : S.shuffle(t).slice(0, Math.max(0, e));
      }, S.sortBy = function (t, e, n) {
        return e = E(e, n), S.pluck(S.map(t, function (t, n, r) {
          return {
            value: t,
            index: n,
            criteria: e(t, n, r)
          };
        }).sort(function (t, e) {
          var n = t.criteria,
            r = e.criteria;
          if (n !== r) {
            if (n > r || void 0 === n) return 1;
            if (n < r || void 0 === r) return -1;
          }
          return t.index - e.index;
        }), "value");
      };
      var R = function R(t) {
        return function (e, n, r) {
          var i = {};
          return n = E(n, r), S.each(e, function (r, o) {
            var a = n(r, o, e);
            t(i, r, a);
          }), i;
        };
      };
      S.groupBy = R(function (t, e, n) {
        S.has(t, n) ? t[n].push(e) : t[n] = [e];
      }), S.indexBy = R(function (t, e, n) {
        t[n] = e;
      }), S.countBy = R(function (t, e, n) {
        S.has(t, n) ? t[n]++ : t[n] = 1;
      }), S.toArray = function (t) {
        return t ? S.isArray(t) ? h.call(t) : I(t) ? S.map(t, S.identity) : S.values(t) : [];
      }, S.size = function (t) {
        return null == t ? 0 : I(t) ? t.length : S.keys(t).length;
      }, S.partition = function (t, e, n) {
        e = E(e, n);
        var r = [],
          i = [];
        return S.each(t, function (t, n, o) {
          (e(t, n, o) ? r : i).push(t);
        }), [r, i];
      }, S.first = S.head = S.take = function (t, e, n) {
        if (null != t) return null == e || n ? t[0] : S.initial(t, t.length - e);
      }, S.initial = function (t, e, n) {
        return h.call(t, 0, Math.max(0, t.length - (null == e || n ? 1 : e)));
      }, S.last = function (t, e, n) {
        if (null != t) return null == e || n ? t[t.length - 1] : S.rest(t, Math.max(0, t.length - e));
      }, S.rest = S.tail = S.drop = function (t, e, n) {
        return h.call(t, null == e || n ? 1 : e);
      }, S.compact = function (t) {
        return S.filter(t, S.identity);
      };
      var P = function P(t, e, n, r) {
        for (var i = [], o = 0, a = r || 0, s = C(t); a < s; a++) {
          var u = t[a];
          if (I(u) && (S.isArray(u) || S.isArguments(u))) {
            e || (u = P(u, e, n));
            var c = 0,
              l = u.length;
            for (i.length += l; c < l;) i[o++] = u[c++];
          } else n || (i[o++] = u);
        }
        return i;
      };
      S.flatten = function (t, e) {
        return P(t, e, !1);
      }, S.without = function (t) {
        return S.difference(t, h.call(arguments, 1));
      }, S.uniq = S.unique = function (t, e, n, r) {
        S.isBoolean(e) || (r = n, n = e, e = !1), null != n && (n = E(n, r));
        for (var i = [], o = [], a = 0, s = C(t); a < s; a++) {
          var u = t[a],
            c = n ? n(u, a, t) : u;
          e ? (a && o === c || i.push(u), o = c) : n ? S.contains(o, c) || (o.push(c), i.push(u)) : S.contains(i, u) || i.push(u);
        }
        return i;
      }, S.union = function () {
        return S.uniq(P(arguments, !0, !0));
      }, S.intersection = function (t) {
        for (var e = [], n = arguments.length, r = 0, i = C(t); r < i; r++) {
          var o = t[r];
          if (!S.contains(e, o)) {
            for (var a = 1; a < n && S.contains(arguments[a], o); a++);
            a === n && e.push(o);
          }
        }
        return e;
      }, S.difference = function (t) {
        var e = P(arguments, !0, !0, 1);
        return S.filter(t, function (t) {
          return !S.contains(e, t);
        });
      }, S.zip = function () {
        return S.unzip(arguments);
      }, S.unzip = function (t) {
        for (var e = t && S.max(t, C).length || 0, n = Array(e), r = 0; r < e; r++) n[r] = S.pluck(t, r);
        return n;
      }, S.object = function (t, e) {
        for (var n = {}, r = 0, i = C(t); r < i; r++) e ? n[t[r]] = e[r] : n[t[r][0]] = t[r][1];
        return n;
      }, S.findIndex = o(1), S.findLastIndex = o(-1), S.sortedIndex = function (t, e, n, r) {
        n = E(n, r, 1);
        for (var i = n(e), o = 0, a = C(t); o < a;) {
          var s = Math.floor((o + a) / 2);
          n(t[s]) < i ? o = s + 1 : a = s;
        }
        return o;
      }, S.indexOf = a(1, S.findIndex, S.sortedIndex), S.lastIndexOf = a(-1, S.findLastIndex), S.range = function (t, e, n) {
        null == e && (e = t || 0, t = 0), n = n || 1;
        for (var r = Math.max(Math.ceil((e - t) / n), 0), i = Array(r), o = 0; o < r; o++, t += n) i[o] = t;
        return i;
      };
      var N = function N(t, e, n, r, i) {
        if (!(r instanceof e)) return t.apply(n, i);
        var o = k(t.prototype),
          a = t.apply(o, i);
        return S.isObject(a) ? a : o;
      };
      S.bind = function (t, e) {
        if (_ && t.bind === _) return _.apply(t, h.call(arguments, 1));
        if (!S.isFunction(t)) throw new TypeError("Bind must be called on a function");
        var n = h.call(arguments, 2),
          r = function r() {
            return N(t, r, e, this, n.concat(h.call(arguments)));
          };
        return r;
      }, S.partial = function (t) {
        var e = h.call(arguments, 1),
          n = function n() {
            for (var r = 0, i = e.length, o = Array(i), a = 0; a < i; a++) o[a] = e[a] === S ? arguments[r++] : e[a];
            for (; r < arguments.length;) o.push(arguments[r++]);
            return N(t, n, this, this, o);
          };
        return n;
      }, S.bindAll = function (t) {
        var e,
          n,
          r = arguments.length;
        if (r <= 1) throw new Error("bindAll must be passed function names");
        for (e = 1; e < r; e++) n = arguments[e], t[n] = S.bind(t[n], t);
        return t;
      }, S.memoize = function (t, e) {
        var n = function n(r) {
          var i = n.cache,
            o = "" + (e ? e.apply(this, arguments) : r);
          return S.has(i, o) || (i[o] = t.apply(this, arguments)), i[o];
        };
        return n.cache = {}, n;
      }, S.delay = function (t, e) {
        var n = h.call(arguments, 2);
        return setTimeout(function () {
          return t.apply(null, n);
        }, e);
      }, S.defer = S.partial(S.delay, S, 1), S.throttle = function (t, e, n) {
        var r,
          i,
          o,
          a = null,
          s = 0;
        n || (n = {});
        var u = function u() {
          s = !1 === n.leading ? 0 : S.now(), a = null, o = t.apply(r, i), a || (r = i = null);
        };
        return function () {
          var c = S.now();
          s || !1 !== n.leading || (s = c);
          var l = e - (c - s);
          return r = this, i = arguments, l <= 0 || l > e ? (a && (clearTimeout(a), a = null), s = c, o = t.apply(r, i), a || (r = i = null)) : a || !1 === n.trailing || (a = setTimeout(u, l)), o;
        };
      }, S.debounce = function (t, e, n) {
        var r,
          i,
          o,
          a,
          s,
          u = function u() {
            var c = S.now() - a;
            c < e && c >= 0 ? r = setTimeout(u, e - c) : (r = null, n || (s = t.apply(o, i), r || (o = i = null)));
          };
        return function () {
          o = this, i = arguments, a = S.now();
          var c = n && !r;
          return r || (r = setTimeout(u, e)), c && (s = t.apply(o, i), o = i = null), s;
        };
      }, S.wrap = function (t, e) {
        return S.partial(e, t);
      }, S.negate = function (t) {
        return function () {
          return !t.apply(this, arguments);
        };
      }, S.compose = function () {
        var t = arguments,
          e = t.length - 1;
        return function () {
          for (var n = e, r = t[e].apply(this, arguments); n--;) r = t[n].call(this, r);
          return r;
        };
      }, S.after = function (t, e) {
        return function () {
          if (--t < 1) return e.apply(this, arguments);
        };
      }, S.before = function (t, e) {
        var n;
        return function () {
          return --t > 0 && (n = e.apply(this, arguments)), t <= 1 && (e = null), n;
        };
      }, S.once = S.partial(S.before, 2);
      var M = !{
          toString: null
        }.propertyIsEnumerable("toString"),
        L = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"];
      S.keys = function (t) {
        if (!S.isObject(t)) return [];
        if (y) return y(t);
        var e = [];
        for (var n in t) S.has(t, n) && e.push(n);
        return M && s(t, e), e;
      }, S.allKeys = function (t) {
        if (!S.isObject(t)) return [];
        var e = [];
        for (var n in t) e.push(n);
        return M && s(t, e), e;
      }, S.values = function (t) {
        for (var e = S.keys(t), n = e.length, r = Array(n), i = 0; i < n; i++) r[i] = t[e[i]];
        return r;
      }, S.mapObject = function (t, e, n) {
        e = E(e, n);
        for (var r, i = S.keys(t), o = i.length, a = {}, s = 0; s < o; s++) r = i[s], a[r] = e(t[r], r, t);
        return a;
      }, S.pairs = function (t) {
        for (var e = S.keys(t), n = e.length, r = Array(n), i = 0; i < n; i++) r[i] = [e[i], t[e[i]]];
        return r;
      }, S.invert = function (t) {
        for (var e = {}, n = S.keys(t), r = 0, i = n.length; r < i; r++) e[t[n[r]]] = n[r];
        return e;
      }, S.functions = S.methods = function (t) {
        var e = [];
        for (var n in t) S.isFunction(t[n]) && e.push(n);
        return e.sort();
      }, S.extend = T(S.allKeys), S.extendOwn = S.assign = T(S.keys), S.findKey = function (t, e, n) {
        e = E(e, n);
        for (var r, i = S.keys(t), o = 0, a = i.length; o < a; o++) if (r = i[o], e(t[r], r, t)) return r;
      }, S.pick = function (t, e, n) {
        var r,
          i,
          o = {},
          a = t;
        if (null == a) return o;
        S.isFunction(e) ? (i = S.allKeys(a), r = x(e, n)) : (i = P(arguments, !1, !1, 1), r = function r(t, e, n) {
          return e in n;
        }, a = Object(a));
        for (var s = 0, u = i.length; s < u; s++) {
          var c = i[s],
            l = a[c];
          r(l, c, a) && (o[c] = l);
        }
        return o;
      }, S.omit = function (t, e, n) {
        if (S.isFunction(e)) e = S.negate(e);else {
          var r = S.map(P(arguments, !1, !1, 1), String);
          e = function e(t, _e2) {
            return !S.contains(r, _e2);
          };
        }
        return S.pick(t, e, n);
      }, S.defaults = T(S.allKeys, !0), S.create = function (t, e) {
        var n = k(t);
        return e && S.extendOwn(n, e), n;
      }, S.clone = function (t) {
        return S.isObject(t) ? S.isArray(t) ? t.slice() : S.extend({}, t) : t;
      }, S.tap = function (t, e) {
        return e(t), t;
      }, S.isMatch = function (t, e) {
        var n = S.keys(e),
          r = n.length;
        if (null == t) return !r;
        for (var i = Object(t), o = 0; o < r; o++) {
          var a = n[o];
          if (e[a] !== i[a] || !(a in i)) return !1;
        }
        return !0;
      };
      var F = function F(t, e, n, r) {
        if (t === e) return 0 !== t || 1 / t == 1 / e;
        if (null == t || null == e) return t === e;
        t instanceof S && (t = t._wrapped), e instanceof S && (e = e._wrapped);
        var i = m.call(t);
        if (i !== m.call(e)) return !1;
        switch (i) {
          case "[object RegExp]":
          case "[object String]":
            return "" + t == "" + e;
          case "[object Number]":
            return +t != +t ? +e != +e : 0 == +t ? 1 / +t == 1 / e : +t == +e;
          case "[object Date]":
          case "[object Boolean]":
            return +t == +e;
        }
        var o = "[object Array]" === i;
        if (!o) {
          if ("object" != typeof t || "object" != typeof e) return !1;
          var a = t.constructor,
            s = e.constructor;
          if (a !== s && !(S.isFunction(a) && a instanceof a && S.isFunction(s) && s instanceof s) && "constructor" in t && "constructor" in e) return !1;
        }
        n = n || [], r = r || [];
        for (var u = n.length; u--;) if (n[u] === t) return r[u] === e;
        if (n.push(t), r.push(e), o) {
          if ((u = t.length) !== e.length) return !1;
          for (; u--;) if (!F(t[u], e[u], n, r)) return !1;
        } else {
          var c,
            l = S.keys(t);
          if (u = l.length, S.keys(e).length !== u) return !1;
          for (; u--;) if (c = l[u], !S.has(e, c) || !F(t[c], e[c], n, r)) return !1;
        }
        return n.pop(), r.pop(), !0;
      };
      S.isEqual = function (t, e) {
        return F(t, e);
      }, S.isEmpty = function (t) {
        return null == t || (I(t) && (S.isArray(t) || S.isString(t) || S.isArguments(t)) ? 0 === t.length : 0 === S.keys(t).length);
      }, S.isElement = function (t) {
        return !(!t || 1 !== t.nodeType);
      }, S.isArray = v || function (t) {
        return "[object Array]" === m.call(t);
      }, S.isObject = function (t) {
        var e = typeof t;
        return "function" === e || "object" === e && !!t;
      }, S.each(["Arguments", "Function", "String", "Number", "Date", "RegExp", "Error"], function (t) {
        S["is" + t] = function (e) {
          return m.call(e) === "[object " + t + "]";
        };
      }), S.isArguments(arguments) || (S.isArguments = function (t) {
        return S.has(t, "callee");
      }), "function" != typeof /./ && "object" != typeof Int8Array && (S.isFunction = function (t) {
        return "function" == typeof t || !1;
      }), S.isFinite = function (t) {
        return isFinite(t) && !isNaN(parseFloat(t));
      }, S.isNaN = function (t) {
        return S.isNumber(t) && t !== +t;
      }, S.isBoolean = function (t) {
        return !0 === t || !1 === t || "[object Boolean]" === m.call(t);
      }, S.isNull = function (t) {
        return null === t;
      }, S.isUndefined = function (t) {
        return void 0 === t;
      }, S.has = function (t, e) {
        return null != t && g.call(t, e);
      }, S.noConflict = function () {
        return u._ = c, this;
      }, S.identity = function (t) {
        return t;
      }, S.constant = function (t) {
        return function () {
          return t;
        };
      }, S.noop = function () {}, S.property = A, S.propertyOf = function (t) {
        return null == t ? function () {} : function (e) {
          return t[e];
        };
      }, S.matcher = S.matches = function (t) {
        return t = S.extendOwn({}, t), function (e) {
          return S.isMatch(e, t);
        };
      }, S.times = function (t, e, n) {
        var r = Array(Math.max(0, t));
        e = x(e, n, 1);
        for (var i = 0; i < t; i++) r[i] = e(i);
        return r;
      }, S.random = function (t, e) {
        return null == e && (e = t, t = 0), t + Math.floor(Math.random() * (e - t + 1));
      }, S.now = Date.now || function () {
        return new Date().getTime();
      };
      var D = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#x27;",
          "`": "&#x60;"
        },
        j = S.invert(D),
        U = function U(t) {
          var e = function e(_e3) {
              return t[_e3];
            },
            n = "(?:" + S.keys(t).join("|") + ")",
            r = RegExp(n),
            i = RegExp(n, "g");
          return function (t) {
            return t = null == t ? "" : "" + t, r.test(t) ? t.replace(i, e) : t;
          };
        };
      S.escape = U(D), S.unescape = U(j), S.result = function (t, e, n) {
        var r = null == t ? void 0 : t[e];
        return void 0 === r && (r = n), S.isFunction(r) ? r.call(t) : r;
      };
      var B = 0;
      S.uniqueId = function (t) {
        var e = ++B + "";
        return t ? t + e : e;
      }, S.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
      };
      var V = /(.)^/,
        q = {
          "'": "'",
          "\\": "\\",
          "\r": "r",
          "\n": "n",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
        H = /\\|'|\r|\n|\u2028|\u2029/g,
        W = function W(t) {
          return "\\" + q[t];
        };
      S.template = function (t, e, n) {
        !e && n && (e = n), e = S.defaults({}, e, S.templateSettings);
        var r = RegExp([(e.escape || V).source, (e.interpolate || V).source, (e.evaluate || V).source].join("|") + "|$", "g"),
          i = 0,
          o = "__p+='";
        t.replace(r, function (e, n, r, a, s) {
          return o += t.slice(i, s).replace(H, W), i = s + e.length, n ? o += "'+\n((__t=(" + n + "))==null?'':_.escape(__t))+\n'" : r ? o += "'+\n((__t=(" + r + "))==null?'':__t)+\n'" : a && (o += "';\n" + a + "\n__p+='"), e;
        }), o += "';\n", e.variable || (o = "with(obj||{}){\n" + o + "}\n"), o = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + o + "return __p;\n";
        try {
          var a = new Function(e.variable || "obj", "_", o);
        } catch (t) {
          throw t.source = o, t;
        }
        var s = function s(t) {
          return a.call(this, t, S);
        };
        return s.source = "function(" + (e.variable || "obj") + "){\n" + o + "}", s;
      }, S.chain = function (t) {
        var e = S(t);
        return e._chain = !0, e;
      };
      var $ = function $(t, e) {
        return t._chain ? S(e).chain() : e;
      };
      S.mixin = function (t) {
        S.each(S.functions(t), function (e) {
          var n = S[e] = t[e];
          S.prototype[e] = function () {
            var t = [this._wrapped];
            return d.apply(t, arguments), $(this, n.apply(S, t));
          };
        });
      }, S.mixin(S), S.each(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (t) {
        var e = l[t];
        S.prototype[t] = function () {
          var n = this._wrapped;
          return e.apply(n, arguments), "shift" !== t && "splice" !== t || 0 !== n.length || delete n[0], $(this, n);
        };
      }), S.each(["concat", "join", "slice"], function (t) {
        var e = l[t];
        S.prototype[t] = function () {
          return $(this, e.apply(this._wrapped, arguments));
        };
      }), S.prototype.value = function () {
        return this._wrapped;
      }, S.prototype.valueOf = S.prototype.toJSON = S.prototype.value, S.prototype.toString = function () {
        return "" + this._wrapped;
      }, r = [], void 0 !== (i = function () {
        return S;
      }.apply(e, r)) && (t.exports = i);
    }).call(this);
  }, function (t, e) {
    t.exports = {
      version: "3.9.2",
      supportedLanguages: ["en", "cs", "da", "de", "el", "es", "fi", "fr", "hu", "id", "in", "it", "ja", "ko", "ms", "nb", "nl-NL", "pl", "pt-BR", "ro", "ru", "sv", "th", "tr", "uk", "vi", "zh-CN", "zh-TW"]
    };
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(6), n(33), n(13)], void 0 !== (i = function (t, e, n, r) {
      function i(t, e) {
        return a.isArray(t.responseType) ? a.contains(t.responseType, e) : e === t.responseType;
      }
      var o = {},
        a = t._;
      return o.getTokens = function (o, s, u) {
        function c(t) {
          o.callGlobalSuccess(e.SUCCESS, t);
        }
        function l(t) {
          "access_denied" === t.errorCode && (u.model.trigger("error", u.model, {
            responseJSON: t
          }), u.model.appState.trigger("removeLoading")), r.triggerAfterError(u, new n.OAuthError(t.message), o);
        }
        var f = o.getAuthClient(),
          p = o.toJSON({
            verbose: !0
          }),
          d = {},
          h = {};
        a.extend(d, a.pick(p, "clientId", "redirectUri"), a.pick(p.authParams, "pkce", "grantType", "responseType", "responseMode", "display", "scopes", "state", "nonce"), s), h.popupTitle = t.loc("socialauth.popup.title", "login"), h.timeout = p.oAuthTimeout, a.extend(h, a.pick(p.authParams, "issuer", "authorizeUrl")), "page" === d.display || i(d, "code") ? f.token.getWithRedirect(d, h).fail(l) : d.sessionToken ? f.token.getWithoutPrompt(d, h).then(c).fail(l).done() : f.token.getWithPopup(d, h).then(c).fail(l).done();
      }, o.addOrRemoveOpenIdScope = function (t) {
        if (t.responseType) {
          var e = Array.isArray(t.scopes) ? t.scopes : t.scopes.split(" ");
          return e.includes("openid") && e.splice(e.indexOf("openid"), 1), t.responseType.includes("id_token") && e.push("openid"), e;
        }
      }, o.getResponseType = function (t) {
        var e = [];
        return !1 !== t.getIdToken && e.push("id_token"), t.getAccessToken && e.push("token"), e;
      }, o.transformShowSignInToGetTokensOptions = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!t.clientId && !e.clientId) throw new n.ConfigError('showSignInToGetTokens() requires a "clientId" property.');
        var r = {
          clientId: t.clientId,
          redirectUri: t.redirectUri,
          authParams: {
            issuer: t.authorizationServerId || "default",
            display: "page",
            responseMode: "fragment",
            responseType: o.getResponseType(t),
            scopes: t.scope || e.authParams && e.authParams.scopes || ["openid"]
          }
        };
        return r.authParams.scopes = o.addOrRemoveOpenIdScope(r.authParams), r;
      }, o;
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e) {
    var n = Math.ceil,
      r = Math.floor;
    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);
      return t;
    };
  }, function (t, e, n) {
    var r = n(46),
      i = n(22).document,
      o = r(i) && r(i.createElement);
    t.exports = function (t) {
      return o ? i.createElement(t) : {};
    };
  }, function (t, e, n) {
    var r = n(46);
    t.exports = function (t, e) {
      if (!r(t)) return t;
      var n, i;
      if (e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
      if ("function" == typeof (n = t.valueOf) && !r(i = n.call(t))) return i;
      if (!e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e, n) {
    var r = n(45),
      i = n(223),
      o = n(162),
      a = n(160)("IE_PROTO"),
      s = function s() {},
      _u2 = function u() {
        var t,
          e = n(156)("iframe"),
          r = o.length;
        for (e.style.display = "none", n(226).appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write("<script>document.F=Object<\/script>"), t.close(), _u2 = t.F; r--;) delete _u2.prototype[o[r]];
        return _u2();
      };
    t.exports = Object.create || function (t, e) {
      var n;
      return null !== t ? (s.prototype = r(t), n = new s(), s.prototype = null, n[a] = t) : n = _u2(), void 0 === e ? n : i(n, e);
    };
  }, function (t, e, n) {
    var r = n(154),
      i = Math.min;
    t.exports = function (t) {
      return t > 0 ? i(r(t), 9007199254740991) : 0;
    };
  }, function (t, e, n) {
    var r = n(161)("keys"),
      i = n(116);
    t.exports = function (t) {
      return r[t] || (r[t] = i(t));
    };
  }, function (t, e, n) {
    var r = n(9),
      i = n(22),
      o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
    (t.exports = function (t, e) {
      return o[t] || (o[t] = void 0 !== e ? e : {});
    })("versions", []).push({
      version: r.version,
      mode: n(91) ? "pure" : "global",
      copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
    });
  }, function (t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, e, n) {
    var r = n(22),
      i = n(9),
      o = n(91),
      a = n(119),
      s = n(50).f;
    t.exports = function (t) {
      var e = i.Symbol || (i.Symbol = o ? {} : r.Symbol || {});
      "_" == t.charAt(0) || t in e || s(e, t, {
        value: a.f(t)
      });
    };
  }, function (t, e) {
    e.f = Object.getOwnPropertySymbols;
  }, function (t, e, n) {
    var r = n(94),
      i = n(92),
      o = n(56),
      a = n(157),
      s = n(72),
      u = n(221),
      c = Object.getOwnPropertyDescriptor;
    e.f = n(39) ? c : function (t, e) {
      if (t = o(t), e = a(e, !0), u) try {
        return c(t, e);
      } catch (t) {}
      if (s(t, e)) return i(!r.f.call(t, e), t[e]);
    };
  }, function (t, e) {}, function (t, e, n) {
    t.exports = {
      default: n(490),
      __esModule: !0
    };
  }, function (t, e, n) {
    var r, i, o; /* @okta/qtip2 v3.0.3-5-g | Plugins: tips modal viewport svg imagemap ie6 | Styles: core basic css3 | qtip2.com | Licensed MIT | Wed May 24 2017 01:22:57 */
    !function (a, s, u) {
      !function (a) {
        "use strict";

        i = [n(120)], r = a, void 0 !== (o = "function" == typeof r ? r.apply(e, i) : r) && (t.exports = o);
      }(function (t) {
        "use strict";

        function e(e, n, r, i) {
          this.id = r, this.target = e, this.tooltip = R, this.elements = {
            target: e
          }, this._id = W + "-" + r, this.timers = {
            img: {}
          }, this.options = n, this.plugins = {}, this.cache = {
            event: {},
            target: t(),
            disabled: I,
            attr: i,
            onTooltip: I,
            lastClass: ""
          }, this.rendered = this.destroyed = this.disabled = this.waiting = this.hiddenDuringWait = this.positioning = this.triggering = I;
        }
        function n(e) {
          return e === R || "object" !== t.type(e);
        }
        function r(e) {
          return !(t.isFunction(e) || e && e.attr || e.length || "object" === t.type(e) && (e.jquery || e.then));
        }
        function i(e) {
          var i, o, a, s;
          return n(e) ? I : (n(e.metadata) && (e.metadata = {
            type: e.metadata
          }), "content" in e && (i = e.content, n(i) || i.jquery || i.done ? (o = r(i) ? I : i, i = e.content = {
            text: o
          }) : o = i.text, "ajax" in i && (a = i.ajax, s = a && a.once !== I, delete i.ajax, i.text = function (e, n) {
            var r = o || t(this).attr(n.options.content.attr) || "Loading...",
              i = t.ajax(t.extend({}, a, {
                context: n
              })).then(a.success, R, a.error).then(function (t) {
                return t && s && n.set("content.text", t), t;
              }, function (t, e, r) {
                n.destroyed || 0 === t.status || n.set("content.text", e + ": " + r);
              });
            return s ? r : (n.set("content.text", r), i);
          }), "title" in i && (t.isPlainObject(i.title) && (i.button = i.title.button, i.title = i.title.text), r(i.title || I) && (i.title = I))), "position" in e && n(e.position) && (e.position = {
            my: e.position,
            at: e.position
          }), "show" in e && n(e.show) && (e.show = e.show.jquery ? {
            target: e.show
          } : e.show === C ? {
            ready: C
          } : {
            event: e.show
          }), "hide" in e && n(e.hide) && (e.hide = e.hide.jquery ? {
            target: e.hide
          } : {
            event: e.hide
          }), "style" in e && n(e.style) && (e.style = {
            classes: e.style
          }), t.each(H, function () {
            this.sanitize && this.sanitize(e);
          }), e);
        }
        function o(t, e) {
          for (var n, r = 0, i = t, o = e.split("."); i = i[o[r++]];) r < o.length && (n = i);
          return [n || t, o.pop()];
        }
        function c(t, e) {
          var n, r, i;
          for (n in this.checks) if (this.checks.hasOwnProperty(n)) for (r in this.checks[n]) this.checks[n].hasOwnProperty(r) && (i = new RegExp(r, "i").exec(t)) && (e.push(i), ("builtin" === n || this.plugins[n]) && this.checks[n][r].apply(this.plugins[n] || this, e));
        }
        function l(t) {
          return G.concat("").join(t ? "-" + t + " " : " ");
        }
        function f(e, n) {
          return n > 0 ? setTimeout(t.proxy(e, this), n) : void e.call(this);
        }
        function p(t) {
          this.tooltip.hasClass(tt) || (clearTimeout(this.timers.show), clearTimeout(this.timers.hide), this.timers.show = f.call(this, function () {
            this.toggle(C, t);
          }, this.options.show.delay));
        }
        function d(e) {
          if (!this.tooltip.hasClass(tt) && !this.destroyed) {
            var n = t(e.relatedTarget),
              r = n.closest(K)[0] === this.tooltip[0],
              i = n[0] === this.options.show.target[0];
            if (clearTimeout(this.timers.show), clearTimeout(this.timers.hide), this !== n[0] && "mouse" === this.options.position.target && r || this.options.hide.fixed && /mouse(out|leave|move)/.test(e.type) && (r || i)) try {
              e.preventDefault(), e.stopImmediatePropagation();
            } catch (t) {} else this.timers.hide = f.call(this, function () {
              this.toggle(I, e);
            }, this.options.hide.delay, this);
          }
        }
        function h(t) {
          !this.tooltip.hasClass(tt) && this.options.hide.inactive && (clearTimeout(this.timers.inactive), this.timers.inactive = f.call(this, function () {
            this.hide(t);
          }, this.options.hide.inactive));
        }
        function m(t) {
          this.rendered && this.tooltip[0].offsetWidth > 0 && this.reposition(t);
        }
        function g(e, n, r) {
          t(s.body).delegate(e, (n.split ? n : n.join("." + W + " ")) + "." + W, function () {
            var e = E.api[t.attr(this, z)];
            e && !e.disabled && r.apply(e, arguments);
          });
        }
        function v(n, r, o) {
          var a,
            u,
            c,
            l,
            f,
            p = t(s.body),
            d = n[0] === s ? p : n,
            h = n.metadata ? n.metadata(o.metadata) : R,
            m = "html5" === o.metadata.type && h ? h[o.metadata.name] : R,
            g = n.data(o.metadata.name || "qtipopts");
          try {
            g = "string" == typeof g ? t.parseJSON(g) : g;
          } catch (t) {}
          if (l = t.extend(C, {}, E.defaults, o, "object" == typeof g ? i(g) : R, i(m || h)), u = l.position, l.id = r, "boolean" == typeof l.content.text) {
            if (c = n.attr(l.content.attr), l.content.attr === I || !c) return I;
            l.content.text = c;
          }
          if (u.container.length || (u.container = p), u.target === I && (u.target = d), l.show.target === I && (l.show.target = d), l.show.solo === C && (l.show.solo = u.container.closest("body")), l.hide.target === I && (l.hide.target = d), l.position.viewport === C && (l.position.viewport = u.container), u.container = u.container.eq(0), u.at = new k(u.at, C), u.my = new k(u.my), n.data(W)) if (l.overwrite) n.qtip("destroy", !0);else if (l.overwrite === I) return I;
          return n.attr($, r), l.suppress && (f = n.attr("title")) && n.removeAttr("title").attr(nt, f).attr("title", ""), a = new e(n, l, r, !!c), n.data(W, a), a;
        }
        function y(t) {
          return t.charAt(0).toUpperCase() + t.slice(1);
        }
        function _(t, e) {
          var n,
            r,
            i = e.charAt(0).toUpperCase() + e.slice(1),
            o = (e + " " + wt.join(i + " ") + i).split(" "),
            a = 0;
          if (bt[e]) return t.css(bt[e]);
          for (; n = o[a++];) if ((r = t.css(n)) !== u) return bt[e] = n, r;
        }
        function b(t, e) {
          return Math.ceil(parseFloat(_(t, e)));
        }
        function w(t, e) {
          this._ns = "tip", this.options = e, this.offset = e.offset, this.size = [e.width, e.height], this.qtip = t, this.init(t);
        }
        function S(t, e) {
          this.options = e, this._ns = "-modal", this.qtip = t, this.init(t);
        }
        function x(t) {
          this._ns = "ie6", this.qtip = t, this.init(t);
        }
        var E,
          T,
          k,
          A,
          O,
          C = !0,
          I = !1,
          R = null,
          P = "x",
          N = "y",
          M = "width",
          L = "height",
          F = "top",
          D = "left",
          j = "bottom",
          U = "right",
          B = "center",
          V = "flipinvert",
          q = "shift",
          H = {},
          W = "qtip",
          $ = "data-hasqtip",
          z = "data-qtip-id",
          G = ["ui-widget", "ui-tooltip"],
          K = "." + W,
          Y = "click dblclick mousedown mouseup mousemove mouseleave mouseenter".split(" "),
          J = W + "-fixed",
          Q = W + "-default",
          X = W + "-focus",
          Z = W + "-hover",
          tt = W + "-disabled",
          et = "_replacedByqTip",
          nt = "oldtitle",
          rt = {
            ie: function () {
              var t, e;
              for (t = 4, e = s.createElement("div"); (e.innerHTML = "\x3c!--[if gt IE " + t + "]><i></i><![endif]--\x3e") && e.getElementsByTagName("i")[0]; t += 1);
              return t > 4 ? t : NaN;
            }(),
            iOS: parseFloat(("" + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ""])[1]).replace("undefined", "3_2").replace("_", ".").replace("_", "")) || I
          };
        T = e.prototype, T._when = function (e) {
          return t.when.apply(t, e);
        }, T.render = function (e) {
          if (this.rendered || this.destroyed) return this;
          var n = this,
            r = this.options,
            i = this.cache,
            o = this.elements,
            a = r.content.text,
            s = r.content.title,
            u = r.content.button,
            c = r.position,
            l = [];
          return t.attr(this.target[0], "aria-describedby", this._id), i.posClass = this._createPosClass((this.position = {
            my: c.my,
            at: c.at
          }).my), this.tooltip = o.tooltip = t("<div/>", {
            id: this._id,
            class: [W, Q, r.style.classes, i.posClass].join(" "),
            width: r.style.width || "",
            height: r.style.height || "",
            tracking: "mouse" === c.target && c.adjust.mouse,
            role: "alert",
            "aria-live": "polite",
            "aria-atomic": I,
            "aria-describedby": this._id + "-content",
            "aria-hidden": C
          }).toggleClass(tt, this.disabled).attr(z, this.id).data(W, this).appendTo(c.container).append(o.content = t("<div />", {
            class: W + "-content",
            id: this._id + "-content",
            "aria-atomic": C
          })), this.rendered = -1, this.positioning = C, s && (this._createTitle(), t.isFunction(s) || l.push(this._updateTitle(s, I))), u && this._createButton(), t.isFunction(a) || l.push(this._updateContent(a, I)), this.rendered = C, this._setWidget(), t.each(H, function (t) {
            var e;
            "render" === this.initialize && (e = this(n)) && (n.plugins[t] = e);
          }), this._unassignEvents(), this._assignEvents(), this._when(l).then(function () {
            n._trigger("render"), n.positioning = I, n.hiddenDuringWait || !r.show.ready && !e || n.toggle(C, i.event, I), n.hiddenDuringWait = I;
          }), E.api[this.id] = this, this;
        }, T.destroy = function (e) {
          function n() {
            if (!this.destroyed) {
              this.destroyed = C;
              var e,
                n = this.target,
                r = n.attr(nt);
              this.rendered && this.tooltip.stop(1, 0).find("*").remove().end().remove(), t.each(this.plugins, function () {
                this.destroy && this.destroy();
              });
              for (e in this.timers) this.timers.hasOwnProperty(e) && clearTimeout(this.timers[e]);
              n.removeData(W).removeAttr(z).removeAttr($).removeAttr("aria-describedby"), this.options.suppress && r && n.attr("title", r).removeAttr(nt), this._unassignEvents(), this.options = this.elements = this.cache = this.timers = this.plugins = this.mouse = R, delete E.api[this.id];
            }
          }
          return this.destroyed ? this.target : (e === C && "hide" !== this.triggering || !this.rendered ? n.call(this) : (this.tooltip.one("tooltiphidden", t.proxy(n, this)), !this.triggering && this.hide()), this.target);
        }, A = T.checks = {
          builtin: {
            "^id$": function id$(e, n, r, i) {
              var o = r === C ? E.nextid : r,
                a = W + "-" + o;
              o !== I && o.length > 0 && !t("#" + a).length ? (this._id = a, this.rendered && (this.tooltip[0].id = this._id, this.elements.content[0].id = this._id + "-content", this.elements.title[0].id = this._id + "-title")) : e[n] = i;
            },
            "^prerender": function prerender(t, e, n) {
              n && !this.rendered && this.render(this.options.show.ready);
            },
            "^content.text$": function contentText$(t, e, n) {
              this._updateContent(n);
            },
            "^content.attr$": function contentAttr$(t, e, n, r) {
              this.options.content.text === this.target.attr(r) && this._updateContent(this.target.attr(n));
            },
            "^content.title$": function contentTitle$(t, e, n) {
              return n ? (n && !this.elements.title && this._createTitle(), void this._updateTitle(n)) : this._removeTitle();
            },
            "^content.button$": function contentButton$(t, e, n) {
              this._updateButton(n);
            },
            "^content.title.(text|button)$": function contentTitleTextButton$(t, e, n) {
              this.set("content." + e, n);
            },
            "^position.(my|at)$": function positionMyAt$(t, e, n) {
              "string" == typeof n && (this.position[e] = t[e] = new k(n, "at" === e));
            },
            "^position.container$": function positionContainer$(t, e, n) {
              this.rendered && this.tooltip.appendTo(n);
            },
            "^show.ready$": function showReady$(t, e, n) {
              n && (!this.rendered && this.render(C) || this.toggle(C));
            },
            "^style.classes$": function styleClasses$(t, e, n, r) {
              this.rendered && this.tooltip.removeClass(r).addClass(n);
            },
            "^style.(width|height)": function styleWidthHeight(t, e, n) {
              this.rendered && this.tooltip.css(e, n);
            },
            "^style.widget|content.title": function styleWidgetContentTitle() {
              this.rendered && this._setWidget();
            },
            "^style.def": function styleDef(t, e, n) {
              this.rendered && this.tooltip.toggleClass(Q, !!n);
            },
            "^events.(render|show|move|hide|focus|blur)$": function eventsRenderShowMoveHideFocusBlur$(e, n, r) {
              this.rendered && this.tooltip[(t.isFunction(r) ? "" : "un") + "bind"]("tooltip" + n, r);
            },
            "^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)": function showHidePositionEventTargetFixedInactiveLeaveDistanceViewportAdjust() {
              if (this.rendered) {
                var t = this.options.position;
                this.tooltip.attr("tracking", "mouse" === t.target && t.adjust.mouse), this._unassignEvents(), this._assignEvents();
              }
            }
          }
        }, T.get = function (t) {
          if (this.destroyed) return this;
          var e = o(this.options, t.toLowerCase()),
            n = e[0][e[1]];
          return n.precedance ? n.string() : n;
        };
        var it = /^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,
          ot = /^prerender|show\.ready/i;
        T.set = function (e, n) {
          if (this.destroyed) return this;
          var r,
            a = this.rendered,
            s = I,
            u = this.options;
          return "string" == typeof e ? (r = e, e = {}, e[r] = n) : e = t.extend({}, e), t.each(e, function (n, r) {
            if (a && ot.test(n)) return void delete e[n];
            var i,
              c = o(u, n.toLowerCase());
            i = c[0][c[1]], c[0][c[1]] = r && r.nodeType ? t(r) : r, s = it.test(n) || s, e[n] = [c[0], c[1], r, i];
          }), i(u), this.positioning = C, t.each(e, t.proxy(c, this)), this.positioning = I, this.rendered && this.tooltip[0].offsetWidth > 0 && s && this.reposition("mouse" === u.position.target ? R : this.cache.event), this;
        }, T._update = function (e, n) {
          var r = this,
            i = this.cache;
          return this.rendered && e ? (t.isFunction(e) && (e = e.call(this.elements.target, i.event, this) || ""), t.isFunction(e.then) ? (i.waiting = C, e.then(function (t) {
            return i.waiting = I, r._update(t, n);
          }, R, function (t) {
            return r._update(t, n);
          })) : e === I || !e && "" !== e ? I : (e.jquery && e.length > 0 ? n.empty().append(e.css({
            display: "block",
            visibility: "visible"
          })) : n.html(e), this._waitForContent(n).then(function (t) {
            r.rendered && r.tooltip[0].offsetWidth > 0 && r.reposition(i.event, !t.length);
          }))) : I;
        }, T._waitForContent = function (e) {
          var n = this.cache;
          return n.waiting = C, (t.fn.imagesLoaded ? e.imagesLoaded() : new t.Deferred().resolve([])).done(function () {
            n.waiting = I;
          }).promise();
        }, T._updateContent = function (t, e) {
          this._update(t, this.elements.content, e);
        }, T._updateTitle = function (t, e) {
          this._update(t, this.elements.title, e) === I && this._removeTitle(I);
        }, T._createTitle = function () {
          var e = this.elements,
            n = this._id + "-title";
          e.titlebar && this._removeTitle(), e.titlebar = t("<div />", {
            class: W + "-titlebar " + (this.options.style.widget ? l("header") : "")
          }).append(e.title = t("<div />", {
            id: n,
            class: W + "-title",
            "aria-atomic": C
          })).insertBefore(e.content).delegate(".qtip-close", "mousedown keydown mouseup keyup mouseout", function (e) {
            t(this).toggleClass("ui-state-active ui-state-focus", "down" === e.type.substr(-4));
          }).delegate(".qtip-close", "mouseover mouseout", function (e) {
            t(this).toggleClass("ui-state-hover", "mouseover" === e.type);
          }), this.options.content.button && this._createButton();
        }, T._removeTitle = function (t) {
          var e = this.elements;
          e.title && (e.titlebar.remove(), e.titlebar = e.title = e.button = R, t !== I && this.reposition());
        }, T._createPosClass = function (t) {
          return W + "-pos-" + (t || this.options.position.my).abbrev();
        }, T.reposition = function (e, n) {
          if (!this.rendered || this.positioning || this.destroyed) return this;
          this.positioning = C;
          var r,
            i,
            o,
            u,
            c = this.cache,
            l = this.tooltip,
            f = this.options.position,
            p = f.target,
            d = f.my,
            h = f.at,
            m = f.viewport,
            g = f.container,
            v = f.adjust,
            y = v.method.split(" "),
            _ = l.outerWidth(I),
            b = l.outerHeight(I),
            w = 0,
            S = 0,
            x = l.css("position"),
            E = {
              left: 0,
              top: 0
            },
            T = l[0].offsetWidth > 0,
            k = e && "scroll" === e.type,
            A = t(a),
            O = g[0].ownerDocument,
            R = this.mouse;
          if (t.isArray(p) && 2 === p.length) h = {
            x: D,
            y: F
          }, E = {
            left: p[0],
            top: p[1]
          };else if ("mouse" === p) h = {
            x: D,
            y: F
          }, (!v.mouse || this.options.hide.distance) && c.origin && c.origin.pageX ? e = c.origin : !e || e && ("resize" === e.type || "scroll" === e.type) ? e = c.event : R && R.pageX && (e = R), "static" !== x && (E = g.offset()), O.body.offsetWidth !== (a.innerWidth || O.documentElement.clientWidth) && (i = t(s.body).offset()), E = {
            left: e.pageX - E.left + (i && i.left || 0),
            top: e.pageY - E.top + (i && i.top || 0)
          }, v.mouse && k && R && (E.left -= (R.scrollX || 0) - A.scrollLeft(), E.top -= (R.scrollY || 0) - A.scrollTop());else {
            if ("event" === p ? e && e.target && "scroll" !== e.type && "resize" !== e.type ? c.target = t(e.target) : e.target || (c.target = this.elements.target) : "event" !== p && (c.target = t(p.jquery ? p : this.elements.target)), p = c.target, p = t(p).eq(0), 0 === p.length) return this;
            p[0] === s || p[0] === a ? (w = rt.iOS ? a.innerWidth : p.width(), S = rt.iOS ? a.innerHeight : p.height(), p[0] === a && (E = {
              top: (m || p).scrollTop(),
              left: (m || p).scrollLeft()
            })) : H.imagemap && p.is("area") ? r = H.imagemap(this, p, h, H.viewport ? y : I) : H.svg && p && p[0].ownerSVGElement ? r = H.svg(this, p, h, H.viewport ? y : I) : (w = p.outerWidth(I), S = p.outerHeight(I), E = p.offset()), r && (w = r.width, S = r.height, i = r.offset, E = r.position), E = this.reposition.offset(p, E, g), (rt.iOS > 3.1 && rt.iOS < 4.1 || rt.iOS >= 4.3 && rt.iOS < 4.33 || !rt.iOS && "fixed" === x) && (E.left -= A.scrollLeft(), E.top -= A.scrollTop()), (!r || r && r.adjustable !== I) && (E.left += h.x === U ? w : h.x === B ? w / 2 : 0, E.top += h.y === j ? S : h.y === B ? S / 2 : 0);
          }
          return E.left += v.x + (d.x === U ? -_ : d.x === B ? -_ / 2 : 0), E.top += v.y + (d.y === j ? -b : d.y === B ? -b / 2 : 0), H.viewport ? (o = E.adjusted = H.viewport(this, E, f, w, S, _, b), i && o.left && (E.left += i.left), i && o.top && (E.top += i.top), o.my && (this.position.my = o.my)) : E.adjusted = {
            left: 0,
            top: 0
          }, c.posClass !== (u = this._createPosClass(this.position.my)) && (c.posClass = u, l.removeClass(c.posClass).addClass(u)), this._trigger("move", [E, m.elem || m], e) ? (delete E.adjusted, n === I || !T || isNaN(E.left) || isNaN(E.top) || "mouse" === p || !t.isFunction(f.effect) ? l.css(E) : t.isFunction(f.effect) && (f.effect.call(l, this, t.extend({}, E)), l.queue(function (e) {
            t(this).css({
              opacity: "",
              height: ""
            }), rt.ie && this.style.removeAttribute("filter"), e();
          })), this.positioning = I, this) : this;
        }, T.reposition.offset = function (e, n, r) {
          function i(t, e) {
            n.left += e * t.scrollLeft(), n.top += e * t.scrollTop();
          }
          if (!r[0]) return n;
          var o,
            a,
            u,
            c,
            l = t(e[0].ownerDocument),
            f = !!rt.ie && "CSS1Compat" !== s.compatMode,
            p = r[0];
          do {
            "static" !== (a = t.css(p, "position")) && ("fixed" === a ? (u = p.getBoundingClientRect(), i(l, -1)) : (u = t(p).position(), u.left += parseFloat(t.css(p, "borderLeftWidth")) || 0, u.top += parseFloat(t.css(p, "borderTopWidth")) || 0), n.left -= u.left + (parseFloat(t.css(p, "marginLeft")) || 0), n.top -= u.top + (parseFloat(t.css(p, "marginTop")) || 0), o || "hidden" === (c = t.css(p, "overflow")) || "visible" === c || "BODY" === t.prop(p, "tagName") || (o = t(p)));
          } while (p = p.offsetParent);
          return o && (o[0] !== l[0] || f) && i(o, 1), n;
        };
        var at = (k = T.reposition.Corner = function (t, e) {
          t = ("" + t).replace(/([A-Z])/, " $1").replace(/middle/gi, B).toLowerCase(), this.x = (t.match(/left|right/i) || t.match(/center/) || ["inherit"])[0].toLowerCase(), this.y = (t.match(/top|bottom|center/i) || ["inherit"])[0].toLowerCase(), this.forceY = !!e;
          var n = t.charAt(0);
          this.precedance = "t" === n || "b" === n ? N : P;
        }).prototype;
        at.invert = function (t, e) {
          this[t] = this[t] === D ? U : this[t] === U ? D : e || this[t];
        }, at.string = function (t) {
          var e = this.x,
            n = this.y,
            r = e !== n ? "center" === e || "center" !== n && (this.precedance === N || this.forceY) ? [n, e] : [e, n] : [e];
          return !1 !== t ? r.join(" ") : r;
        }, at.abbrev = function () {
          var t = this.string(!1);
          return t[0].charAt(0) + (t[1] && t[1].charAt(0) || "");
        }, at.clone = function () {
          return new k(this.string(), this.forceY);
        }, T.toggle = function (e, n) {
          var r = this.cache,
            i = this.options,
            o = this.tooltip;
          if (n) {
            if (/over|enter/.test(n.type) && r.event && /out|leave/.test(r.event.type) && i.show.target.add(n.target).length === i.show.target.length && o.has(n.relatedTarget).length) return this;
            r.event = t.event.fix(n);
          }
          if (this.waiting && !e && (this.hiddenDuringWait = C), !this.rendered) return e ? this.render(1) : this;
          if (this.destroyed || this.disabled) return this;
          var a,
            u,
            c,
            l = e ? "show" : "hide",
            f = this.options[l],
            p = this.options.position,
            d = this.options.content,
            h = this.tooltip.css("width"),
            m = this.tooltip.is(":visible"),
            g = e || 1 === f.target.length,
            v = !n || f.target.length < 2 || r.target[0] === n.target;
          return (typeof e).search("boolean|number") && (e = !m), a = !o.is(":animated") && m === e && v, u = a ? R : !!this._trigger(l, [90]), this.destroyed ? this : (u !== I && e && this.focus(n), !u || a ? this : (t.attr(o[0], "aria-hidden", !e), e ? (this.mouse && (r.origin = t.event.fix(this.mouse)), t.isFunction(d.text) && this._updateContent(d.text, I), t.isFunction(d.title) && this._updateTitle(d.title, I), !O && "mouse" === p.target && p.adjust.mouse && (t(s).bind("mousemove." + W, this._storeMouse), O = C), h || o.css("width", o.outerWidth(I)), this.reposition(n, arguments[2]), h || o.css("width", ""), f.solo && ("string" == typeof f.solo ? t(f.solo) : t(K, f.solo)).not(o).not(f.target).qtip("hide", new t.Event("tooltipsolo"))) : (clearTimeout(this.timers.show), delete r.origin, O && !t(K + '[tracking="true"]:visible', f.solo).not(o).length && (t(s).unbind("mousemove." + W), O = I), this.blur(n)), c = t.proxy(function () {
            e ? (rt.ie && o[0].style.removeAttribute("filter"), o.css("overflow", ""), "string" == typeof f.autofocus && t(this.options.show.autofocus, o).focus(), this.options.show.target.trigger("qtip-" + this.id + "-inactive")) : o.css({
              display: "",
              visibility: "",
              opacity: "",
              left: "",
              top: ""
            }), this._trigger(e ? "visible" : "hidden");
          }, this), f.effect === I || g === I ? (o[l](), c()) : t.isFunction(f.effect) ? (o.stop(1, 1), f.effect.call(o, this), o.queue("fx", function (t) {
            c(), t();
          })) : o.fadeTo(90, e ? 1 : 0, c), e && f.target.trigger("qtip-" + this.id + "-inactive"), this));
        }, T.show = function (t) {
          return this.toggle(C, t);
        }, T.hide = function (t) {
          return this.toggle(I, t);
        }, T.focus = function (e) {
          if (!this.rendered || this.destroyed) return this;
          var n = t(K),
            r = this.tooltip,
            i = parseInt(r[0].style.zIndex, 10),
            o = E.zindex + n.length;
          return r.hasClass(X) || this._trigger("focus", [o], e) && (i !== o && (n.each(function () {
            this.style.zIndex > i && (this.style.zIndex = this.style.zIndex - 1);
          }), n.filter("." + X).qtip("blur", e)), r.addClass(X)[0].style.zIndex = o), this;
        }, T.blur = function (t) {
          return !this.rendered || this.destroyed ? this : (this.tooltip.removeClass(X), this._trigger("blur", [this.tooltip.css("zIndex")], t), this);
        }, T.disable = function (t) {
          return this.destroyed ? this : ("toggle" === t ? t = !(this.rendered ? this.tooltip.hasClass(tt) : this.disabled) : "boolean" != typeof t && (t = C), this.rendered && this.tooltip.toggleClass(tt, t).attr("aria-disabled", t), this.disabled = !!t, this);
        }, T.enable = function () {
          return this.disable(I);
        }, T._createButton = function () {
          var e = this,
            n = this.elements,
            r = n.tooltip,
            i = this.options.content.button,
            o = "string" == typeof i,
            a = o ? i : "Close tooltip";
          n.button && n.button.remove(), i.jquery ? n.button = i : n.button = t("<a />", {
            class: "qtip-close " + (this.options.style.widget ? "" : W + "-icon"),
            title: a,
            "aria-label": a
          }).prepend(t("<span />", {
            class: "ui-icon ui-icon-close",
            html: "&times;"
          })), n.button.appendTo(n.titlebar || r).attr("role", "button").click(function (t) {
            return r.hasClass(tt) || e.hide(t), I;
          });
        }, T._updateButton = function (t) {
          if (!this.rendered) return I;
          var e = this.elements.button;
          t ? this._createButton() : e.remove();
        }, T._setWidget = function () {
          var t = this.options.style.widget,
            e = this.elements,
            n = e.tooltip,
            r = n.hasClass(tt);
          n.removeClass(tt), tt = t ? "ui-state-disabled" : "qtip-disabled", n.toggleClass(tt, r), n.toggleClass("ui-helper-reset " + l(), t).toggleClass(Q, this.options.style.def && !t), e.content && e.content.toggleClass(l("content"), t), e.titlebar && e.titlebar.toggleClass(l("header"), t), e.button && e.button.toggleClass(W + "-icon", !t);
        }, T._storeMouse = function (e) {
          return (this.mouse = t.event.fix(e)).type = "mousemove", this;
        }, T._bind = function (e, n, r, i, o) {
          if (e && r && n.length) {
            var a = "." + this._id + (i ? "-" + i : "");
            return t(e).bind((n.split ? n : n.join(a + " ")) + a, t.proxy(r, o || this)), this;
          }
        }, T._unbind = function (e, n) {
          return e && t(e).unbind("." + this._id + (n ? "-" + n : "")), this;
        }, T._trigger = function (e, n, r) {
          var i = new t.Event("tooltip" + e);
          return i.originalEvent = r && t.extend({}, r) || this.cache.event || R, this.triggering = e, this.tooltip.trigger(i, [this].concat(n || [])), this.triggering = I, !i.isDefaultPrevented();
        }, T._bindEvents = function (e, n, r, i, o, a) {
          var s = r.filter(i).add(i.filter(r)),
            u = [];
          s.length && (t.each(n, function (n, r) {
            var i = t.inArray(r, e);
            i > -1 && u.push(e.splice(i, 1)[0]);
          }), u.length && (this._bind(s, u, function (t) {
            (!!this.rendered && this.tooltip[0].offsetWidth > 0 ? a : o).call(this, t);
          }), r = r.not(s), i = i.not(s))), this._bind(r, e, o), this._bind(i, n, a);
        }, T._assignInitialEvents = function (e) {
          function n(e) {
            return this.disabled || this.destroyed ? I : (this.cache.event = e && t.event.fix(e), this.cache.target = e && t(e.target), clearTimeout(this.timers.show), void (this.timers.show = f.call(this, function () {
              this.render("object" == typeof e || r.show.ready);
            }, r.prerender ? 0 : r.show.delay)));
          }
          var r = this.options,
            i = r.show.target,
            o = r.hide.target,
            a = r.show.event ? t.trim("" + r.show.event).split(" ") : [],
            s = r.hide.event ? t.trim("" + r.hide.event).split(" ") : [];
          this._bind(this.elements.target, ["remove", "removeqtip"], function () {
            this.destroy(!0);
          }, "destroy"), /mouse(over|enter)/i.test(r.show.event) && !/mouse(out|leave)/i.test(r.hide.event) && s.push("mouseleave"), this._bind(i, "mousemove", function (t) {
            this._storeMouse(t), this.cache.onTarget = C;
          }), this._bindEvents(a, s, i, o, n, function () {
            return this.timers ? void clearTimeout(this.timers.show) : I;
          }), (r.show.ready || r.prerender) && n.call(this, e);
        }, T._assignEvents = function () {
          var e = this,
            n = this.options,
            r = n.position,
            i = this.tooltip,
            o = n.show.target,
            u = n.hide.target,
            c = r.container,
            l = r.viewport,
            f = t(s),
            g = t(a),
            v = n.show.event ? t.trim("" + n.show.event).split(" ") : [],
            y = n.hide.event ? t.trim("" + n.hide.event).split(" ") : [];
          t.each(n.events, function (t, n) {
            e._bind(i, "toggle" === t ? ["tooltipshow", "tooltiphide"] : ["tooltip" + t], n, null, i);
          }), /mouse(out|leave)/i.test(n.hide.event) && "window" === n.hide.leave && this._bind(f, ["mouseout", "blur"], function (t) {
            /select|option/.test(t.target.nodeName) || t.relatedTarget || this.hide(t);
          }), n.hide.fixed ? u = u.add(i.addClass(J)) : /mouse(over|enter)/i.test(n.show.event) && this._bind(u, "mouseleave", function () {
            clearTimeout(this.timers.show);
          }), ("" + n.hide.event).indexOf("unfocus") > -1 && this._bind(c.closest("html"), ["mousedown", "touchstart"], function (e) {
            var n = t(e.target),
              r = this.rendered && !this.tooltip.hasClass(tt) && this.tooltip[0].offsetWidth > 0,
              i = n.parents(K).filter(this.tooltip[0]).length > 0;
            n[0] === this.target[0] || n[0] === this.tooltip[0] || i || this.target.has(n[0]).length || !r || this.hide(e);
          }), "number" == typeof n.hide.inactive && (this._bind(o, "qtip-" + this.id + "-inactive", h, "inactive"), this._bind(u.add(i), E.inactiveEvents, h)), this._bindEvents(v, y, o, u, p, d), this._bind(o.add(i), "mousemove", function (t) {
            if ("number" == typeof n.hide.distance) {
              var e = this.cache.origin || {},
                r = this.options.hide.distance,
                i = Math.abs;
              (i(t.pageX - e.pageX) >= r || i(t.pageY - e.pageY) >= r) && this.hide(t);
            }
            this._storeMouse(t);
          }), "mouse" === r.target && r.adjust.mouse && (n.hide.event && this._bind(o, ["mouseenter", "mouseleave"], function (t) {
            return this.cache ? void (this.cache.onTarget = "mouseenter" === t.type) : I;
          }), this._bind(f, "mousemove", function (t) {
            this.rendered && this.cache.onTarget && !this.tooltip.hasClass(tt) && this.tooltip[0].offsetWidth > 0 && this.reposition(t);
          })), (r.adjust.resize || l.length) && this._bind(t.event.special.resize ? l : g, "resize", m), r.adjust.scroll && this._bind(g.add(r.container), "scroll", m);
        }, T._unassignEvents = function () {
          var e = this.options,
            n = e.show.target,
            r = e.hide.target,
            i = t.grep([this.elements.target[0], this.rendered && this.tooltip[0], e.position.container[0], e.position.viewport[0], e.position.container.closest("html")[0], a, s], function (t) {
              return "object" == typeof t;
            });
          n && n.toArray && (i = i.concat(n.toArray())), r && r.toArray && (i = i.concat(r.toArray())), this._unbind(i)._unbind(i, "destroy")._unbind(i, "inactive");
        }, t(function () {
          g(K, ["mouseenter", "mouseleave"], function (e) {
            var n = "mouseenter" === e.type,
              r = t(e.currentTarget),
              i = t(e.relatedTarget || e.target),
              o = this.options;
            n ? (this.focus(e), r.hasClass(J) && !r.hasClass(tt) && clearTimeout(this.timers.hide)) : "mouse" === o.position.target && o.position.adjust.mouse && o.hide.event && o.show.target && !i.closest(o.show.target[0]).length && this.hide(e), r.toggleClass(Z, n);
          }), g("[" + z + "]", Y, h);
        }), E = t.fn.qtip = function (e, n, r) {
          var o = ("" + e).toLowerCase(),
            a = R,
            s = t.makeArray(arguments).slice(1),
            c = s[s.length - 1],
            l = this[0] ? t.data(this[0], W) : R;
          return !arguments.length && l || "api" === o ? l : "string" == typeof e ? (this.each(function () {
            var e = t.data(this, W);
            if (!e) return C;
            if (c && c.timeStamp && (e.cache.event = c), !n || "option" !== o && "options" !== o) e[o] && e[o].apply(e, s);else {
              if (r === u && !t.isPlainObject(n)) return a = e.get(n), I;
              e.set(n, r);
            }
          }), a !== R ? a : this) : "object" != typeof e && arguments.length ? void 0 : (l = i(t.extend(C, {}, e)), this.each(function (e) {
            var n, r;
            return r = t.isArray(l.id) ? l.id[e] : l.id, r = !r || r === I || r.length < 1 || E.api[r] ? E.nextid++ : r, n = v(t(this), r, l), n === I ? C : (E.api[r] = n, t.each(H, function () {
              "initialize" === this.initialize && this(n);
            }), void n._assignInitialEvents(c));
          }));
        }, t.qtip = e, E.api = {}, t.each({
          attr: function attr(e, n) {
            if (this.length) {
              var r = this[0],
                i = "title",
                o = t.data(r, "qtip");
              if (e === i && o && o.options && "object" == typeof o && "object" == typeof o.options && o.options.suppress) return arguments.length < 2 ? t.attr(r, nt) : (o && o.options.content.attr === i && o.cache.attr && o.set("content.text", n), this.attr(nt, n));
            }
            return t.fn["attr" + et].apply(this, arguments);
          },
          clone: function clone(e) {
            var n = t.fn["clone" + et].apply(this, arguments);
            return e || n.filter("[" + nt + "]").attr("title", function () {
              return t.attr(this, nt);
            }).removeAttr(nt), n;
          }
        }, function (e, n) {
          if (!n || t.fn[e + et]) return C;
          var r = t.fn[e + et] = t.fn[e];
          t.fn[e] = function () {
            return n.apply(this, arguments) || r.apply(this, arguments);
          };
        }), t.ui || (t["cleanData" + et] = t.cleanData, t.cleanData = function (e) {
          for (var n, r = 0; (n = t(e[r])).length; r++) if (n.attr($)) try {
            n.triggerHandler("removeqtip");
          } catch (t) {}
          t["cleanData" + et].apply(this, arguments);
        }), E.version = "3.0.3-5-g", E.nextid = 0, E.inactiveEvents = Y, E.zindex = 15e3, E.defaults = {
          prerender: I,
          id: I,
          overwrite: C,
          suppress: C,
          content: {
            text: C,
            attr: "title",
            title: I,
            button: I
          },
          position: {
            my: "top left",
            at: "bottom right",
            target: I,
            container: I,
            viewport: I,
            adjust: {
              x: 0,
              y: 0,
              mouse: C,
              scroll: C,
              resize: C,
              method: "flipinvert flipinvert"
            },
            effect: function effect(e, n) {
              t(this).animate(n, {
                duration: 200,
                queue: I
              });
            }
          },
          show: {
            target: I,
            event: "mouseenter",
            effect: C,
            delay: 90,
            solo: I,
            ready: I,
            autofocus: I
          },
          hide: {
            target: I,
            event: "mouseleave",
            effect: C,
            delay: 0,
            fixed: I,
            inactive: I,
            leave: "window",
            distance: I
          },
          style: {
            classes: "",
            widget: I,
            width: I,
            height: I,
            def: C
          },
          events: {
            render: R,
            move: R,
            show: R,
            hide: R,
            toggle: R,
            visible: R,
            hidden: R,
            focus: R,
            blur: R
          }
        };
        var st,
          ut,
          ct,
          lt,
          ft,
          pt = "margin",
          dt = "border",
          ht = "color",
          mt = "background-color",
          gt = "transparent",
          vt = " !important",
          yt = !!s.createElement("canvas").getContext,
          _t = /rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i,
          bt = {},
          wt = ["Webkit", "O", "Moz", "ms"];
        yt ? (lt = a.devicePixelRatio || 1, ft = function () {
          var t = s.createElement("canvas").getContext("2d");
          return t.backingStorePixelRatio || t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || 1;
        }(), ct = lt / ft) : ut = function ut(t, e, n) {
          return "<qtipvml:" + t + ' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" ' + (e || "") + ' style="behavior: url(#default#VML); ' + (n || "") + '" />';
        }, t.extend(w.prototype, {
          init: function init(e) {
            var n, r;
            r = this.element = e.elements.tip = t("<div />", {
              class: W + "-tip"
            }).prependTo(e.tooltip), yt ? (n = t("<canvas />").appendTo(this.element)[0].getContext("2d"), n.lineJoin = "miter", n.miterLimit = 1e5, n.save()) : (n = ut("shape", 'coordorigin="0,0"', "position:absolute;"), this.element.html(n + n), e._bind(t("*", r).add(r), ["click", "mousedown"], function (t) {
              t.stopPropagation();
            }, this._ns)), e._bind(e.tooltip, "tooltipmove", this.reposition, this._ns, this), this.create();
          },
          _swapDimensions: function _swapDimensions() {
            this.size[0] = this.options.height, this.size[1] = this.options.width;
          },
          _resetDimensions: function _resetDimensions() {
            this.size[0] = this.options.width, this.size[1] = this.options.height;
          },
          _useTitle: function _useTitle(t) {
            var e = this.qtip.elements.titlebar;
            return e && (t.y === F || t.y === B && this.element.position().top + this.size[1] / 2 + this.options.offset < e.outerHeight(C));
          },
          _parseCorner: function _parseCorner(t) {
            var e = this.qtip.options.position.my;
            return t === I || e === I ? t = I : t === C ? t = new k(e.string()) : t.string || (t = new k(t), t.fixed = C), t;
          },
          _parseWidth: function _parseWidth(t, e, n) {
            var r = this.qtip.elements,
              i = dt + y(e) + "Width";
            return (n ? b(n, i) : b(r.content, i) || b(this._useTitle(t) && r.titlebar || r.content, i) || b(r.tooltip, i)) || 0;
          },
          _parseRadius: function _parseRadius(t) {
            var e = this.qtip.elements,
              n = dt + y(t.y) + y(t.x) + "Radius";
            return rt.ie < 9 ? 0 : b(this._useTitle(t) && e.titlebar || e.content, n) || b(e.tooltip, n) || 0;
          },
          _invalidColour: function _invalidColour(t, e, n) {
            var r = t.css(e);
            return !r || n && r === t.css(n) || _t.test(r) ? I : r;
          },
          _parseColours: function _parseColours(e) {
            var n = this.qtip.elements,
              r = this.element.css("cssText", ""),
              i = dt + y(e[e.precedance]) + y(ht),
              o = this._useTitle(e) && n.titlebar || n.content,
              a = this._invalidColour,
              s = [];
            return s[0] = a(r, mt) || a(o, mt) || a(n.content, mt) || a(n.tooltip, mt) || r.css(mt), s[1] = a(r, i, ht) || a(o, i, ht) || a(n.content, i, ht) || a(n.tooltip, i, ht) || n.tooltip.css(i), t("*", r).add(r).css("cssText", mt + ":" + gt + vt + ";" + dt + ":0" + vt + ";"), s;
          },
          _calculateSize: function _calculateSize(t) {
            var e,
              n,
              r,
              i = t.precedance === N,
              o = this.options.width,
              a = this.options.height,
              s = "c" === t.abbrev(),
              u = (i ? o : a) * (s ? .5 : 1),
              c = Math.pow,
              l = Math.round,
              f = Math.sqrt(c(u, 2) + c(a, 2)),
              p = [this.border / u * f, this.border / a * f];
            return p[2] = Math.sqrt(c(p[0], 2) - c(this.border, 2)), p[3] = Math.sqrt(c(p[1], 2) - c(this.border, 2)), e = f + p[2] + p[3] + (s ? 0 : p[0]), n = e / f, r = [l(n * o), l(n * a)], i ? r : r.reverse();
          },
          _calculateTip: function _calculateTip(t, e, n) {
            n = n || 1, e = e || this.size;
            var r = e[0] * n,
              i = e[1] * n,
              o = Math.ceil(r / 2),
              a = Math.ceil(i / 2),
              s = {
                br: [0, 0, r, i, r, 0],
                bl: [0, 0, r, 0, 0, i],
                tr: [0, i, r, 0, r, i],
                tl: [0, 0, 0, i, r, i],
                tc: [0, i, o, 0, r, i],
                bc: [0, 0, r, 0, o, i],
                rc: [0, 0, r, a, 0, i],
                lc: [r, 0, r, i, 0, a]
              };
            return s.lt = s.br, s.rt = s.bl, s.lb = s.tr, s.rb = s.tl, s[t.abbrev()];
          },
          _drawCoords: function _drawCoords(t, e) {
            t.beginPath(), t.moveTo(e[0], e[1]), t.lineTo(e[2], e[3]), t.lineTo(e[4], e[5]), t.closePath();
          },
          create: function create() {
            var t = this.corner = (yt || rt.ie) && this._parseCorner(this.options.corner);
            return this.enabled = !!this.corner && "c" !== this.corner.abbrev(), this.enabled && (this.qtip.cache.corner = t.clone(), this.update()), this.element.toggle(this.enabled), this.corner;
          },
          update: function update(e, n) {
            if (!this.enabled) return this;
            var r,
              i,
              o,
              s,
              u,
              c,
              l,
              f,
              p = this.qtip.elements,
              d = this.element,
              h = d.children(),
              m = this.options,
              g = this.size,
              v = m.mimic,
              y = Math.round;
            e || (e = this.qtip.cache.corner || this.corner), v === I ? v = e : (v = new k(v), v.precedance = e.precedance, "inherit" === v.x ? v.x = e.x : "inherit" === v.y ? v.y = e.y : v.x === v.y && (v[e.precedance] = e[e.precedance])), i = v.precedance, e.precedance === P ? this._swapDimensions() : this._resetDimensions(), r = this.color = this._parseColours(e), r[1] !== gt ? (f = this.border = this._parseWidth(e, e[e.precedance]), m.border && f < 1 && !_t.test(r[1]) && (r[0] = r[1]), this.border = f = m.border !== C ? m.border : f) : this.border = f = 0, l = this.size = this._calculateSize(e), d.css({
              width: l[0],
              height: l[1],
              lineHeight: l[1] + "px"
            }), c = e.precedance === N ? [y(v.x === D ? f : v.x === U ? l[0] - g[0] - f : (l[0] - g[0]) / 2), y(v.y === F ? l[1] - g[1] : 0)] : [y(v.x === D ? l[0] - g[0] : 0), y(v.y === F ? f : v.y === j ? l[1] - g[1] - f : (l[1] - g[1]) / 2)], yt ? (o = h[0].getContext("2d"), o.restore(), o.save(), o.clearRect(0, 0, 6e3, 6e3), s = this._calculateTip(v, g, ct), u = this._calculateTip(v, this.size, ct), h.attr(M, l[0] * ct).attr(L, l[1] * ct), h.css(M, l[0]).css(L, l[1]), this._drawCoords(o, u), o.fillStyle = r[1], o.fill(), o.translate(c[0] * ct, c[1] * ct), this._drawCoords(o, s), o.fillStyle = r[0], o.fill()) : (s = this._calculateTip(v), s = "m" + s[0] + "," + s[1] + " l" + s[2] + "," + s[3] + " " + s[4] + "," + s[5] + " xe", c[2] = f && /^(r|b)/i.test(e.string()) ? 8 === rt.ie ? 2 : 1 : 0, h.css({
              coordsize: l[0] + f + " " + l[1] + f,
              antialias: "" + (v.string().indexOf(B) > -1),
              left: c[0] - c[2] * Number(i === P),
              top: c[1] - c[2] * Number(i === N),
              width: l[0] + f,
              height: l[1] + f
            }).each(function (e) {
              var n = t(this);
              n[n.prop ? "prop" : "attr"]({
                coordsize: l[0] + f + " " + l[1] + f,
                path: s,
                fillcolor: r[0],
                filled: !!e,
                stroked: !e
              }).toggle(!(!f && !e)), !e && n.html(ut("stroke", 'weight="' + 2 * f + 'px" color="' + r[1] + '" miterlimit="1000" joinstyle="miter"'));
            })), a.opera && setTimeout(function () {
              p.tip.css({
                display: "inline-block",
                visibility: "visible"
              });
            }, 1), n !== I && this.calculate(e, l);
          },
          calculate: function calculate(e, n) {
            if (!this.enabled) return I;
            var r,
              i,
              o = this,
              a = this.qtip.elements,
              s = this.element,
              u = this.options.offset,
              c = {};
            return e = e || this.corner, r = e.precedance, n = n || this._calculateSize(e), i = [e.x, e.y], r === P && i.reverse(), t.each(i, function (t, i) {
              var s, l, f;
              i === B ? (s = r === N ? D : F, c[s] = "50%", c[pt + "-" + s] = -Math.round(n[r === N ? 0 : 1] / 2) + u) : (s = o._parseWidth(e, i, a.tooltip), l = o._parseWidth(e, i, a.content), f = o._parseRadius(e), c[i] = Math.max(-o.border, t ? l : u + (f > s ? f : -s)));
            }), c[e[r]] -= n[r === P ? 0 : 1], s.css({
              margin: "",
              top: "",
              bottom: "",
              left: "",
              right: ""
            }).css(c), c;
          },
          reposition: function reposition(t, e, n) {
            function r(t, e, n, r, i) {
              t === q && c.precedance === e && l[r] && c[n] !== B ? c.precedance = c.precedance === P ? N : P : t !== q && l[r] && (c[e] = c[e] === B ? l[r] > 0 ? r : i : c[e] === r ? i : r);
            }
            function i(t, e, r) {
              c[t] === B ? m[pt + "-" + e] = h[t] = o[pt + "-" + e] - l[e] : (a = o[r] !== u ? [l[e], -o[e]] : [-l[e], o[e]], (h[t] = Math.max(a[0], a[1])) > a[0] && (n[e] -= l[e], h[e] = I), m[o[r] !== u ? r : e] = h[t]);
            }
            if (this.enabled) {
              var o,
                a,
                s = e.cache,
                c = this.corner.clone(),
                l = n.adjusted,
                f = e.options.position.adjust.method.split(" "),
                p = f[0],
                d = f[1] || f[0],
                h = {
                  left: I,
                  top: I,
                  x: 0,
                  y: 0
                },
                m = {};
              this.corner.fixed !== C && (r(p, P, N, D, U), r(d, N, P, F, j), c.string() === s.corner.string() && s.cornerTop === l.top && s.cornerLeft === l.left || this.update(c, I)), o = this.calculate(c), o.right !== u && (o.left = -o.right), o.bottom !== u && (o.top = -o.bottom), o.user = this.offset, h.left = p === q && !!l.left, h.left && i(P, D, U), h.top = d === q && !!l.top, h.top && i(N, F, j), this.element.css(m).toggle(!(h.x && h.y || c.x === B && h.y || c.y === B && h.x)), n.left -= o.left.charAt ? o.user : p !== q || h.top || !h.left && !h.top ? o.left + this.border : 0, n.top -= o.top.charAt ? o.user : d !== q || h.left || !h.left && !h.top ? o.top + this.border : 0, s.cornerLeft = l.left, s.cornerTop = l.top, s.corner = c.clone();
            }
          },
          destroy: function destroy() {
            this.qtip._unbind(this.qtip.tooltip, this._ns), this.qtip.elements.tip && this.qtip.elements.tip.find("*").remove().end().remove();
          }
        }), st = H.tip = function (t) {
          return new w(t, t.options.style.tip);
        }, st.initialize = "render", st.sanitize = function (t) {
          if (t.style && "tip" in t.style) {
            var e = t.style.tip;
            "object" != typeof e && (e = t.style.tip = {
              corner: e
            }), /string|boolean/i.test(typeof e.corner) || (e.corner = C);
          }
        }, A.tip = {
          "^position.my|style.tip.(corner|mimic|border)$": function positionMyStyleTipCornerMimicBorder$() {
            this.create(), this.qtip.reposition();
          },
          "^style.tip.(height|width)$": function styleTipHeightWidth$(t) {
            this.size = [t.width, t.height], this.update(), this.qtip.reposition();
          },
          "^content.title|style.(classes|widget)$": function contentTitleStyleClassesWidget$() {
            this.update();
          }
        }, t.extend(C, E.defaults, {
          style: {
            tip: {
              corner: C,
              mimic: I,
              width: 6,
              height: 6,
              border: C,
              offset: 0
            }
          }
        });
        var St,
          xt,
          Et = "qtip-modal",
          Tt = "." + Et;
        xt = function xt() {
          function e(e) {
            if (t.expr[":"].focusable) return t.expr[":"].focusable;
            var n,
              r,
              i,
              o = !isNaN(t.attr(e, "tabindex")),
              a = e.nodeName && e.nodeName.toLowerCase();
            return "area" === a ? (n = e.parentNode, r = n.name, !(!e.href || !r || "map" !== n.nodeName.toLowerCase()) && !!(i = t("img[usemap=#" + r + "]")[0]) && i.is(":visible")) : /input|select|textarea|button|object/.test(a) ? !e.disabled : "a" === a ? e.href || o : o;
          }
          function n(t) {
            c.length < 1 && t.length ? t.not("body").blur() : c.first().focus();
          }
          function r(e) {
            if (a.is(":visible")) {
              var r = t(e.target),
                o = i.tooltip,
                s = r.closest(K);
              (s.length < 1 ? I : parseInt(s[0].style.zIndex, 10) > parseInt(o[0].style.zIndex, 10)) || r.closest(K)[0] === o[0] || n(r);
            }
          }
          var i,
            o,
            a,
            u = this,
            c = {};
          t.extend(u, {
            init: function init() {
              return a = u.elem = t("<div />", {
                id: "qtip-overlay",
                html: "<div></div>",
                mousedown: function mousedown() {
                  return I;
                }
              }).hide(), t(s.body).bind("focusin" + Tt, r), t(s).bind("keydown" + Tt, function (t) {
                i && i.options.show.modal.escape && 27 === t.keyCode && i.hide(t);
              }), a.bind("click" + Tt, function (t) {
                i && i.options.show.modal.blur && i.hide(t);
              }), u;
            },
            update: function update(t) {
              i = t, c = t.options.show.modal.stealfocus !== I ? t.tooltip.find("*").filter(function () {
                return e(this);
              }) : [];
            },
            toggle: function toggle(e, r, c) {
              var l = e.tooltip,
                f = e.options.show.modal,
                p = f.effect,
                d = r ? "show" : "hide",
                h = a.is(":visible"),
                m = t(Tt).filter(":visible:not(:animated)").not(l);
              return u.update(e), r && f.stealfocus !== I && n(t(":focus")), a.toggleClass("blurs", f.blur), r && a.appendTo(s.body), a.is(":animated") && h === r && o !== I || !r && m.length ? u : (a.stop(C, I), t.isFunction(p) ? p.call(a, r) : p === I ? a[d]() : a.fadeTo(parseInt(c, 10) || 90, r ? 1 : 0, function () {
                r || a.hide();
              }), r || a.queue(function (e) {
                a.css({
                  left: "",
                  top: ""
                }), t(Tt).length || a.detach(), e();
              }), o = r, i.destroyed && (i = R), u);
            }
          }), u.init();
        }, xt = new xt(), t.extend(S.prototype, {
          init: function init(e) {
            var n = e.tooltip;
            return this.options.on ? (e.elements.overlay = xt.elem, n.addClass(Et).css("z-index", E.modal_zindex + t(Tt).length), e._bind(n, ["tooltipshow", "tooltiphide"], function (e, r, i) {
              var o = e.originalEvent;
              if (e.target === n[0]) if (o && "tooltiphide" === e.type && /mouse(leave|enter)/.test(o.type) && t(o.relatedTarget).closest(xt.elem[0]).length) try {
                e.preventDefault();
              } catch (t) {} else (!o || o && "tooltipsolo" !== o.type) && this.toggle(e, "tooltipshow" === e.type, i);
            }, this._ns, this), e._bind(n, "tooltipfocus", function (e, r) {
              if (!e.isDefaultPrevented() && e.target === n[0]) {
                var i = t(Tt),
                  o = E.modal_zindex + i.length,
                  a = parseInt(n[0].style.zIndex, 10);
                xt.elem[0].style.zIndex = o - 1, i.each(function () {
                  this.style.zIndex > a && (this.style.zIndex -= 1);
                }), i.filter("." + X).qtip("blur", e.originalEvent), n.addClass(X)[0].style.zIndex = o, xt.update(r);
                try {
                  e.preventDefault();
                } catch (t) {}
              }
            }, this._ns, this), void e._bind(n, "tooltiphide", function (e) {
              e.target === n[0] && t(Tt).filter(":visible").not(n).last().qtip("focus", e);
            }, this._ns, this)) : this;
          },
          toggle: function toggle(t, e, n) {
            return t && t.isDefaultPrevented() ? this : void xt.toggle(this.qtip, !!e, n);
          },
          destroy: function destroy() {
            this.qtip.tooltip.removeClass(Et), this.qtip._unbind(this.qtip.tooltip, this._ns), xt.toggle(this.qtip, I), delete this.qtip.elements.overlay;
          }
        }), St = H.modal = function (t) {
          return new S(t, t.options.show.modal);
        }, St.sanitize = function (t) {
          t.show && ("object" != typeof t.show.modal ? t.show.modal = {
            on: !!t.show.modal
          } : void 0 === t.show.modal.on && (t.show.modal.on = C));
        }, E.modal_zindex = E.zindex - 200, St.initialize = "render", A.modal = {
          "^show.modal.(on|blur)$": function showModalOnBlur$() {
            this.destroy(), this.init(), this.qtip.elems.overlay.toggle(this.qtip.tooltip[0].offsetWidth > 0);
          }
        }, t.extend(C, E.defaults, {
          show: {
            modal: {
              on: I,
              effect: C,
              blur: C,
              stealfocus: C,
              escape: C
            }
          }
        }), H.viewport = function (t, e, n, r, i, o, u) {
          function c(t, n, r, i, o, a, s, u, c) {
            var l = e[o],
              y = b[t],
              _ = w[t],
              S = r === q,
              x = y === o ? c : y === a ? -c : -c / 2,
              E = _ === o ? u : _ === a ? -u : -u / 2,
              T = g[o] + v[o] - (d ? 0 : p[o]),
              k = T - l,
              A = l + c - (s === M ? h : m) - T,
              O = x - (b.precedance === t || y === b[n] ? E : 0) - (_ === B ? u / 2 : 0);
            return S ? (O = (y === o ? 1 : -1) * x, e[o] += k > 0 ? k : A > 0 ? -A : 0, e[o] = Math.max(-p[o] + v[o], l - O, Math.min(Math.max(-p[o] + v[o] + (s === M ? h : m), l + O), e[o], "center" === y ? l - x : 1e9))) : (i *= r === V ? 2 : 0, k > 0 && (y !== o || A > 0) ? (e[o] -= O + i, f.invert(t, o)) : A > 0 && (y !== a || k > 0) && (e[o] -= (y === B ? -O : O) + i, f.invert(t, a)), e[o] < g[o] && -e[o] > A && (e[o] = l, f = b.clone())), e[o] - l;
          }
          var l,
            f,
            p,
            d,
            h,
            m,
            g,
            v,
            y = n.target,
            _ = t.elements.tooltip,
            b = n.my,
            w = n.at,
            S = n.adjust,
            x = S.method.split(" "),
            E = x[0],
            T = x[1] || x[0],
            k = n.viewport,
            A = n.container,
            O = {
              left: 0,
              top: 0
            };
          return k.jquery && y[0] !== a && y[0] !== s.body && "none" !== S.method ? (p = A.offset() || O, d = "static" === A.css("position"), l = "fixed" === _.css("position"), h = k[0] === a ? k.width() : k.outerWidth(I), m = k[0] === a ? k.height() : k.outerHeight(I), g = {
            left: l ? 0 : k.scrollLeft(),
            top: l ? 0 : k.scrollTop()
          }, v = k.offset() || O, "shift" === E && "shift" === T || (f = b.clone()), O = {
            left: "none" !== E ? c(P, N, E, S.x, D, U, M, r, o) : 0,
            top: "none" !== T ? c(N, P, T, S.y, F, j, L, i, u) : 0,
            my: f
          }) : O;
        }, H.polys = {
          polygon: function polygon(t, e) {
            var n,
              r,
              i,
              o = {
                width: 0,
                height: 0,
                position: {
                  top: 1e10,
                  right: 0,
                  bottom: 0,
                  left: 1e10
                },
                adjustable: I
              },
              a = 0,
              s = [],
              u = 1,
              c = 1,
              l = 0,
              f = 0;
            for (a = t.length; a--;) n = [parseInt(t[--a], 10), parseInt(t[a + 1], 10)], n[0] > o.position.right && (o.position.right = n[0]), n[0] < o.position.left && (o.position.left = n[0]), n[1] > o.position.bottom && (o.position.bottom = n[1]), n[1] < o.position.top && (o.position.top = n[1]), s.push(n);
            if (r = o.width = Math.abs(o.position.right - o.position.left), i = o.height = Math.abs(o.position.bottom - o.position.top), "c" === e.abbrev()) o.position = {
              left: o.position.left + o.width / 2,
              top: o.position.top + o.height / 2
            };else {
              for (; r > 0 && i > 0 && u > 0 && c > 0;) for (r = Math.floor(r / 2), i = Math.floor(i / 2), e.x === D ? u = r : e.x === U ? u = o.width - r : u += Math.floor(r / 2), e.y === F ? c = i : e.y === j ? c = o.height - i : c += Math.floor(i / 2), a = s.length; a-- && !(s.length < 2);) l = s[a][0] - o.position.left, f = s[a][1] - o.position.top, (e.x === D && l >= u || e.x === U && l <= u || e.x === B && (l < u || l > o.width - u) || e.y === F && f >= c || e.y === j && f <= c || e.y === B && (f < c || f > o.height - c)) && s.splice(a, 1);
              o.position = {
                left: s[0][0],
                top: s[0][1]
              };
            }
            return o;
          },
          rect: function rect(t, e, n, r) {
            return {
              width: Math.abs(n - t),
              height: Math.abs(r - e),
              position: {
                left: Math.min(t, n),
                top: Math.min(e, r)
              }
            };
          },
          _angles: {
            tc: 1.5,
            tr: 7 / 4,
            tl: 5 / 4,
            bc: .5,
            br: .25,
            bl: .75,
            rc: 2,
            lc: 1,
            c: 0
          },
          ellipse: function ellipse(t, e, n, r, i) {
            var o = H.polys._angles[i.abbrev()],
              a = 0 === o ? 0 : n * Math.cos(o * Math.PI),
              s = r * Math.sin(o * Math.PI);
            return {
              width: 2 * n - Math.abs(a),
              height: 2 * r - Math.abs(s),
              position: {
                left: t + a,
                top: e + s
              },
              adjustable: I
            };
          },
          circle: function circle(t, e, n, r) {
            return H.polys.ellipse(t, e, n, n, r);
          }
        }, H.svg = function (e, n, r) {
          for (var i, o, a, u, c, l, f, p, d, h = n[0], m = t(h.ownerSVGElement), g = h.ownerDocument, v = (parseInt(n.css("stroke-width"), 10) || 0) / 2; !h.getBBox;) h = h.parentNode;
          if (!h.getBBox || !h.parentNode) return I;
          switch (h.nodeName) {
            case "ellipse":
            case "circle":
              p = H.polys.ellipse(h.cx.baseVal.value, h.cy.baseVal.value, (h.rx || h.r).baseVal.value + v, (h.ry || h.r).baseVal.value + v, r);
              break;
            case "line":
            case "polygon":
            case "polyline":
              for (f = h.points || [{
                x: h.x1.baseVal.value,
                y: h.y1.baseVal.value
              }, {
                x: h.x2.baseVal.value,
                y: h.y2.baseVal.value
              }], p = [], l = -1, u = f.numberOfItems || f.length; ++l < u;) c = f.getItem ? f.getItem(l) : f[l], p.push.apply(p, [c.x, c.y]);
              p = H.polys.polygon(p, r);
              break;
            default:
              p = h.getBBox(), p = {
                width: p.width,
                height: p.height,
                position: {
                  left: p.x,
                  top: p.y
                }
              };
          }
          return d = p.position, m = m[0], m.createSVGPoint && (o = h.getScreenCTM(), f = m.createSVGPoint(), f.x = d.left, f.y = d.top, a = f.matrixTransform(o), d.left = a.x, d.top = a.y), g !== s && "mouse" !== e.position.target && (i = t((g.defaultView || g.parentWindow).frameElement).offset()) && (d.left += i.left, d.top += i.top), g = t(g), d.left += g.scrollLeft(), d.top += g.scrollTop(), p;
        }, H.imagemap = function (e, n, r) {
          n.jquery || (n = t(n));
          var i,
            o,
            a,
            s,
            u,
            c = (n.attr("shape") || "rect").toLowerCase().replace("poly", "polygon"),
            l = t('img[usemap="#' + n.parent("map").attr("name") + '"]'),
            f = t.trim(n.attr("coords")),
            p = f.replace(/,$/, "").split(",");
          if (!l.length) return I;
          if ("polygon" === c) s = H.polys.polygon(p, r);else {
            if (!H.polys[c]) return I;
            for (a = -1, u = p.length, o = []; ++a < u;) o.push(parseInt(p[a], 10));
            s = H.polys[c].apply(this, o.concat(r));
          }
          return i = l.offset(), i.left += Math.ceil((l.outerWidth(I) - l.width()) / 2), i.top += Math.ceil((l.outerHeight(I) - l.height()) / 2), s.position.left += i.left, s.position.top += i.top, s;
        };
        var kt;
        t.extend(x.prototype, {
          _scroll: function _scroll() {
            var e = this.qtip.elements.overlay;
            e && (e[0].style.top = t(a).scrollTop() + "px");
          },
          init: function init(e) {
            var n = e.tooltip;
            t("select, object").length < 1 && (this.bgiframe = e.elements.bgiframe = t('<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';"  style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>').appendTo(n), e._bind(n, "tooltipmove", this.adjustBGIFrame, this._ns, this)), this.redrawContainer = t("<div/>", {
              id: W + "-rcontainer"
            }).appendTo(s.body), e.elements.overlay && e.elements.overlay.addClass("qtipmodal-ie6fix") && (e._bind(a, ["scroll", "resize"], this._scroll, this._ns, this), e._bind(n, ["tooltipshow"], this._scroll, this._ns, this)), this.redraw();
          },
          adjustBGIFrame: function adjustBGIFrame() {
            var t,
              e,
              n = this.qtip.tooltip,
              r = {
                height: n.outerHeight(I),
                width: n.outerWidth(I)
              },
              i = this.qtip.plugins.tip,
              o = this.qtip.elements.tip;
            e = parseInt(n.css("borderLeftWidth"), 10) || 0, e = {
              left: -e,
              top: -e
            }, i && o && (t = "x" === i.corner.precedance ? [M, D] : [L, F], e[t[1]] -= o[t[0]]()), this.bgiframe.css(e).css(r);
          },
          redraw: function redraw() {
            if (this.qtip.rendered < 1 || this.drawing) return this;
            var t,
              e,
              n,
              r,
              i = this.qtip.tooltip,
              o = this.qtip.options.style,
              a = this.qtip.options.position.container;
            return this.qtip.drawing = 1, o.height && i.css(L, o.height), o.width ? i.css(M, o.width) : (i.css(M, "").appendTo(this.redrawContainer), e = i.width(), e % 2 < 1 && (e += 1), n = i.css("maxWidth") || "", r = i.css("minWidth") || "", t = (n + r).indexOf("%") > -1 ? a.width() / 100 : 0, n = (n.indexOf("%") > -1 ? t : 1 * parseInt(n, 10)) || e, r = (r.indexOf("%") > -1 ? t : 1 * parseInt(r, 10)) || 0, e = n + r ? Math.min(Math.max(e, r), n) : e, i.css(M, Math.round(e)).appendTo(a)), this.drawing = 0, this;
          },
          destroy: function destroy() {
            this.bgiframe && this.bgiframe.remove(), this.qtip._unbind([a, this.qtip.tooltip], this._ns);
          }
        }), kt = H.ie6 = function (t) {
          return 6 === rt.ie ? new x(t) : I;
        }, kt.initialize = "render", A.ie6 = {
          "^content|style$": function contentStyle$() {
            this.redraw();
          }
        };
      });
    }(window, document);
  }, function (t, e, n) {
    var r = n(170),
      i = n(23)("iterator"),
      o = n(80);
    t.exports = n(9).getIteratorMethod = function (t) {
      if (void 0 != t) return t[i] || t["@@iterator"] || o[r(t)];
    };
  }, function (t, e, n) {
    var r = n(93),
      i = n(23)("toStringTag"),
      o = "Arguments" == r(function () {
        return arguments;
      }()),
      a = function a(t, e) {
        try {
          return t[e];
        } catch (t) {}
      };
    t.exports = function (t) {
      var e, n, s;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = a(e = Object(t), i)) ? n : o ? r(e) : "Object" == (s = r(e)) && "function" == typeof e.callee ? "Arguments" : s;
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(513),
      __esModule: !0
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(515),
      __esModule: !0
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      var e, n;
      this.promise = new t(function (t, r) {
        if (void 0 !== e || void 0 !== n) throw TypeError("Bad Promise constructor");
        e = t, n = r;
      }), this.resolve = i(e), this.reject = i(n);
    }
    // 25.4.1.5 NewPromiseCapability(C)
    var i = n(115);
    t.exports.f = function (t) {
      return new r(t);
    };
  }, function (t, e, n) {
    "use strict";

    var r,
      i,
      o = n(77),
      a = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(o);
    r = [n(17), n(0)], void 0 !== (i = function (t, e) {
      var n = e.$;
      return {
        getUserAgent: function getUserAgent() {
          return navigator.userAgent;
        },
        isAndroid: function isAndroid() {
          return /Android/i.test(this.getUserAgent());
        },
        isMessageFromCorrectSource: function isMessageFromCorrectSource(t, e) {
          return e.source === t[0].contentWindow;
        },
        generateDeviceFingerprint: function generateDeviceFingerprint(e, r) {
          function i() {
            l.off(), l.remove(), window.removeEventListener("message", s, !1);
          }
          function o(t) {
            i(), f.reject(t);
          }
          function s(t) {
            if (p.isMessageFromCorrectSource(l, t)) {
              if (!t || !t.data || t.origin !== e) return void o("no data");
              try {
                var n = JSON.parse(t.data);
                n && "FingerprintServiceReady" === n.type ? u({
                  type: "GetFingerprint"
                }) : n && "FingerprintAvailable" === n.type ? (i(), f.resolve(n.fingerprint)) : o("no data");
              } catch (t) {}
            }
          }
          function u(t) {
            var n = l[0].contentWindow;
            n && n.postMessage((0, a.default)(t), e);
          }
          var c = this.getUserAgent();
          if (!c) return t.reject("user agent is not defined");
          if (function (t) {
            return t.match(/windows phone|iemobile|wpdesktop/i);
          }(c)) return t.reject("device fingerprint is not supported on Windows phones");
          var l,
            f = t.defer(),
            p = this;
          return window.addEventListener("message", s, !1), l = n("<iframe>", {
            style: "display: none;",
            src: e + "/auth/services/devicefingerprint"
          }), r.append(l), f.promise;
        }
      };
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(96), n(176), n(6)], void 0 !== (i = function (t, e, n, r) {
      var i = t._;
      return e.extend({
        props: function props() {
          var e = n.getCookieUsername(),
            r = this.getUsernameAndRemember(e),
            o = {
              username: {
                type: "string",
                validate: function validate(e) {
                  if (i.isEmpty(e)) return t.loc("error.username.required", "login");
                },
                value: r.username
              },
              lastUsername: ["string", !1, e],
              context: ["object", !1],
              remember: ["boolean", !0, r.remember],
              multiOptionalFactorEnroll: ["boolean", !0]
            };
          return this.settings && this.settings.get("features.passwordlessAuth") || (o.password = {
            type: "string",
            validate: function validate(e) {
              if (i.isEmpty(e)) return t.loc("error.password.required", "login");
            }
          }), o;
        },
        getUsernameAndRemember: function getUsernameAndRemember(t) {
          var e,
            n = this.settings && this.settings.get("username"),
            r = this.settings && this.settings.get("features.rememberMe"),
            i = !1;
          return n ? (e = n, i = r && e === t) : r && t && (e = t, i = !0), {
            username: e,
            remember: i
          };
        },
        constructor: function constructor(e) {
          this.settings = e && e.settings, this.appState = e && e.appState, t.Model.apply(this, arguments), this.listenTo(this, "change:username", function (t, e) {
            this.set({
              remember: e === this.get("lastUsername")
            });
          });
        },
        parse: function parse(t) {
          return i.omit(t, ["settings", "appState"]);
        },
        save: function save() {
          var t = this.settings.transformUsername(this.get("username"), r.PRIMARY_AUTH),
            e = this.get("remember"),
            o = this.get("lastUsername");
          this.setUsernameCookie(t, e, o), this.trigger("save"), this.appState.trigger("loading", !0);
          var a,
            s = this.getSignInArgs(t);
          if (this.appState.get("isUnauthenticated")) {
            var u = this.appState.settings.authClient;
            a = this.appState.get("isIdxStateToken") ? this.doTransaction(function (t) {
              return this.doPrimaryAuth(u, s, t.login);
            }) : this.doTransaction(function (t) {
              return this.doPrimaryAuth(u, s, t.authenticate);
            });
          } else a = this.startTransaction(function (t) {
            return this.doPrimaryAuth(t, s, i.bind(t.signIn, t));
          });
          return a.fail(i.bind(function () {
            this.appState.trigger("removeLoading"), n.removeUsernameCookie();
          }, this)).fin(i.bind(function () {
            this.appState.trigger("loading", !1);
          }, this));
        },
        getSignInArgs: function getSignInArgs(t) {
          var e = this.get("multiOptionalFactorEnroll"),
            n = {};
          return this.settings.get("features.passwordlessAuth") || (n.password = this.get("password")), this.appState.get("isIdxStateToken") ? n.identifier = t : (n.username = t, n.options = {
            warnBeforePasswordExpired: !0,
            multiOptionalFactorEnroll: e
          }), n;
        },
        setUsernameCookie: function setUsernameCookie(t, e, r) {
          this.settings.get("features.rememberMe") && (e || r !== t ? e && n.setUsernameCookie(t) : n.removeUsernameCookie());
        },
        doPrimaryAuth: function doPrimaryAuth(t, e, n) {
          var r = this.settings.get("features.deviceFingerprinting"),
            i = this.settings.get("features.trackTypingPattern");
          r && (t.options.headers["X-Device-Fingerprint"] = this.appState.get("deviceFingerprint")), i && (t.options.headers["X-Typing-Pattern"] = this.appState.get("typingPattern"));
          var o = this;
          return n(e).fin(function () {
            r && (delete t.options.headers["X-Device-Fingerprint"], o.appState.unset("deviceFingerprint")), i && (delete t.options.headers["X-Typing-Pattern"], o.appState.unset("typingPattern"));
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      var e = t.internal.util.Cookie,
        n = {};
      return n.getCookieUsername = function () {
        return e.getCookie("ln");
      }, n.setUsernameCookie = function (t) {
        e.setCookie("ln", t, {
          expires: 365,
          path: "/"
        });
      }, n.removeUsernameCookie = function () {
        e.removeCookie("ln", {
          path: "/"
        });
      }, n;
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;
    var r = n(167),
      i = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(r);
    e.default = function (t, e, n) {
      return e in t ? (0, i.default)(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    };
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(6)], void 0 !== (i = function (t, e) {
      return t.View.extend({
        template: '      <a href="#" class="link help" data-se="back-link">        {{i18n code="goback" bundle="login"}}      </a>    ',
        className: "auth-footer",
        events: {
          "click .help": function clickHelp(t) {
            t.preventDefault(), this.back();
          }
        },
        back: function back() {
          this.state.set("navigateDir", e.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      var e = {};
      return e.getU2fEnrollErrorMessageKeyByCode = function (t) {
        switch (t) {
          default:
          case 1:
            return "u2f.error.other";
          case 2:
          case 3:
            return "u2f.error.badRequest";
          case 4:
            return "u2f.error.unsupported";
          case 5:
            return "u2f.error.timeout";
        }
      }, e.getU2fVerifyErrorMessageKeyByCode = function (t, e) {
        switch (t) {
          case 1:
            return e ? "u2f.error.other.oneFactor" : "u2f.error.other";
          case 2:
          case 3:
            return e ? "u2f.error.badRequest.oneFactor" : "u2f.error.badRequest";
          case 4:
            return e ? "u2f.error.unsupported.oneFactor" : "u2f.error.unsupported";
          case 5:
            return "u2f.error.timeout";
        }
      }, e.getU2fEnrollErrorMessageByCode = function (n) {
        return t.loc(e.getU2fEnrollErrorMessageKeyByCode(n), "login");
      }, e.getU2fVerifyErrorMessageByCode = function (n, r) {
        return t.loc(e.getU2fVerifyErrorMessageKeyByCode(n, r), "login");
      }, e.getU2fVersion = function () {
        return "U2F_V2";
      }, e.isU2fAvailable = function () {
        return window.hasOwnProperty("u2f");
      }, e;
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r;
    void 0 !== (r = function () {
      var t = {};
      return t.getStringHash = function (t) {
        for (var e = 5381, n = t.length; n;) e = 33 * e ^ t.charCodeAt(--n);
        return e >>> 0;
      }, t.base64UrlSafeToBase64 = function (t) {
        return t.replace(new RegExp("_", "g"), "/").replace(new RegExp("-", "g"), "+");
      }, t.binToStr = function (t) {
        return btoa(new Uint8Array(t).reduce(function (t, e) {
          return t + String.fromCharCode(e);
        }, ""));
      }, t.strToBin = function (t) {
        return Uint8Array.from(atob(this.base64UrlSafeToBase64(t)), function (t) {
          return t.charCodeAt(0);
        });
      }, t;
    }.call(e, n, e, t)) && (t.exports = r);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(121), n(595)], void 0 !== (i = function (t, e, n) {
      var r = t._,
        i = {};
      return i.getCountries = function () {
        var t = r.omit(e.country, "HM", "BV", "TF"),
          n = r.map(t, function (t, e) {
            return {
              name: t,
              code: e
            };
          });
        n = r.sortBy(n, "name");
        var i = {};
        return r.each(n, function (t) {
          i[t.code] = t.name;
        }), i;
      }, i.getCallingCodeForCountry = function (t) {
        return n[t];
      }, i;
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(18), n(24)], void 0 !== (i = function (t, e, n) {
      var r = t._;
      return t.View.extend({
        className: "scan-instructions clearfix",
        template: '      <div class="scan-instructions-details-wrapper">          <div class="scan-instructions-details">              <p>{{instructions}}</p>          </div>      </div>      <div class="scan-instructions-qrcode-wrapper">          <div class="qrcode-wrap">              <img data-se="qrcode" class="qrcode-image" src="{{qrcode}}">              <div data-se="qrcode-success" class="qrcode-success"></div>              <div data-se="qrcode-error" class="qrcode-error"></div>          </div>          <a href="#" data-type="manual-setup" data-se="manual-setup" class="link manual-setup">            {{i18n code="enroll.totp.cannotScan" bundle="login"}}          </a>          <a href="#" data-type="refresh-qrcode" data-se="refresh-qrcode" class="link refresh-qrcode">            {{i18n code="enroll.totp.refreshBarcode" bundle="login"}}          </a>      </div>    ',
        events: {
          'click [data-type="manual-setup"]': function clickDataTypeManualSetup(t) {
            var e = this;
            t.preventDefault();
            var i = n.createActivateFactorUrl(this.model.get("__provider__"), this.model.get("__factorType__"), "manual");
            "push" === this.model.get("__factorType__") ? this.model.doTransaction(function (t) {
              return t.prev().then(function (t) {
                return r.findWhere(t.factors, {
                  factorType: "push",
                  provider: "OKTA"
                }).enroll();
              });
            }).then(function () {
              e.options.appState.trigger("navigate", i);
            }) : this.options.appState.trigger("navigate", i);
          },
          'click [data-type="refresh-qrcode"]': function clickDataTypeRefreshQrcode(t) {
            t.preventDefault(), this.model.trigger("errors:clear");
            var e = this;
            this.model.doTransaction(function (t) {
              return this.appState.get("isWaitingForActivation") ? t.poll() : t.activate();
            }).then(function (t) {
              var n = t.data;
              "MFA_ENROLL_ACTIVATE" !== n.status && "FACTOR_ENROLL_ACTIVATE" !== n.status || "WAITING" !== n.factorResult || r.defer(r.bind(e.render, e));
            });
          }
        },
        initialize: function initialize() {
          this.listenTo(this.options.appState, "change:lastAuthResponse", function () {
            this.options.appState.get("isMfaEnrollActivate") ? this.$el.toggleClass("qrcode-expired", !this.options.appState.get("isWaitingForActivation")) : this.options.appState.get("isSuccessResponse") && this.$el.addClass("qrcode-success");
          }), this.listenTo(this.model, "error", function () {
            this.options.appState.get("isMfaEnrollActivate") && this.$el.toggleClass("qrcode-expired", !0);
          });
        },
        getTemplateData: function getTemplateData() {
          var n,
            r = e.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
          return n = "GOOGLE" === this.model.get("__provider__") ? t.loc("enroll.totp.setupGoogleAuthApp", "login", [r]) : t.loc("enroll.totp.setupApp", "login", [r]), {
            instructions: n,
            qrcode: this.options.appState.get("qrcode")
          };
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    t.exports = !n(12) && !n(7)(function () {
      return 7 != Object.defineProperty(n(124)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, n) {
    e.f = n(10);
  }, function (t, e, n) {
    var r = n(29),
      i = n(30),
      o = n(101)(!1),
      a = n(126)("IE_PROTO");
    t.exports = function (t, e) {
      var n,
        s = i(t),
        u = 0,
        c = [];
      for (n in s) n != a && r(s, n) && c.push(n);
      for (; e.length > u;) r(s, n = e[u++]) && (~o(c, n) || c.push(n));
      return c;
    };
  }, function (t, e, n) {
    var r = n(15),
      i = n(3),
      o = n(62);
    t.exports = n(12) ? Object.defineProperties : function (t, e) {
      i(t);
      for (var n, a = o(e), s = a.length, u = 0; s > u;) r.f(t, n = a[u++], e[n]);
      return t;
    };
  }, function (t, e, n) {
    var r = n(30),
      i = n(65).f,
      o = {}.toString,
      a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
      s = function s(t) {
        try {
          return i(t);
        } catch (t) {
          return a.slice();
        }
      };
    t.exports.f = function (t) {
      return a && "[object Window]" == o.call(t) ? s(t) : i(r(t));
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(12),
      i = n(62),
      o = n(102),
      a = n(86),
      s = n(16),
      u = n(85),
      c = Object.assign;
    t.exports = !c || n(7)(function () {
      var t = {},
        e = {},
        n = Symbol(),
        r = "abcdefghijklmnopqrst";
      return t[n] = 7, r.split("").forEach(function (t) {
        e[t] = t;
      }), 7 != c({}, t)[n] || Object.keys(c({}, e)).join("") != r;
    }) ? function (t, e) {
      for (var n = s(t), c = arguments.length, l = 1, f = o.f, p = a.f; c > l;) for (var d, h = u(arguments[l++]), m = f ? i(h).concat(f(h)) : i(h), g = m.length, v = 0; g > v;) d = m[v++], r && !p.call(h, d) || (n[d] = h[d]);
      return n;
    } : c;
  }, function (t, e) {
    t.exports = Object.is || function (t, e) {
      return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(20),
      i = n(8),
      o = n(191),
      a = [].slice,
      s = {},
      u = function u(t, e, n) {
        if (!(e in s)) {
          for (var r = [], i = 0; i < e; i++) r[i] = "a[" + i + "]";
          s[e] = Function("F,a", "return new F(" + r.join(",") + ")");
        }
        return s[e](t, n);
      };
    t.exports = Function.bind || function (t) {
      var e = r(this),
        n = a.call(arguments, 1),
        s = function s() {
          var r = n.concat(a.call(arguments));
          return this instanceof s ? u(e, r.length, r) : o(e, r, t);
        };
      return i(e.prototype) && (s.prototype = e.prototype), s;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = void 0 === n;
      switch (e.length) {
        case 0:
          return r ? t() : t.call(n);
        case 1:
          return r ? t(e[0]) : t.call(n, e[0]);
        case 2:
          return r ? t(e[0], e[1]) : t.call(n, e[0], e[1]);
        case 3:
          return r ? t(e[0], e[1], e[2]) : t.call(n, e[0], e[1], e[2]);
        case 4:
          return r ? t(e[0], e[1], e[2], e[3]) : t.call(n, e[0], e[1], e[2], e[3]);
      }
      return t.apply(n, e);
    };
  }, function (t, e, n) {
    var r = n(5).parseInt,
      i = n(75).trim,
      o = n(130),
      a = /^[-+]?0[xX]/;
    t.exports = 8 !== r(o + "08") || 22 !== r(o + "0x16") ? function (t, e) {
      var n = i(String(t), 3);
      return r(n, e >>> 0 || (a.test(n) ? 16 : 10));
    } : r;
  }, function (t, e, n) {
    var r = n(5).parseFloat,
      i = n(75).trim;
    t.exports = 1 / r(n(130) + "-0") != -1 / 0 ? function (t) {
      var e = i(String(t), 3),
        n = r(e);
      return 0 === n && "-" == e.charAt(0) ? -0 : n;
    } : r;
  }, function (t, e, n) {
    var r = n(36);
    t.exports = function (t, e) {
      if ("number" != typeof t && "Number" != r(t)) throw TypeError(e);
      return +t;
    };
  }, function (t, e, n) {
    var r = n(8),
      i = Math.floor;
    t.exports = function (t) {
      return !r(t) && isFinite(t) && i(t) === t;
    };
  }, function (t, e) {
    t.exports = Math.log1p || function (t) {
      return (t = +t) > -1e-8 && t < 1e-8 ? t - t * t / 2 : Math.log(1 + t);
    };
  }, function (t, e, n) {
    var r = n(133),
      i = Math.pow,
      o = i(2, -52),
      a = i(2, -23),
      s = i(2, 127) * (2 - a),
      u = i(2, -126),
      c = function c(t) {
        return t + 1 / o - 1 / o;
      };
    t.exports = Math.fround || function (t) {
      var e,
        n,
        i = Math.abs(t),
        l = r(t);
      return i < u ? l * c(i / u / a) * u * a : (e = (1 + a / o) * i, n = e - (e - i), n > s || n != n ? l * (1 / 0) : l * n);
    };
  }, function (t, e, n) {
    var r = n(3);
    t.exports = function (t, e, n, i) {
      try {
        return i ? e(r(n)[0], n[1]) : e(n);
      } catch (e) {
        var o = t.return;
        throw void 0 !== o && r(o.call(t)), e;
      }
    };
  }, function (t, e, n) {
    var r = n(20),
      i = n(16),
      o = n(85),
      a = n(11);
    t.exports = function (t, e, n, s, u) {
      r(e);
      var c = i(t),
        l = o(c),
        f = a(c.length),
        p = u ? f - 1 : 0,
        d = u ? -1 : 1;
      if (n < 2) for (;;) {
        if (p in l) {
          s = l[p], p += d;
          break;
        }
        if (p += d, u ? p < 0 : f <= p) throw TypeError("Reduce of empty array with no initial value");
      }
      for (; u ? p >= 0 : f > p; p += d) p in l && (s = e(s, l[p], p, c));
      return s;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(16),
      i = n(63),
      o = n(11);
    t.exports = [].copyWithin || function (t, e) {
      var n = r(this),
        a = o(n.length),
        s = i(t, a),
        u = i(e, a),
        c = arguments.length > 2 ? arguments[2] : void 0,
        l = Math.min((void 0 === c ? a : i(c, a)) - u, a - s),
        f = 1;
      for (u < s && s < u + l && (f = -1, u += l - 1, s += l - 1); l-- > 0;) u in n ? n[s] = n[u] : delete n[s], s += f, u += f;
      return n;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        value: e,
        done: !!t
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(145);
    n(1)({
      target: "RegExp",
      proto: !0,
      forced: r !== /./.exec
    }, {
      exec: r
    });
  }, function (t, e, n) {
    n(12) && "g" != /./g.flags && n(15).f(RegExp.prototype, "flags", {
      configurable: !0,
      get: n(87)
    });
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return {
          e: !1,
          v: t()
        };
      } catch (t) {
        return {
          e: !0,
          v: t
        };
      }
    };
  }, function (t, e, n) {
    var r = n(3),
      i = n(8),
      o = n(149);
    t.exports = function (t, e) {
      if (r(t), i(e) && e.constructor === t) return e;
      var n = o.f(t);
      return (0, n.resolve)(e), n.promise;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(207),
      i = n(70);
    t.exports = n(110)("Map", function (t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, {
      get: function get(t) {
        var e = r.getEntry(i(this, "Map"), t);
        return e && e.v;
      },
      set: function set(t, e) {
        return r.def(i(this, "Map"), 0 === t ? 0 : t, e);
      }
    }, r, !0);
  }, function (t, e, n) {
    "use strict";

    var r = n(15).f,
      i = n(64),
      o = n(69),
      a = n(35),
      s = n(67),
      u = n(68),
      c = n(135),
      l = n(201),
      f = n(66),
      p = n(12),
      d = n(54).fastKey,
      h = n(70),
      m = p ? "_s" : "size",
      g = function g(t, e) {
        var n,
          r = d(e);
        if ("F" !== r) return t._i[r];
        for (n = t._f; n; n = n.n) if (n.k == e) return n;
      };
    t.exports = {
      getConstructor: function getConstructor(t, e, n, c) {
        var l = t(function (t, r) {
          s(t, l, e, "_i"), t._t = e, t._i = i(null), t._f = void 0, t._l = void 0, t[m] = 0, void 0 != r && u(r, n, t[c], t);
        });
        return o(l.prototype, {
          clear: function clear() {
            for (var t = h(this, e), n = t._i, r = t._f; r; r = r.n) r.r = !0, r.p && (r.p = r.p.n = void 0), delete n[r.i];
            t._f = t._l = void 0, t[m] = 0;
          },
          delete: function _delete(t) {
            var n = h(this, e),
              r = g(n, t);
            if (r) {
              var i = r.n,
                o = r.p;
              delete n._i[r.i], r.r = !0, o && (o.n = i), i && (i.p = o), n._f == r && (n._f = i), n._l == r && (n._l = o), n[m]--;
            }
            return !!r;
          },
          forEach: function forEach(t) {
            h(this, e);
            for (var n, r = a(t, arguments.length > 1 ? arguments[1] : void 0, 3); n = n ? n.n : this._f;) for (r(n.v, n.k, this); n && n.r;) n = n.p;
          },
          has: function has(t) {
            return !!g(h(this, e), t);
          }
        }), p && r(l.prototype, "size", {
          get: function get() {
            return h(this, e)[m];
          }
        }), l;
      },
      def: function def(t, e, n) {
        var r,
          i,
          o = g(t, e);
        return o ? o.v = n : (t._l = o = {
          i: i = d(e, !0),
          k: e,
          v: n,
          p: r = t._l,
          n: void 0,
          r: !1
        }, t._f || (t._f = o), r && (r.n = o), t[m]++, "F" !== i && (t._i[i] = o)), t;
      },
      getEntry: g,
      setStrong: function setStrong(t, e, n) {
        c(t, e, function (t, n) {
          this._t = h(t, e), this._k = n, this._l = void 0;
        }, function () {
          for (var t = this, e = t._k, n = t._l; n && n.r;) n = n.p;
          return t._t && (t._l = n = n ? n.n : t._t._f) ? "keys" == e ? l(0, n.k) : "values" == e ? l(0, n.v) : l(0, [n.k, n.v]) : (t._t = void 0, l(1));
        }, n ? "entries" : "values", !n, !0), f(e);
      }
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(207),
      i = n(70);
    t.exports = n(110)("Set", function (t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, {
      add: function add(t) {
        return r.def(i(this, "Set"), t = 0 === t ? 0 : t, t);
      }
    }, r);
  }, function (t, e, n) {
    "use strict";

    var r,
      i = n(5),
      o = n(44)(0),
      a = n(26),
      s = n(54),
      u = n(188),
      c = n(210),
      l = n(8),
      f = n(70),
      p = n(70),
      d = !i.ActiveXObject && "ActiveXObject" in i,
      h = s.getWeak,
      m = Object.isExtensible,
      g = c.ufstore,
      v = function v(t) {
        return function () {
          return t(this, arguments.length > 0 ? arguments[0] : void 0);
        };
      },
      y = {
        get: function get(t) {
          if (l(t)) {
            var e = h(t);
            return !0 === e ? g(f(this, "WeakMap")).get(t) : e ? e[this._i] : void 0;
          }
        },
        set: function set(t, e) {
          return c.def(f(this, "WeakMap"), t, e);
        }
      },
      _ = t.exports = n(110)("WeakMap", v, y, c, !0, !0);
    p && d && (r = c.getConstructor(v, "WeakMap"), u(r.prototype, y), s.NEED = !0, o(["delete", "has", "get", "set"], function (t) {
      var e = _.prototype,
        n = e[t];
      a(e, t, function (e, i) {
        if (l(e) && !m(e)) {
          this._f || (this._f = new r());
          var o = this._f[t](e, i);
          return "set" == t ? this : o;
        }
        return n.call(this, e, i);
      });
    }));
  }, function (t, e, n) {
    "use strict";

    var r = n(69),
      i = n(54).getWeak,
      o = n(3),
      a = n(8),
      s = n(67),
      u = n(68),
      c = n(44),
      l = n(29),
      f = n(70),
      p = c(5),
      d = c(6),
      h = 0,
      m = function m(t) {
        return t._l || (t._l = new g());
      },
      g = function g() {
        this.a = [];
      },
      v = function v(t, e) {
        return p(t.a, function (t) {
          return t[0] === e;
        });
      };
    g.prototype = {
      get: function get(t) {
        var e = v(this, t);
        if (e) return e[1];
      },
      has: function has(t) {
        return !!v(this, t);
      },
      set: function set(t, e) {
        var n = v(this, t);
        n ? n[1] = e : this.a.push([t, e]);
      },
      delete: function _delete(t) {
        var e = d(this.a, function (e) {
          return e[0] === t;
        });
        return ~e && this.a.splice(e, 1), !!~e;
      }
    }, t.exports = {
      getConstructor: function getConstructor(t, e, n, o) {
        var c = t(function (t, r) {
          s(t, c, e, "_i"), t._t = e, t._i = h++, t._l = void 0, void 0 != r && u(r, n, t[o], t);
        });
        return r(c.prototype, {
          delete: function _delete(t) {
            if (!a(t)) return !1;
            var n = i(t);
            return !0 === n ? m(f(this, e)).delete(t) : n && l(n, this._i) && delete n[this._i];
          },
          has: function has(t) {
            if (!a(t)) return !1;
            var n = i(t);
            return !0 === n ? m(f(this, e)).has(t) : n && l(n, this._i);
          }
        }), c;
      },
      def: function def(t, e, n) {
        var r = i(o(e), !0);
        return !0 === r ? m(t).set(e, n) : r[t._i] = n, t;
      },
      ufstore: m
    };
  }, function (t, e, n) {
    var r = n(37),
      i = n(11);
    t.exports = function (t) {
      if (void 0 === t) return 0;
      var e = r(t),
        n = i(e);
      if (e !== n) throw RangeError("Wrong length!");
      return n;
    };
  }, function (t, e, n) {
    var r = n(65),
      i = n(102),
      o = n(3),
      a = n(5).Reflect;
    t.exports = a && a.ownKeys || function (t) {
      var e = r.f(o(t)),
        n = i.f;
      return n ? e.concat(n(t)) : e;
    };
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, c, l, f, p, d) {
      for (var h, m, g = l, v = 0, y = !!p && s(p, d, 3); v < c;) {
        if (v in n) {
          if (h = y ? y(n[v], v, e) : n[v], m = !1, o(h) && (m = h[u], m = void 0 !== m ? !!m : i(h)), m && f > 0) g = r(t, e, h, a(h.length), g, f - 1) - 1;else {
            if (g >= 9007199254740991) throw TypeError();
            t[g] = h;
          }
          g++;
        }
        v++;
      }
      return g;
    }
    var i = n(103),
      o = n(8),
      a = n(11),
      s = n(35),
      u = n(10)("isConcatSpreadable");
    t.exports = r;
  }, function (t, e, n) {
    var r = n(11),
      i = n(132),
      o = n(42);
    t.exports = function (t, e, n, a) {
      var s = String(o(t)),
        u = s.length,
        c = void 0 === n ? " " : String(n),
        l = r(e);
      if (l <= u || "" == c) return s;
      var f = l - u,
        p = i.call(c, Math.ceil(f / c.length));
      return p.length > f && (p = p.slice(0, f)), a ? p + s : s + p;
    };
  }, function (t, e, n) {
    var r = n(12),
      i = n(62),
      o = n(30),
      a = n(86).f;
    t.exports = function (t) {
      return function (e) {
        for (var n, s = o(e), u = i(s), c = u.length, l = 0, f = []; c > l;) n = u[l++], r && !a.call(s, n) || f.push(t ? [n, s[n]] : s[n]);
        return f;
      };
    };
  }, function (t, e, n) {
    var r = n(74),
      i = n(217);
    t.exports = function (t) {
      return function () {
        if (r(this) != t) throw TypeError(t + "#toJSON isn't generic");
        return i(this);
      };
    };
  }, function (t, e, n) {
    var r = n(68);
    t.exports = function (t, e) {
      var n = [];
      return r(t, !1, n.push, n, e), n;
    };
  }, function (t, e) {
    t.exports = Math.scale || function (t, e, n, r, i) {
      return 0 === arguments.length || t != t || e != e || n != n || r != r || i != i ? NaN : t === 1 / 0 || t === -1 / 0 ? t : (t - e) * (i - r) / (n - e) + r;
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(477),
      __esModule: !0
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(91),
      i = n(21),
      o = n(222),
      a = n(71),
      s = n(80),
      u = n(479),
      c = n(117),
      l = n(227),
      f = n(23)("iterator"),
      p = !([].keys && "next" in [].keys()),
      d = function d() {
        return this;
      };
    t.exports = function (t, e, n, h, m, g, v) {
      u(n, e, h);
      var y,
        _,
        b,
        w = function w(t) {
          if (!p && t in T) return T[t];
          switch (t) {
            case "keys":
            case "values":
              return function () {
                return new n(this, t);
              };
          }
          return function () {
            return new n(this, t);
          };
        },
        S = e + " Iterator",
        x = "values" == m,
        E = !1,
        T = t.prototype,
        k = T[f] || T["@@iterator"] || m && T[m],
        A = k || w(m),
        O = m ? x ? w("entries") : A : void 0,
        C = "Array" == e ? T.entries || k : k;
      if (C && (b = l(C.call(new t()))) !== Object.prototype && b.next && (c(b, S, !0), r || "function" == typeof b[f] || a(b, f, d)), x && k && "values" !== k.name && (E = !0, A = function A() {
        return k.call(this);
      }), r && !v || !p && !E && T[f] || a(T, f, A), s[e] = A, s[S] = d, m) if (y = {
        values: x ? A : w("values"),
        keys: g ? A : w("keys"),
        entries: O
      }, v) for (_ in y) _ in T || o(T, _, y[_]);else i(i.P + i.F * (p || E), e, y);
      return y;
    };
  }, function (t, e, n) {
    t.exports = !n(39) && !n(79)(function () {
      return 7 != Object.defineProperty(n(156)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, n) {
    t.exports = n(71);
  }, function (t, e, n) {
    var r = n(50),
      i = n(45),
      o = n(81);
    t.exports = n(39) ? Object.defineProperties : function (t, e) {
      i(t);
      for (var n, a = o(e), s = a.length, u = 0; s > u;) r.f(t, n = a[u++], e[n]);
      return t;
    };
  }, function (t, e, n) {
    var r = n(72),
      i = n(56),
      o = n(480)(!1),
      a = n(160)("IE_PROTO");
    t.exports = function (t, e) {
      var n,
        s = i(t),
        u = 0,
        c = [];
      for (n in s) n != a && r(s, n) && c.push(n);
      for (; e.length > u;) r(s, n = e[u++]) && (~o(c, n) || c.push(n));
      return c;
    };
  }, function (t, e, n) {
    var r = n(93);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == r(t) ? t.split("") : Object(t);
    };
  }, function (t, e, n) {
    var r = n(22).document;
    t.exports = r && r.documentElement;
  }, function (t, e, n) {
    var r = n(72),
      i = n(82),
      o = n(160)("IE_PROTO"),
      a = Object.prototype;
    t.exports = Object.getPrototypeOf || function (t) {
      return t = i(t), r(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? a : null;
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(485),
      __esModule: !0
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(22),
      i = n(72),
      o = n(39),
      a = n(21),
      s = n(222),
      u = n(230).KEY,
      c = n(79),
      l = n(161),
      f = n(117),
      p = n(116),
      d = n(23),
      h = n(119),
      m = n(163),
      g = n(486),
      v = n(487),
      y = n(45),
      _ = n(46),
      b = n(82),
      w = n(56),
      S = n(157),
      x = n(92),
      E = n(158),
      T = n(231),
      k = n(165),
      A = n(164),
      O = n(50),
      C = n(81),
      I = k.f,
      R = O.f,
      P = T.f,
      _N = r.Symbol,
      M = r.JSON,
      L = M && M.stringify,
      F = d("_hidden"),
      D = d("toPrimitive"),
      j = {}.propertyIsEnumerable,
      U = l("symbol-registry"),
      B = l("symbols"),
      V = l("op-symbols"),
      q = Object.prototype,
      H = "function" == typeof _N && !!A.f,
      W = r.QObject,
      $ = !W || !W.prototype || !W.prototype.findChild,
      z = o && c(function () {
        return 7 != E(R({}, "a", {
          get: function get() {
            return R(this, "a", {
              value: 7
            }).a;
          }
        })).a;
      }) ? function (t, e, n) {
        var r = I(q, e);
        r && delete q[e], R(t, e, n), r && t !== q && R(q, e, r);
      } : R,
      G = function G(t) {
        var e = B[t] = E(_N.prototype);
        return e._k = t, e;
      },
      K = H && "symbol" == typeof _N.iterator ? function (t) {
        return "symbol" == typeof t;
      } : function (t) {
        return t instanceof _N;
      },
      Y = function Y(t, e, n) {
        return t === q && Y(V, e, n), y(t), e = S(e, !0), y(n), i(B, e) ? (n.enumerable ? (i(t, F) && t[F][e] && (t[F][e] = !1), n = E(n, {
          enumerable: x(0, !1)
        })) : (i(t, F) || R(t, F, x(1, {})), t[F][e] = !0), z(t, e, n)) : R(t, e, n);
      },
      J = function J(t, e) {
        y(t);
        for (var n, r = g(e = w(e)), i = 0, o = r.length; o > i;) Y(t, n = r[i++], e[n]);
        return t;
      },
      Q = function Q(t, e) {
        return void 0 === e ? E(t) : J(E(t), e);
      },
      X = function X(t) {
        var e = j.call(this, t = S(t, !0));
        return !(this === q && i(B, t) && !i(V, t)) && (!(e || !i(this, t) || !i(B, t) || i(this, F) && this[F][t]) || e);
      },
      Z = function Z(t, e) {
        if (t = w(t), e = S(e, !0), t !== q || !i(B, e) || i(V, e)) {
          var n = I(t, e);
          return !n || !i(B, e) || i(t, F) && t[F][e] || (n.enumerable = !0), n;
        }
      },
      tt = function tt(t) {
        for (var e, n = P(w(t)), r = [], o = 0; n.length > o;) i(B, e = n[o++]) || e == F || e == u || r.push(e);
        return r;
      },
      et = function et(t) {
        for (var e, n = t === q, r = P(n ? V : w(t)), o = [], a = 0; r.length > a;) !i(B, e = r[a++]) || n && !i(q, e) || o.push(B[e]);
        return o;
      };
    H || (_N = function N() {
      if (this instanceof _N) throw TypeError("Symbol is not a constructor!");
      var t = p(arguments.length > 0 ? arguments[0] : void 0),
        e = function e(n) {
          this === q && e.call(V, n), i(this, F) && i(this[F], t) && (this[F][t] = !1), z(this, t, x(1, n));
        };
      return o && $ && z(q, t, {
        configurable: !0,
        set: e
      }), G(t);
    }, s(_N.prototype, "toString", function () {
      return this._k;
    }), k.f = Z, O.f = Y, n(232).f = T.f = tt, n(94).f = X, A.f = et, o && !n(91) && s(q, "propertyIsEnumerable", X, !0), h.f = function (t) {
      return G(d(t));
    }), a(a.G + a.W + a.F * !H, {
      Symbol: _N
    });
    for (var nt = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), rt = 0; nt.length > rt;) d(nt[rt++]);
    for (var it = C(d.store), ot = 0; it.length > ot;) m(it[ot++]);
    a(a.S + a.F * !H, "Symbol", {
      for: function _for(t) {
        return i(U, t += "") ? U[t] : U[t] = _N(t);
      },
      keyFor: function keyFor(t) {
        if (!K(t)) throw TypeError(t + " is not a symbol!");
        for (var e in U) if (U[e] === t) return e;
      },
      useSetter: function useSetter() {
        $ = !0;
      },
      useSimple: function useSimple() {
        $ = !1;
      }
    }), a(a.S + a.F * !H, "Object", {
      create: Q,
      defineProperty: Y,
      defineProperties: J,
      getOwnPropertyDescriptor: Z,
      getOwnPropertyNames: tt,
      getOwnPropertySymbols: et
    });
    var at = c(function () {
      A.f(1);
    });
    a(a.S + a.F * at, "Object", {
      getOwnPropertySymbols: function getOwnPropertySymbols(t) {
        return A.f(b(t));
      }
    }), M && a(a.S + a.F * (!H || c(function () {
      var t = _N();
      return "[null]" != L([t]) || "{}" != L({
        a: t
      }) || "{}" != L(Object(t));
    })), "JSON", {
      stringify: function stringify(t) {
        for (var e, n, r = [t], i = 1; arguments.length > i;) r.push(arguments[i++]);
        if (n = e = r[1], (_(e) || void 0 !== t) && !K(t)) return v(e) || (e = function e(t, _e4) {
          if ("function" == typeof n && (_e4 = n.call(this, t, _e4)), !K(_e4)) return _e4;
        }), r[1] = e, L.apply(M, r);
      }
    }), _N.prototype[D] || n(71)(_N.prototype, D, _N.prototype.valueOf), f(_N, "Symbol"), f(Math, "Math", !0), f(r.JSON, "JSON", !0);
  }, function (t, e, n) {
    var r = n(116)("meta"),
      i = n(46),
      o = n(72),
      a = n(50).f,
      s = 0,
      u = Object.isExtensible || function () {
        return !0;
      },
      c = !n(79)(function () {
        return u(Object.preventExtensions({}));
      }),
      l = function l(t) {
        a(t, r, {
          value: {
            i: "O" + ++s,
            w: {}
          }
        });
      },
      f = function f(t, e) {
        if (!i(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
        if (!o(t, r)) {
          if (!u(t)) return "F";
          if (!e) return "E";
          l(t);
        }
        return t[r].i;
      },
      p = function p(t, e) {
        if (!o(t, r)) {
          if (!u(t)) return !0;
          if (!e) return !1;
          l(t);
        }
        return t[r].w;
      },
      d = function d(t) {
        return c && h.NEED && u(t) && !o(t, r) && l(t), t;
      },
      h = t.exports = {
        KEY: r,
        NEED: !1,
        fastKey: f,
        getWeak: p,
        onFreeze: d
      };
  }, function (t, e, n) {
    var r = n(56),
      i = n(232).f,
      o = {}.toString,
      a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
      s = function s(t) {
        try {
          return i(t);
        } catch (t) {
          return a.slice();
        }
      };
    t.exports.f = function (t) {
      return a && "[object Window]" == o.call(t) ? s(t) : i(r(t));
    };
  }, function (t, e, n) {
    var r = n(224),
      i = n(162).concat("length", "prototype");
    e.f = Object.getOwnPropertyNames || function (t) {
      return r(t, i);
    };
  }, function (t, e, n) {
    /**!
    @license
    handlebars v4.7.6
    Copyright (C) 2011-2019 by Yehuda Katz
    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:
    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.
    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
    THE SOFTWARE.
    */
    !function (e, n) {
      t.exports = n();
    }(0, function () {
      return function (t) {
        function e(r) {
          if (n[r]) return n[r].exports;
          var i = n[r] = {
            exports: {},
            id: r,
            loaded: !1
          };
          return t[r].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
        }
        var n = {};
        return e.m = t, e.c = n, e.p = "", e(0);
      }([function (t, e, n) {
        "use strict";

        function r() {
          var t = v();
          return t.compile = function (e, n) {
            return l.compile(e, n, t);
          }, t.precompile = function (e, n) {
            return l.precompile(e, n, t);
          }, t.AST = u.default, t.Compiler = l.Compiler, t.JavaScriptCompiler = p.default, t.Parser = c.parser, t.parse = c.parse, t.parseWithoutProcessing = c.parseWithoutProcessing, t;
        }
        var i = n(1).default;
        e.__esModule = !0;
        var o = n(2),
          a = i(o),
          s = n(45),
          u = i(s),
          c = n(46),
          l = n(51),
          f = n(52),
          p = i(f),
          d = n(49),
          h = i(d),
          m = n(44),
          g = i(m),
          v = a.default.create,
          y = r();
        y.create = r, g.default(y), y.Visitor = h.default, y.default = y, e.default = y, t.exports = e.default;
      }, function (t, e) {
        "use strict";

        e.default = function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        }, e.__esModule = !0;
      }, function (t, e, n) {
        "use strict";

        function r() {
          var t = new s.HandlebarsEnvironment();
          return d.extend(t, s), t.SafeString = c.default, t.Exception = f.default, t.Utils = d, t.escapeExpression = d.escapeExpression, t.VM = m, t.template = function (e) {
            return m.template(e, t);
          }, t;
        }
        var i = n(3).default,
          o = n(1).default;
        e.__esModule = !0;
        var a = n(4),
          s = i(a),
          u = n(37),
          c = o(u),
          l = n(6),
          f = o(l),
          p = n(5),
          d = i(p),
          h = n(38),
          m = i(h),
          g = n(44),
          v = o(g),
          y = r();
        y.create = r, v.default(y), y.default = y, e.default = y, t.exports = e.default;
      }, function (t, e) {
        "use strict";

        e.default = function (t) {
          if (t && t.__esModule) return t;
          var e = {};
          if (null != t) for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          return e.default = t, e;
        }, e.__esModule = !0;
      }, function (t, e, n) {
        "use strict";

        function r(t, e, n) {
          this.helpers = t || {}, this.partials = e || {}, this.decorators = n || {}, u.registerDefaultHelpers(this), c.registerDefaultDecorators(this);
        }
        var i = n(1).default;
        e.__esModule = !0, e.HandlebarsEnvironment = r;
        var o = n(5),
          a = n(6),
          s = i(a),
          u = n(10),
          c = n(30),
          l = n(32),
          f = i(l),
          p = n(33);
        e.VERSION = "4.7.6";
        e.COMPILER_REVISION = 8;
        e.LAST_COMPATIBLE_COMPILER_REVISION = 7;
        var d = {
          1: "<= 1.0.rc.2",
          2: "== 1.0.0-rc.3",
          3: "== 1.0.0-rc.4",
          4: "== 1.x.x",
          5: "== 2.0.0-alpha.x",
          6: ">= 2.0.0-beta.1",
          7: ">= 4.0.0 <4.3.0",
          8: ">= 4.3.0"
        };
        e.REVISION_CHANGES = d;
        r.prototype = {
          constructor: r,
          logger: f.default,
          log: f.default.log,
          registerHelper: function registerHelper(t, e) {
            if ("[object Object]" === o.toString.call(t)) {
              if (e) throw new s.default("Arg not supported with multiple helpers");
              o.extend(this.helpers, t);
            } else this.helpers[t] = e;
          },
          unregisterHelper: function unregisterHelper(t) {
            delete this.helpers[t];
          },
          registerPartial: function registerPartial(t, e) {
            if ("[object Object]" === o.toString.call(t)) o.extend(this.partials, t);else {
              if (void 0 === e) throw new s.default('Attempting to register a partial called "' + t + '" as undefined');
              this.partials[t] = e;
            }
          },
          unregisterPartial: function unregisterPartial(t) {
            delete this.partials[t];
          },
          registerDecorator: function registerDecorator(t, e) {
            if ("[object Object]" === o.toString.call(t)) {
              if (e) throw new s.default("Arg not supported with multiple decorators");
              o.extend(this.decorators, t);
            } else this.decorators[t] = e;
          },
          unregisterDecorator: function unregisterDecorator(t) {
            delete this.decorators[t];
          },
          resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
            p.resetLoggedProperties();
          }
        };
        var h = f.default.log;
        e.log = h, e.createFrame = o.createFrame, e.logger = f.default;
      }, function (t, e) {
        "use strict";

        function n(t) {
          return l[t];
        }
        function r(t) {
          for (var e = 1; e < arguments.length; e++) for (var n in arguments[e]) Object.prototype.hasOwnProperty.call(arguments[e], n) && (t[n] = arguments[e][n]);
          return t;
        }
        function i(t, e) {
          for (var n = 0, r = t.length; n < r; n++) if (t[n] === e) return n;
          return -1;
        }
        function o(t) {
          if ("string" != typeof t) {
            if (t && t.toHTML) return t.toHTML();
            if (null == t) return "";
            if (!t) return t + "";
            t = "" + t;
          }
          return p.test(t) ? t.replace(f, n) : t;
        }
        function a(t) {
          return !t && 0 !== t || !(!m(t) || 0 !== t.length);
        }
        function s(t) {
          var e = r({}, t);
          return e._parent = t, e;
        }
        function u(t, e) {
          return t.path = e, t;
        }
        function c(t, e) {
          return (t ? t + "." : "") + e;
        }
        e.__esModule = !0, e.extend = r, e.indexOf = i, e.escapeExpression = o, e.isEmpty = a, e.createFrame = s, e.blockParams = u, e.appendContextPath = c;
        var l = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;",
            "=": "&#x3D;"
          },
          f = /[&<>"'`=]/g,
          p = /[&<>"'`=]/,
          d = Object.prototype.toString;
        e.toString = d;
        var h = function h(t) {
          return "function" == typeof t;
        };
        h(/x/) && (e.isFunction = h = function h(t) {
          return "function" == typeof t && "[object Function]" === d.call(t);
        }), e.isFunction = h;
        var m = Array.isArray || function (t) {
          return !(!t || "object" != typeof t) && "[object Array]" === d.call(t);
        };
        e.isArray = m;
      }, function (t, e, n) {
        "use strict";

        function r(t, e) {
          var n = e && e.loc,
            a = void 0,
            s = void 0,
            u = void 0,
            c = void 0;
          n && (a = n.start.line, s = n.end.line, u = n.start.column, c = n.end.column, t += " - " + a + ":" + u);
          for (var l = Error.prototype.constructor.call(this, t), f = 0; f < o.length; f++) this[o[f]] = l[o[f]];
          Error.captureStackTrace && Error.captureStackTrace(this, r);
          try {
            n && (this.lineNumber = a, this.endLineNumber = s, i ? (Object.defineProperty(this, "column", {
              value: u,
              enumerable: !0
            }), Object.defineProperty(this, "endColumn", {
              value: c,
              enumerable: !0
            })) : (this.column = u, this.endColumn = c));
          } catch (t) {}
        }
        var i = n(7).default;
        e.__esModule = !0;
        var o = ["description", "fileName", "lineNumber", "endLineNumber", "message", "name", "number", "stack"];
        r.prototype = new Error(), e.default = r, t.exports = e.default;
      }, function (t, e, n) {
        t.exports = {
          default: n(8),
          __esModule: !0
        };
      }, function (t, e, n) {
        var r = n(9);
        t.exports = function (t, e, n) {
          return r.setDesc(t, e, n);
        };
      }, function (t, e) {
        var n = Object;
        t.exports = {
          create: n.create,
          getProto: n.getPrototypeOf,
          isEnum: {}.propertyIsEnumerable,
          getDesc: n.getOwnPropertyDescriptor,
          setDesc: n.defineProperty,
          setDescs: n.defineProperties,
          getKeys: n.keys,
          getNames: n.getOwnPropertyNames,
          getSymbols: n.getOwnPropertySymbols,
          each: [].forEach
        };
      }, function (t, e, n) {
        "use strict";

        function r(t) {
          s.default(t), c.default(t), f.default(t), d.default(t), m.default(t), v.default(t), _.default(t);
        }
        function i(t, e, n) {
          t.helpers[e] && (t.hooks[e] = t.helpers[e], n || delete t.helpers[e]);
        }
        var o = n(1).default;
        e.__esModule = !0, e.registerDefaultHelpers = r, e.moveHelperToHooks = i;
        var a = n(11),
          s = o(a),
          u = n(12),
          c = o(u),
          l = n(25),
          f = o(l),
          p = n(26),
          d = o(p),
          h = n(27),
          m = o(h),
          g = n(28),
          v = o(g),
          y = n(29),
          _ = o(y);
      }, function (t, e, n) {
        "use strict";

        e.__esModule = !0;
        var r = n(5);
        e.default = function (t) {
          t.registerHelper("blockHelperMissing", function (e, n) {
            var i = n.inverse,
              o = n.fn;
            if (!0 === e) return o(this);
            if (!1 === e || null == e) return i(this);
            if (r.isArray(e)) return e.length > 0 ? (n.ids && (n.ids = [n.name]), t.helpers.each(e, n)) : i(this);
            if (n.data && n.ids) {
              var a = r.createFrame(n.data);
              a.contextPath = r.appendContextPath(n.data.contextPath, n.name), n = {
                data: a
              };
            }
            return o(e, n);
          });
        }, t.exports = e.default;
      }, function (t, e, n) {
        (function (r) {
          "use strict";

          var i = n(13).default,
            o = n(1).default;
          e.__esModule = !0;
          var a = n(5),
            s = n(6),
            u = o(s);
          e.default = function (t) {
            t.registerHelper("each", function (t, e) {
              function n(e, n, r) {
                f && (f.key = e, f.index = n, f.first = 0 === n, f.last = !!r, p && (f.contextPath = p + e)), l += o(t[e], {
                  data: f,
                  blockParams: a.blockParams([t[e], e], [p + e, null])
                });
              }
              if (!e) throw new u.default("Must pass iterator to #each");
              var o = e.fn,
                s = e.inverse,
                c = 0,
                l = "",
                f = void 0,
                p = void 0;
              if (e.data && e.ids && (p = a.appendContextPath(e.data.contextPath, e.ids[0]) + "."), a.isFunction(t) && (t = t.call(this)), e.data && (f = a.createFrame(e.data)), t && "object" == typeof t) if (a.isArray(t)) for (var d = t.length; c < d; c++) c in t && n(c, c, c === t.length - 1);else if (r.Symbol && t[r.Symbol.iterator]) {
                for (var h = [], m = t[r.Symbol.iterator](), g = m.next(); !g.done; g = m.next()) h.push(g.value);
                t = h;
                for (var d = t.length; c < d; c++) n(c, c, c === t.length - 1);
              } else !function () {
                var e = void 0;
                i(t).forEach(function (t) {
                  void 0 !== e && n(e, c - 1), e = t, c++;
                }), void 0 !== e && n(e, c - 1, !0);
              }();
              return 0 === c && (l = s(this)), l;
            });
          }, t.exports = e.default;
        }).call(e, function () {
          return this;
        }());
      }, function (t, e, n) {
        t.exports = {
          default: n(14),
          __esModule: !0
        };
      }, function (t, e, n) {
        n(15), t.exports = n(21).Object.keys;
      }, function (t, e, n) {
        var r = n(16);
        n(18)("keys", function (t) {
          return function (e) {
            return t(r(e));
          };
        });
      }, function (t, e, n) {
        var r = n(17);
        t.exports = function (t) {
          return Object(r(t));
        };
      }, function (t, e) {
        t.exports = function (t) {
          if (void 0 == t) throw TypeError("Can't call method on  " + t);
          return t;
        };
      }, function (t, e, n) {
        var r = n(19),
          i = n(21),
          o = n(24);
        t.exports = function (t, e) {
          var n = (i.Object || {})[t] || Object[t],
            a = {};
          a[t] = e(n), r(r.S + r.F * o(function () {
            n(1);
          }), "Object", a);
        };
      }, function (t, e, n) {
        var r = n(20),
          i = n(21),
          o = n(22),
          a = function a(t, e, n) {
            var s,
              u,
              c,
              l = t & a.F,
              f = t & a.G,
              p = t & a.S,
              d = t & a.P,
              h = t & a.B,
              m = t & a.W,
              g = f ? i : i[e] || (i[e] = {}),
              v = f ? r : p ? r[e] : (r[e] || {}).prototype;
            f && (n = e);
            for (s in n) (u = !l && v && s in v) && s in g || (c = u ? v[s] : n[s], g[s] = f && "function" != typeof v[s] ? n[s] : h && u ? o(c, r) : m && v[s] == c ? function (t) {
              var e = function e(_e5) {
                return this instanceof t ? new t(_e5) : t(_e5);
              };
              return e.prototype = t.prototype, e;
            }(c) : d && "function" == typeof c ? o(Function.call, c) : c, d && ((g.prototype || (g.prototype = {}))[s] = c));
          };
        a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, t.exports = a;
      }, function (t, e) {
        var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
        "number" == typeof __g && (__g = n);
      }, function (t, e) {
        var n = t.exports = {
          version: "1.2.6"
        };
        "number" == typeof __e && (__e = n);
      }, function (t, e, n) {
        var r = n(23);
        t.exports = function (t, e, n) {
          if (r(t), void 0 === e) return t;
          switch (n) {
            case 1:
              return function (n) {
                return t.call(e, n);
              };
            case 2:
              return function (n, r) {
                return t.call(e, n, r);
              };
            case 3:
              return function (n, r, i) {
                return t.call(e, n, r, i);
              };
          }
          return function () {
            return t.apply(e, arguments);
          };
        };
      }, function (t, e) {
        t.exports = function (t) {
          if ("function" != typeof t) throw TypeError(t + " is not a function!");
          return t;
        };
      }, function (t, e) {
        t.exports = function (t) {
          try {
            return !!t();
          } catch (t) {
            return !0;
          }
        };
      }, function (t, e, n) {
        "use strict";

        var r = n(1).default;
        e.__esModule = !0;
        var i = n(6),
          o = r(i);
        e.default = function (t) {
          t.registerHelper("helperMissing", function () {
            if (1 !== arguments.length) throw new o.default('Missing helper: "' + arguments[arguments.length - 1].name + '"');
          });
        }, t.exports = e.default;
      }, function (t, e, n) {
        "use strict";

        var r = n(1).default;
        e.__esModule = !0;
        var i = n(5),
          o = n(6),
          a = r(o);
        e.default = function (t) {
          t.registerHelper("if", function (t, e) {
            if (2 != arguments.length) throw new a.default("#if requires exactly one argument");
            return i.isFunction(t) && (t = t.call(this)), !e.hash.includeZero && !t || i.isEmpty(t) ? e.inverse(this) : e.fn(this);
          }), t.registerHelper("unless", function (e, n) {
            if (2 != arguments.length) throw new a.default("#unless requires exactly one argument");
            return t.helpers.if.call(this, e, {
              fn: n.inverse,
              inverse: n.fn,
              hash: n.hash
            });
          });
        }, t.exports = e.default;
      }, function (t, e) {
        "use strict";

        e.__esModule = !0, e.default = function (t) {
          t.registerHelper("log", function () {
            for (var e = [void 0], n = arguments[arguments.length - 1], r = 0; r < arguments.length - 1; r++) e.push(arguments[r]);
            var i = 1;
            null != n.hash.level ? i = n.hash.level : n.data && null != n.data.level && (i = n.data.level), e[0] = i, t.log.apply(t, e);
          });
        }, t.exports = e.default;
      }, function (t, e) {
        "use strict";

        e.__esModule = !0, e.default = function (t) {
          t.registerHelper("lookup", function (t, e, n) {
            return t ? n.lookupProperty(t, e) : t;
          });
        }, t.exports = e.default;
      }, function (t, e, n) {
        "use strict";

        var r = n(1).default;
        e.__esModule = !0;
        var i = n(5),
          o = n(6),
          a = r(o);
        e.default = function (t) {
          t.registerHelper("with", function (t, e) {
            if (2 != arguments.length) throw new a.default("#with requires exactly one argument");
            i.isFunction(t) && (t = t.call(this));
            var n = e.fn;
            if (i.isEmpty(t)) return e.inverse(this);
            var r = e.data;
            return e.data && e.ids && (r = i.createFrame(e.data), r.contextPath = i.appendContextPath(e.data.contextPath, e.ids[0])), n(t, {
              data: r,
              blockParams: i.blockParams([t], [r && r.contextPath])
            });
          });
        }, t.exports = e.default;
      }, function (t, e, n) {
        "use strict";

        function r(t) {
          a.default(t);
        }
        var i = n(1).default;
        e.__esModule = !0, e.registerDefaultDecorators = r;
        var o = n(31),
          a = i(o);
      }, function (t, e, n) {
        "use strict";

        e.__esModule = !0;
        var r = n(5);
        e.default = function (t) {
          t.registerDecorator("inline", function (t, e, n, i) {
            var o = t;
            return e.partials || (e.partials = {}, o = function o(i, _o) {
              var a = n.partials;
              n.partials = r.extend({}, a, e.partials);
              var s = t(i, _o);
              return n.partials = a, s;
            }), e.partials[i.args[0]] = i.fn, o;
          });
        }, t.exports = e.default;
      }, function (t, e, n) {
        "use strict";

        e.__esModule = !0;
        var r = n(5),
          i = {
            methodMap: ["debug", "info", "warn", "error"],
            level: "info",
            lookupLevel: function lookupLevel(t) {
              if ("string" == typeof t) {
                var e = r.indexOf(i.methodMap, t.toLowerCase());
                t = e >= 0 ? e : parseInt(t, 10);
              }
              return t;
            },
            log: function log(t) {
              if (t = i.lookupLevel(t), "undefined" != typeof console && i.lookupLevel(i.level) <= t) {
                var e = i.methodMap[t];
                console[e] || (e = "log");
                for (var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
              }
            }
          };
        e.default = i, t.exports = e.default;
      }, function (t, e, n) {
        "use strict";

        function r(t) {
          var e = u(null);
          e.constructor = !1, e.__defineGetter__ = !1, e.__defineSetter__ = !1, e.__lookupGetter__ = !1;
          var n = u(null);
          return n.__proto__ = !1, {
            properties: {
              whitelist: f.createNewLookupObject(n, t.allowedProtoProperties),
              defaultValue: t.allowProtoPropertiesByDefault
            },
            methods: {
              whitelist: f.createNewLookupObject(e, t.allowedProtoMethods),
              defaultValue: t.allowProtoMethodsByDefault
            }
          };
        }
        function i(t, e, n) {
          return "function" == typeof t ? o(e.methods, n) : o(e.properties, n);
        }
        function o(t, e) {
          return void 0 !== t.whitelist[e] ? !0 === t.whitelist[e] : void 0 !== t.defaultValue ? t.defaultValue : (a(e), !1);
        }
        function a(t) {
          !0 !== h[t] && (h[t] = !0, d.log("error", 'Handlebars: Access has been denied to resolve the property "' + t + '" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'));
        }
        function s() {
          c(h).forEach(function (t) {
            delete h[t];
          });
        }
        var u = n(34).default,
          c = n(13).default,
          l = n(3).default;
        e.__esModule = !0, e.createProtoAccessControl = r, e.resultIsAllowed = i, e.resetLoggedProperties = s;
        var f = n(36),
          p = n(32),
          d = l(p),
          h = u(null);
      }, function (t, e, n) {
        t.exports = {
          default: n(35),
          __esModule: !0
        };
      }, function (t, e, n) {
        var r = n(9);
        t.exports = function (t, e) {
          return r.create(t, e);
        };
      }, function (t, e, n) {
        "use strict";

        function r() {
          for (var t = arguments.length, e = Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          return o.extend.apply(void 0, [i(null)].concat(e));
        }
        var i = n(34).default;
        e.__esModule = !0, e.createNewLookupObject = r;
        var o = n(5);
      }, function (t, e) {
        "use strict";

        function n(t) {
          this.string = t;
        }
        e.__esModule = !0, n.prototype.toString = n.prototype.toHTML = function () {
          return "" + this.string;
        }, e.default = n, t.exports = e.default;
      }, function (t, e, n) {
        "use strict";

        function r(t) {
          var e = t && t[0] || 1,
            n = w.COMPILER_REVISION;
          if (!(e >= w.LAST_COMPATIBLE_COMPILER_REVISION && e <= w.COMPILER_REVISION)) {
            if (e < w.LAST_COMPATIBLE_COMPILER_REVISION) {
              var r = w.REVISION_CHANGES[n],
                i = w.REVISION_CHANGES[e];
              throw new b.default("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + r + ") or downgrade your runtime to an older version (" + i + ").");
            }
            throw new b.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + t[1] + ").");
          }
        }
        function i(t, e) {
          function n(n, r, i) {
            i.hash && (r = y.extend({}, r, i.hash), i.ids && (i.ids[0] = !0)), n = e.VM.resolvePartial.call(this, n, r, i);
            var o = y.extend({}, i, {
                hooks: this.hooks,
                protoAccessControl: this.protoAccessControl
              }),
              a = e.VM.invokePartial.call(this, n, r, o);
            if (null == a && e.compile && (i.partials[i.name] = e.compile(n, t.compilerOptions, e), a = i.partials[i.name](r, o)), null != a) {
              if (i.indent) {
                for (var s = a.split("\n"), u = 0, c = s.length; u < c && (s[u] || u + 1 !== c); u++) s[u] = i.indent + s[u];
                a = s.join("\n");
              }
              return a;
            }
            throw new b.default("The partial " + i.name + " could not be compiled when running in runtime-only mode");
          }
          function r(e) {
            function n(e) {
              return "" + t.main(a, e, a.helpers, a.partials, o, u, s);
            }
            var i = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
              o = i.data;
            r._setup(i), !i.partial && t.useData && (o = c(e, o));
            var s = void 0,
              u = t.useBlockParams ? [] : void 0;
            return t.useDepths && (s = i.depths ? e != i.depths[0] ? [e].concat(i.depths) : i.depths : [e]), (n = l(t.main, n, a, i.depths || [], o, u))(e, i);
          }
          if (!e) throw new b.default("No environment passed to template");
          if (!t || !t.main) throw new b.default("Unknown template object: " + typeof t);
          t.main.decorator = t.main_d, e.VM.checkRevision(t.compiler);
          var i = t.compiler && 7 === t.compiler[0],
            a = {
              strict: function strict(t, e, n) {
                if (!(t && e in t)) throw new b.default('"' + e + '" not defined in ' + t, {
                  loc: n
                });
                return t[e];
              },
              lookupProperty: function lookupProperty(t, e) {
                var n = t[e];
                return null == n ? n : Object.prototype.hasOwnProperty.call(t, e) ? n : E.resultIsAllowed(n, a.protoAccessControl, e) ? n : void 0;
              },
              lookup: function lookup(t, e) {
                for (var n = t.length, r = 0; r < n; r++) {
                  if (null != (t[r] && a.lookupProperty(t[r], e))) return t[r][e];
                }
              },
              lambda: function lambda(t, e) {
                return "function" == typeof t ? t.call(e) : t;
              },
              escapeExpression: y.escapeExpression,
              invokePartial: n,
              fn: function fn(e) {
                var n = t[e];
                return n.decorator = t[e + "_d"], n;
              },
              programs: [],
              program: function program(t, e, n, r, i) {
                var a = this.programs[t],
                  s = this.fn(t);
                return e || i || r || n ? a = o(this, t, s, e, n, r, i) : a || (a = this.programs[t] = o(this, t, s)), a;
              },
              data: function data(t, e) {
                for (; t && e--;) t = t._parent;
                return t;
              },
              mergeIfNeeded: function mergeIfNeeded(t, e) {
                var n = t || e;
                return t && e && t !== e && (n = y.extend({}, e, t)), n;
              },
              nullContext: d({}),
              noop: e.VM.noop,
              compilerInfo: t.compiler
            };
          return r.isTop = !0, r._setup = function (n) {
            if (n.partial) a.protoAccessControl = n.protoAccessControl, a.helpers = n.helpers, a.partials = n.partials, a.decorators = n.decorators, a.hooks = n.hooks;else {
              var r = y.extend({}, e.helpers, n.helpers);
              f(r, a), a.helpers = r, t.usePartial && (a.partials = a.mergeIfNeeded(n.partials, e.partials)), (t.usePartial || t.useDecorators) && (a.decorators = y.extend({}, e.decorators, n.decorators)), a.hooks = {}, a.protoAccessControl = E.createProtoAccessControl(n);
              var o = n.allowCallsToHelperMissing || i;
              S.moveHelperToHooks(a, "helperMissing", o), S.moveHelperToHooks(a, "blockHelperMissing", o);
            }
          }, r._child = function (e, n, r, i) {
            if (t.useBlockParams && !r) throw new b.default("must pass block params");
            if (t.useDepths && !i) throw new b.default("must pass parent depths");
            return o(a, e, t[e], n, 0, r, i);
          }, r;
        }
        function o(t, e, n, r, i, o, a) {
          function s(e) {
            var i = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
              s = a;
            return !a || e == a[0] || e === t.nullContext && null === a[0] || (s = [e].concat(a)), n(t, e, t.helpers, t.partials, i.data || r, o && [i.blockParams].concat(o), s);
          }
          return s = l(n, s, t, a, r, o), s.program = e, s.depth = a ? a.length : 0, s.blockParams = i || 0, s;
        }
        function a(t, e, n) {
          return t ? t.call || n.name || (n.name = t, t = n.partials[t]) : t = "@partial-block" === n.name ? n.data["partial-block"] : n.partials[n.name], t;
        }
        function s(t, e, n) {
          var r = n.data && n.data["partial-block"];
          n.partial = !0, n.ids && (n.data.contextPath = n.ids[0] || n.data.contextPath);
          var i = void 0;
          if (n.fn && n.fn !== u && function () {
            n.data = w.createFrame(n.data);
            var t = n.fn;
            i = n.data["partial-block"] = function (e) {
              var n = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1];
              return n.data = w.createFrame(n.data), n.data["partial-block"] = r, t(e, n);
            }, t.partials && (n.partials = y.extend({}, n.partials, t.partials));
          }(), void 0 === t && i && (t = i), void 0 === t) throw new b.default("The partial " + n.name + " could not be found");
          if (t instanceof Function) return t(e, n);
        }
        function u() {
          return "";
        }
        function c(t, e) {
          return e && "root" in e || (e = e ? w.createFrame(e) : {}, e.root = t), e;
        }
        function l(t, e, n, r, i, o) {
          if (t.decorator) {
            var a = {};
            e = t.decorator(e, a, n, r && r[0], i, o, r), y.extend(e, a);
          }
          return e;
        }
        function f(t, e) {
          h(t).forEach(function (n) {
            var r = t[n];
            t[n] = p(r, e);
          });
        }
        function p(t, e) {
          var n = e.lookupProperty;
          return x.wrapHelper(t, function (t) {
            return y.extend({
              lookupProperty: n
            }, t);
          });
        }
        var d = n(39).default,
          h = n(13).default,
          m = n(3).default,
          g = n(1).default;
        e.__esModule = !0, e.checkRevision = r, e.template = i, e.wrapProgram = o, e.resolvePartial = a, e.invokePartial = s, e.noop = u;
        var v = n(5),
          y = m(v),
          _ = n(6),
          b = g(_),
          w = n(4),
          S = n(10),
          x = n(43),
          E = n(33);
      }, function (t, e, n) {
        t.exports = {
          default: n(40),
          __esModule: !0
        };
      }, function (t, e, n) {
        n(41), t.exports = n(21).Object.seal;
      }, function (t, e, n) {
        var r = n(42);
        n(18)("seal", function (t) {
          return function (e) {
            return t && r(e) ? t(e) : e;
          };
        });
      }, function (t, e) {
        t.exports = function (t) {
          return "object" == typeof t ? null !== t : "function" == typeof t;
        };
      }, function (t, e) {
        "use strict";

        function n(t, e) {
          return "function" != typeof t ? t : function () {
            var n = arguments[arguments.length - 1];
            return arguments[arguments.length - 1] = e(n), t.apply(this, arguments);
          };
        }
        e.__esModule = !0, e.wrapHelper = n;
      }, function (t, e) {
        (function (n) {
          "use strict";

          e.__esModule = !0, e.default = function (t) {
            var e = void 0 !== n ? n : window,
              r = e.Handlebars;
            t.noConflict = function () {
              return e.Handlebars === t && (e.Handlebars = r), t;
            };
          }, t.exports = e.default;
        }).call(e, function () {
          return this;
        }());
      }, function (t, e) {
        "use strict";

        e.__esModule = !0;
        var n = {
          helpers: {
            helperExpression: function helperExpression(t) {
              return "SubExpression" === t.type || ("MustacheStatement" === t.type || "BlockStatement" === t.type) && !!(t.params && t.params.length || t.hash);
            },
            scopedId: function scopedId(t) {
              return /^\.|this\b/.test(t.original);
            },
            simpleId: function simpleId(t) {
              return 1 === t.parts.length && !n.helpers.scopedId(t) && !t.depth;
            }
          }
        };
        e.default = n, t.exports = e.default;
      }, function (t, e, n) {
        "use strict";

        function r(t, e) {
          return "Program" === t.type ? t : (u.default.yy = h, h.locInfo = function (t) {
            return new h.SourceLocation(e && e.srcName, t);
          }, u.default.parse(t));
        }
        function i(t, e) {
          var n = r(t, e);
          return new l.default(e).accept(n);
        }
        var o = n(1).default,
          a = n(3).default;
        e.__esModule = !0, e.parseWithoutProcessing = r, e.parse = i;
        var s = n(47),
          u = o(s),
          c = n(48),
          l = o(c),
          f = n(50),
          p = a(f),
          d = n(5);
        e.parser = u.default;
        var h = {};
        d.extend(h, p);
      }, function (t, e) {
        "use strict";

        e.__esModule = !0;
        var n = function () {
          function t() {
            this.yy = {};
          }
          var e = {
              trace: function trace() {},
              yy: {},
              symbols_: {
                error: 2,
                root: 3,
                program: 4,
                EOF: 5,
                program_repetition0: 6,
                statement: 7,
                mustache: 8,
                block: 9,
                rawBlock: 10,
                partial: 11,
                partialBlock: 12,
                content: 13,
                COMMENT: 14,
                CONTENT: 15,
                openRawBlock: 16,
                rawBlock_repetition0: 17,
                END_RAW_BLOCK: 18,
                OPEN_RAW_BLOCK: 19,
                helperName: 20,
                openRawBlock_repetition0: 21,
                openRawBlock_option0: 22,
                CLOSE_RAW_BLOCK: 23,
                openBlock: 24,
                block_option0: 25,
                closeBlock: 26,
                openInverse: 27,
                block_option1: 28,
                OPEN_BLOCK: 29,
                openBlock_repetition0: 30,
                openBlock_option0: 31,
                openBlock_option1: 32,
                CLOSE: 33,
                OPEN_INVERSE: 34,
                openInverse_repetition0: 35,
                openInverse_option0: 36,
                openInverse_option1: 37,
                openInverseChain: 38,
                OPEN_INVERSE_CHAIN: 39,
                openInverseChain_repetition0: 40,
                openInverseChain_option0: 41,
                openInverseChain_option1: 42,
                inverseAndProgram: 43,
                INVERSE: 44,
                inverseChain: 45,
                inverseChain_option0: 46,
                OPEN_ENDBLOCK: 47,
                OPEN: 48,
                mustache_repetition0: 49,
                mustache_option0: 50,
                OPEN_UNESCAPED: 51,
                mustache_repetition1: 52,
                mustache_option1: 53,
                CLOSE_UNESCAPED: 54,
                OPEN_PARTIAL: 55,
                partialName: 56,
                partial_repetition0: 57,
                partial_option0: 58,
                openPartialBlock: 59,
                OPEN_PARTIAL_BLOCK: 60,
                openPartialBlock_repetition0: 61,
                openPartialBlock_option0: 62,
                param: 63,
                sexpr: 64,
                OPEN_SEXPR: 65,
                sexpr_repetition0: 66,
                sexpr_option0: 67,
                CLOSE_SEXPR: 68,
                hash: 69,
                hash_repetition_plus0: 70,
                hashSegment: 71,
                ID: 72,
                EQUALS: 73,
                blockParams: 74,
                OPEN_BLOCK_PARAMS: 75,
                blockParams_repetition_plus0: 76,
                CLOSE_BLOCK_PARAMS: 77,
                path: 78,
                dataName: 79,
                STRING: 80,
                NUMBER: 81,
                BOOLEAN: 82,
                UNDEFINED: 83,
                NULL: 84,
                DATA: 85,
                pathSegments: 86,
                SEP: 87,
                $accept: 0,
                $end: 1
              },
              terminals_: {
                2: "error",
                5: "EOF",
                14: "COMMENT",
                15: "CONTENT",
                18: "END_RAW_BLOCK",
                19: "OPEN_RAW_BLOCK",
                23: "CLOSE_RAW_BLOCK",
                29: "OPEN_BLOCK",
                33: "CLOSE",
                34: "OPEN_INVERSE",
                39: "OPEN_INVERSE_CHAIN",
                44: "INVERSE",
                47: "OPEN_ENDBLOCK",
                48: "OPEN",
                51: "OPEN_UNESCAPED",
                54: "CLOSE_UNESCAPED",
                55: "OPEN_PARTIAL",
                60: "OPEN_PARTIAL_BLOCK",
                65: "OPEN_SEXPR",
                68: "CLOSE_SEXPR",
                72: "ID",
                73: "EQUALS",
                75: "OPEN_BLOCK_PARAMS",
                77: "CLOSE_BLOCK_PARAMS",
                80: "STRING",
                81: "NUMBER",
                82: "BOOLEAN",
                83: "UNDEFINED",
                84: "NULL",
                85: "DATA",
                87: "SEP"
              },
              productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 0], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
              performAction: function performAction(t, e, n, r, i, o, a) {
                var s = o.length - 1;
                switch (i) {
                  case 1:
                    return o[s - 1];
                  case 2:
                    this.$ = r.prepareProgram(o[s]);
                    break;
                  case 3:
                  case 4:
                  case 5:
                  case 6:
                  case 7:
                  case 8:
                    this.$ = o[s];
                    break;
                  case 9:
                    this.$ = {
                      type: "CommentStatement",
                      value: r.stripComment(o[s]),
                      strip: r.stripFlags(o[s], o[s]),
                      loc: r.locInfo(this._$)
                    };
                    break;
                  case 10:
                    this.$ = {
                      type: "ContentStatement",
                      original: o[s],
                      value: o[s],
                      loc: r.locInfo(this._$)
                    };
                    break;
                  case 11:
                    this.$ = r.prepareRawBlock(o[s - 2], o[s - 1], o[s], this._$);
                    break;
                  case 12:
                    this.$ = {
                      path: o[s - 3],
                      params: o[s - 2],
                      hash: o[s - 1]
                    };
                    break;
                  case 13:
                    this.$ = r.prepareBlock(o[s - 3], o[s - 2], o[s - 1], o[s], !1, this._$);
                    break;
                  case 14:
                    this.$ = r.prepareBlock(o[s - 3], o[s - 2], o[s - 1], o[s], !0, this._$);
                    break;
                  case 15:
                    this.$ = {
                      open: o[s - 5],
                      path: o[s - 4],
                      params: o[s - 3],
                      hash: o[s - 2],
                      blockParams: o[s - 1],
                      strip: r.stripFlags(o[s - 5], o[s])
                    };
                    break;
                  case 16:
                  case 17:
                    this.$ = {
                      path: o[s - 4],
                      params: o[s - 3],
                      hash: o[s - 2],
                      blockParams: o[s - 1],
                      strip: r.stripFlags(o[s - 5], o[s])
                    };
                    break;
                  case 18:
                    this.$ = {
                      strip: r.stripFlags(o[s - 1], o[s - 1]),
                      program: o[s]
                    };
                    break;
                  case 19:
                    var u = r.prepareBlock(o[s - 2], o[s - 1], o[s], o[s], !1, this._$),
                      c = r.prepareProgram([u], o[s - 1].loc);
                    c.chained = !0, this.$ = {
                      strip: o[s - 2].strip,
                      program: c,
                      chain: !0
                    };
                    break;
                  case 20:
                    this.$ = o[s];
                    break;
                  case 21:
                    this.$ = {
                      path: o[s - 1],
                      strip: r.stripFlags(o[s - 2], o[s])
                    };
                    break;
                  case 22:
                  case 23:
                    this.$ = r.prepareMustache(o[s - 3], o[s - 2], o[s - 1], o[s - 4], r.stripFlags(o[s - 4], o[s]), this._$);
                    break;
                  case 24:
                    this.$ = {
                      type: "PartialStatement",
                      name: o[s - 3],
                      params: o[s - 2],
                      hash: o[s - 1],
                      indent: "",
                      strip: r.stripFlags(o[s - 4], o[s]),
                      loc: r.locInfo(this._$)
                    };
                    break;
                  case 25:
                    this.$ = r.preparePartialBlock(o[s - 2], o[s - 1], o[s], this._$);
                    break;
                  case 26:
                    this.$ = {
                      path: o[s - 3],
                      params: o[s - 2],
                      hash: o[s - 1],
                      strip: r.stripFlags(o[s - 4], o[s])
                    };
                    break;
                  case 27:
                  case 28:
                    this.$ = o[s];
                    break;
                  case 29:
                    this.$ = {
                      type: "SubExpression",
                      path: o[s - 3],
                      params: o[s - 2],
                      hash: o[s - 1],
                      loc: r.locInfo(this._$)
                    };
                    break;
                  case 30:
                    this.$ = {
                      type: "Hash",
                      pairs: o[s],
                      loc: r.locInfo(this._$)
                    };
                    break;
                  case 31:
                    this.$ = {
                      type: "HashPair",
                      key: r.id(o[s - 2]),
                      value: o[s],
                      loc: r.locInfo(this._$)
                    };
                    break;
                  case 32:
                    this.$ = r.id(o[s - 1]);
                    break;
                  case 33:
                  case 34:
                    this.$ = o[s];
                    break;
                  case 35:
                    this.$ = {
                      type: "StringLiteral",
                      value: o[s],
                      original: o[s],
                      loc: r.locInfo(this._$)
                    };
                    break;
                  case 36:
                    this.$ = {
                      type: "NumberLiteral",
                      value: Number(o[s]),
                      original: Number(o[s]),
                      loc: r.locInfo(this._$)
                    };
                    break;
                  case 37:
                    this.$ = {
                      type: "BooleanLiteral",
                      value: "true" === o[s],
                      original: "true" === o[s],
                      loc: r.locInfo(this._$)
                    };
                    break;
                  case 38:
                    this.$ = {
                      type: "UndefinedLiteral",
                      original: void 0,
                      value: void 0,
                      loc: r.locInfo(this._$)
                    };
                    break;
                  case 39:
                    this.$ = {
                      type: "NullLiteral",
                      original: null,
                      value: null,
                      loc: r.locInfo(this._$)
                    };
                    break;
                  case 40:
                  case 41:
                    this.$ = o[s];
                    break;
                  case 42:
                    this.$ = r.preparePath(!0, o[s], this._$);
                    break;
                  case 43:
                    this.$ = r.preparePath(!1, o[s], this._$);
                    break;
                  case 44:
                    o[s - 2].push({
                      part: r.id(o[s]),
                      original: o[s],
                      separator: o[s - 1]
                    }), this.$ = o[s - 2];
                    break;
                  case 45:
                    this.$ = [{
                      part: r.id(o[s]),
                      original: o[s]
                    }];
                    break;
                  case 46:
                    this.$ = [];
                    break;
                  case 47:
                    o[s - 1].push(o[s]);
                    break;
                  case 48:
                    this.$ = [];
                    break;
                  case 49:
                    o[s - 1].push(o[s]);
                    break;
                  case 50:
                    this.$ = [];
                    break;
                  case 51:
                    o[s - 1].push(o[s]);
                    break;
                  case 58:
                    this.$ = [];
                    break;
                  case 59:
                    o[s - 1].push(o[s]);
                    break;
                  case 64:
                    this.$ = [];
                    break;
                  case 65:
                    o[s - 1].push(o[s]);
                    break;
                  case 70:
                    this.$ = [];
                    break;
                  case 71:
                    o[s - 1].push(o[s]);
                    break;
                  case 78:
                    this.$ = [];
                    break;
                  case 79:
                    o[s - 1].push(o[s]);
                    break;
                  case 82:
                    this.$ = [];
                    break;
                  case 83:
                    o[s - 1].push(o[s]);
                    break;
                  case 86:
                    this.$ = [];
                    break;
                  case 87:
                    o[s - 1].push(o[s]);
                    break;
                  case 90:
                    this.$ = [];
                    break;
                  case 91:
                    o[s - 1].push(o[s]);
                    break;
                  case 94:
                    this.$ = [];
                    break;
                  case 95:
                    o[s - 1].push(o[s]);
                    break;
                  case 98:
                    this.$ = [o[s]];
                    break;
                  case 99:
                    o[s - 1].push(o[s]);
                    break;
                  case 100:
                    this.$ = [o[s]];
                    break;
                  case 101:
                    o[s - 1].push(o[s]);
                }
              },
              table: [{
                3: 1,
                4: 2,
                5: [2, 46],
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46]
              }, {
                1: [3]
              }, {
                5: [1, 4]
              }, {
                5: [2, 2],
                7: 5,
                8: 6,
                9: 7,
                10: 8,
                11: 9,
                12: 10,
                13: 11,
                14: [1, 12],
                15: [1, 20],
                16: 17,
                19: [1, 23],
                24: 15,
                27: 16,
                29: [1, 21],
                34: [1, 22],
                39: [2, 2],
                44: [2, 2],
                47: [2, 2],
                48: [1, 13],
                51: [1, 14],
                55: [1, 18],
                59: 19,
                60: [1, 24]
              }, {
                1: [2, 1]
              }, {
                5: [2, 47],
                14: [2, 47],
                15: [2, 47],
                19: [2, 47],
                29: [2, 47],
                34: [2, 47],
                39: [2, 47],
                44: [2, 47],
                47: [2, 47],
                48: [2, 47],
                51: [2, 47],
                55: [2, 47],
                60: [2, 47]
              }, {
                5: [2, 3],
                14: [2, 3],
                15: [2, 3],
                19: [2, 3],
                29: [2, 3],
                34: [2, 3],
                39: [2, 3],
                44: [2, 3],
                47: [2, 3],
                48: [2, 3],
                51: [2, 3],
                55: [2, 3],
                60: [2, 3]
              }, {
                5: [2, 4],
                14: [2, 4],
                15: [2, 4],
                19: [2, 4],
                29: [2, 4],
                34: [2, 4],
                39: [2, 4],
                44: [2, 4],
                47: [2, 4],
                48: [2, 4],
                51: [2, 4],
                55: [2, 4],
                60: [2, 4]
              }, {
                5: [2, 5],
                14: [2, 5],
                15: [2, 5],
                19: [2, 5],
                29: [2, 5],
                34: [2, 5],
                39: [2, 5],
                44: [2, 5],
                47: [2, 5],
                48: [2, 5],
                51: [2, 5],
                55: [2, 5],
                60: [2, 5]
              }, {
                5: [2, 6],
                14: [2, 6],
                15: [2, 6],
                19: [2, 6],
                29: [2, 6],
                34: [2, 6],
                39: [2, 6],
                44: [2, 6],
                47: [2, 6],
                48: [2, 6],
                51: [2, 6],
                55: [2, 6],
                60: [2, 6]
              }, {
                5: [2, 7],
                14: [2, 7],
                15: [2, 7],
                19: [2, 7],
                29: [2, 7],
                34: [2, 7],
                39: [2, 7],
                44: [2, 7],
                47: [2, 7],
                48: [2, 7],
                51: [2, 7],
                55: [2, 7],
                60: [2, 7]
              }, {
                5: [2, 8],
                14: [2, 8],
                15: [2, 8],
                19: [2, 8],
                29: [2, 8],
                34: [2, 8],
                39: [2, 8],
                44: [2, 8],
                47: [2, 8],
                48: [2, 8],
                51: [2, 8],
                55: [2, 8],
                60: [2, 8]
              }, {
                5: [2, 9],
                14: [2, 9],
                15: [2, 9],
                19: [2, 9],
                29: [2, 9],
                34: [2, 9],
                39: [2, 9],
                44: [2, 9],
                47: [2, 9],
                48: [2, 9],
                51: [2, 9],
                55: [2, 9],
                60: [2, 9]
              }, {
                20: 25,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 36,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                4: 37,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                39: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46]
              }, {
                4: 38,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46]
              }, {
                15: [2, 48],
                17: 39,
                18: [2, 48]
              }, {
                20: 41,
                56: 40,
                64: 42,
                65: [1, 43],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                4: 44,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46]
              }, {
                5: [2, 10],
                14: [2, 10],
                15: [2, 10],
                18: [2, 10],
                19: [2, 10],
                29: [2, 10],
                34: [2, 10],
                39: [2, 10],
                44: [2, 10],
                47: [2, 10],
                48: [2, 10],
                51: [2, 10],
                55: [2, 10],
                60: [2, 10]
              }, {
                20: 45,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 46,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 47,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 41,
                56: 48,
                64: 42,
                65: [1, 43],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                33: [2, 78],
                49: 49,
                65: [2, 78],
                72: [2, 78],
                80: [2, 78],
                81: [2, 78],
                82: [2, 78],
                83: [2, 78],
                84: [2, 78],
                85: [2, 78]
              }, {
                23: [2, 33],
                33: [2, 33],
                54: [2, 33],
                65: [2, 33],
                68: [2, 33],
                72: [2, 33],
                75: [2, 33],
                80: [2, 33],
                81: [2, 33],
                82: [2, 33],
                83: [2, 33],
                84: [2, 33],
                85: [2, 33]
              }, {
                23: [2, 34],
                33: [2, 34],
                54: [2, 34],
                65: [2, 34],
                68: [2, 34],
                72: [2, 34],
                75: [2, 34],
                80: [2, 34],
                81: [2, 34],
                82: [2, 34],
                83: [2, 34],
                84: [2, 34],
                85: [2, 34]
              }, {
                23: [2, 35],
                33: [2, 35],
                54: [2, 35],
                65: [2, 35],
                68: [2, 35],
                72: [2, 35],
                75: [2, 35],
                80: [2, 35],
                81: [2, 35],
                82: [2, 35],
                83: [2, 35],
                84: [2, 35],
                85: [2, 35]
              }, {
                23: [2, 36],
                33: [2, 36],
                54: [2, 36],
                65: [2, 36],
                68: [2, 36],
                72: [2, 36],
                75: [2, 36],
                80: [2, 36],
                81: [2, 36],
                82: [2, 36],
                83: [2, 36],
                84: [2, 36],
                85: [2, 36]
              }, {
                23: [2, 37],
                33: [2, 37],
                54: [2, 37],
                65: [2, 37],
                68: [2, 37],
                72: [2, 37],
                75: [2, 37],
                80: [2, 37],
                81: [2, 37],
                82: [2, 37],
                83: [2, 37],
                84: [2, 37],
                85: [2, 37]
              }, {
                23: [2, 38],
                33: [2, 38],
                54: [2, 38],
                65: [2, 38],
                68: [2, 38],
                72: [2, 38],
                75: [2, 38],
                80: [2, 38],
                81: [2, 38],
                82: [2, 38],
                83: [2, 38],
                84: [2, 38],
                85: [2, 38]
              }, {
                23: [2, 39],
                33: [2, 39],
                54: [2, 39],
                65: [2, 39],
                68: [2, 39],
                72: [2, 39],
                75: [2, 39],
                80: [2, 39],
                81: [2, 39],
                82: [2, 39],
                83: [2, 39],
                84: [2, 39],
                85: [2, 39]
              }, {
                23: [2, 43],
                33: [2, 43],
                54: [2, 43],
                65: [2, 43],
                68: [2, 43],
                72: [2, 43],
                75: [2, 43],
                80: [2, 43],
                81: [2, 43],
                82: [2, 43],
                83: [2, 43],
                84: [2, 43],
                85: [2, 43],
                87: [1, 50]
              }, {
                72: [1, 35],
                86: 51
              }, {
                23: [2, 45],
                33: [2, 45],
                54: [2, 45],
                65: [2, 45],
                68: [2, 45],
                72: [2, 45],
                75: [2, 45],
                80: [2, 45],
                81: [2, 45],
                82: [2, 45],
                83: [2, 45],
                84: [2, 45],
                85: [2, 45],
                87: [2, 45]
              }, {
                52: 52,
                54: [2, 82],
                65: [2, 82],
                72: [2, 82],
                80: [2, 82],
                81: [2, 82],
                82: [2, 82],
                83: [2, 82],
                84: [2, 82],
                85: [2, 82]
              }, {
                25: 53,
                38: 55,
                39: [1, 57],
                43: 56,
                44: [1, 58],
                45: 54,
                47: [2, 54]
              }, {
                28: 59,
                43: 60,
                44: [1, 58],
                47: [2, 56]
              }, {
                13: 62,
                15: [1, 20],
                18: [1, 61]
              }, {
                33: [2, 86],
                57: 63,
                65: [2, 86],
                72: [2, 86],
                80: [2, 86],
                81: [2, 86],
                82: [2, 86],
                83: [2, 86],
                84: [2, 86],
                85: [2, 86]
              }, {
                33: [2, 40],
                65: [2, 40],
                72: [2, 40],
                80: [2, 40],
                81: [2, 40],
                82: [2, 40],
                83: [2, 40],
                84: [2, 40],
                85: [2, 40]
              }, {
                33: [2, 41],
                65: [2, 41],
                72: [2, 41],
                80: [2, 41],
                81: [2, 41],
                82: [2, 41],
                83: [2, 41],
                84: [2, 41],
                85: [2, 41]
              }, {
                20: 64,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                26: 65,
                47: [1, 66]
              }, {
                30: 67,
                33: [2, 58],
                65: [2, 58],
                72: [2, 58],
                75: [2, 58],
                80: [2, 58],
                81: [2, 58],
                82: [2, 58],
                83: [2, 58],
                84: [2, 58],
                85: [2, 58]
              }, {
                33: [2, 64],
                35: 68,
                65: [2, 64],
                72: [2, 64],
                75: [2, 64],
                80: [2, 64],
                81: [2, 64],
                82: [2, 64],
                83: [2, 64],
                84: [2, 64],
                85: [2, 64]
              }, {
                21: 69,
                23: [2, 50],
                65: [2, 50],
                72: [2, 50],
                80: [2, 50],
                81: [2, 50],
                82: [2, 50],
                83: [2, 50],
                84: [2, 50],
                85: [2, 50]
              }, {
                33: [2, 90],
                61: 70,
                65: [2, 90],
                72: [2, 90],
                80: [2, 90],
                81: [2, 90],
                82: [2, 90],
                83: [2, 90],
                84: [2, 90],
                85: [2, 90]
              }, {
                20: 74,
                33: [2, 80],
                50: 71,
                63: 72,
                64: 75,
                65: [1, 43],
                69: 73,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                72: [1, 79]
              }, {
                23: [2, 42],
                33: [2, 42],
                54: [2, 42],
                65: [2, 42],
                68: [2, 42],
                72: [2, 42],
                75: [2, 42],
                80: [2, 42],
                81: [2, 42],
                82: [2, 42],
                83: [2, 42],
                84: [2, 42],
                85: [2, 42],
                87: [1, 50]
              }, {
                20: 74,
                53: 80,
                54: [2, 84],
                63: 81,
                64: 75,
                65: [1, 43],
                69: 82,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                26: 83,
                47: [1, 66]
              }, {
                47: [2, 55]
              }, {
                4: 84,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                39: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46]
              }, {
                47: [2, 20]
              }, {
                20: 85,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                4: 86,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46]
              }, {
                26: 87,
                47: [1, 66]
              }, {
                47: [2, 57]
              }, {
                5: [2, 11],
                14: [2, 11],
                15: [2, 11],
                19: [2, 11],
                29: [2, 11],
                34: [2, 11],
                39: [2, 11],
                44: [2, 11],
                47: [2, 11],
                48: [2, 11],
                51: [2, 11],
                55: [2, 11],
                60: [2, 11]
              }, {
                15: [2, 49],
                18: [2, 49]
              }, {
                20: 74,
                33: [2, 88],
                58: 88,
                63: 89,
                64: 75,
                65: [1, 43],
                69: 90,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                65: [2, 94],
                66: 91,
                68: [2, 94],
                72: [2, 94],
                80: [2, 94],
                81: [2, 94],
                82: [2, 94],
                83: [2, 94],
                84: [2, 94],
                85: [2, 94]
              }, {
                5: [2, 25],
                14: [2, 25],
                15: [2, 25],
                19: [2, 25],
                29: [2, 25],
                34: [2, 25],
                39: [2, 25],
                44: [2, 25],
                47: [2, 25],
                48: [2, 25],
                51: [2, 25],
                55: [2, 25],
                60: [2, 25]
              }, {
                20: 92,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 74,
                31: 93,
                33: [2, 60],
                63: 94,
                64: 75,
                65: [1, 43],
                69: 95,
                70: 76,
                71: 77,
                72: [1, 78],
                75: [2, 60],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 74,
                33: [2, 66],
                36: 96,
                63: 97,
                64: 75,
                65: [1, 43],
                69: 98,
                70: 76,
                71: 77,
                72: [1, 78],
                75: [2, 66],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 74,
                22: 99,
                23: [2, 52],
                63: 100,
                64: 75,
                65: [1, 43],
                69: 101,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 74,
                33: [2, 92],
                62: 102,
                63: 103,
                64: 75,
                65: [1, 43],
                69: 104,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                33: [1, 105]
              }, {
                33: [2, 79],
                65: [2, 79],
                72: [2, 79],
                80: [2, 79],
                81: [2, 79],
                82: [2, 79],
                83: [2, 79],
                84: [2, 79],
                85: [2, 79]
              }, {
                33: [2, 81]
              }, {
                23: [2, 27],
                33: [2, 27],
                54: [2, 27],
                65: [2, 27],
                68: [2, 27],
                72: [2, 27],
                75: [2, 27],
                80: [2, 27],
                81: [2, 27],
                82: [2, 27],
                83: [2, 27],
                84: [2, 27],
                85: [2, 27]
              }, {
                23: [2, 28],
                33: [2, 28],
                54: [2, 28],
                65: [2, 28],
                68: [2, 28],
                72: [2, 28],
                75: [2, 28],
                80: [2, 28],
                81: [2, 28],
                82: [2, 28],
                83: [2, 28],
                84: [2, 28],
                85: [2, 28]
              }, {
                23: [2, 30],
                33: [2, 30],
                54: [2, 30],
                68: [2, 30],
                71: 106,
                72: [1, 107],
                75: [2, 30]
              }, {
                23: [2, 98],
                33: [2, 98],
                54: [2, 98],
                68: [2, 98],
                72: [2, 98],
                75: [2, 98]
              }, {
                23: [2, 45],
                33: [2, 45],
                54: [2, 45],
                65: [2, 45],
                68: [2, 45],
                72: [2, 45],
                73: [1, 108],
                75: [2, 45],
                80: [2, 45],
                81: [2, 45],
                82: [2, 45],
                83: [2, 45],
                84: [2, 45],
                85: [2, 45],
                87: [2, 45]
              }, {
                23: [2, 44],
                33: [2, 44],
                54: [2, 44],
                65: [2, 44],
                68: [2, 44],
                72: [2, 44],
                75: [2, 44],
                80: [2, 44],
                81: [2, 44],
                82: [2, 44],
                83: [2, 44],
                84: [2, 44],
                85: [2, 44],
                87: [2, 44]
              }, {
                54: [1, 109]
              }, {
                54: [2, 83],
                65: [2, 83],
                72: [2, 83],
                80: [2, 83],
                81: [2, 83],
                82: [2, 83],
                83: [2, 83],
                84: [2, 83],
                85: [2, 83]
              }, {
                54: [2, 85]
              }, {
                5: [2, 13],
                14: [2, 13],
                15: [2, 13],
                19: [2, 13],
                29: [2, 13],
                34: [2, 13],
                39: [2, 13],
                44: [2, 13],
                47: [2, 13],
                48: [2, 13],
                51: [2, 13],
                55: [2, 13],
                60: [2, 13]
              }, {
                38: 55,
                39: [1, 57],
                43: 56,
                44: [1, 58],
                45: 111,
                46: 110,
                47: [2, 76]
              }, {
                33: [2, 70],
                40: 112,
                65: [2, 70],
                72: [2, 70],
                75: [2, 70],
                80: [2, 70],
                81: [2, 70],
                82: [2, 70],
                83: [2, 70],
                84: [2, 70],
                85: [2, 70]
              }, {
                47: [2, 18]
              }, {
                5: [2, 14],
                14: [2, 14],
                15: [2, 14],
                19: [2, 14],
                29: [2, 14],
                34: [2, 14],
                39: [2, 14],
                44: [2, 14],
                47: [2, 14],
                48: [2, 14],
                51: [2, 14],
                55: [2, 14],
                60: [2, 14]
              }, {
                33: [1, 113]
              }, {
                33: [2, 87],
                65: [2, 87],
                72: [2, 87],
                80: [2, 87],
                81: [2, 87],
                82: [2, 87],
                83: [2, 87],
                84: [2, 87],
                85: [2, 87]
              }, {
                33: [2, 89]
              }, {
                20: 74,
                63: 115,
                64: 75,
                65: [1, 43],
                67: 114,
                68: [2, 96],
                69: 116,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                33: [1, 117]
              }, {
                32: 118,
                33: [2, 62],
                74: 119,
                75: [1, 120]
              }, {
                33: [2, 59],
                65: [2, 59],
                72: [2, 59],
                75: [2, 59],
                80: [2, 59],
                81: [2, 59],
                82: [2, 59],
                83: [2, 59],
                84: [2, 59],
                85: [2, 59]
              }, {
                33: [2, 61],
                75: [2, 61]
              }, {
                33: [2, 68],
                37: 121,
                74: 122,
                75: [1, 120]
              }, {
                33: [2, 65],
                65: [2, 65],
                72: [2, 65],
                75: [2, 65],
                80: [2, 65],
                81: [2, 65],
                82: [2, 65],
                83: [2, 65],
                84: [2, 65],
                85: [2, 65]
              }, {
                33: [2, 67],
                75: [2, 67]
              }, {
                23: [1, 123]
              }, {
                23: [2, 51],
                65: [2, 51],
                72: [2, 51],
                80: [2, 51],
                81: [2, 51],
                82: [2, 51],
                83: [2, 51],
                84: [2, 51],
                85: [2, 51]
              }, {
                23: [2, 53]
              }, {
                33: [1, 124]
              }, {
                33: [2, 91],
                65: [2, 91],
                72: [2, 91],
                80: [2, 91],
                81: [2, 91],
                82: [2, 91],
                83: [2, 91],
                84: [2, 91],
                85: [2, 91]
              }, {
                33: [2, 93]
              }, {
                5: [2, 22],
                14: [2, 22],
                15: [2, 22],
                19: [2, 22],
                29: [2, 22],
                34: [2, 22],
                39: [2, 22],
                44: [2, 22],
                47: [2, 22],
                48: [2, 22],
                51: [2, 22],
                55: [2, 22],
                60: [2, 22]
              }, {
                23: [2, 99],
                33: [2, 99],
                54: [2, 99],
                68: [2, 99],
                72: [2, 99],
                75: [2, 99]
              }, {
                73: [1, 108]
              }, {
                20: 74,
                63: 125,
                64: 75,
                65: [1, 43],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                5: [2, 23],
                14: [2, 23],
                15: [2, 23],
                19: [2, 23],
                29: [2, 23],
                34: [2, 23],
                39: [2, 23],
                44: [2, 23],
                47: [2, 23],
                48: [2, 23],
                51: [2, 23],
                55: [2, 23],
                60: [2, 23]
              }, {
                47: [2, 19]
              }, {
                47: [2, 77]
              }, {
                20: 74,
                33: [2, 72],
                41: 126,
                63: 127,
                64: 75,
                65: [1, 43],
                69: 128,
                70: 76,
                71: 77,
                72: [1, 78],
                75: [2, 72],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                5: [2, 24],
                14: [2, 24],
                15: [2, 24],
                19: [2, 24],
                29: [2, 24],
                34: [2, 24],
                39: [2, 24],
                44: [2, 24],
                47: [2, 24],
                48: [2, 24],
                51: [2, 24],
                55: [2, 24],
                60: [2, 24]
              }, {
                68: [1, 129]
              }, {
                65: [2, 95],
                68: [2, 95],
                72: [2, 95],
                80: [2, 95],
                81: [2, 95],
                82: [2, 95],
                83: [2, 95],
                84: [2, 95],
                85: [2, 95]
              }, {
                68: [2, 97]
              }, {
                5: [2, 21],
                14: [2, 21],
                15: [2, 21],
                19: [2, 21],
                29: [2, 21],
                34: [2, 21],
                39: [2, 21],
                44: [2, 21],
                47: [2, 21],
                48: [2, 21],
                51: [2, 21],
                55: [2, 21],
                60: [2, 21]
              }, {
                33: [1, 130]
              }, {
                33: [2, 63]
              }, {
                72: [1, 132],
                76: 131
              }, {
                33: [1, 133]
              }, {
                33: [2, 69]
              }, {
                15: [2, 12],
                18: [2, 12]
              }, {
                14: [2, 26],
                15: [2, 26],
                19: [2, 26],
                29: [2, 26],
                34: [2, 26],
                47: [2, 26],
                48: [2, 26],
                51: [2, 26],
                55: [2, 26],
                60: [2, 26]
              }, {
                23: [2, 31],
                33: [2, 31],
                54: [2, 31],
                68: [2, 31],
                72: [2, 31],
                75: [2, 31]
              }, {
                33: [2, 74],
                42: 134,
                74: 135,
                75: [1, 120]
              }, {
                33: [2, 71],
                65: [2, 71],
                72: [2, 71],
                75: [2, 71],
                80: [2, 71],
                81: [2, 71],
                82: [2, 71],
                83: [2, 71],
                84: [2, 71],
                85: [2, 71]
              }, {
                33: [2, 73],
                75: [2, 73]
              }, {
                23: [2, 29],
                33: [2, 29],
                54: [2, 29],
                65: [2, 29],
                68: [2, 29],
                72: [2, 29],
                75: [2, 29],
                80: [2, 29],
                81: [2, 29],
                82: [2, 29],
                83: [2, 29],
                84: [2, 29],
                85: [2, 29]
              }, {
                14: [2, 15],
                15: [2, 15],
                19: [2, 15],
                29: [2, 15],
                34: [2, 15],
                39: [2, 15],
                44: [2, 15],
                47: [2, 15],
                48: [2, 15],
                51: [2, 15],
                55: [2, 15],
                60: [2, 15]
              }, {
                72: [1, 137],
                77: [1, 136]
              }, {
                72: [2, 100],
                77: [2, 100]
              }, {
                14: [2, 16],
                15: [2, 16],
                19: [2, 16],
                29: [2, 16],
                34: [2, 16],
                44: [2, 16],
                47: [2, 16],
                48: [2, 16],
                51: [2, 16],
                55: [2, 16],
                60: [2, 16]
              }, {
                33: [1, 138]
              }, {
                33: [2, 75]
              }, {
                33: [2, 32]
              }, {
                72: [2, 101],
                77: [2, 101]
              }, {
                14: [2, 17],
                15: [2, 17],
                19: [2, 17],
                29: [2, 17],
                34: [2, 17],
                39: [2, 17],
                44: [2, 17],
                47: [2, 17],
                48: [2, 17],
                51: [2, 17],
                55: [2, 17],
                60: [2, 17]
              }],
              defaultActions: {
                4: [2, 1],
                54: [2, 55],
                56: [2, 20],
                60: [2, 57],
                73: [2, 81],
                82: [2, 85],
                86: [2, 18],
                90: [2, 89],
                101: [2, 53],
                104: [2, 93],
                110: [2, 19],
                111: [2, 77],
                116: [2, 97],
                119: [2, 63],
                122: [2, 69],
                135: [2, 75],
                136: [2, 32]
              },
              parseError: function parseError(t, e) {
                throw new Error(t);
              },
              parse: function parse(t) {
                var e = this,
                  n = [0],
                  r = [null],
                  i = [],
                  o = this.table,
                  a = "",
                  s = 0,
                  u = 0,
                  c = 0;
                this.lexer.setInput(t), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, this.yy.parser = this, void 0 === this.lexer.yylloc && (this.lexer.yylloc = {});
                var l = this.lexer.yylloc;
                i.push(l);
                var f = this.lexer.options && this.lexer.options.ranges;
                "function" == typeof this.yy.parseError && (this.parseError = this.yy.parseError);
                for (var p, d, h, m, g, v, y, _, b, w = {};;) {
                  if (h = n[n.length - 1], this.defaultActions[h] ? m = this.defaultActions[h] : (null !== p && void 0 !== p || (p = function () {
                    var t;
                    return t = e.lexer.lex() || 1, "number" != typeof t && (t = e.symbols_[t] || t), t;
                  }()), m = o[h] && o[h][p]), void 0 === m || !m.length || !m[0]) {
                    var S = "";
                    if (!c) {
                      b = [];
                      for (v in o[h]) this.terminals_[v] && v > 2 && b.push("'" + this.terminals_[v] + "'");
                      S = this.lexer.showPosition ? "Parse error on line " + (s + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + b.join(", ") + ", got '" + (this.terminals_[p] || p) + "'" : "Parse error on line " + (s + 1) + ": Unexpected " + (1 == p ? "end of input" : "'" + (this.terminals_[p] || p) + "'"), this.parseError(S, {
                        text: this.lexer.match,
                        token: this.terminals_[p] || p,
                        line: this.lexer.yylineno,
                        loc: l,
                        expected: b
                      });
                    }
                  }
                  if (m[0] instanceof Array && m.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + h + ", token: " + p);
                  switch (m[0]) {
                    case 1:
                      n.push(p), r.push(this.lexer.yytext), i.push(this.lexer.yylloc), n.push(m[1]), p = null, d ? (p = d, d = null) : (u = this.lexer.yyleng, a = this.lexer.yytext, s = this.lexer.yylineno, l = this.lexer.yylloc, c > 0 && c--);
                      break;
                    case 2:
                      if (y = this.productions_[m[1]][1], w.$ = r[r.length - y], w._$ = {
                        first_line: i[i.length - (y || 1)].first_line,
                        last_line: i[i.length - 1].last_line,
                        first_column: i[i.length - (y || 1)].first_column,
                        last_column: i[i.length - 1].last_column
                      }, f && (w._$.range = [i[i.length - (y || 1)].range[0], i[i.length - 1].range[1]]), void 0 !== (g = this.performAction.call(w, a, u, s, this.yy, m[1], r, i))) return g;
                      y && (n = n.slice(0, -1 * y * 2), r = r.slice(0, -1 * y), i = i.slice(0, -1 * y)), n.push(this.productions_[m[1]][0]), r.push(w.$), i.push(w._$), _ = o[n[n.length - 2]][n[n.length - 1]], n.push(_);
                      break;
                    case 3:
                      return !0;
                  }
                }
                return !0;
              }
            },
            n = function () {
              var t = {
                EOF: 1,
                parseError: function parseError(t, e) {
                  if (!this.yy.parser) throw new Error(t);
                  this.yy.parser.parseError(t, e);
                },
                setInput: function setInput(t) {
                  return this._input = t, this._more = this._less = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                  }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
                },
                input: function input() {
                  var t = this._input[0];
                  return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
                },
                unput: function unput(t) {
                  var e = t.length,
                    n = t.split(/(?:\r\n?|\n)/g);
                  this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e - 1), this.offset -= e;
                  var r = this.match.split(/(?:\r\n?|\n)/g);
                  this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
                  var i = this.yylloc.range;
                  return this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
                  }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this;
                },
                more: function more() {
                  return this._more = !0, this;
                },
                less: function less(t) {
                  this.unput(this.match.slice(t));
                },
                pastInput: function pastInput() {
                  var t = this.matched.substr(0, this.matched.length - this.match.length);
                  return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
                },
                upcomingInput: function upcomingInput() {
                  var t = this.match;
                  return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
                },
                showPosition: function showPosition() {
                  var t = this.pastInput(),
                    e = new Array(t.length + 1).join("-");
                  return t + this.upcomingInput() + "\n" + e + "^";
                },
                next: function next() {
                  if (this.done) return this.EOF;
                  this._input || (this.done = !0);
                  var t, e, n, r, i;
                  this._more || (this.yytext = "", this.match = "");
                  for (var o = this._currentRules(), a = 0; a < o.length && (!(n = this._input.match(this.rules[o[a]])) || e && !(n[0].length > e[0].length) || (e = n, r = a, this.options.flex)); a++);
                  return e ? (i = e[0].match(/(?:\r\n?|\n).*/g), i && (this.yylineno += i.length), this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: i ? i[i.length - 1].length - i[i.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + e[0].length
                  }, this.yytext += e[0], this.match += e[0], this.matches = e, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._input = this._input.slice(e[0].length), this.matched += e[0], t = this.performAction.call(this, this.yy, this, o[r], this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), t || void 0) : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                  });
                },
                lex: function lex() {
                  var t = this.next();
                  return void 0 !== t ? t : this.lex();
                },
                begin: function begin(t) {
                  this.conditionStack.push(t);
                },
                popState: function popState() {
                  return this.conditionStack.pop();
                },
                _currentRules: function _currentRules() {
                  return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                },
                topState: function topState() {
                  return this.conditionStack[this.conditionStack.length - 2];
                },
                pushState: function pushState(t) {
                  this.begin(t);
                }
              };
              return t.options = {}, t.performAction = function (t, e, n, r) {
                function i(t, n) {
                  return e.yytext = e.yytext.substring(t, e.yyleng - n + t);
                }
                switch (n) {
                  case 0:
                    if ("\\\\" === e.yytext.slice(-2) ? (i(0, 1), this.begin("mu")) : "\\" === e.yytext.slice(-1) ? (i(0, 1), this.begin("emu")) : this.begin("mu"), e.yytext) return 15;
                    break;
                  case 1:
                    return 15;
                  case 2:
                    return this.popState(), 15;
                  case 3:
                    return this.begin("raw"), 15;
                  case 4:
                    return this.popState(), "raw" === this.conditionStack[this.conditionStack.length - 1] ? 15 : (i(5, 9), "END_RAW_BLOCK");
                  case 5:
                    return 15;
                  case 6:
                    return this.popState(), 14;
                  case 7:
                    return 65;
                  case 8:
                    return 68;
                  case 9:
                    return 19;
                  case 10:
                    return this.popState(), this.begin("raw"), 23;
                  case 11:
                    return 55;
                  case 12:
                    return 60;
                  case 13:
                    return 29;
                  case 14:
                    return 47;
                  case 15:
                  case 16:
                    return this.popState(), 44;
                  case 17:
                    return 34;
                  case 18:
                    return 39;
                  case 19:
                    return 51;
                  case 20:
                    return 48;
                  case 21:
                    this.unput(e.yytext), this.popState(), this.begin("com");
                    break;
                  case 22:
                    return this.popState(), 14;
                  case 23:
                    return 48;
                  case 24:
                    return 73;
                  case 25:
                  case 26:
                    return 72;
                  case 27:
                    return 87;
                  case 28:
                    break;
                  case 29:
                    return this.popState(), 54;
                  case 30:
                    return this.popState(), 33;
                  case 31:
                    return e.yytext = i(1, 2).replace(/\\"/g, '"'), 80;
                  case 32:
                    return e.yytext = i(1, 2).replace(/\\'/g, "'"), 80;
                  case 33:
                    return 85;
                  case 34:
                  case 35:
                    return 82;
                  case 36:
                    return 83;
                  case 37:
                    return 84;
                  case 38:
                    return 81;
                  case 39:
                    return 75;
                  case 40:
                    return 77;
                  case 41:
                    return 72;
                  case 42:
                    return e.yytext = e.yytext.replace(/\\([\\\]])/g, "$1"), 72;
                  case 43:
                    return "INVALID";
                  case 44:
                    return 5;
                }
              }, t.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^\/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]+?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/], t.conditions = {
                mu: {
                  rules: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44],
                  inclusive: !1
                },
                emu: {
                  rules: [2],
                  inclusive: !1
                },
                com: {
                  rules: [6],
                  inclusive: !1
                },
                raw: {
                  rules: [3, 4, 5],
                  inclusive: !1
                },
                INITIAL: {
                  rules: [0, 1, 44],
                  inclusive: !0
                }
              }, t;
            }();
          return e.lexer = n, t.prototype = e, e.Parser = t, new t();
        }();
        e.default = n, t.exports = e.default;
      }, function (t, e, n) {
        "use strict";

        function r() {
          var t = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
          this.options = t;
        }
        function i(t, e, n) {
          void 0 === e && (e = t.length);
          var r = t[e - 1],
            i = t[e - 2];
          return r ? "ContentStatement" === r.type ? (i || !n ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(r.original) : void 0 : n;
        }
        function o(t, e, n) {
          void 0 === e && (e = -1);
          var r = t[e + 1],
            i = t[e + 2];
          return r ? "ContentStatement" === r.type ? (i || !n ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(r.original) : void 0 : n;
        }
        function a(t, e, n) {
          var r = t[null == e ? 0 : e + 1];
          if (r && "ContentStatement" === r.type && (n || !r.rightStripped)) {
            var i = r.value;
            r.value = r.value.replace(n ? /^\s+/ : /^[ \t]*\r?\n?/, ""), r.rightStripped = r.value !== i;
          }
        }
        function s(t, e, n) {
          var r = t[null == e ? t.length - 1 : e - 1];
          if (r && "ContentStatement" === r.type && (n || !r.leftStripped)) {
            var i = r.value;
            return r.value = r.value.replace(n ? /\s+$/ : /[ \t]+$/, ""), r.leftStripped = r.value !== i, r.leftStripped;
          }
        }
        var u = n(1).default;
        e.__esModule = !0;
        var c = n(49),
          l = u(c);
        r.prototype = new l.default(), r.prototype.Program = function (t) {
          var e = !this.options.ignoreStandalone,
            n = !this.isRootSeen;
          this.isRootSeen = !0;
          for (var r = t.body, u = 0, c = r.length; u < c; u++) {
            var l = r[u],
              f = this.accept(l);
            if (f) {
              var p = i(r, u, n),
                d = o(r, u, n),
                h = f.openStandalone && p,
                m = f.closeStandalone && d,
                g = f.inlineStandalone && p && d;
              f.close && a(r, u, !0), f.open && s(r, u, !0), e && g && (a(r, u), s(r, u) && "PartialStatement" === l.type && (l.indent = /([ \t]+$)/.exec(r[u - 1].original)[1])), e && h && (a((l.program || l.inverse).body), s(r, u)), e && m && (a(r, u), s((l.inverse || l.program).body));
            }
          }
          return t;
        }, r.prototype.BlockStatement = r.prototype.DecoratorBlock = r.prototype.PartialBlockStatement = function (t) {
          this.accept(t.program), this.accept(t.inverse);
          var e = t.program || t.inverse,
            n = t.program && t.inverse,
            r = n,
            u = n;
          if (n && n.chained) for (r = n.body[0].program; u.chained;) u = u.body[u.body.length - 1].program;
          var c = {
            open: t.openStrip.open,
            close: t.closeStrip.close,
            openStandalone: o(e.body),
            closeStandalone: i((r || e).body)
          };
          if (t.openStrip.close && a(e.body, null, !0), n) {
            var l = t.inverseStrip;
            l.open && s(e.body, null, !0), l.close && a(r.body, null, !0), t.closeStrip.open && s(u.body, null, !0), !this.options.ignoreStandalone && i(e.body) && o(r.body) && (s(e.body), a(r.body));
          } else t.closeStrip.open && s(e.body, null, !0);
          return c;
        }, r.prototype.Decorator = r.prototype.MustacheStatement = function (t) {
          return t.strip;
        }, r.prototype.PartialStatement = r.prototype.CommentStatement = function (t) {
          var e = t.strip || {};
          return {
            inlineStandalone: !0,
            open: e.open,
            close: e.close
          };
        }, e.default = r, t.exports = e.default;
      }, function (t, e, n) {
        "use strict";

        function r() {
          this.parents = [];
        }
        function i(t) {
          this.acceptRequired(t, "path"), this.acceptArray(t.params), this.acceptKey(t, "hash");
        }
        function o(t) {
          i.call(this, t), this.acceptKey(t, "program"), this.acceptKey(t, "inverse");
        }
        function a(t) {
          this.acceptRequired(t, "name"), this.acceptArray(t.params), this.acceptKey(t, "hash");
        }
        var s = n(1).default;
        e.__esModule = !0;
        var u = n(6),
          c = s(u);
        r.prototype = {
          constructor: r,
          mutating: !1,
          acceptKey: function acceptKey(t, e) {
            var n = this.accept(t[e]);
            if (this.mutating) {
              if (n && !r.prototype[n.type]) throw new c.default('Unexpected node type "' + n.type + '" found when accepting ' + e + " on " + t.type);
              t[e] = n;
            }
          },
          acceptRequired: function acceptRequired(t, e) {
            if (this.acceptKey(t, e), !t[e]) throw new c.default(t.type + " requires " + e);
          },
          acceptArray: function acceptArray(t) {
            for (var e = 0, n = t.length; e < n; e++) this.acceptKey(t, e), t[e] || (t.splice(e, 1), e--, n--);
          },
          accept: function accept(t) {
            if (t) {
              if (!this[t.type]) throw new c.default("Unknown type: " + t.type, t);
              this.current && this.parents.unshift(this.current), this.current = t;
              var e = this[t.type](t);
              return this.current = this.parents.shift(), !this.mutating || e ? e : !1 !== e ? t : void 0;
            }
          },
          Program: function Program(t) {
            this.acceptArray(t.body);
          },
          MustacheStatement: i,
          Decorator: i,
          BlockStatement: o,
          DecoratorBlock: o,
          PartialStatement: a,
          PartialBlockStatement: function PartialBlockStatement(t) {
            a.call(this, t), this.acceptKey(t, "program");
          },
          ContentStatement: function ContentStatement() {},
          CommentStatement: function CommentStatement() {},
          SubExpression: i,
          PathExpression: function PathExpression() {},
          StringLiteral: function StringLiteral() {},
          NumberLiteral: function NumberLiteral() {},
          BooleanLiteral: function BooleanLiteral() {},
          UndefinedLiteral: function UndefinedLiteral() {},
          NullLiteral: function NullLiteral() {},
          Hash: function Hash(t) {
            this.acceptArray(t.pairs);
          },
          HashPair: function HashPair(t) {
            this.acceptRequired(t, "value");
          }
        }, e.default = r, t.exports = e.default;
      }, function (t, e, n) {
        "use strict";

        function r(t, e) {
          if (e = e.path ? e.path.original : e, t.path.original !== e) {
            var n = {
              loc: t.path.loc
            };
            throw new g.default(t.path.original + " doesn't match " + e, n);
          }
        }
        function i(t, e) {
          this.source = t, this.start = {
            line: e.first_line,
            column: e.first_column
          }, this.end = {
            line: e.last_line,
            column: e.last_column
          };
        }
        function o(t) {
          return /^\[.*\]$/.test(t) ? t.substring(1, t.length - 1) : t;
        }
        function a(t, e) {
          return {
            open: "~" === t.charAt(2),
            close: "~" === e.charAt(e.length - 3)
          };
        }
        function s(t) {
          return t.replace(/^\{\{~?!-?-?/, "").replace(/-?-?~?\}\}$/, "");
        }
        function u(t, e, n) {
          n = this.locInfo(n);
          for (var r = t ? "@" : "", i = [], o = 0, a = 0, s = e.length; a < s; a++) {
            var u = e[a].part,
              c = e[a].original !== u;
            if (r += (e[a].separator || "") + u, c || ".." !== u && "." !== u && "this" !== u) i.push(u);else {
              if (i.length > 0) throw new g.default("Invalid path: " + r, {
                loc: n
              });
              ".." === u && o++;
            }
          }
          return {
            type: "PathExpression",
            data: t,
            depth: o,
            parts: i,
            original: r,
            loc: n
          };
        }
        function c(t, e, n, r, i, o) {
          var a = r.charAt(3) || r.charAt(2),
            s = "{" !== a && "&" !== a;
          return {
            type: /\*/.test(r) ? "Decorator" : "MustacheStatement",
            path: t,
            params: e,
            hash: n,
            escaped: s,
            strip: i,
            loc: this.locInfo(o)
          };
        }
        function l(t, e, n, i) {
          r(t, n), i = this.locInfo(i);
          var o = {
            type: "Program",
            body: e,
            strip: {},
            loc: i
          };
          return {
            type: "BlockStatement",
            path: t.path,
            params: t.params,
            hash: t.hash,
            program: o,
            openStrip: {},
            inverseStrip: {},
            closeStrip: {},
            loc: i
          };
        }
        function f(t, e, n, i, o, a) {
          i && i.path && r(t, i);
          var s = /\*/.test(t.open);
          e.blockParams = t.blockParams;
          var u = void 0,
            c = void 0;
          if (n) {
            if (s) throw new g.default("Unexpected inverse block on decorator", n);
            n.chain && (n.program.body[0].closeStrip = i.strip), c = n.strip, u = n.program;
          }
          return o && (o = u, u = e, e = o), {
            type: s ? "DecoratorBlock" : "BlockStatement",
            path: t.path,
            params: t.params,
            hash: t.hash,
            program: e,
            inverse: u,
            openStrip: t.strip,
            inverseStrip: c,
            closeStrip: i && i.strip,
            loc: this.locInfo(a)
          };
        }
        function p(t, e) {
          if (!e && t.length) {
            var n = t[0].loc,
              r = t[t.length - 1].loc;
            n && r && (e = {
              source: n.source,
              start: {
                line: n.start.line,
                column: n.start.column
              },
              end: {
                line: r.end.line,
                column: r.end.column
              }
            });
          }
          return {
            type: "Program",
            body: t,
            strip: {},
            loc: e
          };
        }
        function d(t, e, n, i) {
          return r(t, n), {
            type: "PartialBlockStatement",
            name: t.path,
            params: t.params,
            hash: t.hash,
            program: e,
            openStrip: t.strip,
            closeStrip: n && n.strip,
            loc: this.locInfo(i)
          };
        }
        var h = n(1).default;
        e.__esModule = !0, e.SourceLocation = i, e.id = o, e.stripFlags = a, e.stripComment = s, e.preparePath = u, e.prepareMustache = c, e.prepareRawBlock = l, e.prepareBlock = f, e.prepareProgram = p, e.preparePartialBlock = d;
        var m = n(6),
          g = h(m);
      }, function (t, e, n) {
        "use strict";

        function r() {}
        function i(t, e, n) {
          if (null == t || "string" != typeof t && "Program" !== t.type) throw new f.default("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + t);
          e = e || {}, "data" in e || (e.data = !0), e.compat && (e.useDepths = !0);
          var r = n.parse(t, e),
            i = new n.Compiler().compile(r, e);
          return new n.JavaScriptCompiler().compile(i, e);
        }
        function o(t, e, n) {
          function r() {
            var r = n.parse(t, e),
              i = new n.Compiler().compile(r, e),
              o = new n.JavaScriptCompiler().compile(i, e, void 0, !0);
            return n.template(o);
          }
          function i(t, e) {
            return o || (o = r()), o.call(this, t, e);
          }
          if (void 0 === e && (e = {}), null == t || "string" != typeof t && "Program" !== t.type) throw new f.default("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + t);
          e = p.extend({}, e), "data" in e || (e.data = !0), e.compat && (e.useDepths = !0);
          var o = void 0;
          return i._setup = function (t) {
            return o || (o = r()), o._setup(t);
          }, i._child = function (t, e, n, i) {
            return o || (o = r()), o._child(t, e, n, i);
          }, i;
        }
        function a(t, e) {
          if (t === e) return !0;
          if (p.isArray(t) && p.isArray(e) && t.length === e.length) {
            for (var n = 0; n < t.length; n++) if (!a(t[n], e[n])) return !1;
            return !0;
          }
        }
        function s(t) {
          if (!t.path.parts) {
            var e = t.path;
            t.path = {
              type: "PathExpression",
              data: !1,
              depth: 0,
              parts: [e.original + ""],
              original: e.original + "",
              loc: e.loc
            };
          }
        }
        var u = n(34).default,
          c = n(1).default;
        e.__esModule = !0, e.Compiler = r, e.precompile = i, e.compile = o;
        var l = n(6),
          f = c(l),
          p = n(5),
          d = n(45),
          h = c(d),
          m = [].slice;
        r.prototype = {
          compiler: r,
          equals: function equals(t) {
            var e = this.opcodes.length;
            if (t.opcodes.length !== e) return !1;
            for (var n = 0; n < e; n++) {
              var r = this.opcodes[n],
                i = t.opcodes[n];
              if (r.opcode !== i.opcode || !a(r.args, i.args)) return !1;
            }
            e = this.children.length;
            for (var n = 0; n < e; n++) if (!this.children[n].equals(t.children[n])) return !1;
            return !0;
          },
          guid: 0,
          compile: function compile(t, e) {
            return this.sourceNode = [], this.opcodes = [], this.children = [], this.options = e, this.stringParams = e.stringParams, this.trackIds = e.trackIds, e.blockParams = e.blockParams || [], e.knownHelpers = p.extend(u(null), {
              helperMissing: !0,
              blockHelperMissing: !0,
              each: !0,
              if: !0,
              unless: !0,
              with: !0,
              log: !0,
              lookup: !0
            }, e.knownHelpers), this.accept(t);
          },
          compileProgram: function compileProgram(t) {
            var e = new this.compiler(),
              n = e.compile(t, this.options),
              r = this.guid++;
            return this.usePartial = this.usePartial || n.usePartial, this.children[r] = n, this.useDepths = this.useDepths || n.useDepths, r;
          },
          accept: function accept(t) {
            if (!this[t.type]) throw new f.default("Unknown type: " + t.type, t);
            this.sourceNode.unshift(t);
            var e = this[t.type](t);
            return this.sourceNode.shift(), e;
          },
          Program: function Program(t) {
            this.options.blockParams.unshift(t.blockParams);
            for (var e = t.body, n = e.length, r = 0; r < n; r++) this.accept(e[r]);
            return this.options.blockParams.shift(), this.isSimple = 1 === n, this.blockParams = t.blockParams ? t.blockParams.length : 0, this;
          },
          BlockStatement: function BlockStatement(t) {
            s(t);
            var e = t.program,
              n = t.inverse;
            e = e && this.compileProgram(e), n = n && this.compileProgram(n);
            var r = this.classifySexpr(t);
            "helper" === r ? this.helperSexpr(t, e, n) : "simple" === r ? (this.simpleSexpr(t), this.opcode("pushProgram", e), this.opcode("pushProgram", n), this.opcode("emptyHash"), this.opcode("blockValue", t.path.original)) : (this.ambiguousSexpr(t, e, n), this.opcode("pushProgram", e), this.opcode("pushProgram", n), this.opcode("emptyHash"), this.opcode("ambiguousBlockValue")), this.opcode("append");
          },
          DecoratorBlock: function DecoratorBlock(t) {
            var e = t.program && this.compileProgram(t.program),
              n = this.setupFullMustacheParams(t, e, void 0),
              r = t.path;
            this.useDecorators = !0, this.opcode("registerDecorator", n.length, r.original);
          },
          PartialStatement: function PartialStatement(t) {
            this.usePartial = !0;
            var e = t.program;
            e && (e = this.compileProgram(t.program));
            var n = t.params;
            if (n.length > 1) throw new f.default("Unsupported number of partial arguments: " + n.length, t);
            n.length || (this.options.explicitPartialContext ? this.opcode("pushLiteral", "undefined") : n.push({
              type: "PathExpression",
              parts: [],
              depth: 0
            }));
            var r = t.name.original,
              i = "SubExpression" === t.name.type;
            i && this.accept(t.name), this.setupFullMustacheParams(t, e, void 0, !0);
            var o = t.indent || "";
            this.options.preventIndent && o && (this.opcode("appendContent", o), o = ""), this.opcode("invokePartial", i, r, o), this.opcode("append");
          },
          PartialBlockStatement: function PartialBlockStatement(t) {
            this.PartialStatement(t);
          },
          MustacheStatement: function MustacheStatement(t) {
            this.SubExpression(t), t.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append");
          },
          Decorator: function Decorator(t) {
            this.DecoratorBlock(t);
          },
          ContentStatement: function ContentStatement(t) {
            t.value && this.opcode("appendContent", t.value);
          },
          CommentStatement: function CommentStatement() {},
          SubExpression: function SubExpression(t) {
            s(t);
            var e = this.classifySexpr(t);
            "simple" === e ? this.simpleSexpr(t) : "helper" === e ? this.helperSexpr(t) : this.ambiguousSexpr(t);
          },
          ambiguousSexpr: function ambiguousSexpr(t, e, n) {
            var r = t.path,
              i = r.parts[0],
              o = null != e || null != n;
            this.opcode("getContext", r.depth), this.opcode("pushProgram", e), this.opcode("pushProgram", n), r.strict = !0, this.accept(r), this.opcode("invokeAmbiguous", i, o);
          },
          simpleSexpr: function simpleSexpr(t) {
            var e = t.path;
            e.strict = !0, this.accept(e), this.opcode("resolvePossibleLambda");
          },
          helperSexpr: function helperSexpr(t, e, n) {
            var r = this.setupFullMustacheParams(t, e, n),
              i = t.path,
              o = i.parts[0];
            if (this.options.knownHelpers[o]) this.opcode("invokeKnownHelper", r.length, o);else {
              if (this.options.knownHelpersOnly) throw new f.default("You specified knownHelpersOnly, but used the unknown helper " + o, t);
              i.strict = !0, i.falsy = !0, this.accept(i), this.opcode("invokeHelper", r.length, i.original, h.default.helpers.simpleId(i));
            }
          },
          PathExpression: function PathExpression(t) {
            this.addDepth(t.depth), this.opcode("getContext", t.depth);
            var e = t.parts[0],
              n = h.default.helpers.scopedId(t),
              r = !t.depth && !n && this.blockParamIndex(e);
            r ? this.opcode("lookupBlockParam", r, t.parts) : e ? t.data ? (this.options.data = !0, this.opcode("lookupData", t.depth, t.parts, t.strict)) : this.opcode("lookupOnContext", t.parts, t.falsy, t.strict, n) : this.opcode("pushContext");
          },
          StringLiteral: function StringLiteral(t) {
            this.opcode("pushString", t.value);
          },
          NumberLiteral: function NumberLiteral(t) {
            this.opcode("pushLiteral", t.value);
          },
          BooleanLiteral: function BooleanLiteral(t) {
            this.opcode("pushLiteral", t.value);
          },
          UndefinedLiteral: function UndefinedLiteral() {
            this.opcode("pushLiteral", "undefined");
          },
          NullLiteral: function NullLiteral() {
            this.opcode("pushLiteral", "null");
          },
          Hash: function Hash(t) {
            var e = t.pairs,
              n = 0,
              r = e.length;
            for (this.opcode("pushHash"); n < r; n++) this.pushParam(e[n].value);
            for (; n--;) this.opcode("assignToHash", e[n].key);
            this.opcode("popHash");
          },
          opcode: function opcode(t) {
            this.opcodes.push({
              opcode: t,
              args: m.call(arguments, 1),
              loc: this.sourceNode[0].loc
            });
          },
          addDepth: function addDepth(t) {
            t && (this.useDepths = !0);
          },
          classifySexpr: function classifySexpr(t) {
            var e = h.default.helpers.simpleId(t.path),
              n = e && !!this.blockParamIndex(t.path.parts[0]),
              r = !n && h.default.helpers.helperExpression(t),
              i = !n && (r || e);
            if (i && !r) {
              var o = t.path.parts[0],
                a = this.options;
              a.knownHelpers[o] ? r = !0 : a.knownHelpersOnly && (i = !1);
            }
            return r ? "helper" : i ? "ambiguous" : "simple";
          },
          pushParams: function pushParams(t) {
            for (var e = 0, n = t.length; e < n; e++) this.pushParam(t[e]);
          },
          pushParam: function pushParam(t) {
            var e = null != t.value ? t.value : t.original || "";
            if (this.stringParams) e.replace && (e = e.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")), t.depth && this.addDepth(t.depth), this.opcode("getContext", t.depth || 0), this.opcode("pushStringParam", e, t.type), "SubExpression" === t.type && this.accept(t);else {
              if (this.trackIds) {
                var n = void 0;
                if (!t.parts || h.default.helpers.scopedId(t) || t.depth || (n = this.blockParamIndex(t.parts[0])), n) {
                  var r = t.parts.slice(1).join(".");
                  this.opcode("pushId", "BlockParam", n, r);
                } else e = t.original || e, e.replace && (e = e.replace(/^this(?:\.|$)/, "").replace(/^\.\//, "").replace(/^\.$/, "")), this.opcode("pushId", t.type, e);
              }
              this.accept(t);
            }
          },
          setupFullMustacheParams: function setupFullMustacheParams(t, e, n, r) {
            var i = t.params;
            return this.pushParams(i), this.opcode("pushProgram", e), this.opcode("pushProgram", n), t.hash ? this.accept(t.hash) : this.opcode("emptyHash", r), i;
          },
          blockParamIndex: function blockParamIndex(t) {
            for (var e = 0, n = this.options.blockParams.length; e < n; e++) {
              var r = this.options.blockParams[e],
                i = r && p.indexOf(r, t);
              if (r && i >= 0) return [e, i];
            }
          }
        };
      }, function (t, e, n) {
        "use strict";

        function r(t) {
          this.value = t;
        }
        function i() {}
        function o(t, e, n, r) {
          var i = e.popStack(),
            o = 0,
            a = n.length;
          for (t && a--; o < a; o++) i = e.nameLookup(i, n[o], r);
          return t ? [e.aliasable("container.strict"), "(", i, ", ", e.quotedString(n[o]), ", ", JSON.stringify(e.source.currentLocation), " )"] : i;
        }
        var a = n(13).default,
          s = n(1).default;
        e.__esModule = !0;
        var u = n(4),
          c = n(6),
          l = s(c),
          f = n(5),
          p = n(53),
          d = s(p);
        i.prototype = {
          nameLookup: function nameLookup(t, e) {
            return this.internalNameLookup(t, e);
          },
          depthedLookup: function depthedLookup(t) {
            return [this.aliasable("container.lookup"), '(depths, "', t, '")'];
          },
          compilerInfo: function compilerInfo() {
            var t = u.COMPILER_REVISION;
            return [t, u.REVISION_CHANGES[t]];
          },
          appendToBuffer: function appendToBuffer(t, e, n) {
            return f.isArray(t) || (t = [t]), t = this.source.wrap(t, e), this.environment.isSimple ? ["return ", t, ";"] : n ? ["buffer += ", t, ";"] : (t.appendToBuffer = !0, t);
          },
          initializeBuffer: function initializeBuffer() {
            return this.quotedString("");
          },
          internalNameLookup: function internalNameLookup(t, e) {
            return this.lookupPropertyFunctionIsUsed = !0, ["lookupProperty(", t, ",", JSON.stringify(e), ")"];
          },
          lookupPropertyFunctionIsUsed: !1,
          compile: function compile(t, e, n, r) {
            this.environment = t, this.options = e, this.stringParams = this.options.stringParams, this.trackIds = this.options.trackIds, this.precompile = !r, this.name = this.environment.name, this.isChild = !!n, this.context = n || {
              decorators: [],
              programs: [],
              environments: []
            }, this.preamble(), this.stackSlot = 0, this.stackVars = [], this.aliases = {}, this.registers = {
              list: []
            }, this.hashes = [], this.compileStack = [], this.inlineStack = [], this.blockParams = [], this.compileChildren(t, e), this.useDepths = this.useDepths || t.useDepths || t.useDecorators || this.options.compat, this.useBlockParams = this.useBlockParams || t.useBlockParams;
            var i = t.opcodes,
              o = void 0,
              a = void 0,
              s = void 0,
              u = void 0;
            for (s = 0, u = i.length; s < u; s++) o = i[s], this.source.currentLocation = o.loc, a = a || o.loc, this[o.opcode].apply(this, o.args);
            if (this.source.currentLocation = a, this.pushSource(""), this.stackSlot || this.inlineStack.length || this.compileStack.length) throw new l.default("Compile completed with content left on stack");
            this.decorators.isEmpty() ? this.decorators = void 0 : (this.useDecorators = !0, this.decorators.prepend(["var decorators = container.decorators, ", this.lookupPropertyFunctionVarDeclaration(), ";\n"]), this.decorators.push("return fn;"), r ? this.decorators = Function.apply(this, ["fn", "props", "container", "depth0", "data", "blockParams", "depths", this.decorators.merge()]) : (this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n"), this.decorators.push("}\n"), this.decorators = this.decorators.merge()));
            var c = this.createFunctionContext(r);
            if (this.isChild) return c;
            var f = {
              compiler: this.compilerInfo(),
              main: c
            };
            this.decorators && (f.main_d = this.decorators, f.useDecorators = !0);
            var p = this.context,
              d = p.programs,
              h = p.decorators;
            for (s = 0, u = d.length; s < u; s++) d[s] && (f[s] = d[s], h[s] && (f[s + "_d"] = h[s], f.useDecorators = !0));
            return this.environment.usePartial && (f.usePartial = !0), this.options.data && (f.useData = !0), this.useDepths && (f.useDepths = !0), this.useBlockParams && (f.useBlockParams = !0), this.options.compat && (f.compat = !0), r ? f.compilerOptions = this.options : (f.compiler = JSON.stringify(f.compiler), this.source.currentLocation = {
              start: {
                line: 1,
                column: 0
              }
            }, f = this.objectLiteral(f), e.srcName ? (f = f.toStringWithSourceMap({
              file: e.destName
            }), f.map = f.map && f.map.toString()) : f = f.toString()), f;
          },
          preamble: function preamble() {
            this.lastContext = 0, this.source = new d.default(this.options.srcName), this.decorators = new d.default(this.options.srcName);
          },
          createFunctionContext: function createFunctionContext(t) {
            var e = this,
              n = "",
              r = this.stackVars.concat(this.registers.list);
            r.length > 0 && (n += ", " + r.join(", "));
            var i = 0;
            a(this.aliases).forEach(function (t) {
              var r = e.aliases[t];
              r.children && r.referenceCount > 1 && (n += ", alias" + ++i + "=" + t, r.children[0] = "alias" + i);
            }), this.lookupPropertyFunctionIsUsed && (n += ", " + this.lookupPropertyFunctionVarDeclaration());
            var o = ["container", "depth0", "helpers", "partials", "data"];
            (this.useBlockParams || this.useDepths) && o.push("blockParams"), this.useDepths && o.push("depths");
            var s = this.mergeSource(n);
            return t ? (o.push(s), Function.apply(this, o)) : this.source.wrap(["function(", o.join(","), ") {\n  ", s, "}"]);
          },
          mergeSource: function mergeSource(t) {
            var e = this.environment.isSimple,
              n = !this.forceBuffer,
              r = void 0,
              i = void 0,
              o = void 0,
              a = void 0;
            return this.source.each(function (t) {
              t.appendToBuffer ? (o ? t.prepend("  + ") : o = t, a = t) : (o && (i ? o.prepend("buffer += ") : r = !0, a.add(";"), o = a = void 0), i = !0, e || (n = !1));
            }), n ? o ? (o.prepend("return "), a.add(";")) : i || this.source.push('return "";') : (t += ", buffer = " + (r ? "" : this.initializeBuffer()), o ? (o.prepend("return buffer + "), a.add(";")) : this.source.push("return buffer;")), t && this.source.prepend("var " + t.substring(2) + (r ? "" : ";\n")), this.source.merge();
          },
          lookupPropertyFunctionVarDeclaration: function lookupPropertyFunctionVarDeclaration() {
            return "\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    ".trim();
          },
          blockValue: function blockValue(t) {
            var e = this.aliasable("container.hooks.blockHelperMissing"),
              n = [this.contextName(0)];
            this.setupHelperArgs(t, 0, n);
            var r = this.popStack();
            n.splice(1, 0, r), this.push(this.source.functionCall(e, "call", n));
          },
          ambiguousBlockValue: function ambiguousBlockValue() {
            var t = this.aliasable("container.hooks.blockHelperMissing"),
              e = [this.contextName(0)];
            this.setupHelperArgs("", 0, e, !0), this.flushInline();
            var n = this.topStack();
            e.splice(1, 0, n), this.pushSource(["if (!", this.lastHelper, ") { ", n, " = ", this.source.functionCall(t, "call", e), "}"]);
          },
          appendContent: function appendContent(t) {
            this.pendingContent ? t = this.pendingContent + t : this.pendingLocation = this.source.currentLocation, this.pendingContent = t;
          },
          append: function append() {
            if (this.isInline()) this.replaceStack(function (t) {
              return [" != null ? ", t, ' : ""'];
            }), this.pushSource(this.appendToBuffer(this.popStack()));else {
              var t = this.popStack();
              this.pushSource(["if (", t, " != null) { ", this.appendToBuffer(t, void 0, !0), " }"]), this.environment.isSimple && this.pushSource(["else { ", this.appendToBuffer("''", void 0, !0), " }"]);
            }
          },
          appendEscaped: function appendEscaped() {
            this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"), "(", this.popStack(), ")"]));
          },
          getContext: function getContext(t) {
            this.lastContext = t;
          },
          pushContext: function pushContext() {
            this.pushStackLiteral(this.contextName(this.lastContext));
          },
          lookupOnContext: function lookupOnContext(t, e, n, r) {
            var i = 0;
            r || !this.options.compat || this.lastContext ? this.pushContext() : this.push(this.depthedLookup(t[i++])), this.resolvePath("context", t, i, e, n);
          },
          lookupBlockParam: function lookupBlockParam(t, e) {
            this.useBlockParams = !0, this.push(["blockParams[", t[0], "][", t[1], "]"]), this.resolvePath("context", e, 1);
          },
          lookupData: function lookupData(t, e, n) {
            t ? this.pushStackLiteral("container.data(data, " + t + ")") : this.pushStackLiteral("data"), this.resolvePath("data", e, 0, !0, n);
          },
          resolvePath: function resolvePath(t, e, n, r, i) {
            var a = this;
            if (this.options.strict || this.options.assumeObjects) return void this.push(o(this.options.strict && i, this, e, t));
            for (var s = e.length; n < s; n++) this.replaceStack(function (i) {
              var o = a.nameLookup(i, e[n], t);
              return r ? [" && ", o] : [" != null ? ", o, " : ", i];
            });
          },
          resolvePossibleLambda: function resolvePossibleLambda() {
            this.push([this.aliasable("container.lambda"), "(", this.popStack(), ", ", this.contextName(0), ")"]);
          },
          pushStringParam: function pushStringParam(t, e) {
            this.pushContext(), this.pushString(e), "SubExpression" !== e && ("string" == typeof t ? this.pushString(t) : this.pushStackLiteral(t));
          },
          emptyHash: function emptyHash(t) {
            this.trackIds && this.push("{}"), this.stringParams && (this.push("{}"), this.push("{}")), this.pushStackLiteral(t ? "undefined" : "{}");
          },
          pushHash: function pushHash() {
            this.hash && this.hashes.push(this.hash), this.hash = {
              values: {},
              types: [],
              contexts: [],
              ids: []
            };
          },
          popHash: function popHash() {
            var t = this.hash;
            this.hash = this.hashes.pop(), this.trackIds && this.push(this.objectLiteral(t.ids)), this.stringParams && (this.push(this.objectLiteral(t.contexts)), this.push(this.objectLiteral(t.types))), this.push(this.objectLiteral(t.values));
          },
          pushString: function pushString(t) {
            this.pushStackLiteral(this.quotedString(t));
          },
          pushLiteral: function pushLiteral(t) {
            this.pushStackLiteral(t);
          },
          pushProgram: function pushProgram(t) {
            null != t ? this.pushStackLiteral(this.programExpression(t)) : this.pushStackLiteral(null);
          },
          registerDecorator: function registerDecorator(t, e) {
            var n = this.nameLookup("decorators", e, "decorator"),
              r = this.setupHelperArgs(e, t);
            this.decorators.push(["fn = ", this.decorators.functionCall(n, "", ["fn", "props", "container", r]), " || fn;"]);
          },
          invokeHelper: function invokeHelper(t, e, n) {
            var r = this.popStack(),
              i = this.setupHelper(t, e),
              o = [];
            n && o.push(i.name), o.push(r), this.options.strict || o.push(this.aliasable("container.hooks.helperMissing"));
            var a = ["(", this.itemsSeparatedBy(o, "||"), ")"],
              s = this.source.functionCall(a, "call", i.callParams);
            this.push(s);
          },
          itemsSeparatedBy: function itemsSeparatedBy(t, e) {
            var n = [];
            n.push(t[0]);
            for (var r = 1; r < t.length; r++) n.push(e, t[r]);
            return n;
          },
          invokeKnownHelper: function invokeKnownHelper(t, e) {
            var n = this.setupHelper(t, e);
            this.push(this.source.functionCall(n.name, "call", n.callParams));
          },
          invokeAmbiguous: function invokeAmbiguous(t, e) {
            this.useRegister("helper");
            var n = this.popStack();
            this.emptyHash();
            var r = this.setupHelper(0, t, e),
              i = this.lastHelper = this.nameLookup("helpers", t, "helper"),
              o = ["(", "(helper = ", i, " || ", n, ")"];
            this.options.strict || (o[0] = "(helper = ", o.push(" != null ? helper : ", this.aliasable("container.hooks.helperMissing"))), this.push(["(", o, r.paramsInit ? ["),(", r.paramsInit] : [], "),", "(typeof helper === ", this.aliasable('"function"'), " ? ", this.source.functionCall("helper", "call", r.callParams), " : helper))"]);
          },
          invokePartial: function invokePartial(t, e, n) {
            var r = [],
              i = this.setupParams(e, 1, r);
            t && (e = this.popStack(), delete i.name), n && (i.indent = JSON.stringify(n)), i.helpers = "helpers", i.partials = "partials", i.decorators = "container.decorators", t ? r.unshift(e) : r.unshift(this.nameLookup("partials", e, "partial")), this.options.compat && (i.depths = "depths"), i = this.objectLiteral(i), r.push(i), this.push(this.source.functionCall("container.invokePartial", "", r));
          },
          assignToHash: function assignToHash(t) {
            var e = this.popStack(),
              n = void 0,
              r = void 0,
              i = void 0;
            this.trackIds && (i = this.popStack()), this.stringParams && (r = this.popStack(), n = this.popStack());
            var o = this.hash;
            n && (o.contexts[t] = n), r && (o.types[t] = r), i && (o.ids[t] = i), o.values[t] = e;
          },
          pushId: function pushId(t, e, n) {
            "BlockParam" === t ? this.pushStackLiteral("blockParams[" + e[0] + "].path[" + e[1] + "]" + (n ? " + " + JSON.stringify("." + n) : "")) : "PathExpression" === t ? this.pushString(e) : "SubExpression" === t ? this.pushStackLiteral("true") : this.pushStackLiteral("null");
          },
          compiler: i,
          compileChildren: function compileChildren(t, e) {
            for (var n = t.children, r = void 0, i = void 0, o = 0, a = n.length; o < a; o++) {
              r = n[o], i = new this.compiler();
              var s = this.matchExistingProgram(r);
              if (null == s) {
                this.context.programs.push("");
                var u = this.context.programs.length;
                r.index = u, r.name = "program" + u, this.context.programs[u] = i.compile(r, e, this.context, !this.precompile), this.context.decorators[u] = i.decorators, this.context.environments[u] = r, this.useDepths = this.useDepths || i.useDepths, this.useBlockParams = this.useBlockParams || i.useBlockParams, r.useDepths = this.useDepths, r.useBlockParams = this.useBlockParams;
              } else r.index = s.index, r.name = "program" + s.index, this.useDepths = this.useDepths || s.useDepths, this.useBlockParams = this.useBlockParams || s.useBlockParams;
            }
          },
          matchExistingProgram: function matchExistingProgram(t) {
            for (var e = 0, n = this.context.environments.length; e < n; e++) {
              var r = this.context.environments[e];
              if (r && r.equals(t)) return r;
            }
          },
          programExpression: function programExpression(t) {
            var e = this.environment.children[t],
              n = [e.index, "data", e.blockParams];
            return (this.useBlockParams || this.useDepths) && n.push("blockParams"), this.useDepths && n.push("depths"), "container.program(" + n.join(", ") + ")";
          },
          useRegister: function useRegister(t) {
            this.registers[t] || (this.registers[t] = !0, this.registers.list.push(t));
          },
          push: function push(t) {
            return t instanceof r || (t = this.source.wrap(t)), this.inlineStack.push(t), t;
          },
          pushStackLiteral: function pushStackLiteral(t) {
            this.push(new r(t));
          },
          pushSource: function pushSource(t) {
            this.pendingContent && (this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation)), this.pendingContent = void 0), t && this.source.push(t);
          },
          replaceStack: function replaceStack(t) {
            var e = ["("],
              n = void 0,
              i = void 0,
              o = void 0;
            if (!this.isInline()) throw new l.default("replaceStack on non-inline");
            var a = this.popStack(!0);
            if (a instanceof r) n = [a.value], e = ["(", n], o = !0;else {
              i = !0;
              var s = this.incrStack();
              e = ["((", this.push(s), " = ", a, ")"], n = this.topStack();
            }
            var u = t.call(this, n);
            o || this.popStack(), i && this.stackSlot--, this.push(e.concat(u, ")"));
          },
          incrStack: function incrStack() {
            return this.stackSlot++, this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot), this.topStackName();
          },
          topStackName: function topStackName() {
            return "stack" + this.stackSlot;
          },
          flushInline: function flushInline() {
            var t = this.inlineStack;
            this.inlineStack = [];
            for (var e = 0, n = t.length; e < n; e++) {
              var i = t[e];
              if (i instanceof r) this.compileStack.push(i);else {
                var o = this.incrStack();
                this.pushSource([o, " = ", i, ";"]), this.compileStack.push(o);
              }
            }
          },
          isInline: function isInline() {
            return this.inlineStack.length;
          },
          popStack: function popStack(t) {
            var e = this.isInline(),
              n = (e ? this.inlineStack : this.compileStack).pop();
            if (!t && n instanceof r) return n.value;
            if (!e) {
              if (!this.stackSlot) throw new l.default("Invalid stack pop");
              this.stackSlot--;
            }
            return n;
          },
          topStack: function topStack() {
            var t = this.isInline() ? this.inlineStack : this.compileStack,
              e = t[t.length - 1];
            return e instanceof r ? e.value : e;
          },
          contextName: function contextName(t) {
            return this.useDepths && t ? "depths[" + t + "]" : "depth" + t;
          },
          quotedString: function quotedString(t) {
            return this.source.quotedString(t);
          },
          objectLiteral: function objectLiteral(t) {
            return this.source.objectLiteral(t);
          },
          aliasable: function aliasable(t) {
            var e = this.aliases[t];
            return e ? (e.referenceCount++, e) : (e = this.aliases[t] = this.source.wrap(t), e.aliasable = !0, e.referenceCount = 1, e);
          },
          setupHelper: function setupHelper(t, e, n) {
            var r = [];
            return {
              params: r,
              paramsInit: this.setupHelperArgs(e, t, r, n),
              name: this.nameLookup("helpers", e, "helper"),
              callParams: [this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : (container.nullContext || {})")].concat(r)
            };
          },
          setupParams: function setupParams(t, e, n) {
            var r = {},
              i = [],
              o = [],
              a = [],
              s = !n,
              u = void 0;
            s && (n = []), r.name = this.quotedString(t), r.hash = this.popStack(), this.trackIds && (r.hashIds = this.popStack()), this.stringParams && (r.hashTypes = this.popStack(), r.hashContexts = this.popStack());
            var c = this.popStack(),
              l = this.popStack();
            (l || c) && (r.fn = l || "container.noop", r.inverse = c || "container.noop");
            for (var f = e; f--;) u = this.popStack(), n[f] = u, this.trackIds && (a[f] = this.popStack()), this.stringParams && (o[f] = this.popStack(), i[f] = this.popStack());
            return s && (r.args = this.source.generateArray(n)), this.trackIds && (r.ids = this.source.generateArray(a)), this.stringParams && (r.types = this.source.generateArray(o), r.contexts = this.source.generateArray(i)), this.options.data && (r.data = "data"), this.useBlockParams && (r.blockParams = "blockParams"), r;
          },
          setupHelperArgs: function setupHelperArgs(t, e, n, r) {
            var i = this.setupParams(t, e, n);
            return i.loc = JSON.stringify(this.source.currentLocation), i = this.objectLiteral(i), r ? (this.useRegister("options"), n.push("options"), ["options=", i]) : n ? (n.push(i), "") : i;
          }
        }, function () {
          for (var t = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" "), e = i.RESERVED_WORDS = {}, n = 0, r = t.length; n < r; n++) e[t[n]] = !0;
        }(), i.isValidJavaScriptVariableName = function (t) {
          return !i.RESERVED_WORDS[t] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(t);
        }, e.default = i, t.exports = e.default;
      }, function (t, e, n) {
        "use strict";

        function r(t, e, n) {
          if (a.isArray(t)) {
            for (var r = [], i = 0, o = t.length; i < o; i++) r.push(e.wrap(t[i], n));
            return r;
          }
          return "boolean" == typeof t || "number" == typeof t ? t + "" : t;
        }
        function i(t) {
          this.srcFile = t, this.source = [];
        }
        var o = n(13).default;
        e.__esModule = !0;
        var a = n(5),
          s = void 0;
        try {} catch (t) {}
        s || (s = function s(t, e, n, r) {
          this.src = "", r && this.add(r);
        }, s.prototype = {
          add: function add(t) {
            a.isArray(t) && (t = t.join("")), this.src += t;
          },
          prepend: function prepend(t) {
            a.isArray(t) && (t = t.join("")), this.src = t + this.src;
          },
          toStringWithSourceMap: function toStringWithSourceMap() {
            return {
              code: this.toString()
            };
          },
          toString: function toString() {
            return this.src;
          }
        }), i.prototype = {
          isEmpty: function isEmpty() {
            return !this.source.length;
          },
          prepend: function prepend(t, e) {
            this.source.unshift(this.wrap(t, e));
          },
          push: function push(t, e) {
            this.source.push(this.wrap(t, e));
          },
          merge: function merge() {
            var t = this.empty();
            return this.each(function (e) {
              t.add(["  ", e, "\n"]);
            }), t;
          },
          each: function each(t) {
            for (var e = 0, n = this.source.length; e < n; e++) t(this.source[e]);
          },
          empty: function empty() {
            var t = this.currentLocation || {
              start: {}
            };
            return new s(t.start.line, t.start.column, this.srcFile);
          },
          wrap: function wrap(t) {
            var e = arguments.length <= 1 || void 0 === arguments[1] ? this.currentLocation || {
              start: {}
            } : arguments[1];
            return t instanceof s ? t : (t = r(t, this, e), new s(e.start.line, e.start.column, this.srcFile, t));
          },
          functionCall: function functionCall(t, e, n) {
            return n = this.generateList(n), this.wrap([t, e ? "." + e + "(" : "(", n, ")"]);
          },
          quotedString: function quotedString(t) {
            return '"' + (t + "").replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029") + '"';
          },
          objectLiteral: function objectLiteral(t) {
            var e = this,
              n = [];
            o(t).forEach(function (i) {
              var o = r(t[i], e);
              "undefined" !== o && n.push([e.quotedString(i), ":", o]);
            });
            var i = this.generateList(n);
            return i.prepend("{"), i.add("}"), i;
          },
          generateList: function generateList(t) {
            for (var e = this.empty(), n = 0, i = t.length; n < i; n++) n && e.add(","), e.add(r(t[n], this));
            return e;
          },
          generateArray: function generateArray(t) {
            var e = this.generateList(t);
            return e.prepend("["), e.add("]"), e;
          }
        }, e.default = i, t.exports = e.default;
      }]);
    });
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (t, e, n) {
    var r = n(45);
    t.exports = function (t, e, n, i) {
      try {
        return i ? e(r(n)[0], n[1]) : e(n);
      } catch (e) {
        var o = t.return;
        throw void 0 !== o && r(o.call(t)), e;
      }
    };
  }, function (t, e, n) {
    var r = n(80),
      i = n(23)("iterator"),
      o = Array.prototype;
    t.exports = function (t) {
      return void 0 !== t && (r.Array === t || o[i] === t);
    };
  }, function (t, e, n) {
    var r = n(23)("iterator"),
      i = !1;
    try {
      var o = [7][r]();
      o.return = function () {
        i = !0;
      }, Array.from(o, function () {
        throw 2;
      });
    } catch (t) {}
    t.exports = function (t, e) {
      if (!e && !i) return !1;
      var n = !1;
      try {
        var o = [7],
          a = o[r]();
        a.next = function () {
          return {
            done: n = !0
          };
        }, o[r] = function () {
          return a;
        }, t(o);
      } catch (t) {}
      return n;
    };
  }, function (t, e, n) {
    var r = n(45),
      i = n(115),
      o = n(23)("species");
    t.exports = function (t, e) {
      var n,
        a = r(t).constructor;
      return void 0 === a || void 0 == (n = r(a)[o]) ? e : i(n);
    };
  }, function (t, e, n) {
    var r,
      i,
      o,
      a = n(78),
      s = n(519),
      u = n(226),
      c = n(156),
      l = n(22),
      f = l.process,
      p = l.setImmediate,
      d = l.clearImmediate,
      h = l.MessageChannel,
      m = l.Dispatch,
      g = 0,
      v = {},
      y = function y() {
        var t = +this;
        if (v.hasOwnProperty(t)) {
          var e = v[t];
          delete v[t], e();
        }
      },
      _ = function _(t) {
        y.call(t.data);
      };
    p && d || (p = function p(t) {
      for (var e = [], n = 1; arguments.length > n;) e.push(arguments[n++]);
      return v[++g] = function () {
        s("function" == typeof t ? t : Function(t), e);
      }, r(g), g;
    }, d = function d(t) {
      delete v[t];
    }, "process" == n(93)(f) ? r = function r(t) {
      f.nextTick(a(y, t, 1));
    } : m && m.now ? r = function r(t) {
      m.now(a(y, t, 1));
    } : h ? (i = new h(), o = i.port2, i.port1.onmessage = _, r = a(o.postMessage, o, 1)) : l.addEventListener && "function" == typeof postMessage && !l.importScripts ? (r = function r(t) {
      l.postMessage(t + "", "*");
    }, l.addEventListener("message", _, !1)) : r = "onreadystatechange" in c("script") ? function (t) {
      u.appendChild(c("script")).onreadystatechange = function () {
        u.removeChild(this), y.call(t);
      };
    } : function (t) {
      setTimeout(a(y, t, 1), 0);
    }), t.exports = {
      set: p,
      clear: d
    };
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return {
          e: !1,
          v: t()
        };
      } catch (t) {
        return {
          e: !0,
          v: t
        };
      }
    };
  }, function (t, e, n) {
    var r = n(45),
      i = n(46),
      o = n(173);
    t.exports = function (t, e) {
      if (r(t), i(e) && e.constructor === t) return e;
      var n = o.f(t);
      return (0, n.resolve)(e), n.promise;
    };
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(243), n(245), n(547), n(175), n(246), n(83), n(174)], void 0 !== (i = function (t, e, n, r, i, o, a, s) {
      var u = t.$;
      return a.extend({
        className: "primary-auth",
        state: {
          enabled: !0
        },
        View: e,
        constructor: function constructor(t) {
          t.appState.unset("username"), this.model = new i({
            multiOptionalFactorEnroll: t.settings.get("features.multiOptionalFactorEnroll"),
            settings: t.settings,
            appState: t.appState
          }, {
            parse: !0
          }), a.apply(this, arguments), this.addListeners(), t.settings.get("hasConfiguredButtons") && this.add(n, {
            prepend: t.settings.get("socialAuthPositionTop"),
            options: {
              currentController: this
            }
          }), this.addFooter(t), this.setUsername();
        },
        addFooter: function addFooter(t) {
          this.add(new o(this.toJSON({
            appState: t.appState
          }))), (t.settings.get("features.registration") || t.appState.get("isIdxStateToken")) && this.add(new r({
            settings: this.settings,
            appState: t.appState
          }));
        },
        setUsername: function setUsername() {
          var t = this.model.get("username");
          t && this.options.appState.set("username", t);
        },
        events: {
          "focusout input[name=username]": function focusoutInputNameUsername() {
            if (this.shouldComputeDeviceFingerprint()) {
              var t = this;
              s.generateDeviceFingerprint(this.settings.get("baseUrl"), this.$el).then(function (e) {
                t.options.appState.set("deviceFingerprint", e), t.options.appState.set("username", t.model.get("username"));
              }).fail(function () {
                t.options.appState.set("username", t.model.get("username"));
              });
            } else this.options.appState.set("username", this.model.get("username"));
          },
          "focusin input": function focusinInput(t) {
            u(t.target.parentElement).addClass("focused-input");
          },
          "focusout input": function focusoutInput(t) {
            u(t.target.parentElement).removeClass("focused-input");
          },
          "click .button-show": function clickButtonShow() {
            this.trigger("passwordRevealed");
          }
        },
        initialize: function initialize() {
          this.options.appState.unset("deviceFingerprint"), this.listenTo(this.model, "change:username", function (t, e) {
            e || this.options.appState.set("username", "");
          }), this.listenTo(this.model, "save", function () {
            this.state.set("enabled", !1);
          }), this.listenTo(this.model, "error", function () {
            this.state.set("enabled", !0);
          });
        },
        shouldComputeDeviceFingerprint: function shouldComputeDeviceFingerprint() {
          return this.settings.get("features.securityImage") && this.settings.get("features.deviceFingerprinting") && this.settings.get("features.useDeviceFingerprintForSecurityImage");
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(14), n(174), n(539), n(13)], void 0 !== (i = function (t, e, n, r, i) {
      var o = t._;
      return t.Form.extend({
        className: "primary-auth-form",
        noCancelButton: !0,
        attributes: {
          novalidate: "novalidate"
        },
        save: function save() {
          return this.settings.get("features.passwordlessAuth") ? t.loc("oform.next", "login") : t.loc("primaryauth.submit", "login");
        },
        saveId: "okta-signin-submit",
        layout: "o-form-theme",
        title: function title() {
          var e = t.loc("primaryauth.title", "login");
          return this.settings.get("socialAuthPositionTop") && (e = ""), e;
        },
        initialize: function initialize() {
          var t = this.settings.get("features.trackTypingPattern");
          this.listenTo(this, "save", function () {
            if (t) {
              var e = r.getTypingPattern();
              this.options.appState.set("typingPattern", e);
            }
            var i = this,
              a = {
                username: this.model.get("username")
              };
            this.settings.get("features.passwordlessAuth") || (a.password = this.model.get("password")), this.settings.processCreds(a).then(function () {
              if (i.settings.get("features.deviceFingerprinting")) return n.generateDeviceFingerprint(i.settings.get("baseUrl"), i.$el).then(function (t) {
                i.options.appState.set("deviceFingerprint", t);
              }).fail(function () {});
            }).then(o.bind(this.model.save, this.model));
          }), this.stateEnableChange();
        },
        stateEnableChange: function stateEnableChange() {
          this.listenTo(this.state, "change:enabled", function (t, e) {
            e ? this.enable() : this.disable();
          });
        },
        inputs: function inputs() {
          var t = [];
          return t.push(this.getUsernameField()), this.settings.get("features.passwordlessAuth") || t.push(this.getPasswordField()), this.settings.get("features.rememberMe") && t.push(this.getRemeberMeCheckbox()), t;
        },
        getUsernameField: function getUsernameField() {
          var n = this;
          return {
            className: "margin-btm-5",
            label: t.loc("primaryauth.username.placeholder", "login"),
            "label-top": !0,
            explain: function explain() {
              return !(n.settings.get("features.hideDefaultTip") && !n.isCustomized("primaryauth.username.tooltip")) && i.createInputExplain("primaryauth.username.tooltip", "primaryauth.username.placeholder", "login");
            },
            "explain-top": !0,
            name: "username",
            input: e,
            inputId: "okta-signin-username",
            type: "text",
            disabled: this.options.appState.get("disableUsername"),
            render: function render() {
              this.$("input[name=" + this.options.name + "]").prop("required", !0);
            }
          };
        },
        getPasswordField: function getPasswordField() {
          var e = this,
            n = {
              className: "margin-btm-30",
              label: t.loc("primaryauth.password.placeholder", "login"),
              "label-top": !0,
              explain: function explain() {
                return !(e.settings.get("features.hideDefaultTip") && !e.isCustomized("primaryauth.password.tooltip")) && i.createInputExplain("primaryauth.password.tooltip", "primaryauth.password.placeholder", "login");
              },
              "explain-top": !0,
              name: "password",
              inputId: "okta-signin-password",
              validateOnlyIfDirty: !0,
              type: "password",
              render: function render() {
                this.$("input[name=" + this.options.name + "]").prop("required", !0);
              }
            };
          return this.settings.get("features.showPasswordToggleOnSignInPage") && (n.params = {}, n.params.showPasswordToggle = !0), n;
        },
        isCustomized: function isCustomized(t) {
          var e = this.settings.get("language"),
            n = this.settings.get("i18n");
          return !!(n && n[e] && n[e][t]);
        },
        getRemeberMeCheckbox: function getRemeberMeCheckbox() {
          return {
            label: !1,
            placeholder: t.loc("remember", "login"),
            name: "remember",
            type: "checkbox",
            "label-top": !0,
            className: "margin-btm-0",
            initialize: function initialize() {
              this.listenTo(this.model, "change:remember", function (t, e) {
                this.$(":checkbox").prop("checked", e).trigger("updateState");
              });
            }
          };
        },
        focus: function focus() {
          this.model.get("username") ? this.settings.get("features.passwordlessAuth") || this.getInputs().toArray()[1].focus() : this.getInputs().first().focus(), this.settings.get("features.trackTypingPattern") && r.track("okta-signin-username");
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    e.__esModule = !0;
    var i = n(541),
      o = r(i),
      a = n(544),
      s = r(a);
    e.default = function () {
      function t(t, e) {
        var n = [],
          r = !0,
          i = !1,
          o = void 0;
        try {
          for (var a, u = (0, s.default)(t); !(r = (a = u.next()).done) && (n.push(a.value), !e || n.length !== e); r = !0);
        } catch (t) {
          i = !0, o = t;
        } finally {
          try {
            !r && u.return && u.return();
          } finally {
            if (i) throw o;
          }
        }
        return n;
      }
      return function (e, n) {
        if (Array.isArray(e)) return e;
        if ((0, o.default)(Object(e))) return t(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };
    }();
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(153)], void 0 !== (i = function (t, e) {
      var n = t._,
        r = t.$,
        i = t.internal.util.Util,
        o = t.tpl('<div class="auth-divider">      <span class="auth-divider-text">{{text}}</span>    </div>'),
        a = t.tpl('<h2 data-se="o-form-head" class="okta-form-title o-form-head">{{title}}</h2>');
      return t.View.extend({
        className: "primary-auth-container",
        children: function children() {
          var e = [],
            r = this.settings.get("configuredSocialIdps"),
            i = this.settings.get("piv"),
            s = this.settings.get("customButtons"),
            u = o({
              text: t.loc("socialauth.divider.text", "login")
            });
          return this.settings.get("hasPivCard") && e.push(this._createPivButton(i)), n.each(r, function (t) {
            e.push(this._createSocialIdpButton(t));
          }, this), n.each(s, function (t) {
            e.push(this._createCustomButton(t));
          }, this), this.settings.get("socialAuthPositionTop") ? (e.unshift(a({
            title: t.loc("primaryauth.title", "login")
          })), e.push(u)) : e.unshift(u), e;
        },
        _createSocialIdpButton: function _createSocialIdpButton(n) {
          return t.createButton({
            attributes: {
              "data-se": n.dataAttr
            },
            className: n.className,
            title: function title() {
              return n.text || t.loc(n.i18nKey);
            },
            click: function click(t) {
              if (t.preventDefault(), this.settings.get("oauth2Enabled")) e.getTokens(this.settings, {
                idp: n.id
              }, this.options.currentController);else {
                var o = this.settings.get("baseUrl"),
                  a = r.param({
                    fromURI: this.settings.get("relayState")
                  }),
                  s = o + "/sso/idps/" + n.id + "?" + a;
                i.redirect(s);
              }
            }
          });
        },
        _createPivButton: function _createPivButton(e) {
          var n = e.className || "";
          return t.createButton({
            attributes: {
              "data-se": "piv-card-button"
            },
            className: n + " piv-button",
            title: e.text || t.loc("piv.cac.card", "login"),
            click: function click(t) {
              t.preventDefault(), this.options.appState.trigger("navigate", "signin/verify/piv");
            }
          });
        },
        _createCustomButton: function _createCustomButton(e) {
          return t.createButton({
            attributes: {
              "data-se": e.dataAttr
            },
            className: e.className + " default-custom-button",
            title: e.title,
            click: e.click
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      var e = t.internal.util.Util,
        n = t._;
      return t.View.extend({
        template: '      <a href="#" data-se="needhelp" aria-expanded="false"         aria-controls="help-links-container" class="link help js-help">      {{i18n code="needhelp" bundle="login"}}      </a>      <ul class="help-links js-help-links" id="help-links-container">        <li>        <a href="#" data-se="forgot-password" class="link js-forgot-password">        {{i18n code="forgotpassword" bundle="login"}}        </a>        </li>        {{#if features.selfServiceUnlock}}          <li>          <a href="#" data-se="unlock" class="link js-unlock">          {{i18n code="unlockaccount" bundle="login"}}          </a>          </li>        {{/if}}        {{#each helpLinks.custom}}          <li>          <a href="{{href}}" class="link js-custom" rel="noopener noreferrer"          {{#if target}}target="{{target}}"{{/if}}>{{text}}</a>          </li>        {{/each}}        <li>        <a href="{{helpLinkUrl}}" data-se="help-link" class="link js-help-link"          rel="noopener noreferrer" target="_blank">        {{i18n code="help" bundle="login"}}        </a>        </li>      </ul>    ',
        className: "auth-footer",
        initialize: function initialize() {
          this.listenTo(this.state, "change:enabled", function (t, e) {
            this.$(":link").toggleClass("o-form-disabled", !e);
          });
        },
        getTemplateData: function getTemplateData() {
          var e,
            r = this.settings.get("helpLinks.help");
          return e = r || t.tpl("{{baseUrl}}/help/login")({
            baseUrl: this.settings.get("baseUrl")
          }), n.extend(this.settings.toJSON({
            verbose: !0
          }), {
            helpLinkUrl: e
          });
        },
        postRender: function postRender() {
          this.$(".js-help-links").hide();
        },
        toggleLinks: function toggleLinks(t) {
          t.preventDefault(), this.$(".js-help-links").slideToggle(200, n.bind(function () {
            this.$(".js-help").attr("aria-expanded", this.$(".js-help-links").is(":visible"));
          }, this));
        },
        events: {
          "click .js-help": function clickJsHelp(t) {
            t.preventDefault(), this.state.get("enabled") && this.toggleLinks(t);
          },
          "click .js-forgot-password": function clickJsForgotPassword(t) {
            if (t.preventDefault(), this.state.get("enabled")) {
              var n = this.settings.get("helpLinks.forgotPassword");
              n ? e.redirect(n) : this.options.appState.trigger("navigate", "signin/forgot-password");
            }
          },
          "click .js-unlock": function clickJsUnlock(t) {
            if (t.preventDefault(), this.state.get("enabled")) {
              var n = this.settings.get("helpLinks.unlock");
              n ? e.redirect(n) : this.options.appState.trigger("navigate", "signin/unlock");
            }
          }
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r,
      i,
      o,
      a = n(89);
    !function (t) {
      t && t.__esModule;
    }(a); /**
          * Duo Web SDK v2
          * Copyright 2019, Duo Security
          */
    !function (n, a) {
      i = [], r = a, void 0 !== (o = "function" == typeof r ? r.apply(e, i) : r) && (t.exports = o);
    }(0, function () {
      function t() {
        E = "", T = "sig_response", k = void 0, A = void 0, O = void 0, C = void 0, I = void 0, R = void 0;
      }
      function e(t, e) {
        var n = e || "https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe";
        throw new Error("Duo Web SDK error: " + t + (n ? "\nSee " + n + " for more information" : ""));
      }
      function n(t) {
        return t.replace(/([a-z])([A-Z])/, "$1-$2").toLowerCase();
      }
      function r(t, e) {
        return "dataset" in t ? t.dataset[e] : t.getAttribute("data-" + n(e));
      }
      function i(t, e, n, r) {
        "addEventListener" in window ? t.addEventListener(e, r, !1) : t.attachEvent(n, r);
      }
      function o(t, e, n, r) {
        "removeEventListener" in window ? t.removeEventListener(e, r, !1) : t.detachEvent(n, r);
      }
      function a(t) {
        i(document, "DOMContentLoaded", "onreadystatechange", t);
      }
      function s(t) {
        o(document, "DOMContentLoaded", "onreadystatechange", t);
      }
      function u(t) {
        i(window, "message", "onmessage", t);
      }
      function c(t) {
        o(window, "message", "onmessage", t);
      }
      function l(t) {
        if (t) {
          0 === t.indexOf("ERR|") && e(t.split("|")[1]), -1 !== t.indexOf(":") && 2 === t.split(":").length || e("Duo was given a bad token.  This might indicate a configuration problem with one of Duo's client libraries.");
          var n = t.split(":");
          return A = t, O = n[0], C = n[1], {
            sigRequest: t,
            duoSig: n[0],
            appSig: n[1]
          };
        }
      }
      function f(t) {
        return Boolean(t.origin === "https://" + k && "string" == typeof t.data && (t.data.match(P) || t.data.match(N) || t.data.match(M)));
      }
      function p(e) {
        t(), e && (e.host && (k = e.host), e.sig_request && l(e.sig_request), e.post_action && (E = e.post_action), e.post_argument && (T = e.post_argument), "function" == typeof e.submit_callback && (R = e.submit_callback));
        var n = d(e);
        n ? S(n, e.iframeAttributes || {}) : w(e), s(p);
      }
      function d(t) {
        var n;
        return t.iframe && t.iframeContainer ? e("Passing both `iframe` and `iframeContainer` arguments at the same time is not allowed.") : t.iframe ? (n = h(t.iframe), g(n)) : t.iframeContainer ? (n = h(t.iframeContainer), v(n)) : n = document.getElementById("duo_iframe"), n;
      }
      function h(t) {
        return t.tagName ? t : "string" == typeof t ? document.getElementById(t) : null;
      }
      function m(t) {
        return t && t.tagName && "iframe" === t.tagName.toLowerCase();
      }
      function g(t) {
        t && !m(t) && e("`iframe` only accepts an iframe element or the id of an iframe. To use a non-iframe element, use the `iframeContainer` argument.");
      }
      function v(t) {
        t && m(t) && e("`iframeContainer` only accepts a non-iframe element or the id of a non-iframe. To use a non-iframe element, use the `iframeContainer` argument on Duo.init().");
      }
      function y() {
        return ["https://", k, "/frame/web/v1/auth?tx=", O, "&parent=", encodeURIComponent(document.location.href), "&v=2.8"].join("");
      }
      function _(t) {
        if (f(t)) if (t.data.match(M)) {
          var e = t.data.substring("DUO_OPEN_WINDOW|".length);
          b(e) && window.open(e, "_self");
        } else x(t.data), c(_);
      }
      function b(t) {
        if (!t) return !1;
        var e = document.createElement("a");
        if (e.href = t, "duotrustedendpoints:" === e.protocol) return !0;
        if ("https:" !== e.protocol) return !1;
        for (var n = 0; n < L.length; n++) if (e.hostname.endsWith("." + L[n]) || e.hostname === L[n]) return !0;
        return !1;
      }
      function w(t) {
        a(function n() {
          var r = d(t);
          r || e('This page does not contain an iframe for Duo to use. Add an element like <iframe id="duo_iframe"></iframe> to this page.'), S(r, t.iframeAttributes || {}), s(n);
        });
      }
      function S(t, n) {
        if (k || (k = r(t, "host")) || e("No API hostname is given for Duo to use.  Be sure to pass a `host` parameter to Duo.init, or through the `data-host` attribute on the iframe element."), O && C || (l(r(t, "sigRequest")), O && C || e("No valid signed request is given.  Be sure to give the `sig_request` parameter to Duo.init, or use the `data-sig-request` attribute on the iframe element.")), "" === E && (E = r(t, "postAction") || E), "sig_response" === T && (T = r(t, "postArgument") || T), m(t)) I = t, I.src = y();else {
          for (; t.firstChild;) t.removeChild(t.firstChild);
          I = document.createElement("iframe"), n.src = y();
          for (var i in n) I.setAttribute(i, n[i]);
          t.appendChild(I);
        }
        u(_);
      }
      function x(t) {
        E(t + ":" + C);
      }
      var E,
        T,
        k,
        A,
        O,
        C,
        I,
        R,
        P = /^(?:AUTH|ENROLL)+\|[A-Za-z0-9\+\/=]+\|[A-Za-z0-9\+\/=]+$/,
        N = /^ERR\|[\w\s\.\(\)]+$/,
        M = /^DUO_OPEN_WINDOW\|/,
        L = ["duo.com", "duosecurity.com", "duomobile.s3-us-west-1.amazonaws.com"];
      return t(), {
        init: p,
        _onReady: a,
        _parseSigRequest: l,
        _isDuoMessage: f,
        _doPostBack: x
      };
    });
  }, function (t, e, n) {
    t.exports = n(562);
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;
    var r = n(172),
      i = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(r);
    e.default = function (t) {
      return function () {
        var e = t.apply(this, arguments);
        return new i.default(function (t, n) {
          function r(o, a) {
            try {
              var s = e[o](a),
                u = s.value;
            } catch (t) {
              return void n(t);
            }
            if (!s.done) return i.default.resolve(u).then(function (t) {
              r("next", t);
            }, function (t) {
              r("throw", t);
            });
            t(u);
          }
          return r("next");
        });
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(6)], void 0 !== (i = function (t, e) {
      var n = t._;
      return t.View.extend({
        className: "hide resend-email-infobox",
        template: '<div class="infobox infobox-warning"><span class="icon warning-16"></span><p><span>{{i18n code="email.code.not.received" bundle="login"}}</span><a href="#" class="resend-email-btn">{{i18n code="email.button.resend" bundle="login"}}</a></p></div>',
        events: {
          "click .resend-email-btn": "resendEmail"
        },
        postRender: function postRender() {
          this.showResendCallout();
        },
        showResendCallout: function showResendCallout() {
          var t = this;
          n.delay(function () {
            t.$el.removeClass("hide");
          }, e.API_RATE_LIMIT);
        },
        hideResendCallout: function hideResendCallout() {
          this.$el.addClass("hide");
        },
        resendEmail: function resendEmail(t) {
          t.preventDefault(), this.hideResendCallout(), this.model.resend().finally(this.showResendCallout.bind(this));
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      return t.View.extend({
        className: "okta-waiting-spinner",
        attributes: {
          "data-se": "o-form-okta-waiting-spinner"
        },
        modelEvents: {
          "spinner:show": "show",
          "spinner:hide": "hide"
        },
        initialize: function initialize(t) {
          t && !1 === t.visible && this.hide();
        },
        show: function show() {
          this.$el.removeClass("hide");
        },
        hide: function hide() {
          this.$el.addClass("hide");
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    //Copyright 2014-2015 Google Inc. All rights reserved.
    //license that can be found in the LICENSE file or at
    //https://developers.google.com/open-source/licenses/bsd
    !function () {
      var t = "chrome" in window && window.navigator.userAgent.indexOf("Edge") < 0;
      if (!("u2f" in window) && t) {
        var e,
          n = window.u2f = {};
        n.EXTENSION_ID = "kmendfapggjehodndflmmgagdbamhnfd", n.MessageTypes = {
          U2F_REGISTER_REQUEST: "u2f_register_request",
          U2F_REGISTER_RESPONSE: "u2f_register_response",
          U2F_SIGN_REQUEST: "u2f_sign_request",
          U2F_SIGN_RESPONSE: "u2f_sign_response",
          U2F_GET_API_VERSION_REQUEST: "u2f_get_api_version_request",
          U2F_GET_API_VERSION_RESPONSE: "u2f_get_api_version_response"
        }, n.ErrorCodes = {
          OK: 0,
          OTHER_ERROR: 1,
          BAD_REQUEST: 2,
          CONFIGURATION_UNSUPPORTED: 3,
          DEVICE_INELIGIBLE: 4,
          TIMEOUT: 5
        }, n.U2fRequest, n.U2fResponse, n.Error, n.Transport, n.Transports, n.SignRequest, n.SignResponse, n.RegisterRequest, n.RegisterResponse, n.RegisteredKey, n.GetJsApiVersionResponse, n.getMessagePort = function (t) {
          if ("undefined" != typeof chrome && chrome.runtime) {
            var e = {
              type: n.MessageTypes.U2F_SIGN_REQUEST,
              signRequests: []
            };
            chrome.runtime.sendMessage(n.EXTENSION_ID, e, function () {
              chrome.runtime.lastError ? n.getIframePort_(t) : n.getChromeRuntimePort_(t);
            });
          } else n.isAndroidChrome_() ? n.getAuthenticatorPort_(t) : n.isIosChrome_() ? n.getIosPort_(t) : n.getIframePort_(t);
        }, n.isAndroidChrome_ = function () {
          var t = navigator.userAgent;
          return -1 != t.indexOf("Chrome") && -1 != t.indexOf("Android");
        }, n.isIosChrome_ = function () {
          return ["iPhone", "iPad", "iPod"].indexOf(navigator.platform) > -1;
        }, n.getChromeRuntimePort_ = function (t) {
          var e = chrome.runtime.connect(n.EXTENSION_ID, {
            includeTlsChannelId: !0
          });
          setTimeout(function () {
            t(new n.WrappedChromeRuntimePort_(e));
          }, 0);
        }, n.getAuthenticatorPort_ = function (t) {
          setTimeout(function () {
            t(new n.WrappedAuthenticatorPort_());
          }, 0);
        }, n.getIosPort_ = function (t) {
          setTimeout(function () {
            t(new n.WrappedIosPort_());
          }, 0);
        }, n.WrappedChromeRuntimePort_ = function (t) {
          this.port_ = t;
        }, n.formatSignRequest_ = function (t, r, i, o, a) {
          if (void 0 === e || e < 1.1) {
            for (var s = [], u = 0; u < i.length; u++) s[u] = {
              version: i[u].version,
              challenge: r,
              keyHandle: i[u].keyHandle,
              appId: t
            };
            return {
              type: n.MessageTypes.U2F_SIGN_REQUEST,
              signRequests: s,
              timeoutSeconds: o,
              requestId: a
            };
          }
          return {
            type: n.MessageTypes.U2F_SIGN_REQUEST,
            appId: t,
            challenge: r,
            registeredKeys: i,
            timeoutSeconds: o,
            requestId: a
          };
        }, n.formatRegisterRequest_ = function (t, r, i, o, a) {
          if (void 0 === e || e < 1.1) {
            for (var s = 0; s < i.length; s++) i[s].appId = t;
            for (var u = [], s = 0; s < r.length; s++) u[s] = {
              version: r[s].version,
              challenge: i[0],
              keyHandle: r[s].keyHandle,
              appId: t
            };
            return {
              type: n.MessageTypes.U2F_REGISTER_REQUEST,
              signRequests: u,
              registerRequests: i,
              timeoutSeconds: o,
              requestId: a
            };
          }
          return {
            type: n.MessageTypes.U2F_REGISTER_REQUEST,
            appId: t,
            registerRequests: i,
            registeredKeys: r,
            timeoutSeconds: o,
            requestId: a
          };
        }, n.WrappedChromeRuntimePort_.prototype.postMessage = function (t) {
          this.port_.postMessage(t);
        }, n.WrappedChromeRuntimePort_.prototype.addEventListener = function (t, e) {
          var n = t.toLowerCase();
          "message" != n && "onmessage" != n || this.port_.onMessage.addListener(function (t) {
            e({
              data: t
            });
          });
        }, n.WrappedAuthenticatorPort_ = function () {
          this.requestId_ = -1, this.requestObject_ = null;
        }, n.WrappedAuthenticatorPort_.prototype.postMessage = function (t) {
          var e = n.WrappedAuthenticatorPort_.INTENT_URL_BASE_ + ";S.request=" + encodeURIComponent(JSON.stringify(t)) + ";end";
          document.location = e;
        }, n.WrappedAuthenticatorPort_.prototype.getPortType = function () {
          return "WrappedAuthenticatorPort_";
        }, n.WrappedAuthenticatorPort_.prototype.addEventListener = function (t, e) {
          if ("message" == t.toLowerCase()) {
            var n = this;
            window.addEventListener("message", n.onRequestUpdate_.bind(n, e), !1);
          }
        }, n.WrappedAuthenticatorPort_.prototype.onRequestUpdate_ = function (t, e) {
          var n = JSON.parse(e.data),
            r = (n.intentURL, n.errorCode, null);
          n.hasOwnProperty("data") && (r = JSON.parse(n.data)), t({
            data: r
          });
        }, n.WrappedAuthenticatorPort_.INTENT_URL_BASE_ = "intent:#Intent;action=com.google.android.apps.authenticator.AUTHENTICATE", n.WrappedIosPort_ = function () {}, n.WrappedIosPort_.prototype.postMessage = function (t) {
          var e = JSON.stringify(t),
            n = "u2f://auth?" + encodeURI(e);
          location.replace(n);
        }, n.WrappedIosPort_.prototype.getPortType = function () {
          return "WrappedIosPort_";
        }, n.WrappedIosPort_.prototype.addEventListener = function (t, e) {
          t.toLowerCase();
        }, n.getIframePort_ = function (t) {
          var e = "chrome-extension://" + n.EXTENSION_ID,
            r = document.createElement("iframe");
          r.src = e + "/u2f-comms.html", r.setAttribute("style", "display:none"), document.body.appendChild(r);
          var i = new MessageChannel(),
            o = function o(e) {
              "ready" == e.data && (i.port1.removeEventListener("message", o), t(i.port1));
            };
          i.port1.addEventListener("message", o), i.port1.start(), r.addEventListener("load", function () {
            r.contentWindow.postMessage("init", e, [i.port2]);
          });
        }, n.EXTENSION_TIMEOUT_SEC = 30, n.port_ = null, n.waitingForPort_ = [], n.reqCounter_ = 0, n.callbackMap_ = {}, n.getPortSingleton_ = function (t) {
          n.port_ ? t(n.port_) : (0 == n.waitingForPort_.length && n.getMessagePort(function (t) {
            for (n.port_ = t, n.port_.addEventListener("message", n.responseHandler_); n.waitingForPort_.length;) n.waitingForPort_.shift()(n.port_);
          }), n.waitingForPort_.push(t));
        }, n.responseHandler_ = function (t) {
          var e = t.data,
            r = e.requestId;
          if (r && n.callbackMap_[r]) {
            var i = n.callbackMap_[r];
            delete n.callbackMap_[r], i(e.responseData);
          }
        }, n.sign = function (t, r, i, o, a) {
          void 0 === e ? n.getApiVersion(function (s) {
            e = void 0 === s.js_api_version ? 0 : s.js_api_version, n.sendSignRequest(t, r, i, o, a);
          }) : n.sendSignRequest(t, r, i, o, a);
        }, n.sendSignRequest = function (t, e, r, i, o) {
          n.getPortSingleton_(function (a) {
            var s = ++n.reqCounter_;
            n.callbackMap_[s] = i;
            var u = void 0 !== o ? o : n.EXTENSION_TIMEOUT_SEC,
              c = n.formatSignRequest_(t, e, r, u, s);
            a.postMessage(c);
          });
        }, n.register = function (t, r, i, o, a) {
          void 0 === e ? n.getApiVersion(function (s) {
            e = void 0 === s.js_api_version ? 0 : s.js_api_version, n.sendRegisterRequest(t, r, i, o, a);
          }) : n.sendRegisterRequest(t, r, i, o, a);
        }, n.sendRegisterRequest = function (t, e, r, i, o) {
          n.getPortSingleton_(function (a) {
            var s = ++n.reqCounter_;
            n.callbackMap_[s] = i;
            var u = void 0 !== o ? o : n.EXTENSION_TIMEOUT_SEC,
              c = n.formatRegisterRequest_(t, r, e, u, s);
            a.postMessage(c);
          });
        }, n.getApiVersion = function (t, e) {
          n.getPortSingleton_(function (r) {
            if (r.getPortType) {
              var i;
              switch (r.getPortType()) {
                case "WrappedIosPort_":
                case "WrappedAuthenticatorPort_":
                  i = 1.1;
                  break;
                default:
                  i = 0;
              }
              return void t({
                js_api_version: i
              });
            }
            var o = ++n.reqCounter_;
            n.callbackMap_[o] = t;
            var a = {
              type: n.MessageTypes.U2F_GET_API_VERSION_REQUEST,
              timeoutSeconds: void 0 !== e ? e : n.EXTENSION_TIMEOUT_SEC,
              requestId: o
            };
            r.postMessage(a);
          });
        };
      }
    }();
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(24), n(18)], void 0 !== (i = function (t, e, n) {
      var r = t._,
        i = t.tpl('<span class="factor-cardinality">{{cardinalityText}}</span>'),
        o = t.View.extend({
          className: "enroll-factor-row clearfix",
          template: '      <div class="enroll-factor-icon-container">        <div class="factor-icon enroll-factor-icon {{iconClassName}}">        </div>      </div>      <div class="enroll-factor-description">        <h3 class="enroll-factor-label">{{factorLabel}}</h3>        {{#if factorDescription}}          <p>{{factorDescription}}</p>        {{/if}}        <div class="enroll-factor-button"></div>      </div>    ',
          attributes: function attributes() {
            return {
              "data-se": this.model.get("factorName")
            };
          },
          children: function children() {
            var r = [],
              o = this.model.get("enrolled"),
              a = this.model.get("required"),
              s = this.model.get("cardinality");
            if (this.options.showInlineSetupButton) return [[t.createButton({
              className: "button",
              title: this.getSetupButtonText(),
              click: function click() {
                this.options.appState.trigger("navigate", e.createEnrollFactorUrl(this.model.get("provider"), this.model.get("factorType")));
              }
            }), ".enroll-factor-button"]];
            o ? r.push(['<span class="icon success-16-green"></span>', ".enroll-factor-label"]) : a && r.push(['<span class="icon success-16-gray"></span>', ".enroll-factor-label"]);
            var u = n.getCardinalityText(o, a, s);
            return u && r.push([i({
              cardinalityText: u
            }), ".enroll-factor-description"]), r;
          },
          minimize: function minimize() {
            this.$el.addClass("enroll-factor-row-min");
          },
          maximize: function maximize() {
            this.$el.removeClass("enroll-factor-row-min");
          },
          getSetupButtonText: function getSetupButtonText() {
            return this.model.get("additionalEnrollment") ? t.loc("enroll.choices.setup.another", "login") : t.loc("enroll.choices.setup", "login");
          }
        });
      return t.ListView.extend({
        className: "enroll-factor-list",
        item: o,
        itemSelector: ".list-content",
        template: '      {{#if listTitle}}        <div class="list-title">{{listTitle}}</div>      {{/if}}      <div class="list-content"></div>    ',
        getTemplateData: function getTemplateData() {
          var e = t.ListView.prototype.getTemplateData.call(this);
          return r.extend(e, this), e;
        },
        postRender: function postRender() {
          this.options.minimize && this.invoke("minimize");
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      var e = t._;
      return t.internal.views.forms.inputs.TextBox.extend({
        template: t.tpl('      <span class="okta-form-label-inline o-form-label-inline">{{countryCallingCode}}</span>      <span class="okta-form-input-field input-fix o-form-control">        <input type="{{type}}" placeholder="{{placeholder}}" name="{{name}}"           id="{{inputId}}" value="{{value}}" autocomplete="off"/>      </span>    '),
        initialize: function initialize() {
          this.listenTo(this.model, "change:countryCallingCode", function () {
            this.$(".o-form-label-inline").text(this.model.get("countryCallingCode"));
          });
        },
        preRender: function preRender() {
          this.options.countryCallingCode = this.model.get("countryCallingCode");
        },
        postRender: function postRender() {
          this.$el.removeClass("input-fix o-form-control"), e.defer(e.bind(function () {
            this.$el.parent().addClass("o-form-input-group");
          }, this));
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(19)], void 0 !== (i = function (t, e, n) {
      var r = t._,
        i = t.internal.util.Util;
      return e.extend({
        className: "enroll-custom-factor",
        Model: {
          local: {
            provider: "string",
            factorType: "string"
          },
          save: function save() {
            var t = this;
            return this.manageTransaction(function (e, n) {
              return r.findWhere(e.factors, {
                provider: t.get("provider"),
                factorType: t.get("factorType")
              }).enroll().then(function (e) {
                n(e);
                var r = t.appState.get("enrollCustomFactorRedirectUrl");
                null !== r && i.redirect(r);
              }).fail(function (t) {
                throw t;
              });
            });
          }
        },
        Form: function Form() {
          var e = this.options.appState.get("factors"),
            n = e.findWhere({
              provider: this.options.provider,
              factorType: this.options.factorType
            }),
            r = n.get("vendorName");
          return {
            autoSave: !0,
            title: r,
            subtitle: t.loc("enroll.customFactor.subtitle", "login", [r]),
            save: t.loc("enroll.customFactor.save", "login")
          };
        },
        trapAuthResponse: function trapAuthResponse() {
          if (this.options.appState.get("isMfaEnrollActivate")) return !0;
        },
        initialize: function initialize() {
          this.model.set("provider", this.options.provider), this.model.set("factorType", this.options.factorType);
        },
        Footer: n
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(17), n(33), n(58), n(13), n(57), n(152)], void 0 !== (i = function (t, e, n, r, i, o, a) {
      var s = t.internal.util.Util,
        u = ["facebook", "google", "linkedin", "microsoft"],
        c = ["token", "id_token", "code"],
        l = t.tpl("{{origin}}"),
        f = t._,
        p = n.ConfigError,
        d = n.UnsupportedBrowserError,
        h = t.tpl("https://ok1static.oktacdn.com/assets/js/sdk/okta-signin-widget/{{version}}");
      return t.Model.extend({
        flat: !0,
        authClient: void 0,
        local: {
          baseUrl: ["string", !0],
          recoveryToken: ["string", !1, void 0],
          stateToken: ["string", !1, void 0],
          username: ["string", !1],
          signOutLink: ["string", !1],
          relayState: ["string", !1],
          transformUsername: ["function", !1],
          globalSuccessFn: "function",
          globalErrorFn: "function",
          processCreds: "function",
          logo: "string",
          logoText: ["string", !1],
          helpSupportNumber: "string",
          "features.router": ["boolean", !0, !1],
          "features.securityImage": ["boolean", !0, !1],
          "features.rememberMe": ["boolean", !0, !0],
          "features.autoPush": ["boolean", !0, !1],
          "features.smsRecovery": ["boolean", !0, !1],
          "features.callRecovery": ["boolean", !0, !1],
          "features.emailRecovery": ["boolean", !1, !0],
          "features.webauthn": ["boolean", !0, !1],
          "features.selfServiceUnlock": ["boolean", !0, !1],
          "features.multiOptionalFactorEnroll": ["boolean", !0, !1],
          "features.preventBrowserFromSavingOktaPassword": ["boolean", !0, !0],
          "features.deviceFingerprinting": ["boolean", !1, !1],
          "features.hideSignOutLinkInMFA": ["boolean", !1, !1],
          "features.hideBackToSignInForReset": ["boolean", !1, !1],
          "features.customExpiredPassword": ["boolean", !0, !1],
          "features.registration": ["boolean", !1, !1],
          "features.consent": ["boolean", !1, !1],
          "features.idpDiscovery": ["boolean", !1, !1],
          "features.passwordlessAuth": ["boolean", !1, !1],
          "features.showPasswordToggleOnSignInPage": ["boolean", !1, !1],
          "features.trackTypingPattern": ["boolean", !1, !1],
          "features.redirectByFormSubmit": ["boolean", !1, !1],
          "features.useDeviceFingerprintForSecurityImage": ["boolean", !1, !0],
          "features.restrictRedirectToForeground": ["boolean", !0, !1],
          "features.hideDefaultTip": ["boolean", !1, !0],
          language: ["any", !1],
          i18n: ["object", !1],
          "assets.baseUrl": ["string", !1],
          "assets.rewrite": {
            type: "function",
            value: f.identity
          },
          authScheme: ["string", !1, "OAUTH2"],
          "authParams.display": {
            type: "string",
            values: ["none", "popup", "page"]
          },
          "authParams.responseMode": {
            type: "string",
            values: ["query", "fragment", "form_post", "okta_post_message"]
          },
          "authParams.responseType": ["any", !1, "id_token"],
          "authParams.scopes": ["array", !1],
          "authParams.issuer": ["string", !1],
          "authParams.authorizeUrl": ["string", !1],
          "authParams.state": ["string", !1],
          "authParams.nonce": ["string", !1],
          policyId: "string",
          clientId: "string",
          redirectUri: "string",
          idps: ["array", !1, []],
          idpDisplay: {
            type: "string",
            values: ["PRIMARY", "SECONDARY"],
            value: "SECONDARY"
          },
          oAuthTimeout: ["number", !1],
          "helpLinks.help": "string",
          "helpLinks.forgotPassword": "string",
          "helpLinks.unlock": "string",
          "helpLinks.custom": "array",
          customButtons: ["array", !1, []],
          "registration.click": "function",
          "registration.parseSchema": "function",
          "registration.preSubmit": "function",
          "registration.postSubmit": "function",
          "consent.cancel": "function",
          "idpDiscovery.requestContext": "string",
          "colors.brand": "string",
          brandName: "string",
          piv: ["object", !1, {}]
        },
        derived: {
          redirectUtilFn: {
            deps: ["features.redirectByFormSubmit"],
            fn: function fn(t) {
              return t ? i.redirectWithFormGet.bind(i) : s.redirect.bind(s);
            },
            cache: !0
          },
          supportedLanguages: {
            deps: ["i18n"],
            fn: function fn(t) {
              return f.union(a.supportedLanguages, f.keys(t));
            },
            cache: !0
          },
          languageCode: {
            deps: ["language", "supportedLanguages"],
            fn: function fn(t, e) {
              var n,
                o = r.getUserLanguages(),
                a = f.clone(o),
                s = i.toLower(e);
              f.isString(t) ? a.unshift(t) : f.isFunction(t) && a.unshift(t(e, o)), a.push("en"), n = i.toLower(i.expandLanguages(a));
              var u, c;
              for (u = 0; u < n.length; u++) if ((c = s.indexOf(n[u])) > -1) return e[c];
            }
          },
          oauth2Enabled: {
            deps: ["clientId", "authScheme", "authParams.responseType"],
            fn: function fn(t, e, n) {
              if (!t) return !1;
              if ("oauth2" !== e.toLowerCase()) return !1;
              var r = f.isArray(n) ? n : [n];
              return f.intersection(r, c).length > 0;
            },
            cache: !0
          },
          oauthRedirectUri: {
            deps: ["redirectUri"],
            fn: function fn(t) {
              if (t) return t;
              var e = window.location.origin;
              if (!e) {
                var n = window.location.href,
                  r = window.location.pathname;
                "" !== r && (e = n.substring(0, n.lastIndexOf(r)));
              }
              return l({
                origin: e
              });
            }
          },
          configuredSocialIdps: {
            deps: ["idps"],
            fn: function fn(t) {
              return f.map(t, function (t) {
                var e = t.type && t.type.toLowerCase();
                return e && f.contains(u, e) || (e = "general-idp", t.text = t.text || "{ Please provide a text value }"), t.className = ["social-auth-button", "social-auth-" + e + "-button ", t.className ? t.className : ""].join(" "), t.dataAttr = "social-auth-" + e + "-button", t.i18nKey = "socialauth." + e + ".label", t;
              });
            },
            cache: !0
          },
          hasPivCard: {
            deps: ["piv"],
            fn: function fn(t) {
              return t && t.certAuthUrl;
            },
            cache: !0
          },
          socialAuthPositionTop: {
            deps: ["configuredSocialIdps", "hasPivCard", "idpDisplay"],
            fn: function fn(t, e, n) {
              return (!f.isEmpty(t) || e) && "PRIMARY" === n.toUpperCase();
            },
            cache: !0
          },
          hasConfiguredButtons: {
            deps: ["configuredSocialIdps", "customButtons", "hasPivCard"],
            fn: function fn(t, e, n) {
              return !f.isEmpty(t) || !f.isEmpty(e) || n;
            },
            cache: !0
          }
        },
        initialize: function initialize(e) {
          e.baseUrl ? e.colors && f.isString(e.colors.brand) && !e.colors.brand.match(/^#[0-9A-Fa-f]{6}$/) ? this.callGlobalError(new p(t.loc("error.invalid.colors.brand"))) : r.corsIsNotSupported() && this.callGlobalError(new d(t.loc("error.unsupported.cors"))) : this.callGlobalError(new p(t.loc("error.required.baseUrl")));
        },
        setAcceptLanguageHeader: function setAcceptLanguageHeader(t) {
          t && t.options && t.options.headers && (t.options.headers["Accept-Language"] = this.get("languageCode"));
        },
        setAuthClient: function setAuthClient(t) {
          this.setAcceptLanguageHeader(t), this.authClient = t;
        },
        getAuthClient: function getAuthClient() {
          return this.authClient;
        },
        set: function set() {
          try {
            return t.Model.prototype.set.apply(this, arguments);
          } catch (t) {
            var e = t.message ? t.message : t;
            this.callGlobalError(new p(e));
          }
        },
        callGlobalSuccess: function callGlobalSuccess(t, e) {
          var n = f.extend(e, {
            status: t
          });
          f.defer(f.partial(this.get("globalSuccessFn"), n));
        },
        callGlobalError: function callGlobalError(t) {
          var e = this.get("globalErrorFn") || this.options.globalErrorFn;
          if (!e) throw t;
          e(t);
        },
        transformUsername: function transformUsername(t, e) {
          var n = this.get("transformUsername");
          return n && f.isFunction(n) ? n(t, e) : t;
        },
        processCreds: function processCreds(t) {
          var n = this.get("processCreds");
          return e.Promise(function (e) {
            f.isFunction(n) ? 2 === n.length ? n(t, e) : (n(t), e()) : e();
          });
        },
        parseSchema: function parseSchema(e, n, r) {
          var i = this.get("registration.parseSchema");
          f.isFunction(i) ? i(e, function (t) {
            n(t);
          }, function (e) {
            e = e || {
              errorSummary: t.loc("registration.default.callbackhook.error")
            }, e.callback = "parseSchema", r(e);
          }) : n(e);
        },
        preSubmit: function preSubmit(e, n, r) {
          var i = this.get("registration.preSubmit");
          f.isFunction(i) ? i(e, function (t) {
            n(t);
          }, function (e) {
            e = e || {
              errorSummary: t.loc("registration.default.callbackhook.error")
            }, e.callback = "preSubmit", r(e);
          }) : n(e);
        },
        postSubmit: function postSubmit(e, n, r) {
          var i = this.get("registration.postSubmit");
          f.isFunction(i) ? i(e, function (t) {
            n(t);
          }, function (e) {
            e = e || {
              errorSummary: t.loc("registration.default.callbackhook.error")
            }, e.callback = "postSubmit", r(e);
          }) : n(e);
        },
        parse: function parse(t) {
          if (t.authParams && t.authParams.pkce && (t.authParams.responseType = "code"), t.authParams && t.authParams.scope && (t.authParams.scopes = t.authParams.scope, delete t.authParams.scope), t.labels || t.country) {
            var e = t.labels || {};
            f.each(t.country, function (t, n) {
              e["country." + n] = t;
            }), t.i18n = {}, f.each(a.supportedLanguages, function (n) {
              t.i18n[n] = e;
            }), delete t.labels, delete t.country;
          }
          t.assets || (t.assets = {});
          var n = t.assets.baseUrl;
          return n ? "/" === n[n.length - 1] && (t.assets.baseUrl = n.substring(0, n.length - 1)) : t.assets.baseUrl = h({
            version: a.version
          }), t;
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(123), n(608)], void 0 !== (i = function (t, e, n) {
      function r(t) {
        return t && t.equals(n);
      }
      function i(t) {
        t.currentBeacon && (t.currentBeacon.remove(), t.currentBeacon = null);
      }
      function o(t, e, n, r) {
        t.add(e, {
          selector: n,
          options: r
        }), t.currentBeacon = t.first();
      }
      function a(t, e, n) {
        return t || e ? !t && n.loading ? "load" : t && r(t) ? e ? "swap" : "unload" : t && t.equals(e, n) ? "same" : !t && e ? "add" : t && !e ? "remove" : t instanceof e ? "fade" : "swap" : "none";
      }
      return t.View.extend({
        currentBeacon: null,
        template: '      <div class="okta-sign-in-header auth-header">        {{#if logo}}        <img src="{{logo}}" class="auth-org-logo" alt="{{logoText}}"/>        {{/if}}        <div data-type="beacon-container" class="beacon-container"></div>      </div>      <div class="auth-content"><div class="auth-content-inner"></div></div>    ',
        initialize: function initialize(t) {
          t.settings.get("features.securityImage") || (this.$el.addClass("no-beacon"), this.listenTo(t.appState, "loading", this.setLoadingBeacon), this.listenTo(t.appState, "removeLoading", this.removeLoadingBeacon));
        },
        setBeacon: function setBeacon(t, n) {
          var s = '[data-type="beacon-container"]',
            u = this.$(s),
            c = a(this.currentBeacon, t, n),
            l = this;
          switch (c) {
            case "none":
              return void this.$el.addClass("no-beacon");
            case "same":
              return;
            case "add":
              return this.$el.removeClass("no-beacon"), o(this, t, s, n), e.explode(u);
            case "remove":
              return this.$el.addClass("no-beacon"), e.implode(u).then(function () {
                i(l);
              }).done();
            case "fade":
              if (!this.currentBeacon.fadeOut) throw new Error('The current beacon is missing the "fadeOut" method');
              return n.animate = !0, this.currentBeacon.fadeOut().then(function () {
                i(l), o(l, t, s, n);
              }).done();
            case "swap":
              return e.swapBeacons({
                $el: u,
                swap: function swap() {
                  var e = r(l.currentBeacon);
                  i(l), e && (u.removeClass("beacon-small beacon-loading"), l.$el.removeClass("no-beacon")), o(l, t, s, n);
                }
              }).done();
            case "load":
              return u.addClass("beacon-small beacon-loading"), o(l, t, s, n), e.explode(u);
            case "unload":
              return this.removeLoadingBeacon();
            default:
              throw new Error('the "' + c + '" is not recognized');
          }
        },
        setLoadingBeacon: function setLoadingBeacon(t) {
          t && !r(this.currentBeacon) && this.setBeacon(n, {
            loading: !0
          });
        },
        removeLoadingBeacon: function removeLoadingBeacon() {
          var t = this,
            n = this.$('[data-type="beacon-container"]');
          return e.implode(n).then(function () {
            i(t), n.removeClass("beacon-small beacon-loading");
          }).done();
        },
        getTemplateData: function getTemplateData() {
          return this.settings.toJSON({
            verbose: !0
          });
        },
        getContentEl: function getContentEl() {
          return this.$(".auth-content-inner");
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    var i,
      o,
      a = n(248),
      s = r(a),
      u = n(249),
      c = r(u);
    i = [n(0), n(123)], void 0 !== (o = function (t, e) {
      function n(t, e) {
        var n = e.get("securityImage"),
          r = e.get("securityImageDescription"),
          i = e.get("isUndefinedUser"),
          o = e.get("isNewUser"),
          s = !i && !o;
        return t.css("background-image", ""), t.removeClass("new-user undefined-user"), o ? void t.addClass("new-user") : i ? void t.addClass("undefined-user") : s ? (t.removeAttr("aria-describedby"), t.find(".accessibility-text").text(r), void t.css("background-image", "url(" + a.escape(n) + ")")) : void 0;
      }
      function r(e, n) {
        u(window).on("resize.securityBeaconQtip", a.debounce(function () {
          e.is(":visible") && e.qtip("show");
        }, 300)), e.qtip({
          prerender: !0,
          content: {
            text: t.loc("primaryauth.newUser.tooltip", "login", [a.escape(n)]),
            button: t.loc("primaryauth.newUser.tooltip.close", "login")
          },
          style: {
            classes: "okta-security-image-tooltip security-image-qtip qtip-custom qtip-shadow qtip-rounded",
            tip: {
              height: 12,
              width: 16
            }
          },
          position: {
            my: "top center",
            at: "center",
            target: u(".auth-beacon-security"),
            adjust: {
              method: "flip",
              scroll: !1,
              resize: !0
            },
            effect: !1
          },
          hide: {
            event: !1,
            fixed: !0
          },
          show: {
            event: !1,
            delay: 200
          },
          events: {
            move: function move(t, e) {
              e.elements.target.is(":visible") || (e.set("hide.effect", !1), e.hide(), e.set("hide.effect", !0));
            }
          }
        }), e.qtip("toggle", e.is(":visible"));
      }
      function i(t) {
        t.qtip("destroy"), u(window).off("resize.securityBeaconQtip");
      }
      var o = function () {
          var t = (0, c.default)(s.default.mark(function t(o, a, u) {
            var c, l, f, p, d, h, m;
            return s.default.wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  if (c = o.find(".auth-beacon-security"), l = o.find(".js-auth-beacon-border"), f = !a.get("isUndefinedUser"), p = a.get("isNewUser"), d = o.find(".radial-progress-bar"), h = a.get("baseUrl").match(/https?:\/\/(.[^\/]+)/)[1], m = 200, u) {
                    t.next = 5;
                    break;
                  }
                  return n(c, a), l.toggleClass("auth-beacon-border", f), t.abrupt("return");
                case 5:
                  if (i(c), f) {
                    t.next = 10;
                    break;
                  }
                  c.fadeOut(m, function () {
                    n(c, a), l.removeClass("auth-beacon-border"), c.fadeIn(m);
                  }), t.next = 15;
                  break;
                case 10:
                  return l.removeClass("auth-beacon-border"), t.next = 13, e.radialProgressBar({
                    $el: d,
                    swap: function swap() {
                      c.fadeOut(m, function () {
                        n(c, a), c.fadeIn(m);
                      });
                    }
                  });
                case 13:
                  l.addClass("auth-beacon-border"), p && r(c, h);
                case 15:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
          return function (e, n, r) {
            return t.apply(this, arguments);
          };
        }(),
        a = t._,
        u = t.$;
      return t.View.extend({
        template: '    <div class="beacon-blank">      <div class="radial-progress-bar">        <div class="circle left"></div>        <div class="circle right"></div>      </div>    </div>    <div aria-live="polite" role="img" class="bg-helper auth-beacon auth-beacon-security" data-se="security-beacon">      <span class="accessibility-text"></span>      <div class="okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border">      </div>    </div>    ',
        className: "js-security-beacon",
        initialize: function initialize(t) {
          this.update = a.partial(o, this.$el, t.appState), this.listenTo(t.appState, "change:securityImage", this.update), this.listenTo(t.appState, "loading", function (t) {
            this.$el.toggleClass("beacon-loading", t), this.removeAntiPhishingMessage();
          }), this.options.appState.set("beaconType", "security"), this.listenTo(t.appState, "navigate", this.removeAntiPhishingMessage);
        },
        postRender: function postRender() {
          this.update(!1);
        },
        equals: function equals(t) {
          return t && this instanceof t;
        },
        removeAntiPhishingMessage: function removeAntiPhishingMessage() {
          this.$el.find(".auth-beacon-security").qtip("destroy");
        }
      });
    }.apply(e, i)) && (t.exports = o);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(6)], void 0 !== (i = function (t, e) {
      return t.View.extend({
        className: "auth-container main-container",
        id: e.WIDGET_CONTAINER_ID,
        attributes: {
          "data-se": "auth-container"
        },
        initialize: function initialize(t) {
          this.listenTo(t.appState, "change:beaconType", function (t, e) {
            this.$el.toggleClass("can-remove-beacon", "security" === e);
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(6)], void 0 !== (i = function (t) {
      var e = {},
        n = function n(t) {
          return "\n#okta-sign-in.auth-container .button-primary,\n#okta-sign-in.auth-container .button-primary:active,\n#okta-sign-in.auth-container .button-primary:focus { background: " + t.brand + "; }\n#okta-sign-in.auth-container .button-primary:hover { background: " + e.lighten(t.brand, .05) + "; }\n#okta-sign-in.auth-container .button.button-primary.link-button-disabled {\n  background: " + t.brand + ";\n  opacity: 0.5;\n}\n    ";
        };
      return e.lighten = function (t, e) {
        e = e || 0, t = t.substr(1);
        for (var n = "#", r = 0; r < 3; r++) {
          var i = parseInt(t.substr(2 * r, 2), 16);
          i = Math.round(Math.min(Math.max(0, i + i * e), 255)).toString(16), n += ("00" + i).substr(i.length);
        }
        return n;
      }, e.addStyle = function (e) {
        var r = n(e),
          i = document.getElementById(t.WIDGET_CONTAINER_ID),
          o = document.createElement("style");
        o.id = t.WIDGET_CONFIG_COLORS_ID, o.type = "text/css", o.appendChild(document.createTextNode(r)), i.appendChild(o);
      }, e.isLoaded = function () {
        return !!document.getElementById(t.WIDGET_CONFIG_COLORS_ID);
      }, e;
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(18), n(4), n(13), n(14)], void 0 !== (i = function (t, e, n, r, i) {
      var o = t._;
      return {
        title: function title() {
          var n = e.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
          return t.loc("enroll.totp.title", "login", [n]);
        },
        subtitle: o.partial(t.loc, "enroll.totp.enterCode", "login"),
        autoSave: !0,
        noButtonBar: !0,
        attributes: {
          "data-se": "step-sendcode"
        },
        formChildren: function formChildren() {
          return [n.Input({
            label: t.loc("mfa.challenge.enterCode.placeholder", "login"),
            "label-top": !0,
            explain: r.createInputExplain("mfa.challenge.enterCode.tooltip", "mfa.challenge.enterCode.placeholder", "login"),
            "explain-top": !0,
            name: "passCode",
            input: i,
            type: "tel"
          }), n.Toolbar({
            noCancelButton: !0,
            save: t.loc("oform.verify", "login")
          })];
        }
      };
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(6)], void 0 !== (i = function (t, e) {
      var n = t.internal.util.Util;
      return t.View.extend({
        template: '      {{#if passwordWarn}}        <a href="#" class="link help js-skip" data-se="skip-link">          {{i18n code="password.expiring.later" bundle="login"}}        </a>      {{/if}}      <a href="#" class="link help goto js-signout" data-se="signout-link">{{i18n code="signout" bundle="login"}}</a>    ',
        className: "auth-footer clearfix",
        events: {
          "click .js-signout": function clickJsSignout(t) {
            t.preventDefault();
            var r = this;
            this.model.doTransaction(function (t) {
              return t.cancel();
            }).then(function () {
              r.settings.get("signOutLink") ? n.redirect(r.settings.get("signOutLink")) : (r.state.set("navigateDir", e.DIRECTION_BACK), r.options.appState.trigger("navigate", ""));
            });
          },
          "click .js-skip": function clickJsSkip(t) {
            t.preventDefault(), this.model.doTransaction(function (t) {
              return t.skip();
            });
          }
        },
        getTemplateData: function getTemplateData() {
          return {
            passwordWarn: this.options.appState.get("isPwdExpiringSoon")
          };
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      return t.View.extend({
        template: '      <div class="infobox">        <span class="icon info-16"></span>        <p>{{i18n code="contact.support" bundle="login" arguments="helpSupportNumber"}}</p>      </div>',
        className: "contact-support",
        getTemplateData: function getTemplateData() {
          return this.settings.pick("helpSupportNumber");
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(14)], void 0 !== (i = function (t, e) {
      var n = t._,
        r = t.internal.views.forms.helpers.SchemaFormFactory,
        i = function i(t) {
          var e = t.split(""),
            r = [],
            i = [",", ".", "-", "_", "#", "@"],
            o = "";
          return n.each(e, function (t) {
            -1 === i.indexOf(t) ? o += t : (o.length >= 3 && r.push(n.clone(o)), o = "");
          }), o.length >= 3 && r.push(n.clone(o)), r.filter(Boolean);
        },
        o = function o(t, e) {
          if (!t) return !1;
          t = t.toLowerCase(), e = e.toLowerCase();
          for (var n = i(t), r = 0; r < n.length; r++) {
            var o = n[r];
            if (-1 !== e.indexOf(o)) return !0;
          }
          return !1;
        },
        a = function a(t, e, r) {
          var i = t.get("minLength"),
            a = t.get("maxLength"),
            s = t.get("format");
          if (n.isNumber(i) && e.length < i) return !1;
          if (n.isNumber(a) && e.length > a) return !1;
          var u = e;
          if (n.isString(s)) {
            if ("^[#/userName]" === s || "^[#/firstName]" === s || "^[#/lastName]" === s) {
              var c = s.split("^[#/")[1].split("]")[0],
                l = r.get(c);
              return "userName" === c && (l = r.has("userName") ? r.get("userName") : r.get("email")), !o(l, u);
            }
            if (!new RegExp(s).test(e)) return !1;
          }
          return !0;
        },
        s = function s(e, r, i, o) {
          var s = r.get(e);
          n.isString(s) && i.each(function (n, i) {
            var u = t.$("#subschemas-" + e + " .subschema-" + i);
            s ? u.children("p").removeClass("default-schema") : u.children("p").addClass("default-schema"), u.removeClass("subschema-satisfied subschema-unsatisfied subschema-error"), a(n, s, r) ? (u.addClass("subschema-satisfied"), u.find("p span").removeClass("error error-16-small"), u.find("p span").addClass("confirm-16")) : o && (u.find("p span").removeClass("confirm-16"), u.find("p span").addClass("error error-16-small"), u.addClass("subschema-error subschema-unsatisfied"));
          });
        };
      return {
        createInputOptions: function createInputOptions(t) {
          var i = r.createInputOptions(t);
          if ("select" === i.type) i = n.extend(i, {
            label: t.get("title")
          });else {
            var o = t.get("title");
            t.get("required") && (o += " *"), i = n.extend(i, {
              label: !1,
              "label-top": !0,
              placeholder: o
            });
          }
          var a = t.get("name");
          switch (a) {
            case "userName":
              i.input = e, i.params = {
                icon: "person-16-gray"
              };
              break;
            case "password":
              i.type = "password", i.input = e, i.params = {
                icon: "remote-lock-16"
              };
          }
          var u = t.get("subSchemas");
          return u && (i.events = {
            input: function input() {
              s(a, this.model, u, !0);
            },
            focusout: function focusout() {
              s(a, this.model, u, !0);
            },
            "change:userName": function changeUserName() {
              s(a, this.model, u, !0);
            },
            "change:firstName": function changeFirstName() {
              s(a, this.model, u, !0);
            },
            "change:lastName": function changeLastName() {
              s(a, this.model, u, !0);
            },
            "change:email": function changeEmail() {
              s(a, this.model, u, !0);
            }
          }), i;
        },
        getUsernameParts: i,
        passwordContainsFormField: o
      };
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
      i = {
        email: {
          label: (0, r.loc)("factor.email", "login"),
          description: "",
          iconClassName: "mfa-okta-email"
        },
        password: {
          label: (0, r.loc)("factor.password", "login"),
          description: "",
          iconClassName: "mfa-okta-password"
        },
        webauthn: {
          label: (0, r.loc)("factor.webauthn", "login"),
          description: "",
          iconClassName: "mfa-webauthn"
        }
      },
      o = function o(t) {
        return i[t];
      };
    t.exports = {
      getFactorData: o
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(0),
      o = n(267),
      a = r(o),
      s = n(123),
      u = r(s);
    e.default = i.View.extend({
      HeaderBeacon: a.default,
      initialize: function initialize() {
        this.add(this.HeaderBeacon);
      },
      postRender: function postRender() {
        (0, i.$)("#okta-sign-in").removeClass("no-beacon");
        var t = this.$el.find('[data-type="beacon-container"]');
        u.default.explode(t);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
      i = r.View.extend({
        template: '    <div data-type="beacon-container" class="beacon-container">      <div class="beacon-blank auth-beacon">        <div class="beacon-blank js-blank-beacon-border auth-beacon-border"></div>      </div>      <div class="bg-helper auth-beacon auth-beacon-factor {{className}}" data-se="factor-beacon">        <div class="okta-sign-in-beacon-border auth-beacon-border"></div>      </div>      <div data-type="factor-types-dropdown" class="factors-dropdown-wrap"></div>    </div >    ',
        getTemplateData: function getTemplateData() {
          return {
            className: this.getBeaconClassName() || ""
          };
        },
        getBeaconClassName: function getBeaconClassName() {
          return "undefined-user";
        }
      });
    t.exports = i;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(0);
    e.default = {
      startPolling: function startPolling() {
        var t = this,
          e = this.options.appState.get("factor"),
          n = e && e.poll && e.poll.refresh;
        r._.isNumber(n) && (this.polling = setInterval(function () {
          t.options.appState.trigger("invokeAction", "factor-poll");
        }, n));
      },
      startDevicePolling: function startDevicePolling() {
        var t = this,
          e = this.options.appState.getCurrentViewState().refresh;
        r._.isNumber(e) && (this.polling = setInterval(function () {
          t.options.appState.trigger("saveForm", t.model);
        }, e));
      },
      stopPolling: function stopPolling() {
        this.polling && clearInterval(this.polling);
      }
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(40),
      o = r(i),
      a = n(28),
      s = r(a),
      u = n(59),
      c = r(u),
      l = s.default.extend({
        title: function title() {
          return (this.options.appState.get("terminal").message || {}).message || "You can close this window";
        },
        noButtonBar: !0,
        postRender: function postRender() {
          s.default.prototype.postRender.apply(this, arguments), this.$el.addClass("terminal-state");
        }
      }),
      f = c.default.extend({
        links: function links() {
          return [{
            type: "link",
            label: "Back to sign in",
            name: "back",
            href: "/"
          }];
        }
      });
    e.default = o.default.extend({
      Body: l,
      Footer: f
    });
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = {
      title: function title() {
        return "Email link (" + this.options.appState.get("factorProfile").email + ")";
      }
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(99),
      o = r(i),
      a = n(269),
      s = r(a);
    e.default = o.default.extend({
      Body: s.default.prototype.Body,
      Footer: s.default.prototype.Footer
    });
  }, function (t, e, n) {
    n(273), t.exports = n(475);
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      function e(t, e, n) {
        t[e] || Object[r](t, e, {
          writable: !0,
          configurable: !0,
          value: n
        });
      }
      if (n(274), n(471), n(472), t._babelPolyfill) throw new Error("only one instance of babel-polyfill is allowed");
      t._babelPolyfill = !0;
      var r = "defineProperty";
      e(String.prototype, "padLeft", "".padStart), e(String.prototype, "padRight", "".padEnd), "pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (t) {
        [][t] && e(Array, t, Function.call.bind([][t]));
      });
    }).call(e, n(100));
  }, function (t, e, n) {
    n(275), n(278), n(279), n(280), n(281), n(282), n(283), n(284), n(285), n(286), n(287), n(288), n(289), n(290), n(291), n(292), n(293), n(294), n(295), n(296), n(297), n(298), n(299), n(300), n(301), n(302), n(303), n(304), n(305), n(306), n(307), n(308), n(309), n(310), n(311), n(312), n(313), n(314), n(315), n(316), n(317), n(318), n(319), n(320), n(321), n(322), n(323), n(324), n(325), n(326), n(327), n(328), n(329), n(330), n(331), n(332), n(333), n(334), n(335), n(336), n(337), n(338), n(339), n(340), n(341), n(342), n(343), n(344), n(345), n(346), n(347), n(348), n(349), n(350), n(351), n(352), n(353), n(355), n(356), n(358), n(359), n(360), n(361), n(362), n(363), n(364), n(366), n(367), n(368), n(369), n(370), n(371), n(372), n(373), n(374), n(375), n(376), n(377), n(378), n(144), n(379), n(202), n(380), n(203), n(381), n(382), n(383), n(384), n(385), n(206), n(208), n(209), n(386), n(387), n(388), n(389), n(390), n(391), n(392), n(393), n(394), n(395), n(396), n(397), n(398), n(399), n(400), n(401), n(402), n(403), n(404), n(405), n(406), n(407), n(408), n(409), n(410), n(411), n(412), n(413), n(414), n(415), n(416), n(417), n(418), n(419), n(420), n(421), n(422), n(423), n(424), n(425), n(426), n(427), n(428), n(429), n(430), n(431), n(432), n(433), n(434), n(435), n(436), n(437), n(438), n(439), n(440), n(441), n(442), n(443), n(444), n(445), n(446), n(447), n(448), n(449), n(450), n(451), n(452), n(453), n(454), n(455), n(456), n(457), n(458), n(459), n(460), n(461), n(462), n(463), n(464), n(465), n(466), n(467), n(468), n(469), n(470), t.exports = n(34);
  }, function (t, e, n) {
    "use strict";

    var r = n(5),
      i = n(29),
      o = n(12),
      a = n(1),
      s = n(26),
      u = n(54).KEY,
      c = n(7),
      l = n(84),
      f = n(73),
      p = n(61),
      d = n(10),
      h = n(184),
      m = n(125),
      g = n(277),
      v = n(103),
      y = n(3),
      _ = n(8),
      b = n(16),
      w = n(30),
      S = n(41),
      x = n(60),
      E = n(64),
      T = n(187),
      k = n(31),
      A = n(102),
      O = n(15),
      C = n(62),
      I = k.f,
      R = O.f,
      P = T.f,
      _N2 = r.Symbol,
      M = r.JSON,
      L = M && M.stringify,
      F = d("_hidden"),
      D = d("toPrimitive"),
      j = {}.propertyIsEnumerable,
      U = l("symbol-registry"),
      B = l("symbols"),
      V = l("op-symbols"),
      q = Object.prototype,
      H = "function" == typeof _N2 && !!A.f,
      W = r.QObject,
      $ = !W || !W.prototype || !W.prototype.findChild,
      z = o && c(function () {
        return 7 != E(R({}, "a", {
          get: function get() {
            return R(this, "a", {
              value: 7
            }).a;
          }
        })).a;
      }) ? function (t, e, n) {
        var r = I(q, e);
        r && delete q[e], R(t, e, n), r && t !== q && R(q, e, r);
      } : R,
      G = function G(t) {
        var e = B[t] = E(_N2.prototype);
        return e._k = t, e;
      },
      K = H && "symbol" == typeof _N2.iterator ? function (t) {
        return "symbol" == typeof t;
      } : function (t) {
        return t instanceof _N2;
      },
      Y = function Y(t, e, n) {
        return t === q && Y(V, e, n), y(t), e = S(e, !0), y(n), i(B, e) ? (n.enumerable ? (i(t, F) && t[F][e] && (t[F][e] = !1), n = E(n, {
          enumerable: x(0, !1)
        })) : (i(t, F) || R(t, F, x(1, {})), t[F][e] = !0), z(t, e, n)) : R(t, e, n);
      },
      J = function J(t, e) {
        y(t);
        for (var n, r = g(e = w(e)), i = 0, o = r.length; o > i;) Y(t, n = r[i++], e[n]);
        return t;
      },
      Q = function Q(t, e) {
        return void 0 === e ? E(t) : J(E(t), e);
      },
      X = function X(t) {
        var e = j.call(this, t = S(t, !0));
        return !(this === q && i(B, t) && !i(V, t)) && (!(e || !i(this, t) || !i(B, t) || i(this, F) && this[F][t]) || e);
      },
      Z = function Z(t, e) {
        if (t = w(t), e = S(e, !0), t !== q || !i(B, e) || i(V, e)) {
          var n = I(t, e);
          return !n || !i(B, e) || i(t, F) && t[F][e] || (n.enumerable = !0), n;
        }
      },
      tt = function tt(t) {
        for (var e, n = P(w(t)), r = [], o = 0; n.length > o;) i(B, e = n[o++]) || e == F || e == u || r.push(e);
        return r;
      },
      et = function et(t) {
        for (var e, n = t === q, r = P(n ? V : w(t)), o = [], a = 0; r.length > a;) !i(B, e = r[a++]) || n && !i(q, e) || o.push(B[e]);
        return o;
      };
    H || (_N2 = function N() {
      if (this instanceof _N2) throw TypeError("Symbol is not a constructor!");
      var t = p(arguments.length > 0 ? arguments[0] : void 0),
        e = function e(n) {
          this === q && e.call(V, n), i(this, F) && i(this[F], t) && (this[F][t] = !1), z(this, t, x(1, n));
        };
      return o && $ && z(q, t, {
        configurable: !0,
        set: e
      }), G(t);
    }, s(_N2.prototype, "toString", function () {
      return this._k;
    }), k.f = Z, O.f = Y, n(65).f = T.f = tt, n(86).f = X, A.f = et, o && !n(53) && s(q, "propertyIsEnumerable", X, !0), h.f = function (t) {
      return G(d(t));
    }), a(a.G + a.W + a.F * !H, {
      Symbol: _N2
    });
    for (var nt = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), rt = 0; nt.length > rt;) d(nt[rt++]);
    for (var it = C(d.store), ot = 0; it.length > ot;) m(it[ot++]);
    a(a.S + a.F * !H, "Symbol", {
      for: function _for(t) {
        return i(U, t += "") ? U[t] : U[t] = _N2(t);
      },
      keyFor: function keyFor(t) {
        if (!K(t)) throw TypeError(t + " is not a symbol!");
        for (var e in U) if (U[e] === t) return e;
      },
      useSetter: function useSetter() {
        $ = !0;
      },
      useSimple: function useSimple() {
        $ = !1;
      }
    }), a(a.S + a.F * !H, "Object", {
      create: Q,
      defineProperty: Y,
      defineProperties: J,
      getOwnPropertyDescriptor: Z,
      getOwnPropertyNames: tt,
      getOwnPropertySymbols: et
    });
    var at = c(function () {
      A.f(1);
    });
    a(a.S + a.F * at, "Object", {
      getOwnPropertySymbols: function getOwnPropertySymbols(t) {
        return A.f(b(t));
      }
    }), M && a(a.S + a.F * (!H || c(function () {
      var t = _N2();
      return "[null]" != L([t]) || "{}" != L({
        a: t
      }) || "{}" != L(Object(t));
    })), "JSON", {
      stringify: function stringify(t) {
        for (var e, n, r = [t], i = 1; arguments.length > i;) r.push(arguments[i++]);
        if (n = e = r[1], (_(e) || void 0 !== t) && !K(t)) return v(e) || (e = function e(t, _e6) {
          if ("function" == typeof n && (_e6 = n.call(this, t, _e6)), !K(_e6)) return _e6;
        }), r[1] = e, L.apply(M, r);
      }
    }), _N2.prototype[D] || n(25)(_N2.prototype, D, _N2.prototype.valueOf), f(_N2, "Symbol"), f(Math, "Math", !0), f(r.JSON, "JSON", !0);
  }, function (t, e, n) {
    t.exports = n(84)("native-function-to-string", Function.toString);
  }, function (t, e, n) {
    var r = n(62),
      i = n(102),
      o = n(86);
    t.exports = function (t) {
      var e = r(t),
        n = i.f;
      if (n) for (var a, s = n(t), u = o.f, c = 0; s.length > c;) u.call(t, a = s[c++]) && e.push(a);
      return e;
    };
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Object", {
      create: n(64)
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S + r.F * !n(12), "Object", {
      defineProperty: n(15).f
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S + r.F * !n(12), "Object", {
      defineProperties: n(186)
    });
  }, function (t, e, n) {
    var r = n(30),
      i = n(31).f;
    n(43)("getOwnPropertyDescriptor", function () {
      return function (t, e) {
        return i(r(t), e);
      };
    });
  }, function (t, e, n) {
    var r = n(16),
      i = n(32);
    n(43)("getPrototypeOf", function () {
      return function (t) {
        return i(r(t));
      };
    });
  }, function (t, e, n) {
    var r = n(16),
      i = n(62);
    n(43)("keys", function () {
      return function (t) {
        return i(r(t));
      };
    });
  }, function (t, e, n) {
    n(43)("getOwnPropertyNames", function () {
      return n(187).f;
    });
  }, function (t, e, n) {
    var r = n(8),
      i = n(54).onFreeze;
    n(43)("freeze", function (t) {
      return function (e) {
        return t && r(e) ? t(i(e)) : e;
      };
    });
  }, function (t, e, n) {
    var r = n(8),
      i = n(54).onFreeze;
    n(43)("seal", function (t) {
      return function (e) {
        return t && r(e) ? t(i(e)) : e;
      };
    });
  }, function (t, e, n) {
    var r = n(8),
      i = n(54).onFreeze;
    n(43)("preventExtensions", function (t) {
      return function (e) {
        return t && r(e) ? t(i(e)) : e;
      };
    });
  }, function (t, e, n) {
    var r = n(8);
    n(43)("isFrozen", function (t) {
      return function (e) {
        return !r(e) || !!t && t(e);
      };
    });
  }, function (t, e, n) {
    var r = n(8);
    n(43)("isSealed", function (t) {
      return function (e) {
        return !r(e) || !!t && t(e);
      };
    });
  }, function (t, e, n) {
    var r = n(8);
    n(43)("isExtensible", function (t) {
      return function (e) {
        return !!r(e) && (!t || t(e));
      };
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S + r.F, "Object", {
      assign: n(188)
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Object", {
      is: n(189)
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Object", {
      setPrototypeOf: n(129).set
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(74),
      i = {};
    i[n(10)("toStringTag")] = "z", i + "" != "[object z]" && n(26)(Object.prototype, "toString", function () {
      return "[object " + r(this) + "]";
    }, !0);
  }, function (t, e, n) {
    var r = n(1);
    r(r.P, "Function", {
      bind: n(190)
    });
  }, function (t, e, n) {
    var r = n(15).f,
      i = Function.prototype,
      o = /^\s*function ([^ (]*)/;
    "name" in i || n(12) && r(i, "name", {
      configurable: !0,
      get: function get() {
        try {
          return ("" + this).match(o)[1];
        } catch (t) {
          return "";
        }
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(8),
      i = n(32),
      o = n(10)("hasInstance"),
      a = Function.prototype;
    o in a || n(15).f(a, o, {
      value: function value(t) {
        if ("function" != typeof this || !r(t)) return !1;
        if (!r(this.prototype)) return t instanceof this;
        for (; t = i(t);) if (this.prototype === t) return !0;
        return !1;
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(192);
    r(r.G + r.F * (parseInt != i), {
      parseInt: i
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(193);
    r(r.G + r.F * (parseFloat != i), {
      parseFloat: i
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(5),
      i = n(29),
      o = n(36),
      a = n(131),
      s = n(41),
      u = n(7),
      c = n(65).f,
      l = n(31).f,
      f = n(15).f,
      p = n(75).trim,
      _d = r.Number,
      h = _d,
      m = _d.prototype,
      g = "Number" == o(n(64)(m)),
      v = ("trim" in String.prototype),
      y = function y(t) {
        var e = s(t, !1);
        if ("string" == typeof e && e.length > 2) {
          e = v ? e.trim() : p(e, 3);
          var n,
            r,
            i,
            o = e.charCodeAt(0);
          if (43 === o || 45 === o) {
            if (88 === (n = e.charCodeAt(2)) || 120 === n) return NaN;
          } else if (48 === o) {
            switch (e.charCodeAt(1)) {
              case 66:
              case 98:
                r = 2, i = 49;
                break;
              case 79:
              case 111:
                r = 8, i = 55;
                break;
              default:
                return +e;
            }
            for (var a, u = e.slice(2), c = 0, l = u.length; c < l; c++) if ((a = u.charCodeAt(c)) < 48 || a > i) return NaN;
            return parseInt(u, r);
          }
        }
        return +e;
      };
    if (!_d(" 0o1") || !_d("0b1") || _d("+0x1")) {
      _d = function d(t) {
        var e = arguments.length < 1 ? 0 : t,
          n = this;
        return n instanceof _d && (g ? u(function () {
          m.valueOf.call(n);
        }) : "Number" != o(n)) ? a(new h(y(e)), n, _d) : y(e);
      };
      for (var _, b = n(12) ? c(h) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), w = 0; b.length > w; w++) i(h, _ = b[w]) && !i(_d, _) && f(_d, _, l(h, _));
      _d.prototype = m, m.constructor = _d, n(26)(r, "Number", _d);
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(37),
      o = n(194),
      a = n(132),
      s = 1..toFixed,
      u = Math.floor,
      c = [0, 0, 0, 0, 0, 0],
      l = "Number.toFixed: incorrect invocation!",
      f = function f(t, e) {
        for (var n = -1, r = e; ++n < 6;) r += t * c[n], c[n] = r % 1e7, r = u(r / 1e7);
      },
      p = function p(t) {
        for (var e = 6, n = 0; --e >= 0;) n += c[e], c[e] = u(n / t), n = n % t * 1e7;
      },
      d = function d() {
        for (var t = 6, e = ""; --t >= 0;) if ("" !== e || 0 === t || 0 !== c[t]) {
          var n = String(c[t]);
          e = "" === e ? n : e + a.call("0", 7 - n.length) + n;
        }
        return e;
      },
      h = function h(t, e, n) {
        return 0 === e ? n : e % 2 == 1 ? h(t, e - 1, n * t) : h(t * t, e / 2, n);
      },
      m = function m(t) {
        for (var e = 0, n = t; n >= 4096;) e += 12, n /= 4096;
        for (; n >= 2;) e += 1, n /= 2;
        return e;
      };
    r(r.P + r.F * (!!s && ("0.000" !== 8e-5.toFixed(3) || "1" !== .9.toFixed(0) || "1.25" !== 1.255.toFixed(2) || "1000000000000000128" !== 0xde0b6b3a7640080.toFixed(0)) || !n(7)(function () {
      s.call({});
    })), "Number", {
      toFixed: function toFixed(t) {
        var e,
          n,
          r,
          s,
          u = o(this, l),
          c = i(t),
          g = "",
          v = "0";
        if (c < 0 || c > 20) throw RangeError(l);
        if (u != u) return "NaN";
        if (u <= -1e21 || u >= 1e21) return String(u);
        if (u < 0 && (g = "-", u = -u), u > 1e-21) if (e = m(u * h(2, 69, 1)) - 69, n = e < 0 ? u * h(2, -e, 1) : u / h(2, e, 1), n *= 4503599627370496, (e = 52 - e) > 0) {
          for (f(0, n), r = c; r >= 7;) f(1e7, 0), r -= 7;
          for (f(h(10, r, 1), 0), r = e - 1; r >= 23;) p(1 << 23), r -= 23;
          p(1 << r), f(1, 1), p(2), v = d();
        } else f(0, n), f(1 << -e, 0), v = d() + a.call("0", c);
        return c > 0 ? (s = v.length, v = g + (s <= c ? "0." + a.call("0", c - s) + v : v.slice(0, s - c) + "." + v.slice(s - c))) : v = g + v, v;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(7),
      o = n(194),
      a = 1..toPrecision;
    r(r.P + r.F * (i(function () {
      return "1" !== a.call(1, void 0);
    }) || !i(function () {
      a.call({});
    })), "Number", {
      toPrecision: function toPrecision(t) {
        var e = o(this, "Number#toPrecision: incorrect invocation!");
        return void 0 === t ? a.call(e) : a.call(e, t);
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Number", {
      EPSILON: Math.pow(2, -52)
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(5).isFinite;
    r(r.S, "Number", {
      isFinite: function isFinite(t) {
        return "number" == typeof t && i(t);
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Number", {
      isInteger: n(195)
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Number", {
      isNaN: function isNaN(t) {
        return t != t;
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(195),
      o = Math.abs;
    r(r.S, "Number", {
      isSafeInteger: function isSafeInteger(t) {
        return i(t) && o(t) <= 9007199254740991;
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Number", {
      MAX_SAFE_INTEGER: 9007199254740991
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Number", {
      MIN_SAFE_INTEGER: -9007199254740991
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(193);
    r(r.S + r.F * (Number.parseFloat != i), "Number", {
      parseFloat: i
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(192);
    r(r.S + r.F * (Number.parseInt != i), "Number", {
      parseInt: i
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(196),
      o = Math.sqrt,
      a = Math.acosh;
    r(r.S + r.F * !(a && 710 == Math.floor(a(Number.MAX_VALUE)) && a(1 / 0) == 1 / 0), "Math", {
      acosh: function acosh(t) {
        return (t = +t) < 1 ? NaN : t > 94906265.62425156 ? Math.log(t) + Math.LN2 : i(t - 1 + o(t - 1) * o(t + 1));
      }
    });
  }, function (t, e, n) {
    function r(t) {
      return isFinite(t = +t) && 0 != t ? t < 0 ? -r(-t) : Math.log(t + Math.sqrt(t * t + 1)) : t;
    }
    var i = n(1),
      o = Math.asinh;
    i(i.S + i.F * !(o && 1 / o(0) > 0), "Math", {
      asinh: r
    });
  }, function (t, e, n) {
    var r = n(1),
      i = Math.atanh;
    r(r.S + r.F * !(i && 1 / i(-0) < 0), "Math", {
      atanh: function atanh(t) {
        return 0 == (t = +t) ? t : Math.log((1 + t) / (1 - t)) / 2;
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(133);
    r(r.S, "Math", {
      cbrt: function cbrt(t) {
        return i(t = +t) * Math.pow(Math.abs(t), 1 / 3);
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      clz32: function clz32(t) {
        return (t >>>= 0) ? 31 - Math.floor(Math.log(t + .5) * Math.LOG2E) : 32;
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = Math.exp;
    r(r.S, "Math", {
      cosh: function cosh(t) {
        return (i(t = +t) + i(-t)) / 2;
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(134);
    r(r.S + r.F * (i != Math.expm1), "Math", {
      expm1: i
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      fround: n(197)
    });
  }, function (t, e, n) {
    var r = n(1),
      i = Math.abs;
    r(r.S, "Math", {
      hypot: function hypot(t, e) {
        for (var n, r, o = 0, a = 0, s = arguments.length, u = 0; a < s;) n = i(arguments[a++]), u < n ? (r = u / n, o = o * r * r + 1, u = n) : n > 0 ? (r = n / u, o += r * r) : o += n;
        return u === 1 / 0 ? 1 / 0 : u * Math.sqrt(o);
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = Math.imul;
    r(r.S + r.F * n(7)(function () {
      return -5 != i(4294967295, 5) || 2 != i.length;
    }), "Math", {
      imul: function imul(t, e) {
        var n = +t,
          r = +e,
          i = 65535 & n,
          o = 65535 & r;
        return 0 | i * o + ((65535 & n >>> 16) * o + i * (65535 & r >>> 16) << 16 >>> 0);
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      log10: function log10(t) {
        return Math.log(t) * Math.LOG10E;
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      log1p: n(196)
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      log2: function log2(t) {
        return Math.log(t) / Math.LN2;
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      sign: n(133)
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(134),
      o = Math.exp;
    r(r.S + r.F * n(7)(function () {
      return -2e-17 != !Math.sinh(-2e-17);
    }), "Math", {
      sinh: function sinh(t) {
        return Math.abs(t = +t) < 1 ? (i(t) - i(-t)) / 2 : (o(t - 1) - o(-t - 1)) * (Math.E / 2);
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(134),
      o = Math.exp;
    r(r.S, "Math", {
      tanh: function tanh(t) {
        var e = i(t = +t),
          n = i(-t);
        return e == 1 / 0 ? 1 : n == 1 / 0 ? -1 : (e - n) / (o(t) + o(-t));
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      trunc: function trunc(t) {
        return (t > 0 ? Math.floor : Math.ceil)(t);
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(63),
      o = String.fromCharCode,
      a = String.fromCodePoint;
    r(r.S + r.F * (!!a && 1 != a.length), "String", {
      fromCodePoint: function fromCodePoint(t) {
        for (var e, n = [], r = arguments.length, a = 0; r > a;) {
          if (e = +arguments[a++], i(e, 1114111) !== e) throw RangeError(e + " is not a valid code point");
          n.push(e < 65536 ? o(e) : o(55296 + ((e -= 65536) >> 10), e % 1024 + 56320));
        }
        return n.join("");
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(30),
      o = n(11);
    r(r.S, "String", {
      raw: function raw(t) {
        for (var e = i(t.raw), n = o(e.length), r = arguments.length, a = [], s = 0; n > s;) a.push(String(e[s++])), s < r && a.push(String(arguments[s]));
        return a.join("");
      }
    });
  }, function (t, e, n) {
    "use strict";

    n(75)("trim", function (t) {
      return function () {
        return t(this, 3);
      };
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(104)(!0);
    n(135)(String, "String", function (t) {
      this._t = String(t), this._i = 0;
    }, function () {
      var t,
        e = this._t,
        n = this._i;
      return n >= e.length ? {
        value: void 0,
        done: !0
      } : (t = r(e, n), this._i += t.length, {
        value: t,
        done: !1
      });
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(104)(!1);
    r(r.P, "String", {
      codePointAt: function codePointAt(t) {
        return i(this, t);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(11),
      o = n(137),
      a = "".endsWith;
    r(r.P + r.F * n(138)("endsWith"), "String", {
      endsWith: function endsWith(t) {
        var e = o(this, t, "endsWith"),
          n = arguments.length > 1 ? arguments[1] : void 0,
          r = i(e.length),
          s = void 0 === n ? r : Math.min(i(n), r),
          u = String(t);
        return a ? a.call(e, u, s) : e.slice(s - u.length, s) === u;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(137);
    r(r.P + r.F * n(138)("includes"), "String", {
      includes: function includes(t) {
        return !!~i(this, t, "includes").indexOf(t, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.P, "String", {
      repeat: n(132)
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(11),
      o = n(137),
      a = "".startsWith;
    r(r.P + r.F * n(138)("startsWith"), "String", {
      startsWith: function startsWith(t) {
        var e = o(this, t, "startsWith"),
          n = i(Math.min(arguments.length > 1 ? arguments[1] : void 0, e.length)),
          r = String(t);
        return a ? a.call(e, r, n) : e.slice(n, n + r.length) === r;
      }
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("anchor", function (t) {
      return function (e) {
        return t(this, "a", "name", e);
      };
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("big", function (t) {
      return function () {
        return t(this, "big", "", "");
      };
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("blink", function (t) {
      return function () {
        return t(this, "blink", "", "");
      };
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("bold", function (t) {
      return function () {
        return t(this, "b", "", "");
      };
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("fixed", function (t) {
      return function () {
        return t(this, "tt", "", "");
      };
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("fontcolor", function (t) {
      return function (e) {
        return t(this, "font", "color", e);
      };
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("fontsize", function (t) {
      return function (e) {
        return t(this, "font", "size", e);
      };
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("italics", function (t) {
      return function () {
        return t(this, "i", "", "");
      };
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("link", function (t) {
      return function (e) {
        return t(this, "a", "href", e);
      };
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("small", function (t) {
      return function () {
        return t(this, "small", "", "");
      };
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("strike", function (t) {
      return function () {
        return t(this, "strike", "", "");
      };
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("sub", function (t) {
      return function () {
        return t(this, "sub", "", "");
      };
    });
  }, function (t, e, n) {
    "use strict";

    n(27)("sup", function (t) {
      return function () {
        return t(this, "sup", "", "");
      };
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Date", {
      now: function now() {
        return new Date().getTime();
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(16),
      o = n(41);
    r(r.P + r.F * n(7)(function () {
      return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({
        toISOString: function toISOString() {
          return 1;
        }
      });
    }), "Date", {
      toJSON: function toJSON(t) {
        var e = i(this),
          n = o(e);
        return "number" != typeof n || isFinite(n) ? e.toISOString() : null;
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(354);
    r(r.P + r.F * (Date.prototype.toISOString !== i), "Date", {
      toISOString: i
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(7),
      i = Date.prototype.getTime,
      o = Date.prototype.toISOString,
      a = function a(t) {
        return t > 9 ? t : "0" + t;
      };
    t.exports = r(function () {
      return "0385-07-25T07:06:39.999Z" != o.call(new Date(-5e13 - 1));
    }) || !r(function () {
      o.call(new Date(NaN));
    }) ? function () {
      if (!isFinite(i.call(this))) throw RangeError("Invalid time value");
      var t = this,
        e = t.getUTCFullYear(),
        n = t.getUTCMilliseconds(),
        r = e < 0 ? "-" : e > 9999 ? "+" : "";
      return r + ("00000" + Math.abs(e)).slice(r ? -6 : -4) + "-" + a(t.getUTCMonth() + 1) + "-" + a(t.getUTCDate()) + "T" + a(t.getUTCHours()) + ":" + a(t.getUTCMinutes()) + ":" + a(t.getUTCSeconds()) + "." + (n > 99 ? n : "0" + a(n)) + "Z";
    } : o;
  }, function (t, e, n) {
    var r = Date.prototype,
      i = r.toString,
      o = r.getTime;
    new Date(NaN) + "" != "Invalid Date" && n(26)(r, "toString", function () {
      var t = o.call(this);
      return t === t ? i.call(this) : "Invalid Date";
    });
  }, function (t, e, n) {
    var r = n(10)("toPrimitive"),
      i = Date.prototype;
    r in i || n(25)(i, r, n(357));
  }, function (t, e, n) {
    "use strict";

    var r = n(3),
      i = n(41);
    t.exports = function (t) {
      if ("string" !== t && "number" !== t && "default" !== t) throw TypeError("Incorrect hint");
      return i(r(this), "number" != t);
    };
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Array", {
      isArray: n(103)
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(35),
      i = n(1),
      o = n(16),
      a = n(198),
      s = n(139),
      u = n(11),
      c = n(140),
      l = n(141);
    i(i.S + i.F * !n(106)(function (t) {
      Array.from(t);
    }), "Array", {
      from: function from(t) {
        var e,
          n,
          i,
          f,
          p = o(t),
          d = "function" == typeof this ? this : Array,
          h = arguments.length,
          m = h > 1 ? arguments[1] : void 0,
          g = void 0 !== m,
          v = 0,
          y = l(p);
        if (g && (m = r(m, h > 2 ? arguments[2] : void 0, 2)), void 0 == y || d == Array && s(y)) for (e = u(p.length), n = new d(e); e > v; v++) c(n, v, g ? m(p[v], v) : p[v]);else for (f = y.call(p), n = new d(); !(i = f.next()).done; v++) c(n, v, g ? a(f, m, [i.value, v], !0) : i.value);
        return n.length = v, n;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(140);
    r(r.S + r.F * n(7)(function () {
      function t() {}
      return !(Array.of.call(t) instanceof t);
    }), "Array", {
      of: function of() {
        for (var t = 0, e = arguments.length, n = new ("function" == typeof this ? this : Array)(e); e > t;) i(n, t, arguments[t++]);
        return n.length = e, n;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(30),
      o = [].join;
    r(r.P + r.F * (n(85) != Object || !n(38)(o)), "Array", {
      join: function join(t) {
        return o.call(i(this), void 0 === t ? "," : t);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(128),
      o = n(36),
      a = n(63),
      s = n(11),
      u = [].slice;
    r(r.P + r.F * n(7)(function () {
      i && u.call(i);
    }), "Array", {
      slice: function slice(t, e) {
        var n = s(this.length),
          r = o(this);
        if (e = void 0 === e ? n : e, "Array" == r) return u.call(this, t, e);
        for (var i = a(t, n), c = a(e, n), l = s(c - i), f = new Array(l), p = 0; p < l; p++) f[p] = "String" == r ? this.charAt(i + p) : this[i + p];
        return f;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(20),
      o = n(16),
      a = n(7),
      s = [].sort,
      u = [1, 2, 3];
    r(r.P + r.F * (a(function () {
      u.sort(void 0);
    }) || !a(function () {
      u.sort(null);
    }) || !n(38)(s)), "Array", {
      sort: function sort(t) {
        return void 0 === t ? s.call(o(this)) : s.call(o(this), i(t));
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(44)(0),
      o = n(38)([].forEach, !0);
    r(r.P + r.F * !o, "Array", {
      forEach: function forEach(t) {
        return i(this, t, arguments[1]);
      }
    });
  }, function (t, e, n) {
    var r = n(8),
      i = n(103),
      o = n(10)("species");
    t.exports = function (t) {
      var e;
      return i(t) && (e = t.constructor, "function" != typeof e || e !== Array && !i(e.prototype) || (e = void 0), r(e) && null === (e = e[o]) && (e = void 0)), void 0 === e ? Array : e;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(44)(1);
    r(r.P + r.F * !n(38)([].map, !0), "Array", {
      map: function map(t) {
        return i(this, t, arguments[1]);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(44)(2);
    r(r.P + r.F * !n(38)([].filter, !0), "Array", {
      filter: function filter(t) {
        return i(this, t, arguments[1]);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(44)(3);
    r(r.P + r.F * !n(38)([].some, !0), "Array", {
      some: function some(t) {
        return i(this, t, arguments[1]);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(44)(4);
    r(r.P + r.F * !n(38)([].every, !0), "Array", {
      every: function every(t) {
        return i(this, t, arguments[1]);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(199);
    r(r.P + r.F * !n(38)([].reduce, !0), "Array", {
      reduce: function reduce(t) {
        return i(this, t, arguments.length, arguments[1], !1);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(199);
    r(r.P + r.F * !n(38)([].reduceRight, !0), "Array", {
      reduceRight: function reduceRight(t) {
        return i(this, t, arguments.length, arguments[1], !0);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(101)(!1),
      o = [].indexOf,
      a = !!o && 1 / [1].indexOf(1, -0) < 0;
    r(r.P + r.F * (a || !n(38)(o)), "Array", {
      indexOf: function indexOf(t) {
        return a ? o.apply(this, arguments) || 0 : i(this, t, arguments[1]);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(30),
      o = n(37),
      a = n(11),
      s = [].lastIndexOf,
      u = !!s && 1 / [1].lastIndexOf(1, -0) < 0;
    r(r.P + r.F * (u || !n(38)(s)), "Array", {
      lastIndexOf: function lastIndexOf(t) {
        if (u) return s.apply(this, arguments) || 0;
        var e = i(this),
          n = a(e.length),
          r = n - 1;
        for (arguments.length > 1 && (r = Math.min(r, o(arguments[1]))), r < 0 && (r = n + r); r >= 0; r--) if (r in e && e[r] === t) return r || 0;
        return -1;
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.P, "Array", {
      copyWithin: n(200)
    }), n(55)("copyWithin");
  }, function (t, e, n) {
    var r = n(1);
    r(r.P, "Array", {
      fill: n(143)
    }), n(55)("fill");
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(44)(5),
      o = !0;
    "find" in [] && Array(1).find(function () {
      o = !1;
    }), r(r.P + r.F * o, "Array", {
      find: function find(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), n(55)("find");
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(44)(6),
      o = "findIndex",
      a = !0;
    o in [] && Array(1)[o](function () {
      a = !1;
    }), r(r.P + r.F * a, "Array", {
      findIndex: function findIndex(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), n(55)(o);
  }, function (t, e, n) {
    n(66)("Array");
  }, function (t, e, n) {
    var r = n(5),
      i = n(131),
      o = n(15).f,
      a = n(65).f,
      s = n(105),
      u = n(87),
      _c = r.RegExp,
      l = _c,
      f = _c.prototype,
      p = /a/g,
      d = /a/g,
      h = new _c(p) !== p;
    if (n(12) && (!h || n(7)(function () {
      return d[n(10)("match")] = !1, _c(p) != p || _c(d) == d || "/a/i" != _c(p, "i");
    }))) {
      _c = function c(t, e) {
        var n = this instanceof _c,
          r = s(t),
          o = void 0 === e;
        return !n && r && t.constructor === _c && o ? t : i(h ? new l(r && !o ? t.source : t, e) : l((r = t instanceof _c) ? t.source : t, r && o ? u.call(t) : e), n ? this : f, _c);
      };
      for (var m = a(l), g = 0; m.length > g;) !function (t) {
        t in _c || o(_c, t, {
          configurable: !0,
          get: function get() {
            return l[t];
          },
          set: function set(e) {
            l[t] = e;
          }
        });
      }(m[g++]);
      f.constructor = _c, _c.prototype = f, n(26)(r, "RegExp", _c);
    }
    n(66)("RegExp");
  }, function (t, e, n) {
    "use strict";

    n(203);
    var r = n(3),
      i = n(87),
      o = n(12),
      a = /./.toString,
      s = function s(t) {
        n(26)(RegExp.prototype, "toString", t, !0);
      };
    n(7)(function () {
      return "/a/b" != a.call({
        source: "a",
        flags: "b"
      });
    }) ? s(function () {
      var t = r(this);
      return "/".concat(t.source, "/", "flags" in t ? t.flags : !o && t instanceof RegExp ? i.call(t) : void 0);
    }) : "toString" != a.name && s(function () {
      return a.call(this);
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(3),
      i = n(11),
      o = n(146),
      a = n(107);
    n(108)("match", 1, function (t, e, n, s) {
      return [function (n) {
        var r = t(this),
          i = void 0 == n ? void 0 : n[e];
        return void 0 !== i ? i.call(n, r) : new RegExp(n)[e](String(r));
      }, function (t) {
        var e = s(n, t, this);
        if (e.done) return e.value;
        var u = r(t),
          c = String(this);
        if (!u.global) return a(u, c);
        var l = u.unicode;
        u.lastIndex = 0;
        for (var f, p = [], d = 0; null !== (f = a(u, c));) {
          var h = String(f[0]);
          p[d] = h, "" === h && (u.lastIndex = o(c, i(u.lastIndex), l)), d++;
        }
        return 0 === d ? null : p;
      }];
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(3),
      i = n(16),
      o = n(11),
      a = n(37),
      s = n(146),
      u = n(107),
      c = Math.max,
      l = Math.min,
      f = Math.floor,
      p = /\$([$&`']|\d\d?|<[^>]*>)/g,
      d = /\$([$&`']|\d\d?)/g,
      h = function h(t) {
        return void 0 === t ? t : String(t);
      };
    n(108)("replace", 2, function (t, e, n, m) {
      function g(t, e, r, o, a, s) {
        var u = r + t.length,
          c = o.length,
          l = d;
        return void 0 !== a && (a = i(a), l = p), n.call(s, l, function (n, i) {
          var s;
          switch (i.charAt(0)) {
            case "$":
              return "$";
            case "&":
              return t;
            case "`":
              return e.slice(0, r);
            case "'":
              return e.slice(u);
            case "<":
              s = a[i.slice(1, -1)];
              break;
            default:
              var l = +i;
              if (0 === l) return n;
              if (l > c) {
                var p = f(l / 10);
                return 0 === p ? n : p <= c ? void 0 === o[p - 1] ? i.charAt(1) : o[p - 1] + i.charAt(1) : n;
              }
              s = o[l - 1];
          }
          return void 0 === s ? "" : s;
        });
      }
      return [function (r, i) {
        var o = t(this),
          a = void 0 == r ? void 0 : r[e];
        return void 0 !== a ? a.call(r, o, i) : n.call(String(o), r, i);
      }, function (t, e) {
        var i = m(n, t, this, e);
        if (i.done) return i.value;
        var f = r(t),
          p = String(this),
          d = "function" == typeof e;
        d || (e = String(e));
        var v = f.global;
        if (v) {
          var y = f.unicode;
          f.lastIndex = 0;
        }
        for (var _ = [];;) {
          var b = u(f, p);
          if (null === b) break;
          if (_.push(b), !v) break;
          "" === String(b[0]) && (f.lastIndex = s(p, o(f.lastIndex), y));
        }
        for (var w = "", S = 0, x = 0; x < _.length; x++) {
          b = _[x];
          for (var E = String(b[0]), T = c(l(a(b.index), p.length), 0), k = [], A = 1; A < b.length; A++) k.push(h(b[A]));
          var O = b.groups;
          if (d) {
            var C = [E].concat(k, T, p);
            void 0 !== O && C.push(O);
            var I = String(e.apply(void 0, C));
          } else I = g(E, p, T, k, O, e);
          T >= S && (w += p.slice(S, T) + I, S = T + E.length);
        }
        return w + p.slice(S);
      }];
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(3),
      i = n(189),
      o = n(107);
    n(108)("search", 1, function (t, e, n, a) {
      return [function (n) {
        var r = t(this),
          i = void 0 == n ? void 0 : n[e];
        return void 0 !== i ? i.call(n, r) : new RegExp(n)[e](String(r));
      }, function (t) {
        var e = a(n, t, this);
        if (e.done) return e.value;
        var s = r(t),
          u = String(this),
          c = s.lastIndex;
        i(c, 0) || (s.lastIndex = 0);
        var l = o(s, u);
        return i(s.lastIndex, c) || (s.lastIndex = c), null === l ? -1 : l.index;
      }];
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(105),
      i = n(3),
      o = n(88),
      a = n(146),
      s = n(11),
      u = n(107),
      c = n(145),
      l = n(7),
      f = Math.min,
      p = [].push,
      d = "length",
      h = !l(function () {
        RegExp(4294967295, "y");
      });
    n(108)("split", 2, function (t, e, n, l) {
      var m;
      return m = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1)[d] || 2 != "ab".split(/(?:ab)*/)[d] || 4 != ".".split(/(.?)(.?)/)[d] || ".".split(/()()/)[d] > 1 || "".split(/.?/)[d] ? function (t, e) {
        var i = String(this);
        if (void 0 === t && 0 === e) return [];
        if (!r(t)) return n.call(i, t, e);
        for (var o, a, s, u = [], l = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), f = 0, h = void 0 === e ? 4294967295 : e >>> 0, m = new RegExp(t.source, l + "g"); (o = c.call(m, i)) && !((a = m.lastIndex) > f && (u.push(i.slice(f, o.index)), o[d] > 1 && o.index < i[d] && p.apply(u, o.slice(1)), s = o[0][d], f = a, u[d] >= h));) m.lastIndex === o.index && m.lastIndex++;
        return f === i[d] ? !s && m.test("") || u.push("") : u.push(i.slice(f)), u[d] > h ? u.slice(0, h) : u;
      } : "0".split(void 0, 0)[d] ? function (t, e) {
        return void 0 === t && 0 === e ? [] : n.call(this, t, e);
      } : n, [function (n, r) {
        var i = t(this),
          o = void 0 == n ? void 0 : n[e];
        return void 0 !== o ? o.call(n, i, r) : m.call(String(i), n, r);
      }, function (t, e) {
        var r = l(m, t, this, e, m !== n);
        if (r.done) return r.value;
        var c = i(t),
          p = String(this),
          d = o(c, RegExp),
          g = c.unicode,
          v = (c.ignoreCase ? "i" : "") + (c.multiline ? "m" : "") + (c.unicode ? "u" : "") + (h ? "y" : "g"),
          y = new d(h ? c : "^(?:" + c.source + ")", v),
          _ = void 0 === e ? 4294967295 : e >>> 0;
        if (0 === _) return [];
        if (0 === p.length) return null === u(y, p) ? [p] : [];
        for (var b = 0, w = 0, S = []; w < p.length;) {
          y.lastIndex = h ? w : 0;
          var x,
            E = u(y, h ? p : p.slice(w));
          if (null === E || (x = f(s(y.lastIndex + (h ? 0 : w)), p.length)) === b) w = a(p, w, g);else {
            if (S.push(p.slice(b, w)), S.length === _) return S;
            for (var T = 1; T <= E.length - 1; T++) if (S.push(E[T]), S.length === _) return S;
            w = b = x;
          }
        }
        return S.push(p.slice(b)), S;
      }];
    });
  }, function (t, e, n) {
    "use strict";

    var r,
      i,
      o,
      a,
      s = n(53),
      u = n(5),
      c = n(35),
      l = n(74),
      f = n(1),
      p = n(8),
      d = n(20),
      h = n(67),
      m = n(68),
      g = n(88),
      v = n(147).set,
      y = n(148)(),
      _ = n(149),
      b = n(204),
      w = n(109),
      S = n(205),
      x = u.TypeError,
      E = u.process,
      T = E && E.versions,
      k = T && T.v8 || "",
      _A = u.Promise,
      O = "process" == l(E),
      C = function C() {},
      I = i = _.f,
      R = !!function () {
        try {
          var t = _A.resolve(1),
            e = (t.constructor = {})[n(10)("species")] = function (t) {
              t(C, C);
            };
          return (O || "function" == typeof PromiseRejectionEvent) && t.then(C) instanceof e && 0 !== k.indexOf("6.6") && -1 === w.indexOf("Chrome/66");
        } catch (t) {}
      }(),
      P = function P(t) {
        var e;
        return !(!p(t) || "function" != typeof (e = t.then)) && e;
      },
      N = function N(t, e) {
        if (!t._n) {
          t._n = !0;
          var n = t._c;
          y(function () {
            for (var r = t._v, i = 1 == t._s, o = 0; n.length > o;) !function (e) {
              var n,
                o,
                a,
                s = i ? e.ok : e.fail,
                u = e.resolve,
                c = e.reject,
                l = e.domain;
              try {
                s ? (i || (2 == t._h && F(t), t._h = 1), !0 === s ? n = r : (l && l.enter(), n = s(r), l && (l.exit(), a = !0)), n === e.promise ? c(x("Promise-chain cycle")) : (o = P(n)) ? o.call(n, u, c) : u(n)) : c(r);
              } catch (t) {
                l && !a && l.exit(), c(t);
              }
            }(n[o++]);
            t._c = [], t._n = !1, e && !t._h && M(t);
          });
        }
      },
      M = function M(t) {
        v.call(u, function () {
          var e,
            n,
            r,
            i = t._v,
            o = L(t);
          if (o && (e = b(function () {
            O ? E.emit("unhandledRejection", i, t) : (n = u.onunhandledrejection) ? n({
              promise: t,
              reason: i
            }) : (r = u.console) && r.error && r.error("Unhandled promise rejection", i);
          }), t._h = O || L(t) ? 2 : 1), t._a = void 0, o && e.e) throw e.v;
        });
      },
      L = function L(t) {
        return 1 !== t._h && 0 === (t._a || t._c).length;
      },
      F = function F(t) {
        v.call(u, function () {
          var e;
          O ? E.emit("rejectionHandled", t) : (e = u.onrejectionhandled) && e({
            promise: t,
            reason: t._v
          });
        });
      },
      D = function D(t) {
        var e = this;
        e._d || (e._d = !0, e = e._w || e, e._v = t, e._s = 2, e._a || (e._a = e._c.slice()), N(e, !0));
      },
      j = function j(t) {
        var e,
          n = this;
        if (!n._d) {
          n._d = !0, n = n._w || n;
          try {
            if (n === t) throw x("Promise can't be resolved itself");
            (e = P(t)) ? y(function () {
              var r = {
                _w: n,
                _d: !1
              };
              try {
                e.call(t, c(j, r, 1), c(D, r, 1));
              } catch (t) {
                D.call(r, t);
              }
            }) : (n._v = t, n._s = 1, N(n, !1));
          } catch (t) {
            D.call({
              _w: n,
              _d: !1
            }, t);
          }
        }
      };
    R || (_A = function A(t) {
      h(this, _A, "Promise", "_h"), d(t), r.call(this);
      try {
        t(c(j, this, 1), c(D, this, 1));
      } catch (t) {
        D.call(this, t);
      }
    }, r = function r(t) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }, r.prototype = n(69)(_A.prototype, {
      then: function then(t, e) {
        var n = I(g(this, _A));
        return n.ok = "function" != typeof t || t, n.fail = "function" == typeof e && e, n.domain = O ? E.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && N(this, !1), n.promise;
      },
      catch: function _catch(t) {
        return this.then(void 0, t);
      }
    }), o = function o() {
      var t = new r();
      this.promise = t, this.resolve = c(j, t, 1), this.reject = c(D, t, 1);
    }, _.f = I = function I(t) {
      return t === _A || t === a ? new o(t) : i(t);
    }), f(f.G + f.W + f.F * !R, {
      Promise: _A
    }), n(73)(_A, "Promise"), n(66)("Promise"), a = n(34).Promise, f(f.S + f.F * !R, "Promise", {
      reject: function reject(t) {
        var e = I(this);
        return (0, e.reject)(t), e.promise;
      }
    }), f(f.S + f.F * (s || !R), "Promise", {
      resolve: function resolve(t) {
        return S(s && this === a ? _A : this, t);
      }
    }), f(f.S + f.F * !(R && n(106)(function (t) {
      _A.all(t).catch(C);
    })), "Promise", {
      all: function all(t) {
        var e = this,
          n = I(e),
          r = n.resolve,
          i = n.reject,
          o = b(function () {
            var n = [],
              o = 0,
              a = 1;
            m(t, !1, function (t) {
              var s = o++,
                u = !1;
              n.push(void 0), a++, e.resolve(t).then(function (t) {
                u || (u = !0, n[s] = t, --a || r(n));
              }, i);
            }), --a || r(n);
          });
        return o.e && i(o.v), n.promise;
      },
      race: function race(t) {
        var e = this,
          n = I(e),
          r = n.reject,
          i = b(function () {
            m(t, !1, function (t) {
              e.resolve(t).then(n.resolve, r);
            });
          });
        return i.e && r(i.v), n.promise;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(210),
      i = n(70);
    n(110)("WeakSet", function (t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, {
      add: function add(t) {
        return r.def(i(this, "WeakSet"), t, !0);
      }
    }, r, !1, !0);
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(111),
      o = n(150),
      a = n(3),
      s = n(63),
      u = n(11),
      c = n(8),
      l = n(5).ArrayBuffer,
      f = n(88),
      p = o.ArrayBuffer,
      d = o.DataView,
      h = i.ABV && l.isView,
      m = p.prototype.slice,
      g = i.VIEW;
    r(r.G + r.W + r.F * (l !== p), {
      ArrayBuffer: p
    }), r(r.S + r.F * !i.CONSTR, "ArrayBuffer", {
      isView: function isView(t) {
        return h && h(t) || c(t) && g in t;
      }
    }), r(r.P + r.U + r.F * n(7)(function () {
      return !new p(2).slice(1, void 0).byteLength;
    }), "ArrayBuffer", {
      slice: function slice(t, e) {
        if (void 0 !== m && void 0 === e) return m.call(a(this), t);
        for (var n = a(this).byteLength, r = s(t, n), i = s(void 0 === e ? n : e, n), o = new (f(this, p))(u(i - r)), c = new d(this), l = new d(o), h = 0; r < i;) l.setUint8(h++, c.getUint8(r++));
        return o;
      }
    }), n(66)("ArrayBuffer");
  }, function (t, e, n) {
    var r = n(1);
    r(r.G + r.W + r.F * !n(111).ABV, {
      DataView: n(150).DataView
    });
  }, function (t, e, n) {
    n(48)("Int8", 1, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    });
  }, function (t, e, n) {
    n(48)("Uint8", 1, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    });
  }, function (t, e, n) {
    n(48)("Uint8", 1, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    }, !0);
  }, function (t, e, n) {
    n(48)("Int16", 2, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    });
  }, function (t, e, n) {
    n(48)("Uint16", 2, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    });
  }, function (t, e, n) {
    n(48)("Int32", 4, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    });
  }, function (t, e, n) {
    n(48)("Uint32", 4, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    });
  }, function (t, e, n) {
    n(48)("Float32", 4, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    });
  }, function (t, e, n) {
    n(48)("Float64", 8, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(20),
      o = n(3),
      a = (n(5).Reflect || {}).apply,
      s = Function.apply;
    r(r.S + r.F * !n(7)(function () {
      a(function () {});
    }), "Reflect", {
      apply: function apply(t, e, n) {
        var r = i(t),
          u = o(n);
        return a ? a(r, e, u) : s.call(r, e, u);
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(64),
      o = n(20),
      a = n(3),
      s = n(8),
      u = n(7),
      c = n(190),
      l = (n(5).Reflect || {}).construct,
      f = u(function () {
        function t() {}
        return !(l(function () {}, [], t) instanceof t);
      }),
      p = !u(function () {
        l(function () {});
      });
    r(r.S + r.F * (f || p), "Reflect", {
      construct: function construct(t, e) {
        o(t), a(e);
        var n = arguments.length < 3 ? t : o(arguments[2]);
        if (p && !f) return l(t, e, n);
        if (t == n) {
          switch (e.length) {
            case 0:
              return new t();
            case 1:
              return new t(e[0]);
            case 2:
              return new t(e[0], e[1]);
            case 3:
              return new t(e[0], e[1], e[2]);
            case 4:
              return new t(e[0], e[1], e[2], e[3]);
          }
          var r = [null];
          return r.push.apply(r, e), new (c.apply(t, r))();
        }
        var u = n.prototype,
          d = i(s(u) ? u : Object.prototype),
          h = Function.apply.call(t, d, e);
        return s(h) ? h : d;
      }
    });
  }, function (t, e, n) {
    var r = n(15),
      i = n(1),
      o = n(3),
      a = n(41);
    i(i.S + i.F * n(7)(function () {
      Reflect.defineProperty(r.f({}, 1, {
        value: 1
      }), 1, {
        value: 2
      });
    }), "Reflect", {
      defineProperty: function defineProperty(t, e, n) {
        o(t), e = a(e, !0), o(n);
        try {
          return r.f(t, e, n), !0;
        } catch (t) {
          return !1;
        }
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(31).f,
      o = n(3);
    r(r.S, "Reflect", {
      deleteProperty: function deleteProperty(t, e) {
        var n = i(o(t), e);
        return !(n && !n.configurable) && delete t[e];
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(3),
      o = function o(t) {
        this._t = i(t), this._i = 0;
        var e,
          n = this._k = [];
        for (e in t) n.push(e);
      };
    n(136)(o, "Object", function () {
      var t,
        e = this,
        n = e._k;
      do {
        if (e._i >= n.length) return {
          value: void 0,
          done: !0
        };
      } while (!((t = n[e._i++]) in e._t));
      return {
        value: t,
        done: !1
      };
    }), r(r.S, "Reflect", {
      enumerate: function enumerate(t) {
        return new o(t);
      }
    });
  }, function (t, e, n) {
    function r(t, e) {
      var n,
        s,
        l = arguments.length < 3 ? t : arguments[2];
      return c(t) === l ? t[e] : (n = i.f(t, e)) ? a(n, "value") ? n.value : void 0 !== n.get ? n.get.call(l) : void 0 : u(s = o(t)) ? r(s, e, l) : void 0;
    }
    var i = n(31),
      o = n(32),
      a = n(29),
      s = n(1),
      u = n(8),
      c = n(3);
    s(s.S, "Reflect", {
      get: r
    });
  }, function (t, e, n) {
    var r = n(31),
      i = n(1),
      o = n(3);
    i(i.S, "Reflect", {
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, e) {
        return r.f(o(t), e);
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(32),
      o = n(3);
    r(r.S, "Reflect", {
      getPrototypeOf: function getPrototypeOf(t) {
        return i(o(t));
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Reflect", {
      has: function has(t, e) {
        return e in t;
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(3),
      o = Object.isExtensible;
    r(r.S, "Reflect", {
      isExtensible: function isExtensible(t) {
        return i(t), !o || o(t);
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Reflect", {
      ownKeys: n(212)
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(3),
      o = Object.preventExtensions;
    r(r.S, "Reflect", {
      preventExtensions: function preventExtensions(t) {
        i(t);
        try {
          return o && o(t), !0;
        } catch (t) {
          return !1;
        }
      }
    });
  }, function (t, e, n) {
    function r(t, e, n) {
      var u,
        p,
        d = arguments.length < 4 ? t : arguments[3],
        h = o.f(l(t), e);
      if (!h) {
        if (f(p = a(t))) return r(p, e, n, d);
        h = c(0);
      }
      if (s(h, "value")) {
        if (!1 === h.writable || !f(d)) return !1;
        if (u = o.f(d, e)) {
          if (u.get || u.set || !1 === u.writable) return !1;
          u.value = n, i.f(d, e, u);
        } else i.f(d, e, c(0, n));
        return !0;
      }
      return void 0 !== h.set && (h.set.call(d, n), !0);
    }
    var i = n(15),
      o = n(31),
      a = n(32),
      s = n(29),
      u = n(1),
      c = n(60),
      l = n(3),
      f = n(8);
    u(u.S, "Reflect", {
      set: r
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(129);
    i && r(r.S, "Reflect", {
      setPrototypeOf: function setPrototypeOf(t, e) {
        i.check(t, e);
        try {
          return i.set(t, e), !0;
        } catch (t) {
          return !1;
        }
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(101)(!0);
    r(r.P, "Array", {
      includes: function includes(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), n(55)("includes");
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(213),
      o = n(16),
      a = n(11),
      s = n(20),
      u = n(142);
    r(r.P, "Array", {
      flatMap: function flatMap(t) {
        var e,
          n,
          r = o(this);
        return s(t), e = a(r.length), n = u(r, 0), i(n, r, r, e, 0, 1, t, arguments[1]), n;
      }
    }), n(55)("flatMap");
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(213),
      o = n(16),
      a = n(11),
      s = n(37),
      u = n(142);
    r(r.P, "Array", {
      flatten: function flatten() {
        var t = arguments[0],
          e = o(this),
          n = a(e.length),
          r = u(e, 0);
        return i(r, e, e, n, 0, void 0 === t ? 1 : s(t)), r;
      }
    }), n(55)("flatten");
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(104)(!0);
    r(r.P, "String", {
      at: function at(t) {
        return i(this, t);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(214),
      o = n(109),
      a = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(o);
    r(r.P + r.F * a, "String", {
      padStart: function padStart(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0, !0);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(214),
      o = n(109),
      a = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(o);
    r(r.P + r.F * a, "String", {
      padEnd: function padEnd(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0, !1);
      }
    });
  }, function (t, e, n) {
    "use strict";

    n(75)("trimLeft", function (t) {
      return function () {
        return t(this, 1);
      };
    }, "trimStart");
  }, function (t, e, n) {
    "use strict";

    n(75)("trimRight", function (t) {
      return function () {
        return t(this, 2);
      };
    }, "trimEnd");
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(42),
      o = n(11),
      a = n(105),
      s = n(87),
      u = RegExp.prototype,
      c = function c(t, e) {
        this._r = t, this._s = e;
      };
    n(136)(c, "RegExp String", function () {
      var t = this._r.exec(this._s);
      return {
        value: t,
        done: null === t
      };
    }), r(r.P, "String", {
      matchAll: function matchAll(t) {
        if (i(this), !a(t)) throw TypeError(t + " is not a regexp!");
        var e = String(this),
          n = "flags" in u ? String(t.flags) : s.call(t),
          r = new RegExp(t.source, ~n.indexOf("g") ? n : "g" + n);
        return r.lastIndex = o(t.lastIndex), new c(r, e);
      }
    });
  }, function (t, e, n) {
    n(125)("asyncIterator");
  }, function (t, e, n) {
    n(125)("observable");
  }, function (t, e, n) {
    var r = n(1),
      i = n(212),
      o = n(30),
      a = n(31),
      s = n(140);
    r(r.S, "Object", {
      getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
        for (var e, n, r = o(t), u = a.f, c = i(r), l = {}, f = 0; c.length > f;) void 0 !== (n = u(r, e = c[f++])) && s(l, e, n);
        return l;
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(215)(!1);
    r(r.S, "Object", {
      values: function values(t) {
        return i(t);
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(215)(!0);
    r(r.S, "Object", {
      entries: function entries(t) {
        return i(t);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(16),
      o = n(20),
      a = n(15);
    n(12) && r(r.P + n(112), "Object", {
      __defineGetter__: function __defineGetter__(t, e) {
        a.f(i(this), t, {
          get: o(e),
          enumerable: !0,
          configurable: !0
        });
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(16),
      o = n(20),
      a = n(15);
    n(12) && r(r.P + n(112), "Object", {
      __defineSetter__: function __defineSetter__(t, e) {
        a.f(i(this), t, {
          set: o(e),
          enumerable: !0,
          configurable: !0
        });
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(16),
      o = n(41),
      a = n(32),
      s = n(31).f;
    n(12) && r(r.P + n(112), "Object", {
      __lookupGetter__: function __lookupGetter__(t) {
        var e,
          n = i(this),
          r = o(t, !0);
        do {
          if (e = s(n, r)) return e.get;
        } while (n = a(n));
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(16),
      o = n(41),
      a = n(32),
      s = n(31).f;
    n(12) && r(r.P + n(112), "Object", {
      __lookupSetter__: function __lookupSetter__(t) {
        var e,
          n = i(this),
          r = o(t, !0);
        do {
          if (e = s(n, r)) return e.set;
        } while (n = a(n));
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.P + r.R, "Map", {
      toJSON: n(216)("Map")
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.P + r.R, "Set", {
      toJSON: n(216)("Set")
    });
  }, function (t, e, n) {
    n(113)("Map");
  }, function (t, e, n) {
    n(113)("Set");
  }, function (t, e, n) {
    n(113)("WeakMap");
  }, function (t, e, n) {
    n(113)("WeakSet");
  }, function (t, e, n) {
    n(114)("Map");
  }, function (t, e, n) {
    n(114)("Set");
  }, function (t, e, n) {
    n(114)("WeakMap");
  }, function (t, e, n) {
    n(114)("WeakSet");
  }, function (t, e, n) {
    var r = n(1);
    r(r.G, {
      global: n(5)
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "System", {
      global: n(5)
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(36);
    r(r.S, "Error", {
      isError: function isError(t) {
        return "Error" === i(t);
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      clamp: function clamp(t, e, n) {
        return Math.min(n, Math.max(e, t));
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      DEG_PER_RAD: Math.PI / 180
    });
  }, function (t, e, n) {
    var r = n(1),
      i = 180 / Math.PI;
    r(r.S, "Math", {
      degrees: function degrees(t) {
        return t * i;
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(218),
      o = n(197);
    r(r.S, "Math", {
      fscale: function fscale(t, e, n, r, a) {
        return o(i(t, e, n, r, a));
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      iaddh: function iaddh(t, e, n, r) {
        var i = t >>> 0,
          o = e >>> 0,
          a = n >>> 0;
        return o + (r >>> 0) + ((i & a | (i | a) & ~(i + a >>> 0)) >>> 31) | 0;
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      isubh: function isubh(t, e, n, r) {
        var i = t >>> 0,
          o = e >>> 0,
          a = n >>> 0;
        return o - (r >>> 0) - ((~i & a | ~(i ^ a) & i - a >>> 0) >>> 31) | 0;
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      imulh: function imulh(t, e) {
        var n = +t,
          r = +e,
          i = 65535 & n,
          o = 65535 & r,
          a = n >> 16,
          s = r >> 16,
          u = (a * o >>> 0) + (i * o >>> 16);
        return a * s + (u >> 16) + ((i * s >>> 0) + (65535 & u) >> 16);
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      RAD_PER_DEG: 180 / Math.PI
    });
  }, function (t, e, n) {
    var r = n(1),
      i = Math.PI / 180;
    r(r.S, "Math", {
      radians: function radians(t) {
        return t * i;
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      scale: n(218)
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      umulh: function umulh(t, e) {
        var n = +t,
          r = +e,
          i = 65535 & n,
          o = 65535 & r,
          a = n >>> 16,
          s = r >>> 16,
          u = (a * o >>> 0) + (i * o >>> 16);
        return a * s + (u >>> 16) + ((i * s >>> 0) + (65535 & u) >>> 16);
      }
    });
  }, function (t, e, n) {
    var r = n(1);
    r(r.S, "Math", {
      signbit: function signbit(t) {
        return (t = +t) != t ? t : 0 == t ? 1 / t == 1 / 0 : t > 0;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(34),
      o = n(5),
      a = n(88),
      s = n(205);
    r(r.P + r.R, "Promise", {
      finally: function _finally(t) {
        var e = a(this, i.Promise || o.Promise),
          n = "function" == typeof t;
        return this.then(n ? function (n) {
          return s(e, t()).then(function () {
            return n;
          });
        } : t, n ? function (n) {
          return s(e, t()).then(function () {
            throw n;
          });
        } : t);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(149),
      o = n(204);
    r(r.S, "Promise", {
      try: function _try(t) {
        var e = i.f(this),
          n = o(t);
        return (n.e ? e.reject : e.resolve)(n.v), e.promise;
      }
    });
  }, function (t, e, n) {
    var r = n(49),
      i = n(3),
      o = r.key,
      a = r.set;
    r.exp({
      defineMetadata: function defineMetadata(t, e, n, r) {
        a(t, e, i(n), o(r));
      }
    });
  }, function (t, e, n) {
    var r = n(49),
      i = n(3),
      o = r.key,
      a = r.map,
      s = r.store;
    r.exp({
      deleteMetadata: function deleteMetadata(t, e) {
        var n = arguments.length < 3 ? void 0 : o(arguments[2]),
          r = a(i(e), n, !1);
        if (void 0 === r || !r.delete(t)) return !1;
        if (r.size) return !0;
        var u = s.get(e);
        return u.delete(n), !!u.size || s.delete(e);
      }
    });
  }, function (t, e, n) {
    var r = n(49),
      i = n(3),
      o = n(32),
      a = r.has,
      s = r.get,
      u = r.key,
      c = function c(t, e, n) {
        if (a(t, e, n)) return s(t, e, n);
        var r = o(e);
        return null !== r ? c(t, r, n) : void 0;
      };
    r.exp({
      getMetadata: function getMetadata(t, e) {
        return c(t, i(e), arguments.length < 3 ? void 0 : u(arguments[2]));
      }
    });
  }, function (t, e, n) {
    var r = n(208),
      i = n(217),
      o = n(49),
      a = n(3),
      s = n(32),
      u = o.keys,
      c = o.key,
      l = function l(t, e) {
        var n = u(t, e),
          o = s(t);
        if (null === o) return n;
        var a = l(o, e);
        return a.length ? n.length ? i(new r(n.concat(a))) : a : n;
      };
    o.exp({
      getMetadataKeys: function getMetadataKeys(t) {
        return l(a(t), arguments.length < 2 ? void 0 : c(arguments[1]));
      }
    });
  }, function (t, e, n) {
    var r = n(49),
      i = n(3),
      o = r.get,
      a = r.key;
    r.exp({
      getOwnMetadata: function getOwnMetadata(t, e) {
        return o(t, i(e), arguments.length < 3 ? void 0 : a(arguments[2]));
      }
    });
  }, function (t, e, n) {
    var r = n(49),
      i = n(3),
      o = r.keys,
      a = r.key;
    r.exp({
      getOwnMetadataKeys: function getOwnMetadataKeys(t) {
        return o(i(t), arguments.length < 2 ? void 0 : a(arguments[1]));
      }
    });
  }, function (t, e, n) {
    var r = n(49),
      i = n(3),
      o = n(32),
      a = r.has,
      s = r.key,
      u = function u(t, e, n) {
        if (a(t, e, n)) return !0;
        var r = o(e);
        return null !== r && u(t, r, n);
      };
    r.exp({
      hasMetadata: function hasMetadata(t, e) {
        return u(t, i(e), arguments.length < 3 ? void 0 : s(arguments[2]));
      }
    });
  }, function (t, e, n) {
    var r = n(49),
      i = n(3),
      o = r.has,
      a = r.key;
    r.exp({
      hasOwnMetadata: function hasOwnMetadata(t, e) {
        return o(t, i(e), arguments.length < 3 ? void 0 : a(arguments[2]));
      }
    });
  }, function (t, e, n) {
    var r = n(49),
      i = n(3),
      o = n(20),
      a = r.key,
      s = r.set;
    r.exp({
      metadata: function metadata(t, e) {
        return function (n, r) {
          s(t, e, (void 0 !== r ? i : o)(n), a(r));
        };
      }
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(148)(),
      o = n(5).process,
      a = "process" == n(36)(o);
    r(r.G, {
      asap: function asap(t) {
        var e = a && o.domain;
        i(e ? e.bind(t) : t);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n(5),
      o = n(34),
      a = n(148)(),
      s = n(10)("observable"),
      u = n(20),
      c = n(3),
      l = n(67),
      f = n(69),
      p = n(25),
      d = n(68),
      h = d.RETURN,
      m = function m(t) {
        return null == t ? void 0 : u(t);
      },
      g = function g(t) {
        var e = t._c;
        e && (t._c = void 0, e());
      },
      v = function v(t) {
        return void 0 === t._o;
      },
      y = function y(t) {
        v(t) || (t._o = void 0, g(t));
      },
      _ = function _(t, e) {
        c(t), this._c = void 0, this._o = t, t = new b(this);
        try {
          var n = e(t),
            r = n;
          null != n && ("function" == typeof n.unsubscribe ? n = function n() {
            r.unsubscribe();
          } : u(n), this._c = n);
        } catch (e) {
          return void t.error(e);
        }
        v(this) && g(this);
      };
    _.prototype = f({}, {
      unsubscribe: function unsubscribe() {
        y(this);
      }
    });
    var b = function b(t) {
      this._s = t;
    };
    b.prototype = f({}, {
      next: function next(t) {
        var e = this._s;
        if (!v(e)) {
          var n = e._o;
          try {
            var r = m(n.next);
            if (r) return r.call(n, t);
          } catch (t) {
            try {
              y(e);
            } finally {
              throw t;
            }
          }
        }
      },
      error: function error(t) {
        var e = this._s;
        if (v(e)) throw t;
        var n = e._o;
        e._o = void 0;
        try {
          var r = m(n.error);
          if (!r) throw t;
          t = r.call(n, t);
        } catch (t) {
          try {
            g(e);
          } finally {
            throw t;
          }
        }
        return g(e), t;
      },
      complete: function complete(t) {
        var e = this._s;
        if (!v(e)) {
          var n = e._o;
          e._o = void 0;
          try {
            var r = m(n.complete);
            t = r ? r.call(n, t) : void 0;
          } catch (t) {
            try {
              g(e);
            } finally {
              throw t;
            }
          }
          return g(e), t;
        }
      }
    });
    var w = function w(t) {
      l(this, w, "Observable", "_f")._f = u(t);
    };
    f(w.prototype, {
      subscribe: function subscribe(t) {
        return new _(t, this._f);
      },
      forEach: function forEach(t) {
        var e = this;
        return new (o.Promise || i.Promise)(function (n, r) {
          u(t);
          var i = e.subscribe({
            next: function next(e) {
              try {
                return t(e);
              } catch (t) {
                r(t), i.unsubscribe();
              }
            },
            error: r,
            complete: n
          });
        });
      }
    }), f(w, {
      from: function from(t) {
        var e = "function" == typeof this ? this : w,
          n = m(c(t)[s]);
        if (n) {
          var r = c(n.call(t));
          return r.constructor === e ? r : new e(function (t) {
            return r.subscribe(t);
          });
        }
        return new e(function (e) {
          var n = !1;
          return a(function () {
            if (!n) {
              try {
                if (d(t, !1, function (t) {
                  if (e.next(t), n) return h;
                }) === h) return;
              } catch (t) {
                if (n) throw t;
                return void e.error(t);
              }
              e.complete();
            }
          }), function () {
            n = !0;
          };
        });
      },
      of: function of() {
        for (var t = 0, e = arguments.length, n = new Array(e); t < e;) n[t] = arguments[t++];
        return new ("function" == typeof this ? this : w)(function (t) {
          var e = !1;
          return a(function () {
            if (!e) {
              for (var r = 0; r < n.length; ++r) if (t.next(n[r]), e) return;
              t.complete();
            }
          }), function () {
            e = !0;
          };
        });
      }
    }), p(w.prototype, s, function () {
      return this;
    }), r(r.G, {
      Observable: w
    }), n(66)("Observable");
  }, function (t, e, n) {
    var r = n(5),
      i = n(1),
      o = n(109),
      a = [].slice,
      s = /MSIE .\./.test(o),
      u = function u(t) {
        return function (e, n) {
          var r = arguments.length > 2,
            i = !!r && a.call(arguments, 2);
          return t(r ? function () {
            ("function" == typeof e ? e : Function(e)).apply(this, i);
          } : e, n);
        };
      };
    i(i.G + i.B + i.F * s, {
      setTimeout: u(r.setTimeout),
      setInterval: u(r.setInterval)
    });
  }, function (t, e, n) {
    var r = n(1),
      i = n(147);
    r(r.G + r.B, {
      setImmediate: i.set,
      clearImmediate: i.clear
    });
  }, function (t, e, n) {
    for (var r = n(144), i = n(62), o = n(26), a = n(5), s = n(25), u = n(76), c = n(10), l = c("iterator"), f = c("toStringTag"), p = u.Array, d = {
        CSSRuleList: !0,
        CSSStyleDeclaration: !1,
        CSSValueList: !1,
        ClientRectList: !1,
        DOMRectList: !1,
        DOMStringList: !1,
        DOMTokenList: !0,
        DataTransferItemList: !1,
        FileList: !1,
        HTMLAllCollection: !1,
        HTMLCollection: !1,
        HTMLFormElement: !1,
        HTMLSelectElement: !1,
        MediaList: !0,
        MimeTypeArray: !1,
        NamedNodeMap: !1,
        NodeList: !0,
        PaintRequestList: !1,
        Plugin: !1,
        PluginArray: !1,
        SVGLengthList: !1,
        SVGNumberList: !1,
        SVGPathSegList: !1,
        SVGPointList: !1,
        SVGStringList: !1,
        SVGTransformList: !1,
        SourceBufferList: !1,
        StyleSheetList: !0,
        TextTrackCueList: !1,
        TextTrackList: !1,
        TouchList: !1
      }, h = i(d), m = 0; m < h.length; m++) {
      var g,
        v = h[m],
        y = d[v],
        _ = a[v],
        b = _ && _.prototype;
      if (b && (b[l] || s(b, l, p), b[f] || s(b, f, v), u[v] = p, y)) for (g in r) b[g] || o(b, g, r[g], !0);
    }
  }, function (t, e, n) {
    (function (e) {
      /**
      * Copyright (c) 2014, Facebook, Inc.
      * All rights reserved.
      *
      * This source code is licensed under the BSD-style license found in the
      * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
      * additional grant of patent rights can be found in the PATENTS file in
      * the same directory.
      */
      !function (e) {
        "use strict";

        function n(t, e, n, r) {
          var o = e && e.prototype instanceof i ? e : i,
            a = Object.create(o.prototype),
            s = new d(r || []);
          return a._invoke = c(t, n, s), a;
        }
        function r(t, e, n) {
          try {
            return {
              type: "normal",
              arg: t.call(e, n)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }
        function i() {}
        function o() {}
        function a() {}
        function s(t) {
          ["next", "throw", "return"].forEach(function (e) {
            t[e] = function (t) {
              return this._invoke(e, t);
            };
          });
        }
        function u(t) {
          function n(e, i, o, a) {
            var s = r(t[e], t, i);
            if ("throw" !== s.type) {
              var u = s.arg,
                c = u.value;
              return c && "object" == typeof c && y.call(c, "__await") ? Promise.resolve(c.__await).then(function (t) {
                n("next", t, o, a);
              }, function (t) {
                n("throw", t, o, a);
              }) : Promise.resolve(c).then(function (t) {
                u.value = t, o(u);
              }, a);
            }
            a(s.arg);
          }
          function i(t, e) {
            function r() {
              return new Promise(function (r, i) {
                n(t, e, r, i);
              });
            }
            return o = o ? o.then(r, r) : r();
          }
          "object" == typeof e.process && e.process.domain && (n = e.process.domain.bind(n));
          var o;
          this._invoke = i;
        }
        function c(t, e, n) {
          var i = T;
          return function (o, a) {
            if (i === A) throw new Error("Generator is already running");
            if (i === O) {
              if ("throw" === o) throw a;
              return m();
            }
            for (n.method = o, n.arg = a;;) {
              var s = n.delegate;
              if (s) {
                var u = l(s, n);
                if (u) {
                  if (u === C) continue;
                  return u;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (i === T) throw i = O, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              i = A;
              var c = r(t, e, n);
              if ("normal" === c.type) {
                if (i = n.done ? O : k, c.arg === C) continue;
                return {
                  value: c.arg,
                  done: n.done
                };
              }
              "throw" === c.type && (i = O, n.method = "throw", n.arg = c.arg);
            }
          };
        }
        function l(t, e) {
          var n = t.iterator[e.method];
          if (n === g) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = g, l(t, e), "throw" === e.method)) return C;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return C;
          }
          var i = r(n, t.iterator, e.arg);
          if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, C;
          var o = i.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = g), e.delegate = null, C) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, C);
        }
        function f(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }
        function p(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }
        function d(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(f, this), this.reset(!0);
        }
        function h(t) {
          if (t) {
            var e = t[b];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var n = -1,
                r = function e() {
                  for (; ++n < t.length;) if (y.call(t, n)) return e.value = t[n], e.done = !1, e;
                  return e.value = g, e.done = !0, e;
                };
              return r.next = r;
            }
          }
          return {
            next: m
          };
        }
        function m() {
          return {
            value: g,
            done: !0
          };
        }
        var g,
          v = Object.prototype,
          y = v.hasOwnProperty,
          _ = "function" == typeof Symbol ? Symbol : {},
          b = _.iterator || "@@iterator",
          w = _.asyncIterator || "@@asyncIterator",
          S = _.toStringTag || "@@toStringTag",
          x = "object" == typeof t,
          E = e.regeneratorRuntime;
        if (E) return void (x && (t.exports = E));
        E = e.regeneratorRuntime = x ? t.exports : {}, E.wrap = n;
        var T = "suspendedStart",
          k = "suspendedYield",
          A = "executing",
          O = "completed",
          C = {},
          I = {};
        I[b] = function () {
          return this;
        };
        var R = Object.getPrototypeOf,
          P = R && R(R(h([])));
        P && P !== v && y.call(P, b) && (I = P);
        var N = a.prototype = i.prototype = Object.create(I);
        o.prototype = N.constructor = a, a.constructor = o, a[S] = o.displayName = "GeneratorFunction", E.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === o || "GeneratorFunction" === (e.displayName || e.name));
        }, E.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, a) : (t.__proto__ = a, S in t || (t[S] = "GeneratorFunction")), t.prototype = Object.create(N), t;
        }, E.awrap = function (t) {
          return {
            __await: t
          };
        }, s(u.prototype), u.prototype[w] = function () {
          return this;
        }, E.AsyncIterator = u, E.async = function (t, e, r, i) {
          var o = new u(n(t, e, r, i));
          return E.isGeneratorFunction(e) ? o : o.next().then(function (t) {
            return t.done ? t.value : o.next();
          });
        }, s(N), N[S] = "Generator", N[b] = function () {
          return this;
        }, N.toString = function () {
          return "[object Generator]";
        }, E.keys = function (t) {
          var e = [];
          for (var n in t) e.push(n);
          return e.reverse(), function n() {
            for (; e.length;) {
              var r = e.pop();
              if (r in t) return n.value = r, n.done = !1, n;
            }
            return n.done = !0, n;
          };
        }, E.values = h, d.prototype = {
          constructor: d,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = g, this.done = !1, this.delegate = null, this.method = "next", this.arg = g, this.tryEntries.forEach(p), !t) for (var e in this) "t" === e.charAt(0) && y.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = g);
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0],
              e = t.completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            function e(e, r) {
              return o.type = "throw", o.arg = t, n.next = e, r && (n.method = "next", n.arg = g), !!r;
            }
            if (this.done) throw t;
            for (var n = this, r = this.tryEntries.length - 1; r >= 0; --r) {
              var i = this.tryEntries[r],
                o = i.completion;
              if ("root" === i.tryLoc) return e("end");
              if (i.tryLoc <= this.prev) {
                var a = y.call(i, "catchLoc"),
                  s = y.call(i, "finallyLoc");
                if (a && s) {
                  if (this.prev < i.catchLoc) return e(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return e(i.finallyLoc);
                } else if (a) {
                  if (this.prev < i.catchLoc) return e(i.catchLoc, !0);
                } else {
                  if (!s) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return e(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var r = this.tryEntries[n];
              if (r.tryLoc <= this.prev && y.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                var i = r;
                break;
              }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var o = i ? i.completion : {};
            return o.type = t, o.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, C) : this.complete(o);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), C;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var n = this.tryEntries[e];
              if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), p(n), C;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var n = this.tryEntries[e];
              if (n.tryLoc === t) {
                var r = n.completion;
                if ("throw" === r.type) {
                  var i = r.arg;
                  p(n);
                }
                return i;
              }
            }
            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, n) {
            return this.delegate = {
              iterator: h(t),
              resultName: e,
              nextLoc: n
            }, "next" === this.method && (this.arg = g), C;
          }
        };
      }("object" == typeof e ? e : "object" == typeof window ? window : "object" == typeof self ? self : this);
    }).call(e, n(100));
  }, function (t, e, n) {
    n(473), t.exports = n(34).RegExp.escape;
  }, function (t, e, n) {
    var r = n(1),
      i = n(474)(/[\\^$*+?.()|[\]{}]/g, "\\$&");
    r(r.S, "RegExp", {
      escape: function escape(t) {
        return i(t);
      }
    });
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = e === Object(e) ? function (t) {
        return e[t];
      } : e;
      return function (e) {
        return String(e).replace(t, n);
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = function () {
      function t(t, r) {
        function c(a, s, c) {
          if (i) throw new Error("An instance of the widget has already been rendered. Call remove() first.");
          d() && r.debugMessage("\n            Looks like there are still tokens in the URL! Don't forget to parse and store them.\n            See: https://github.com/okta/okta-signin-widget/#oidc-tokenparsetokensfromurlsuccess-error.\n          ");
          var l = !r.isV1StateToken(m.stateToken),
            f = u;
          m.stateToken && l && (f = n(648)), m.stateToken ? r.introspectToken(t, m).then(o.bind(function (n) {
            var r = n;
            i = e.call(this, f, t, m, a, s, c), l && (r = n.rawIdxState, i.appState.set("idx", n)), i.appState.set("introspectSuccess", r), i.start();
          }, this)).fail(o.bind(function (n) {
            i = e.call(this, f, t, m, a, s, c);
            var r = l ? n.details : n;
            i.appState.set("introspectError", r), i.start();
          }, this)) : (i = e.call(this, f, t, m, a, s, c), i.start());
        }
        function l() {
          i && i.hide();
        }
        function f() {
          i && i.show();
        }
        function p() {
          i && (i.remove(), i = void 0);
        }
        function d() {
          return r.hasTokensInHash(window.location.hash);
        }
        function h(t) {
          var e = s.transformShowSignInToGetTokensOptions(t, a);
          return c.call(this, e);
        }
        var m = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return {
          renderEl: c,
          authClient: t,
          showSignInToGetTokens: h,
          hasTokensInUrl: d,
          hide: l,
          show: f,
          remove: p
        };
      }
      function e(t, e, n, r, i, a) {
        var s = new t(o.extend({}, n, r, {
          authClient: e,
          globalSuccessFn: i,
          globalErrorFn: a
        }));
        return o.extend(this, t.prototype.Events), this.listenTo(t.prototype, "all", this.trigger), this.once("afterRender", function (t) {
          this.trigger("ready", t);
        }), s;
      }
      function r(e) {
        n(0);
        var r = n(13),
          i = n(673),
          s = o.extend({
            url: e.baseUrl,
            transformErrorXHR: r.transformErrorXHR,
            headers: {
              "X-Okta-User-Agent-Extended": "okta-signin-widget-" + a.version
            },
            clientId: e.clientId,
            redirectUri: e.redirectUri
          }, e.authParams),
          c = new i(s);
        r.debugMessage("\n        The Okta Sign-In Widget is running in development mode.\n        When you are ready to publish your app, embed the minified version to turn on production mode.\n        See: https://developer.okta.com/code/javascript/okta_sign-in_widget#cdn\n      "), o.extend(this, u.prototype.Events, t(c, r, e));
      }
      var i,
        o = n(151),
        a = n(152),
        s = n(153),
        u = n(537);
      return r;
    }();
    t.exports = r;
  }, function (t, e, n) {
    var r = n(9),
      i = r.JSON || (r.JSON = {
        stringify: JSON.stringify
      });
    t.exports = function (t) {
      return i.stringify.apply(i, arguments);
    };
  }, function (t, e, n) {
    n(90), n(118), t.exports = n(119).f("iterator");
  }, function (t, e, n) {
    var r = n(154),
      i = n(155);
    t.exports = function (t) {
      return function (e, n) {
        var o,
          a,
          s = String(i(e)),
          u = r(n),
          c = s.length;
        return u < 0 || u >= c ? t ? "" : void 0 : (o = s.charCodeAt(u), o < 55296 || o > 56319 || u + 1 === c || (a = s.charCodeAt(u + 1)) < 56320 || a > 57343 ? t ? s.charAt(u) : o : t ? s.slice(u, u + 2) : a - 56320 + (o - 55296 << 10) + 65536);
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(158),
      i = n(92),
      o = n(117),
      a = {};
    n(71)(a, n(23)("iterator"), function () {
      return this;
    }), t.exports = function (t, e, n) {
      t.prototype = r(a, {
        next: i(1, n)
      }), o(t, e + " Iterator");
    };
  }, function (t, e, n) {
    var r = n(56),
      i = n(159),
      o = n(481);
    t.exports = function (t) {
      return function (e, n, a) {
        var s,
          u = r(e),
          c = i(u.length),
          l = o(a, c);
        if (t && n != n) {
          for (; c > l;) if ((s = u[l++]) != s) return !0;
        } else for (; c > l; l++) if ((t || l in u) && u[l] === n) return t || l || 0;
        return !t && -1;
      };
    };
  }, function (t, e, n) {
    var r = n(154),
      i = Math.max,
      o = Math.min;
    t.exports = function (t, e) {
      return t = r(t), t < 0 ? i(t + e, 0) : o(t, e);
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(483),
      i = n(484),
      o = n(80),
      a = n(56);
    t.exports = n(220)(Array, "Array", function (t, e) {
      this._t = a(t), this._i = 0, this._k = e;
    }, function () {
      var t = this._t,
        e = this._k,
        n = this._i++;
      return !t || n >= t.length ? (this._t = void 0, i(1)) : "keys" == e ? i(0, n) : "values" == e ? i(0, t[n]) : i(0, [n, t[n]]);
    }, "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries");
  }, function (t, e) {
    t.exports = function () {};
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        value: e,
        done: !!t
      };
    };
  }, function (t, e, n) {
    n(229), n(166), n(488), n(489), t.exports = n(9).Symbol;
  }, function (t, e, n) {
    var r = n(81),
      i = n(164),
      o = n(94);
    t.exports = function (t) {
      var e = r(t),
        n = i.f;
      if (n) for (var a, s = n(t), u = o.f, c = 0; s.length > c;) u.call(t, a = s[c++]) && e.push(a);
      return e;
    };
  }, function (t, e, n) {
    var r = n(93);
    t.exports = Array.isArray || function (t) {
      return "Array" == r(t);
    };
  }, function (t, e, n) {
    n(163)("asyncIterator");
  }, function (t, e, n) {
    n(163)("observable");
  }, function (t, e, n) {
    n(491);
    var r = n(9).Object;
    t.exports = function (t, e, n) {
      return r.defineProperty(t, e, n);
    };
  }, function (t, e, n) {
    var r = n(21);
    r(r.S + r.F * !n(39), "Object", {
      defineProperty: n(50).f
    });
  }, function (t, e, n) {
    (function (r) {
      var i, o;
      //     (c) 2010-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
      //     Backbone may be freely distributed under the MIT license.
      !function (a) {
        var s = "object" == typeof self && self.self == self && self || "object" == typeof r && r.global == r && r;
        i = [n(493), n(120), e], void 0 !== (o = function (t, e, n) {
          s.Backbone = a(s, n, t, e);
        }.apply(e, i)) && (t.exports = o);
      }(function (t, e, n, r) {
        var i = t.Backbone,
          o = [].slice;
        e.VERSION = "1.2.1", e.$ = r, e.noConflict = function () {
          return t.Backbone = i, this;
        }, e.emulateHTTP = !1, e.emulateJSON = !1;
        var a = function a(t, e, r) {
            switch (t) {
              case 1:
                return function () {
                  return n[e](this[r]);
                };
              case 2:
                return function (t) {
                  return n[e](this[r], t);
                };
              case 3:
                return function (t, i) {
                  return n[e](this[r], t, i);
                };
              case 4:
                return function (t, i, o) {
                  return n[e](this[r], t, i, o);
                };
              default:
                return function () {
                  var t = o.call(arguments);
                  return t.unshift(this[r]), n[e].apply(n, t);
                };
            }
          },
          s = function s(t, e, r) {
            n.each(e, function (e, i) {
              n[i] && (t.prototype[i] = a(e, i, r));
            });
          },
          u = e.Events = {},
          c = /\s+/,
          l = function l(t, e, r, i, o) {
            var a,
              s = 0;
            if (r && "object" == typeof r) {
              void 0 !== i && "context" in o && void 0 === o.context && (o.context = i);
              for (a = n.keys(r); s < a.length; s++) e = t(e, a[s], r[a[s]], o);
            } else if (r && c.test(r)) for (a = r.split(c); s < a.length; s++) e = t(e, a[s], i, o);else e = t(e, r, i, o);
            return e;
          };
        u.on = function (t, e, n) {
          return f(this, t, e, n);
        };
        var f = function f(t, e, n, r, i) {
          if (t._events = l(p, t._events || {}, e, n, {
            context: r,
            ctx: t,
            listening: i
          }), i) {
            (t._listeners || (t._listeners = {}))[i.id] = i;
          }
          return t;
        };
        u.listenTo = function (t, e, r) {
          if (!t) return this;
          var i = t._listenId || (t._listenId = n.uniqueId("l")),
            o = this._listeningTo || (this._listeningTo = {}),
            a = o[i];
          if (!a) {
            var s = this._listenId || (this._listenId = n.uniqueId("l"));
            a = o[i] = {
              obj: t,
              objId: i,
              id: s,
              listeningTo: o,
              count: 0
            };
          }
          return f(t, e, r, this, a), this;
        };
        var p = function p(t, e, n, r) {
          if (n) {
            var i = t[e] || (t[e] = []),
              o = r.context,
              a = r.ctx,
              s = r.listening;
            s && s.count++, i.push({
              callback: n,
              context: o,
              ctx: o || a,
              listening: s
            });
          }
          return t;
        };
        u.off = function (t, e, n) {
          return this._events ? (this._events = l(d, this._events, t, e, {
            context: n,
            listeners: this._listeners
          }), this) : this;
        }, u.stopListening = function (t, e, r) {
          var i = this._listeningTo;
          if (!i) return this;
          for (var o = t ? [t._listenId] : n.keys(i), a = 0; a < o.length; a++) {
            var s = i[o[a]];
            if (!s) break;
            s.obj.off(e, r, this);
          }
          return n.isEmpty(i) && (this._listeningTo = void 0), this;
        };
        var d = function d(t, e, r, i) {
          if (t) {
            var o,
              a = 0,
              s = i.context,
              u = i.listeners;
            if (e || r || s) {
              for (var c = e ? [e] : n.keys(t); a < c.length; a++) {
                e = c[a];
                var l = t[e];
                if (!l) break;
                for (var f = [], p = 0; p < l.length; p++) {
                  var d = l[p];
                  r && r !== d.callback && r !== d.callback._callback || s && s !== d.context ? f.push(d) : (o = d.listening) && 0 == --o.count && (delete u[o.id], delete o.listeningTo[o.objId]);
                }
                f.length ? t[e] = f : delete t[e];
              }
              return n.size(t) ? t : void 0;
            }
            for (var h = n.keys(u); a < h.length; a++) o = u[h[a]], delete u[o.id], delete o.listeningTo[o.objId];
          }
        };
        u.once = function (t, e, r) {
          var i = l(h, {}, t, e, n.bind(this.off, this));
          return this.on(i, void 0, r);
        }, u.listenToOnce = function (t, e, r) {
          var i = l(h, {}, e, r, n.bind(this.stopListening, this, t));
          return this.listenTo(t, i);
        };
        var h = function h(t, e, r, i) {
          if (r) {
            var o = t[e] = n.once(function () {
              i(e, o), r.apply(this, arguments);
            });
            o._callback = r;
          }
          return t;
        };
        u.trigger = function (t) {
          if (!this._events) return this;
          for (var e = Math.max(0, arguments.length - 1), n = Array(e), r = 0; r < e; r++) n[r] = arguments[r + 1];
          return l(m, this._events, t, void 0, n), this;
        };
        var m = function m(t, e, n, r) {
            if (t) {
              var i = t[e],
                o = t.all;
              i && o && (o = o.slice()), i && g(i, r), o && g(o, [e].concat(r));
            }
            return t;
          },
          g = function g(t, e) {
            var n,
              r = -1,
              i = t.length,
              o = e[0],
              a = e[1],
              s = e[2];
            switch (e.length) {
              case 0:
                for (; ++r < i;) (n = t[r]).callback.call(n.ctx);
                return;
              case 1:
                for (; ++r < i;) (n = t[r]).callback.call(n.ctx, o);
                return;
              case 2:
                for (; ++r < i;) (n = t[r]).callback.call(n.ctx, o, a);
                return;
              case 3:
                for (; ++r < i;) (n = t[r]).callback.call(n.ctx, o, a, s);
                return;
              default:
                for (; ++r < i;) (n = t[r]).callback.apply(n.ctx, e);
                return;
            }
          };
        u.bind = u.on, u.unbind = u.off, n.extend(e, u);
        var v = e.Model = function (t, e) {
          var r = t || {};
          e || (e = {}), this.cid = n.uniqueId(this.cidPrefix), this.attributes = {}, e.collection && (this.collection = e.collection), e.parse && (r = this.parse(r, e) || {}), r = n.defaults({}, r, n.result(this, "defaults")), this.set(r, e), this.changed = {}, this.initialize.apply(this, arguments);
        };
        n.extend(v.prototype, u, {
          changed: null,
          validationError: null,
          idAttribute: "id",
          cidPrefix: "c",
          initialize: function initialize() {},
          toJSON: function toJSON(t) {
            return n.clone(this.attributes);
          },
          sync: function sync() {
            return e.sync.apply(this, arguments);
          },
          get: function get(t) {
            return this.attributes[t];
          },
          escape: function escape(t) {
            return n.escape(this.get(t));
          },
          has: function has(t) {
            return null != this.get(t);
          },
          matches: function matches(t) {
            return !!n.iteratee(t, this)(this.attributes);
          },
          set: function set(t, e, r) {
            if (null == t) return this;
            var i;
            if ("object" == typeof t ? (i = t, r = e) : (i = {})[t] = e, r || (r = {}), !this._validate(i, r)) return !1;
            var o = r.unset,
              a = r.silent,
              s = [],
              u = this._changing;
            this._changing = !0, u || (this._previousAttributes = n.clone(this.attributes), this.changed = {});
            var c = this.attributes,
              l = this.changed,
              f = this._previousAttributes;
            this.idAttribute in i && (this.id = i[this.idAttribute]);
            for (var p in i) e = i[p], n.isEqual(c[p], e) || s.push(p), n.isEqual(f[p], e) ? delete l[p] : l[p] = e, o ? delete c[p] : c[p] = e;
            if (!a) {
              s.length && (this._pending = r);
              for (var d = 0; d < s.length; d++) this.trigger("change:" + s[d], this, c[s[d]], r);
            }
            if (u) return this;
            if (!a) for (; this._pending;) r = this._pending, this._pending = !1, this.trigger("change", this, r);
            return this._pending = !1, this._changing = !1, this;
          },
          unset: function unset(t, e) {
            return this.set(t, void 0, n.extend({}, e, {
              unset: !0
            }));
          },
          clear: function clear(t) {
            var e = {};
            for (var r in this.attributes) e[r] = void 0;
            return this.set(e, n.extend({}, t, {
              unset: !0
            }));
          },
          hasChanged: function hasChanged(t) {
            return null == t ? !n.isEmpty(this.changed) : n.has(this.changed, t);
          },
          changedAttributes: function changedAttributes(t) {
            if (!t) return !!this.hasChanged() && n.clone(this.changed);
            var e = this._changing ? this._previousAttributes : this.attributes,
              r = {};
            for (var i in t) {
              var o = t[i];
              n.isEqual(e[i], o) || (r[i] = o);
            }
            return !!n.size(r) && r;
          },
          previous: function previous(t) {
            return null != t && this._previousAttributes ? this._previousAttributes[t] : null;
          },
          previousAttributes: function previousAttributes() {
            return n.clone(this._previousAttributes);
          },
          fetch: function fetch(t) {
            t = n.extend({
              parse: !0
            }, t);
            var e = this,
              r = t.success;
            return t.success = function (n) {
              var i = t.parse ? e.parse(n, t) : n;
              if (!e.set(i, t)) return !1;
              r && r.call(t.context, e, n, t), e.trigger("sync", e, n, t);
            }, D(this, t), this.sync("read", this, t);
          },
          save: function save(t, e, r) {
            var i;
            null == t || "object" == typeof t ? (i = t, r = e) : (i = {})[t] = e, r = n.extend({
              validate: !0,
              parse: !0
            }, r);
            var o = r.wait;
            if (i && !o) {
              if (!this.set(i, r)) return !1;
            } else if (!this._validate(i, r)) return !1;
            var a = this,
              s = r.success,
              u = this.attributes;
            r.success = function (t) {
              a.attributes = u;
              var e = r.parse ? a.parse(t, r) : t;
              if (o && (e = n.extend({}, i, e)), e && !a.set(e, r)) return !1;
              s && s.call(r.context, a, t, r), a.trigger("sync", a, t, r);
            }, D(this, r), i && o && (this.attributes = n.extend({}, u, i));
            var c = this.isNew() ? "create" : r.patch ? "patch" : "update";
            "patch" !== c || r.attrs || (r.attrs = i);
            var l = this.sync(c, this, r);
            return this.attributes = u, l;
          },
          destroy: function destroy(t) {
            t = t ? n.clone(t) : {};
            var e = this,
              r = t.success,
              i = t.wait,
              o = function o() {
                e.stopListening(), e.trigger("destroy", e, e.collection, t);
              };
            t.success = function (n) {
              i && o(), r && r.call(t.context, e, n, t), e.isNew() || e.trigger("sync", e, n, t);
            };
            var a = !1;
            return this.isNew() ? n.defer(t.success) : (D(this, t), a = this.sync("delete", this, t)), i || o(), a;
          },
          url: function url() {
            var t = n.result(this, "urlRoot") || n.result(this.collection, "url") || F();
            if (this.isNew()) return t;
            var e = this.get(this.idAttribute);
            return t.replace(/[^\/]$/, "$&/") + encodeURIComponent(e);
          },
          parse: function parse(t, e) {
            return t;
          },
          clone: function clone() {
            return new this.constructor(this.attributes);
          },
          isNew: function isNew() {
            return !this.has(this.idAttribute);
          },
          isValid: function isValid(t) {
            return this._validate({}, n.defaults({
              validate: !0
            }, t));
          },
          _validate: function _validate(t, e) {
            if (!e.validate || !this.validate) return !0;
            t = n.extend({}, this.attributes, t);
            var r = this.validationError = this.validate(t, e) || null;
            return !r || (this.trigger("invalid", this, r, n.extend(e, {
              validationError: r
            })), !1);
          }
        }), s(v, {
          keys: 1,
          values: 1,
          pairs: 1,
          invert: 1,
          pick: 0,
          omit: 0,
          chain: 1,
          isEmpty: 1
        }, "attributes");
        var y = e.Collection = function (t, e) {
            e || (e = {}), e.model && (this.model = e.model), void 0 !== e.comparator && (this.comparator = e.comparator), this._reset(), this.initialize.apply(this, arguments), t && this.reset(t, n.extend({
              silent: !0
            }, e));
          },
          _ = {
            add: !0,
            remove: !0,
            merge: !0
          },
          b = {
            add: !0,
            remove: !1
          };
        n.extend(y.prototype, u, {
          model: v,
          initialize: function initialize() {},
          toJSON: function toJSON(t) {
            return this.map(function (e) {
              return e.toJSON(t);
            });
          },
          sync: function sync() {
            return e.sync.apply(this, arguments);
          },
          add: function add(t, e) {
            return this.set(t, n.extend({
              merge: !1
            }, e, b));
          },
          remove: function remove(t, e) {
            e = n.extend({}, e);
            var r = !n.isArray(t);
            t = r ? [t] : n.clone(t);
            var i = this._removeModels(t, e);
            return !e.silent && i && this.trigger("update", this, e), r ? i[0] : i;
          },
          set: function set(t, e) {
            e = n.defaults({}, e, _), e.parse && !this._isModel(t) && (t = this.parse(t, e));
            var r = !n.isArray(t);
            t = r ? t ? [t] : [] : t.slice();
            var i,
              o,
              a,
              s,
              u,
              c = e.at;
            null != c && (c = +c), c < 0 && (c += this.length + 1);
            for (var l = this.comparator && null == c && !1 !== e.sort, f = n.isString(this.comparator) ? this.comparator : null, p = [], d = [], h = {}, m = e.add, g = e.merge, v = e.remove, y = !(l || !m || !v) && [], b = !1, w = 0; w < t.length; w++) {
              if (a = t[w], s = this.get(a)) v && (h[s.cid] = !0), g && a !== s && (a = this._isModel(a) ? a.attributes : a, e.parse && (a = s.parse(a, e)), s.set(a, e), l && !u && s.hasChanged(f) && (u = !0)), t[w] = s;else if (m) {
                if (!(o = t[w] = this._prepareModel(a, e))) continue;
                p.push(o), this._addReference(o, e);
              }
              o = s || o, o && (i = this.modelId(o.attributes), !y || !o.isNew() && h[i] || (y.push(o), b = b || !this.models[w] || o.cid !== this.models[w].cid), h[i] = !0);
            }
            if (v) {
              for (var w = 0; w < this.length; w++) h[(o = this.models[w]).cid] || d.push(o);
              d.length && this._removeModels(d, e);
            }
            if (p.length || b) if (l && (u = !0), this.length += p.length, null != c) for (var w = 0; w < p.length; w++) this.models.splice(c + w, 0, p[w]);else {
              y && (this.models.length = 0);
              for (var S = y || p, w = 0; w < S.length; w++) this.models.push(S[w]);
            }
            if (u && this.sort({
              silent: !0
            }), !e.silent) {
              for (var x = null != c ? n.clone(e) : e, w = 0; w < p.length; w++) null != c && (x.index = c + w), (o = p[w]).trigger("add", o, this, x);
              (u || b) && this.trigger("sort", this, e), (p.length || d.length) && this.trigger("update", this, e);
            }
            return r ? t[0] : t;
          },
          reset: function reset(t, e) {
            e = e ? n.clone(e) : {};
            for (var r = 0; r < this.models.length; r++) this._removeReference(this.models[r], e);
            return e.previousModels = this.models, this._reset(), t = this.add(t, n.extend({
              silent: !0
            }, e)), e.silent || this.trigger("reset", this, e), t;
          },
          push: function push(t, e) {
            return this.add(t, n.extend({
              at: this.length
            }, e));
          },
          pop: function pop(t) {
            var e = this.at(this.length - 1);
            return this.remove(e, t);
          },
          unshift: function unshift(t, e) {
            return this.add(t, n.extend({
              at: 0
            }, e));
          },
          shift: function shift(t) {
            var e = this.at(0);
            return this.remove(e, t);
          },
          slice: function slice() {
            return o.apply(this.models, arguments);
          },
          get: function get(t) {
            if (null != t) {
              var e = this.modelId(this._isModel(t) ? t.attributes : t);
              return this._byId[t] || this._byId[e] || this._byId[t.cid];
            }
          },
          at: function at(t) {
            return t < 0 && (t += this.length), this.models[t];
          },
          where: function where(t, e) {
            var r = n.matches(t);
            return this[e ? "find" : "filter"](function (t) {
              return r(t.attributes);
            });
          },
          findWhere: function findWhere(t) {
            return this.where(t, !0);
          },
          sort: function sort(t) {
            if (!this.comparator) throw new Error("Cannot sort a set without a comparator");
            return t || (t = {}), n.isString(this.comparator) || 1 === this.comparator.length ? this.models = this.sortBy(this.comparator, this) : this.models.sort(n.bind(this.comparator, this)), t.silent || this.trigger("sort", this, t), this;
          },
          pluck: function pluck(t) {
            return n.invoke(this.models, "get", t);
          },
          fetch: function fetch(t) {
            t = n.extend({
              parse: !0
            }, t);
            var e = t.success,
              r = this;
            return t.success = function (n) {
              var i = t.reset ? "reset" : "set";
              r[i](n, t), e && e.call(t.context, r, n, t), r.trigger("sync", r, n, t);
            }, D(this, t), this.sync("read", this, t);
          },
          create: function create(t, e) {
            e = e ? n.clone(e) : {};
            var r = e.wait;
            if (!(t = this._prepareModel(t, e))) return !1;
            r || this.add(t, e);
            var i = this,
              o = e.success;
            return e.success = function (t, e, n) {
              r && i.add(t, n), o && o.call(n.context, t, e, n);
            }, t.save(null, e), t;
          },
          parse: function parse(t, e) {
            return t;
          },
          clone: function clone() {
            return new this.constructor(this.models, {
              model: this.model,
              comparator: this.comparator
            });
          },
          modelId: function modelId(t) {
            return t[this.model.prototype.idAttribute || "id"];
          },
          _reset: function _reset() {
            this.length = 0, this.models = [], this._byId = {};
          },
          _prepareModel: function _prepareModel(t, e) {
            if (this._isModel(t)) return t.collection || (t.collection = this), t;
            e = e ? n.clone(e) : {}, e.collection = this;
            var r = new this.model(t, e);
            return r.validationError ? (this.trigger("invalid", this, r.validationError, e), !1) : r;
          },
          _removeModels: function _removeModels(t, e) {
            for (var n = [], r = 0; r < t.length; r++) {
              var i = this.get(t[r]);
              if (i) {
                var o = this.indexOf(i);
                this.models.splice(o, 1), this.length--, e.silent || (e.index = o, i.trigger("remove", i, this, e)), n.push(i), this._removeReference(i, e);
              }
            }
            return !!n.length && n;
          },
          _isModel: function _isModel(t) {
            return t instanceof v;
          },
          _addReference: function _addReference(t, e) {
            this._byId[t.cid] = t;
            var n = this.modelId(t.attributes);
            null != n && (this._byId[n] = t), t.on("all", this._onModelEvent, this);
          },
          _removeReference: function _removeReference(t, e) {
            delete this._byId[t.cid];
            var n = this.modelId(t.attributes);
            null != n && delete this._byId[n], this === t.collection && delete t.collection, t.off("all", this._onModelEvent, this);
          },
          _onModelEvent: function _onModelEvent(t, e, n, r) {
            if ("add" !== t && "remove" !== t || n === this) {
              if ("destroy" === t && this.remove(e, r), "change" === t) {
                var i = this.modelId(e.previousAttributes()),
                  o = this.modelId(e.attributes);
                i !== o && (null != i && delete this._byId[i], null != o && (this._byId[o] = e));
              }
              this.trigger.apply(this, arguments);
            }
          }
        }), s(y, {
          forEach: 3,
          each: 3,
          map: 3,
          collect: 3,
          reduce: 4,
          foldl: 4,
          inject: 4,
          reduceRight: 4,
          foldr: 4,
          find: 3,
          detect: 3,
          filter: 3,
          select: 3,
          reject: 3,
          every: 3,
          all: 3,
          some: 3,
          any: 3,
          include: 2,
          contains: 2,
          invoke: 0,
          max: 3,
          min: 3,
          toArray: 1,
          size: 1,
          first: 3,
          head: 3,
          take: 3,
          initial: 3,
          rest: 3,
          tail: 3,
          drop: 3,
          last: 3,
          without: 0,
          difference: 0,
          indexOf: 3,
          shuffle: 1,
          lastIndexOf: 3,
          isEmpty: 1,
          chain: 1,
          sample: 3,
          partition: 3
        }, "models");
        var w = ["groupBy", "countBy", "sortBy", "indexBy"];
        n.each(w, function (t) {
          n[t] && (y.prototype[t] = function (e, r) {
            var i = n.isFunction(e) ? e : function (t) {
              return t.get(e);
            };
            return n[t](this.models, i, r);
          });
        });
        var S = e.View = function (t) {
            this.cid = n.uniqueId("view"), n.extend(this, n.pick(t, E)), this._ensureElement(), this.initialize.apply(this, arguments);
          },
          x = /^(\S+)\s*(.*)$/,
          E = ["model", "collection", "el", "id", "attributes", "className", "tagName", "events"];
        n.extend(S.prototype, u, {
          tagName: "div",
          $: function $(t) {
            return this.$el.find(t);
          },
          initialize: function initialize() {},
          render: function render() {
            return this;
          },
          remove: function remove() {
            return this._removeElement(), this.stopListening(), this;
          },
          _removeElement: function _removeElement() {
            this.$el.remove();
          },
          setElement: function setElement(t) {
            return this.undelegateEvents(), this._setElement(t), this.delegateEvents(), this;
          },
          _setElement: function _setElement(t) {
            this.$el = t instanceof e.$ ? t : e.$(t), this.el = this.$el[0];
          },
          delegateEvents: function delegateEvents(t) {
            if (t || (t = n.result(this, "events")), !t) return this;
            this.undelegateEvents();
            for (var e in t) {
              var r = t[e];
              if (n.isFunction(r) || (r = this[r]), r) {
                var i = e.match(x);
                this.delegate(i[1], i[2], n.bind(r, this));
              }
            }
            return this;
          },
          delegate: function delegate(t, e, n) {
            return this.$el.on(t + ".delegateEvents" + this.cid, e, n), this;
          },
          undelegateEvents: function undelegateEvents() {
            return this.$el && this.$el.off(".delegateEvents" + this.cid), this;
          },
          undelegate: function undelegate(t, e, n) {
            return this.$el.off(t + ".delegateEvents" + this.cid, e, n), this;
          },
          _createElement: function _createElement(t) {
            return document.createElement(t);
          },
          _ensureElement: function _ensureElement() {
            if (this.el) this.setElement(n.result(this, "el"));else {
              var t = n.extend({}, n.result(this, "attributes"));
              this.id && (t.id = n.result(this, "id")), this.className && (t.class = n.result(this, "className")), this.setElement(this._createElement(n.result(this, "tagName"))), this._setAttributes(t);
            }
          },
          _setAttributes: function _setAttributes(t) {
            this.$el.attr(t);
          }
        }), e.sync = function (t, r, i) {
          var o = T[t];
          n.defaults(i || (i = {}), {
            emulateHTTP: e.emulateHTTP,
            emulateJSON: e.emulateJSON
          });
          var a = {
            type: o,
            dataType: "json"
          };
          if (i.url || (a.url = n.result(r, "url") || F()), null != i.data || !r || "create" !== t && "update" !== t && "patch" !== t || (a.contentType = "application/json", a.data = JSON.stringify(i.attrs || r.toJSON(i))), i.emulateJSON && (a.contentType = "application/x-www-form-urlencoded", a.data = a.data ? {
            model: a.data
          } : {}), i.emulateHTTP && ("PUT" === o || "DELETE" === o || "PATCH" === o)) {
            a.type = "POST", i.emulateJSON && (a.data._method = o);
            var s = i.beforeSend;
            i.beforeSend = function (t) {
              if (t.setRequestHeader("X-HTTP-Method-Override", o), s) return s.apply(this, arguments);
            };
          }
          "GET" === a.type || i.emulateJSON || (a.processData = !1);
          var u = i.error;
          i.error = function (t, e, n) {
            i.textStatus = e, i.errorThrown = n, u && u.call(i.context, t, e, n);
          };
          var c = i.xhr = e.ajax(n.extend(a, i));
          return r.trigger("request", r, c, i), c;
        };
        var T = {
          create: "POST",
          update: "PUT",
          patch: "PATCH",
          delete: "DELETE",
          read: "GET"
        };
        e.ajax = function () {
          return e.$.ajax.apply(e.$, arguments);
        };
        var k = e.Router = function (t) {
            t || (t = {}), t.routes && (this.routes = t.routes), this._bindRoutes(), this.initialize.apply(this, arguments);
          },
          A = /\((.*?)\)/g,
          O = /(\(\?)?:\w+/g,
          C = /\*\w+/g,
          I = /[\-{}\[\]+?.,\\\^$|#\s]/g;
        n.extend(k.prototype, u, {
          initialize: function initialize() {},
          route: function route(t, r, i) {
            n.isRegExp(t) || (t = this._routeToRegExp(t)), n.isFunction(r) && (i = r, r = ""), i || (i = this[r]);
            var o = this;
            return e.history.route(t, function (n) {
              var a = o._extractParameters(t, n);
              !1 !== o.execute(i, a, r) && (o.trigger.apply(o, ["route:" + r].concat(a)), o.trigger("route", r, a), e.history.trigger("route", o, r, a));
            }), this;
          },
          execute: function execute(t, e, n) {
            t && t.apply(this, e);
          },
          navigate: function navigate(t, n) {
            return e.history.navigate(t, n), this;
          },
          _bindRoutes: function _bindRoutes() {
            if (this.routes) {
              this.routes = n.result(this, "routes");
              for (var t, e = n.keys(this.routes); null != (t = e.pop());) this.route(t, this.routes[t]);
            }
          },
          _routeToRegExp: function _routeToRegExp(t) {
            return t = t.replace(I, "\\$&").replace(A, "(?:$1)?").replace(O, function (t, e) {
              return e ? t : "([^/?]+)";
            }).replace(C, "([^?]*?)"), new RegExp("^" + t + "(?:\\?([\\s\\S]*))?$");
          },
          _extractParameters: function _extractParameters(t, e) {
            var r = t.exec(e).slice(1);
            return n.map(r, function (t, e) {
              return e === r.length - 1 ? t || null : t ? decodeURIComponent(t) : null;
            });
          }
        });
        var R = e.History = function () {
            this.handlers = [], n.bindAll(this, "checkUrl"), "undefined" != typeof window && (this.location = window.location, this.history = window.history);
          },
          P = /^[#\/]|\s+$/g,
          N = /^\/+|\/+$/g,
          M = /#.*$/;
        R.started = !1, n.extend(R.prototype, u, {
          interval: 50,
          atRoot: function atRoot() {
            return this.location.pathname.replace(/[^\/]$/, "$&/") === this.root && !this.getSearch();
          },
          matchRoot: function matchRoot() {
            return this.decodeFragment(this.location.pathname).slice(0, this.root.length - 1) + "/" === this.root;
          },
          decodeFragment: function decodeFragment(t) {
            return decodeURI(t.replace(/%25/g, "%2525"));
          },
          getSearch: function getSearch() {
            var t = this.location.href.replace(/#.*/, "").match(/\?.+/);
            return t ? t[0] : "";
          },
          getHash: function getHash(t) {
            var e = (t || this).location.href.match(/#(.*)$/);
            return e ? e[1] : "";
          },
          getPath: function getPath() {
            var t = this.decodeFragment(this.location.pathname + this.getSearch()).slice(this.root.length - 1);
            return "/" === t.charAt(0) ? t.slice(1) : t;
          },
          getFragment: function getFragment(t) {
            return null == t && (t = this._usePushState || !this._wantsHashChange ? this.getPath() : this.getHash()), t.replace(P, "");
          },
          start: function start(t) {
            if (R.started) throw new Error("Backbone.history has already been started");
            if (R.started = !0, this.options = n.extend({
              root: "/"
            }, this.options, t), this.root = this.options.root, this._wantsHashChange = !1 !== this.options.hashChange, this._hasHashChange = "onhashchange" in window, this._useHashChange = this._wantsHashChange && this._hasHashChange, this._wantsPushState = !!this.options.pushState, this._hasPushState = !(!this.history || !this.history.pushState), this._usePushState = this._wantsPushState && this._hasPushState, this.fragment = this.getFragment(), this.root = ("/" + this.root + "/").replace(N, "/"), this._wantsHashChange && this._wantsPushState) {
              if (!this._hasPushState && !this.atRoot()) {
                var e = this.root.slice(0, -1) || "/";
                return this.location.replace(e + "#" + this.getPath()), !0;
              }
              this._hasPushState && this.atRoot() && this.navigate(this.getHash(), {
                replace: !0
              });
            }
            if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
              this.iframe = document.createElement("iframe"), this.iframe.src = "javascript:0", this.iframe.style.display = "none", this.iframe.tabIndex = -1;
              var r = document.body,
                i = r.insertBefore(this.iframe, r.firstChild).contentWindow;
              i.document.open(), i.document.close(), i.location.hash = "#" + this.fragment;
            }
            var o = window.addEventListener || function (t, e) {
              return attachEvent("on" + t, e);
            };
            if (this._usePushState ? o("popstate", this.checkUrl, !1) : this._useHashChange && !this.iframe ? o("hashchange", this.checkUrl, !1) : this._wantsHashChange && (this._checkUrlInterval = setInterval(this.checkUrl, this.interval)), !this.options.silent) return this.loadUrl();
          },
          stop: function stop() {
            var t = window.removeEventListener || function (t, e) {
              return detachEvent("on" + t, e);
            };
            this._usePushState ? t("popstate", this.checkUrl, !1) : this._useHashChange && !this.iframe && t("hashchange", this.checkUrl, !1), this.iframe && (document.body.removeChild(this.iframe), this.iframe = null), this._checkUrlInterval && clearInterval(this._checkUrlInterval), R.started = !1;
          },
          route: function route(t, e) {
            this.handlers.unshift({
              route: t,
              callback: e
            });
          },
          checkUrl: function checkUrl(t) {
            var e = this.getFragment();
            if (e === this.fragment && this.iframe && (e = this.getHash(this.iframe.contentWindow)), e === this.fragment) return !1;
            this.iframe && this.navigate(e), this.loadUrl();
          },
          loadUrl: function loadUrl(t) {
            return !!this.matchRoot() && (t = this.fragment = this.getFragment(t), n.any(this.handlers, function (e) {
              if (e.route.test(t)) return e.callback(t), !0;
            }));
          },
          navigate: function navigate(t, e) {
            if (!R.started) return !1;
            e && !0 !== e || (e = {
              trigger: !!e
            }), t = this.getFragment(t || "");
            var n = this.root;
            "" !== t && "?" !== t.charAt(0) || (n = n.slice(0, -1) || "/");
            var r = n + t;
            if (t = this.decodeFragment(t.replace(M, "")), this.fragment !== t) {
              if (this.fragment = t, this._usePushState) this.history[e.replace ? "replaceState" : "pushState"]({}, document.title, r);else {
                if (!this._wantsHashChange) return this.location.assign(r);
                if (this._updateHash(this.location, t, e.replace), this.iframe && t !== this.getHash(this.iframe.contentWindow)) {
                  var i = this.iframe.contentWindow;
                  e.replace || (i.document.open(), i.document.close()), this._updateHash(i.location, t, e.replace);
                }
              }
              return e.trigger ? this.loadUrl(t) : void 0;
            }
          },
          _updateHash: function _updateHash(t, e, n) {
            if (n) {
              var r = t.href.replace(/(javascript:|#).*$/, "");
              t.replace(r + "#" + e);
            } else t.hash = "#" + e;
          }
        }), e.history = new R();
        var L = function L(t, e) {
          var r,
            i = this;
          r = t && n.has(t, "constructor") ? t.constructor : function () {
            return i.apply(this, arguments);
          }, n.extend(r, i, e);
          var o = function o() {
            this.constructor = r;
          };
          return o.prototype = i.prototype, r.prototype = new o(), t && n.extend(r.prototype, t), r.__super__ = i.prototype, r;
        };
        v.extend = y.extend = k.extend = S.extend = R.extend = L;
        var F = function F() {
            throw new Error('A "url" property or function must be specified');
          },
          D = function D(t, e) {
            var n = e.error;
            e.error = function (r) {
              n && n.call(e.context, t, r, e), t.trigger("error", t, r, e);
            };
          };
        return e;
      });
    }).call(e, n(100));
  }, function (t, e, n) {
    (function (t, n) {
      var r, i;
      //     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
      //     Underscore may be freely distributed under the MIT license.
      !function () {
        var o = "object" == typeof self && self.self === self && self || "object" == typeof t && t.global === t && t || this || {},
          a = o._,
          s = Array.prototype,
          u = Object.prototype,
          c = "undefined" != typeof Symbol ? Symbol.prototype : null,
          l = s.push,
          f = s.slice,
          p = u.toString,
          d = u.hasOwnProperty,
          h = Array.isArray,
          m = Object.keys,
          g = Object.create,
          v = function v() {},
          y = function y(t) {
            return t instanceof y ? t : this instanceof y ? void (this._wrapped = t) : new y(t);
          };
        void 0 === e || e.nodeType ? o._ = y : (void 0 !== n && !n.nodeType && n.exports && (e = n.exports = y), e._ = y), y.VERSION = "1.9.1";
        var _,
          b = function b(t, e, n) {
            if (void 0 === e) return t;
            switch (null == n ? 3 : n) {
              case 1:
                return function (n) {
                  return t.call(e, n);
                };
              case 3:
                return function (n, r, i) {
                  return t.call(e, n, r, i);
                };
              case 4:
                return function (n, r, i, o) {
                  return t.call(e, n, r, i, o);
                };
            }
            return function () {
              return t.apply(e, arguments);
            };
          },
          w = function w(t, e, n) {
            return y.iteratee !== _ ? y.iteratee(t, e) : null == t ? y.identity : y.isFunction(t) ? b(t, e, n) : y.isObject(t) && !y.isArray(t) ? y.matcher(t) : y.property(t);
          };
        y.iteratee = _ = function _(t, e) {
          return w(t, e, 1 / 0);
        };
        var S = function S(t, e) {
            return e = null == e ? t.length - 1 : +e, function () {
              for (var n = Math.max(arguments.length - e, 0), r = Array(n), i = 0; i < n; i++) r[i] = arguments[i + e];
              switch (e) {
                case 0:
                  return t.call(this, r);
                case 1:
                  return t.call(this, arguments[0], r);
                case 2:
                  return t.call(this, arguments[0], arguments[1], r);
              }
              var o = Array(e + 1);
              for (i = 0; i < e; i++) o[i] = arguments[i];
              return o[e] = r, t.apply(this, o);
            };
          },
          x = function x(t) {
            if (!y.isObject(t)) return {};
            if (g) return g(t);
            v.prototype = t;
            var e = new v();
            return v.prototype = null, e;
          },
          E = function E(t) {
            return function (e) {
              return null == e ? void 0 : e[t];
            };
          },
          T = function T(t, e) {
            return null != t && d.call(t, e);
          },
          k = function k(t, e) {
            for (var n = e.length, r = 0; r < n; r++) {
              if (null == t) return;
              t = t[e[r]];
            }
            return n ? t : void 0;
          },
          A = Math.pow(2, 53) - 1,
          O = E("length"),
          C = function C(t) {
            var e = O(t);
            return "number" == typeof e && e >= 0 && e <= A;
          };
        y.each = y.forEach = function (t, e, n) {
          e = b(e, n);
          var r, i;
          if (C(t)) for (r = 0, i = t.length; r < i; r++) e(t[r], r, t);else {
            var o = y.keys(t);
            for (r = 0, i = o.length; r < i; r++) e(t[o[r]], o[r], t);
          }
          return t;
        }, y.map = y.collect = function (t, e, n) {
          e = w(e, n);
          for (var r = !C(t) && y.keys(t), i = (r || t).length, o = Array(i), a = 0; a < i; a++) {
            var s = r ? r[a] : a;
            o[a] = e(t[s], s, t);
          }
          return o;
        };
        var I = function I(t) {
          var e = function e(_e7, n, r, i) {
            var o = !C(_e7) && y.keys(_e7),
              a = (o || _e7).length,
              s = t > 0 ? 0 : a - 1;
            for (i || (r = _e7[o ? o[s] : s], s += t); s >= 0 && s < a; s += t) {
              var u = o ? o[s] : s;
              r = n(r, _e7[u], u, _e7);
            }
            return r;
          };
          return function (t, n, r, i) {
            var o = arguments.length >= 3;
            return e(t, b(n, i, 4), r, o);
          };
        };
        y.reduce = y.foldl = y.inject = I(1), y.reduceRight = y.foldr = I(-1), y.find = y.detect = function (t, e, n) {
          var r = C(t) ? y.findIndex : y.findKey,
            i = r(t, e, n);
          if (void 0 !== i && -1 !== i) return t[i];
        }, y.filter = y.select = function (t, e, n) {
          var r = [];
          return e = w(e, n), y.each(t, function (t, n, i) {
            e(t, n, i) && r.push(t);
          }), r;
        }, y.reject = function (t, e, n) {
          return y.filter(t, y.negate(w(e)), n);
        }, y.every = y.all = function (t, e, n) {
          e = w(e, n);
          for (var r = !C(t) && y.keys(t), i = (r || t).length, o = 0; o < i; o++) {
            var a = r ? r[o] : o;
            if (!e(t[a], a, t)) return !1;
          }
          return !0;
        }, y.some = y.any = function (t, e, n) {
          e = w(e, n);
          for (var r = !C(t) && y.keys(t), i = (r || t).length, o = 0; o < i; o++) {
            var a = r ? r[o] : o;
            if (e(t[a], a, t)) return !0;
          }
          return !1;
        }, y.contains = y.includes = y.include = function (t, e, n, r) {
          return C(t) || (t = y.values(t)), ("number" != typeof n || r) && (n = 0), y.indexOf(t, e, n) >= 0;
        }, y.invoke = S(function (t, e, n) {
          var r, i;
          return y.isFunction(e) ? i = e : y.isArray(e) && (r = e.slice(0, -1), e = e[e.length - 1]), y.map(t, function (t) {
            var o = i;
            if (!o) {
              if (r && r.length && (t = k(t, r)), null == t) return;
              o = t[e];
            }
            return null == o ? o : o.apply(t, n);
          });
        }), y.pluck = function (t, e) {
          return y.map(t, y.property(e));
        }, y.where = function (t, e) {
          return y.filter(t, y.matcher(e));
        }, y.findWhere = function (t, e) {
          return y.find(t, y.matcher(e));
        }, y.max = function (t, e, n) {
          var r,
            i,
            o = -1 / 0,
            a = -1 / 0;
          if (null == e || "number" == typeof e && "object" != typeof t[0] && null != t) {
            t = C(t) ? t : y.values(t);
            for (var s = 0, u = t.length; s < u; s++) null != (r = t[s]) && r > o && (o = r);
          } else e = w(e, n), y.each(t, function (t, n, r) {
            ((i = e(t, n, r)) > a || i === -1 / 0 && o === -1 / 0) && (o = t, a = i);
          });
          return o;
        }, y.min = function (t, e, n) {
          var r,
            i,
            o = 1 / 0,
            a = 1 / 0;
          if (null == e || "number" == typeof e && "object" != typeof t[0] && null != t) {
            t = C(t) ? t : y.values(t);
            for (var s = 0, u = t.length; s < u; s++) null != (r = t[s]) && r < o && (o = r);
          } else e = w(e, n), y.each(t, function (t, n, r) {
            ((i = e(t, n, r)) < a || i === 1 / 0 && o === 1 / 0) && (o = t, a = i);
          });
          return o;
        }, y.shuffle = function (t) {
          return y.sample(t, 1 / 0);
        }, y.sample = function (t, e, n) {
          if (null == e || n) return C(t) || (t = y.values(t)), t[y.random(t.length - 1)];
          var r = C(t) ? y.clone(t) : y.values(t),
            i = O(r);
          e = Math.max(Math.min(e, i), 0);
          for (var o = i - 1, a = 0; a < e; a++) {
            var s = y.random(a, o),
              u = r[a];
            r[a] = r[s], r[s] = u;
          }
          return r.slice(0, e);
        }, y.sortBy = function (t, e, n) {
          var r = 0;
          return e = w(e, n), y.pluck(y.map(t, function (t, n, i) {
            return {
              value: t,
              index: r++,
              criteria: e(t, n, i)
            };
          }).sort(function (t, e) {
            var n = t.criteria,
              r = e.criteria;
            if (n !== r) {
              if (n > r || void 0 === n) return 1;
              if (n < r || void 0 === r) return -1;
            }
            return t.index - e.index;
          }), "value");
        };
        var R = function R(t, e) {
          return function (n, r, i) {
            var o = e ? [[], []] : {};
            return r = w(r, i), y.each(n, function (e, i) {
              var a = r(e, i, n);
              t(o, e, a);
            }), o;
          };
        };
        y.groupBy = R(function (t, e, n) {
          T(t, n) ? t[n].push(e) : t[n] = [e];
        }), y.indexBy = R(function (t, e, n) {
          t[n] = e;
        }), y.countBy = R(function (t, e, n) {
          T(t, n) ? t[n]++ : t[n] = 1;
        });
        var P = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
        y.toArray = function (t) {
          return t ? y.isArray(t) ? f.call(t) : y.isString(t) ? t.match(P) : C(t) ? y.map(t, y.identity) : y.values(t) : [];
        }, y.size = function (t) {
          return null == t ? 0 : C(t) ? t.length : y.keys(t).length;
        }, y.partition = R(function (t, e, n) {
          t[n ? 0 : 1].push(e);
        }, !0), y.first = y.head = y.take = function (t, e, n) {
          return null == t || t.length < 1 ? null == e ? void 0 : [] : null == e || n ? t[0] : y.initial(t, t.length - e);
        }, y.initial = function (t, e, n) {
          return f.call(t, 0, Math.max(0, t.length - (null == e || n ? 1 : e)));
        }, y.last = function (t, e, n) {
          return null == t || t.length < 1 ? null == e ? void 0 : [] : null == e || n ? t[t.length - 1] : y.rest(t, Math.max(0, t.length - e));
        }, y.rest = y.tail = y.drop = function (t, e, n) {
          return f.call(t, null == e || n ? 1 : e);
        }, y.compact = function (t) {
          return y.filter(t, Boolean);
        };
        var N = function N(t, e, n, r) {
          r = r || [];
          for (var i = r.length, o = 0, a = O(t); o < a; o++) {
            var s = t[o];
            if (C(s) && (y.isArray(s) || y.isArguments(s))) {
              if (e) for (var u = 0, c = s.length; u < c;) r[i++] = s[u++];else N(s, e, n, r), i = r.length;
            } else n || (r[i++] = s);
          }
          return r;
        };
        y.flatten = function (t, e) {
          return N(t, e, !1);
        }, y.without = S(function (t, e) {
          return y.difference(t, e);
        }), y.uniq = y.unique = function (t, e, n, r) {
          y.isBoolean(e) || (r = n, n = e, e = !1), null != n && (n = w(n, r));
          for (var i = [], o = [], a = 0, s = O(t); a < s; a++) {
            var u = t[a],
              c = n ? n(u, a, t) : u;
            e && !n ? (a && o === c || i.push(u), o = c) : n ? y.contains(o, c) || (o.push(c), i.push(u)) : y.contains(i, u) || i.push(u);
          }
          return i;
        }, y.union = S(function (t) {
          return y.uniq(N(t, !0, !0));
        }), y.intersection = function (t) {
          for (var e = [], n = arguments.length, r = 0, i = O(t); r < i; r++) {
            var o = t[r];
            if (!y.contains(e, o)) {
              var a;
              for (a = 1; a < n && y.contains(arguments[a], o); a++);
              a === n && e.push(o);
            }
          }
          return e;
        }, y.difference = S(function (t, e) {
          return e = N(e, !0, !0), y.filter(t, function (t) {
            return !y.contains(e, t);
          });
        }), y.unzip = function (t) {
          for (var e = t && y.max(t, O).length || 0, n = Array(e), r = 0; r < e; r++) n[r] = y.pluck(t, r);
          return n;
        }, y.zip = S(y.unzip), y.object = function (t, e) {
          for (var n = {}, r = 0, i = O(t); r < i; r++) e ? n[t[r]] = e[r] : n[t[r][0]] = t[r][1];
          return n;
        };
        var M = function M(t) {
          return function (e, n, r) {
            n = w(n, r);
            for (var i = O(e), o = t > 0 ? 0 : i - 1; o >= 0 && o < i; o += t) if (n(e[o], o, e)) return o;
            return -1;
          };
        };
        y.findIndex = M(1), y.findLastIndex = M(-1), y.sortedIndex = function (t, e, n, r) {
          n = w(n, r, 1);
          for (var i = n(e), o = 0, a = O(t); o < a;) {
            var s = Math.floor((o + a) / 2);
            n(t[s]) < i ? o = s + 1 : a = s;
          }
          return o;
        };
        var L = function L(t, e, n) {
          return function (r, i, o) {
            var a = 0,
              s = O(r);
            if ("number" == typeof o) t > 0 ? a = o >= 0 ? o : Math.max(o + s, a) : s = o >= 0 ? Math.min(o + 1, s) : o + s + 1;else if (n && o && s) return o = n(r, i), r[o] === i ? o : -1;
            if (i !== i) return o = e(f.call(r, a, s), y.isNaN), o >= 0 ? o + a : -1;
            for (o = t > 0 ? a : s - 1; o >= 0 && o < s; o += t) if (r[o] === i) return o;
            return -1;
          };
        };
        y.indexOf = L(1, y.findIndex, y.sortedIndex), y.lastIndexOf = L(-1, y.findLastIndex), y.range = function (t, e, n) {
          null == e && (e = t || 0, t = 0), n || (n = e < t ? -1 : 1);
          for (var r = Math.max(Math.ceil((e - t) / n), 0), i = Array(r), o = 0; o < r; o++, t += n) i[o] = t;
          return i;
        }, y.chunk = function (t, e) {
          if (null == e || e < 1) return [];
          for (var n = [], r = 0, i = t.length; r < i;) n.push(f.call(t, r, r += e));
          return n;
        };
        var F = function F(t, e, n, r, i) {
          if (!(r instanceof e)) return t.apply(n, i);
          var o = x(t.prototype),
            a = t.apply(o, i);
          return y.isObject(a) ? a : o;
        };
        y.bind = S(function (t, e, n) {
          if (!y.isFunction(t)) throw new TypeError("Bind must be called on a function");
          var r = S(function (i) {
            return F(t, r, e, this, n.concat(i));
          });
          return r;
        }), y.partial = S(function (t, e) {
          var n = y.partial.placeholder,
            r = function r() {
              for (var i = 0, o = e.length, a = Array(o), s = 0; s < o; s++) a[s] = e[s] === n ? arguments[i++] : e[s];
              for (; i < arguments.length;) a.push(arguments[i++]);
              return F(t, r, this, this, a);
            };
          return r;
        }), y.partial.placeholder = y, y.bindAll = S(function (t, e) {
          e = N(e, !1, !1);
          var n = e.length;
          if (n < 1) throw new Error("bindAll must be passed function names");
          for (; n--;) {
            var r = e[n];
            t[r] = y.bind(t[r], t);
          }
        }), y.memoize = function (t, e) {
          var n = function n(r) {
            var i = n.cache,
              o = "" + (e ? e.apply(this, arguments) : r);
            return T(i, o) || (i[o] = t.apply(this, arguments)), i[o];
          };
          return n.cache = {}, n;
        }, y.delay = S(function (t, e, n) {
          return setTimeout(function () {
            return t.apply(null, n);
          }, e);
        }), y.defer = y.partial(y.delay, y, 1), y.throttle = function (t, e, n) {
          var r,
            i,
            o,
            a,
            s = 0;
          n || (n = {});
          var u = function u() {
              s = !1 === n.leading ? 0 : y.now(), r = null, a = t.apply(i, o), r || (i = o = null);
            },
            c = function c() {
              var c = y.now();
              s || !1 !== n.leading || (s = c);
              var l = e - (c - s);
              return i = this, o = arguments, l <= 0 || l > e ? (r && (clearTimeout(r), r = null), s = c, a = t.apply(i, o), r || (i = o = null)) : r || !1 === n.trailing || (r = setTimeout(u, l)), a;
            };
          return c.cancel = function () {
            clearTimeout(r), s = 0, r = i = o = null;
          }, c;
        }, y.debounce = function (t, e, n) {
          var r,
            i,
            o = function o(e, n) {
              r = null, n && (i = t.apply(e, n));
            },
            a = S(function (a) {
              if (r && clearTimeout(r), n) {
                var s = !r;
                r = setTimeout(o, e), s && (i = t.apply(this, a));
              } else r = y.delay(o, e, this, a);
              return i;
            });
          return a.cancel = function () {
            clearTimeout(r), r = null;
          }, a;
        }, y.wrap = function (t, e) {
          return y.partial(e, t);
        }, y.negate = function (t) {
          return function () {
            return !t.apply(this, arguments);
          };
        }, y.compose = function () {
          var t = arguments,
            e = t.length - 1;
          return function () {
            for (var n = e, r = t[e].apply(this, arguments); n--;) r = t[n].call(this, r);
            return r;
          };
        }, y.after = function (t, e) {
          return function () {
            if (--t < 1) return e.apply(this, arguments);
          };
        }, y.before = function (t, e) {
          var n;
          return function () {
            return --t > 0 && (n = e.apply(this, arguments)), t <= 1 && (e = null), n;
          };
        }, y.once = y.partial(y.before, 2), y.restArguments = S;
        var D = !{
            toString: null
          }.propertyIsEnumerable("toString"),
          j = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
          U = function U(t, e) {
            var n = j.length,
              r = t.constructor,
              i = y.isFunction(r) && r.prototype || u,
              o = "constructor";
            for (T(t, o) && !y.contains(e, o) && e.push(o); n--;) (o = j[n]) in t && t[o] !== i[o] && !y.contains(e, o) && e.push(o);
          };
        y.keys = function (t) {
          if (!y.isObject(t)) return [];
          if (m) return m(t);
          var e = [];
          for (var n in t) T(t, n) && e.push(n);
          return D && U(t, e), e;
        }, y.allKeys = function (t) {
          if (!y.isObject(t)) return [];
          var e = [];
          for (var n in t) e.push(n);
          return D && U(t, e), e;
        }, y.values = function (t) {
          for (var e = y.keys(t), n = e.length, r = Array(n), i = 0; i < n; i++) r[i] = t[e[i]];
          return r;
        }, y.mapObject = function (t, e, n) {
          e = w(e, n);
          for (var r = y.keys(t), i = r.length, o = {}, a = 0; a < i; a++) {
            var s = r[a];
            o[s] = e(t[s], s, t);
          }
          return o;
        }, y.pairs = function (t) {
          for (var e = y.keys(t), n = e.length, r = Array(n), i = 0; i < n; i++) r[i] = [e[i], t[e[i]]];
          return r;
        }, y.invert = function (t) {
          for (var e = {}, n = y.keys(t), r = 0, i = n.length; r < i; r++) e[t[n[r]]] = n[r];
          return e;
        }, y.functions = y.methods = function (t) {
          var e = [];
          for (var n in t) y.isFunction(t[n]) && e.push(n);
          return e.sort();
        };
        var B = function B(t, e) {
          return function (n) {
            var r = arguments.length;
            if (e && (n = Object(n)), r < 2 || null == n) return n;
            for (var i = 1; i < r; i++) for (var o = arguments[i], a = t(o), s = a.length, u = 0; u < s; u++) {
              var c = a[u];
              e && void 0 !== n[c] || (n[c] = o[c]);
            }
            return n;
          };
        };
        y.extend = B(y.allKeys), y.extendOwn = y.assign = B(y.keys), y.findKey = function (t, e, n) {
          e = w(e, n);
          for (var r, i = y.keys(t), o = 0, a = i.length; o < a; o++) if (r = i[o], e(t[r], r, t)) return r;
        };
        var V = function V(t, e, n) {
          return e in n;
        };
        y.pick = S(function (t, e) {
          var n = {},
            r = e[0];
          if (null == t) return n;
          y.isFunction(r) ? (e.length > 1 && (r = b(r, e[1])), e = y.allKeys(t)) : (r = V, e = N(e, !1, !1), t = Object(t));
          for (var i = 0, o = e.length; i < o; i++) {
            var a = e[i],
              s = t[a];
            r(s, a, t) && (n[a] = s);
          }
          return n;
        }), y.omit = S(function (t, e) {
          var n,
            r = e[0];
          return y.isFunction(r) ? (r = y.negate(r), e.length > 1 && (n = e[1])) : (e = y.map(N(e, !1, !1), String), r = function r(t, n) {
            return !y.contains(e, n);
          }), y.pick(t, r, n);
        }), y.defaults = B(y.allKeys, !0), y.create = function (t, e) {
          var n = x(t);
          return e && y.extendOwn(n, e), n;
        }, y.clone = function (t) {
          return y.isObject(t) ? y.isArray(t) ? t.slice() : y.extend({}, t) : t;
        }, y.tap = function (t, e) {
          return e(t), t;
        }, y.isMatch = function (t, e) {
          var n = y.keys(e),
            r = n.length;
          if (null == t) return !r;
          for (var i = Object(t), o = 0; o < r; o++) {
            var a = n[o];
            if (e[a] !== i[a] || !(a in i)) return !1;
          }
          return !0;
        };
        var q, H;
        q = function q(t, e, n, r) {
          if (t === e) return 0 !== t || 1 / t == 1 / e;
          if (null == t || null == e) return !1;
          if (t !== t) return e !== e;
          var i = typeof t;
          return ("function" === i || "object" === i || "object" == typeof e) && H(t, e, n, r);
        }, H = function H(t, e, n, r) {
          t instanceof y && (t = t._wrapped), e instanceof y && (e = e._wrapped);
          var i = p.call(t);
          if (i !== p.call(e)) return !1;
          switch (i) {
            case "[object RegExp]":
            case "[object String]":
              return "" + t == "" + e;
            case "[object Number]":
              return +t != +t ? +e != +e : 0 == +t ? 1 / +t == 1 / e : +t == +e;
            case "[object Date]":
            case "[object Boolean]":
              return +t == +e;
            case "[object Symbol]":
              return c.valueOf.call(t) === c.valueOf.call(e);
          }
          var o = "[object Array]" === i;
          if (!o) {
            if ("object" != typeof t || "object" != typeof e) return !1;
            var a = t.constructor,
              s = e.constructor;
            if (a !== s && !(y.isFunction(a) && a instanceof a && y.isFunction(s) && s instanceof s) && "constructor" in t && "constructor" in e) return !1;
          }
          n = n || [], r = r || [];
          for (var u = n.length; u--;) if (n[u] === t) return r[u] === e;
          if (n.push(t), r.push(e), o) {
            if ((u = t.length) !== e.length) return !1;
            for (; u--;) if (!q(t[u], e[u], n, r)) return !1;
          } else {
            var l,
              f = y.keys(t);
            if (u = f.length, y.keys(e).length !== u) return !1;
            for (; u--;) if (l = f[u], !T(e, l) || !q(t[l], e[l], n, r)) return !1;
          }
          return n.pop(), r.pop(), !0;
        }, y.isEqual = function (t, e) {
          return q(t, e);
        }, y.isEmpty = function (t) {
          return null == t || (C(t) && (y.isArray(t) || y.isString(t) || y.isArguments(t)) ? 0 === t.length : 0 === y.keys(t).length);
        }, y.isElement = function (t) {
          return !(!t || 1 !== t.nodeType);
        }, y.isArray = h || function (t) {
          return "[object Array]" === p.call(t);
        }, y.isObject = function (t) {
          var e = typeof t;
          return "function" === e || "object" === e && !!t;
        }, y.each(["Arguments", "Function", "String", "Number", "Date", "RegExp", "Error", "Symbol", "Map", "WeakMap", "Set", "WeakSet"], function (t) {
          y["is" + t] = function (e) {
            return p.call(e) === "[object " + t + "]";
          };
        }), y.isArguments(arguments) || (y.isArguments = function (t) {
          return T(t, "callee");
        });
        var W = o.document && o.document.childNodes;
        "function" != typeof /./ && "object" != typeof Int8Array && "function" != typeof W && (y.isFunction = function (t) {
          return "function" == typeof t || !1;
        }), y.isFinite = function (t) {
          return !y.isSymbol(t) && isFinite(t) && !isNaN(parseFloat(t));
        }, y.isNaN = function (t) {
          return y.isNumber(t) && isNaN(t);
        }, y.isBoolean = function (t) {
          return !0 === t || !1 === t || "[object Boolean]" === p.call(t);
        }, y.isNull = function (t) {
          return null === t;
        }, y.isUndefined = function (t) {
          return void 0 === t;
        }, y.has = function (t, e) {
          if (!y.isArray(e)) return T(t, e);
          for (var n = e.length, r = 0; r < n; r++) {
            var i = e[r];
            if (null == t || !d.call(t, i)) return !1;
            t = t[i];
          }
          return !!n;
        }, y.noConflict = function () {
          return o._ = a, this;
        }, y.identity = function (t) {
          return t;
        }, y.constant = function (t) {
          return function () {
            return t;
          };
        }, y.noop = function () {}, y.property = function (t) {
          return y.isArray(t) ? function (e) {
            return k(e, t);
          } : E(t);
        }, y.propertyOf = function (t) {
          return null == t ? function () {} : function (e) {
            return y.isArray(e) ? k(t, e) : t[e];
          };
        }, y.matcher = y.matches = function (t) {
          return t = y.extendOwn({}, t), function (e) {
            return y.isMatch(e, t);
          };
        }, y.times = function (t, e, n) {
          var r = Array(Math.max(0, t));
          e = b(e, n, 1);
          for (var i = 0; i < t; i++) r[i] = e(i);
          return r;
        }, y.random = function (t, e) {
          return null == e && (e = t, t = 0), t + Math.floor(Math.random() * (e - t + 1));
        }, y.now = Date.now || function () {
          return new Date().getTime();
        };
        var $ = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;"
          },
          z = y.invert($),
          G = function G(t) {
            var e = function e(_e8) {
                return t[_e8];
              },
              n = "(?:" + y.keys(t).join("|") + ")",
              r = RegExp(n),
              i = RegExp(n, "g");
            return function (t) {
              return t = null == t ? "" : "" + t, r.test(t) ? t.replace(i, e) : t;
            };
          };
        y.escape = G($), y.unescape = G(z), y.result = function (t, e, n) {
          y.isArray(e) || (e = [e]);
          var r = e.length;
          if (!r) return y.isFunction(n) ? n.call(t) : n;
          for (var i = 0; i < r; i++) {
            var o = null == t ? void 0 : t[e[i]];
            void 0 === o && (o = n, i = r), t = y.isFunction(o) ? o.call(t) : o;
          }
          return t;
        };
        var K = 0;
        y.uniqueId = function (t) {
          var e = ++K + "";
          return t ? t + e : e;
        }, y.templateSettings = {
          evaluate: /<%([\s\S]+?)%>/g,
          interpolate: /<%=([\s\S]+?)%>/g,
          escape: /<%-([\s\S]+?)%>/g
        };
        var Y = /(.)^/,
          J = {
            "'": "'",
            "\\": "\\",
            "\r": "r",
            "\n": "n",
            "\u2028": "u2028",
            "\u2029": "u2029"
          },
          Q = /\\|'|\r|\n|\u2028|\u2029/g,
          X = function X(t) {
            return "\\" + J[t];
          };
        y.template = function (t, e, n) {
          !e && n && (e = n), e = y.defaults({}, e, y.templateSettings);
          var r = RegExp([(e.escape || Y).source, (e.interpolate || Y).source, (e.evaluate || Y).source].join("|") + "|$", "g"),
            i = 0,
            o = "__p+='";
          t.replace(r, function (e, n, r, a, s) {
            return o += t.slice(i, s).replace(Q, X), i = s + e.length, n ? o += "'+\n((__t=(" + n + "))==null?'':_.escape(__t))+\n'" : r ? o += "'+\n((__t=(" + r + "))==null?'':__t)+\n'" : a && (o += "';\n" + a + "\n__p+='"), e;
          }), o += "';\n", e.variable || (o = "with(obj||{}){\n" + o + "}\n"), o = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + o + "return __p;\n";
          var a;
          try {
            a = new Function(e.variable || "obj", "_", o);
          } catch (t) {
            throw t.source = o, t;
          }
          var s = function s(t) {
            return a.call(this, t, y);
          };
          return s.source = "function(" + (e.variable || "obj") + "){\n" + o + "}", s;
        }, y.chain = function (t) {
          var e = y(t);
          return e._chain = !0, e;
        };
        var Z = function Z(t, e) {
          return t._chain ? y(e).chain() : e;
        };
        y.mixin = function (t) {
          return y.each(y.functions(t), function (e) {
            var n = y[e] = t[e];
            y.prototype[e] = function () {
              var t = [this._wrapped];
              return l.apply(t, arguments), Z(this, n.apply(y, t));
            };
          }), y;
        }, y.mixin(y), y.each(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (t) {
          var e = s[t];
          y.prototype[t] = function () {
            var n = this._wrapped;
            return e.apply(n, arguments), "shift" !== t && "splice" !== t || 0 !== n.length || delete n[0], Z(this, n);
          };
        }), y.each(["concat", "join", "slice"], function (t) {
          var e = s[t];
          y.prototype[t] = function () {
            return Z(this, e.apply(this._wrapped, arguments));
          };
        }), y.prototype.value = function () {
          return this._wrapped;
        }, y.prototype.valueOf = y.prototype.toJSON = y.prototype.value, y.prototype.toString = function () {
          return String(this._wrapped);
        }, r = [], void 0 !== (i = function () {
          return y;
        }.apply(e, r)) && (n.exports = i);
      }();
    }).call(e, n(100), n(234)(t));
  }, function (t, e) {
    t.exports = {
      signout: "Sign Out",
      signin: "Sign In",
      remember: "Remember me",
      rememberDevice: "Trust this device",
      "rememberDevice.timebased": "Do not challenge me on this device for the next {0}",
      "rememberDevice.devicebased": "Do not challenge me on this device again",
      autoPush: "Send push automatically",
      unlockaccount: "Unlock account?",
      needhelp: "Need help signing in?",
      goback: "Back to Sign In",
      forgotpassword: "Forgot password?",
      help: "Help",
      retry: "Retry",
      iphone: "iPhone",
      android: "Android",
      "minutes.oneMinute": "minute",
      minutes: "{0} minutes",
      hours: "{0} hours",
      days: "{0} days",
      "error.config": "There was a configuration error",
      "error.required.authParams": 'Missing parameters for the configured authentication scheme - "OAUTH2"',
      "error.required.baseUrl": '"baseUrl" is a required widget parameter',
      "error.required.success": "A success handler is required",
      "error.required.el": '"el" is a required widget parameter',
      "error.invalid.colors.brand": '"colors.brand" must be in six-digit hex format',
      "error.unsupported.browser": "Unsupported browser",
      "error.unsupported.cors": "Unsupported browser - missing CORS support",
      "error.unsupported.localStorage": "Unsupported browser - missing localStorage support",
      "error.enabled.cors": "There was an error sending the request - have you enabled CORS?",
      "error.expired.session": "Your session has expired. Please try to log in again.",
      "error.auth.lockedOut": "Your account is locked. Please contact your administrator.",
      "error.oauth.idToken": "There was a problem generating the id_token for the user. Please try again.",
      "error.network.connection": "Unable to connect to the server. Please check your network connection.",
      "error.username.required": "Please enter a username",
      "error.password.required": "Please enter a password",
      "errors.E0000004": "Unable to sign in",
      "errors.E0000069": "Your account is locked because of too many authentication attempts.",
      "errors.E0000047": "You exceeded the maximum number of requests. Try again in a while.",
      "errors.E0000079": "The operation is not allowed. Please refresh the page to proceed.",
      "errors.E0000001": "Api validation failed: {0}",
      "errors.E0000002": "The request was not valid: {0}",
      "errors.E0000003": "The request body was not well-formed.",
      "errors.E0000005": "Invalid session",
      "errors.E0000006": "You do not have permission to perform the requested action",
      "errors.E0000007": "Not found: {0}",
      "errors.E0000008": "The requested path was not found",
      "errors.E0000009": "Internal Server Error",
      "errors.E0000010": "Service is in read only mode",
      "errors.E0000011": "Invalid token provided",
      "errors.E0000012": "Unsupported media type",
      "errors.E0000013": "Invalid client app id",
      "errors.E0000015": "You do not have permission to access the feature you are requesting",
      "errors.E0000016": "Activation failed because the user is already active",
      "errors.E0000017": "Password reset failed",
      "errors.E0000018": "Bad request.  Accept and/or Content-Type headers are likely not set.",
      "errors.E0000019": "Bad request.  Accept and/or Content-Type headers likely do not match supported values.",
      "errors.E0000020": "Bad request.",
      "errors.E0000021": "Bad request.  Accept and/or Content-Type headers likely do not match supported values.",
      "errors.E0000022": "The endpoint does not support the provided HTTP method",
      "errors.E0000023": "Operation failed because user profile is mastered under another system",
      "errors.E0000024": "Bad request.  This operation on app metadata is not yet supported.",
      "errors.E0000025": "App version assignment failed.",
      "errors.E0000026": "This endpoint has been deprecated.",
      "errors.E0000027": "Group push bad request : {0}",
      "errors.E0000028": "The request is missing a required parameter.",
      "errors.E0000029": "Invalid paging request.",
      "errors.E0000030": "Bad request. Invalid date. Dates must be of the form yyyy-MM-dd''T''HH:mm:ss.SSSZZ, e.g. 2013-01-01T12:00:00.000-07:00.",
      "errors.E0000031": "Invalid search criteria.",
      "errors.E0000032": "Unlock is not allowed for this user.",
      "errors.E0000033": "Bad request. Can't specify a search query and filter in the same request.",
      "errors.E0000034": "Forgot password not allowed on specified user.",
      "errors.E0000035": "Change password not allowed on specified user.",
      "errors.E0000036": "Change recovery question not allowed on specified user.",
      "errors.E0000037": "Type mismatch exception.",
      "errors.E0000038": "This operation is not allowed in the user''s current status.",
      "errors.E0000039": "Operation on application settings failed.",
      "errors.E0000040": "Application label must not be the same as an existing application label.",
      "errors.E0000041": "Credentials should not be set on this resource based on the scheme.",
      "errors.E0000042": "Setting the error page redirect URL failed.",
      "errors.E0000043": "Self service application assignment is not enabled.",
      "errors.E0000044": "Self service application assignment is not supported.",
      "errors.E0000045": "Field mapping bad request.",
      "errors.E0000046": "Deactivate application for user forbidden.",
      "errors.E0000048": "Entity not found exception.",
      "errors.E0000049": "Invalid SCIM data from SCIM implementation.",
      "errors.E0000050": "Invalid SCIM data from client.",
      "errors.E0000051": "No response from SCIM implementation.",
      "errors.E0000052": "Endpoint not implemented.",
      "errors.E0000053": "Invalid SCIM filter.",
      "errors.E0000054": "Invalid pagination properties.",
      "errors.E0000055": "Duplicate group.",
      "errors.E0000056": "Delete application forbidden.",
      "errors.E0000057": "Access to this application is denied due to a policy.",
      "errors.E0000058": "Access to this application requires MFA: {0}",
      "errors.E0000059": "The connector configuration could not be tested. Make sure that the URL, Authentication Parameters are correct and that there is an implementation available at the URL provided.",
      "errors.E0000060": "Unsupported operation.",
      "errors.E0000061": "Tab error: {0}",
      "errors.E0000062": "The specified user is already assigned to the application.",
      "errors.E0000063": "Invalid combination of parameters specified.",
      "errors.E0000064": "Password is expired and must be changed.",
      "errors.E0000065": "Internal error processing app metadata.",
      "errors.E0000066": "APNS is not configured, contact your admin",
      "errors.E0000067": "Factors Service Error.",
      "errors.E0000070": "Waiting for ACK",
      "errors.E0000071": "Unsupported OS Version: {0}",
      "errors.E0000072": "MIM policy settings have disallowed enrollment for this user",
      "errors.E0000073": "User rejected authentication",
      "errors.E0000074": "Factor Service Error",
      "errors.E0000075": "Cannot modify the {0} attribute because it has a field mapping and profile push is enabled.",
      "errors.E0000076": "Cannot modify the app user because it is mastered by an external app.",
      "errors.E0000077": "Cannot modify the {0} attribute because it is read-only.",
      "errors.E0000078": "Cannot modify the {0} attribute because it is immutable.",
      "errors.E0000081": "Cannot modify the {0} attribute because it is a reserved attribute for this application.",
      "errors.E0000082": "Each code can only be used once. Please wait for a new code and try again.",
      "errors.E0000083": "PassCode is valid but exceeded time window.",
      "errors.E0000084": "App evaluation error.",
      "errors.E0000085": "You do not have permission to access your account at this time.",
      "errors.E0000086": "This policy cannot be activated at this time.",
      "errors.E0000087": "The recovery question answer did not match our records.",
      "errors.E0000090": "The role specified is already assigned to the user.",
      "errors.E0000091": "The provided role type was not the same as required role type.",
      "errors.E0000092": "Access to this application requires re-authentication: {0}",
      "errors.E0000093": "Target count limit exceeded",
      "errors.E0000094": "The provided filter is unsupported.",
      "errors.E0000095": "Recovery not allowed for unknown user.",
      "errors.E0000096": "This certificate has already been uploaded with kid={0}.",
      "errors.E0000097": "There is no verified phone number on file.",
      "errors.E0000098": "This phone number is invalid.",
      "errors.E0000099": "Only numbers located in US and Canada are allowed.  Contact your administrator if this is a problem.",
      "errors.E0000100": "Unable to perform search query.",
      "errors.E0000101": "Upload failed because of a problem with your ipa file, {0}",
      "errors.E0000102": "YubiKey cannot be deleted while assigned to an user. Please deactivate YubiKey using reset MFA and try again",
      "errors.E0000103": "Action on device already in queue or in progress",
      "errors.E0000104": "Device is already locked and cannot be locked again",
      "errors.E0000105": "You have accessed an account recovery link that has expired or been previously used.",
      "errors.E0000106": "Wait for token to change, then enter the new tokencode.",
      "errors.E0000107": "The entity is not in the expected state for the requested transition.",
      "errors.E0000109": "An SMS message was recently sent. Please wait 30 seconds before trying again.",
      "errors.E0000110": "You have accessed a link that has expired or has been previously used.",
      "errors.E0000111": "Cannot modify the {0} object because it is read-only.",
      "errors.E0000112": "Cannot update this user because they are still being activated. Please try again in a few minutes.",
      "errors.E0000113": "{0}.",
      "errors.E0000114": "A user with this login already exists in the current organization.",
      "errors.E0000115": "Upload failed, {0}",
      "errors.E0000116": "{0}",
      "errors.E0000119": "Your account is locked. Please contact your administrator.",
      "errors.E0000124": "Could not create user. To create a user and expire their password immediately, a password must be specified",
      "errors.E0000125": 'Could not create user. To create a user and expire their password immediately, "activate" must be true',
      "errors.E0000133": "A phone call was recently made. Please wait 30 seconds before trying again.",
      "oform.next": "Next",
      "oform.verify": "Verify",
      "oform.send": "Send",
      "oform.back": "Back",
      "oform.save": "Save",
      "oform.cancel": "Cancel",
      "oform.edit": "Edit",
      "oform.previous": "Previous",
      "oform.error.icon.ariaLabel": "Error",
      "oform.errorbanner.title": "We found some errors. Please review the form and make corrections.",
      "oform.errormsg.title": "Please review the form to correct the following errors:",
      "oform.error.unexpected": "There was an unexpected internal error. Please try again.",
      "model.validation.field.blank": "This field cannot be left blank",
      "model.validation.field.wrong.type": "This field is of the wrong type",
      "model.validation.field.invalid": "This field has an invalid value",
      "model.validation.field.value.not.allowed": "This field value is not allowed",
      "model.validation.field.array.minItems": "This array does not have enough items",
      "model.validation.field.array.maxItems": "This array contains too many items",
      "model.validation.field.array.unique": "This array can only have unique values",
      "model.validation.field.string.minLength": "This field cannot be less than the minimum required characters",
      "model.validation.field.string.maxLength": "This field cannot exceed the maximum allowed characters",
      "model.validation.field.invalid.format.email": "This value is not a valid email address",
      "model.validation.field.invalid.format.uri": "This value is not a valid URI",
      "model.validation.field.invalid.format.ipv4": "This value is not a valid IPv4 address",
      "model.validation.field.invalid.format.hostname": "This value is not a valid hostname",
      "model.validation.field.username": "Please check your username",
      "factor.totpSoft.oktaVerify": "Okta Verify",
      "factor.totpSoft.googleAuthenticator": "Google Authenticator",
      "factor.totpSoft.description": "Enter single-use code from the mobile app.",
      "factor.totpHard.rsaSecurId": "RSA SecurID",
      "factor.totpHard.symantecVip": "Symantec VIP",
      "factor.totpHard.description": "Enter a single-use code from a hardware token.",
      "factor.totpHard.yubikey": "YubiKey",
      "factor.totpHard.yubikey.description": "Insert your YubiKey and tap it to get a verification code.",
      "factor.totpHard.yubikey.placeholder": "Click here, then tap your YubiKey",
      "factor.oktaVerifyPush": "Okta Verify",
      "factor.push.description": "Use a push notification sent to the mobile app.",
      "factor.duo": "Duo Security",
      "factor.duo.description": "Use Push Notification, SMS, or Voice call to authenticate.",
      "factor.sms": "SMS Authentication",
      "factor.sms.description": "Enter a single-use code sent to your mobile phone.",
      "factor.sms.time.warning": 'Haven\'t received an SMS? To try again, click <span style="font-weight:bold">Re-send code</span>.',
      "factor.call": "Voice Call Authentication",
      "factor.call.description": "Use a phone to authenticate by following voice instructions.",
      "factor.call.time.warning": 'Haven\'t received a voice call? To try again, click <span style="font-weight:bold">Redial</span>.',
      "factor.securityQuestion": "Security Question",
      "factor.securityQuestion.description": "Use the answer to a security question to authenticate.",
      "factor.windowsHello": "Windows Hello",
      "factor.windowsHello.signin.description": "Sign in to Okta using Windows Hello.",
      "factor.windowsHello.signin.description.generic": "Sign in using Windows Hello.",
      "factor.windowsHello.signin.description.specific": "Sign in to {0} using Windows Hello.",
      "factor.u2f": "Security Key (U2F)",
      "factor.u2f.description": "Use a Universal 2nd Factor (U2F) security key to sign on to Okta.",
      "factor.u2f.description.generic": "Use a Universal 2nd Factor (U2F) security key to sign in.",
      "factor.u2f.description.specific": "Use a Universal 2nd Factor (U2F) security key to sign in to {0}.",
      "factor.email": "Email Authentication",
      "factor.email.description": "Enter a verification code sent to your email.",
      "factor.password": "Password",
      "factor.customFactor.description": "Redirect to a third party MFA provider to sign in to Okta.",
      "factor.customFactor.description.generic": "Redirect to a third party MFA provider to sign in.",
      "factor.customFactor.description.specific": "Redirect to a third party MFA provider to sign in to {0}.",
      "factor.webauthn.biometric": "Security Key or Biometric Authenticator",
      "factor.webauthn.biometric.description": "Use a security key (USB or bluetooth) or a biometric authenticator (Windows Hello, Touch ID, etc.)",
      "factor.hotp.description": "Enter a single-use code from an authenticator.",
      "mfa.challenge.verify": "Verify",
      "mfa.challenge.answer.placeholder": "Answer",
      "mfa.challenge.answer.tooltip": "Answer",
      "mfa.challenge.answer.showAnswer": "Show",
      "mfa.challenge.answer.hideAnswer": "Hide",
      "mfa.challenge.enterCode.placeholder": "Enter Code",
      "mfa.challenge.enterCode.tooltip": "Enter Code",
      "mfa.challenge.password.placeholder": "Password",
      "mfa.backToFactors": "Back to factor list",
      "mfa.phoneNumber.placeholder": "Phone number",
      "mfa.phoneNumber.ext.placeholder": "Extension",
      "mfa.sendCode": "Send code",
      "mfa.sent": "Sent",
      "mfa.resendCode": "Re-send code",
      "mfa.call": "Call",
      "mfa.calling": "Calling",
      "mfa.redial": "Redial",
      "mfa.sendEmail": "Send email",
      "mfa.resendEmail": "Re-send email",
      "mfa.scanBarcode": "Scan barcode",
      "mfa.noAccessToEmail": "Can't access email",
      "password.reset": "Reset Password",
      "password.oldPassword.placeholder": "Old password",
      "password.oldPassword.tooltip": "Old password",
      "password.newPassword.placeholder": "New password",
      "password.newPassword.tooltip": "New password",
      "password.confirmPassword.placeholder": "Repeat password",
      "password.confirmPassword.tooltip": "Repeat password",
      "password.error.match": "New passwords must match",
      "password.enroll.error.match": "Passwords must match",
      "recovery.sms.hint": "SMS can only be used if a mobile phone number has been configured.",
      "recovery.mobile.hint": "{0} can only be used if a mobile phone number has been configured.",
      "recovery.sms": "SMS",
      "recovery.call": "Voice Call",
      "recovery.smsOrCall": "SMS or Voice Call",
      "verify.choices.description": "Verify with one of the following factors.",
      "email.button.send": "Send me the code",
      "email.button.resend": "Send again",
      "email.code.label": "Verification code",
      "email.code.not.received": "Haven't received an email?",
      "email.enroll.title": "Set up Email Authentication",
      "email.enroll.description": "Send a verification code to your registered email.",
      "email.mfa.title": "Verify with Email Authentication",
      "email.mfa.description": "Send a verification code to {0}.",
      "email.mfa.email.sent.description": "A verification code was sent to {0}. Check your email and enter the code below.",
      "enroll.choices.title": "Set up multifactor authentication",
      "enroll.choices.description": "Your company requires multifactor authentication to add an additional layer of security when signing in to your Okta account",
      "enroll.choices.description.generic": "Your company requires multifactor authentication to add an additional layer of security when signing in to your account",
      "enroll.choices.description.specific": "Your company requires multifactor authentication to add an additional layer of security when signing in to your {0} account",
      "enroll.choices.description.gracePeriod.bold": "Your company recommends setting up additional factors for authentication. Set up will be required in: <b>{0} day(s)</b>.",
      "enroll.choices.description.gracePeriod.oneDay.bold": "Your company recommends setting up additional factors for authentication. Set up will be required in: <b>less than 1 day</b>.",
      "enroll.choices.optional": "You can configure any additional optional factor or click finish",
      "enroll.choices.list.setup": "Setup required",
      "enroll.choices.list.enrolled": "Enrolled factors",
      "enroll.choices.list.optional": "Additional optional factors",
      "enroll.choices.setup": "Setup",
      "enroll.choices.setup.another": "Set up another",
      "enroll.choices.submit.finish": "Finish",
      "enroll.choices.submit.configure": "Configure factor",
      "enroll.choices.submit.next": "Configure next factor",
      "enroll.choices.cardinality.setup": "({0} set up)",
      "enroll.choices.cardinality.setup.remaining": "({0} of {1} set up)",
      "enroll.choices.setup.skip": "Skip set up",
      "enroll.securityQuestion.setup": "Setup secret question authentication",
      "security.disliked_food": "What is the food you least liked as a child?",
      "security.name_of_first_plush_toy": "What is the name of your first stuffed animal?",
      "security.first_award": "What did you earn your first medal or award for?",
      "security.favorite_security_question": "What is your favorite security question?",
      "security.favorite_toy": "What is the toy/stuffed animal you liked the most as a kid?",
      "security.first_computer_game": "What was the first computer game you played?",
      "security.favorite_movie_quote": "What is your favorite movie quote?",
      "security.first_sports_team_mascot": "What was the mascot of the first sports team you played on?",
      "security.first_music_purchase": "What music album or song did you first purchase?",
      "security.favorite_art_piece": "What is your favorite piece of art?",
      "security.grandmother_favorite_desert": "What was your grandmother's favorite dessert?",
      "security.first_thing_cooked": "What was the first thing you learned to cook?",
      "security.childhood_dream_job": "What was your dream job as a child?",
      "security.first_kiss_location": "Where did you have your first kiss?",
      "security.place_where_significant_other_was_met": "Where did you meet your spouse/significant other?",
      "security.favorite_vacation_location": "Where did you go for your favorite vacation?",
      "security.new_years_two_thousand": "Where were you on New Year's Eve in the year 2000?",
      "security.favorite_speaker_actor": "Who is your favorite speaker/orator?",
      "security.favorite_book_movie_character": "Who is your favorite book/movie character?",
      "security.favorite_sports_player": "Who is your favorite sports player?",
      "enroll.password.setup": "Select a password",
      "save.password": "Save password",
      "enroll.sms.setup": "Receive a code via SMS to authenticate",
      "enroll.sms.try_again": "The number you entered seems invalid. If the number is correct, please try again.",
      "enroll.call.setup": "Follow phone call instructions to authenticate",
      "enroll.onprem.username.placeholder": "Enter {0} username",
      "enroll.onprem.username.tooltip": "Enter {0} username",
      "enroll.onprem.passcode.placeholder": "Enter {0} passcode",
      "enroll.onprem.passcode.tooltip": "Enter {0} passcode",
      "enroll.symantecVip.subtitle": "Enter Credential ID and two consecutive generated codes",
      "enroll.symantecVip.credentialId.placeholder": "Enter credential ID",
      "enroll.symantecVip.credentialId.tooltip": "Enter credential ID",
      "enroll.symantecVip.passcode1.placeholder": "Security code 1",
      "enroll.symantecVip.passcode1.tooltip": "Security code 1",
      "enroll.symantecVip.passcode2.placeholder": "Security code 2",
      "enroll.symantecVip.passcode2.tooltip": "Security code 2",
      "enroll.yubikey.title": "Setup YubiKey",
      "enroll.yubikey.subtitle": "Insert your YubiKey into a USB port and tap it to generate a verification code",
      "enroll.totp.title": "Setup {0}",
      "enroll.totp.selectDevice": "Select your device type",
      "enroll.totp.downloadApp": 'Download <a href="{0}" class="inline-link">{1} from the {2}</a> onto your mobile device.',
      "enroll.hotp.restricted": "Contact your administrator to continue enrollment.",
      "enroll.duo.title": "Setup Duo Security",
      "enroll.windowsHello.title": "Enroll Windows Hello",
      "enroll.windowsHello.subtitle": "Click below to enroll Windows Hello as a second form of authentication",
      "enroll.windowsHello.subtitle.loading": "Please wait while Windows Hello is loading...",
      "enroll.windowsHello.save": "Enroll Windows Hello",
      "enroll.windowsHello.error.notWindows": "Windows Hello can only be used on Windows Edge with Windows 10. Contact your admin for assistance.",
      "enroll.windowsHello.error.notConfiguredHtml": "Windows Hello is not configured. Select the <b>Start</b> button, then select <b>Settings</b> - <b>Accounts</b> - <b>Sign-in</b> to configure Windows Hello.",
      "verify.windowsHello.subtitle": "Verify your identity with Windows Hello",
      "verify.windowsHello.subtitle.loading": "Please wait while Windows Hello is loading...",
      "verify.windowsHello.subtitle.signingIn": "Signing in to Okta...",
      "verify.windowsHello.subtitle.signingIn.generic": "Signing in...",
      "verify.windowsHello.subtitle.signingIn.specific": "Signing in to {0}...",
      "verify.windowsHello.save": "Verify with Windows Hello",
      "verify.windowsHello.error.notFound": "Your Windows Hello enrollment does not match our records. Contact your administrator for assistance.",
      "verify.windowsHello.error.notFound.selectAnother": "Your Windows Hello enrollment does not match our records. Select another factor or contact your administrator for assistance.",
      "enroll.u2f.title": "Setup Security Key (U2F)",
      "enroll.u2f.save": "Register Security Key",
      "enroll.u2f.general2": "Make sure you have a Security Key. If already inserted, remove it now.<br>If you have a Bluetooth Security Key, turn on your computer's Bluetooth.",
      "enroll.u2f.general3": "Click the button below to register",
      "enroll.u2f.instructions": "Insert your Security Key into a USB port on this computer. If it has a button or gold disk, tap it.",
      "enroll.u2f.instructionsBluetooth": "If you are using a Bluetooth Security Key, press the button.",
      "u2f.error.factorNotSupported": "Security Key (U2F) is not supported on this browser. Select another factor or contact your admin for assistance.",
      "u2f.error.factorNotSupported.oneFactor": "Security Key (U2F) is not supported on this browser. Contact your admin for assistance.",
      "u2f.error.other": "An unknown error has occured. Try again or select another factor.",
      "u2f.error.other.oneFactor": "An unknown error has occured. Try again or contact your admin for assistance.",
      "u2f.error.badRequest": "There was an error with the U2F request. Try again or select another factor.",
      "u2f.error.badRequest.oneFactor": "There was an error with the U2F request. Try again or contact your admin for assistance.",
      "u2f.error.unsupported": "The security key is unsupported. Select another factor.",
      "u2f.error.unsupported.oneFactor": "The security key is unsupported. Contact your admin for assistance.",
      "u2f.error.timeout": "You have timed out of the authentication period. Please try again.",
      "verify.u2f.instructions": "Insert your Security Key. If it has a button or gold disk, tap it.",
      "verify.u2f.instructionsBluetooth": "If you are using a Bluetooth Security Key, turn on your computer's Bluetooth and press the button.",
      "verify.u2f.retry": "Retry",
      "enroll.customFactor.subtitle": "Clicking below will redirect to MFA enrollment with {0}",
      "enroll.customFactor.save": "Enroll",
      "verify.customFactor.subtitle": "Clicking below will redirect to verification with {0}",
      "enroll.webauthn.biometric.title": "Set up security key or biometric authenticator",
      "enroll.webauthn.save": "Enroll",
      "enroll.webauthn.biometric.instructions": "Your browser will prompt to register a security key or biometric authenticator (Windows Hello, Touch ID, etc.). Follow the instructions to complete enrollment.",
      "enroll.webauthn.biometric.instructions.edge": "Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select '<b>Cancel</b>' in the prompt before continuing.",
      "verify.webauthn.biometric.instructions": "Your browser or device will prompt you to verify with a security key or biometric authenticator. Follow the instructions to complete authentication.",
      "webauthn.biometric.error.factorNotSupported": "Security key or biometric authenticator is not supported on this browser. Select another factor or contact your admin for assistance.",
      "webauthn.biometric.error.factorNotSupported.oneFactor": "Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.",
      "enroll.webauthn.instructions.noSupportForBiometric": "Note: Some browsers may not support biometric authenticators.",
      "enroll.totp.enterCode": "Enter code displayed from the application",
      "enroll.totp.setupApp": "Launch {0} application on your mobile device and select Add an account.",
      "enroll.totp.setupGoogleAuthApp": 'Launch {0}, tap the "+" icon, then select "Scan barcode".',
      "enroll.totp.cannotScan": "Can't scan?",
      "enroll.totp.refreshBarcode": "Refresh code",
      "enroll.totp.cannotScanBarcode": "Can't scan barcode?",
      "enroll.totp.manualSetupInstructions": "To set up manually enter your Okta Account username and then input the following in the Secret Key Field",
      "enroll.totp.manualSetupInstructions.generic": "To set up manually enter your Account username and then input the following in the Secret Key Field",
      "enroll.totp.manualSetupInstructions.specific": "To set up manually enter your {0} Account username and then input the following in the Secret Key Field",
      "enroll.totp.sharedSecretInstructions": "Enter your Okta Account username and enter the following in the Secret Key Field",
      "enroll.totp.sharedSecretInstructions.generic": "Enter your Account username and enter the following in the Secret Key Field",
      "enroll.totp.sharedSecretInstructions.specific": "Enter your {0} Account username and enter the following in the Secret Key Field",
      "enroll.totp.sendSms": "Send activation link via SMS",
      "enroll.totp.sendEmail": "Send activation link via email",
      "enroll.totp.setupManually": "Setup manually without push notification",
      "enroll.totp.enrollViaEmail.title": "Activation email sent!",
      "enroll.totp.enrollViaEmail.msg": "Open the email from your mobile device.",
      "enroll.totp.enrollViaSms.title": "SMS sent!",
      "enroll.totp.enrollViaSms.msg": "View the SMS on your mobile device.",
      "recoveryChallenge.sms.title": "Enter verification code sent via SMS",
      "recoveryChallenge.call.title": "Enter verification code received via Voice Call",
      "mfa.factors.dropdown.title": "Select an authentication factor",
      "mfa.factors.dropdown.sr.text": "Select Authentication Factor - {0} Factor Selected",
      "mfa.duoSecurity.push": "Push — {0}",
      "mfa.duoSecurity.sms": "SMS — {0}",
      "mfa.duoSecurity.call": "Call — {0}",
      "mfa.challenge.title": "Enter your {0} passcode",
      "mfa.challenge.orEnterCode": "Or enter code",
      "mfa.challenge.totp.subtitle.multiple": "Enter code from any registered {0} device.",
      "mfa.emailVerification.checkEmail": "To finish signing in, click the link in your email.",
      "mfa.emailVerification.title": "Sign in using a link sent to your email.",
      "mfa.emailVerification.subtitle": "Emails will be sent to {0}",
      "mfa.emailVerification.otc.finish": "To finish signing in, enter the code which was emailed to you.",
      "oktaverify.send": "Send Push",
      "oktaverify.resend": "Re-send Push",
      "oktaverify.sent": "Push sent!",
      "oktaverify.rejected": "You have chosen to reject this login.",
      "oktaverify.timeout": "Your push notification has expired.",
      "oktaverify.warning": "Haven't received a push notification yet? Try opening the Okta Verify App on your phone.",
      "oktaverify.numberchallenge.instruction": 'On your phone, tap <span class="challenge-number">{0}</span> on Okta Verify prompt to continue.',
      "oktaverify.numberchallenge.explain": "This extra step helps us make sure it's really you signing in.",
      "primaryauth.title": "Sign In",
      "primaryauth.username.placeholder": "Username",
      "primaryauth.username.tooltip": "Username",
      "primaryauth.password.placeholder": "Password",
      "primaryauth.password.tooltip": "Password",
      "primaryauth.submit": "Sign In",
      "primaryauth.newUser.tooltip": "This is the first time you are connecting to {0} from this browser",
      "primaryauth.newUser.tooltip.close": "Close",
      "idpDiscovery.email.placeholder": "Email",
      "password.forgot.email.or.username.placeholder": "Email or Username",
      "password.forgot.email.or.username.tooltip": "Email or Username",
      "password.forgot.sendText": "Reset via SMS",
      "password.forgot.sendEmail": "Reset via Email",
      "password.forgot.call": "Reset via Voice Call",
      "password.forgot.emailSent.title": "Email sent!",
      "password.forgot.emailSent.desc": "Email has been sent to {0} with instructions on resetting your password.",
      "password.forgot.question.title": "Answer Forgotten Password Challenge",
      "password.forgot.question.submit": "Reset Password",
      "password.forgot.code.notReceived": "Didn't receive a code? Reset via email",
      "password.forgot.noFactorsEnabled": "No password reset options available. Please contact your administrator.",
      "password.reset.title": "Reset your Okta password",
      "password.reset.title.generic": "Reset your password",
      "password.reset.title.specific": "Reset your {0} password",
      "password.complexity.requirements": "Password requirements: {0}.",
      "password.complexity.history": "Your password cannot be any of your last {0} passwords.",
      "password.complexity.minAgeMinutes": "At least {0} minute(s) must have elapsed since you last changed your password.",
      "password.complexity.minAgeHours": "At least {0} hour(s) must have elapsed since you last changed your password.",
      "password.complexity.minAgeDays": "At least {0} day(s) must have elapsed since you last changed your password.",
      "password.reset.verification": "Verify with one of the following factors to reset your password.",
      "password.complexity.length": "at least {0} characters",
      "password.complexity.list.element": ", {0}",
      "password.complexity.lowercase": "a lowercase letter",
      "password.complexity.uppercase": "an uppercase letter",
      "password.complexity.number": "a number",
      "password.complexity.symbol": "a symbol",
      "password.complexity.no_username": "no parts of your username",
      "password.complexity.no_first_name": "does not include your first name",
      "password.complexity.no_last_name": "does not include your last name",
      "password.expired.submit": "Change Password",
      "password.expired.title": "Your Okta password has expired",
      "password.expired.title.generic": "Your password has expired",
      "password.expired.title.specific": "Your {0} password has expired",
      "password.expiring.later": "Remind me later",
      "password.expiring.title": "Your password will expire in {0} days",
      "password.expiring.today": "Your password will expire later today",
      "password.expiring.soon": "Your password is expiring soon",
      "password.expiring.subtitle": "When password expires you may be locked out of Okta Mobile, mobile email, and other services.",
      "password.expiring.subtitle.generic": "When password expires you will be locked out of your account.",
      "password.expiring.subtitle.specific": "When password expires you will be locked out of your {0} account.",
      "password.expired.custom.submit": "Go to {0}",
      "password.expired.custom.subtitle": "This password is set on another website. Click the button below to go there and set a new password.",
      "account.unlock.title": "Unlock account",
      "account.unlock.email.or.username.placeholder": "Email or username",
      "account.unlock.email.or.username.tooltip": "Email or username",
      "account.unlock.sendText": "Send SMS",
      "account.unlock.voiceCall": "Voice Call",
      "account.unlock.sendEmail": "Send Email",
      "account.unlock.emailSent.title": "Email sent!",
      "account.unlock.emailSent.desc": "Email has been sent to {0} with instructions on unlocking your account.",
      "account.unlock.question.title": "Answer Unlock Account Challenge",
      "account.unlock.question.submit": "Unlock Account",
      "account.unlock.unlocked.title": "Account successfully unlocked!",
      "account.unlock.unlocked.desc": "You can log in using your existing username and password.",
      "account.unlock.code.notReceived": "Didn't receive a code? Unlock via email",
      "account.unlock.noFactorsEnabled": "No unlock options available. Please contact your administrator.",
      "contact.support": "If you didn't provide a secondary email address or don't have access to email, please contact your administrator at {0}",
      "socialauth.divider.text": "OR",
      "socialauth.facebook.label": "Sign in with Facebook",
      "socialauth.google.label": "Sign in with Google",
      "socialauth.linkedin.label": "Sign in with LinkedIn",
      "socialauth.microsoft.label": "Sign in with Microsoft",
      "socialauth.popup.title": "External Identity Provider User Authentication",
      "authbutton.divider.text": "or",
      "registration.signup.label": "Don't have an account?",
      "registration.signup.text": "Sign up",
      "registration.complete.title": "Verification email sent",
      "registration.complete.confirm.text": "To finish signing in, check your email.",
      "registration.form.title": "Create Account",
      "registration.form.submit": "Register",
      "registration.passwordComplexity.minLength": "At least {0} character(s)",
      "registration.passwordComplexity.minLower": "At least {0} lowercase letter(s)",
      "registration.passwordComplexity.minUpper": "At least {0} uppercase letter(s)",
      "registration.passwordComplexity.minNumber": "At least {0} number(s)",
      "registration.passwordComplexity.minSymbol": "At least {0} symbol(s)",
      "registration.passwordComplexity.excludeUsername": "Does not contain part of username",
      "registration.passwordComplexity.excludeAttribute": "Does not contain '{0}'",
      "registration.required.fields.label": "* indicates required field",
      "registration.default.callbackhook.error": "We could not process your registration at this time. Please try again later.",
      "registration.error.userName.invalidEmail": "Invalid email address",
      "registration.error.password.passwordRequirementsNotMet": "Password requirements were not met",
      "registration.error.userName.notUniqueWithinOrg": "An account with that email already exists",
      "piv.card": "PIV Card",
      "piv.card.insert": "Please insert your PIV card and select the user certificate.",
      "piv.card.error": "Certificate authentication failed. Contact your admin.",
      "piv.card.error.empty": "No certificate selected. Choose a certificate and try again.",
      "piv.card.error.invalid": "Certificate validation failed. Choose another certificate and try again.",
      "piv.cac.card": "Sign in with PIV / CAC card",
      "piv.cac.title": "PIV / CAC card",
      "piv.cac.card.insert": "Please insert your PIV / CAC card and select the user certificate.",
      "piv.cac.error": "There was an error signing in. Click the button below to try again.",
      "unsupported.oneDrive.title": "Your OneDrive version is not supported",
      "unsupported.oneDrive.desc": "Upgrade now by installing the OneDrive for Business Next Generation Sync Client to login to Okta",
      "unsupported.oneDrive.action": "Learn how to upgrade",
      "unsupported.cookies.title": "Cookies are required",
      "unsupported.cookies.desc": "Cookies are disabled on your browser. Please enable Cookies and refresh this page.",
      "unsupported.cookies.action": "Refresh",
      "deviceTrust.sso.text": "Sign in to access company resources",
      "deviceTrust.sso.subtitle.2": "Your company uses Okta Mobile to get you approved to access this app.",
      "deviceTrust.sso.button": "Sign in with Okta Mobile",
      "deviceTrust.sso.expire.title": "Oops let's get you back on track",
      "deviceTrust.sso.expire.subtitle": "Unfortunately the steps required to sign in took longer than expected and your attempt timed out.",
      "deviceTrust.sso.expire.button": "Sign in using Okta Mobile",
      "deviceTrust.universalLink.fallback.getOktaMobile.title": "Get Okta Mobile",
      "deviceTrust.universalLink.fallback.getOktaMobile.subtitle": "Go to the {0}AppStore{1}, {0}search{1} for {0}Okta Mobile{1} and tap on {0}GET{1} Okta Mobile. Once installed, sign in to Okta Mobile and follow the instructions to secure your device.",
      "signin.with.fastpass": "Signing in using Okta FastPass",
      "customUri.title": "Verify account access",
      "customUri.subtitle": "Launching Okta Verify...",
      "customUri.content": '<div class="skinny-content"> If nothing prompts from the browser, <a href="#" id="launch-ov" class="link">click here</a> to launch Okta Verify, or make sure Okta Verify is installed.</div>',
      "universalLink.title": "Verify your sign in",
      "universalLink.content": 'To continue, you\'ll need to use the <span class="highlight-text">Okta Verify</span> app to confirm your sign in.',
      "universalLink.button": "Sign in with Okta Verify",
      "consent.required.text": "<b>{0}</b> would like to:",
      "consent.required.description": "By clicking Allow Access, you allow the actions listed above.",
      "consent.required.termsOfService": "Terms of Service",
      "consent.required.privacyPolicy": "Privacy Policy",
      "consent.required.consentButton": "Allow Access",
      "consent.required.cancelButton": "Don't Allow",
      "polling.title": "There are too many users trying to sign in right now. We will automatically retry in {0} seconds.",
      "cert.authentication.title": "Certificate authentication"
    };
  }, function (t, e) {
    t.exports = {
      AF: "Afghanistan",
      AX: "Åland Islands",
      AL: "Albania",
      DZ: "Algeria",
      AS: "American Samoa",
      AD: "Andorra",
      AO: "Angola",
      AI: "Anguilla",
      AQ: "Antarctica",
      AG: "Antigua and Barbuda",
      AR: "Argentina",
      AM: "Armenia",
      AW: "Aruba",
      AU: "Australia",
      AT: "Austria",
      AZ: "Azerbaijan",
      BS: "Bahamas",
      BH: "Bahrain",
      BD: "Bangladesh",
      BB: "Barbados",
      BY: "Belarus",
      BE: "Belgium",
      BZ: "Belize",
      BJ: "Benin",
      BM: "Bermuda",
      BT: "Bhutan",
      BO: "Bolivia, Plurinational State of",
      BA: "Bosnia and Herzegovina",
      BW: "Botswana",
      BV: "Bouvet Island",
      BR: "Brazil",
      IO: "British Indian Ocean Territory",
      VG: "Virgin Islands, British",
      BN: "Brunei Darussalam",
      BG: "Bulgaria",
      BF: "Burkina Faso",
      BI: "Burundi",
      KH: "Cambodia",
      CM: "Cameroon",
      CA: "Canada",
      CV: "Cape Verde",
      KY: "Cayman Islands",
      CF: "Central African Republic",
      TD: "Chad",
      CL: "Chile",
      CN: "China",
      CX: "Christmas Island",
      CO: "Colombia",
      KM: "Comoros",
      CG: "Congo",
      CK: "Cook Islands",
      CR: "Costa Rica",
      CI: "Côte d'Ivoire",
      HR: "Croatia",
      CU: "Cuba",
      CY: "Cyprus",
      CZ: "Czech Republic",
      CD: "Congo, the Democratic Republic of the",
      DK: "Denmark",
      DJ: "Djibouti",
      DM: "Dominica",
      DO: "Dominican Republic",
      TL: "Timor-Leste",
      EC: "Ecuador",
      EG: "Egypt",
      SV: "El Salvador",
      GQ: "Equatorial Guinea",
      ER: "Eritrea",
      EE: "Estonia",
      ET: "Ethiopia",
      FK: "Falkland Islands (Malvinas)",
      FO: "Faroe Islands",
      FJ: "Fiji",
      FI: "Finland",
      FR: "France",
      GF: "French Guiana",
      PF: "French Polynesia",
      TF: "French Southern Territories",
      GA: "Gabon",
      GM: "Gambia",
      GE: "Georgia",
      DE: "Germany",
      GH: "Ghana",
      GI: "Gibraltar",
      GR: "Greece",
      GL: "Greenland",
      GD: "Grenada",
      GP: "Guadeloupe",
      GU: "Guam",
      GT: "Guatemala",
      GG: "Guernsey",
      GN: "Guinea",
      GW: "Guinea-Bissau",
      GY: "Guyana",
      HT: "Haiti",
      HM: "Heard Island and McDonald Islands",
      HN: "Honduras",
      HK: "Hong Kong",
      HU: "Hungary",
      IS: "Iceland",
      IN: "India",
      ID: "Indonesia",
      IR: "Iran, Islamic Republic of",
      IQ: "Iraq",
      IE: "Ireland",
      IL: "Israel",
      IT: "Italy",
      JM: "Jamaica",
      JP: "Japan",
      JE: "Jersey",
      JO: "Jordan",
      KZ: "Kazakhstan",
      KE: "Kenya",
      KI: "Kiribati",
      KR: "Korea, Republic of",
      XK: "Kosovo, Republic of",
      KW: "Kuwait",
      KG: "Kyrgyzstan",
      LA: "Lao People's Democratic Republic",
      LV: "Latvia",
      LB: "Lebanon",
      LS: "Lesotho",
      LR: "Liberia",
      LY: "Libya",
      LI: "Liechtenstein",
      LT: "Lithuania",
      LU: "Luxembourg",
      MO: "Macao",
      MK: "Macedonia, the former Yugoslav Republic of",
      MG: "Madagascar",
      MW: "Malawi",
      MY: "Malaysia",
      MV: "Maldives",
      ML: "Mali",
      MT: "Malta",
      MH: "Marshall Islands",
      MQ: "Martinique",
      MR: "Mauritania",
      MU: "Mauritius",
      YT: "Mayotte",
      MX: "Mexico",
      FM: "Micronesia, Federated States of",
      MD: "Moldova, Republic of",
      MC: "Monaco",
      MN: "Mongolia",
      ME: "Montenegro",
      MS: "Montserrat",
      MA: "Morocco",
      MZ: "Mozambique",
      MM: "Myanmar",
      NA: "Namibia",
      NR: "Nauru",
      NP: "Nepal",
      NL: "Netherlands",
      AN: "Netherlands Antilles",
      NC: "New Caledonia",
      NZ: "New Zealand",
      NI: "Nicaragua",
      NE: "Niger",
      NG: "Nigeria",
      NU: "Niue",
      NF: "Norfolk Island",
      KP: "Korea, Democratic People's Republic of",
      MP: "Northern Mariana Islands",
      NO: "Norway",
      OM: "Oman",
      PK: "Pakistan",
      PW: "Palau",
      PS: "Palestine, State of",
      PA: "Panama",
      PG: "Papua New Guinea",
      PY: "Paraguay",
      PE: "Peru",
      PH: "Philippines",
      PN: "Pitcairn",
      PL: "Poland",
      PT: "Portugal",
      PR: "Puerto Rico",
      QA: "Qatar",
      RE: "Réunion",
      RO: "Romania",
      RU: "Russian Federation",
      RW: "Rwanda",
      SH: "Saint Helena, Ascension and Tristan da Cunha",
      KN: "Saint Kitts and Nevis",
      LC: "Saint Lucia",
      PM: "Saint Pierre and Miquelon",
      VC: "Saint Vincent and the Grenadines",
      WS: "Samoa",
      SM: "San Marino",
      ST: "São Tomé and Príncipe",
      SA: "Saudi Arabia",
      SN: "Senegal",
      RS: "Serbia",
      SC: "Seychelles",
      SL: "Sierra Leone",
      SG: "Singapore",
      SK: "Slovakia",
      SI: "Slovenia",
      SB: "Solomon Islands",
      SO: "Somalia",
      ZA: "South Africa",
      GS: "South Georgia and the South Sandwich Islands",
      SS: "South Sudan",
      ES: "Spain",
      LK: "Sri Lanka",
      SD: "Sudan",
      SR: "Suriname",
      SJ: "Svalbard and Jan Mayen",
      SZ: "Swaziland",
      SE: "Sweden",
      CH: "Switzerland",
      SY: "Syrian Arab Republic",
      TW: "Taiwan",
      TJ: "Tajikistan",
      TZ: "Tanzania, United Republic of",
      TH: "Thailand",
      TG: "Togo",
      TK: "Tokelau",
      TO: "Tonga",
      TT: "Trinidad and Tobago",
      TN: "Tunisia",
      TR: "Turkey",
      TM: "Turkmenistan",
      TC: "Turks and Caicos Islands",
      TV: "Tuvalu",
      VI: "Virgin Islands, U.S.",
      UG: "Uganda",
      UA: "Ukraine",
      AE: "United Arab Emirates",
      GB: "United Kingdom",
      US: "United States",
      UM: "United States Minor Outlying Islands",
      UY: "Uruguay",
      UZ: "Uzbekistan",
      VU: "Vanuatu",
      VA: "Holy See (Vatican City State)",
      VE: "Venezuela, Bolivarian Republic of",
      VN: "Viet Nam",
      WF: "Wallis and Futuna",
      EH: "Western Sahara",
      YE: "Yemen",
      ZM: "Zambia",
      ZW: "Zimbabwe"
    };
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      function r(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }
      var i,
        o,
        a,
        s = n(77),
        u = r(s),
        c = n(497),
        l = r(c),
        f = n(501),
        p = r(f),
        d = n(505),
        h = r(d),
        m = n(508),
        g = r(m),
        v = n(510),
        y = r(v),
        _ = n(171),
        b = r(_),
        w = n(172),
        S = r(w),
        x = n(526),
        E = r(x),
        T = n(219),
        k = r(T),
        A = n(529),
        O = r(A),
        C = n(532),
        I = r(C),
        R = n(535),
        P = r(R),
        N = n(228),
        M = r(N),
        L = n(167),
        F = r(L),
        D = n(89),
        j = r(D);
      !function (n, r) {
        "object" == (0, j.default)(e) && "object" == (0, j.default)(t) ? t.exports = r() : (o = [], i = r, void 0 !== (a = "function" == typeof i ? i.apply(e, o) : i) && (t.exports = a));
      }(window, function () {
        return function (t) {
          function e(r) {
            if (n[r]) return n[r].exports;
            var i = n[r] = {
              i: r,
              l: !1,
              exports: {}
            };
            return t[r].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
          }
          var n = {};
          return e.m = t, e.c = n, e.d = function (t, n, r) {
            e.o(t, n) || (0, F.default)(t, n, {
              enumerable: !0,
              get: r
            });
          }, e.r = function (t) {
            void 0 !== M.default && P.default && (0, F.default)(t, P.default, {
              value: "Module"
            }), Object.defineProperty(t, "__esModule", {
              value: !0
            });
          }, e.t = function (t, n) {
            if (1 & n && (t = e(t)), 8 & n) return t;
            if (4 & n && "object" == (void 0 === t ? "undefined" : (0, j.default)(t)) && t && t.__esModule) return t;
            var r = (0, I.default)(null);
            if (e.r(r), Object.defineProperty(r, "default", {
              enumerable: !0,
              value: t
            }), 2 & n && "string" != typeof t) for (var i in t) e.d(r, i, function (e) {
              return t[e];
            }.bind(null, i));
            return r;
          }, e.n = function (t) {
            var n = t && t.__esModule ? function () {
              return t.default;
            } : function () {
              return t;
            };
            return e.d(n, "a", n), n;
          }, e.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
          }, e.p = "", e(e.s = 234);
        }([function (t, e, n) {
          var r = n(3),
            i = n(28).f,
            o = n(82),
            a = n(5),
            s = n(44),
            u = n(11),
            c = n(10),
            l = function l(t) {
              var e = function e(_e9, n, r) {
                if (this instanceof t) {
                  switch (arguments.length) {
                    case 0:
                      return new t();
                    case 1:
                      return new t(_e9);
                    case 2:
                      return new t(_e9, n);
                  }
                  return new t(_e9, n, r);
                }
                return t.apply(this, arguments);
              };
              return e.prototype = t.prototype, e;
            };
          t.exports = function (t, e) {
            var n,
              f,
              p,
              d,
              h,
              m,
              g,
              v,
              y = t.target,
              _ = t.global,
              b = t.stat,
              w = t.proto,
              S = _ ? r : b ? r[y] : (r[y] || {}).prototype,
              x = _ ? a : a[y] || (a[y] = {}),
              E = x.prototype;
            for (p in e) n = !o(_ ? p : y + (b ? "." : "#") + p, t.forced) && S && c(S, p), h = x[p], n && (m = t.noTargetGet ? (v = i(S, p)) && v.value : S[p]), d = n && m ? m : e[p], n && (void 0 === h ? "undefined" : (0, j.default)(h)) == (void 0 === d ? "undefined" : (0, j.default)(d)) || (g = t.bind && n ? s(d, r) : t.wrap && n ? l(d) : w && "function" == typeof d ? s(Function.call, d) : d, (t.sham || d && d.sham || h && h.sham) && u(g, "sham", !0), x[p] = g, w && (c(a, f = y + "Prototype") || u(a, f, {}), a[f][p] = d, t.real && E && !E[p] && u(E, p, d)));
          };
        }, function (t, e, n) {
          var r = n(5),
            i = n(10),
            o = n(73),
            a = n(14).f;
          t.exports = function (t) {
            var e = r.Symbol || (r.Symbol = {});
            i(e, t) || a(e, t, {
              value: o.f(t)
            });
          };
        }, function (t, e, n) {
          var r = n(3),
            i = n(62),
            o = n(10),
            a = n(63),
            s = n(66),
            u = n(84),
            c = i("wks"),
            l = r.Symbol,
            f = u ? l : l && l.withoutSetter || a;
          t.exports = function (t) {
            return o(c, t) || (s && o(l, t) ? c[t] = l[t] : c[t] = f("Symbol." + t)), c[t];
          };
        }, function (t, e, n) {
          (function (e) {
            var n = function n(t) {
              return t && t.Math == Math && t;
            };
            t.exports = n("object" == ("undefined" == typeof globalThis ? "undefined" : (0, j.default)(globalThis)) && globalThis) || n("object" == ("undefined" == typeof window ? "undefined" : (0, j.default)(window)) && window) || n("object" == ("undefined" == typeof self ? "undefined" : (0, j.default)(self)) && self) || n("object" == (void 0 === e ? "undefined" : (0, j.default)(e)) && e) || Function("return this")();
          }).call(this, n(118));
        }, function (t, e) {
          t.exports = function (t) {
            try {
              return !!t();
            } catch (t) {
              return !0;
            }
          };
        }, function (t, e) {
          t.exports = {};
        }, function (t, e, n) {
          var r = n(4);
          t.exports = !r(function () {
            return 7 != Object.defineProperty({}, 1, {
              get: function get() {
                return 7;
              }
            })[1];
          });
        }, function (t, e, n) {
          t.exports = n(114);
        }, function (t, e, n) {
          t.exports = n(115);
        }, function (t, e, n) {
          var r = n(12);
          t.exports = function (t) {
            if (!r(t)) throw TypeError(String(t) + " is not an object");
            return t;
          };
        }, function (t, e) {
          var n = {}.hasOwnProperty;
          t.exports = function (t, e) {
            return n.call(t, e);
          };
        }, function (t, e, n) {
          var r = n(6),
            i = n(14),
            o = n(19);
          t.exports = r ? function (t, e, n) {
            return i.f(t, e, o(1, n));
          } : function (t, e, n) {
            return t[e] = n, t;
          };
        }, function (t, e) {
          t.exports = function (t) {
            return "object" == (void 0 === t ? "undefined" : (0, j.default)(t)) ? null !== t : "function" == typeof t;
          };
        }, function (t, e, n) {
          t.exports = n(161);
        }, function (t, e, n) {
          var r = n(6),
            i = n(79),
            o = n(9),
            a = n(41),
            s = F.default;
          e.f = r ? s : function (t, e, n) {
            if (o(t), e = a(e, !0), o(n), i) try {
              return s(t, e, n);
            } catch (t) {}
            if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
            return "value" in n && (t[e] = n.value), t;
          };
        }, function (t, e, n) {
          var r = n(81),
            i = n(60);
          t.exports = function (t) {
            return r(i(t));
          };
        }, function (t, e, n) {
          var r = n(5),
            i = n(3),
            o = function o(t) {
              return "function" == typeof t ? t : void 0;
            };
          t.exports = function (t, e) {
            return arguments.length < 2 ? o(r[t]) || o(i[t]) : r[t] && r[t][e] || i[t] && i[t][e];
          };
        }, function (t, e, n) {
          function r(t, e, n, r, o, a, s) {
            try {
              var u = t[a](s),
                c = u.value;
            } catch (t) {
              return void n(t);
            }
            u.done ? e(c) : i.resolve(c).then(r, o);
          }
          var i = n(137);
          t.exports = function (t) {
            return function () {
              var e = this,
                n = arguments;
              return new i(function (i, o) {
                function a(t) {
                  r(u, i, o, a, s, "next", t);
                }
                function s(t) {
                  r(u, i, o, a, s, "throw", t);
                }
                var u = t.apply(e, n);
                a(void 0);
              });
            };
          };
        }, function (t, e) {
          t.exports = {};
        }, function (t, e) {
          t.exports = function (t, e) {
            return {
              enumerable: !(1 & t),
              configurable: !(2 & t),
              writable: !(4 & t),
              value: e
            };
          };
        }, function (t, e) {
          t.exports = !0;
        }, function (t, e) {
          var n = {}.toString;
          t.exports = function (t) {
            return n.call(t).slice(8, -1);
          };
        }, function (t, e) {
          t.exports = function (t) {
            if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
            return t;
          };
        }, function (t, e, n) {
          var r = n(69),
            i = n(14).f,
            o = n(11),
            a = n(10),
            s = n(123),
            u = n(2)("toStringTag");
          t.exports = function (t, e, n, c) {
            if (t) {
              var l = n ? t : t.prototype;
              a(l, u) || i(l, u, {
                configurable: !0,
                value: e
              }), c && !r && o(l, "toString", s);
            }
          };
        }, function (t, e, n) {
          t.exports = n(171);
        }, function (t, e, n) {
          t.exports = n(175);
        }, function (t, e, n) {
          t.exports = n(178);
        }, function (t, e, n) {
          var r,
            i,
            o,
            a = n(117),
            s = n(3),
            u = n(12),
            c = n(11),
            l = n(10),
            f = n(42),
            p = n(43),
            d = s.WeakMap;
          if (a) {
            var h = new d(),
              m = h.get,
              g = h.has,
              v = h.set;
            r = function r(t, e) {
              return v.call(h, t, e), e;
            }, i = function i(t) {
              return m.call(h, t) || {};
            }, o = function o(t) {
              return g.call(h, t);
            };
          } else {
            var y = f("state");
            p[y] = !0, r = function r(t, e) {
              return c(t, y, e), e;
            }, i = function i(t) {
              return l(t, y) ? t[y] : {};
            }, o = function o(t) {
              return l(t, y);
            };
          }
          t.exports = {
            set: r,
            get: i,
            has: o,
            enforce: function enforce(t) {
              return o(t) ? i(t) : r(t, {});
            },
            getterFor: function getterFor(t) {
              return function (e) {
                var n;
                if (!u(e) || (n = i(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
                return n;
              };
            }
          };
        }, function (t, e, n) {
          var r = n(6),
            i = n(64),
            o = n(19),
            a = n(15),
            s = n(41),
            u = n(10),
            c = n(79),
            l = O.default;
          e.f = r ? l : function (t, e) {
            if (t = a(t), e = s(e, !0), c) try {
              return l(t, e);
            } catch (t) {}
            if (u(t, e)) return o(!i.f.call(t, e), t[e]);
          };
        }, function (t, e, n) {
          var r = n(60);
          t.exports = function (t) {
            return Object(r(t));
          };
        }, function (t, e, n) {
          var r = n(69),
            i = n(21),
            o = n(2)("toStringTag"),
            a = "Arguments" == i(function () {
              return arguments;
            }());
          t.exports = r ? i : function (t) {
            var e, n, r;
            return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function (t, e) {
              try {
                return t[e];
              } catch (t) {}
            }(e = Object(t), o)) ? n : a ? i(e) : "Object" == (r = i(e)) && "function" == typeof e.callee ? "Arguments" : r;
          };
        }, function (t, e, n) {
          var r = n(11);
          t.exports = function (t, e, n, i) {
            i && i.enumerable ? t[e] = n : r(t, e, n);
          };
        }, function (t, e, n) {
          n(90);
          var r = n(126),
            i = n(3),
            o = n(30),
            a = n(11),
            s = n(18),
            u = n(2)("toStringTag");
          for (var c in r) {
            var l = i[c],
              f = l && l.prototype;
            f && o(f) !== u && a(f, u, c), s[c] = s.Array;
          }
        }, function (t, e, n) {
          var r = n(9),
            i = n(131),
            o = n(46),
            a = n(44),
            s = n(92),
            u = n(132),
            c = function c(t, e) {
              this.stopped = t, this.result = e;
            };
          (t.exports = function (t, e, n, l, f) {
            var p,
              d,
              h,
              m,
              g,
              v,
              y,
              _ = a(e, n, l ? 2 : 1);
            if (f) p = t;else {
              if ("function" != typeof (d = s(t))) throw TypeError("Target is not iterable");
              if (i(d)) {
                for (h = 0, m = o(t.length); m > h; h++) if ((g = l ? _(r(y = t[h])[0], y[1]) : _(t[h])) && g instanceof c) return g;
                return new c(!1);
              }
              p = d.call(t);
            }
            for (v = p.next; !(y = v.call(p)).done;) if ("object" == (0, j.default)(g = u(p, _, y.value, l)) && g && g instanceof c) return g;
            return new c(!1);
          }).stop = function (t) {
            return new c(!0, t);
          };
        }, function (t, e, n) {
          var r = n(22),
            i = function i(t) {
              var e, n;
              this.promise = new t(function (t, r) {
                if (void 0 !== e || void 0 !== n) throw TypeError("Bad Promise constructor");
                e = t, n = r;
              }), this.resolve = r(e), this.reject = r(n);
            };
          t.exports.f = function (t) {
            return new i(t);
          };
        }, function (t, e, n) {
          var r = n(5);
          t.exports = function (t) {
            return r[t + "Prototype"];
          };
        }, function (t, e, n) {
          t.exports = n(143);
        }, function (t, e) {
          var n = function (t) {
            function e() {
              this.fetch = !1, this.DOMException = t.DOMException;
            }
            return e.prototype = t, new e();
          }("undefined" != typeof self ? self : this);
          !function (t) {
            !function (e) {
              function n(t) {
                if ("string" != typeof t && (t = String(t)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(t)) throw new TypeError("Invalid character in header field name");
                return t.toLowerCase();
              }
              function r(t) {
                return "string" != typeof t && (t = String(t)), t;
              }
              function i(t) {
                var e = {
                  next: function next() {
                    var e = t.shift();
                    return {
                      done: void 0 === e,
                      value: e
                    };
                  }
                };
                return g && (e[k.default] = function () {
                  return e;
                }), e;
              }
              function o(t) {
                this.map = {}, t instanceof o ? t.forEach(function (t, e) {
                  this.append(e, t);
                }, this) : Array.isArray(t) ? t.forEach(function (t) {
                  this.append(t[0], t[1]);
                }, this) : t && (0, E.default)(t).forEach(function (e) {
                  this.append(e, t[e]);
                }, this);
              }
              function a(t) {
                if (t.bodyUsed) return S.default.reject(new TypeError("Already read"));
                t.bodyUsed = !0;
              }
              function s(t) {
                return new S.default(function (e, n) {
                  t.onload = function () {
                    e(t.result);
                  }, t.onerror = function () {
                    n(t.error);
                  };
                });
              }
              function u(t) {
                var e = new FileReader(),
                  n = s(e);
                return e.readAsArrayBuffer(t), n;
              }
              function c(t) {
                if (t.slice) return t.slice(0);
                var e = new Uint8Array(t.byteLength);
                return e.set(new Uint8Array(t)), e.buffer;
              }
              function l() {
                return this.bodyUsed = !1, this._initBody = function (t) {
                  var e;
                  this._bodyInit = t, t ? "string" == typeof t ? this._bodyText = t : v && Blob.prototype.isPrototypeOf(t) ? this._bodyBlob = t : y && FormData.prototype.isPrototypeOf(t) ? this._bodyFormData = t : m && URLSearchParams.prototype.isPrototypeOf(t) ? this._bodyText = t.toString() : _ && v && (e = t) && DataView.prototype.isPrototypeOf(e) ? (this._bodyArrayBuffer = c(t.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : _ && (ArrayBuffer.prototype.isPrototypeOf(t) || w(t)) ? this._bodyArrayBuffer = c(t) : this._bodyText = t = Object.prototype.toString.call(t) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof t ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : m && URLSearchParams.prototype.isPrototypeOf(t) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                }, v && (this.blob = function () {
                  var t = a(this);
                  if (t) return t;
                  if (this._bodyBlob) return S.default.resolve(this._bodyBlob);
                  if (this._bodyArrayBuffer) return S.default.resolve(new Blob([this._bodyArrayBuffer]));
                  if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                  return S.default.resolve(new Blob([this._bodyText]));
                }, this.arrayBuffer = function () {
                  return this._bodyArrayBuffer ? a(this) || S.default.resolve(this._bodyArrayBuffer) : this.blob().then(u);
                }), this.text = function () {
                  var t,
                    e,
                    n,
                    r = a(this);
                  if (r) return r;
                  if (this._bodyBlob) return t = this._bodyBlob, e = new FileReader(), n = s(e), e.readAsText(t), n;
                  if (this._bodyArrayBuffer) return S.default.resolve(function (t) {
                    for (var e = new Uint8Array(t), n = new Array(e.length), r = 0; r < e.length; r++) n[r] = String.fromCharCode(e[r]);
                    return n.join("");
                  }(this._bodyArrayBuffer));
                  if (this._bodyFormData) throw new Error("could not read FormData body as text");
                  return S.default.resolve(this._bodyText);
                }, y && (this.formData = function () {
                  return this.text().then(p);
                }), this.json = function () {
                  return this.text().then(JSON.parse);
                }, this;
              }
              function f(t, e) {
                var n,
                  r,
                  i = (e = e || {}).body;
                if (t instanceof f) {
                  if (t.bodyUsed) throw new TypeError("Already read");
                  this.url = t.url, this.credentials = t.credentials, e.headers || (this.headers = new o(t.headers)), this.method = t.method, this.mode = t.mode, this.signal = t.signal, i || null == t._bodyInit || (i = t._bodyInit, t.bodyUsed = !0);
                } else this.url = String(t);
                if (this.credentials = e.credentials || this.credentials || "same-origin", !e.headers && this.headers || (this.headers = new o(e.headers)), this.method = (n = e.method || this.method || "GET", r = n.toUpperCase(), x.indexOf(r) > -1 ? r : n), this.mode = e.mode || this.mode || null, this.signal = e.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");
                this._initBody(i);
              }
              function p(t) {
                var e = new FormData();
                return t.trim().split("&").forEach(function (t) {
                  if (t) {
                    var n = t.split("="),
                      r = n.shift().replace(/\+/g, " "),
                      i = n.join("=").replace(/\+/g, " ");
                    e.append(decodeURIComponent(r), decodeURIComponent(i));
                  }
                }), e;
              }
              function d(t, e) {
                e || (e = {}), this.type = "default", this.status = void 0 === e.status ? 200 : e.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in e ? e.statusText : "OK", this.headers = new o(e.headers), this.url = e.url || "", this._initBody(t);
              }
              function h(t, n) {
                return new S.default(function (r, i) {
                  function a() {
                    u.abort();
                  }
                  var s = new f(t, n);
                  if (s.signal && s.signal.aborted) return i(new e.DOMException("Aborted", "AbortError"));
                  var u = new XMLHttpRequest();
                  u.onload = function () {
                    var t,
                      e,
                      n = {
                        status: u.status,
                        statusText: u.statusText,
                        headers: (t = u.getAllResponseHeaders() || "", e = new o(), t.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (t) {
                          var n = t.split(":"),
                            r = n.shift().trim();
                          if (r) {
                            var i = n.join(":").trim();
                            e.append(r, i);
                          }
                        }), e)
                      };
                    n.url = "responseURL" in u ? u.responseURL : n.headers.get("X-Request-URL");
                    var i = "response" in u ? u.response : u.responseText;
                    r(new d(i, n));
                  }, u.onerror = function () {
                    i(new TypeError("Network request failed"));
                  }, u.ontimeout = function () {
                    i(new TypeError("Network request failed"));
                  }, u.onabort = function () {
                    i(new e.DOMException("Aborted", "AbortError"));
                  }, u.open(s.method, s.url, !0), "include" === s.credentials ? u.withCredentials = !0 : "omit" === s.credentials && (u.withCredentials = !1), "responseType" in u && v && (u.responseType = "blob"), s.headers.forEach(function (t, e) {
                    u.setRequestHeader(e, t);
                  }), s.signal && (s.signal.addEventListener("abort", a), u.onreadystatechange = function () {
                    4 === u.readyState && s.signal.removeEventListener("abort", a);
                  }), u.send(void 0 === s._bodyInit ? null : s._bodyInit);
                });
              }
              var m = ("URLSearchParams" in t),
                g = "Symbol" in t && "iterator" in M.default,
                v = "FileReader" in t && "Blob" in t && function () {
                  try {
                    return new Blob(), !0;
                  } catch (t) {
                    return !1;
                  }
                }(),
                y = ("FormData" in t),
                _ = ("ArrayBuffer" in t);
              if (_) var b = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
                w = ArrayBuffer.isView || function (t) {
                  return t && b.indexOf(Object.prototype.toString.call(t)) > -1;
                };
              o.prototype.append = function (t, e) {
                t = n(t), e = r(e);
                var i = this.map[t];
                this.map[t] = i ? i + ", " + e : e;
              }, o.prototype.delete = function (t) {
                delete this.map[n(t)];
              }, o.prototype.get = function (t) {
                return t = n(t), this.has(t) ? this.map[t] : null;
              }, o.prototype.has = function (t) {
                return this.map.hasOwnProperty(n(t));
              }, o.prototype.set = function (t, e) {
                this.map[n(t)] = r(e);
              }, o.prototype.forEach = function (t, e) {
                for (var n in this.map) this.map.hasOwnProperty(n) && t.call(e, this.map[n], n, this);
              }, o.prototype.keys = function () {
                var t = [];
                return this.forEach(function (e, n) {
                  t.push(n);
                }), i(t);
              }, o.prototype.values = function () {
                var t = [];
                return this.forEach(function (e) {
                  t.push(e);
                }), i(t);
              }, o.prototype.entries = function () {
                var t = [];
                return this.forEach(function (e, n) {
                  t.push([n, e]);
                }), i(t);
              }, g && (o.prototype[k.default] = o.prototype.entries);
              var x = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
              f.prototype.clone = function () {
                return new f(this, {
                  body: this._bodyInit
                });
              }, l.call(f.prototype), l.call(d.prototype), d.prototype.clone = function () {
                return new d(this._bodyInit, {
                  status: this.status,
                  statusText: this.statusText,
                  headers: new o(this.headers),
                  url: this.url
                });
              }, d.error = function () {
                var t = new d(null, {
                  status: 0,
                  statusText: ""
                });
                return t.type = "error", t;
              };
              var T = [301, 302, 303, 307, 308];
              d.redirect = function (t, e) {
                if (-1 === T.indexOf(e)) throw new RangeError("Invalid status code");
                return new d(null, {
                  status: e,
                  headers: {
                    location: t
                  }
                });
              }, e.DOMException = t.DOMException;
              try {
                new e.DOMException();
              } catch (t) {
                e.DOMException = function (t, e) {
                  this.message = t, this.name = e;
                  var n = Error(t);
                  this.stack = n.stack;
                }, e.DOMException.prototype = (0, I.default)(Error.prototype), e.DOMException.prototype.constructor = e.DOMException;
              }
              h.polyfill = !0, t.fetch || (t.fetch = h, t.Headers = o, t.Request = f, t.Response = d), e.Headers = o, e.Request = f, e.Response = d, e.fetch = h;
            }({});
          }(n), delete n.fetch.polyfill, (e = n.fetch).default = n.fetch, e.fetch = n.fetch, e.Headers = n.Headers, e.Request = n.Request, e.Response = n.Response, t.exports = e;
        }, function (t, e, n) {
          t.exports = n(221);
        }, function (t, e, n) {
          t.exports = n(222);
        }, function (t, e, n) {
          var r = n(116).charAt,
            i = n(27),
            o = n(80),
            a = i.set,
            s = i.getterFor("String Iterator");
          o(String, "String", function (t) {
            a(this, {
              type: "String Iterator",
              string: String(t),
              index: 0
            });
          }, function () {
            var t,
              e = s(this),
              n = e.string,
              i = e.index;
            return i >= n.length ? {
              value: void 0,
              done: !0
            } : (t = r(n, i), e.index += t.length, {
              value: t,
              done: !1
            });
          });
        }, function (t, e, n) {
          var r = n(12);
          t.exports = function (t, e) {
            if (!r(t)) return t;
            var n, i;
            if (e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
            if ("function" == typeof (n = t.valueOf) && !r(i = n.call(t))) return i;
            if (!e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
            throw TypeError("Can't convert object to primitive value");
          };
        }, function (t, e, n) {
          var r = n(62),
            i = n(63),
            o = r("keys");
          t.exports = function (t) {
            return o[t] || (o[t] = i(t));
          };
        }, function (t, e) {
          t.exports = {};
        }, function (t, e, n) {
          var r = n(22);
          t.exports = function (t, e, n) {
            if (r(t), void 0 === e) return t;
            switch (n) {
              case 0:
                return function () {
                  return t.call(e);
                };
              case 1:
                return function (n) {
                  return t.call(e, n);
                };
              case 2:
                return function (n, r) {
                  return t.call(e, n, r);
                };
              case 3:
                return function (n, r, i) {
                  return t.call(e, n, r, i);
                };
            }
            return function () {
              return t.apply(e, arguments);
            };
          };
        }, function (t, e, n) {
          var r = n(86),
            i = n(68);
          t.exports = b.default || function (t) {
            return r(t, i);
          };
        }, function (t, e, n) {
          var r = n(59),
            i = Math.min;
          t.exports = function (t) {
            return t > 0 ? i(r(t), 9007199254740991) : 0;
          };
        }, function (t, e) {
          t.exports = function (t) {
            try {
              return {
                error: !1,
                value: t()
              };
            } catch (t) {
              return {
                error: !0,
                value: t
              };
            }
          };
        }, function (t, e, n) {
          var r = n(21);
          t.exports = Array.isArray || function (t) {
            return "Array" == r(t);
          };
        }, function (t, e, n) {
          var r = n(44),
            i = n(81),
            o = n(29),
            a = n(46),
            s = n(100),
            u = [].push,
            c = function c(t) {
              var e = 1 == t,
                n = 2 == t,
                c = 3 == t,
                l = 4 == t,
                f = 6 == t,
                p = 5 == t || f;
              return function (d, h, m, g) {
                for (var v, y, _ = o(d), b = i(_), w = r(h, m, 3), S = a(b.length), x = 0, E = g || s, T = e ? E(d, S) : n ? E(d, 0) : void 0; S > x; x++) if ((p || x in b) && (y = w(v = b[x], x, _), t)) if (e) T[x] = y;else if (y) switch (t) {
                  case 3:
                    return !0;
                  case 5:
                    return v;
                  case 6:
                    return x;
                  case 2:
                    u.call(T, v);
                } else if (l) return !1;
                return f ? -1 : c || l ? l : T;
              };
            };
          t.exports = {
            forEach: c(0),
            map: c(1),
            filter: c(2),
            some: c(3),
            every: c(4),
            find: c(5),
            findIndex: c(6)
          };
        }, function (t, e, n) {
          var r = n(6),
            i = n(4),
            o = n(10),
            a = F.default,
            s = {},
            u = function u(t) {
              throw t;
            };
          t.exports = function (t, e) {
            if (o(s, t)) return s[t];
            e || (e = {});
            var n = [][t],
              c = !!o(e, "ACCESSORS") && e.ACCESSORS,
              l = o(e, 0) ? e[0] : u,
              f = o(e, 1) ? e[1] : void 0;
            return s[t] = !!n && !i(function () {
              if (c && !r) return !0;
              var t = {
                length: -1
              };
              c ? a(t, 1, {
                enumerable: !0,
                get: u
              }) : t[1] = 1, n.call(t, l, f);
            });
          };
        }, function (t, e, n) {
          var r = n(146),
            i = n(150),
            o = n(156);
          t.exports = function (t, e) {
            return r(t) || i(t, e) || o();
          };
        }, function (t, e, n) {
          t.exports = n(151);
        }, function (t, e, n) {
          t.exports = n(157);
        }, function (t, e, n) {
          t.exports = n(166);
        }, function (t, e, n) {
          t.exports = n(168);
        }, function (t, e, n) {
          var r = n(183);
          t.exports = function (t, e, n) {
            return e in t ? r(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[e] = n, t;
          };
        }, function (t, e, n) {
          t.exports = n(226);
        }, function (t, e, n) {
          t.exports = n(230);
        }, function (t, e) {
          var n = Math.ceil,
            r = Math.floor;
          t.exports = function (t) {
            return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
          };
        }, function (t, e) {
          t.exports = function (t) {
            if (null == t) throw TypeError("Can't call method on " + t);
            return t;
          };
        }, function (t, e, n) {
          var r = n(3),
            i = n(12),
            o = r.document,
            a = i(o) && i(o.createElement);
          t.exports = function (t) {
            return a ? o.createElement(t) : {};
          };
        }, function (t, e, n) {
          var r = n(20),
            i = n(78);
          (t.exports = function (t, e) {
            return i[t] || (i[t] = void 0 !== e ? e : {});
          })("versions", []).push({
            version: "3.6.4",
            mode: r ? "pure" : "global",
            copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
          });
        }, function (t, e) {
          var n = 0,
            r = Math.random();
          t.exports = function (t) {
            return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++n + r).toString(36);
          };
        }, function (t, e, n) {
          var r = {}.propertyIsEnumerable,
            i = O.default,
            o = i && !r.call({
              1: 2
            }, 1);
          e.f = o ? function (t) {
            var e = i(this, t);
            return !!e && e.enumerable;
          } : r;
        }, function (t, e, n) {
          var r = n(10),
            i = n(29),
            o = n(42),
            a = n(121),
            s = o("IE_PROTO"),
            u = Object.prototype;
          t.exports = a ? y.default : function (t) {
            return t = i(t), r(t, s) ? t[s] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null;
          };
        }, function (t, e, n) {
          var r = n(4);
          t.exports = !!g.default && !r(function () {
            return !String((0, M.default)());
          });
        }, function (t, e, n) {
          var r,
            i = n(9),
            o = n(85),
            a = n(68),
            s = n(43),
            u = n(88),
            c = n(61),
            l = n(42),
            f = l("IE_PROTO"),
            p = function p() {},
            d = function d(t) {
              return "<script>" + t + "<\/script>";
            },
            _h = function h() {
              try {
                r = document.domain && new ActiveXObject("htmlfile");
              } catch (t) {}
              var t, e;
              _h = r ? function (t) {
                t.write(d("")), t.close();
                var e = t.parentWindow.Object;
                return t = null, e;
              }(r) : ((e = c("iframe")).style.display = "none", u.appendChild(e), e.src = String("javascript:"), (t = e.contentWindow.document).open(), t.write(d("document.F=Object")), t.close(), t.F);
              for (var n = a.length; n--;) delete _h.prototype[a[n]];
              return _h();
            };
          s[f] = !0, t.exports = I.default || function (t, e) {
            var n;
            return null !== t ? (p.prototype = i(t), n = new p(), p.prototype = null, n[f] = t) : n = _h(), void 0 === e ? n : o(n, e);
          };
        }, function (t, e) {
          t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        }, function (t, e, n) {
          var r = {};
          r[n(2)("toStringTag")] = "z", t.exports = "[object z]" === String(r);
        }, function (t, e, n) {
          var r,
            i,
            o = n(3),
            a = n(96),
            s = o.process,
            u = s && s.versions,
            c = u && u.v8;
          c ? i = (r = c.split("."))[0] + r[1] : a && (!(r = a.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = a.match(/Chrome\/(\d+)/)) && (i = r[1]), t.exports = i && +i;
        }, function (t, e, n) {
          var r = n(86),
            i = n(68).concat("length", "prototype");
          e.f = E.default || function (t) {
            return r(t, i);
          };
        }, function (t, e, n) {
          var r = n(41),
            i = n(14),
            o = n(19);
          t.exports = function (t, e, n) {
            var a = r(e);
            a in t ? i.f(t, a, o(0, n)) : t[a] = n;
          };
        }, function (t, e, n) {
          var r = n(2);
          e.f = r;
        }, function (t, e, n) {
          var r = n(4),
            i = n(2),
            o = n(70),
            a = i("species");
          t.exports = function (t) {
            return o >= 51 || !r(function () {
              var e = [];
              return (e.constructor = {})[a] = function () {
                return {
                  foo: 1
                };
              }, 1 !== e[t](Boolean).foo;
            });
          };
        }, function (t, e, n) {
          n(76), n(40), n(32), n(127), n(98), n(136);
          var r = n(5);
          t.exports = r.Promise;
        }, function (t, e) {}, function (t, e, n) {
          var r = n(78),
            i = Function.toString;
          "function" != typeof r.inspectSource && (r.inspectSource = function (t) {
            return i.call(t);
          }), t.exports = r.inspectSource;
        }, function (t, e, n) {
          var r = n(3),
            i = n(119),
            o = r["__core-js_shared__"] || i("__core-js_shared__", {});
          t.exports = o;
        }, function (t, e, n) {
          var r = n(6),
            i = n(4),
            o = n(61);
          t.exports = !r && !i(function () {
            return 7 != Object.defineProperty(o("div"), "a", {
              get: function get() {
                return 7;
              }
            }).a;
          });
        }, function (t, e, n) {
          var r = n(0),
            i = n(120),
            o = n(65),
            a = n(89),
            s = n(23),
            u = n(11),
            c = n(31),
            l = n(2),
            f = n(20),
            p = n(18),
            d = n(83),
            h = d.IteratorPrototype,
            m = d.BUGGY_SAFARI_ITERATORS,
            g = l("iterator"),
            v = function v() {
              return this;
            };
          t.exports = function (t, e, n, l, d, y, _) {
            i(n, e, l);
            var b,
              w,
              S,
              x = function x(t) {
                if (t === d && O) return O;
                if (!m && t in k) return k[t];
                switch (t) {
                  case "keys":
                  case "values":
                  case "entries":
                    return function () {
                      return new n(this, t);
                    };
                }
                return function () {
                  return new n(this);
                };
              },
              E = e + " Iterator",
              T = !1,
              k = t.prototype,
              A = k[g] || k["@@iterator"] || d && k[d],
              O = !m && A || x(d),
              C = "Array" == e && k.entries || A;
            if (C && (b = o(C.call(new t())), h !== Object.prototype && b.next && (f || o(b) === h || (a ? a(b, h) : "function" != typeof b[g] && u(b, g, v)), s(b, E, !0, !0), f && (p[E] = v))), "values" == d && A && "values" !== A.name && (T = !0, O = function O() {
              return A.call(this);
            }), f && !_ || k[g] === O || u(k, g, O), p[e] = O, d) if (w = {
              values: x("values"),
              keys: y ? O : x("keys"),
              entries: x("entries")
            }, _) for (S in w) !m && !T && S in k || c(k, S, w[S]);else r({
              target: e,
              proto: !0,
              forced: m || T
            }, w);
            return w;
          };
        }, function (t, e, n) {
          var r = n(4),
            i = n(21),
            o = "".split;
          t.exports = r(function () {
            return !Object("z").propertyIsEnumerable(0);
          }) ? function (t) {
            return "String" == i(t) ? o.call(t, "") : Object(t);
          } : Object;
        }, function (t, e, n) {
          var r = n(4),
            i = /#|\.prototype\./,
            o = function o(t, e) {
              var n = s[a(t)];
              return n == c || n != u && ("function" == typeof e ? r(e) : !!e);
            },
            a = o.normalize = function (t) {
              return String(t).replace(i, ".").toLowerCase();
            },
            s = o.data = {},
            u = o.NATIVE = "N",
            c = o.POLYFILL = "P";
          t.exports = o;
        }, function (t, e, n) {
          var r,
            i,
            o,
            a = n(65),
            s = n(11),
            u = n(10),
            c = n(2),
            l = n(20),
            f = c("iterator"),
            p = !1;
          [].keys && ("next" in (o = [].keys()) ? (i = a(a(o))) !== Object.prototype && (r = i) : p = !0), null == r && (r = {}), l || u(r, f) || s(r, f, function () {
            return this;
          }), t.exports = {
            IteratorPrototype: r,
            BUGGY_SAFARI_ITERATORS: p
          };
        }, function (t, e, n) {
          var r = n(66);
          t.exports = r && !M.default.sham && "symbol" == (0, j.default)(k.default);
        }, function (t, e, n) {
          var r = n(6),
            i = n(14),
            o = n(9),
            a = n(45);
          t.exports = r ? h.default : function (t, e) {
            o(t);
            for (var n, r = a(e), s = r.length, u = 0; s > u;) i.f(t, n = r[u++], e[n]);
            return t;
          };
        }, function (t, e, n) {
          var r = n(10),
            i = n(15),
            o = n(87).indexOf,
            a = n(43);
          t.exports = function (t, e) {
            var n,
              s = i(t),
              u = 0,
              c = [];
            for (n in s) !r(a, n) && r(s, n) && c.push(n);
            for (; e.length > u;) r(s, n = e[u++]) && (~o(c, n) || c.push(n));
            return c;
          };
        }, function (t, e, n) {
          var r = n(15),
            i = n(46),
            o = n(122),
            a = function a(t) {
              return function (e, n, a) {
                var s,
                  u = r(e),
                  c = i(u.length),
                  l = o(a, c);
                if (t && n != n) {
                  for (; c > l;) if ((s = u[l++]) != s) return !0;
                } else for (; c > l; l++) if ((t || l in u) && u[l] === n) return t || l || 0;
                return !t && -1;
              };
            };
          t.exports = {
            includes: a(!0),
            indexOf: a(!1)
          };
        }, function (t, e, n) {
          var r = n(16);
          t.exports = r("document", "documentElement");
        }, function (t, e, n) {
          var r = n(9),
            i = n(124);
          t.exports = p.default || ("__proto__" in {} ? function () {
            var t,
              e = !1,
              n = {};
            try {
              (t = (0, O.default)(Object.prototype, "__proto__").set).call(n, []), e = n instanceof Array;
            } catch (t) {}
            return function (n, o) {
              return r(n), i(o), e ? t.call(n, o) : n.__proto__ = o, n;
            };
          }() : void 0);
        }, function (t, e, n) {
          var r = n(15),
            i = n(125),
            o = n(18),
            a = n(27),
            s = n(80),
            u = a.set,
            c = a.getterFor("Array Iterator");
          t.exports = s(Array, "Array", function (t, e) {
            u(this, {
              type: "Array Iterator",
              target: r(t),
              index: 0,
              kind: e
            });
          }, function () {
            var t = c(this),
              e = t.target,
              n = t.kind,
              r = t.index++;
            return !e || r >= e.length ? (t.target = void 0, {
              value: void 0,
              done: !0
            }) : "keys" == n ? {
              value: r,
              done: !1
            } : "values" == n ? {
              value: e[r],
              done: !1
            } : {
              value: [r, e[r]],
              done: !1
            };
          }, "values"), o.Arguments = o.Array, i("keys"), i("values"), i("entries");
        }, function (t, e, n) {
          var r = n(3);
          t.exports = r.Promise;
        }, function (t, e, n) {
          var r = n(30),
            i = n(18),
            o = n(2)("iterator");
          t.exports = function (t) {
            if (null != t) return t[o] || t["@@iterator"] || i[r(t)];
          };
        }, function (t, e, n) {
          var r = n(9),
            i = n(22),
            o = n(2)("species");
          t.exports = function (t, e) {
            var n,
              a = r(t).constructor;
            return void 0 === a || null == (n = r(a)[o]) ? e : i(n);
          };
        }, function (t, e, n) {
          var r,
            i,
            o,
            a = n(3),
            s = n(4),
            u = n(21),
            c = n(44),
            l = n(88),
            f = n(61),
            p = n(95),
            d = a.location,
            h = a.setImmediate,
            m = a.clearImmediate,
            g = a.process,
            v = a.MessageChannel,
            y = a.Dispatch,
            _ = 0,
            b = {},
            w = function w(t) {
              if (b.hasOwnProperty(t)) {
                var e = b[t];
                delete b[t], e();
              }
            },
            S = function S(t) {
              return function () {
                w(t);
              };
            },
            x = function x(t) {
              w(t.data);
            },
            E = function E(t) {
              a.postMessage(t + "", d.protocol + "//" + d.host);
            };
          h && m || (h = function h(t) {
            for (var e = [], n = 1; arguments.length > n;) e.push(arguments[n++]);
            return b[++_] = function () {
              ("function" == typeof t ? t : Function(t)).apply(void 0, e);
            }, r(_), _;
          }, m = function m(t) {
            delete b[t];
          }, "process" == u(g) ? r = function r(t) {
            g.nextTick(S(t));
          } : y && y.now ? r = function r(t) {
            y.now(S(t));
          } : v && !p ? (o = (i = new v()).port2, i.port1.onmessage = x, r = c(o.postMessage, o, 1)) : !a.addEventListener || "function" != typeof postMessage || a.importScripts || s(E) ? r = "onreadystatechange" in f("script") ? function (t) {
            l.appendChild(f("script")).onreadystatechange = function () {
              l.removeChild(this), w(t);
            };
          } : function (t) {
            setTimeout(S(t), 0);
          } : (r = E, a.addEventListener("message", x, !1))), t.exports = {
            set: h,
            clear: m
          };
        }, function (t, e, n) {
          var r = n(96);
          t.exports = /(iphone|ipod|ipad).*applewebkit/i.test(r);
        }, function (t, e, n) {
          var r = n(16);
          t.exports = r("navigator", "userAgent") || "";
        }, function (t, e, n) {
          var r = n(9),
            i = n(12),
            o = n(34);
          t.exports = function (t, e) {
            if (r(t), i(e) && e.constructor === t) return e;
            var n = o.f(t);
            return (0, n.resolve)(e), n.promise;
          };
        }, function (t, e, n) {
          var r = n(0),
            i = n(22),
            o = n(34),
            a = n(47),
            s = n(33);
          r({
            target: "Promise",
            stat: !0
          }, {
            allSettled: function allSettled(t) {
              var e = this,
                n = o.f(e),
                r = n.resolve,
                u = n.reject,
                c = a(function () {
                  var n = i(e.resolve),
                    o = [],
                    a = 0,
                    u = 1;
                  s(t, function (t) {
                    var i = a++,
                      s = !1;
                    o.push(void 0), u++, n.call(e, t).then(function (t) {
                      s || (s = !0, o[i] = {
                        status: "fulfilled",
                        value: t
                      }, --u || r(o));
                    }, function (t) {
                      s || (s = !0, o[i] = {
                        status: "rejected",
                        reason: t
                      }, --u || r(o));
                    });
                  }), --u || r(o);
                });
              return c.error && u(c.value), n.promise;
            }
          });
        }, function (t, e, n) {
          n(149);
          var r = n(5);
          t.exports = r.Array.isArray;
        }, function (t, e, n) {
          var r = n(12),
            i = n(48),
            o = n(2)("species");
          t.exports = function (t, e) {
            var n;
            return i(t) && ("function" != typeof (n = t.constructor) || n !== Array && !i(n.prototype) ? r(n) && null === (n = n[o]) && (n = void 0) : n = void 0), new (void 0 === n ? Array : n)(0 === e ? 0 : e);
          };
        }, function (t, e, n) {
          var r = n(4);
          t.exports = function (t, e) {
            var n = [][t];
            return !!n && r(function () {
              n.call(null, e || function () {
                throw 1;
              }, 1);
            });
          };
        }, function (t, e, n) {
          n(167);
          var r = n(5).Object,
            i = t.exports = function (t, e, n) {
              return r.defineProperty(t, e, n);
            };
          r.defineProperty.sham && (i.sham = !0);
        }, function (t, e) {
          e.f = g.default;
        }, function (t, e, n) {
          n(105);
          var r = n(5);
          t.exports = r.Object.getOwnPropertySymbols;
        }, function (t, e, n) {
          var r = n(0),
            i = n(3),
            o = n(16),
            a = n(20),
            s = n(6),
            u = n(66),
            c = n(84),
            l = n(4),
            f = n(10),
            p = n(48),
            d = n(12),
            h = n(9),
            m = n(29),
            g = n(15),
            v = n(41),
            y = n(19),
            _ = n(67),
            b = n(45),
            w = n(71),
            S = n(179),
            x = n(103),
            E = n(28),
            T = n(14),
            k = n(64),
            A = n(11),
            O = n(31),
            C = n(62),
            I = n(42),
            R = n(43),
            P = n(63),
            N = n(2),
            M = n(73),
            L = n(1),
            F = n(23),
            D = n(27),
            U = n(49).forEach,
            B = I("hidden"),
            V = N("toPrimitive"),
            q = D.set,
            H = D.getterFor("Symbol"),
            W = Object.prototype,
            _$ = i.Symbol,
            z = o("JSON", "stringify"),
            G = E.f,
            K = T.f,
            Y = S.f,
            J = k.f,
            Q = C("symbols"),
            X = C("op-symbols"),
            Z = C("string-to-symbol-registry"),
            tt = C("symbol-to-string-registry"),
            et = C("wks"),
            nt = i.QObject,
            rt = !nt || !nt.prototype || !nt.prototype.findChild,
            it = s && l(function () {
              return 7 != _(K({}, "a", {
                get: function get() {
                  return K(this, "a", {
                    value: 7
                  }).a;
                }
              })).a;
            }) ? function (t, e, n) {
              var r = G(W, e);
              r && delete W[e], K(t, e, n), r && t !== W && K(W, e, r);
            } : K,
            ot = function ot(t, e) {
              var n = Q[t] = _(_$.prototype);
              return q(n, {
                type: "Symbol",
                tag: t,
                description: e
              }), s || (n.description = e), n;
            },
            at = c ? function (t) {
              return "symbol" == (void 0 === t ? "undefined" : (0, j.default)(t));
            } : function (t) {
              return Object(t) instanceof _$;
            },
            st = function t(e, n, r) {
              e === W && t(X, n, r), h(e);
              var i = v(n, !0);
              return h(r), f(Q, i) ? (r.enumerable ? (f(e, B) && e[B][i] && (e[B][i] = !1), r = _(r, {
                enumerable: y(0, !1)
              })) : (f(e, B) || K(e, B, y(1, {})), e[B][i] = !0), it(e, i, r)) : K(e, i, r);
            },
            ut = function ut(t, e) {
              h(t);
              var n = g(e),
                r = b(n).concat(pt(n));
              return U(r, function (e) {
                s && !ct.call(n, e) || st(t, e, n[e]);
              }), t;
            },
            ct = function ct(t) {
              var e = v(t, !0),
                n = J.call(this, e);
              return !(this === W && f(Q, e) && !f(X, e)) && (!(n || !f(this, e) || !f(Q, e) || f(this, B) && this[B][e]) || n);
            },
            lt = function lt(t, e) {
              var n = g(t),
                r = v(e, !0);
              if (n !== W || !f(Q, r) || f(X, r)) {
                var i = G(n, r);
                return !i || !f(Q, r) || f(n, B) && n[B][r] || (i.enumerable = !0), i;
              }
            },
            ft = function ft(t) {
              var e = Y(g(t)),
                n = [];
              return U(e, function (t) {
                f(Q, t) || f(R, t) || n.push(t);
              }), n;
            },
            pt = function pt(t) {
              var e = t === W,
                n = Y(e ? X : g(t)),
                r = [];
              return U(n, function (t) {
                !f(Q, t) || e && !f(W, t) || r.push(Q[t]);
              }), r;
            };
          u || (O((_$ = function $() {
            if (this instanceof _$) throw TypeError("Symbol is not a constructor");
            var t = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0,
              e = P(t),
              n = function t(n) {
                this === W && t.call(X, n), f(this, B) && f(this[B], e) && (this[B][e] = !1), it(this, e, y(1, n));
              };
            return s && rt && it(W, e, {
              configurable: !0,
              set: n
            }), ot(e, t);
          }).prototype, "toString", function () {
            return H(this).tag;
          }), O(_$, "withoutSetter", function (t) {
            return ot(P(t), t);
          }), k.f = ct, T.f = st, E.f = lt, w.f = S.f = ft, x.f = pt, M.f = function (t) {
            return ot(N(t), t);
          }, s && (K(_$.prototype, "description", {
            configurable: !0,
            get: function get() {
              return H(this).description;
            }
          }), a || O(W, "propertyIsEnumerable", ct, {
            unsafe: !0
          }))), r({
            global: !0,
            wrap: !0,
            forced: !u,
            sham: !u
          }, {
            Symbol: _$
          }), U(b(et), function (t) {
            L(t);
          }), r({
            target: "Symbol",
            stat: !0,
            forced: !u
          }, {
            for: function _for(t) {
              var e = String(t);
              if (f(Z, e)) return Z[e];
              var n = _$(e);
              return Z[e] = n, tt[n] = e, n;
            },
            keyFor: function keyFor(t) {
              if (!at(t)) throw TypeError(t + " is not a symbol");
              if (f(tt, t)) return tt[t];
            },
            useSetter: function useSetter() {
              rt = !0;
            },
            useSimple: function useSimple() {
              rt = !1;
            }
          }), r({
            target: "Object",
            stat: !0,
            forced: !u,
            sham: !s
          }, {
            create: function create(t, e) {
              return void 0 === e ? _(t) : ut(_(t), e);
            },
            defineProperty: st,
            defineProperties: ut,
            getOwnPropertyDescriptor: lt
          }), r({
            target: "Object",
            stat: !0,
            forced: !u
          }, {
            getOwnPropertyNames: ft,
            getOwnPropertySymbols: pt
          }), r({
            target: "Object",
            stat: !0,
            forced: l(function () {
              x.f(1);
            })
          }, {
            getOwnPropertySymbols: function getOwnPropertySymbols(t) {
              return x.f(m(t));
            }
          }), z && r({
            target: "JSON",
            stat: !0,
            forced: !u || l(function () {
              var t = _$();
              return "[null]" != z([t]) || "{}" != z({
                a: t
              }) || "{}" != z(Object(t));
            })
          }, {
            stringify: function stringify(t, e, n) {
              for (var r, i = [t], o = 1; arguments.length > o;) i.push(arguments[o++]);
              if (r = e, (d(e) || void 0 !== t) && !at(t)) return p(e) || (e = function e(t, _e10) {
                if ("function" == typeof r && (_e10 = r.call(this, t, _e10)), !at(_e10)) return _e10;
              }), i[1] = e, z.apply(null, i);
            }
          }), _$.prototype[V] || A(_$.prototype, V, _$.prototype.valueOf), F(_$, "Symbol"), R[B] = !0;
        }, function (t, e, n) {
          var r = n(0),
            i = n(4),
            o = n(48),
            a = n(12),
            s = n(29),
            u = n(46),
            c = n(72),
            l = n(100),
            f = n(74),
            p = n(2),
            d = n(70),
            h = p("isConcatSpreadable"),
            m = d >= 51 || !i(function () {
              var t = [];
              return t[h] = !1, t.concat()[0] !== t;
            }),
            g = f("concat"),
            v = function v(t) {
              if (!a(t)) return !1;
              var e = t[h];
              return void 0 !== e ? !!e : o(t);
            };
          r({
            target: "Array",
            proto: !0,
            forced: !m || !g
          }, {
            concat: function concat(t) {
              var e,
                n,
                r,
                i,
                o,
                a = s(this),
                f = l(a, 0),
                p = 0;
              for (e = -1, r = arguments.length; e < r; e++) if (o = -1 === e ? a : arguments[e], v(o)) {
                if (p + (i = u(o.length)) > 9007199254740991) throw TypeError("Maximum allowed index exceeded");
                for (n = 0; n < i; n++, p++) n in o && c(f, p, o[n]);
              } else {
                if (p >= 9007199254740991) throw TypeError("Maximum allowed index exceeded");
                c(f, p++, o);
              }
              return f.length = p, f;
            }
          });
        }, function (t, e, n) {
          t.exports = n(185);
        }, function (t, e, n) {
          n(194);
          var r = n(5);
          t.exports = r.Object.keys;
        }, function (t, e, n) {
          n(1)("iterator");
        }, function (t, e, n) {
          t.exports = n(180);
        }, function (t, e, n) {
          var r = n(107),
            i = n(189),
            o = n(191);
          t.exports = function (t, e) {
            if (null == t) return {};
            var n,
              a,
              s = o(t, e);
            if (i) {
              var u = i(t);
              for (a = 0; a < u.length; a++) n = u[a], r(e).call(e, n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (s[n] = t[n]);
            }
            return s;
          };
        }, function (t, e, n) {
          function r(e) {
            return t.exports = r = "function" == typeof o && "symbol" == (void 0 === i ? "undefined" : (0, j.default)(i)) ? function (t) {
              return void 0 === t ? "undefined" : (0, j.default)(t);
            } : function (t) {
              return t && "function" == typeof o && t.constructor === o && t !== o.prototype ? "symbol" : void 0 === t ? "undefined" : (0, j.default)(t);
            }, r(e);
          }
          var i = n(195),
            o = n(198);
          t.exports = r;
        }, function (t, e, n) {
          t.exports = n(233);
        }, function (t, e, n) {
          var r = function (t) {
            function e(t, e, i, o) {
              var a = e && e.prototype instanceof r ? e : r,
                s = (0, I.default)(a.prototype),
                c = new f(o || []);
              return s._invoke = function (t, e, r) {
                var i = "suspendedStart";
                return function (o, a) {
                  if ("executing" === i) throw new Error("Generator is already running");
                  if ("completed" === i) {
                    if ("throw" === o) throw a;
                    return h();
                  }
                  for (r.method = o, r.arg = a;;) {
                    var s = r.delegate;
                    if (s) {
                      var c = u(s, r);
                      if (c) {
                        if (c === x) continue;
                        return c;
                      }
                    }
                    if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                      if ("suspendedStart" === i) throw i = "completed", r.arg;
                      r.dispatchException(r.arg);
                    } else "return" === r.method && r.abrupt("return", r.arg);
                    i = "executing";
                    var l = n(t, e, r);
                    if ("normal" === l.type) {
                      if (i = r.done ? "completed" : "suspendedYield", l.arg === x) continue;
                      return {
                        value: l.arg,
                        done: r.done
                      };
                    }
                    "throw" === l.type && (i = "completed", r.method = "throw", r.arg = l.arg);
                  }
                };
              }(t, i, c), s;
            }
            function n(t, e, n) {
              try {
                return {
                  type: "normal",
                  arg: t.call(e, n)
                };
              } catch (t) {
                return {
                  type: "throw",
                  arg: t
                };
              }
            }
            function r() {}
            function i() {}
            function o() {}
            function a(t) {
              ["next", "throw", "return"].forEach(function (e) {
                t[e] = function (t) {
                  return this._invoke(e, t);
                };
              });
            }
            function s(t) {
              var e;
              this._invoke = function (r, i) {
                function o() {
                  return new S.default(function (e, o) {
                    !function e(r, i, o, a) {
                      var s = n(t[r], t, i);
                      if ("throw" !== s.type) {
                        var u = s.arg,
                          c = u.value;
                        return c && "object" == (void 0 === c ? "undefined" : (0, j.default)(c)) && g.call(c, "__await") ? S.default.resolve(c.__await).then(function (t) {
                          e("next", t, o, a);
                        }, function (t) {
                          e("throw", t, o, a);
                        }) : S.default.resolve(c).then(function (t) {
                          u.value = t, o(u);
                        }, function (t) {
                          return e("throw", t, o, a);
                        });
                      }
                      a(s.arg);
                    }(r, i, e, o);
                  });
                }
                return e = e ? e.then(o, o) : o();
              };
            }
            function u(t, e) {
              var r = t.iterator[e.method];
              if (void 0 === r) {
                if (e.delegate = null, "throw" === e.method) {
                  if (t.iterator.return && (e.method = "return", e.arg = void 0, u(t, e), "throw" === e.method)) return x;
                  e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
                }
                return x;
              }
              var i = n(r, t.iterator, e.arg);
              if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, x;
              var o = i.arg;
              return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, x) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, x);
            }
            function c(t) {
              var e = {
                tryLoc: t[0]
              };
              1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
            }
            function l(t) {
              var e = t.completion || {};
              e.type = "normal", delete e.arg, t.completion = e;
            }
            function f(t) {
              this.tryEntries = [{
                tryLoc: "root"
              }], t.forEach(c, this), this.reset(!0);
            }
            function d(t) {
              if (t) {
                var e = t[_];
                if (e) return e.call(t);
                if ("function" == typeof t.next) return t;
                if (!isNaN(t.length)) {
                  var n = -1,
                    r = function e() {
                      for (; ++n < t.length;) if (g.call(t, n)) return e.value = t[n], e.done = !1, e;
                      return e.value = void 0, e.done = !0, e;
                    };
                  return r.next = r;
                }
              }
              return {
                next: h
              };
            }
            function h() {
              return {
                value: void 0,
                done: !0
              };
            }
            var m = Object.prototype,
              g = m.hasOwnProperty,
              v = "function" == typeof M.default ? M.default : {},
              _ = v.iterator || "@@iterator",
              b = v.asyncIterator || "@@asyncIterator",
              w = v.toStringTag || "@@toStringTag";
            t.wrap = e;
            var x = {},
              E = {};
            E[_] = function () {
              return this;
            };
            var T = y.default,
              k = T && T(T(d([])));
            k && k !== m && g.call(k, _) && (E = k);
            var A = o.prototype = r.prototype = (0, I.default)(E);
            return i.prototype = A.constructor = o, o.constructor = i, o[w] = i.displayName = "GeneratorFunction", t.isGeneratorFunction = function (t) {
              var e = "function" == typeof t && t.constructor;
              return !!e && (e === i || "GeneratorFunction" === (e.displayName || e.name));
            }, t.mark = function (t) {
              return p.default ? (0, p.default)(t, o) : (t.__proto__ = o, w in t || (t[w] = "GeneratorFunction")), t.prototype = (0, I.default)(A), t;
            }, t.awrap = function (t) {
              return {
                __await: t
              };
            }, a(s.prototype), s.prototype[b] = function () {
              return this;
            }, t.AsyncIterator = s, t.async = function (n, r, i, o) {
              var a = new s(e(n, r, i, o));
              return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
                return t.done ? t.value : a.next();
              });
            }, a(A), A[w] = "Generator", A[_] = function () {
              return this;
            }, A.toString = function () {
              return "[object Generator]";
            }, t.keys = function (t) {
              var e = [];
              for (var n in t) e.push(n);
              return e.reverse(), function n() {
                for (; e.length;) {
                  var r = e.pop();
                  if (r in t) return n.value = r, n.done = !1, n;
                }
                return n.done = !0, n;
              };
            }, t.values = d, f.prototype = {
              constructor: f,
              reset: function reset(t) {
                if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(l), !t) for (var e in this) "t" === e.charAt(0) && g.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
              },
              stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(t) {
                function e(e, r) {
                  return o.type = "throw", o.arg = t, n.next = e, r && (n.method = "next", n.arg = void 0), !!r;
                }
                if (this.done) throw t;
                for (var n = this, r = this.tryEntries.length - 1; r >= 0; --r) {
                  var i = this.tryEntries[r],
                    o = i.completion;
                  if ("root" === i.tryLoc) return e("end");
                  if (i.tryLoc <= this.prev) {
                    var a = g.call(i, "catchLoc"),
                      s = g.call(i, "finallyLoc");
                    if (a && s) {
                      if (this.prev < i.catchLoc) return e(i.catchLoc, !0);
                      if (this.prev < i.finallyLoc) return e(i.finallyLoc);
                    } else if (a) {
                      if (this.prev < i.catchLoc) return e(i.catchLoc, !0);
                    } else {
                      if (!s) throw new Error("try statement without catch or finally");
                      if (this.prev < i.finallyLoc) return e(i.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(t, e) {
                for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                  var r = this.tryEntries[n];
                  if (r.tryLoc <= this.prev && g.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                    var i = r;
                    break;
                  }
                }
                i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                var o = i ? i.completion : {};
                return o.type = t, o.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, x) : this.complete(o);
              },
              complete: function complete(t, e) {
                if ("throw" === t.type) throw t.arg;
                return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), x;
              },
              finish: function finish(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var n = this.tryEntries[e];
                  if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), l(n), x;
                }
              },
              catch: function _catch(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var n = this.tryEntries[e];
                  if (n.tryLoc === t) {
                    var r = n.completion;
                    if ("throw" === r.type) {
                      var i = r.arg;
                      l(n);
                    }
                    return i;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(t, e, n) {
                return this.delegate = {
                  iterator: d(t),
                  resultName: e,
                  nextLoc: n
                }, "next" === this.method && (this.arg = void 0), x;
              }
            }, t;
          }(t.exports);
          try {
            regeneratorRuntime = r;
          } catch (t) {
            Function("r", "regeneratorRuntime = r")(r);
          }
        }, function (t, e, n) {
          var r = n(75);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(59),
            i = n(60),
            o = function o(t) {
              return function (e, n) {
                var o,
                  a,
                  s = String(i(e)),
                  u = r(n),
                  c = s.length;
                return u < 0 || u >= c ? t ? "" : void 0 : (o = s.charCodeAt(u)) < 55296 || o > 56319 || u + 1 === c || (a = s.charCodeAt(u + 1)) < 56320 || a > 57343 ? t ? s.charAt(u) : o : t ? s.slice(u, u + 2) : a - 56320 + (o - 55296 << 10) + 65536;
              };
            };
          t.exports = {
            codeAt: o(!1),
            charAt: o(!0)
          };
        }, function (t, e, n) {
          var r = n(3),
            i = n(77),
            o = r.WeakMap;
          t.exports = "function" == typeof o && /native code/.test(i(o));
        }, function (t, e) {
          var n;
          n = function () {
            return this;
          }();
          try {
            n = n || new Function("return this")();
          } catch (t) {
            "object" == ("undefined" == typeof window ? "undefined" : (0, j.default)(window)) && (n = window);
          }
          t.exports = n;
        }, function (t, e, n) {
          var r = n(3),
            i = n(11);
          t.exports = function (t, e) {
            try {
              i(r, t, e);
            } catch (n) {
              r[t] = e;
            }
            return e;
          };
        }, function (t, e, n) {
          var r = n(83).IteratorPrototype,
            i = n(67),
            o = n(19),
            a = n(23),
            s = n(18),
            u = function u() {
              return this;
            };
          t.exports = function (t, e, n) {
            var c = e + " Iterator";
            return t.prototype = i(r, {
              next: o(1, n)
            }), a(t, c, !1, !0), s[c] = u, t;
          };
        }, function (t, e, n) {
          var r = n(4);
          t.exports = !r(function () {
            function t() {}
            return t.prototype.constructor = null, (0, y.default)(new t()) !== t.prototype;
          });
        }, function (t, e, n) {
          var r = n(59),
            i = Math.max,
            o = Math.min;
          t.exports = function (t, e) {
            var n = r(t);
            return n < 0 ? i(n + e, 0) : o(n, e);
          };
        }, function (t, e, n) {
          var r = n(69),
            i = n(30);
          t.exports = r ? {}.toString : function () {
            return "[object " + i(this) + "]";
          };
        }, function (t, e, n) {
          var r = n(12);
          t.exports = function (t) {
            if (!r(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
            return t;
          };
        }, function (t, e) {
          t.exports = function () {};
        }, function (t, e) {
          t.exports = {
            CSSRuleList: 0,
            CSSStyleDeclaration: 0,
            CSSValueList: 0,
            ClientRectList: 0,
            DOMRectList: 0,
            DOMStringList: 0,
            DOMTokenList: 1,
            DataTransferItemList: 0,
            FileList: 0,
            HTMLAllCollection: 0,
            HTMLCollection: 0,
            HTMLFormElement: 0,
            HTMLSelectElement: 0,
            MediaList: 0,
            MimeTypeArray: 0,
            NamedNodeMap: 0,
            NodeList: 1,
            PaintRequestList: 0,
            Plugin: 0,
            PluginArray: 0,
            SVGLengthList: 0,
            SVGNumberList: 0,
            SVGPathSegList: 0,
            SVGPointList: 0,
            SVGStringList: 0,
            SVGTransformList: 0,
            SourceBufferList: 0,
            StyleSheetList: 0,
            TextTrackCueList: 0,
            TextTrackList: 0,
            TouchList: 0
          };
        }, function (t, e, n) {
          var r,
            i,
            o,
            a,
            s = n(0),
            u = n(20),
            c = n(3),
            l = n(16),
            f = n(91),
            p = n(31),
            d = n(128),
            h = n(23),
            m = n(129),
            g = n(12),
            v = n(22),
            y = n(130),
            _ = n(21),
            b = n(77),
            w = n(33),
            S = n(133),
            x = n(93),
            E = n(94).set,
            T = n(134),
            k = n(97),
            A = n(135),
            O = n(34),
            C = n(47),
            I = n(27),
            R = n(82),
            P = n(2),
            N = n(70),
            M = P("species"),
            L = "Promise",
            F = I.get,
            D = I.set,
            j = I.getterFor(L),
            _U = f,
            B = c.TypeError,
            V = c.document,
            q = c.process,
            H = l("fetch"),
            W = O.f,
            $ = W,
            z = "process" == _(q),
            G = !!(V && V.createEvent && c.dispatchEvent),
            K = R(L, function () {
              if (b(_U) === String(_U)) {
                if (66 === N) return !0;
                if (!z && "function" != typeof PromiseRejectionEvent) return !0;
              }
              if (u && !_U.prototype.finally) return !0;
              if (N >= 51 && /native code/.test(_U)) return !1;
              var t = _U.resolve(1),
                e = function e(t) {
                  t(function () {}, function () {});
                };
              return (t.constructor = {})[M] = e, !(t.then(function () {}) instanceof e);
            }),
            Y = K || !S(function (t) {
              _U.all(t).catch(function () {});
            }),
            J = function J(t) {
              var e;
              return !(!g(t) || "function" != typeof (e = t.then)) && e;
            },
            Q = function Q(t, e, n) {
              if (!e.notified) {
                e.notified = !0;
                var r = e.reactions;
                T(function () {
                  for (var i = e.value, o = 1 == e.state, a = 0; r.length > a;) {
                    var s,
                      u,
                      c,
                      l = r[a++],
                      f = o ? l.ok : l.fail,
                      p = l.resolve,
                      d = l.reject,
                      h = l.domain;
                    try {
                      f ? (o || (2 === e.rejection && et(t, e), e.rejection = 1), !0 === f ? s = i : (h && h.enter(), s = f(i), h && (h.exit(), c = !0)), s === l.promise ? d(B("Promise-chain cycle")) : (u = J(s)) ? u.call(s, p, d) : p(s)) : d(i);
                    } catch (t) {
                      h && !c && h.exit(), d(t);
                    }
                  }
                  e.reactions = [], e.notified = !1, n && !e.rejection && Z(t, e);
                });
              }
            },
            X = function X(t, e, n) {
              var r, i;
              G ? ((r = V.createEvent("Event")).promise = e, r.reason = n, r.initEvent(t, !1, !0), c.dispatchEvent(r)) : r = {
                promise: e,
                reason: n
              }, (i = c["on" + t]) ? i(r) : "unhandledrejection" === t && A("Unhandled promise rejection", n);
            },
            Z = function Z(t, e) {
              E.call(c, function () {
                var n,
                  r = e.value;
                if (tt(e) && (n = C(function () {
                  z ? q.emit("unhandledRejection", r, t) : X("unhandledrejection", t, r);
                }), e.rejection = z || tt(e) ? 2 : 1, n.error)) throw n.value;
              });
            },
            tt = function tt(t) {
              return 1 !== t.rejection && !t.parent;
            },
            et = function et(t, e) {
              E.call(c, function () {
                z ? q.emit("rejectionHandled", t) : X("rejectionhandled", t, e.value);
              });
            },
            nt = function nt(t, e, n, r) {
              return function (i) {
                t(e, n, i, r);
              };
            },
            rt = function rt(t, e, n, r) {
              e.done || (e.done = !0, r && (e = r), e.value = n, e.state = 2, Q(t, e, !0));
            },
            it = function t(e, n, r, i) {
              if (!n.done) {
                n.done = !0, i && (n = i);
                try {
                  if (e === r) throw B("Promise can't be resolved itself");
                  var o = J(r);
                  o ? T(function () {
                    var i = {
                      done: !1
                    };
                    try {
                      o.call(r, nt(t, e, i, n), nt(rt, e, i, n));
                    } catch (t) {
                      rt(e, i, t, n);
                    }
                  }) : (n.value = r, n.state = 1, Q(e, n, !1));
                } catch (r) {
                  rt(e, {
                    done: !1
                  }, r, n);
                }
              }
            };
          K && (_U = function U(t) {
            y(this, _U, L), v(t), r.call(this);
            var e = F(this);
            try {
              t(nt(it, this, e), nt(rt, this, e));
            } catch (t) {
              rt(this, e, t);
            }
          }, (r = function r(t) {
            D(this, {
              type: L,
              done: !1,
              notified: !1,
              parent: !1,
              reactions: [],
              rejection: !1,
              state: 0,
              value: void 0
            });
          }).prototype = d(_U.prototype, {
            then: function then(t, e) {
              var n = j(this),
                r = W(x(this, _U));
              return r.ok = "function" != typeof t || t, r.fail = "function" == typeof e && e, r.domain = z ? q.domain : void 0, n.parent = !0, n.reactions.push(r), 0 != n.state && Q(this, n, !1), r.promise;
            },
            catch: function _catch(t) {
              return this.then(void 0, t);
            }
          }), i = function i() {
            var t = new r(),
              e = F(t);
            this.promise = t, this.resolve = nt(it, t, e), this.reject = nt(rt, t, e);
          }, O.f = W = function W(t) {
            return t === _U || t === o ? new i(t) : $(t);
          }, u || "function" != typeof f || (a = f.prototype.then, p(f.prototype, "then", function (t, e) {
            var n = this;
            return new _U(function (t, e) {
              a.call(n, t, e);
            }).then(t, e);
          }, {
            unsafe: !0
          }), "function" == typeof H && s({
            global: !0,
            enumerable: !0,
            forced: !0
          }, {
            fetch: function fetch(t) {
              return k(_U, H.apply(c, arguments));
            }
          }))), s({
            global: !0,
            wrap: !0,
            forced: K
          }, {
            Promise: _U
          }), h(_U, L, !1, !0), m(L), o = l(L), s({
            target: L,
            stat: !0,
            forced: K
          }, {
            reject: function reject(t) {
              var e = W(this);
              return e.reject.call(void 0, t), e.promise;
            }
          }), s({
            target: L,
            stat: !0,
            forced: u || K
          }, {
            resolve: function resolve(t) {
              return k(u && this === o ? _U : this, t);
            }
          }), s({
            target: L,
            stat: !0,
            forced: Y
          }, {
            all: function all(t) {
              var e = this,
                n = W(e),
                r = n.resolve,
                i = n.reject,
                o = C(function () {
                  var n = v(e.resolve),
                    o = [],
                    a = 0,
                    s = 1;
                  w(t, function (t) {
                    var u = a++,
                      c = !1;
                    o.push(void 0), s++, n.call(e, t).then(function (t) {
                      c || (c = !0, o[u] = t, --s || r(o));
                    }, i);
                  }), --s || r(o);
                });
              return o.error && i(o.value), n.promise;
            },
            race: function race(t) {
              var e = this,
                n = W(e),
                r = n.reject,
                i = C(function () {
                  var i = v(e.resolve);
                  w(t, function (t) {
                    i.call(e, t).then(n.resolve, r);
                  });
                });
              return i.error && r(i.value), n.promise;
            }
          });
        }, function (t, e, n) {
          var r = n(31);
          t.exports = function (t, e, n) {
            for (var i in e) n && n.unsafe && t[i] ? t[i] = e[i] : r(t, i, e[i], n);
            return t;
          };
        }, function (t, e, n) {
          var r = n(16),
            i = n(14),
            o = n(2),
            a = n(6),
            s = o("species");
          t.exports = function (t) {
            var e = r(t),
              n = i.f;
            a && e && !e[s] && n(e, s, {
              configurable: !0,
              get: function get() {
                return this;
              }
            });
          };
        }, function (t, e) {
          t.exports = function (t, e, n) {
            if (!(t instanceof e)) throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
            return t;
          };
        }, function (t, e, n) {
          var r = n(2),
            i = n(18),
            o = r("iterator"),
            a = Array.prototype;
          t.exports = function (t) {
            return void 0 !== t && (i.Array === t || a[o] === t);
          };
        }, function (t, e, n) {
          var r = n(9);
          t.exports = function (t, e, n, i) {
            try {
              return i ? e(r(n)[0], n[1]) : e(n);
            } catch (e) {
              var o = t.return;
              throw void 0 !== o && r(o.call(t)), e;
            }
          };
        }, function (t, e, n) {
          var r = n(2)("iterator"),
            i = !1;
          try {
            var o = 0,
              a = {
                next: function next() {
                  return {
                    done: !!o++
                  };
                },
                return: function _return() {
                  i = !0;
                }
              };
            a[r] = function () {
              return this;
            }, (0, l.default)(a, function () {
              throw 2;
            });
          } catch (t) {}
          t.exports = function (t, e) {
            if (!e && !i) return !1;
            var n = !1;
            try {
              var o = {};
              o[r] = function () {
                return {
                  next: function next() {
                    return {
                      done: n = !0
                    };
                  }
                };
              }, t(o);
            } catch (t) {}
            return n;
          };
        }, function (t, e, n) {
          var r,
            i,
            o,
            a,
            s,
            u,
            c,
            l,
            f = n(3),
            p = n(28).f,
            d = n(21),
            h = n(94).set,
            m = n(95),
            g = f.MutationObserver || f.WebKitMutationObserver,
            v = f.process,
            y = f.Promise,
            _ = "process" == d(v),
            b = p(f, "queueMicrotask"),
            w = b && b.value;
          w || (r = function r() {
            var t, e;
            for (_ && (t = v.domain) && t.exit(); i;) {
              e = i.fn, i = i.next;
              try {
                e();
              } catch (t) {
                throw i ? a() : o = void 0, t;
              }
            }
            o = void 0, t && t.enter();
          }, _ ? a = function a() {
            v.nextTick(r);
          } : g && !m ? (s = !0, u = document.createTextNode(""), new g(r).observe(u, {
            characterData: !0
          }), a = function a() {
            u.data = s = !s;
          }) : y && y.resolve ? (c = y.resolve(void 0), l = c.then, a = function a() {
            l.call(c, r);
          }) : a = function a() {
            h.call(f, r);
          }), t.exports = w || function (t) {
            var e = {
              fn: t,
              next: void 0
            };
            o && (o.next = e), i || (i = e, a()), o = e;
          };
        }, function (t, e, n) {
          var r = n(3);
          t.exports = function (t, e) {
            var n = r.console;
            n && n.error && (1 === arguments.length ? n.error(t) : n.error(t, e));
          };
        }, function (t, e, n) {
          var r = n(0),
            i = n(20),
            o = n(91),
            a = n(4),
            s = n(16),
            u = n(93),
            c = n(97),
            l = n(31);
          r({
            target: "Promise",
            proto: !0,
            real: !0,
            forced: !!o && a(function () {
              o.prototype.finally.call({
                then: function then() {}
              }, function () {});
            })
          }, {
            finally: function _finally(t) {
              var e = u(this, s("Promise")),
                n = "function" == typeof t;
              return this.then(n ? function (n) {
                return c(e, t()).then(function () {
                  return n;
                });
              } : t, n ? function (n) {
                return c(e, t()).then(function () {
                  throw n;
                });
              } : t);
            }
          }), i || "function" != typeof o || o.prototype.finally || l(o.prototype, "finally", s("Promise").prototype.finally);
        }, function (t, e, n) {
          t.exports = n(138);
        }, function (t, e, n) {
          var r = n(75);
          n(139), n(140), n(141), n(142), t.exports = r;
        }, function (t, e, n) {
          var r = n(0),
            i = n(6),
            o = n(65),
            a = n(89),
            s = n(67),
            u = n(14),
            c = n(19),
            l = n(33),
            f = n(11),
            p = n(27),
            d = p.set,
            h = p.getterFor("AggregateError"),
            m = function t(e, n) {
              var r = this;
              if (!(r instanceof t)) return new t(e, n);
              a && (r = a(new Error(n), o(r)));
              var s = [];
              return l(e, s.push, s), i ? d(r, {
                errors: s,
                type: "AggregateError"
              }) : r.errors = s, void 0 !== n && f(r, "message", String(n)), r;
            };
          m.prototype = s(Error.prototype, {
            constructor: c(5, m),
            message: c(5, ""),
            name: c(5, "AggregateError")
          }), i && u.f(m.prototype, "errors", {
            get: function get() {
              return h(this).errors;
            },
            configurable: !0
          }), r({
            global: !0
          }, {
            AggregateError: m
          });
        }, function (t, e, n) {
          n(98);
        }, function (t, e, n) {
          var r = n(0),
            i = n(34),
            o = n(47);
          r({
            target: "Promise",
            stat: !0
          }, {
            try: function _try(t) {
              var e = i.f(this),
                n = o(t);
              return (n.error ? e.reject : e.resolve)(n.value), e.promise;
            }
          });
        }, function (t, e, n) {
          var r = n(0),
            i = n(22),
            o = n(16),
            a = n(34),
            s = n(47),
            u = n(33);
          r({
            target: "Promise",
            stat: !0
          }, {
            any: function any(t) {
              var e = this,
                n = a.f(e),
                r = n.resolve,
                c = n.reject,
                l = s(function () {
                  var n = i(e.resolve),
                    a = [],
                    s = 0,
                    l = 1,
                    f = !1;
                  u(t, function (t) {
                    var i = s++,
                      u = !1;
                    a.push(void 0), l++, n.call(e, t).then(function (t) {
                      u || f || (f = !0, r(t));
                    }, function (t) {
                      u || f || (u = !0, a[i] = t, --l || c(new (o("AggregateError"))(a, "No one promise resolved")));
                    });
                  }), --l || c(new (o("AggregateError"))(a, "No one promise resolved"));
                });
              return l.error && c(l.value), n.promise;
            }
          });
        }, function (t, e, n) {
          var r = n(144);
          t.exports = r;
        }, function (t, e, n) {
          n(145);
          var r = n(5);
          r.JSON || (r.JSON = {
            stringify: u.default
          }), t.exports = function (t, e, n) {
            return r.JSON.stringify.apply(null, arguments);
          };
        }, function (t, e, n) {
          var r = n(0),
            i = n(16),
            o = n(4),
            a = i("JSON", "stringify"),
            s = /[\uD800-\uDFFF]/g,
            u = /^[\uD800-\uDBFF]$/,
            c = /^[\uDC00-\uDFFF]$/,
            l = function l(t, e, n) {
              var r = n.charAt(e - 1),
                i = n.charAt(e + 1);
              return u.test(t) && !c.test(i) || c.test(t) && !u.test(r) ? "\\u" + t.charCodeAt(0).toString(16) : t;
            },
            f = o(function () {
              return "\"\\udf06\\ud834\"" !== a("��") || "\"\\udead\"" !== a("�");
            });
          a && r({
            target: "JSON",
            stat: !0,
            forced: f
          }, {
            stringify: function stringify(t, e, n) {
              var r = a.apply(null, arguments);
              return "string" == typeof r ? r.replace(s, l) : r;
            }
          });
        }, function (t, e, n) {
          var r = n(147);
          t.exports = function (t) {
            if (r(t)) return t;
          };
        }, function (t, e, n) {
          t.exports = n(148);
        }, function (t, e, n) {
          var r = n(99);
          t.exports = r;
        }, function (t, e, n) {
          n(0)({
            target: "Array",
            stat: !0
          }, {
            isArray: n(48)
          });
        }, function (t, e, n) {
          var r = n(52),
            i = n(153);
          t.exports = function (t, e) {
            if (i(Object(t)) || "[object Arguments]" === Object.prototype.toString.call(t)) {
              var n = [],
                o = !0,
                a = !1,
                s = void 0;
              try {
                for (var u, c = r(t); !(o = (u = c.next()).done) && (n.push(u.value), !e || n.length !== e); o = !0);
              } catch (t) {
                a = !0, s = t;
              } finally {
                try {
                  o || null == c.return || c.return();
                } finally {
                  if (a) throw s;
                }
              }
              return n;
            }
          };
        }, function (t, e, n) {
          n(32), n(40);
          var r = n(152);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(9),
            i = n(92);
          t.exports = function (t) {
            var e = i(t);
            if ("function" != typeof e) throw TypeError(String(t) + " is not iterable");
            return r(e.call(t));
          };
        }, function (t, e, n) {
          t.exports = n(154);
        }, function (t, e, n) {
          n(32), n(40);
          var r = n(155);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(30),
            i = n(2),
            o = n(18),
            a = i("iterator");
          t.exports = function (t) {
            var e = Object(t);
            return void 0 !== e[a] || "@@iterator" in e || o.hasOwnProperty(r(e));
          };
        }, function (t, e) {
          t.exports = function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          };
        }, function (t, e, n) {
          var r = n(158);
          t.exports = r;
        }, function (t, e, n) {
          n(159);
          var r = n(5);
          t.exports = r.Object.entries;
        }, function (t, e, n) {
          var r = n(0),
            i = n(160).entries;
          r({
            target: "Object",
            stat: !0
          }, {
            entries: function entries(t) {
              return i(t);
            }
          });
        }, function (t, e, n) {
          var r = n(6),
            i = n(45),
            o = n(15),
            a = n(64).f,
            s = function s(t) {
              return function (e) {
                for (var n, s = o(e), u = i(s), c = u.length, l = 0, f = []; c > l;) n = u[l++], r && !a.call(s, n) || f.push(t ? [n, s[n]] : s[n]);
                return f;
              };
            };
          t.exports = {
            entries: s(!0),
            values: s(!1)
          };
        }, function (t, e, n) {
          n(32);
          var r = n(162),
            i = n(30),
            o = Array.prototype,
            a = {
              DOMTokenList: !0,
              NodeList: !0
            };
          t.exports = function (t) {
            var e = t.forEach;
            return t === o || t instanceof Array && e === o.forEach || a.hasOwnProperty(i(t)) ? r : e;
          };
        }, function (t, e, n) {
          var r = n(163);
          t.exports = r;
        }, function (t, e, n) {
          n(164);
          var r = n(35);
          t.exports = r("Array").forEach;
        }, function (t, e, n) {
          var r = n(0),
            i = n(165);
          r({
            target: "Array",
            proto: !0,
            forced: [].forEach != i
          }, {
            forEach: i
          });
        }, function (t, e, n) {
          var r = n(49).forEach,
            i = n(101),
            o = n(50),
            a = i("forEach"),
            s = o("forEach");
          t.exports = a && s ? [].forEach : function (t) {
            return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
          };
        }, function (t, e, n) {
          var r = n(102);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(0),
            i = n(6);
          r({
            target: "Object",
            stat: !0,
            forced: !i,
            sham: !i
          }, {
            defineProperty: n(14).f
          });
        }, function (t, e, n) {
          var r = n(169);
          t.exports = r;
        }, function (t, e, n) {
          n(170);
          var r = n(5).Object,
            i = t.exports = function (t, e) {
              return r.defineProperties(t, e);
            };
          r.defineProperties.sham && (i.sham = !0);
        }, function (t, e, n) {
          var r = n(0),
            i = n(6);
          r({
            target: "Object",
            stat: !0,
            forced: !i,
            sham: !i
          }, {
            defineProperties: n(85)
          });
        }, function (t, e, n) {
          var r = n(172);
          t.exports = r;
        }, function (t, e, n) {
          n(173);
          var r = n(5);
          t.exports = r.Object.getOwnPropertyDescriptors;
        }, function (t, e, n) {
          var r = n(0),
            i = n(6),
            o = n(174),
            a = n(15),
            s = n(28),
            u = n(72);
          r({
            target: "Object",
            stat: !0,
            sham: !i
          }, {
            getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
              for (var e, n, r = a(t), i = s.f, c = o(r), l = {}, f = 0; c.length > f;) void 0 !== (n = i(r, e = c[f++])) && u(l, e, n);
              return l;
            }
          });
        }, function (t, e, n) {
          var r = n(16),
            i = n(71),
            o = n(103),
            a = n(9);
          t.exports = r("Reflect", "ownKeys") || function (t) {
            var e = i.f(a(t)),
              n = o.f;
            return n ? e.concat(n(t)) : e;
          };
        }, function (t, e, n) {
          var r = n(176);
          t.exports = r;
        }, function (t, e, n) {
          n(177);
          var r = n(5).Object,
            i = t.exports = function (t, e) {
              return r.getOwnPropertyDescriptor(t, e);
            };
          r.getOwnPropertyDescriptor.sham && (i.sham = !0);
        }, function (t, e, n) {
          var r = n(0),
            i = n(4),
            o = n(15),
            a = n(28).f,
            s = n(6),
            u = i(function () {
              a(1);
            });
          r({
            target: "Object",
            stat: !0,
            forced: !s || u,
            sham: !s
          }, {
            getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, e) {
              return a(o(t), e);
            }
          });
        }, function (t, e, n) {
          var r = n(104);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(15),
            i = n(71).f,
            o = {}.toString,
            a = "object" == ("undefined" == typeof window ? "undefined" : (0, j.default)(window)) && window && E.default ? (0, E.default)(window) : [];
          t.exports.f = function (t) {
            return a && "[object Window]" == o.call(t) ? function (t) {
              try {
                return i(t);
              } catch (t) {
                return a.slice();
              }
            }(t) : i(r(t));
          };
        }, function (t, e, n) {
          var r = n(181);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(182),
            i = Array.prototype;
          t.exports = function (t) {
            var e = t.concat;
            return t === i || t instanceof Array && e === i.concat ? r : e;
          };
        }, function (t, e, n) {
          n(106);
          var r = n(35);
          t.exports = r("Array").concat;
        }, function (t, e, n) {
          t.exports = n(184);
        }, function (t, e, n) {
          var r = n(102);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(186);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(187),
            i = Array.prototype;
          t.exports = function (t) {
            var e = t.indexOf;
            return t === i || t instanceof Array && e === i.indexOf ? r : e;
          };
        }, function (t, e, n) {
          n(188);
          var r = n(35);
          t.exports = r("Array").indexOf;
        }, function (t, e, n) {
          var r = n(0),
            i = n(87).indexOf,
            o = n(101),
            a = n(50),
            s = [].indexOf,
            u = !!s && 1 / [1].indexOf(1, -0) < 0,
            c = o("indexOf"),
            l = a("indexOf", {
              ACCESSORS: !0,
              1: 0
            });
          r({
            target: "Array",
            proto: !0,
            forced: u || !c || !l
          }, {
            indexOf: function indexOf(t) {
              return u ? s.apply(this, arguments) || 0 : i(this, t, arguments.length > 1 ? arguments[1] : void 0);
            }
          });
        }, function (t, e, n) {
          t.exports = n(190);
        }, function (t, e, n) {
          var r = n(104);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(107),
            i = n(192);
          t.exports = function (t, e) {
            if (null == t) return {};
            var n,
              o,
              a = {},
              s = i(t);
            for (o = 0; o < s.length; o++) n = s[o], r(e).call(e, n) >= 0 || (a[n] = t[n]);
            return a;
          };
        }, function (t, e, n) {
          t.exports = n(193);
        }, function (t, e, n) {
          var r = n(108);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(0),
            i = n(29),
            o = n(45);
          r({
            target: "Object",
            stat: !0,
            forced: n(4)(function () {
              o(1);
            })
          }, {
            keys: function keys(t) {
              return o(i(t));
            }
          });
        }, function (t, e, n) {
          t.exports = n(196);
        }, function (t, e, n) {
          var r = n(197);
          t.exports = r;
        }, function (t, e, n) {
          n(109), n(40), n(32);
          var r = n(73);
          t.exports = r.f("iterator");
        }, function (t, e, n) {
          t.exports = n(199);
        }, function (t, e, n) {
          var r = n(200);
          n(216), n(217), n(218), n(219), n(220), t.exports = r;
        }, function (t, e, n) {
          n(106), n(76), n(105), n(201), n(202), n(203), n(204), n(109), n(205), n(206), n(207), n(208), n(209), n(210), n(211), n(212), n(213), n(214), n(215);
          var r = n(5);
          t.exports = r.Symbol;
        }, function (t, e, n) {
          n(1)("asyncIterator");
        }, function (t, e) {}, function (t, e, n) {
          n(1)("hasInstance");
        }, function (t, e, n) {
          n(1)("isConcatSpreadable");
        }, function (t, e, n) {
          n(1)("match");
        }, function (t, e, n) {
          n(1)("matchAll");
        }, function (t, e, n) {
          n(1)("replace");
        }, function (t, e, n) {
          n(1)("search");
        }, function (t, e, n) {
          n(1)("species");
        }, function (t, e, n) {
          n(1)("split");
        }, function (t, e, n) {
          n(1)("toPrimitive");
        }, function (t, e, n) {
          n(1)("toStringTag");
        }, function (t, e, n) {
          n(1)("unscopables");
        }, function (t, e, n) {
          n(23)(Math, "Math", !0);
        }, function (t, e, n) {
          var r = n(3);
          n(23)(r.JSON, "JSON", !0);
        }, function (t, e, n) {
          n(1)("asyncDispose");
        }, function (t, e, n) {
          n(1)("dispose");
        }, function (t, e, n) {
          n(1)("observable");
        }, function (t, e, n) {
          n(1)("patternMatch");
        }, function (t, e, n) {
          n(1)("replaceAll");
        }, function (t, e, n) {
          var r = n(108);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(223);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(224),
            i = Array.prototype;
          t.exports = function (t) {
            var e = t.filter;
            return t === i || t instanceof Array && e === i.filter ? r : e;
          };
        }, function (t, e, n) {
          n(225);
          var r = n(35);
          t.exports = r("Array").filter;
        }, function (t, e, n) {
          var r = n(0),
            i = n(49).filter,
            o = n(74),
            a = n(50),
            s = o("filter"),
            u = a("filter");
          r({
            target: "Array",
            proto: !0,
            forced: !s || !u
          }, {
            filter: function filter(t) {
              return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
            }
          });
        }, function (t, e, n) {
          var r = n(227);
          t.exports = r;
        }, function (t, e, n) {
          var r = n(228),
            i = Array.prototype;
          t.exports = function (t) {
            var e = t.map;
            return t === i || t instanceof Array && e === i.map ? r : e;
          };
        }, function (t, e, n) {
          n(229);
          var r = n(35);
          t.exports = r("Array").map;
        }, function (t, e, n) {
          var r = n(0),
            i = n(49).map,
            o = n(74),
            a = n(50),
            s = o("map"),
            u = a("map");
          r({
            target: "Array",
            proto: !0,
            forced: !s || !u
          }, {
            map: function map(t) {
              return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
            }
          });
        }, function (t, e, n) {
          var r = n(231);
          t.exports = r;
        }, function (t, e, n) {
          n(90), n(232);
          var r = n(5);
          t.exports = r.Object.fromEntries;
        }, function (t, e, n) {
          var r = n(0),
            i = n(33),
            o = n(72);
          r({
            target: "Object",
            stat: !0
          }, {
            fromEntries: function fromEntries(t) {
              var e = {};
              return i(t, function (t, n) {
                o(e, t, n);
              }, void 0, !0), e;
            }
          });
        }, function (t, e, n) {
          var r = n(99);
          t.exports = r;
        }, function (t, e, n) {
          function r(t, e) {
            var n = H()(t);
            if (N.a) {
              var r = N()(t);
              e && (r = $()(r).call(r, function (e) {
                return R()(t, e).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function i(t) {
            for (var e = 1; e < arguments.length; e++) {
              var n,
                i = null != arguments[e] ? arguments[e] : {};
              if (e % 2) x()(n = r(Object(i), !0)).call(n, function (e) {
                D()(t, e, i[e]);
              });else if (C.a) A()(t, C()(i));else {
                var o;
                x()(o = r(Object(i))).call(o, function (e) {
                  T()(t, e, R()(i, e));
                });
              }
            }
            return t;
          }
          function o(t, e) {
            var n = H()(t);
            if (N.a) {
              var r = N()(t);
              e && (r = $()(r).call(r, function (e) {
                return R()(t, e).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          n.r(e);
          var a,
            s = n(7),
            u = n.n(s),
            c = n(8),
            l = n.n(c),
            f = n(17),
            p = n.n(f),
            d = n(36),
            h = n.n(d),
            m = n(37),
            g = n.n(m),
            v = function () {
              var t = p()(u.a.mark(function t(e) {
                var n, r, i;
                return u.a.wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return n = e.domain, r = e.stateHandle, i = "".concat(n, "/idp/idx/introspect"), t.abrupt("return", g()(i, {
                        method: "POST",
                        headers: {
                          "content-type": "application/json"
                        },
                        body: h()({
                          stateToken: r
                        })
                      }).then(function (t) {
                        return t.ok ? t.json() : t.json().then(function (t) {
                          return l.a.reject(t);
                        });
                      }));
                    case 3:
                    case "end":
                      return t.stop();
                  }
                }, t);
              }));
              return function (e) {
                return t.apply(this, arguments);
              };
            }(),
            y = n(51),
            _ = n.n(y),
            b = n(53),
            w = n.n(b),
            S = n(13),
            x = n.n(S),
            E = n(54),
            T = n.n(E),
            k = n(55),
            A = n.n(k),
            O = n(24),
            C = n.n(O),
            I = n(25),
            R = n.n(I),
            P = n(26),
            N = n.n(P),
            M = n(110),
            L = n.n(M),
            F = n(56),
            D = n.n(F),
            j = n(111),
            U = n.n(j),
            B = n(112),
            V = n.n(B),
            q = n(38),
            H = n.n(q),
            W = n(39),
            $ = n.n(W),
            z = n(57),
            G = n.n(z),
            K = n(58),
            Y = n.n(K),
            J = n(113),
            Q = n.n(J),
            X = n(52),
            Z = n.n(X),
            tt = function tt(t) {
              return !(t.visible || !t.value);
            },
            et = function et(t) {
              var e = [],
                n = {},
                r = !0,
                i = !1,
                o = void 0;
              try {
                for (var a, s = Z()(t.value); !(r = (a = s.next()).done); r = !0) {
                  var u,
                    c = a.value;
                  tt(c) ? n[c.name] = null !== (u = c.value) && void 0 !== u ? u : "" : e.push(c);
                }
              } catch (t) {
                i = !0, o = t;
              } finally {
                try {
                  r || null == s.return || s.return();
                } finally {
                  if (i) throw o;
                }
              }
              return {
                neededParamsForAction: e,
                existingParamsForAction: n
              };
            },
            nt = function nt(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = t.href;
              return function () {
                var r = p()(u.a.mark(function r(o) {
                  return u.a.wrap(function (r) {
                    for (;;) switch (r.prev = r.next) {
                      case 0:
                        return r.abrupt("return", g()(n, {
                          method: t.method,
                          headers: {
                            "content-type": t.accepts
                          },
                          body: h()(i({}, o, {}, e))
                        }).then(function (t) {
                          var e = t.json();
                          return t.ok ? e : 401 === t.status && 'Oktadevicejwt realm="Okta Device"' === t.headers.get("WWW-Authenticate") ? e.then(function (t) {
                            return l.a.reject(ut(t));
                          }) : e.then(function (t) {
                            return l.a.reject(t);
                          });
                        }).then(function (t) {
                          return ut(t);
                        }));
                      case 1:
                      case "end":
                        return r.stop();
                    }
                  }, r);
                }));
                return function (t) {
                  return r.apply(this, arguments);
                };
              }();
            },
            rt = function rt(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = t.href;
              return function () {
                var r = p()(u.a.mark(function r(o) {
                  return u.a.wrap(function (r) {
                    for (;;) switch (r.prev = r.next) {
                      case 0:
                        return r.abrupt("return", g()(n, {
                          method: t.method,
                          headers: {
                            "content-type": t.accepts
                          },
                          body: h()(i({}, o, {}, e))
                        }).then(function (t) {
                          return t.ok ? t.json() : t.json().then(function (t) {
                            return l.a.reject(t);
                          });
                        }).then(function (t) {
                          return ut(t);
                        }));
                      case 1:
                      case "end":
                        return r.stop();
                    }
                  }, r);
                }));
                return function (t) {
                  return r.apply(this, arguments);
                };
              }();
            },
            it = function it(t) {
              var e = t.refresh ? rt : nt,
                n = function (t) {
                  t = Q()(t) ? t : [t];
                  var e = {},
                    n = {},
                    r = !0,
                    i = !1,
                    o = void 0;
                  try {
                    for (var a, s = Z()(t); !(r = (a = s.next()).done); r = !0) {
                      var u = a.value,
                        c = et(u),
                        l = c.neededParamsForAction,
                        f = c.existingParamsForAction;
                      e[u.name] = l, n[u.name] = f;
                    }
                  } catch (t) {
                    i = !0, o = t;
                  } finally {
                    try {
                      r || null == s.return || s.return();
                    } finally {
                      if (i) throw o;
                    }
                  }
                  return {
                    neededParams: e,
                    existingParams: n
                  };
                }(t),
                r = n.neededParams,
                i = e(t, n.existingParams[t.name]);
              return i.neededParams = r[t.name], i;
            },
            ot = Y()(G()(a = ["remediation", "context"]).call(a, function (t) {
              return [t, !0];
            })),
            at = function at(t) {
              var e,
                n,
                r = {},
                i = {};
              return x()(e = $()(n = H()(t)).call(n, function (t) {
                return !ot[t];
              })).call(e, function (e) {
                var n;
                if ("object" === V()(t[e]) && t[e]) {
                  if (t[e].rel) r[t[e].name] = it(t[e]);else {
                    var a = t[e],
                      s = a.value,
                      u = a.type,
                      c = U()(a, ["value", "type"]);
                    i[e] = function (t) {
                      for (var e = 1; e < arguments.length; e++) {
                        var n,
                          r = null != arguments[e] ? arguments[e] : {};
                        if (e % 2) x()(n = o(Object(r), !0)).call(n, function (e) {
                          D()(t, e, r[e]);
                        });else if (C.a) A()(t, C()(r));else {
                          var i;
                          x()(i = o(Object(r))).call(i, function (e) {
                            T()(t, e, R()(r, e));
                          });
                        }
                      }
                      return t;
                    }({
                      type: u
                    }, c), "object" === u ? (i[e].value = {}, x()(n = w()(s)).call(n, function (t) {
                      var n,
                        o = _()(t, 2),
                        a = o[0],
                        s = o[1];
                      s.rel ? r[L()(n = "".concat(e, "-")).call(n, a.name || a)] = it(s) : i[e].value[a] = s;
                    })) : i[e].value = s;
                  }
                } else i[e] = t[e];
              }), {
                context: i,
                actions: r
              };
            },
            st = function st(t) {
              var e,
                n,
                r = (n = (null === (e = t.remediation) || void 0 === e ? void 0 : e.value) || [], Y()(G()(n).call(n, function (t) {
                  return [t.name, it(t)];
                }))),
                i = at(t);
              return {
                remediations: r,
                context: i.context,
                actions: i.actions
              };
            },
            ut = function ut(t) {
              var e,
                n = st(t),
                r = n.remediations,
                i = n.context,
                o = n.actions,
                a = {};
              return x()(e = w()(r)).call(e, function (t) {
                var e = _()(t, 2),
                  n = e[0],
                  r = e[1];
                a[n] = r.neededParams;
              }), {
                proceed: function () {
                  var t = p()(u.a.mark(function t(e) {
                    var n,
                      i = arguments;
                    return u.a.wrap(function (t) {
                      for (;;) switch (t.prev = t.next) {
                        case 0:
                          if (n = i.length > 1 && void 0 !== i[1] ? i[1] : {}, r[e]) {
                            t.next = 3;
                            break;
                          }
                          return t.abrupt("return", l.a.reject("Unknown remediation choice: [".concat(e, "]")));
                        case 3:
                          return t.abrupt("return", r[e](n));
                        case 4:
                        case "end":
                          return t.stop();
                      }
                    }, t);
                  }));
                  return function (e) {
                    return t.apply(this, arguments);
                  };
                }(),
                neededToProceed: a,
                actions: o,
                context: i,
                rawIdxState: t
              };
            },
            ct = function () {
              var t = p()(u.a.mark(function t(e) {
                var n, r, i, o;
                return u.a.wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      if (n = e.domain, r = e.stateHandle) {
                        t.next = 3;
                        break;
                      }
                      return t.abrupt("return", l.a.reject({
                        error: "stateHandle is required"
                      }));
                    case 3:
                      if (n) {
                        t.next = 5;
                        break;
                      }
                      return t.abrupt("return", l.a.reject({
                        error: "domain is required"
                      }));
                    case 5:
                      return t.next = 7, v({
                        domain: n,
                        stateHandle: r
                      }).catch(function (t) {
                        return l.a.reject({
                          error: "introspect call failed",
                          details: t
                        });
                      });
                    case 7:
                      return i = t.sent, o = ut(i), t.abrupt("return", o);
                    case 10:
                    case "end":
                      return t.stop();
                  }
                }, t);
              }));
              return function (e) {
                return t.apply(this, arguments);
              };
            }();
          e.default = {
            start: ct
          };
        }]);
      });
    }).call(e, n(234)(t));
  }, function (t, e, n) {
    t.exports = {
      default: n(498),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(90), n(499), t.exports = n(9).Array.from;
  }, function (t, e, n) {
    "use strict";

    var r = n(78),
      i = n(21),
      o = n(82),
      a = n(235),
      s = n(236),
      u = n(159),
      c = n(500),
      l = n(169);
    i(i.S + i.F * !n(237)(function (t) {
      Array.from(t);
    }), "Array", {
      from: function from(t) {
        var e,
          n,
          i,
          f,
          p = o(t),
          d = "function" == typeof this ? this : Array,
          h = arguments.length,
          m = h > 1 ? arguments[1] : void 0,
          g = void 0 !== m,
          v = 0,
          y = l(p);
        if (g && (m = r(m, h > 2 ? arguments[2] : void 0, 2)), void 0 == y || d == Array && s(y)) for (e = u(p.length), n = new d(e); e > v; v++) c(n, v, g ? m(p[v], v) : p[v]);else for (f = y.call(p), n = new d(); !(i = f.next()).done; v++) c(n, v, g ? a(f, m, [i.value, v], !0) : i.value);
        return n.length = v, n;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(50),
      i = n(92);
    t.exports = function (t, e, n) {
      e in t ? r.f(t, e, i(0, n)) : t[e] = n;
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(502),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(503), t.exports = n(9).Object.setPrototypeOf;
  }, function (t, e, n) {
    var r = n(21);
    r(r.S, "Object", {
      setPrototypeOf: n(504).set
    });
  }, function (t, e, n) {
    var r = n(46),
      i = n(45),
      o = function o(t, e) {
        if (i(t), !r(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
      };
    t.exports = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, r) {
        try {
          r = n(78)(Function.call, n(165).f(Object.prototype, "__proto__").set, 2), r(t, []), e = !(t instanceof Array);
        } catch (t) {
          e = !0;
        }
        return function (t, n) {
          return o(t, n), e ? t.__proto__ = n : r(t, n), t;
        };
      }({}, !1) : void 0),
      check: o
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(506),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(507);
    var r = n(9).Object;
    t.exports = function (t, e) {
      return r.defineProperties(t, e);
    };
  }, function (t, e, n) {
    var r = n(21);
    r(r.S + r.F * !n(39), "Object", {
      defineProperties: n(223)
    });
  }, function (t, e, n) {
    t.exports = {
      default: n(509),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(229), t.exports = n(9).Object.getOwnPropertySymbols;
  }, function (t, e, n) {
    t.exports = {
      default: n(511),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(512), t.exports = n(9).Object.getPrototypeOf;
  }, function (t, e, n) {
    var r = n(82),
      i = n(227);
    n(95)("getPrototypeOf", function () {
      return function (t) {
        return i(r(t));
      };
    });
  }, function (t, e, n) {
    n(514), t.exports = n(9).Object.keys;
  }, function (t, e, n) {
    var r = n(82),
      i = n(81);
    n(95)("keys", function () {
      return function (t) {
        return i(r(t));
      };
    });
  }, function (t, e, n) {
    n(166), n(90), n(118), n(516), n(524), n(525), t.exports = n(9).Promise;
  }, function (t, e, n) {
    "use strict";

    var r,
      i,
      o,
      a,
      s = n(91),
      u = n(22),
      c = n(78),
      l = n(170),
      f = n(21),
      p = n(46),
      d = n(115),
      h = n(517),
      m = n(518),
      g = n(238),
      v = n(239).set,
      y = n(520)(),
      _ = n(173),
      b = n(240),
      w = n(521),
      S = n(241),
      x = u.TypeError,
      E = u.process,
      T = E && E.versions,
      k = T && T.v8 || "",
      _A2 = u.Promise,
      O = "process" == l(E),
      C = function C() {},
      I = i = _.f,
      R = !!function () {
        try {
          var t = _A2.resolve(1),
            e = (t.constructor = {})[n(23)("species")] = function (t) {
              t(C, C);
            };
          return (O || "function" == typeof PromiseRejectionEvent) && t.then(C) instanceof e && 0 !== k.indexOf("6.6") && -1 === w.indexOf("Chrome/66");
        } catch (t) {}
      }(),
      P = function P(t) {
        var e;
        return !(!p(t) || "function" != typeof (e = t.then)) && e;
      },
      N = function N(t, e) {
        if (!t._n) {
          t._n = !0;
          var n = t._c;
          y(function () {
            for (var r = t._v, i = 1 == t._s, o = 0; n.length > o;) !function (e) {
              var n,
                o,
                a,
                s = i ? e.ok : e.fail,
                u = e.resolve,
                c = e.reject,
                l = e.domain;
              try {
                s ? (i || (2 == t._h && F(t), t._h = 1), !0 === s ? n = r : (l && l.enter(), n = s(r), l && (l.exit(), a = !0)), n === e.promise ? c(x("Promise-chain cycle")) : (o = P(n)) ? o.call(n, u, c) : u(n)) : c(r);
              } catch (t) {
                l && !a && l.exit(), c(t);
              }
            }(n[o++]);
            t._c = [], t._n = !1, e && !t._h && M(t);
          });
        }
      },
      M = function M(t) {
        v.call(u, function () {
          var e,
            n,
            r,
            i = t._v,
            o = L(t);
          if (o && (e = b(function () {
            O ? E.emit("unhandledRejection", i, t) : (n = u.onunhandledrejection) ? n({
              promise: t,
              reason: i
            }) : (r = u.console) && r.error && r.error("Unhandled promise rejection", i);
          }), t._h = O || L(t) ? 2 : 1), t._a = void 0, o && e.e) throw e.v;
        });
      },
      L = function L(t) {
        return 1 !== t._h && 0 === (t._a || t._c).length;
      },
      F = function F(t) {
        v.call(u, function () {
          var e;
          O ? E.emit("rejectionHandled", t) : (e = u.onrejectionhandled) && e({
            promise: t,
            reason: t._v
          });
        });
      },
      D = function D(t) {
        var e = this;
        e._d || (e._d = !0, e = e._w || e, e._v = t, e._s = 2, e._a || (e._a = e._c.slice()), N(e, !0));
      },
      j = function j(t) {
        var e,
          n = this;
        if (!n._d) {
          n._d = !0, n = n._w || n;
          try {
            if (n === t) throw x("Promise can't be resolved itself");
            (e = P(t)) ? y(function () {
              var r = {
                _w: n,
                _d: !1
              };
              try {
                e.call(t, c(j, r, 1), c(D, r, 1));
              } catch (t) {
                D.call(r, t);
              }
            }) : (n._v = t, n._s = 1, N(n, !1));
          } catch (t) {
            D.call({
              _w: n,
              _d: !1
            }, t);
          }
        }
      };
    R || (_A2 = function A(t) {
      h(this, _A2, "Promise", "_h"), d(t), r.call(this);
      try {
        t(c(j, this, 1), c(D, this, 1));
      } catch (t) {
        D.call(this, t);
      }
    }, r = function r(t) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }, r.prototype = n(522)(_A2.prototype, {
      then: function then(t, e) {
        var n = I(g(this, _A2));
        return n.ok = "function" != typeof t || t, n.fail = "function" == typeof e && e, n.domain = O ? E.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && N(this, !1), n.promise;
      },
      catch: function _catch(t) {
        return this.then(void 0, t);
      }
    }), o = function o() {
      var t = new r();
      this.promise = t, this.resolve = c(j, t, 1), this.reject = c(D, t, 1);
    }, _.f = I = function I(t) {
      return t === _A2 || t === a ? new o(t) : i(t);
    }), f(f.G + f.W + f.F * !R, {
      Promise: _A2
    }), n(117)(_A2, "Promise"), n(523)("Promise"), a = n(9).Promise, f(f.S + f.F * !R, "Promise", {
      reject: function reject(t) {
        var e = I(this);
        return (0, e.reject)(t), e.promise;
      }
    }), f(f.S + f.F * (s || !R), "Promise", {
      resolve: function resolve(t) {
        return S(s && this === a ? _A2 : this, t);
      }
    }), f(f.S + f.F * !(R && n(237)(function (t) {
      _A2.all(t).catch(C);
    })), "Promise", {
      all: function all(t) {
        var e = this,
          n = I(e),
          r = n.resolve,
          i = n.reject,
          o = b(function () {
            var n = [],
              o = 0,
              a = 1;
            m(t, !1, function (t) {
              var s = o++,
                u = !1;
              n.push(void 0), a++, e.resolve(t).then(function (t) {
                u || (u = !0, n[s] = t, --a || r(n));
              }, i);
            }), --a || r(n);
          });
        return o.e && i(o.v), n.promise;
      },
      race: function race(t) {
        var e = this,
          n = I(e),
          r = n.reject,
          i = b(function () {
            m(t, !1, function (t) {
              e.resolve(t).then(n.resolve, r);
            });
          });
        return i.e && r(i.v), n.promise;
      }
    });
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      if (!(t instanceof e) || void 0 !== r && r in t) throw TypeError(n + ": incorrect invocation!");
      return t;
    };
  }, function (t, e, n) {
    var r = n(78),
      i = n(235),
      o = n(236),
      a = n(45),
      s = n(159),
      u = n(169),
      c = {},
      l = {},
      e = t.exports = function (t, e, n, f, p) {
        var d,
          h,
          m,
          g,
          v = p ? function () {
            return t;
          } : u(t),
          y = r(n, f, e ? 2 : 1),
          _ = 0;
        if ("function" != typeof v) throw TypeError(t + " is not iterable!");
        if (o(v)) {
          for (d = s(t.length); d > _; _++) if ((g = e ? y(a(h = t[_])[0], h[1]) : y(t[_])) === c || g === l) return g;
        } else for (m = v.call(t); !(h = m.next()).done;) if ((g = i(m, y, h.value, e)) === c || g === l) return g;
      };
    e.BREAK = c, e.RETURN = l;
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = void 0 === n;
      switch (e.length) {
        case 0:
          return r ? t() : t.call(n);
        case 1:
          return r ? t(e[0]) : t.call(n, e[0]);
        case 2:
          return r ? t(e[0], e[1]) : t.call(n, e[0], e[1]);
        case 3:
          return r ? t(e[0], e[1], e[2]) : t.call(n, e[0], e[1], e[2]);
        case 4:
          return r ? t(e[0], e[1], e[2], e[3]) : t.call(n, e[0], e[1], e[2], e[3]);
      }
      return t.apply(n, e);
    };
  }, function (t, e, n) {
    var r = n(22),
      i = n(239).set,
      o = r.MutationObserver || r.WebKitMutationObserver,
      a = r.process,
      s = r.Promise,
      u = "process" == n(93)(a);
    t.exports = function () {
      var t,
        e,
        n,
        c = function c() {
          var r, i;
          for (u && (r = a.domain) && r.exit(); t;) {
            i = t.fn, t = t.next;
            try {
              i();
            } catch (r) {
              throw t ? n() : e = void 0, r;
            }
          }
          e = void 0, r && r.enter();
        };
      if (u) n = function n() {
        a.nextTick(c);
      };else if (!o || r.navigator && r.navigator.standalone) {
        if (s && s.resolve) {
          var l = s.resolve(void 0);
          n = function n() {
            l.then(c);
          };
        } else n = function n() {
          i.call(r, c);
        };
      } else {
        var f = !0,
          p = document.createTextNode("");
        new o(c).observe(p, {
          characterData: !0
        }), n = function n() {
          p.data = f = !f;
        };
      }
      return function (r) {
        var i = {
          fn: r,
          next: void 0
        };
        e && (e.next = i), t || (t = i, n()), e = i;
      };
    };
  }, function (t, e, n) {
    var r = n(22),
      i = r.navigator;
    t.exports = i && i.userAgent || "";
  }, function (t, e, n) {
    var r = n(71);
    t.exports = function (t, e, n) {
      for (var i in e) n && t[i] ? t[i] = e[i] : r(t, i, e[i]);
      return t;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(22),
      i = n(9),
      o = n(50),
      a = n(39),
      s = n(23)("species");
    t.exports = function (t) {
      var e = "function" == typeof i[t] ? i[t] : r[t];
      a && e && !e[s] && o.f(e, s, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(21),
      i = n(9),
      o = n(22),
      a = n(238),
      s = n(241);
    r(r.P + r.R, "Promise", {
      finally: function _finally(t) {
        var e = a(this, i.Promise || o.Promise),
          n = "function" == typeof t;
        return this.then(n ? function (n) {
          return s(e, t()).then(function () {
            return n;
          });
        } : t, n ? function (n) {
          return s(e, t()).then(function () {
            throw n;
          });
        } : t);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(21),
      i = n(173),
      o = n(240);
    r(r.S, "Promise", {
      try: function _try(t) {
        var e = i.f(this),
          n = o(t);
        return (n.e ? e.reject : e.resolve)(n.v), e.promise;
      }
    });
  }, function (t, e, n) {
    t.exports = {
      default: n(527),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(528);
    var r = n(9).Object;
    t.exports = function (t) {
      return r.getOwnPropertyNames(t);
    };
  }, function (t, e, n) {
    n(95)("getOwnPropertyNames", function () {
      return n(231).f;
    });
  }, function (t, e, n) {
    t.exports = {
      default: n(530),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(531);
    var r = n(9).Object;
    t.exports = function (t, e) {
      return r.getOwnPropertyDescriptor(t, e);
    };
  }, function (t, e, n) {
    var r = n(56),
      i = n(165).f;
    n(95)("getOwnPropertyDescriptor", function () {
      return function (t, e) {
        return i(r(t), e);
      };
    });
  }, function (t, e, n) {
    t.exports = {
      default: n(533),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(534);
    var r = n(9).Object;
    t.exports = function (t, e) {
      return r.create(t, e);
    };
  }, function (t, e, n) {
    var r = n(21);
    r(r.S, "Object", {
      create: n(158)
    });
  }, function (t, e, n) {
    t.exports = {
      default: n(536),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(166), t.exports = n(119).f("toStringTag");
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(607), n(538), n(242), n(550), n(561), n(564), n(575), n(579), n(580), n(581), n(582), n(590), n(591), n(592), n(593), n(594), n(596), n(597), n(598), n(599), n(600), n(601), n(603), n(604), n(255), n(605), n(606), n(647), n(610), n(611), n(612), n(614), n(616), n(617), n(618), n(619), n(620), n(621), n(622), n(623), n(624), n(625), n(626), n(627), n(628), n(629), n(630), n(634), n(635), n(638), n(258), n(642), n(645), n(646)], void 0 !== (i = function (t, e, n, r, i, o, a, s, u, c, l, f, p, d, h, m, g, v, y, _, b, w, S, x, E, T, k, A, O, C, I, R, P, N, M, L, F, D, j, U, B, V, q, H, W, $, z, G, K, Y, J, Q, X, Z) {
      return t.extend({
        routes: {
          "": "defaultAuth",
          signin: "primaryAuth",
          "signin/verify/duo/web": "verifyDuo",
          "signin/verify/piv": "verifyPIV",
          "signin/poll": "poll",
          "signin/verify/fido/webauthn": "verifyWebauthn",
          "signin/verify/webauthn": "verifyWebauthn",
          "signin/verify/fido/u2f": "verifyU2F",
          "signin/verify/u2f": "verifyU2F",
          "signin/verify/generic_saml/assertion:saml2": "verifySAMLFactor",
          "signin/verify/generic_oidc/assertion:oidc": "verifyOIDCFactor",
          "signin/verify/custom/claims_provider": "verifyClaimsFactor",
          "signin/verify/:factorType": "verifyNoProvider",
          "signin/verify/:provider/:factorType(/:factorIndex)": "verify",
          "signin/enroll": "enrollChoices",
          "signin/enroll/duo/web": "enrollDuo",
          "signin/enroll/okta/question": "enrollQuestion",
          "signin/enroll/okta/password": "enrollPassword",
          "signin/enroll/okta/sms": "enrollSms",
          "signin/enroll/okta/call": "enrollCall",
          "signin/enroll/okta/email": "enrollEmail",
          "signin/enroll-activate/okta/sms": "enrollSms",
          "signin/enroll/rsa/token": "enrollRsa",
          "signin/enroll/del_oath/token": "enrollOnPrem",
          "signin/enroll/symantec/token": "enrollSymantecVip",
          "signin/enroll/yubico/token:hardware": "enrollYubikey",
          "signin/enroll/fido/webauthn": "enrollWebauthn",
          "signin/enroll/fido/u2f": "enrollU2F",
          "signin/enroll/generic_saml/assertion:saml2": "enrollSAMLFactor",
          "signin/enroll/generic_oidc/assertion:oidc": "enrollOIDCFactor",
          "signin/enroll/custom/claims_provider": "enrollClaimsFactor",
          "signin/enroll/custom/token:hotp": "enrollHotpFactor",
          "signin/enroll/:provider/:factorType": "enrollTotpFactor",
          "signin/enroll-activate/okta/email": "enrollActivateEmail",
          "signin/enroll-activate/okta/push": "scanBarcodePushFactor",
          "signin/enroll-activate/okta/push/manual": "manualSetupPushFactor",
          "signin/enroll-activate/okta/push/sent": "activationLinkSent",
          "signin/enroll-activate/okta/token:software:totp/passcode": "enterPasscodeInPushEnrollmentFlow",
          "signin/enroll-activate/custom/claims_provider": "enrollActivateClaimsFactor",
          "signin/enroll-activate/:provider/:factorType": "scanBarcodeTotpFactor",
          "signin/enroll-activate/:provider/:factorType/activate": "activateTotpFactor",
          "signin/enroll-activate/:provider/:factorType/manual": "manualSetupTotpFactor",
          "signin/password-expired": "passwordExpired",
          "signin/custom-password-expired": "customPasswordExpired",
          "signin/forgot-password": "forgotPassword",
          "signin/recovery-challenge": "recoveryChallenge",
          "signin/recovery-emailed": "recoveryEmailSent",
          "signin/recovery-question": "recoveryQuestion",
          "signin/password-reset": "passwordReset",
          "signin/reset-password/:token": "recoveryLoading",
          "signin/user-unlock/:token": "recoveryLoading",
          "signin/recovery/:token": "recoveryLoading",
          "signin/unlock-emailed": "unlockEmailSent",
          "signin/unlock": "unlockAccount",
          "signin/account-unlocked": "accountUnlocked",
          "signin/refresh-auth-state(/:token)": "refreshAuthState",
          "signin/register": "register",
          "signin/register-complete": "registerComplete",
          "signin/consent": "consentRequired",
          "signin/enroll-user": "enrollUser",
          "*wildcard": "defaultAuth"
        },
        stateLessRouteHandlers: ["defaultAuth", "idpDiscovery", "primaryAuth", "forgotPassword", "recoveryLoading", "unlockAccount", "refreshAuthState", "register", "registerComplete", "verifyPIV"],
        defaultAuth: function defaultAuth() {
          this.settings.get("features.idpDiscovery") ? this.idpDiscovery() : this.primaryAuth();
        },
        idpDiscovery: function idpDiscovery() {
          this.render(e, {
            Beacon: J
          });
        },
        primaryAuth: function primaryAuth() {
          this.render(n, {
            Beacon: J
          });
        },
        verifyDuo: function verifyDuo() {
          this.render(r, {
            provider: "DUO",
            factorType: "web",
            Beacon: Q
          });
        },
        verifyPIV: function verifyPIV() {
          this.render(i, {
            Beacon: X
          });
        },
        poll: function poll() {
          this.render(Z);
        },
        verifyWebauthn: function verifyWebauthn() {
          this.settings.get("features.webauthn") ? this.render(u, {
            provider: "FIDO",
            factorType: "webauthn",
            Beacon: Q
          }) : this.render(a, {
            provider: "FIDO",
            factorType: "webauthn",
            Beacon: Q
          });
        },
        verifyU2F: function verifyU2F() {
          this.render(s, {
            provider: "FIDO",
            factorType: "u2f",
            Beacon: Q
          });
        },
        verifySAMLFactor: function verifySAMLFactor() {
          this.render(c, {
            provider: "GENERIC_SAML",
            factorType: "assertion:saml2",
            Beacon: Q
          });
        },
        verifyOIDCFactor: function verifyOIDCFactor() {
          this.render(c, {
            provider: "GENERIC_OIDC",
            factorType: "assertion:oidc",
            Beacon: Q
          });
        },
        verifyClaimsFactor: function verifyClaimsFactor() {
          this.render(c, {
            provider: "CUSTOM",
            factorType: "claims_provider",
            Beacon: Q
          });
        },
        verify: function verify(t, e, n) {
          this.render(o, {
            provider: t.toUpperCase(),
            factorType: e,
            factorIndex: n,
            Beacon: Q
          });
        },
        verifyNoProvider: function verifyNoProvider(t) {
          this.render(o, {
            factorType: t,
            Beacon: Q
          });
        },
        enrollChoices: function enrollChoices() {
          this.render(l, {
            Beacon: J
          });
        },
        enrollDuo: function enrollDuo() {
          this.render(f, {
            provider: "DUO",
            factorType: "web",
            Beacon: Q
          });
        },
        enrollQuestion: function enrollQuestion() {
          this.render(p, {
            provider: "OKTA",
            factorType: "question",
            Beacon: Q
          });
        },
        enrollPassword: function enrollPassword() {
          this.render(d, {
            provider: "OKTA",
            factorType: "password",
            Beacon: Q
          });
        },
        enrollSms: function enrollSms() {
          this.render(m, {
            provider: "OKTA",
            factorType: "sms",
            Beacon: Q
          });
        },
        enrollCall: function enrollCall() {
          this.render(m, {
            provider: "OKTA",
            factorType: "call",
            Beacon: Q
          });
        },
        enrollEmail: function enrollEmail() {
          this.render(g, {
            provider: "OKTA",
            factorType: "email",
            Beacon: Q
          });
        },
        enrollActivateEmail: function enrollActivateEmail() {
          this.render(v, {
            provider: "OKTA",
            factorType: "email",
            Beacon: Q
          });
        },
        enrollRsa: function enrollRsa() {
          this.render(y, {
            provider: "RSA",
            factorType: "token",
            Beacon: Q
          });
        },
        enrollOnPrem: function enrollOnPrem() {
          this.render(y, {
            provider: "DEL_OATH",
            factorType: "token",
            Beacon: Q
          });
        },
        enrollSymantecVip: function enrollSymantecVip() {
          this.render(_, {
            provider: "SYMANTEC",
            factorType: "token",
            Beacon: Q
          });
        },
        enrollYubikey: function enrollYubikey() {
          this.render(b, {
            provider: "YUBICO",
            factorType: "token:hardware",
            Beacon: Q
          });
        },
        enrollSAMLFactor: function enrollSAMLFactor() {
          this.render(E, {
            provider: "GENERIC_SAML",
            factorType: "assertion:saml2",
            Beacon: Q
          });
        },
        enrollOIDCFactor: function enrollOIDCFactor() {
          this.render(E, {
            provider: "GENERIC_OIDC",
            factorType: "assertion:oidc",
            Beacon: Q
          });
        },
        enrollClaimsFactor: function enrollClaimsFactor() {
          this.render(E, {
            provider: "CUSTOM",
            factorType: "claims_provider",
            Beacon: Q
          });
        },
        enrollActivateClaimsFactor: function enrollActivateClaimsFactor() {
          this.render(T, {
            provider: "CUSTOM",
            factorType: "claims_provider",
            Beacon: Q
          });
        },
        enrollTotpFactor: function enrollTotpFactor(t, e) {
          this.render(w, {
            provider: t.toUpperCase(),
            factorType: e,
            Beacon: Q
          });
        },
        enrollHotpFactor: function enrollHotpFactor() {
          this.render(k, {
            provider: "CUSTOM",
            factorType: "token:hotp",
            Beacon: Q
          });
        },
        enrollWebauthn: function enrollWebauthn() {
          this.settings.get("features.webauthn") ? this.render(x, {
            provider: "FIDO",
            factorType: "webauthn",
            Beacon: Q
          }) : this.render(h, {
            provider: "FIDO",
            factorType: "webauthn",
            Beacon: Q
          });
        },
        enrollU2F: function enrollU2F() {
          this.render(S, {
            provider: "FIDO",
            factorType: "u2f",
            Beacon: Q
          });
        },
        scanBarcodeTotpFactor: function scanBarcodeTotpFactor(t, e) {
          this.render(A, {
            provider: t.toUpperCase(),
            factorType: e,
            Beacon: Q
          });
        },
        scanBarcodePushFactor: function scanBarcodePushFactor() {
          this.render(O, {
            provider: "OKTA",
            factorType: "push",
            Beacon: Q
          });
        },
        activateTotpFactor: function activateTotpFactor(t, e) {
          this.render(C, {
            provider: t.toUpperCase(),
            factorType: e,
            Beacon: Q
          });
        },
        manualSetupTotpFactor: function manualSetupTotpFactor(t, e) {
          this.render(I, {
            provider: t.toUpperCase(),
            factorType: e,
            Beacon: Q
          });
        },
        manualSetupPushFactor: function manualSetupPushFactor() {
          this.render(R, {
            provider: "OKTA",
            factorType: "push",
            Beacon: Q
          });
        },
        activationLinkSent: function activationLinkSent() {
          this.render(P, {
            provider: "OKTA",
            factorType: "push",
            Beacon: Q
          });
        },
        enterPasscodeInPushEnrollmentFlow: function enterPasscodeInPushEnrollmentFlow() {
          this.render(N, {
            provider: "OKTA",
            factorType: "token:software:totp",
            Beacon: Q
          });
        },
        passwordExpired: function passwordExpired() {
          this.render(M, {
            Beacon: J
          });
        },
        customPasswordExpired: function customPasswordExpired() {
          this.render(L, {
            Beacon: J
          });
        },
        forgotPassword: function forgotPassword() {
          this.render(F);
        },
        recoveryChallenge: function recoveryChallenge() {
          this.render(D, {
            Beacon: J
          });
        },
        recoveryEmailSent: function recoveryEmailSent() {
          this.render(j, {
            Beacon: J
          });
        },
        unlockEmailSent: function unlockEmailSent() {
          this.render(W, {
            Beacon: J
          });
        },
        recoveryQuestion: function recoveryQuestion() {
          this.render(U, {
            Beacon: J
          });
        },
        passwordReset: function passwordReset() {
          this.render(B, {
            Beacon: J
          });
        },
        recoveryLoading: function recoveryLoading(t) {
          this.render(V, {
            token: t,
            Beacon: J
          });
        },
        unlockAccount: function unlockAccount() {
          this.render(q);
        },
        accountUnlocked: function accountUnlocked() {
          this.render(H, {
            Beacon: J
          });
        },
        refreshAuthState: function refreshAuthState(t) {
          this.render($, {
            token: t,
            Beacon: J
          });
        },
        register: function register() {
          this.render(z);
        },
        registerComplete: function registerComplete() {
          this.render(G);
        },
        consentRequired: function consentRequired() {
          this.render(K);
        },
        enrollUser: function enrollUser() {
          this.render(Y);
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(242), n(175), n(548), n(549), n(246), n(83), n(245)], void 0 !== (i = function (t, e, n, r, i, o, a, s) {
      return e.extend({
        className: "idp-discovery",
        View: r,
        constructor: function constructor(t) {
          t.appState.unset("username"), this.model = new i({
            requestContext: t.settings.get("idpDiscovery.requestContext"),
            settings: t.settings,
            appState: t.appState
          }, {
            parse: !0
          }), a.apply(this, arguments), this.addListeners(), t.settings.get("hasConfiguredButtons") && this.add(s, {
            prepend: t.settings.get("socialAuthPositionTop"),
            options: {
              currentController: this
            }
          }), this.addFooter(t), this.setUsername();
        },
        initialize: function initialize() {
          e.prototype.initialize.apply(this), this.listenTo(this.model, "goToPrimaryAuth", function () {
            if (this.settings.set("username", this.model.get("username")), this.settings.get("features.passwordlessAuth")) {
              var t = new n({
                username: this.model.get("username"),
                multiOptionalFactorEnroll: this.options.settings.get("features.multiOptionalFactorEnroll"),
                settings: this.options.settings,
                appState: this.options.appState
              }, {
                parse: !0
              });
              this.addModelListeners(t), t.save();
            } else this.options.appState.set("disableUsername", !0), this.options.appState.trigger("navigate", "signin");
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(540)], void 0 !== (i = function (t) {
      var e;
      return {
        track: function track(n) {
          try {
            e = new t(), e.addTarget(n), e.start();
          } catch (t) {}
        },
        getTypingPattern: function getTypingPattern() {
          try {
            return e.getTypingPattern({
              type: 1
            });
          } catch (t) {
            return null;
          }
        }
      };
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    var i = n(244),
      o = r(i),
      a = n(89),
      s = r(a); /**
                * TypingDNA - Typing Biometrics JavaScript API
                * https://api.typingdna.com/scripts/typingdna.js
                * https://typingdna.com/scripts/typingdna.js (alternative)
                *
                * @version 2.15
                * @author Raul Popa
                * @copyright SC TypingDNA SRL, http://typingdna.com
                * @license http://www.apache.org/licenses/LICENSE-2.0
                * Licensed under the Apache License, Version 2.0 (the "License");
                * you may not use this file except in compliance with the License.
                * You may obtain a copy of the License at
                * http://www.apache.org/licenses/LICENSE-2.0
                *
                * Unless required by applicable law or agreed to in writing, software
                * distributed under the License is distributed on an "AS IS" BASIS,
                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                * See the License for the specific language governing permissions and
                * limitations under the License.
                *
                * Typical usage:
                * var tdna = new TypingDNA(); // creates a new TypingDNA object and starts recording
                * var typingPattern = tdna.getTypingPattern({type=1, text="Hello5g21?*"});
                * returns a type 1 typing pattern (and continues recording afterwards)
                *
                * Optional:
                * tdna.stop(); // ends recording and clears history stack (returns recording flag: false)
                * tdna.start(); // restarts the recording after a stop (returns recording flag: true)
                * tdna.reset(); // restarts the recording anytime, clears history stack and starts from scratch (returns nothing)
                * var typingPatternQuality = TypingDNA.getQuality(typingPattern); //returns the quality/strength of any typing pattern
                * (there is no need to initialize the class to do pattern quality checking)
                */
    t.exports = function t() {
      if (1 == t.initialized) return t.instance;
      t.prototype.start = function () {
        return t.start.apply(this, arguments);
      }, t.prototype.stop = function () {
        return t.stop.apply(this, arguments);
      }, t.prototype.reset = function () {
        return t.reset.apply(this, arguments);
      }, t.prototype.addTarget = function () {
        return t.addTarget.apply(this, arguments);
      }, t.prototype.removeTarget = function () {
        return t.removeTarget.apply(this, arguments);
      }, t.prototype.getTypingPattern = function () {
        return t.getTypingPattern.apply(this, arguments);
      }, t.prototype.get = function () {
        return t.get.apply(this, arguments);
      }, t.prototype.startDiagram = function () {}, t.prototype.stopDiagram = function () {}, t.prototype.getDiagram = function () {
        return t.getDiagram.apply(this, arguments);
      }, t.prototype.getExtendedDiagram = function () {
        return t.getExtendedDiagram.apply(this, arguments);
      }, t.prototype.getMouseDiagram = function () {
        return t.getMouseDiagram.apply(this, arguments);
      }, t.prototype.startMouse = function () {
        return t.startMouse.apply(this, arguments);
      }, t.prototype.stopMouse = function () {
        return t.stopMouse.apply(this, arguments);
      }, t.prototype.getQuality = function () {
        return t.getQuality.apply(this, arguments);
      }, t.prototype.getLength = function () {
        return t.getLength.apply(this, arguments);
      }, t.prototype.isMobile = function () {
        return t.isMobile.apply(this, arguments);
      }, t.prototype.getTextId = function () {
        return t.getTextId.apply(this, arguments);
      }, t.initialized = !0, t.prototype.maxHistoryLength = t.maxHistoryLength, t.prototype.defaultHistoryLength = t.defaultHistoryLength, t.prototype.maxSeekTime = t.maxSeekTime, t.prototype.maxPressTime = t.maxPressTime, t.version = 2.15, t.flags = 0, t.instance = this, t.document = document, t.maxHistoryLength = 2e3, t.maxSeekTime = 1500, t.maxPressTime = 300, t.defaultHistoryLength = 160, t.spKeyCodes = [8, 13, 32], t.spKeyCodesObj = {
        8: 1,
        13: 1,
        32: 1
      }, t.keyCodes = [65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 32, 222, 188, 190, 186, 187, 189, 191, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57], t.keyCodesObj = {};
      for (var e in t.keyCodes) t.keyCodesObj[t.keyCodes[e]] = 1;
      t.pt1 = t.ut1 = new Date().getTime(), t.wfk = [], t.sti = [], t.skt = [], t.recording = !0, t.mouseRecording = !0, t.mouseMoveRecording = !1, t.spKeyRecording = !0, t.diagramRecording = !0, t.dwfk = [], t.dsti = [], t.dskt = [], t.drkc = [], t.dlastDownKey, t.prevKeyCode = 0, t.maxMoveDeltaTime = 600, t.maxScrollDeltaTime = 800, t.maxStopTime = 1500, t.maxClickTime = 600, t.maxMouseHistoryLength = 500, t.lastMouseMoveTime = t.lastMouseDownTime = new Date().getTime(), t.stopTimes = [], t.clickTimes = [], t.lastMouseStop = !0, t.zl = 1e-7, t.isAndroidChrome = !1, t.ACLastTime = new Date().getTime(), t.ACSeekTime = 0, t.ACPressTime = 0, t.ACLastCharCode = 0, t.ACLastKeyCode = 0, t.ACInputLengths = {
        inputs: [],
        lastLength: []
      }, t.ACPreviousKeyCode = 0, t.targetIds = [], t.lastTarget = "", t.lastTargetFound = !1, t.replaceMissingKeys = !0, t.replaceMissingKeysPerc = 7, t.keyDown = function (e) {
        if ((t.recording || t.diagramRecording) && t.isTarget(e.target.id)) {
          var n = e.keyCode;
          if (1 == t.wfk[n] || t.dwfk[n], 229 == n && t.isMobile() && !t.isAndroidChrome) t.isAndroidChrome = !0, t.ACSeekTime = new Date().getTime() - t.ACLastTime, t.ACLastTime = new Date().getTime(), t.document.removeEventListener("keydown", t.keyDown), t.document.removeEventListener("keyup", t.keyUp), t.document.removeEventListener("keypress", t.keyPress), t.document.addEventListener("keydown", t.ACKeyDown), t.document.addEventListener("keyup", t.ACKeyUp);else {
            var r = t.pt1;
            t.pt1 = new Date().getTime();
            var i = t.pt1 - r,
              o = t.pt1;
            (1 == t.recording || t.spKeyCodesObj[n] && 1 == t.spKeyRecording) && (e.shiftKey && !t.isMobile() || (t.wfk[n] = 1, t.skt[n] = i, t.sti[n] = o)), 1 == t.diagramRecording && (t.dwfk[n] = 1, t.dskt[n] = i, t.dsti[n] = o, t.dlastDownKey = n);
          }
        }
      }, t.keyPress = function (e) {
        if ((t.recording || t.diagramRecording) && t.isTarget(e.target.id) && 1 == t.diagramRecording) {
          var n = t.dlastDownKey;
          t.drkc[n] = e.charCode;
        }
      }, t.keyUp = function (e) {
        if ((t.recording || t.diagramRecording) && t.isTarget(e.target.id)) {
          var n = new Date().getTime(),
            r = e.keyCode;
          if (1 == t.recording || t.spKeyCodesObj[r] && 1 == t.spKeyRecording) {
            if ((!e.shiftKey || t.isMobile()) && 1 == t.wfk[r]) {
              var i = n - t.sti[r],
                o = t.skt[r],
                a = [r, o, i, t.prevKeyCode, n, e.target.id];
              t.history.add(a), t.prevKeyCode = r;
            }
            t.wfk[r] = 0;
          }
          if (1 == t.diagramRecording) {
            if (void 0 != t.drkc[r] && 0 != t.drkc[r] && 1 == t.dwfk[r]) {
              var i = n - t.dsti[r],
                o = t.dskt[r],
                s = t.drkc[r],
                u = [r, o, i, s, n, e.target.id];
              t.history.addDiagram(u);
            }
            t.dwfk[r] = 0;
          }
        }
      }, t.mouseScroll = function (e) {
        if (1 == t.mouseRecording && 1 == t.mouseMoveRecording) if (1 == t.mouse.scrollStarted) {
          var n = new Date().getTime();
          t.mouse.scrollTimes.push(n), t.mouse.scrollTopArr.push(t.document.body.scrollTop), clearInterval(t.scrollInterval), t.scrollInterval = setInterval(t.mouse.checkScroll, t.maxScrollDeltaTime);
        } else t.mouse.scrollStarted = !0;
      }, t.mouseMove = function (e) {
        if (1 == t.mouseRecording) {
          var n = new Date().getTime();
          1 == t.mouseMoveRecording && (1 == t.mouse.started ? (t.mouse.times.push(n), t.mouse.xPositions.push(e.screenX), t.mouse.yPositions.push(e.screenY), clearInterval(t.moveInterval), t.moveInterval = setInterval(t.mouse.checkMove, t.maxMoveDeltaTime)) : t.mouse.started = !0), t.lastMouseMoveTime = n;
        }
      }, t.mouseDown = function (e) {
        if (1 == t.mouseRecording && (t.mouse.checkMove(), t.mouse.checkScroll(), 1 == e.which)) {
          t.lastMouseDownTime = new Date().getTime();
          var n = t.lastMouseDownTime - t.lastMouseMoveTime;
          if (n < t.maxStopTime && 0 == t.lastMouseStop && (t.stopTimes.push(n), 1 == t.mouseMoveRecording)) {
            var r = [3, n];
            t.mouse.history.add(r), t.lastMouseStop = !0;
          }
        }
      }, t.mouseUp = function (e) {
        if (1 == t.mouseRecording && 1 == e.which) {
          var n = new Date().getTime() - t.lastMouseDownTime;
          if (n < t.maxClickTime && t.lastMouseDownTime > t.lastMouseMoveTime && (t.clickTimes.push(n), 1 == t.mouseMoveRecording)) {
            var r = [4, n];
            t.mouse.history.add(r);
          }
        }
      }, t.ACKeyDown = function (e) {
        (t.recording || t.diagramRecording) && (t.ACSeekTime = new Date().getTime() - t.ACLastTime, t.ACLastTime = new Date().getTime(), t.isTarget(e.target.id) && -1 === t.ACInputLengths.inputs.indexOf(e.target) && (t.ACInputLengths.inputs.push(e.target), t.ACInputLengths.lastLength.push(0)));
      }, t.ACKeyUp = function (e) {
        if ((t.recording || t.diagramRecording) && (t.ACPressTime = new Date().getTime() - t.ACLastTime, t.ACLastTime = new Date().getTime(), t.isTarget(e.target.id))) {
          var n = e.keyCode,
            r = t.ACInputLengths.inputs.indexOf(e.target);
          if (-1 === r && (t.ACInputLengths.inputs.push(e.target), t.ACInputLengths.lastLength.push(0), r = t.ACInputLengths.inputs.indexOf(e.target)), 229 == n && e.target.value.length >= t.ACInputLengths.lastLength[r]) {
            var i = e.target.value.substr(e.target.selectionStart - 1 || 0, 1);
            n = i.toUpperCase().charCodeAt(0), t.ACLastCharCode = i.charCodeAt(0), t.ACLastKeyCode = i.toUpperCase().charCodeAt(0);
          }
          t.ACInputLengths.lastLength[r] = e.target.value.length;
          var o = [n, t.ACSeekTime, t.ACPressTime, t.ACPreviousKeyCode, t.ACLastTime];
          if (t.history.add(o), t.ACPreviousKeyCode = n, 1 == t.diagramRecording) {
            var a = [n, t.ACSeekTime, t.ACPressTime, t.ACLastCharCode];
            t.history.addDiagram(a);
          }
        }
      }, t.isTarget = function (e) {
        if (t.lastTarget == e && t.lastTargetFound) return !0;
        var n = t.targetIds.length,
          r = !1;
        if (n > 0) {
          for (var i = 0; i < n; i++) if (t.targetIds[i] == e) {
            r = !0;
            break;
          }
          return t.lastTarget = e, t.lastTargetFound = r, r;
        }
        return t.lastTarget = e, t.lastTargetFound = !0, !0;
      }, t.document.addEventListener ? (t.document.addEventListener("keydown", t.keyDown), t.document.addEventListener("keyup", t.keyUp), t.document.addEventListener("keypress", t.keyPress), t.document.addEventListener("mousemove", t.mouseMove), t.document.addEventListener("mousedown", t.mouseDown), t.document.addEventListener("mouseup", t.mouseUp), t.document.addEventListener("scroll", t.mouseScroll)) : t.document.attachEvent && (t.document.attachEvent("onkeydown", t.keyDown), t.document.attachEvent("onkeyup", t.keyUp), t.document.attachEvent("onkeypress", t.keyPress), t.document.attachEvent("onmousemove", t.mouseMove), t.document.attachEvent("onmousedown", t.mouseDown), t.document.attachEvent("onmouseup", t.mouseUp), t.document.attachEvent("onscroll", t.mouseScroll)), t.mouse = {}, t.mouse.times = [], t.mouse.xPositions = [], t.mouse.yPositions = [], t.mouse.scrollTimes = [], t.mouse.scrollTopArr = [], t.mouse.history = {}, t.mouse.history.stack = [], t.mouse.getDistance = function (t, e) {
        return Math.sqrt(t * t + e * e);
      }, t.mouse.getTotalDistance = function (n, r) {
        var i = 0,
          o = n.length;
        for (e = 1; e < o - 1; e++) {
          var a = n[e] - n[e - 1],
            s = r[e] - r[e - 1];
          i += t.mouse.getDistance(a, s);
        }
        return i;
      }, t.mouse.getAngle = function (t, e) {
        var n = t >= 0,
          r = e < 0;
        return n ? r ? 180 + Math.round(Math.atan(Math.abs(t) / (Math.abs(e) + 1e-7)) / .01745329251) : 90 - Math.round(Math.atan(Math.abs(t) / (Math.abs(e) + 1e-7)) / .01745329251) + 270 : r ? 90 - Math.round(Math.atan(Math.abs(t) / (Math.abs(e) + 1e-7)) / .01745329251) + 90 : Math.round(Math.atan(Math.abs(t) / (Math.abs(e) + 1e-7)) / .01745329251);
      }, t.mouse.recordMoveAction = function () {
        var n = t.mouse.times.length;
        if (!(n < 3)) {
          var r = t.mouse.times[n - 1] - t.mouse.times[0],
            i = t.mouse.xPositions[n - 1] - t.mouse.xPositions[0],
            o = t.mouse.yPositions[n - 1] - t.mouse.yPositions[0],
            a = Math.round(t.mouse.getDistance(i, o)),
            s = Math.round(t.mouse.getTotalDistance(t.mouse.xPositions, t.mouse.yPositions)),
            u = Math.round(100 * s / a),
            c = Math.round(100 * a / r),
            l = t.mouse.getAngle(i, o),
            f = [1, r, a, c, l, u];
          for (e in f) if (isNaN(f[e])) return;
          t.mouse.history.add(f), t.lastMouseStop = !1;
        }
      }, t.mouse.recordScrollAction = function () {
        var n = t.mouse.scrollTimes.length;
        if (!(n < 2)) {
          var r = t.mouse.scrollTimes[n - 1] - t.mouse.scrollTimes[0],
            i = t.mouse.scrollTopArr[n - 1] - t.mouse.scrollTopArr[0],
            o = Math.round(100 * i / r),
            a = [2, r, i, o];
          for (e in a) if (isNaN(a[e]) && !isFinite(a[e])) return;
          t.mouse.history.add(a);
        }
      }, t.mouse.history.add = function (e) {
        this.stack.push(e), this.stack.length > t.maxMouseHistoryLength && this.stack.shift();
      }, t.mouse.history.getDiagram = function () {
        var e = this.stack.join("|");
        return [String(t.isMobile()) + "," + String(t.version), e].join("|");
      }, t.mouse.clearLastMove = function () {
        t.mouse.times = [], t.mouse.xPositions = [], t.mouse.yPositions = [];
      }, t.mouse.checkMove = function () {
        clearInterval(t.moveInterval), 1 == t.mouse.started && (t.mouse.started = !1, t.mouse.recordMoveAction(), t.mouse.clearLastMove());
      }, t.mouse.clearLastScroll = function () {
        t.mouse.scrollTimes = [], t.mouse.scrollTopArr = [];
      }, t.mouse.checkScroll = function () {
        clearInterval(t.scrollInterval), 1 == t.mouse.scrollStarted && (t.mouse.scrollStarted = !1, t.mouse.recordScrollAction(), t.mouse.clearLastScroll());
      }, t.addTarget = function (e) {
        var n = t.targetIds.length,
          r = !1;
        if (n > 0) {
          for (var i = 0; i < n; i++) if (t.targetIds[i] == e) {
            r = !0;
            break;
          }
          r || t.targetIds.push(e);
        } else t.targetIds.push(e);
      }, t.removeTarget = function (e) {
        var n = t.targetIds.length;
        if (n > 0) for (var r = 0; r < n; r++) if (t.targetIds[r] == e) {
          t.targetIds.splice(r, 1);
          break;
        }
      }, t.reset = function (e) {
        t.history.stack = [], t.history.stackDiagram = [], t.clickTimes = [], t.stopTimes = [], t.ACInputLengths = {
          inputs: [],
          lastLength: []
        }, 1 == e && (t.mouse.history.stack = []);
      }, t.start = function () {
        return t.diagramRecording = !0, t.recording = !0;
      }, t.stop = function () {
        return t.diagramRecording = !1, t.recording = !1;
      }, t.startMouse = function () {
        return t.mouseRecording = t.mouseMoveRecording = !0;
      }, t.stopMouse = function () {
        return t.mouseRecording = t.mouseMoveRecording = !1;
      }, t.getTypingPattern = function (e) {
        if ("object" !== (void 0 === e ? "undefined" : (0, s.default)(e))) return t.get();
        switch (e.type) {
          case 0:
            return t.get(e.length, e.targetId);
          case 1:
            var n = void 0 != e.text ? e.text : e.length;
            return t.history.getDiagram(e.extended, n, e.textId, e.targetId, e.caseSensitive);
          case 2:
            var n = void 0 != e.text ? e.text : e.length;
            return t.history.getDiagram(!0, n, e.textId, e.targetId, e.caseSensitive);
          default:
            return t.get(e.length);
        }
      }, t.getDiagram = function (e, n) {
        return t.history.getDiagram(!1, e, n, void 0, !1);
      }, t.getExtendedDiagram = function (e, n) {
        return t.history.getDiagram(!0, e, n, void 0, !1);
      }, t.getMouseDiagram = function () {
        return t.mouse.history.getDiagram();
      }, t.get = function (e, n) {
        var r = t.history.stack.length;
        void 0 != e && 0 != e || (e = t.defaultHistoryLength), e > r && (e = r);
        var i = {},
          a = t.history.get(e, "", n),
          s = (0, o.default)(a, 2);
        i.arr = s[0], targetLength = s[1], void 0 != n && "" != n && (e = targetLength);
        var u = t.zl,
          c = e,
          l = t.math.fo(t.history.get(e, "seek", n)),
          f = t.math.fo(t.history.get(e, "press", n)),
          p = Math.round(t.math.avg(f)),
          d = Math.round(t.math.avg(l)),
          h = Math.round(t.math.sd(f)),
          m = Math.round(t.math.sd(l)),
          g = d + p,
          v = t.math.rd((p + u) / (g + u), 4),
          y = t.math.rd((1 - v) / v, 4),
          _ = t.math.rd((h + u) / (p + u), 4),
          b = t.math.rd((m + u) / (p + u), 4),
          w = Math.round(6e4 / (g + u));
        0 == c && (w = 0);
        for (var S in i.arr) {
          var x = i.arr[S][1].length,
            E = 0,
            T = 0,
            k = 0,
            A = 0,
            O = 0,
            C = 0;
          switch (i.arr[S][0].length) {
            case 0:
              break;
            case 1:
              var E = t.math.rd((i.arr[S][0][0] + u) / (d + u), 4);
              break;
            default:
              var I = t.math.fo(i.arr[S][0]);
              E = t.math.rd((t.math.avg(I) + u) / (d + u), 4), A = t.math.rd((t.math.sd(I) + u) / (m + u), 4);
          }
          switch (i.arr[S][1].length) {
            case 0:
              break;
            case 1:
              var T = t.math.rd((i.arr[S][1][0] + u) / (p + u), 4);
              break;
            default:
              var I = t.math.fo(i.arr[S][1]);
              T = t.math.rd((t.math.avg(I) + u) / (p + u), 4), O = t.math.rd((t.math.sd(I) + u) / (h + u), 4);
          }
          switch (i.arr[S][2].length) {
            case 0:
              break;
            case 1:
              var k = t.math.rd((i.arr[S][2][0] + u) / (d + u), 4);
              break;
            default:
              var I = t.math.fo(i.arr[S][2]);
              k = t.math.rd((t.math.avg(I) + u) / (d + u), 4), C = t.math.rd((t.math.sd(I) + u) / (m + u), 4);
          }
          delete i.arr[S][2], delete i.arr[S][1], delete i.arr[S][0], i.arr[S][0] = x, i.arr[S][1] = E, i.arr[S][2] = T, i.arr[S][3] = k, i.arr[S][4] = A, i.arr[S][5] = O, i.arr[S][6] = C;
        }
        var I = [];
        t.apu(I, c), t.apu(I, w), t.apu(I, g), t.apu(I, v), t.apu(I, y), t.apu(I, _), t.apu(I, b), t.apu(I, p), t.apu(I, d), t.apu(I, h), t.apu(I, m);
        for (var R = 0; R <= 6; R++) for (var S = 0; S < 44; S++) {
          var P = t.keyCodes[S],
            N = i.arr[P][R];
          0 == N && R > 0 && (N = 1), t.apu(I, N);
        }
        return t.apu(I, t.isMobile()), t.apu(I, t.version), t.apu(I, t.flags), I.push(t.history.getSpecialKeys()), I.join(",");
      }, t.apu = function (t, e) {
        "NaN" == String(e) && (e = 0), t.push(e);
      }, t.math = {}, t.math.rd = function (t, e) {
        return Number(t.toFixed(e));
      }, t.math.avg = function (t) {
        var e = t.length;
        if (e > 0) {
          for (var n = 0, r = 0; r < e; r++) n += t[r];
          return this.rd(n / e, 4);
        }
        return 0;
      }, t.math.sd = function (t) {
        var e = t.length;
        if (e < 2) return 0;
        for (var n = 0, r = this.avg(t), i = 0; i < e; i++) n += (t[i] - r) * (t[i] - r);
        return Math.sqrt(n / e);
      }, t.math.fo = function (t) {
        if (t.length > 1) {
          var e = t.concat(),
            n = t.length;
          e.sort(function (t, e) {
            return t - e;
          });
          var r = this.sd(e),
            i = e[Math.ceil(t.length / 2)],
            o = i + 2 * r,
            a = i - 2 * r;
          n < 20 && (a = 0);
          for (var s = [], u = 0; u < n; u++) {
            var c = e[u];
            c < o && c > a && s.push(c);
          }
          return s;
        }
        return t;
      }, t.math.fnv1aHash = function (t) {
        if (void 0 == t && "string" != typeof t) return 0;
        t = t.toLowerCase();
        var e,
          n,
          r = 1914395348;
        for (e = 0, n = t.length; e < n; e++) r ^= t.charCodeAt(e), r += (r << 1) + (r << 4) + (r << 7) + (r << 8) + (r << 24);
        return r >>> 0;
      }, t.history = {}, t.history.stack = [], t.history.stackDiagram = [], t.history.add = function (e) {
        this.stack.push(e), this.stack.length > t.maxHistoryLength && this.stack.shift();
      }, t.history.addDiagram = function (t) {
        this.stackDiagram.push(t);
      }, t.history.getDiagram = function (e, n, r, i, o) {
        var o = void 0 != o ? o : void 0 == n || "" == n,
          a = [],
          u = 1 == e ? 1 : 0,
          c = this.stackDiagram;
        if (void 0 != i && "" != i && c.length > 0) {
          if (c = t.sliceStackByTargetId(c, i), void 0 == n || "" == n) {
            var l = t.document.getElementById(i);
            null != l && (n = l.value);
          }
        } else {
          var f = t.targetIds.length;
          if ((void 0 == n || "" == n) && f > 0) {
            n = "";
            for (var p = 0; p < f; p++) {
              var l = t.document.getElementById(t.targetIds[p]);
              null != l && (n += l.value);
            }
          }
        }
        var d = 0,
          h = c.length,
          m = h;
        "string" == typeof n ? m = n.length : "number" == typeof n && n < h && (m = n);
        var g = 0;
        if (void 0 != r ? g = isNaN(parseInt(r)) ? t.math.fnv1aHash(r) : parseInt(r) : "string" == typeof n && (g = t.math.fnv1aHash(n)), a.push([t.isMobile(), t.version, t.flags, u, m, g, t.history.getSpecialKeys()]), void 0 != n && n.length > 0 && "string" == typeof n) for (var v, y, _ = n.toLowerCase(), b = n.toUpperCase(), w = [], S = 0, p = 0; p < n.length; p++) {
          var x = n.charCodeAt(p);
          o || (v = b.charCodeAt(p), y = v != x ? v : _.charCodeAt(p));
          for (var E = S, T = h, k = !1; 0 == k;) {
            for (var A = E; A < T; A++) {
              var O = c[A],
                C = O[3];
              if (C == x || !o && C == y) {
                if (k = !0, A == S) S++, w = [];else {
                  w.push(A);
                  var I = w.length;
                  I > 1 && w[I - 1] == w[I - 2] + 1 && (S = A + 1, w = []);
                }
                var R = O[0],
                  P = O[1],
                  N = O[2];
                e ? a.push([C, P, N, R]) : a.push([P, N]);
                break;
              }
            }
            if (0 == k) if (0 != E) E = 0, T = S;else if (k = !0, t.replaceMissingKeys) {
              if (d++, "object" !== (0, s.default)(t.savedMissingAvgValues) || t.savedMissingAvgValues.historyLength != h) {
                var M = t.math.fo(t.history.get(0, "seek")),
                  L = t.math.fo(t.history.get(0, "press")),
                  P = Math.round(t.math.avg(M)),
                  N = Math.round(t.math.avg(L));
                t.savedMissingAvgValues = {
                  seekTime: P,
                  pressTime: N,
                  historyLength: h
                };
              } else var P = t.savedMissingAvgValues.seekTime,
                N = t.savedMissingAvgValues.pressTime;
              e ? a.push([x, P, N, x, 1]) : a.push([P, N, 1]);
              break;
            }
          }
          if (t.replaceMissingKeysPerc < 100 * d / m) return null;
        } else {
          var F = 0;
          "number" == typeof n && (F = h - n), F < 0 && (F = 0);
          for (var p = F; p < h; p++) {
            var O = c[p],
              R = O[0],
              P = O[1],
              N = O[2];
            if (e) {
              var C = O[3];
              a.push([C, P, N, R]);
            } else a.push([P, N]);
          }
        }
        return a.join("|");
      }, t.sliceStackByTargetId = function (t, n) {
        var r = t.length,
          i = [];
        for (e = 0; e < r; e++) {
          var o = t[e];
          o[5] == n && i.push(o);
        }
        return i;
      }, t.history.get = function (e, n, r) {
        var i = this.stack;
        void 0 != r && "" != r && i.length > 0 && (i = t.sliceStackByTargetId(i, r));
        var o = i.length;
        switch (0 != e && void 0 != e || (e = t.defaultHistoryLength), e > o && (e = o), n) {
          case "seek":
            var a = [];
            for (f = 1; f <= e; f++) {
              var s = i[o - f][1];
              s <= t.maxSeekTime && a.push(s);
            }
            return a;
          case "press":
            var u = [];
            for (f = 1; f <= e; f++) {
              var c = i[o - f][2];
              c <= t.maxPressTime && u.push(c);
            }
            return u;
          default:
            var l = {};
            for (var f in t.keyCodes) l[t.keyCodes[f]] = [[], [], []];
            for (f = 1; f <= e; f++) {
              var p = i[o - f],
                d = p[0],
                s = p[1],
                c = p[2],
                h = p[3];
              t.keyCodesObj[d] && (s <= t.maxSeekTime && (l[d][0].push(s), 0 != h && t.keyCodesObj[h] && l[h][2].push(s)), c <= t.maxPressTime && l[d][1].push(c));
            }
            return [l, e];
        }
      }, t.history.getSpecialKeys = function () {
        var e = [],
          n = this.stack.length,
          r = {};
        for (var i in t.spKeyCodes) r[t.spKeyCodes[i]] = [[]];
        for (i = 1; i <= n; i++) {
          var o = this.stack[n - i];
          if (t.spKeyCodesObj[o[0]]) {
            var a = o[0],
              s = o[2];
            s <= t.maxPressTime && r[a][0].push(s);
          }
        }
        for (var i in t.spKeyCodes) {
          var o = t.math.fo(r[t.spKeyCodes[i]][0]),
            u = o.length;
          e.push(u), u > 1 ? (e.push(Math.round(t.math.avg(o))), e.push(Math.round(t.math.sd(o)))) : 1 == u ? e.push([o[0], -1]) : e.push([-1, -1]);
        }
        var c = t.clickTimes.length;
        e.push(c), c > 1 ? (e.push(Math.round(t.math.avg(t.clickTimes))), e.push(Math.round(t.math.sd(t.clickTimes)))) : 1 == c ? e.push(t.clickTimes[0], -1) : e.push([-1, -1]);
        var l = t.stopTimes.length;
        return e.push(l), l > 1 ? (e.push(Math.round(t.math.avg(t.stopTimes))), e.push(Math.round(t.math.sd(t.stopTimes)))) : 1 == l ? e.push(t.stopTimes[0], -1) : e.push([-1, -1]), e;
      }, t.getQuality = function (e) {
        var n = e.split(",");
        for (a = 0; a < n.length; a++) n[a] = Number(n[a]);
        var r = (n[0], rec = avgAcc = 0),
          i = t.math.avg(n),
          o = n.slice(11, 55);
        for (var a in o) rec += Number(o[a] > 0), r += Number(o[a] > 4), avgAcc += Number(o[a] > i);
        var s = Math.sqrt(rec * r * avgAcc) / 80;
        return s > 1 ? 1 : s;
      }, t.checkMobileValidity = function (t) {
        var e = t.split(","),
          n = e[0];
        if (0 == n) return 0;
        var r = 0,
          i = e.slice(11, 55);
        for (var o in i) r += Number(i[o]);
        return r / n;
      }, t.getLength = function (t) {
        return Number(t.split(",")[1]);
      }, t.isMobile = function () {
        if (void 0 != t.mobile) return t.mobile;
        var e = 0;
        return function (t) {
          (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))) && (e = 1);
        }(navigator.userAgent || navigator.vendor || window.opera), t.mobile = e, e;
      }, t.getTextId = function (e) {
        return t.math.fnv1aHash(e);
      };
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(542),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(118), n(90), t.exports = n(543);
  }, function (t, e, n) {
    var r = n(170),
      i = n(23)("iterator"),
      o = n(80);
    t.exports = n(9).isIterable = function (t) {
      var e = Object(t);
      return void 0 !== e[i] || "@@iterator" in e || o.hasOwnProperty(r(e));
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(545),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(118), n(90), t.exports = n(546);
  }, function (t, e, n) {
    var r = n(45),
      i = n(169);
    t.exports = n(9).getIterator = function (t) {
      var e = i(t);
      if ("function" != typeof e) throw TypeError(t + " is not iterable!");
      return r(e.call(t));
    };
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      return t.View.extend({
        template: '        <div class="content-container">          <span class="registration-label">{{label}}</span>          <a title="{{text}}" aria-label="{{text}}" class="registration-link" href="#">{{text}}</a>        </div>        ',
        className: "registration-container",
        events: {
          "click a.registration-link": "handleClickEvent"
        },
        handleClickEvent: function handleClickEvent(t) {
          t.preventDefault();
          var e = this.settings.get("registration.click");
          e ? e() : this.options.appState.get("isIdxStateToken") ? this.options.appState.trigger("navigate", "signin/enroll-user") : this.options.appState.trigger("navigate", "signin/register");
        },
        getTemplateData: function getTemplateData() {
          return {
            label: t.loc("registration.signup.label", "login"),
            text: t.loc("registration.signup.text", "login")
          };
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(13), n(243)], void 0 !== (i = function (t, e, n) {
      var r = t._;
      return n.extend({
        className: "idp-discovery-form",
        save: function save() {
          return t.loc("oform.next", "login");
        },
        saveId: "idp-discovery-submit",
        initialize: function initialize() {
          this.listenTo(this, "save", r.bind(this.model.save, this.model)), this.stateEnableChange();
        },
        inputs: function inputs() {
          var n = [],
            i = {
              className: "margin-btm-30",
              label: t.loc("primaryauth.username.placeholder", "login"),
              "label-top": !0,
              explain: e.createInputExplain("primaryauth.username.tooltip", "primaryauth.username.placeholder", "login"),
              "explain-top": !0,
              inputId: "idp-discovery-username",
              disabled: !1
            };
          return n.push(r.extend(this.getUsernameField(), i)), this.settings.get("features.rememberMe") && n.push(this.getRemeberMeCheckbox()), n;
        },
        focus: function focus() {
          this.model.get("username") ? this.getInputs().toArray()[1] && this.getInputs().toArray()[1].focus() : this.getInputs().first().focus();
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(175), n(176), n(6), n(13)], void 0 !== (i = function (t, e, n, r, i) {
      var o = t._;
      return e.extend({
        props: function props() {
          var t = n.getCookieUsername(),
            e = this.getUsernameAndRemember(t);
          return {
            username: ["string", !0, e.username],
            lastUsername: ["string", !1, t],
            context: ["object", !1],
            remember: ["boolean", !0, e.remember]
          };
        },
        local: {},
        save: function save() {
          var t = this.settings.transformUsername(this.get("username"), r.IDP_DISCOVERY),
            e = this.get("remember"),
            a = this.get("lastUsername"),
            s = "okta:acct:" + t,
            u = this.get("requestContext");
          this.setUsernameCookie(t, e, a), this.trigger("save"), this.appState.trigger("loading", !0);
          var c = {
            resource: s,
            requestContext: u
          };
          this.appState.settings.authClient.webfinger(c).then(o.bind(function (t) {
            if (t && t.links && t.links[0]) if ("OKTA" === t.links[0].properties["okta:idp:type"]) this.trigger("goToPrimaryAuth");else if (t.links[0].href) {
              var e = t.links[0].href.includes("OKTA_INVALID_SESSION_REPOST%3Dtrue") ? i.redirectWithFormGet.bind(i) : this.settings.get("redirectUtilFn");
              e(t.links[0].href);
            }
          }, this)).fail(o.bind(function () {
            this.trigger("error"), this.appState.trigger("removeLoading"), n.removeUsernameCookie();
          }, this)).fin(o.bind(function () {
            this.appState.trigger("loading", !1);
          }, this));
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(247), n(17), n(18), n(2), n(6), n(4), n(51)], void 0 !== (i = function (t, e, n, r, i, o, a, s) {
      var u = t.$,
        c = t._;
      return i.extend({
        className: "mfa-verify-duo duo-form",
        Model: {
          props: {
            host: "string",
            signature: "string",
            postAction: "string",
            factorId: "string",
            stateToken: "string",
            rememberDevice: "boolean"
          },
          initialize: function initialize() {
            var t = r.getRememberDeviceValue(this.appState);
            this.set("rememberDevice", t);
          },
          getInitOptions: function getInitOptions() {
            var t = !!this.get("rememberDevice");
            return this.doTransaction(function (e) {
              var n = {
                rememberDevice: t
              };
              return c.findWhere(e.factors, {
                provider: "DUO",
                factorType: "web"
              }).verify(n).fail(function (t) {
                throw t;
              });
            });
          },
          verify: function verify(t) {
            var e = this.get("postAction"),
              r = this.get("factorId"),
              i = this,
              o = {
                id: r,
                stateToken: this.get("stateToken"),
                sig_response: t
              },
              a = this.get("rememberDevice");
            return n(u.post(e, o)).then(function () {
              return i.doTransaction(function (t) {
                var e;
                return a && (e = {
                  rememberDevice: a
                }), t.poll(e);
              });
            }).fail(function (t) {
              i.trigger("error", i, t.xhr);
            });
          }
        },
        Form: {
          autoSave: !0,
          noButtonBar: !0,
          title: c.partial(t.loc, "factor.duo"),
          attributes: {
            "data-se": "factor-duo"
          },
          postRender: function postRender() {
            this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>'), this.options.appState.get("allowRememberDevice") && this.addInput({
              label: !1,
              "label-top": !0,
              placeholder: this.options.appState.get("rememberDeviceLabel"),
              className: "margin-btm-0",
              name: "rememberDevice",
              type: "checkbox"
            }), e.init({
              host: this.model.get("host"),
              sig_request: this.model.get("signature"),
              iframe: this.$("iframe").get(0),
              post_action: c.bind(this.model.verify, this.model)
            });
          }
        },
        Footer: s,
        fetchInitialData: function fetchInitialData() {
          var t = this;
          return this.model.getInitOptions().then(function (e) {
            var n = e.data;
            if (!(n._embedded && n._embedded.factor && n._embedded.factor._embedded && n._embedded.factor._embedded.verification)) throw new Error("Response does not have duo verification options");
            var r = n._embedded.factor._embedded.verification;
            t.model.set({
              host: r.host,
              signature: r.signature,
              postAction: r._links.complete.href,
              factorId: n._embedded.factor.id,
              stateToken: n.stateToken
            });
          });
        },
        trapAuthResponse: function trapAuthResponse() {
          if (this.options.appState.get("isMfaChallenge")) return !0;
        },
        back: function back() {}
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    var i,
      o,
      a = n(177),
      s = r(a),
      u = n(47),
      c = r(u),
      l = n(171),
      f = r(l);
    i = [n(555), n(556)], void 0 !== (o = function (t, e) {
      var n = {
          MILLISECOND: "milliseconds",
          SECOND: "seconds",
          MINUTE: "minutes",
          HOUR: "hours",
          DAY: "days"
        },
        r = (0, f.default)(n),
        i = function i(t) {
          var e = r.filter(function (e) {
            return n[e] === t;
          });
          return 1 === e.length ? e[0] : t;
        };
      return {
        getTimeInHighestRelevantUnit: function getTimeInHighestRelevantUnit(r, o) {
          var a = {
              days: 0,
              hours: 0,
              minutes: 0,
              seconds: 0,
              milliseconds: 0
            },
            u = n[o] || o,
            l = void 0;
          try {
            var p = e((0, c.default)(a, (0, s.default)({}, u, r)));
            l = t(p);
          } catch (t) {
            l = {};
          }
          var d = (0, f.default)(l).reduce(function (t, e) {
              return 0 !== l[e] && (t[e] = l[e]), t;
            }, {}),
            h = void 0,
            m = void 0;
          return 1 === (0, f.default)(d).length ? (0, f.default)(d).forEach(function (t) {
            m = d[t], h = t;
          }) : (m = r, h = u), {
            time: m,
            unit: i(h)
          };
        }
      };
    }.apply(e, i)) && (t.exports = o);
  }, function (t, e, n) {
    n(553), t.exports = n(9).Object.assign;
  }, function (t, e, n) {
    var r = n(21);
    r(r.S + r.F, "Object", {
      assign: n(554)
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(39),
      i = n(81),
      o = n(164),
      a = n(94),
      s = n(82),
      u = n(225),
      c = Object.assign;
    t.exports = !c || n(79)(function () {
      var t = {},
        e = {},
        n = Symbol(),
        r = "abcdefghijklmnopqrst";
      return t[n] = 7, r.split("").forEach(function (t) {
        e[t] = t;
      }), 7 != c({}, t)[n] || Object.keys(c({}, e)).join("") != r;
    }) ? function (t, e) {
      for (var n = s(t), c = arguments.length, l = 1, f = o.f, p = a.f; c > l;) for (var d, h = u(arguments[l++]), m = f ? i(h).concat(f(h)) : i(h), g = m.length, v = 0; g > v;) d = m[v++], r && !p.call(h, d) || (n[d] = h[d]);
      return n;
    } : c;
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t) {
      if ("number" != typeof t) throw new TypeError("Expected a number");
      var e = t > 0 ? Math.floor : Math.ceil;
      return {
        days: e(t / 864e5),
        hours: e(t / 36e5) % 24,
        minutes: e(t / 6e4) % 60,
        seconds: e(t / 1e3) % 60,
        milliseconds: e(t) % 1e3,
        microseconds: e(1e3 * t) % 1e3,
        nanoseconds: e(1e6 * t) % 1e3
      };
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    var i = n(89),
      o = r(i),
      a = n(244),
      s = r(a),
      u = n(557),
      c = r(u),
      l = {
        days: function days(t) {
          return 864e5 * t;
        },
        hours: function hours(t) {
          return 36e5 * t;
        },
        minutes: function minutes(t) {
          return 6e4 * t;
        },
        seconds: function seconds(t) {
          return 1e3 * t;
        },
        milliseconds: function milliseconds(t) {
          return t;
        },
        microseconds: function microseconds(t) {
          return t / 1e3;
        },
        nanoseconds: function nanoseconds(t) {
          return t / 1e6;
        }
      },
      f = function f(t) {
        return (0, c.default)(t).reduce(function (t, e) {
          var n = (0, s.default)(e, 2),
            r = n[0],
            i = n[1];
          if ("number" != typeof i) throw new TypeError("Expected a `number` for key `" + r + "`, got `" + i + "` (" + (void 0 === i ? "undefined" : (0, o.default)(i)) + ")");
          if (!l[r]) throw new Error("Unsupported time key");
          return t + l[r](i);
        }, 0);
      };
    t.exports = f, t.exports.default = f;
  }, function (t, e, n) {
    t.exports = {
      default: n(558),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(559), t.exports = n(9).Object.entries;
  }, function (t, e, n) {
    var r = n(21),
      i = n(560)(!0);
    r(r.S, "Object", {
      entries: function entries(t) {
        return i(t);
      }
    });
  }, function (t, e, n) {
    var r = n(39),
      i = n(81),
      o = n(56),
      a = n(94).f;
    t.exports = function (t) {
      return function (e) {
        for (var n, s = o(e), u = i(s), c = u.length, l = 0, f = []; c > l;) n = u[l++], r && !a.call(s, n) || f.push(t ? [n, s[n]] : s[n]);
        return f;
      };
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    var i,
      o,
      a = n(77),
      s = r(a),
      u = n(248),
      c = r(u),
      l = n(249),
      f = r(l);
    i = [n(0), n(2), n(4), n(178)], void 0 !== (o = function (t, e, n, r) {
      var i = t._,
        o = t.$,
        a = t.internal.util.Util;
      return e.extend({
        className: "piv-cac-card",
        Model: {
          save: function () {
            function e() {
              return n.apply(this, arguments);
            }
            var n = (0, f.default)(c.default.mark(function e() {
              var n, r, o, s;
              return c.default.wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return this.trigger("request"), n = this, r = this.settings.get("piv"), o = {
                      fromURI: this.settings.get("relayState"),
                      isCustomDomain: r.isCustomDomain
                    }, e.prev = 2, e.next = 5, this.getCert(r.certAuthUrl);
                  case 5:
                    return e.next = 7, this.postCert(r.certAuthUrl, o);
                  case 7:
                    s = e.sent, a.redirect(s.redirectUrl), e.next = 15;
                    break;
                  case 11:
                    e.prev = 11, e.t0 = e.catch(2), i.isEmpty(e.t0.responseJSON) && !e.t0.responseText && (e.t0.responseJSON = {
                      errorSummary: t.loc("piv.cac.error", "login")
                    }), n.trigger("error", n, e.t0);
                  case 15:
                  case "end":
                    return e.stop();
                }
              }, e, this, [[2, 11]]);
            }));
            return e;
          }(),
          getCert: function getCert(t) {
            return o.get({
              url: t,
              xhrFields: {
                withCredentials: !0
              },
              beforeSend: function beforeSend() {}
            });
          },
          postCert: function postCert(t, e) {
            return o.post({
              url: t,
              xhrFields: {
                withCredentials: !0
              },
              data: (0, s.default)(e),
              contentType: "text/plain",
              beforeSend: function beforeSend() {}
            });
          }
        },
        Form: {
          autoSave: !0,
          hasSavingState: !1,
          title: i.partial(t.loc, "piv.cac.title", "login"),
          className: "piv-cac-card",
          noCancelButton: !0,
          save: i.partial(t.loc, "retry", "login"),
          modelEvents: {
            request: "_startEnrollment",
            error: "_stopEnrollment"
          },
          formChildren: [n.View({
            View: '<div class="piv-verify-text">               <p>{{i18n code="piv.cac.card.insert" bundle="login"}}</p>               <div data-se="piv-waiting" class="okta-waiting-spinner"></div>             </div>'
          })],
          _startEnrollment: function _startEnrollment() {
            this.$(".okta-waiting-spinner").show(), this.$(".o-form-button-bar").hide();
          },
          _stopEnrollment: function _stopEnrollment() {
            this.$(".okta-waiting-spinner").hide(), this.$(".o-form-button-bar").show();
          },
          postRender: function postRender() {
            var t = this;
            i.defer(function () {
              t.model.save();
            });
          }
        },
        back: function back() {},
        Footer: r
      });
    }.apply(e, i)) && (t.exports = o);
  }, function (t, e, n) {
    /**
    * Copyright (c) 2014-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var r = function () {
        return this;
      }() || Function("return this")(),
      i = r.regeneratorRuntime && Object.getOwnPropertyNames(r).indexOf("regeneratorRuntime") >= 0,
      o = i && r.regeneratorRuntime;
    if (r.regeneratorRuntime = void 0, t.exports = n(563), i) r.regeneratorRuntime = o;else try {
      delete r.regeneratorRuntime;
    } catch (t) {
      r.regeneratorRuntime = void 0;
    }
  }, function (t, e) {
    /**
    * Copyright (c) 2014-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    !function (e) {
      "use strict";

      function n(t, e, n, r) {
        var o = e && e.prototype instanceof i ? e : i,
          a = Object.create(o.prototype),
          s = new d(r || []);
        return a._invoke = c(t, n, s), a;
      }
      function r(t, e, n) {
        try {
          return {
            type: "normal",
            arg: t.call(e, n)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }
      function i() {}
      function o() {}
      function a() {}
      function s(t) {
        ["next", "throw", "return"].forEach(function (e) {
          t[e] = function (t) {
            return this._invoke(e, t);
          };
        });
      }
      function u(t) {
        function e(n, i, o, a) {
          var s = r(t[n], t, i);
          if ("throw" !== s.type) {
            var u = s.arg,
              c = u.value;
            return c && "object" == typeof c && y.call(c, "__await") ? Promise.resolve(c.__await).then(function (t) {
              e("next", t, o, a);
            }, function (t) {
              e("throw", t, o, a);
            }) : Promise.resolve(c).then(function (t) {
              u.value = t, o(u);
            }, a);
          }
          a(s.arg);
        }
        function n(t, n) {
          function r() {
            return new Promise(function (r, i) {
              e(t, n, r, i);
            });
          }
          return i = i ? i.then(r, r) : r();
        }
        var i;
        this._invoke = n;
      }
      function c(t, e, n) {
        var i = T;
        return function (o, a) {
          if (i === A) throw new Error("Generator is already running");
          if (i === O) {
            if ("throw" === o) throw a;
            return m();
          }
          for (n.method = o, n.arg = a;;) {
            var s = n.delegate;
            if (s) {
              var u = l(s, n);
              if (u) {
                if (u === C) continue;
                return u;
              }
            }
            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (i === T) throw i = O, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            i = A;
            var c = r(t, e, n);
            if ("normal" === c.type) {
              if (i = n.done ? O : k, c.arg === C) continue;
              return {
                value: c.arg,
                done: n.done
              };
            }
            "throw" === c.type && (i = O, n.method = "throw", n.arg = c.arg);
          }
        };
      }
      function l(t, e) {
        var n = t.iterator[e.method];
        if (n === g) {
          if (e.delegate = null, "throw" === e.method) {
            if (t.iterator.return && (e.method = "return", e.arg = g, l(t, e), "throw" === e.method)) return C;
            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return C;
        }
        var i = r(n, t.iterator, e.arg);
        if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, C;
        var o = i.arg;
        return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = g), e.delegate = null, C) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, C);
      }
      function f(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }
      function p(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }
      function d(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(f, this), this.reset(!0);
      }
      function h(t) {
        if (t) {
          var e = t[b];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;
          if (!isNaN(t.length)) {
            var n = -1,
              r = function e() {
                for (; ++n < t.length;) if (y.call(t, n)) return e.value = t[n], e.done = !1, e;
                return e.value = g, e.done = !0, e;
              };
            return r.next = r;
          }
        }
        return {
          next: m
        };
      }
      function m() {
        return {
          value: g,
          done: !0
        };
      }
      var g,
        v = Object.prototype,
        y = v.hasOwnProperty,
        _ = "function" == typeof Symbol ? Symbol : {},
        b = _.iterator || "@@iterator",
        w = _.asyncIterator || "@@asyncIterator",
        S = _.toStringTag || "@@toStringTag",
        x = "object" == typeof t,
        E = e.regeneratorRuntime;
      if (E) return void (x && (t.exports = E));
      E = e.regeneratorRuntime = x ? t.exports : {}, E.wrap = n;
      var T = "suspendedStart",
        k = "suspendedYield",
        A = "executing",
        O = "completed",
        C = {},
        I = {};
      I[b] = function () {
        return this;
      };
      var R = Object.getPrototypeOf,
        P = R && R(R(h([])));
      P && P !== v && y.call(P, b) && (I = P);
      var N = a.prototype = i.prototype = Object.create(I);
      o.prototype = N.constructor = a, a.constructor = o, a[S] = o.displayName = "GeneratorFunction", E.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === o || "GeneratorFunction" === (e.displayName || e.name));
      }, E.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, a) : (t.__proto__ = a, S in t || (t[S] = "GeneratorFunction")), t.prototype = Object.create(N), t;
      }, E.awrap = function (t) {
        return {
          __await: t
        };
      }, s(u.prototype), u.prototype[w] = function () {
        return this;
      }, E.AsyncIterator = u, E.async = function (t, e, r, i) {
        var o = new u(n(t, e, r, i));
        return E.isGeneratorFunction(e) ? o : o.next().then(function (t) {
          return t.done ? t.value : o.next();
        });
      }, s(N), N[S] = "Generator", N[b] = function () {
        return this;
      }, N.toString = function () {
        return "[object Generator]";
      }, E.keys = function (t) {
        var e = [];
        for (var n in t) e.push(n);
        return e.reverse(), function n() {
          for (; e.length;) {
            var r = e.pop();
            if (r in t) return n.value = r, n.done = !1, n;
          }
          return n.done = !0, n;
        };
      }, E.values = h, d.prototype = {
        constructor: d,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = g, this.done = !1, this.delegate = null, this.method = "next", this.arg = g, this.tryEntries.forEach(p), !t) for (var e in this) "t" === e.charAt(0) && y.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = g);
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0],
            e = t.completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          function e(e, r) {
            return o.type = "throw", o.arg = t, n.next = e, r && (n.method = "next", n.arg = g), !!r;
          }
          if (this.done) throw t;
          for (var n = this, r = this.tryEntries.length - 1; r >= 0; --r) {
            var i = this.tryEntries[r],
              o = i.completion;
            if ("root" === i.tryLoc) return e("end");
            if (i.tryLoc <= this.prev) {
              var a = y.call(i, "catchLoc"),
                s = y.call(i, "finallyLoc");
              if (a && s) {
                if (this.prev < i.catchLoc) return e(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return e(i.finallyLoc);
              } else if (a) {
                if (this.prev < i.catchLoc) return e(i.catchLoc, !0);
              } else {
                if (!s) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return e(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var r = this.tryEntries[n];
            if (r.tryLoc <= this.prev && y.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
              var i = r;
              break;
            }
          }
          i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var o = i ? i.completion : {};
          return o.type = t, o.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, C) : this.complete(o);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), C;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var n = this.tryEntries[e];
            if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), p(n), C;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var n = this.tryEntries[e];
            if (n.tryLoc === t) {
              var r = n.completion;
              if ("throw" === r.type) {
                var i = r.arg;
                p(n);
              }
              return i;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, n) {
          return this.delegate = {
            iterator: h(t),
            resultName: e,
            nextLoc: n
          }, "next" === this.method && (this.arg = g), C;
        }
      };
    }(function () {
      return this;
    }() || Function("return this")());
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(83), n(565), n(566), n(567), n(568), n(574), n(569), n(571), n(572), n(573), n(51)], void 0 !== (i = function (t, e, n, r, i, o, a, s, u, c, l, f) {
      var p = t.internal.views.forms.inputs.CheckBox;
      return e.extend({
        className: "mfa-verify",
        initialize: function initialize(e) {
          var d,
            h = e.factorType;
          switch (h) {
            case "question":
              d = i;
              break;
            case "email":
              d = this.options.appState.get("isIdxStateToken") ? a : l;
              break;
            case "sms":
            case "call":
              d = o;
              break;
            case "token":
            case "token:software:totp":
            case "token:hotp":
              d = n;
              break;
            case "token:hardware":
              d = r;
              break;
            case "push":
              d = s;
              break;
            case "password":
              d = u;
              break;
            default:
              throw new Error("Unrecognized factor type");
          }
          if (this.model = this.findModel(h, e), !this.model) throw new Error("Unrecognized factor/provider");
          this.addListeners(), this.add(new d(this.toJSON())), "push" === h && this.model.get("isOktaFactor") && (this.model.get("backupFactor") && (this.inlineTotpForm = this.add(c, {
            options: {
              model: this.model.get("backupFactor")
            }
          }).last()), this.settings.get("features.autoPush") && (this.autoPushCheckBox = this.add(p, {
            options: {
              model: this.model,
              name: "autoPush",
              placeholder: t.loc("autoPush", "login"),
              label: !1,
              "label-top": !1,
              className: "margin-btm-0"
            }
          }).last()), this.options.appState.get("allowRememberDevice") && (this.rememberDeviceCheckbox = this.add(p, {
            options: {
              model: this.model,
              name: "rememberDevice",
              placeholder: this.options.appState.get("rememberDeviceLabel"),
              label: !1,
              "label-top": !0,
              className: "margin-btm-0"
            }
          }).last()), this.model.get("backupFactor") && this.listenTo(this.model, "change:rememberDevice", function (t, e) {
            t.get("backupFactor").set("rememberDevice", e);
          })), this.listenTo(this.options.appState, "change:isWaitingForNumberChallenge", function (t, e) {
            e || "SUCCESS" === this.options.appState.get("lastAuthResponse").status ? (this.autoPushCheckBox && this.autoPushCheckBox.$el.hide(), this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.hide(), this.inlineTotpForm && this.inlineTotpForm.$el.hide()) : (this.autoPushCheckBox && this.autoPushCheckBox.$el.show(), this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.show(), this.inlineTotpForm && this.inlineTotpForm.$el.show());
          }), this.settings.get("features.hideSignOutLinkInMFA") || this.add(new f(this.toJSON()));
        },
        findModel: function findModel(t, e) {
          var n = e.appState.get("factors"),
            r = e.provider,
            i = e.factorIndex;
          return r ? n.hasMultipleFactorsOfSameType(t) && i ? n.getFactorByTypeAndIndex(t, i) : n.findWhere({
            provider: r,
            factorType: t
          }) : n.findWhere({
            factorType: t,
            isFactorTypeVerification: !0
          });
        },
        trapAuthResponse: function trapAuthResponse() {
          return !!(this.options.appState.get("isMfaRequired") && this.options.appState.get("trapMfaRequiredResponse") || this.options.appState.get("isMfaChallenge")) && (this.options.appState.set("trapMfaRequiredResponse", !1), !0);
        },
        back: function back() {}
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(14)], void 0 !== (i = function (t, e) {
      var n = t._;
      return t.Form.extend({
        className: "mfa-verify-totp",
        autoSave: !0,
        noCancelButton: !0,
        save: n.partial(t.loc, "mfa.challenge.verify", "login"),
        scrollOnError: !1,
        layout: "o-form-theme",
        attributes: {
          "data-se": "factor-totp"
        },
        initialize: function initialize() {
          var r = this.model.get("factorLabel"),
            i = "RSA" === this.model.get("provider") || "DEL_OATH" === this.model.get("provider");
          this.title = r, this.model.get("isFactorTypeVerification") ? this.subtitle = t.loc("mfa.challenge.totp.subtitle.multiple", "login", [r]) : this.subtitle = t.loc("mfa.challenge.title", "login", [r]), this.addInput({
            label: t.loc("mfa.challenge.enterCode.placeholder", "login"),
            "label-top": !0,
            className: "o-form-fieldset o-form-label-top auth-passcode",
            name: "answer",
            input: e,
            type: i ? "password" : "tel"
          }), this.options.appState.get("allowRememberDevice") && this.addInput({
            label: !1,
            "label-top": !0,
            placeholder: this.options.appState.get("rememberDeviceLabel"),
            className: "margin-btm-0",
            name: "rememberDevice",
            type: "checkbox"
          }), "RSA" !== this.model.get("provider") && "DEL_OATH" !== this.model.get("provider") || this.listenTo(this.model, "error", n.bind(function (t, e) {
            e && 409 === e.status && (this.$(".auth-passcode input").val(""), this.$(".auth-passcode input").trigger("change"), this.$(".auth-passcode input").focus());
          }, this));
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(14)], void 0 !== (i = function (t, e) {
      var n = t._;
      return t.Form.extend({
        className: "mfa-verify-yubikey",
        autoSave: !0,
        noCancelButton: !0,
        save: n.partial(t.loc, "mfa.challenge.verify", "login"),
        scrollOnError: !1,
        layout: "o-form-theme",
        attributes: {
          "data-se": "factor-yubikey"
        },
        initialize: function initialize() {
          var n = this.model.get("factorLabel");
          this.title = n, this.subtitle = t.loc("factor.totpHard.yubikey.description", "login"), this.addInput({
            label: t.loc("factor.totpHard.yubikey.placeholder", "login"),
            "label-top": !0,
            className: "o-form-fieldset o-form-label-top auth-passcode",
            name: "answer",
            input: e,
            inputId: "mfa-answer",
            type: "password"
          }), this.options.appState.get("allowRememberDevice") && this.addInput({
            label: !1,
            "label-top": !0,
            className: "margin-btm-0",
            placeholder: this.options.appState.get("rememberDeviceLabel"),
            name: "rememberDevice",
            type: "checkbox"
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      var e = t._;
      return t.Form.extend({
        className: "mfa-verify-question",
        autoSave: !0,
        noCancelButton: !0,
        save: e.partial(t.loc, "mfa.challenge.verify", "login"),
        scrollOnError: !1,
        layout: "o-form-theme",
        attributes: {
          "data-se": "factor-question"
        },
        initialize: function initialize() {
          this.title = this.model.get("factorLabel"), this.addInput({
            label: this.model.get("securityQuestion"),
            "label-top": !0,
            placeholder: t.loc("mfa.challenge.answer.placeholder", "login"),
            className: "auth-passcode",
            name: "answer",
            type: "password",
            params: {
              showPasswordToggle: !0
            }
          }), this.options.appState.get("allowRememberDevice") && this.addInput({
            label: !1,
            "label-top": !0,
            placeholder: this.options.appState.get("rememberDeviceLabel"),
            className: "margin-btm-0",
            name: "rememberDevice",
            type: "checkbox"
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(17), n(14), n(6)], void 0 !== (i = function (t, e, n, r) {
      function i(e) {
        switch (e) {
          case "sms":
            return {
              buttonDataSe: "sms-send-code",
              buttonClassName: "sms-request-button",
              formSubmit: t.loc("mfa.sendCode", "login"),
              formRetry: t.loc("mfa.resendCode", "login"),
              formSubmitted: t.loc("mfa.sent", "login"),
              subtitle: o({
                subtitle: this.model.get("phoneNumber")
              }),
              warning: t.loc("factor.sms.time.warning", "login")
            };
          case "call":
            return {
              buttonDataSe: "make-call",
              buttonClassName: "call-request-button",
              formSubmit: t.loc("mfa.call", "login"),
              formRetry: t.loc("mfa.redial", "login"),
              formSubmitted: t.loc("mfa.calling", "login"),
              subtitle: o({
                subtitle: this.model.get("phoneNumber")
              }),
              warning: t.loc("factor.call.time.warning", "login")
            };
          case "email":
            return {
              buttonDataSe: "email-send-code",
              buttonClassName: "email-request-button",
              formSubmit: t.loc("mfa.sendEmail", "login"),
              formRetry: t.loc("mfa.resendEmail", "login"),
              formSubmitted: t.loc("mfa.sent", "login"),
              subtitle: o({
                subtitle: this.model.get("email")
              })
            };
          default:
            return {
              buttonDataSe: "",
              buttonClassName: "",
              formSubmit: "",
              formRetry: "",
              formSubmitted: ""
            };
        }
      }
      var o = t.tpl("({{subtitle}})"),
        a = t._;
      return t.Form.extend({
        className: "mfa-verify-passcode",
        autoSave: !0,
        noCancelButton: !0,
        save: a.partial(t.loc, "mfa.challenge.verify", "login"),
        scrollOnError: !1,
        layout: "o-form-theme",
        disableSubmitButton: function disableSubmitButton() {
          return this.model.appState.get("isMfaChallenge") && this.model.get("answer");
        },
        showWarning: function showWarning(t) {
          this.clearWarnings(), this.add('<div class="okta-form-infobox-warning infobox infobox-warning login-timeout-warning">                           <span class="icon warning-16"></span>                           <p>{{{warning}}}</p>                         </div>                         ', ".o-form-error-container", {
            options: {
              warning: t
            }
          });
        },
        clearWarnings: function clearWarnings() {
          this.$(".okta-form-infobox-warning").remove();
        },
        initialize: function initialize() {
          var o = this;
          this.title = this.model.get("factorLabel");
          var s = this.model.get("factorType"),
            u = i.call(this, s),
            c = u.warning;
          this.$el.attr("data-se", "factor-" + s), this.subtitle = u.subtitle, this.listenTo(this.model, "error", function () {
            this.clearErrors();
          }), this.addInput({
            label: t.loc("mfa.challenge.enterCode.placeholder", "login"),
            "label-top": !0,
            className: "o-form-fieldset o-form-label-top auth-passcode",
            name: "answer",
            input: n,
            type: "tel"
          }), this.add(t.createButton({
            attributes: {
              "data-se": u.buttonDataSe
            },
            className: "button " + u.buttonClassName,
            title: u.formSubmit,
            click: function click() {
              o.clearErrors(), this.disable(), o.clearWarnings(), this.options.title = u.formSubmitted, this.render(), this.model.set("answer", ""), this.model.save().then(function () {
                return o.getInputs().first().render().focus(), e.delay(r.API_RATE_LIMIT);
              }).then(a.bind(function () {
                this.options.title = u.formRetry, this.enable(), "call" !== s && "sms" !== s || o.showWarning(c), this.render();
              }, this));
            }
          })), this.options.appState.get("allowRememberDevice") && this.addInput({
            label: !1,
            "label-top": !0,
            placeholder: this.options.appState.get("rememberDeviceLabel"),
            className: "margin-btm-0",
            name: "rememberDevice",
            type: "checkbox"
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(176), n(13), n(570)], void 0 !== (i = function (t, e, n, r) {
      var i = t._,
        o = t.tpl("{{factorName}} ({{{deviceName}}})");
      return t.Form.extend({
        className: "mfa-verify-push",
        autoSave: !0,
        noCancelButton: !0,
        save: i.partial(t.loc, "oktaverify.send", "login"),
        scrollOnError: !1,
        layout: "o-form-theme",
        attributes: {
          "data-se": "factor-push"
        },
        events: {
          submit: "submit"
        },
        initialize: function initialize() {
          this.enabled = !0, this.listenTo(this.options.appState, "change:isMfaRejectedByUser", function (e, n) {
            this.setSubmitState(n), n && this.showError(t.loc("oktaverify.rejected", "login"));
          }), this.numberChallengeView = this.add(r).last(), this.listenTo(this.options.appState, "change:isWaitingForNumberChallenge", function (t, e) {
            e || "SUCCESS" === this.options.appState.get("lastAuthResponse").status ? (this.clearWarnings(), this.$el.find(".button").hide(), this.numberChallengeView.$el.show()) : (this.numberChallengeView.$el.hide(), this.$el.find(".button").show());
          }), this.listenTo(this.options.appState, "change:isMfaTimeout", function (e, n) {
            this.setSubmitState(n), n && this.showError(t.loc("oktaverify.timeout", "login"));
          }), this.listenTo(this.options.appState, "change:isMfaRequired", function (t, e) {
            e && (this.clearErrors(), this.clearWarnings());
          }), this.title = o({
            factorName: this.model.get("factorLabel"),
            deviceName: this.model.get("deviceName")
          });
        },
        setSubmitState: function setSubmitState(e) {
          var n = this.$el.find(".button");
          this.enabled = e, e ? (n.removeClass("link-button-disabled"), n.prop("value", t.loc("oktaverify.send", "login")), n.prop("disabled", !1)) : (n.addClass("link-button-disabled"), n.prop("value", t.loc("oktaverify.sent", "login")), n.prop("disabled", !0));
        },
        submit: function submit(t) {
          void 0 !== t && t.preventDefault(), this.enabled && (this.setSubmitState(!1), this.doSave());
        },
        postRender: function postRender() {
          var t = this.options.appState.get("factorsPolicyInfo"),
            e = this.model.get("id");
          !!(this.settings.get("features.autoPush") && t && t[e]) && t[e].autoPushEnabled && (this.model.set("autoPush", !0), i.defer(i.bind(this.submit, this)));
        },
        doSave: function doSave() {
          var e;
          this.clearErrors(), this.clearWarnings(), this.model.isValid() && (this.listenToOnce(this.model, "error", function () {
            this.setSubmitState(!0), this.clearWarnings(), clearTimeout(e);
          }), this.trigger("save", this.model), e = n.callAfterTimeout(i.bind(function () {
            this.options.appState.get("isWaitingForNumberChallenge") || this.showWarning(t.loc("oktaverify.warning", "login"));
          }, this), 3e4));
        },
        showError: function showError(t) {
          this.clearWarnings(), this.model.trigger("error", this.model, {
            responseJSON: {
              errorSummary: t
            }
          });
        },
        showWarning: function showWarning(t) {
          this.clearWarnings(), this.add('<div class="okta-form-infobox-warning infobox infobox-warning">                           <span class="icon warning-16"></span>                           <p>{{warning}}</p>                         </div>', ".o-form-error-container", {
            options: {
              warning: t
            }
          });
        },
        clearWarnings: function clearWarnings() {
          this.$(".okta-form-infobox-warning").remove();
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      return t.View.extend({
        className: "number-challenge-view",
        template: '\n      <p data-se="number-challenge-instruction">\n        {{{i18n code="oktaverify.numberchallenge.instruction" bundle="login" arguments="number"}}}\n      </p>\n      <div class="phone">\n        <div class="phone--body">\n          <div class="phone--screen">\n            <span class="phone--number" data-se="challenge-number">{{number}}</span>\n          </div>\n          <div class="phone--home-button"></div>\n        </div>\n      </div>\n      <p>{{i18n code="oktaverify.numberchallenge.explain"  bundle="login"}}</p>\n    ',
        initialize: function initialize() {
          var t = this;
          this.listenTo(this.options.appState, "change:isWaitingForNumberChallenge", function () {
            "SUCCESS" !== t.options.appState.get("lastAuthResponse").status && t.render();
          });
        },
        getTemplateData: function getTemplateData() {
          var t = this.options.appState.get("lastAuthResponse");
          return this.options.appState.get("isWaitingForNumberChallenge") ? {
            number: t._embedded.factor._embedded.challenge.correctAnswer
          } : {
            number: null
          };
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      var e = t._;
      return t.Form.extend({
        className: "mfa-verify-password",
        autoSave: !0,
        noCancelButton: !0,
        save: e.partial(t.loc, "mfa.challenge.verify", "login"),
        scrollOnError: !1,
        layout: "o-form-theme",
        attributes: {
          "data-se": "factor-password"
        },
        initialize: function initialize() {
          this.title = this.model.get("factorLabel"), this.addInput({
            label: t.loc("mfa.challenge.password.placeholder", "login"),
            "label-top": !0,
            className: "auth-passcode",
            name: "password",
            type: "password",
            params: {
              showPasswordToggle: !0
            }
          }), this.options.appState.get("allowRememberDevice") && this.addInput({
            label: !1,
            "label-top": !0,
            placeholder: this.options.appState.get("rememberDeviceLabel"),
            className: "margin-btm-0",
            name: "rememberDevice",
            type: "checkbox"
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(14)], void 0 !== (i = function (t, e) {
      function n(n) {
        n.addDivider(), n.addInput({
          label: t.loc("mfa.challenge.enterCode.placeholder", "login"),
          "label-top": !0,
          className: "o-form-fieldset o-form-label-top inline-input auth-passcode",
          name: "answer",
          input: e,
          type: "tel"
        }), n.add(t.createButton({
          attributes: {
            "data-se": "inline-totp-verify"
          },
          className: "button inline-totp-verify margin-top-30",
          title: t.loc("mfa.challenge.verify", "login"),
          click: function click() {
            n.isValid() && n.model.manageTransaction(function (t, e) {
              if ("MFA_CHALLENGE" === t.status && t.prev) return n.options.appState.set("trapMfaRequiredResponse", !0), t.prev().then(function (t) {
                e(t), n.model.save();
              });
              n.model.save();
            });
          }
        })), n.at(1).focus();
      }
      return t.Form.extend({
        autoSave: !0,
        noButtonBar: !0,
        scrollOnError: !1,
        layout: "o-form-theme",
        className: "mfa-verify-totp-inline",
        attributes: {
          "data-se": "factor-inline-totp"
        },
        initialize: function initialize() {
          var e = this;
          this.listenTo(this.model, "error", function () {
            this.clearErrors();
          }), this.add(t.createButton({
            className: "link",
            attributes: {
              "data-se": "inline-totp-add"
            },
            title: t.loc("mfa.challenge.orEnterCode", "login"),
            click: function click() {
              this.remove(), n(e);
            }
          }));
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r,
      i,
      o = n(47),
      a = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(o);
    r = [n(0), n(14), n(250)], void 0 !== (i = function (t, e, n) {
      var r = t._,
        i = function i() {
          var e = this.model.get("email");
          return {
            factorEmail: t.tpl('<span class="mask-email">{{email}}</span>')({
              email: e
            })
          };
        };
      return t.Form.extend({
        layout: "o-form-theme",
        className: "mfa-verify-email",
        title: r.partial(t.loc, "email.mfa.title", "login"),
        noButtonBar: !1,
        autoSave: !0,
        noCancelButton: !0,
        attributes: {
          "data-se": "factor-email"
        },
        save: function save() {
          return this.options.appState.get("isMfaChallenge") ? t.loc("mfa.challenge.verify", "login") : t.loc("email.button.send", "login");
        },
        events: (0, a.default)({}, t.Form.prototype.events, {
          submit: function submit(t) {
            t.preventDefault(), this.clearErrors(), this.options.appState.get("isMfaChallenge") ? this.isValid() && this.model.save() : (this.model.set("answer", ""), this.model.save().then(this.renderChallengView.bind(this)));
          }
        }),
        initialize: function initialize() {
          t.Form.prototype.initialize.apply(this, arguments), this.add(t.View.extend({
            attributes: {
              "data-se": "mfa-send-email-content"
            },
            className: "mfa-send-email-content",
            template: '{{{i18n code="email.mfa.description" bundle="login" arguments="factorEmail"}}}',
            getTemplateData: i
          }));
        },
        renderChallengView: function renderChallengView() {
          this.removeChildren(), this.add(t.View.extend({
            className: "mfa-email-sent-content",
            attributes: {
              "data-se": "mfa-email-sent-content"
            },
            template: '{{{i18n code="email.mfa.email.sent.description" bundle="login" arguments="factorEmail"}}}',
            getTemplateData: i
          })), this.add(n), this.addInput({
            label: t.loc("email.code.label", "login"),
            "label-top": !0,
            name: "answer",
            input: e,
            wide: !0,
            type: "tel"
          }), this.options.appState.get("allowRememberDevice") && this.addInput({
            label: !1,
            "label-top": !0,
            placeholder: this.options.appState.get("rememberDeviceLabel"),
            className: "margin-btm-0",
            name: "rememberDevice",
            type: "checkbox"
          }), this.render();
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(17), n(6)], void 0 !== (i = function (t, e, n) {
      var r = t._;
      return t.Form.extend({
        layout: "o-form-theme",
        className: "factor-verify-magiclink",
        autoSave: !0,
        noCancelButton: !0,
        initialize: function initialize() {
          var i = this;
          this.title = this.model.get("factorLabel");
          var o = this.model.get("email") || this.options.appState.get("lastAuthResponse")._embedded.user.profile.login;
          this.subtitle = "(" + o + ")", this.add(t.createButton({
            attributes: {
              "data-se": "email-send-code"
            },
            className: "button email-request-button",
            title: t.loc("mfa.sendEmail", "login"),
            click: function click() {
              i.clearErrors(), this.disable(), this.options.title = t.loc("mfa.sent", "login"), this.render(), this.model.save().then(r.bind(function () {
                return e.delay(n.API_RATE_LIMIT);
              }, this)).then(r.bind(function () {
                this.options.title = t.loc("mfa.resendEmail", "login"), this.enable(), this.render();
              }, this));
            }
          }));
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(4), n(97), n(251), n(51), n(52)], void 0 !== (i = function (t, e, n, r, i, o, a) {
      var s = t._;
      return e.extend({
        className: "mfa-verify verify-windows-hello",
        Model: {
          local: {
            __autoTriggered__: "boolean"
          },
          save: function save() {
            if (r.isAvailable()) {
              this.trigger("request");
              var t = this;
              return this.doTransaction(function (e) {
                var n = s.findWhere(e.factors, {
                  factorType: "webauthn",
                  provider: "FIDO"
                });
                return n.verify().then(function (i) {
                  var o = i.factor;
                  return r.getAssertion(o.challenge.nonce, [{
                    id: o.profile.credentialId
                  }]).then(function (t) {
                    return n.verify({
                      authenticatorData: t.authenticatorData,
                      clientData: t.clientData,
                      signatureData: t.signature
                    });
                  }).then(function (e) {
                    return t.trigger("sync"), t.trigger("signIn"), e;
                  }).fail(function (n) {
                    switch (n.message) {
                      case "AbortError":
                      case "NotFoundError":
                      case "NotSupportedError":
                        return t.trigger("abort", n.message), e;
                    }
                    throw n;
                  });
                });
              });
            }
          }
        },
        Form: {
          autoSave: !0,
          hasSavingState: !1,
          title: s.partial(t.loc, "factor.windowsHello", "login"),
          subtitle: function subtitle() {
            return r.isAvailable() ? t.loc("verify.windowsHello.subtitle", "login") : "";
          },
          save: s.partial(t.loc, "verify.windowsHello.save", "login"),
          customSavingState: {
            stop: "abort"
          },
          modelEvents: function modelEvents() {
            return r.isAvailable() ? {
              request: "_startEnrollment",
              error: "_stopEnrollment",
              abort: "_stopEnrollment",
              signIn: "_successEnrollment"
            } : {};
          },
          noButtonBar: function noButtonBar() {
            return !r.isAvailable();
          },
          formChildren: function formChildren() {
            var e = [];
            return r.isAvailable() || e.push(n.View({
              View: new a({
                message: t.loc("enroll.windowsHello.error.notWindows", "login")
              })
            }, {
              selector: ".o-form-error-container"
            })), e.push(n.View({
              View: new i({
                model: this.model,
                visible: !1
              })
            })), e;
          },
          postRender: function postRender() {
            1 !== this.options.appState.get("factors").length || this.model.get("__autoTriggered__") || (this.model.set("__autoTriggered__", !0), this.model.save());
          },
          _startEnrollment: function _startEnrollment() {
            this.subtitle = t.loc("verify.windowsHello.subtitle.loading", "login"), this.model.trigger("spinner:show"), this._resetErrorMessage(), this.render(), this.$(".o-form-button-bar").addClass("hide");
          },
          _stopEnrollment: function _stopEnrollment(e) {
            this.subtitle = t.loc("verify.windowsHello.subtitle", "login"), this.model.trigger("spinner:hide"), this.$(".o-form-button-bar").removeClass("hide");
            var n;
            switch (e) {
              case "NotFoundError":
                n = this.options.appState.get("factors").length > 1 ? t.loc("verify.windowsHello.error.notFound.selectAnother", "login") : t.loc("verify.windowsHello.error.notFound", "login");
                break;
              case "NotSupportedError":
                n = t.loc("enroll.windowsHello.error.notConfiguredHtml", "login");
            }
            if (this._resetErrorMessage(), n) {
              var r = new a({
                message: n
              });
              this.$(".o-form-error-container").addClass("o-form-has-errors"), this.add(r, {
                selector: ".o-form-error-container"
              }), this._errorMessageView = this.last();
            }
            this.render();
          },
          _successEnrollment: function _successEnrollment() {
            this.subtitle = this.settings.get("brandName") ? t.loc("verify.windowsHello.subtitle.signingIn.specific", "login", [this.settings.get("brandName")]) : t.loc("verify.windowsHello.subtitle.signingIn.generic", "login"), this.render(), this.$(".o-form-button-bar").addClass("hide");
          },
          _resetErrorMessage: function _resetErrorMessage() {
            this._errorMessageView && this._errorMessageView.remove(), this._errorMessageView = void 0, this.clearErrors();
          }
        },
        back: function back() {},
        Footer: o
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    t.exports = {
      default: n(577),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(578), t.exports = n(9).Object.freeze;
  }, function (t, e, n) {
    var r = n(46),
      i = n(230).onFreeze;
    n(95)("freeze", function (t) {
      return function (e) {
        return t && r(e) ? t(i(e)) : e;
      };
    });
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(33), n(2), n(4), n(51), n(17), n(18), n(179), n(52), n(252)], void 0 !== (i = function (t, e, n, r, i, o, a, s, u) {
      function c(t) {
        var e = [];
        return l.each(t, function (t) {
          e.push({
            version: t.profile.version,
            keyHandle: t.profile.credentialId
          });
        }), e;
      }
      var l = t._;
      return n.extend({
        className: "mfa-verify verify-u2f",
        Model: {
          props: {
            rememberDevice: "boolean"
          },
          initialize: function initialize() {
            var t = a.getRememberDeviceValue(this.appState);
            this.set("rememberDevice", t);
          },
          save: function save() {
            return this.trigger("request"), this.doTransaction(function (t) {
              var n;
              n = t.factorTypes ? l.findWhere(t.factorTypes, {
                factorType: "u2f"
              }) : l.findWhere(t.factors, {
                factorType: "u2f",
                provider: "FIDO"
              });
              var r = this;
              return n.verify().then(function (t) {
                var i, a, u;
                if (t.factors) {
                  var l = t.factors;
                  a = l[0].profile.appId, u = t.challenge.nonce, i = c(l);
                } else {
                  var f = t.factor;
                  a = f.profile.appId, u = f.challenge.nonce, i = [{
                    version: s.getU2fVersion(),
                    keyHandle: f.profile.credentialId
                  }];
                }
                r.trigger("request");
                var p = o.defer();
                return u2f.sign(a, u, i, function (t) {
                  if (r.trigger("errors:clear"), !t.errorCode || 0 === t.errorCode) {
                    var i = !!r.get("rememberDevice");
                    return n.verify({
                      clientData: t.clientData,
                      signatureData: t.signatureData,
                      rememberDevice: i
                    }).then(p.resolve);
                  }
                  var o = 1 === r.options.appState.get("factors").length;
                  p.reject(new e.U2FError({
                    xhr: {
                      responseJSON: {
                        errorSummary: s.getU2fVerifyErrorMessageByCode(t.errorCode, o)
                      }
                    }
                  }));
                }), p.promise;
              });
            });
          }
        },
        Form: {
          autoSave: !0,
          hasSavingState: !1,
          title: l.partial(t.loc, "factor.u2f", "login"),
          className: "verify-u2f-form",
          noCancelButton: !0,
          save: l.partial(t.loc, "verify.u2f.retry", "login"),
          noButtonBar: function noButtonBar() {
            return !s.isU2fAvailable();
          },
          modelEvents: {
            request: "_startEnrollment",
            error: "_stopEnrollment"
          },
          formChildren: function formChildren() {
            var e = [];
            if (s.isU2fAvailable()) e.push(r.View({
              View: '            <div class="u2f-verify-text">              <p>{{i18n code="verify.u2f.instructions" bundle="login"}}</p>              <p>{{i18n code="verify.u2f.instructionsBluetooth" bundle="login"}}</p>              <div data-se="u2f-waiting" class="okta-waiting-spinner"></div>            </div>'
            }));else {
              var n = "u2f.error.factorNotSupported";
              1 === this.options.appState.get("factors").length && (n = "u2f.error.factorNotSupported.oneFactor"), e.push(r.View({
                View: new u({
                  message: t.loc(n, "login")
                })
              }, {
                selector: ".o-form-error-container"
              }));
            }
            return this.options.appState.get("allowRememberDevice") && e.push(r.Input({
              label: !1,
              "label-top": !0,
              placeholder: this.options.appState.get("rememberDeviceLabel"),
              className: "margin-btm-0",
              name: "rememberDevice",
              type: "checkbox"
            })), e;
          },
          postRender: function postRender() {
            l.defer(l.bind(function () {
              s.isU2fAvailable() ? this.model.save() : this.$('[data-se="u2f-waiting"]').addClass("hide");
            }, this));
          },
          _startEnrollment: function _startEnrollment() {
            this.$(".okta-waiting-spinner").removeClass("hide"), this.$(".o-form-button-bar").hide();
          },
          _stopEnrollment: function _stopEnrollment() {
            this.$(".okta-waiting-spinner").addClass("hide"), this.$(".o-form-button-bar").show();
          }
        },
        back: function back() {},
        Footer: i
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(33), n(2), n(4), n(180), n(97), n(51), n(17), n(18), n(52)], void 0 !== (i = function (t, e, n, r, i, o, a, s, u, c) {
      function l(t) {
        var e = [];
        return f.each(t, function (t) {
          e.push({
            type: "public-key",
            id: i.strToBin(t.profile.credentialId)
          });
        }), e;
      }
      var f = t._;
      return n.extend({
        className: "mfa-verify verify-webauthn",
        Model: {
          props: {
            rememberDevice: "boolean"
          },
          initialize: function initialize() {
            var t = this,
              e = u.getRememberDeviceValue(this.appState);
            this.set("rememberDevice", e), this.appState.on("factorSwitched signOut", function () {
              t.webauthnAbortController && (t.webauthnAbortController.abort(), t.webauthnAbortController = null);
            });
          },
          save: function save() {
            return this.trigger("request"), this.doTransaction(function (t) {
              var n;
              n = t.factorTypes ? f.findWhere(t.factorTypes, {
                factorType: "webauthn"
              }) : f.findWhere(t.factors, {
                factorType: "webauthn",
                provider: "FIDO"
              });
              var r = this;
              return n.verify().then(function (t) {
                var o, a;
                if (t.factors) {
                  var u = t.factors;
                  a = t.challenge, o = l(u);
                } else {
                  var c = t.factor;
                  a = c.challenge, o = l([c]);
                }
                r.trigger("request");
                var p = f.extend({}, a, {
                  allowCredentials: o,
                  challenge: i.strToBin(a.challenge)
                });
                return r.webauthnAbortController = new AbortController(), new s(navigator.credentials.get({
                  publicKey: p,
                  signal: r.webauthnAbortController.signal
                })).then(function (t) {
                  var e = !!r.get("rememberDevice");
                  return n.verify({
                    clientData: i.binToStr(t.response.clientDataJSON),
                    authenticatorData: i.binToStr(t.response.authenticatorData),
                    signatureData: i.binToStr(t.response.signature),
                    rememberDevice: e
                  });
                }).fail(function (t) {
                  throw r.trigger("errors:clear"), r.webauthnAbortController ? new e.WebAuthnError({
                    xhr: {
                      responseJSON: {
                        errorSummary: t.message
                      }
                    }
                  }) : new e.WebauthnAbortError();
                }).finally(function () {
                  r.webauthnAbortController = null;
                });
              });
            });
          }
        },
        Form: {
          autoSave: !0,
          hasSavingState: !1,
          title: f.partial(t.loc, "factor.webauthn.biometric", "login"),
          className: "verify-webauthn-form",
          noCancelButton: !0,
          save: f.partial(t.loc, "verify.u2f.retry", "login"),
          noButtonBar: function noButtonBar() {
            return !o.isNewApiAvailable();
          },
          modelEvents: {
            request: "_startEnrollment",
            error: "_stopEnrollment"
          },
          formChildren: function formChildren() {
            var e = [];
            if (o.isNewApiAvailable()) e.push(r.View({
              View: '<div class="webauthn-verify-text">                 <p>{{i18n code="verify.webauthn.biometric.instructions" bundle="login"}}</p>                 <div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>               </div>'
            }));else {
              var n = "webauthn.biometric.error.factorNotSupported";
              1 === this.options.appState.get("factors").length && (n = "webauthn.biometric.error.factorNotSupported.oneFactor"), e.push(r.View({
                View: new c({
                  message: t.loc(n, "login")
                })
              }, {
                selector: ".o-form-error-container"
              }));
            }
            return this.options.appState.get("allowRememberDevice") && e.push(r.Input({
              label: !1,
              "label-top": !0,
              placeholder: this.options.appState.get("rememberDeviceLabel"),
              className: "margin-btm-0",
              name: "rememberDevice",
              type: "checkbox"
            })), e;
          },
          postRender: function postRender() {
            f.defer(f.bind(function () {
              o.isNewApiAvailable() ? this.model.save() : this.$('[data-se="webauthn-waiting"]').hide();
            }, this));
          },
          _startEnrollment: function _startEnrollment() {
            this.$(".okta-waiting-spinner").show(), this.$(".o-form-button-bar").hide();
          },
          _stopEnrollment: function _stopEnrollment() {
            this.$(".okta-waiting-spinner").hide(), this.$(".o-form-button-bar").show();
          }
        },
        back: function back() {},
        Footer: a
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(4), n(51), n(18), n(52)], void 0 !== (i = function (t, e, n, r, i, o) {
      var a = t._,
        s = t.internal.util.Util;
      return e.extend({
        className: "verify-custom-factor custom-factor-form",
        Model: {
          props: {
            rememberDevice: "boolean"
          },
          initialize: function initialize() {
            var t = i.getRememberDeviceValue(this.appState);
            this.set("rememberDevice", t);
          },
          save: function save() {
            var t = this,
              e = !!this.get("rememberDevice");
            return this.manageTransaction(function (n, r) {
              var i = {
                rememberDevice: e
              };
              return a.findWhere(n.factors, {
                provider: t.get("provider"),
                factorType: t.get("factorType")
              }).verify(i).then(function (e) {
                r(e);
                var n = t.appState.get("verifyCustomFactorRedirectUrl");
                null !== n && s.redirect(n);
              }).fail(function (t) {
                throw t;
              });
            });
          }
        },
        Form: function Form() {
          var e = this.options.appState.get("factors"),
            r = e.findWhere({
              provider: this.options.provider,
              factorType: this.options.factorType
            }),
            i = r.get("vendorName");
          return {
            autoSave: !0,
            title: i,
            save: t.loc("mfa.challenge.verify", "login"),
            subtitle: t.loc("verify.customFactor.subtitle", "login", [i]),
            attributes: {
              "data-se": "factor-custom"
            },
            initialize: function initialize() {
              this.options.appState.get("allowRememberDevice") && this.addInput({
                label: !1,
                "label-top": !0,
                placeholder: this.options.appState.get("rememberDeviceLabel"),
                className: "margin-btm-0",
                name: "rememberDevice",
                type: "checkbox"
              });
            },
            formChildren: function formChildren() {
              var t = [],
                e = this.options.appState.get("lastFailedChallengeFactorData");
              return e && t.push(n.View({
                View: new o({
                  message: e.errorMessage
                })
              }, {
                selector: ".o-form-error-container"
              })), t;
            }
          };
        },
        trapAuthResponse: function trapAuthResponse() {
          if (this.options.appState.get("isMfaChallenge")) return !0;
        },
        back: function back() {},
        initialize: function initialize() {
          this.model.set("provider", this.options.provider), this.model.set("factorType", this.options.factorType), this.settings.get("features.hideSignOutLinkInMFA") || this.addFooter(r);
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r,
      i,
      o = n(583),
      a = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(o);
    r = [n(0), n(2), n(6), n(24), n(253), n(588), n(589)], void 0 !== (i = function (t, e, n, r, i, o, s) {
      var u = t._,
        c = t.$,
        l = t.tpl("<span>{{{subtitle}}}</span>");
      return e.extend({
        className: "enroll-choices",
        state: {
          pageType: null
        },
        Model: {},
        Form: {
          noCancelButton: !0,
          title: u.partial(t.loc, "enroll.choices.title", "login"),
          noButtonBar: function noButtonBar() {
            return this.state.get("pageType") === n.ALL_OPTIONAL_NONE_ENROLLED;
          },
          subtitle: " ",
          getSubtitle: function getSubtitle() {
            switch (this.state.get("pageType")) {
              case n.ALL_OPTIONAL_SOME_ENROLLED:
              case n.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
                return t.loc("enroll.choices.optional", "login");
              case n.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
                var e = this.options.appState.get("gracePeriodRemainingDays");
                return (0, a.default)(e) && e >= 0 ? this.getGracePeriodSubtitle(e) : this.getDefaultSubtitle();
              default:
                return this.getDefaultSubtitle();
            }
          },
          getDefaultSubtitle: function getDefaultSubtitle() {
            return this.settings.get("brandName") ? t.loc("enroll.choices.description.specific", "login", [this.settings.get("brandName")]) : t.loc("enroll.choices.description.generic", "login");
          },
          getGracePeriodSubtitle: function getGracePeriodSubtitle(e) {
            return e >= 1 ? t.loc("enroll.choices.description.gracePeriod.bold", "login", [e]) : t.loc("enroll.choices.description.gracePeriod.oneDay.bold", "login");
          },
          save: function save() {
            switch (this.state.get("pageType")) {
              case n.ALL_OPTIONAL_SOME_ENROLLED:
              case n.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
                return t.loc("enroll.choices.submit.finish", "login");
              case n.HAS_REQUIRED_NONE_ENROLLED:
                return t.loc("enroll.choices.submit.configure", "login");
              case n.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
                return t.loc("enroll.choices.submit.next", "login");
              default:
                return "";
            }
          },
          initialize: function initialize(t) {
            this.listenTo(this, "save", function () {
              var e;
              switch (this.state.get("pageType")) {
                case n.HAS_REQUIRED_NONE_ENROLLED:
                case n.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
                  e = t.appState.get("factors").getFirstUnenrolledRequiredFactor(), t.appState.trigger("navigate", r.createEnrollFactorUrl(e.get("provider"), e.get("factorType")));
                  break;
                default:
                  return this.model.doTransaction(function (t) {
                    return t.skip();
                  });
              }
            });
          },
          preRender: function preRender() {
            this.add(l({
              subtitle: this.getSubtitle()
            }), c("p.okta-form-subtitle"));
            var e = this.options.appState.get("factors");
            switch (this.state.get("pageType")) {
              case n.HAS_REQUIRED_NONE_ENROLLED:
              case n.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
                this.add(new o({
                  minimize: !0,
                  collection: new t.Collection(e.where({
                    required: !0
                  })),
                  appState: this.options.appState
                }));
                break;
              case n.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
              case n.ALL_OPTIONAL_SOME_ENROLLED:
              case n.ALL_OPTIONAL_NONE_ENROLLED:
                var r,
                  a = e.where({
                    enrolled: !0
                  }),
                  s = e.filter(function (t) {
                    return !t.get("enrolled") || t.get("additionalEnrollment");
                  });
                a.length > 0 && (r = t.loc("enroll.choices.list.optional", "login"), this.add(new i({
                  listTitle: t.loc("enroll.choices.list.enrolled", "login"),
                  minimize: !0,
                  collection: new t.Collection(a),
                  appState: this.options.appState
                }))), this.add(new i({
                  listTitle: r,
                  collection: new t.Collection(s),
                  appState: this.options.appState,
                  showInlineSetupButton: !0
                }));
            }
          }
        },
        initialize: function initialize(t) {
          var e,
            r,
            i = 0,
            o = 0,
            a = 0,
            u = 0;
          t.appState.get("factors").each(function (t) {
            var e = t.get("required"),
              n = t.get("enrolled"),
              r = t.get("additionalEnrollment");
            e && n ? i++ : e && !n ? o++ : !e && n ? a++ : e || n || u++, n && r && u++;
          }), e = i > 0 || o > 0, e && 0 === i ? r = n.HAS_REQUIRED_NONE_ENROLLED : e && o > 0 ? r = n.HAS_REQUIRED_SOME_REQUIRED_ENROLLED : e && u > 0 ? r = n.HAS_REQUIRED_ALL_REQUIRED_ENROLLED : 0 === a && u > 0 ? r = n.ALL_OPTIONAL_NONE_ENROLLED : u > 0 ? r = n.ALL_OPTIONAL_SOME_ENROLLED : this.model.doTransaction(function (t) {
            return t.skip();
          }), this.state.set("pageType", r), this.options.appState.get("skipLink") && r === n.HAS_REQUIRED_SOME_REQUIRED_ENROLLED && this.add(new s(this.toJSON()));
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    t.exports = {
      default: n(584),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(585), t.exports = n(9).Number.isInteger;
  }, function (t, e, n) {
    var r = n(21);
    r(r.S, "Number", {
      isInteger: n(586)
    });
  }, function (t, e, n) {
    var r = n(46),
      i = Math.floor;
    t.exports = function (t) {
      return !r(t) && isFinite(t) && i(t) === t;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = {
      INVALID_TOKEN_EXCEPTION: "E0000011"
    };
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(253)], void 0 !== (i = function (t, e) {
      var n = t._;
      return e.extend({
        listTitle: n.partial(t.loc, "enroll.choices.list.setup", "login"),
        className: function className() {
          return e.prototype.className + " enroll-required-factor-list";
        },
        postRender: function postRender() {
          var t, n;
          e.prototype.postRender.apply(this, arguments), t = this.options.appState.get("factors").getFirstUnenrolledRequiredFactor(), n = this.find(function (e) {
            return e.model === t;
          }), n.maximize();
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      return t.View.extend({
        template: '<a href="#" class="link goto js-skip" data-se="skip-link">\n          {{i18n code="enroll.choices.setup.skip" bundle="login"}}\n       </a>',
        className: "auth-footer clearfix",
        events: {
          "click .js-skip": function clickJsSkip(t) {
            t.preventDefault(), this.model.doTransaction(function (t) {
              return t.skip();
            });
          }
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(247), n(17), n(2), n(19)], void 0 !== (i = function (t, e, n, r, i) {
      var o = t.$,
        a = t._;
      return r.extend({
        className: "enroll-duo duo-form",
        Model: {
          props: {
            host: "string",
            signature: "string",
            postAction: "string",
            factorId: "string",
            stateToken: "string"
          },
          getInitOptions: function getInitOptions() {
            return this.doTransaction(function (t) {
              return a.findWhere(t.factors, {
                factorType: "web",
                provider: "DUO"
              }).enroll();
            });
          },
          activate: function activate(t) {
            var e = this.get("postAction"),
              r = this.get("factorId"),
              i = this,
              a = {
                id: r,
                stateToken: this.get("stateToken"),
                sig_response: t
              };
            return n(o.post(e, a)).then(function () {
              return i.doTransaction(function (t) {
                return t.poll();
              });
            }).fail(function (t) {
              i.trigger("error", i, t.xhr);
            });
          }
        },
        Form: {
          autoSave: !0,
          noButtonBar: !0,
          title: a.partial(t.loc, "enroll.duo.title", "login"),
          postRender: function postRender() {
            this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>'), e.init({
              host: this.model.get("host"),
              sig_request: this.model.get("signature"),
              iframe: this.$("iframe").get(0),
              post_action: a.bind(this.model.activate, this.model)
            });
          }
        },
        Footer: i,
        fetchInitialData: function fetchInitialData() {
          var t = this;
          return this.model.getInitOptions(this.options.appState).then(function (e) {
            var n = e.data;
            if (!(n && n._embedded && n._embedded.factor && n._embedded.factor._embedded && n._embedded.factor._embedded.activation)) throw new Error("Response does not have duo activation options");
            var r = n._embedded.factor,
              i = r._embedded.activation;
            t.model.set({
              host: i.host,
              signature: i.signature,
              postAction: i._links.complete.href,
              factorId: r.id,
              stateToken: n.stateToken
            });
          });
        },
        trapAuthResponse: function trapAuthResponse() {
          if (this.options.appState.get("isMfaEnrollActivate")) return !0;
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(18), n(13), n(19), n(14)], void 0 !== (i = function (t, e, n, r, i, o) {
      var a = t._;
      return e.extend({
        className: "enroll-question",
        Model: {
          props: {
            question: "string",
            answer: ["string", !0]
          },
          local: {
            securityQuestions: "object"
          },
          save: function save() {
            return this.doTransaction(function (t) {
              return a.findWhere(t.factors, {
                factorType: "question",
                provider: "OKTA"
              }).enroll({
                profile: {
                  question: this.get("question"),
                  answer: this.get("answer")
                }
              });
            });
          }
        },
        Form: {
          autoSave: !0,
          title: a.partial(t.loc, "enroll.securityQuestion.setup", "login"),
          inputs: function inputs() {
            return [{
              label: !1,
              "label-top": !0,
              name: "question",
              type: "select",
              wide: !0,
              options: function options() {
                return this.model.get("securityQuestions");
              },
              params: {
                searchThreshold: 25
              }
            }, {
              label: t.loc("mfa.challenge.answer.placeholder", "login"),
              "label-top": !0,
              explain: r.createInputExplain("mfa.challenge.answer.tooltip", "mfa.challenge.answer.placeholder", "login"),
              "explain-top": !0,
              className: "o-form-fieldset o-form-label-top auth-passcode",
              name: "answer",
              input: o,
              type: "text"
            }];
          }
        },
        Footer: i,
        fetchInitialData: function fetchInitialData() {
          var t = this;
          return this.model.manageTransaction(function (t) {
            return a.findWhere(t.factors, {
              factorType: "question",
              provider: "OKTA"
            }).questions();
          }).then(function (e) {
            var r = {};
            a.each(e, function (t) {
              r[t.question] = n.getSecurityQuestionLabel(t);
            }), t.model.set("securityQuestions", r);
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(98), n(19), n(14)], void 0 !== (i = function (t, e, n, r, i) {
      var o = t._;
      return e.extend({
        className: "enroll-password",
        Model: {
          props: {
            password: ["string", !0],
            confirmPassword: ["string", !0]
          },
          validate: function validate() {
            return n.validateFieldsMatch(this, "password", "confirmPassword", t.loc("password.enroll.error.match", "login"));
          },
          save: function save() {
            return this.doTransaction(function (t) {
              return o.findWhere(t.factors, {
                factorType: "password",
                provider: "OKTA"
              }).enroll({
                profile: {
                  password: this.get("password")
                }
              });
            });
          }
        },
        Form: {
          autoSave: !0,
          title: o.partial(t.loc, "enroll.password.setup", "login"),
          inputs: function inputs() {
            return [{
              label: t.loc("mfa.challenge.password.placeholder", "login"),
              "label-top": !0,
              className: "o-form-fieldset o-form-label-top auth-passcode",
              name: "password",
              input: i,
              type: "password"
            }, {
              label: t.loc("password.confirmPassword.placeholder", "login"),
              "label-top": !0,
              className: "o-form-fieldset o-form-label-top auth-passcode",
              name: "confirmPassword",
              input: i,
              type: "password"
            }];
          }
        },
        Footer: r
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(4), n(97), n(251), n(19), n(52)], void 0 !== (i = function (t, e, n, r, i, o, a) {
      var s = t._;
      return e.extend({
        className: "enroll-windows-hello",
        Model: {
          local: {
            __isEnrolled__: "boolean"
          },
          save: function save() {
            if (r.isAvailable()) return this.trigger("request"), this.get("__isEnrolled__") ? this.activate() : this.doTransaction(function (t) {
              return this._enroll(t);
            });
          },
          _enroll: function _enroll(t) {
            return s.findWhere(t.factors, {
              factorType: "webauthn",
              provider: "FIDO"
            }).enroll();
          },
          activate: function activate() {
            return this.set("__isEnrolled__", !0), this.doTransaction(function (t) {
              var e = t.factor.activation,
                n = t.user,
                i = this,
                o = {
                  rpDisplayName: e.rpDisplayName,
                  userDisplayName: n.profile.displayName,
                  accountName: n.profile.login,
                  userId: n.id
                },
                a = [{
                  algorithm: e.algorithm
                }],
                s = e.nonce;
              return r.makeCredential(o, a, s).then(function (e) {
                return t.activate({
                  credentialId: e.credential.id,
                  publicKey: e.publicKey,
                  attestation: null
                });
              }).fail(function (e) {
                switch (e.message) {
                  case "AbortError":
                  case "NotFoundError":
                  case "NotSupportedError":
                    return i.trigger("abort", e.message), t;
                }
                throw e;
              });
            });
          }
        },
        Form: {
          autoSave: !0,
          hasSavingState: !1,
          title: s.partial(t.loc, "enroll.windowsHello.title", "login"),
          subtitle: function subtitle() {
            return r.isAvailable() ? t.loc("enroll.windowsHello.subtitle", "login") : "";
          },
          save: s.partial(t.loc, "enroll.windowsHello.save", "login"),
          customSavingState: {
            stop: "abort"
          },
          modelEvents: function modelEvents() {
            return r.isAvailable() ? {
              request: "_startEnrollment",
              error: "_stopEnrollment",
              abort: "_stopEnrollment"
            } : {};
          },
          noButtonBar: function noButtonBar() {
            return !r.isAvailable();
          },
          formChildren: function formChildren() {
            var e = [];
            return r.isAvailable() || e.push(n.View({
              View: new a({
                message: t.loc("enroll.windowsHello.error.notWindows", "login")
              })
            }, {
              selector: ".o-form-error-container"
            })), e.push(n.View({
              View: new i({
                model: this.model,
                visible: !1
              })
            })), e;
          },
          _startEnrollment: function _startEnrollment() {
            this.subtitle = t.loc("enroll.windowsHello.subtitle.loading", "login"), this.model.trigger("spinner:show"), this._resetErrorMessage(), this.render(), this.$(".o-form-button-bar").addClass("hide");
          },
          _stopEnrollment: function _stopEnrollment(e) {
            this.subtitle = t.loc("enroll.windowsHello.subtitle", "login"), this.model.trigger("spinner:hide");
            var n;
            switch (e) {
              case "NotSupportedError":
                n = t.loc("enroll.windowsHello.error.notConfiguredHtml", "login");
            }
            if (this._resetErrorMessage(), n) {
              var r = new a({
                message: n
              });
              this.$(".o-form-error-container").addClass("o-form-has-errors"), this.add(r, {
                selector: ".o-form-error-container"
              }), this._errorMessageView = this.last();
            }
            this.render(), this.$(".o-form-button-bar").removeClass("hide");
          },
          _resetErrorMessage: function _resetErrorMessage() {
            this._errorMessageView && this._errorMessageView.remove(), this._errorMessageView = void 0, this.clearErrors();
          }
        },
        Footer: o,
        trapAuthResponse: function trapAuthResponse() {
          if (this.options.appState.get("isMfaEnrollActivate")) return this.model.activate(), !0;
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(19), n(254), n(14), n(181), n(4), n(13), n(6)], void 0 !== (i = function (t, e, n, r, i, o, a, s, u) {
      function c(t) {
        return "call" === t;
      }
      function l(t) {
        return c(t) ? "enroll-call" : "enroll-sms";
      }
      function f(t) {
        d.isEnter(t) && (t.stopPropagation(), t.preventDefault(), "keyup" === t.type && t.data && t.data.model && t.data.model.sendCode());
      }
      var p = t._,
        d = t.internal.util.Keys,
        h = {
          factorId: function factorId(t) {
            return !p.isUndefined(t);
          }
        };
      return e.extend({
        className: function className() {
          return l(this.options.factorType);
        },
        Model: {
          props: {
            countryCode: ["string", !0, "US"],
            phoneNumber: ["string", !0],
            phoneExtension: ["string", !1],
            lastEnrolledPhoneNumber: "string",
            passCode: ["string", !0],
            factorId: "string"
          },
          local: {
            hasExistingPhones: "boolean",
            trapEnrollment: "boolean",
            ableToResend: "boolean",
            factorType: "string",
            skipPhoneValidation: "boolean"
          },
          derived: {
            countryCallingCode: {
              deps: ["countryCode"],
              fn: function fn(t) {
                return "+" + o.getCallingCodeForCountry(t);
              }
            },
            fullPhoneNumber: {
              deps: ["countryCallingCode", "phoneNumber"],
              fn: function fn(t, e) {
                return e ? t + e : "";
              }
            },
            enrolled: {
              deps: ["lastEnrolledPhoneNumber", "fullPhoneNumber"],
              fn: function fn(t, e) {
                return t === e;
              }
            }
          },
          limitResending: function limitResending() {
            this.set({
              ableToResend: !1
            }), p.delay(p.bind(this.set, this), u.API_RATE_LIMIT, {
              ableToResend: !0
            });
          },
          sendCode: function sendCode() {
            var e = this,
              n = this.get("fullPhoneNumber"),
              r = this.get("phoneExtension");
            return e.trigger("errors:clear"), n.length ? this.doTransaction(function (i) {
              var o = "MFA_ENROLL" === i.status || "FACTOR_ENROLL" === i.status,
                a = {
                  phoneNumber: n,
                  updatePhone: !o || e.get("hasExistingPhones")
                };
              c(e.get("factorType")) && (a.phoneExtension = r), e.get("skipPhoneValidation") && (a.validatePhone = !1);
              var s = function s(n) {
                return p.findWhere(n.factors, {
                  factorType: e.get("factorType"),
                  provider: "OKTA"
                }).enroll({
                  profile: a
                }).fail(function (n) {
                  throw "E0000098" === n.errorCode && (e.set("skipPhoneValidation", !0), n.xhr.responseJSON.errorSummary = t.loc("enroll.sms.try_again", "login")), n;
                });
              };
              return o ? s(i) : (e.set("trapEnrollment", !0), i.prev().then(s).then(function (t) {
                return e.set("trapEnrollment", !1), t;
              }));
            }, !0).then(function () {
              e.set("lastEnrolledPhoneNumber", n), e.limitResending();
            }).fail(function () {
              e.set("ableToResend", !0), e.set("trapEnrollment", !1);
            }) : void e.trigger("invalid", e, {
              phoneNumber: "model.validation.field.blank"
            });
          },
          resendCode: function resendCode() {
            return this.trigger("errors:clear"), this.limitResending(), this.doTransaction(function (t) {
              return t.resend(this.get("factorType"));
            });
          },
          save: function save() {
            return this.doTransaction(function (t) {
              return t.activate({
                passCode: this.get("passCode")
              });
            });
          }
        },
        Form: function Form() {
          var e = this.options.factorType,
            n = c(e),
            u = t.loc(n ? "enroll.call.setup" : "enroll.sms.setup", "login"),
            p = t.loc(n ? "mfa.call" : "mfa.sendCode", "login"),
            d = t.loc(n ? "mfa.redial" : "mfa.resendCode", "login"),
            m = t.loc(n ? "mfa.calling" : "mfa.sent", "login"),
            g = n ? "enroll-call-phone" : "enroll-sms-phone",
            v = n ? "call-request-button" : "sms-request-button",
            y = [a.Input({
              name: "countryCode",
              type: "select",
              wide: !0,
              options: o.getCountries()
            }), a.Input({
              label: t.loc("mfa.phoneNumber.placeholder", "login"),
              "label-top": !0,
              className: g,
              name: "phoneNumber",
              input: r,
              type: "text",
              render: function render() {
                this.$('input[name="phoneNumber"]').off("keydown keyup", f).keydown(f).keyup({
                  model: this.model
                }, f);
              }
            })];
          return n && y.push(a.Input({
            label: t.loc("mfa.phoneNumber.ext.placeholder", "login"),
            "label-top": !0,
            className: "enroll-call-extension",
            name: "phoneExtension",
            input: i,
            type: "text"
          })), y.push(a.Button({
            title: p,
            attributes: {
              "data-se": v
            },
            className: "button button-primary js-enroll-phone margin-top-30 " + v,
            click: function click() {
              this.model.sendCode();
            }
          }), a.Button({
            title: d,
            attributes: {
              "data-se": v
            },
            className: "button js-enroll-phone margin-top-30 " + v,
            click: function click() {
              this.model.resendCode();
            },
            initialize: function initialize() {
              this.$el.css({
                display: "none"
              }), this.listenTo(this.model, "change:ableToResend", function (t, e) {
                e ? (this.options.title = d, this.enable()) : (this.options.title = m, this.disable()), this.render();
              });
            }
          }), a.Divider({
            showWhen: h
          }), a.Input({
            label: t.loc("mfa.challenge.enterCode.placeholder", "login"),
            "label-top": !0,
            explain: s.createInputExplain("mfa.challenge.enterCode.tooltip", "mfa.challenge.enterCode.placeholder", "login"),
            "explain-top": !0,
            name: "passCode",
            input: i,
            type: "tel",
            showWhen: h
          }), a.Toolbar({
            noCancelButton: !0,
            save: t.loc("mfa.challenge.verify", "login"),
            showWhen: h
          })), {
            title: u,
            noButtonBar: !0,
            autoSave: !0,
            className: l(e),
            showWarning: function showWarning(t) {
              this.clearWarnings(), this.add('<div class="okta-form-infobox-warning infobox infobox-warning login-timeout-warning">                           <span class="icon warning-16"></span>                           <p>{{{warning}}}</p>                         </div>                         ', ".o-form-error-container", {
                options: {
                  warning: t
                }
              });
            },
            clearWarnings: function clearWarnings() {
              this.$(".okta-form-infobox-warning").remove();
            },
            initialize: function initialize() {
              this.listenTo(this.model, "change:ableToResend", function (e, r) {
                r ? this.showWarning(t.loc(n ? "factor.call.time.warning" : "factor.sms.time.warning", "login")) : this.clearWarnings();
              }), this.listenTo(this.model, "error errors:clear", function () {
                this.clearWarnings(), this.clearErrors();
              }), this.listenTo(this.model, "change:enrolled", function () {
                this.$(".js-enroll-phone").toggle();
              });
            },
            formChildren: y
          };
        },
        Footer: n,
        trapAuthResponse: function trapAuthResponse() {
          return this.options.appState.get("isMfaEnrollActivate") ? (this.model.set("factorId", this.options.appState.get("activatedFactorId")), !0) : !(!this.options.appState.get("isMfaEnroll") || !this.model.get("trapEnrollment")) || void 0;
        },
        initialize: function initialize() {
          c(this.options.factorType) ? this.model.set("hasExistingPhones", this.options.appState.get("hasExistingPhonesForCall")) : this.model.set("hasExistingPhones", this.options.appState.get("hasExistingPhones")), this.model.set("factorType", this.options.factorType);
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    t.exports = {
      US: "1",
      AG: "1",
      AI: "1",
      AS: "1",
      BB: "1",
      BM: "1",
      BS: "1",
      CA: "1",
      DM: "1",
      DO: "1",
      GD: "1",
      GU: "1",
      JM: "1",
      KN: "1",
      KY: "1",
      LC: "1",
      MP: "1",
      MS: "1",
      PR: "1",
      SX: "1",
      TC: "1",
      TT: "1",
      VC: "1",
      VG: "1",
      VI: "1",
      RU: "7",
      KZ: "7",
      EG: "20",
      ZA: "27",
      GR: "30",
      NL: "31",
      BE: "32",
      FR: "33",
      ES: "34",
      HU: "36",
      IT: "39",
      VA: "39",
      RO: "40",
      CH: "41",
      AT: "43",
      GB: "44",
      GG: "44",
      IM: "44",
      JE: "44",
      DK: "45",
      SE: "46",
      NO: "47",
      SJ: "47",
      PL: "48",
      DE: "49",
      PE: "51",
      MX: "52",
      CU: "53",
      AR: "54",
      BR: "55",
      CL: "56",
      CO: "57",
      VE: "58",
      MY: "60",
      AU: "61",
      CC: "61",
      CX: "61",
      ID: "62",
      PH: "63",
      NZ: "64",
      SG: "65",
      TH: "66",
      JP: "81",
      KR: "82",
      VN: "84",
      CN: "86",
      TR: "90",
      IN: "91",
      PK: "92",
      AF: "93",
      LK: "94",
      MM: "95",
      IR: "98",
      SS: "211",
      MA: "212",
      EH: "212",
      DZ: "213",
      TN: "216",
      LY: "218",
      GM: "220",
      SN: "221",
      MR: "222",
      ML: "223",
      GN: "224",
      CI: "225",
      BF: "226",
      NE: "227",
      TG: "228",
      BJ: "229",
      MU: "230",
      LR: "231",
      SL: "232",
      GH: "233",
      NG: "234",
      TD: "235",
      CF: "236",
      CM: "237",
      CV: "238",
      ST: "239",
      GQ: "240",
      GA: "241",
      CG: "242",
      CD: "243",
      AO: "244",
      GW: "245",
      IO: "246",
      AC: "247",
      SC: "248",
      SD: "249",
      RW: "250",
      ET: "251",
      SO: "252",
      DJ: "253",
      KE: "254",
      TZ: "255",
      UG: "256",
      BI: "257",
      MZ: "258",
      ZM: "260",
      MG: "261",
      RE: "262",
      YT: "262",
      ZW: "263",
      NA: "264",
      MW: "265",
      LS: "266",
      BW: "267",
      SZ: "268",
      KM: "269",
      SH: "290",
      TA: "290",
      ER: "291",
      AW: "297",
      FO: "298",
      GL: "299",
      GI: "350",
      PT: "351",
      LU: "352",
      IE: "353",
      IS: "354",
      AL: "355",
      MT: "356",
      CY: "357",
      FI: "358",
      AX: "358",
      BG: "359",
      LT: "370",
      LV: "371",
      EE: "372",
      MD: "373",
      AM: "374",
      BY: "375",
      AD: "376",
      MC: "377",
      SM: "378",
      UA: "380",
      RS: "381",
      ME: "382",
      XK: "383",
      HR: "385",
      SI: "386",
      BA: "387",
      MK: "389",
      CZ: "420",
      SK: "421",
      LI: "423",
      FK: "500",
      BZ: "501",
      GT: "502",
      SV: "503",
      HN: "504",
      NI: "505",
      CR: "506",
      PA: "507",
      PM: "508",
      HT: "509",
      GP: "590",
      BL: "590",
      MF: "590",
      BO: "591",
      GY: "592",
      EC: "593",
      GF: "594",
      PY: "595",
      MQ: "596",
      SR: "597",
      UY: "598",
      CW: "599",
      BQ: "599",
      TL: "670",
      NF: "672",
      BN: "673",
      NR: "674",
      PG: "675",
      TO: "676",
      SB: "677",
      VU: "678",
      FJ: "679",
      PW: "680",
      WF: "681",
      CK: "682",
      NU: "683",
      WS: "685",
      KI: "686",
      NC: "687",
      TV: "688",
      PF: "689",
      TK: "690",
      FM: "691",
      MH: "692",
      "001": "979",
      KP: "850",
      HK: "852",
      MO: "853",
      KH: "855",
      LA: "856",
      BD: "880",
      TW: "886",
      MV: "960",
      LB: "961",
      JO: "962",
      SY: "963",
      IQ: "964",
      KW: "965",
      SA: "966",
      YE: "967",
      OM: "968",
      PS: "970",
      AE: "971",
      IL: "972",
      BH: "973",
      QA: "974",
      BT: "975",
      MN: "976",
      NP: "977",
      TJ: "992",
      TM: "993",
      AZ: "994",
      GE: "995",
      KG: "996",
      UZ: "998",
      GS: "500",
      PN: "64",
      AQ: "672",
      UM: "1",
      AN: "599"
    };
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(19), n(4)], void 0 !== (i = function (t, e, n, r) {
      var i = t._,
        o = {
          local: {
            factorType: "string",
            provider: "string"
          },
          save: function save() {
            this.trigger("save");
            var t = this.pick("factorType", "provider");
            return this.doTransaction(function (e) {
              return i.findWhere(e.factors, t).enroll();
            });
          }
        },
        a = function a() {
          return {
            title: i.partial(t.loc, "email.enroll.title", "login"),
            noButtonBar: !1,
            autoSave: !0,
            save: i.partial(t.loc, "email.button.send", "login"),
            formChildren: [r.View({
              View: t.View.extend({
                attributes: {
                  "data-se": "enroll-email-content"
                },
                template: '{{i18n code="email.enroll.description" bundle="login"}}'
              })
            })]
          };
        };
      return e.extend({
        className: "enroll-email",
        Model: o,
        Form: a,
        Footer: n,
        initialize: function initialize() {
          this.model.set(i.pick(this.options, "factorType", "provider"));
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(19), n(250), n(4)], void 0 !== (i = function (t, e, n, r, i) {
      var o = t._,
        a = {
          props: {
            passCode: "string"
          },
          resend: function resend() {
            return this.trigger("form:clear-errors"), this.doTransaction(function (t) {
              return t.resend("email");
            });
          },
          save: function save() {
            this.trigger("save");
            var t = this.toJSON();
            return this.doTransaction(function (e) {
              return e.activate(t);
            });
          }
        },
        s = function s() {
          return {
            title: o.partial(t.loc, "email.enroll.title", "login"),
            noButtonBar: !1,
            autoSave: !0,
            save: o.partial(t.loc, "oform.verify", "login"),
            formChildren: [i.View({
              View: t.View.extend({
                className: "enroll-activate-email-content",
                attributes: {
                  "data-se": "enroll-activate-email-content"
                },
                template: '{{{i18n code="email.mfa.email.sent.description" bundle="login" arguments="factorEmail"}}}',
                getTemplateData: function getTemplateData() {
                  var e = this.options.appState.get("factor"),
                    n = e && e.profile ? e.profile.email : "";
                  return {
                    factorEmail: t.tpl('<span class="mask-email">{{email}}</span>')({
                      email: n
                    })
                  };
                }
              })
            }), i.View({
              View: r
            }), i.Input({
              label: t.loc("email.code.label", "login"),
              "label-top": !0,
              name: "passCode",
              type: "text",
              wide: !0
            })]
          };
        };
      return e.extend({
        className: "enroll-activate-email",
        Model: a,
        Form: s,
        Footer: n
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(4), n(2), n(13), n(19), n(14)], void 0 !== (i = function (t, e, n, r, i, o) {
      function a(t) {
        return "RSA" === t;
      }
      function s(t) {
        return a(t) ? "enroll-rsa" : "enroll-onprem";
      }
      var u = t._;
      return n.extend({
        className: function className() {
          return s(this.options.provider);
        },
        Model: function Model() {
          var t = this.options.provider,
            e = this.options.appState.get("factors"),
            n = e.findWhere(u.pick(this.options, "provider", "factorType")),
            r = n.get("profile");
          return {
            props: {
              credentialId: ["string", !0, r && r.credentialId ? r.credentialId : ""],
              passCode: ["string", !0],
              factorId: "string"
            },
            save: function save() {
              return this.doTransaction(function (e) {
                return u.findWhere(e.factors, {
                  factorType: "token",
                  provider: t
                }).enroll({
                  passCode: this.get("passCode"),
                  profile: {
                    credentialId: this.get("credentialId")
                  }
                });
              });
            }
          };
        },
        Form: function Form() {
          var n = this.options.provider,
            i = this.options.appState.get("factors"),
            c = i.findWhere(u.pick(this.options, "provider", "factorType")),
            l = c.get("vendorName");
          return {
            title: a(n) ? t.loc("factor.totpHard.rsaSecurId", "login") : l,
            noButtonBar: !0,
            autoSave: !0,
            className: s(n),
            initialize: function initialize() {
              this.listenTo(this.model, "error", u.bind(function (t, e) {
                e && 409 === e.status && (this.$(".o-form-input-name-passCode input").val(""), this.$(".o-form-input-name-passCode input").trigger("change"), this.$(".o-form-input-name-passCode input").focus());
              }, this));
            },
            formChildren: [e.Input({
              label: t.loc("enroll.onprem.username.placeholder", "login", [l]),
              "label-top": !0,
              explain: r.createInputExplain("enroll.onprem.username.tooltip", "enroll.onprem.username.placeholder", "login", [l], [l]),
              "explain-top": !0,
              name: "credentialId",
              input: o,
              type: "text"
            }), e.Input({
              label: t.loc("enroll.onprem.passcode.placeholder", "login", [l]),
              "label-top": !0,
              explain: r.createInputExplain("enroll.onprem.passcode.tooltip", "enroll.onprem.passcode.placeholder", "login", [l], [l]),
              "explain-top": !0,
              name: "passCode",
              input: o,
              type: "password"
            }), e.Toolbar({
              noCancelButton: !0,
              save: t.loc("mfa.challenge.verify", "login")
            })]
          };
        },
        Footer: i
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(4), n(2), n(13), n(19), n(14)], void 0 !== (i = function (t, e, n, r, i, o) {
      var a = t._;
      return n.extend({
        className: "enroll-symantec",
        Model: {
          props: {
            credentialId: ["string", !0],
            passCode: ["string", !0],
            nextPassCode: ["string", !0],
            factorId: "string"
          },
          save: function save() {
            return this.doTransaction(function (t) {
              return a.findWhere(t.factors, {
                factorType: "token",
                provider: "SYMANTEC"
              }).enroll({
                passCode: this.get("passCode"),
                nextPassCode: this.get("nextPassCode"),
                profile: {
                  credentialId: this.get("credentialId")
                }
              });
            });
          }
        },
        Form: {
          title: a.partial(t.loc, "factor.totpHard.symantecVip", "login"),
          subtitle: a.partial(t.loc, "enroll.symantecVip.subtitle", "login"),
          noButtonBar: !0,
          autoSave: !0,
          className: "enroll-symantec",
          formChildren: function formChildren() {
            return [e.Input({
              label: t.loc("enroll.symantecVip.credentialId.placeholder", "login"),
              "label-top": !0,
              explain: r.createInputExplain("enroll.symantecVip.credentialId.tooltip", "enroll.symantecVip.credentialId.placeholder", "login"),
              "explain-top": !0,
              name: "credentialId",
              input: o,
              type: "text"
            }), e.Input({
              label: t.loc("enroll.symantecVip.passcode1.placeholder", "login"),
              "label-top": !0,
              explain: r.createInputExplain("enroll.symantecVip.passcode1.tooltip", "enroll.symantecVip.passcode1.placeholder", "login"),
              "explain-top": !0,
              name: "passCode",
              input: o,
              type: "text"
            }), e.Input({
              label: t.loc("enroll.symantecVip.passcode2.placeholder", "login"),
              "label-top": !0,
              explain: r.createInputExplain("enroll.symantecVip.passcode2.tooltip", "enroll.symantecVip.passcode2.placeholder", "login"),
              "explain-top": !0,
              name: "nextPassCode",
              input: o,
              type: "text"
            }), e.Toolbar({
              noCancelButton: !0,
              save: t.loc("mfa.challenge.verify", "login")
            })];
          }
        },
        Footer: i
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(4), n(2), n(19), n(14)], void 0 !== (i = function (t, e, n, r, i) {
      var o = t._;
      return n.extend({
        className: "enroll-yubikey",
        Model: {
          props: {
            passCode: ["string", !0],
            factorId: "string"
          },
          save: function save() {
            return this.doTransaction(function (t) {
              return o.findWhere(t.factors, {
                factorType: "token:hardware",
                provider: "YUBICO"
              }).enroll({
                passCode: this.get("passCode")
              });
            });
          }
        },
        Form: {
          title: o.partial(t.loc, "enroll.yubikey.title", "login"),
          subtitle: o.partial(t.loc, "enroll.yubikey.subtitle", "login"),
          noCancelButton: !0,
          save: o.partial(t.loc, "mfa.challenge.verify", "login"),
          autoSave: !0,
          className: "enroll-yubikey",
          formChildren: [e.View({
            View: '<div class="yubikey-demo" data-type="yubikey-example"></div>'
          }), e.Input({
            name: "passCode",
            input: i,
            type: "password"
          })]
        },
        Footer: r
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(18), n(2), n(4), n(24), n(602), n(182), n(19)], void 0 !== (i = function (t, e, n, r, i, o, a, s) {
      var u = t._,
        c = {
          __deviceType__: function __deviceType__(t) {
            return void 0 !== t;
          }
        },
        l = t.View.extend({
          attributes: {
            "data-se": "app-download-instructions"
          },
          className: "app-download-instructions",
          template: '      <span class="app-logo {{appIcon}}"></span>      <p class="instructions">{{{appStoreLinkText}}}</p>    ',
          initialize: function initialize() {
            this.listenTo(this.model, "change:__deviceType__", this.render);
          },
          getTemplateData: function getTemplateData() {
            var n,
              r,
              i,
              a = e.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
            return i = o.STORE[this.model.get("__deviceType__")], "GOOGLE" === this.model.get("__provider__") ? (n = o.GOOGLE[this.model.get("__deviceType__")], r = "google-auth-38") : (n = o.OKTA[this.model.get("__deviceType__")], r = "okta-verify-38"), {
              appStoreLinkText: t.loc("enroll.totp.downloadApp", "login", [n, a, i]),
              appIcon: r
            };
          }
        });
      return n.extend({
        className: "enroll-totp",
        Model: function Model() {
          return {
            local: {
              __deviceType__: "string",
              __factorType__: ["string", !1, this.options.factorType],
              __provider__: ["string", !1, this.options.provider]
            },
            save: function save() {
              return this.doTransaction(function (t) {
                return u.findWhere(t.factors, {
                  factorType: this.get("__factorType__"),
                  provider: this.get("__provider__")
                }).enroll();
              });
            }
          };
        },
        Form: {
          title: function title() {
            var n = e.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
            return t.loc("enroll.totp.title", "login", [n]);
          },
          subtitle: u.partial(t.loc, "enroll.totp.selectDevice", "login"),
          autoSave: !0,
          noButtonBar: !0,
          attributes: {
            "data-se": "step-device-type"
          },
          formChildren: function formChildren() {
            var e = {
              APPLE: t.loc("iphone", "login"),
              ANDROID: t.loc("android", "login")
            };
            return [r.Input({
              name: "__deviceType__",
              type: "radio",
              options: e
            }), r.Divider({
              showWhen: c
            }), r.View({
              View: l,
              showWhen: c
            }), r.Toolbar({
              noCancelButton: !0,
              save: t.loc("oform.next", "login"),
              showWhen: c
            })];
          }
        },
        Footer: s
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    t.exports = {
      OKTA: {
        APPLE: "https://itunes.apple.com/us/app/okta-verify/id490179405",
        ANDROID: "https://play.google.com/store/apps/details?id=com.okta.android.auth"
      },
      GOOGLE: {
        APPLE: "https://itunes.apple.com/us/app/google-authenticator/id388497605",
        ANDROID: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
      },
      STORE: {
        APPLE: "App Store",
        ANDROID: "Google Play Store"
      }
    };
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(33), n(4), n(2), n(179), n(19), n(17), n(52), n(252)], void 0 !== (i = function (t, e, n, r, i, o, a, s) {
      var u = t._;
      return r.extend({
        className: "enroll-u2f",
        Model: {
          local: {
            __enrolled__: "boolean"
          },
          save: function save() {
            return this.trigger("request"), this.get("__enrolled__") ? this.activate() : this.doTransaction(function (t) {
              return u.findWhere(t.factors, {
                factorType: "u2f",
                provider: "FIDO"
              }).enroll();
            });
          },
          activate: function activate() {
            return this.set("__enrolled__", !0), this.trigger("errors:clear"), this.doTransaction(function (t) {
              var n = t.factor.activation,
                r = n.appId,
                o = [{
                  version: i.getU2fVersion(),
                  challenge: n.nonce
                }],
                s = this,
                u = a.defer();
              return u2f.register(r, o, [], function (n) {
                s.trigger("errors:clear"), n.errorCode && 0 !== n.errorCode ? u.reject(new e.U2FError({
                  xhr: {
                    responseJSON: {
                      errorSummary: i.getU2fEnrollErrorMessageByCode(n.errorCode)
                    }
                  }
                })) : u.resolve(t.activate({
                  registrationData: n.registrationData,
                  version: n.version,
                  challenge: n.challenge,
                  clientData: n.clientData
                }));
              }), u.promise;
            });
          }
        },
        Form: {
          title: u.partial(t.loc, "enroll.u2f.title", "login"),
          save: u.partial(t.loc, "enroll.u2f.save", "login"),
          noCancelButton: !0,
          hasSavingState: !1,
          autoSave: !0,
          className: "enroll-u2f-form",
          noButtonBar: function noButtonBar() {
            return !i.isU2fAvailable();
          },
          modelEvents: {
            request: "_startEnrollment",
            error: "_stopEnrollment"
          },
          formChildren: function formChildren() {
            var e = [];
            if (i.isU2fAvailable()) e.push(n.View({
              View: '<div class="u2f-instructions"><ol>          <li>{{{i18n code="enroll.u2f.general2" bundle="login"}}}</li>          <li>{{i18n code="enroll.u2f.general3" bundle="login"}}</li>          </ol></div>'
            })), e.push(n.View({
              View: '          <div class="u2f-enroll-text hide">            <p>{{i18n code="enroll.u2f.instructions" bundle="login"}}</p>            <p>{{i18n code="enroll.u2f.instructionsBluetooth" bundle="login"}}</p>            <div data-se="u2f-devices" class="u2f-devices-images">              <div class="u2f-usb"></div>              <div class="u2f-bluetooth"></div>            </div>            <div data-se="u2f-waiting" class="okta-waiting-spinner"></div>          </div>'
            }));else {
              var r = "u2f.error.factorNotSupported";
              1 === this.options.appState.get("factors").length && (r = "u2f.error.factorNotSupported.oneFactor"), e.push(n.View({
                View: new s({
                  message: t.loc(r, "login")
                })
              }, {
                selector: ".o-form-error-container"
              }));
            }
            return e;
          },
          _startEnrollment: function _startEnrollment() {
            this.$(".u2f-instructions").addClass("hide"), this.$(".u2f-enroll-text").removeClass("hide"), this.$(".o-form-button-bar").hide();
          },
          _stopEnrollment: function _stopEnrollment() {
            this.$(".u2f-instructions").removeClass("hide"), this.$(".u2f-enroll-text").addClass("hide"), this.$(".o-form-button-bar").show();
          }
        },
        Footer: o,
        trapAuthResponse: function trapAuthResponse() {
          if (this.options.appState.get("isMfaEnrollActivate")) return this.model.activate(), !0;
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(33), n(4), n(2), n(180), n(97), n(19), n(17), n(52), n(58)], void 0 !== (i = function (t, e, n, r, i, o, a, s, u, c) {
      function l(t) {
        var e = [];
        return f.each(t, function (t) {
          e.push({
            type: "public-key",
            id: i.strToBin(t.id)
          });
        }), e;
      }
      var f = t._;
      return r.extend({
        className: "enroll-webauthn",
        Model: {
          local: {
            __enrolled__: "boolean"
          },
          save: function save() {
            return this.trigger("request"), this.get("__enrolled__") ? this.activate() : this.doTransaction(function (t) {
              return f.findWhere(t.factors, {
                factorType: "webauthn",
                provider: "FIDO"
              }).enroll();
            });
          },
          activate: function activate() {
            var t = this;
            return this.set("__enrolled__", !0), this.trigger("errors:clear"), this.appState.on("backToFactors", function () {
              t.webauthnAbortController && (t.webauthnAbortController.abort(), t.webauthnAbortController = null);
            }), this.doTransaction(function (t) {
              var n = t.factor.activation,
                r = this;
              if (o.isNewApiAvailable()) {
                var a = f.extend({}, n, {
                  challenge: i.strToBin(n.challenge),
                  user: {
                    id: i.strToBin(n.user.id),
                    name: n.user.name,
                    displayName: n.user.displayName
                  },
                  excludeCredentials: l(n.excludeCredentials)
                });
                return r.webauthnAbortController = new AbortController(), new s(navigator.credentials.create({
                  publicKey: a,
                  signal: r.webauthnAbortController.signal
                })).then(function (e) {
                  return t.activate({
                    attestation: i.binToStr(e.response.attestationObject),
                    clientData: i.binToStr(e.response.clientDataJSON)
                  });
                }).fail(function (t) {
                  throw r.trigger("errors:clear"), r.webauthnAbortController ? new e.WebAuthnError({
                    xhr: {
                      responseJSON: {
                        errorSummary: t.message
                      }
                    }
                  }) : new e.WebauthnAbortError();
                }).finally(function () {
                  r.webauthnAbortController = null;
                });
              }
            });
          }
        },
        Form: {
          title: f.partial(t.loc, "enroll.webauthn.biometric.title", "login"),
          save: f.partial(t.loc, "enroll.webauthn.save", "login"),
          noCancelButton: !0,
          hasSavingState: !1,
          autoSave: !0,
          className: "enroll-webauthn-form",
          noButtonBar: function noButtonBar() {
            return !o.isNewApiAvailable();
          },
          modelEvents: {
            request: "_startEnrollment",
            error: "_stopEnrollment"
          },
          formChildren: function formChildren() {
            var e = [];
            if (o.isNewApiAvailable()) e.push(n.View({
              View: t.View.extend({
                className: "webauthn-enroll-text",
                template: '                <div class="webauthn-enroll-instructions">                  <p>{{i18n code="enroll.webauthn.biometric.instructions" bundle="login"}}</p>                </div>                {{#if isEdge}}                  <div class="webauthn-edge-text">                     <p>{{{i18n code="enroll.webauthn.biometric.instructions.edge" bundle="login"}}}</p>                  </div>                {{/if}}                {{#if onlySupportsSecurityKey}}                  <div class="webauthn-restrictions-text">                     <p>{{{i18n code="enroll.webauthn.instructions.noSupportForBiometric" bundle="login"}}}</p>                  </div>                {{/if}}                <div data-se="webauthn-waiting" class="okta-waiting-spinner hide"></div>              ',
                getTemplateData: function getTemplateData() {
                  return {
                    isEdge: c.isEdge(),
                    onlySupportsSecurityKey: (c.isFirefox() || c.isSafari()) && c.isMac()
                  };
                }
              })
            }));else {
              var r = "webauthn.biometric.error.factorNotSupported";
              1 === this.options.appState.get("factors").length && (r = "webauthn.biometric.error.factorNotSupported.oneFactor"), e.push(n.View({
                View: new u({
                  message: t.loc(r, "login")
                })
              }, {
                selector: ".o-form-error-container"
              }));
            }
            return e;
          },
          _startEnrollment: function _startEnrollment() {
            this.$(".okta-waiting-spinner").show(), this.$(".o-form-button-bar").hide();
          },
          _stopEnrollment: function _stopEnrollment() {
            this.$(".okta-waiting-spinner").hide(), this.$(".o-form-button-bar").show();
          }
        },
        Footer: a,
        trapAuthResponse: function trapAuthResponse() {
          if (this.options.appState.get("isMfaEnrollActivate")) return this.model.activate(), !0;
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(122), n(4), n(255), n(52)], void 0 !== (i = function (t, e, n, r, i) {
      var o = t.internal.util.Util;
      return r.extend({
        Model: {
          local: {
            provider: "string",
            factorType: "string"
          },
          save: function save() {
            var t = this;
            return this.manageTransaction(function () {
              var e = t.appState.get("enrollCustomFactorRedirectUrl");
              null !== e && o.redirect(e);
            });
          }
        },
        Form: function Form() {
          var r = new e.Model(this.options.appState.get("factor"), this.toJSON()),
            o = r.get("vendorName");
          return {
            autoSave: !0,
            title: o,
            subtitle: t.loc("enroll.customFactor.subtitle", "login", [o]),
            save: t.loc("enroll.customFactor.save", "login"),
            formChildren: function formChildren() {
              var t = [];
              return this.options.appState.get("isFactorResultFailed") && t.push(n.View({
                View: new i({
                  message: this.options.appState.get("factorResultErrorMessage")
                })
              }, {
                selector: ".o-form-error-container"
              })), t;
            }
          };
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(4), n(19), n(52)], void 0 !== (i = function (t, e, n, r, i) {
      return e.extend({
        className: "enroll-hotp",
        Model: function Model() {
          return {
            local: {
              __factorType__: ["string", !1, this.options.factorType],
              __provider__: ["string", !1, this.options.provider]
            }
          };
        },
        Form: {
          title: function title() {
            var e = this.options.appState.get("factors"),
              n = e.findWhere({
                provider: this.model.get("__provider__"),
                factorType: this.model.get("__factorType__")
              });
            return t.loc("enroll.totp.title", "login", [n.get("factorLabel")]);
          },
          noButtonBar: !0,
          attributes: {
            "data-se": "restrict-enroll"
          },
          formChildren: function formChildren() {
            return [n.View({
              View: new i({
                message: t.loc("enroll.hotp.restricted", "login")
              })
            })];
          }
        },
        Footer: r
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(58), n(256), n(257), n(258), n(259), n(609), n(260), n(24), n(123), n(33), n(13), n(6), n(121), n(57)], void 0 !== (i = function (t, e, n, r, i, o, a, s, u, c, l, f, p, d, h) {
      function m(t, e) {
        return y.find(t.stateLessRouteHandlers, function (n) {
          return e === t[n];
        });
      }
      function g(t, e) {
        return !!t && (t !== i || e.get("features.securityImage"));
      }
      function v(t, e, n, r) {
        var i = setTimeout(function () {
          t.trigger("loading", !0);
        }, 200);
        return d.loadLanguage(t.get("languageCode"), e, {
          baseUrl: n,
          rewrite: r
        }).then(function () {
          clearTimeout(i), t.trigger("loading", !1);
        });
      }
      var y = t._,
        _ = t.$,
        b = t.Backbone;
      return t.Router.extend({
        Events: b.Events,
        initialize: function initialize(e) {
          e.globalSuccessFn || (e.globalSuccessFn = function () {}), e.globalErrorFn || (e.globalErrorFn = function (t) {
            h.error(t);
          }), this.settings = new n(y.omit(e, "el", "authClient"), {
            parse: !0
          }), this.settings.setAuthClient(e.authClient), e.el || this.settings.callGlobalError(new l.ConfigError(t.loc("error.required.el"))), _("body > div").on("click", function () {}), this.appState = new a({
            baseUrl: this.settings.get("baseUrl"),
            settings: this.settings
          }, {
            parse: !0
          });
          var i = new o({
            appState: this.appState
          });
          t.$(e.el).append(i.render().$el), this.el = "#" + p.WIDGET_CONTAINER_ID, this.header = new r({
            el: this.el,
            appState: this.appState,
            settings: this.settings
          }), this.listenTo(this.appState, "change:transactionError", function (t, e) {
            u.routeAfterAuthStatusChangeError(this, e);
          }), this.listenTo(this.appState, "change:transaction", function (t, e) {
            u.routeAfterAuthStatusChange(this, e.data);
          }), this.listenTo(this.appState, "navigate", function (t) {
            this.navigate(t, {
              trigger: !0
            });
          });
        },
        execute: function execute(t, e) {
          var n = this.settings.get("recoveryToken");
          if (n) return this.settings.unset("recoveryToken"), void this.navigate(u.createRecoveryUrl(n), {
            trigger: !0
          });
          var r = this.settings.get("stateToken");
          if (r) return this.settings.unset("stateToken"), void this.navigate(u.createRefreshUrl(r), {
            trigger: !0
          });
          var i = this.appState.get("transaction");
          return i && i.data || m(this, t) ? void t.apply(this, e) : this.settings.getAuthClient().tx.exists() ? void this.navigate(u.createRefreshUrl(), {
            trigger: !0
          }) : void this.navigate("", {
            trigger: !0
          });
        },
        navigate: function navigate(e, n) {
          return this.settings.get("features.router") ? t.Router.prototype.navigate.apply(this, arguments) : n && n.trigger ? b.history.loadUrl(e) : void 0;
        },
        render: function render(e, n) {
          n || (n = {});
          var r = n.Beacon,
            i = y.extend({
              settings: this.settings,
              appState: this.appState
            }, y.omit(n, "Beacon"));
          if (this.header.rendered() || (this.el = this.header.render().getContentEl()), !d.isLoaded(this.appState.get("languageCode"))) return v(this.appState, this.settings.get("i18n"), this.settings.get("assets.baseUrl"), this.settings.get("assets.rewrite")).then(y.bind(this.render, this, e, n)).done();
          if (this.settings.get("colors.brand") && !s.isLoaded()) {
            var o = {
              brand: this.settings.get("colors.brand")
            };
            s.addStyle(o);
          }
          var a = this.controller;
          this.controller = new e(i), this.listenTo(this.controller, "all", this.trigger), this.controller.fetchInitialData().then(y.bind(function () {
            return g(r, this.settings) || (r = null), this.header.setBeacon(r, i), this.controller.render(), a ? c.swapPages({
              $parent: this.el,
              $oldRoot: a.$el,
              $newRoot: this.controller.$el,
              dir: a.state.get("navigateDir"),
              ctx: this,
              success: function success() {
                var e = this.appState.get("flashError"),
                  n = this.controller.model;
                a.remove(), a.$el.remove(), this.controller.postRenderAnimation(), e && (n.trigger("error", n, {
                  responseJSON: {
                    errorSummary: t.loc("error.expired.session")
                  }
                }), this.appState.unset("flashError"), f.triggerAfterError(this.controller, e));
              }
            }) : (this.el.append(this.controller.el), void this.controller.postRenderAnimation());
          }, this)).fail(function () {
            a && (a.remove(), a.$el.remove());
          }).done();
        },
        start: function start() {
          var n = !1;
          window.addEventListener && this.settings.get("features.router") && (window.addEventListener("popstate", y.bind(function (t) {
            this.controller.back && (t.preventDefault(), t.stopImmediatePropagation(), this.controller.back());
          }, this)), n = e.supportsPushState()), t.Router.prototype.start.call(this, {
            pushState: n
          });
        },
        hide: function hide() {
          this.header.$el.hide();
        },
        show: function show() {
          this.header.$el.show();
        },
        remove: function remove() {
          this.controller.remove(), this.header.$el.remove(), d.remove(), b.history.stop();
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      return t.View.extend({
        template: '      <div class="beacon-blank"/>      <div class="bg-helper auth-beacon auth-beacon-security" data-se="loading-beacon">      <div class="okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border"/>      </div>    ',
        equals: function equals(t) {
          return t && this instanceof t;
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(17), n(122), n(58), n(33)], void 0 !== (i = function (t, e, n, r, i) {
      function o(t, n, r) {
        if (c.isEmpty(n) || c.isUndefined(n)) return e({
          securityImage: p,
          securityImageDescription: m
        });
        n = encodeURIComponent(n);
        var i = v({
            baseUrl: t,
            username: n
          }),
          o = {
            url: i,
            dataType: "json"
          };
        return r && (o.headers = {
          "X-Device-Fingerprint": r
        }), e(l.ajax(o)).then(function (t) {
          return t.pwdImg === f ? {
            securityImage: d,
            securityImageDescription: h
          } : {
            securityImage: t.pwdImg,
            securityImageDescription: t.imageDescription || g
          };
        });
      }
      function a(e) {
        if (e > 60 && e <= 1440) {
          var n = e / 60;
          return t.loc("hours", "login", [n]);
        }
        if (e > 1440) {
          var r = e / 1440;
          return t.loc("days", "login", [r]);
        }
        return 1 === e ? t.loc("minutes.oneMinute", "login") : t.loc("minutes", "login", [e]);
      }
      function s(t) {
        var e = new Date(t).getTime();
        return Math.floor((e - new Date().getTime()) / 864e5);
      }
      function u(t, e) {
        var n = [],
          r = [];
        return c.each(e, function (e) {
          var i = e.factorType;
          if (!c.contains(n, i)) {
            var o = c.findWhere(t, {
              factorType: i
            });
            o ? (n.push(i), r.push(o)) : r.push(e);
          }
        }), r;
      }
      var c = t._,
        l = t.$,
        f = "/img/security/unknown.png",
        p = "/img/security/default.png",
        d = "/img/security/unknown-device.png",
        h = "",
        m = "",
        g = "",
        v = t.tpl("{{baseUrl}}/login/getimage?username={{username}}");
      return t.Model.extend({
        initialize: function initialize() {
          if (this.settings.get("features.securityImage")) {
            var e = this;
            this.listenTo(this, "change:username", function (n, a) {
              o(this.get("baseUrl"), a, this.get("deviceFingerprint")).then(function (t) {
                n.set("securityImage", t.securityImage), n.set("securityImageDescription", t.securityImageDescription), n.unset("deviceFingerprint");
              }).fail(function (n) {
                if (!r.corsIsNotEnabled(n)) throw n;
                e.settings.callGlobalError(new i.UnsupportedBrowserError(t.loc("error.enabled.cors")));
              }).done();
            });
          }
        },
        local: {
          baseUrl: "string",
          lastAuthResponse: ["object", !0, {}],
          transaction: "object",
          transactionError: "object",
          introspectSuccess: "object",
          introspectError: "object",
          username: "string",
          factors: "object",
          policy: "object",
          securityImage: ["string", !0, p],
          securityImageDescription: ["string", !0, m],
          userCountryCode: "string",
          userPhoneNumber: "string",
          factorActivationType: "string",
          flashError: "object",
          beaconType: "string",
          deviceFingerprint: "string",
          typingPattern: "string",
          languageCode: ["string", !0],
          disableUsername: ["boolean", !1, !1],
          trapMfaRequiredResponse: ["boolean", !1, !1],
          lastFailedChallengeFactorData: ["object", !1]
        },
        setAuthResponse: function setAuthResponse(t) {
          var e = this;
          if (t._embedded && t._embedded.policy && this.set("policy", t._embedded.policy), t._embedded && t._embedded.factors) {
            var r = t._embedded.factors;
            t._embedded.factorTypes && (r = u(t._embedded.factorTypes, r));
            var i = c.map(r, function (t) {
              return t.settings = e.settings, t.appState = e, t;
            });
            this.set("factors", new n.Collection(i, {
              parse: !0
            }));
          }
          this.set("lastAuthResponse", t);
        },
        clearLastAuthResponse: function clearLastAuthResponse() {
          this.set("lastAuthResponse", {});
        },
        setLastFailedChallengeFactorData: function setLastFailedChallengeFactorData() {
          this.set("lastFailedChallengeFactorData", {
            factor: this.get("factor"),
            errorMessage: this.get("factorResultErrorMessage")
          });
        },
        clearLastFailedChallengeFactorData: function clearLastFailedChallengeFactorData() {
          this.unset("lastFailedChallengeFactorData");
        },
        derived: {
          isSuccessResponse: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return "SUCCESS" === t.status;
            }
          },
          isMfaRequired: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return "MFA_REQUIRED" === t.status || "FACTOR_REQUIRED" === t.status;
            }
          },
          isProfileRequired: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return "PROFILE_REQUIRED" === t.status;
            }
          },
          isMfaEnroll: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return "MFA_ENROLL" === t.status || "FACTOR_ENROLL" === t.status;
            }
          },
          isMfaChallenge: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return "MFA_CHALLENGE" === t.status || "FACTOR_CHALLENGE" === t.status;
            }
          },
          isUnauthenticated: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return "UNAUTHENTICATED" === t.status;
            }
          },
          isMfaRejectedByUser: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return "REJECTED" === t.factorResult;
            }
          },
          isMfaTimeout: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return "TIMEOUT" === t.factorResult;
            }
          },
          isMfaEnrollActivate: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return "MFA_ENROLL_ACTIVATE" === t.status || "FACTOR_ENROLL_ACTIVATE" === t.status;
            }
          },
          isWaitingForActivation: {
            deps: ["isMfaEnrollActivate", "lastAuthResponse"],
            fn: function fn(t, e) {
              return t && "WAITING" === e.factorResult;
            }
          },
          isWaitingForNumberChallenge: {
            deps: ["lastAuthResponse", "isMfaChallenge"],
            fn: function fn(t, e) {
              return !!(e && t && "WAITING" === t.factorResult && t._embedded && t._embedded.factor && t._embedded.factor._embedded && t._embedded.factor._embedded.challenge);
            }
          },
          hasMultipleFactorsAvailable: {
            deps: ["factors", "isMfaRequired", "isMfaChallenge", "isUnauthenticated"],
            fn: function fn(t, e, n, r) {
              return !!(e || n || r) && t && t.length > 1;
            }
          },
          promptForFactorInUnauthenticated: {
            deps: ["lastAuthResponse", "factors"],
            fn: function fn(t, e) {
              return "UNAUTHENTICATED" === t.status && e && e.length > 0;
            }
          },
          userId: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t._embedded && t._embedded.user ? t._embedded.user.id : null;
            }
          },
          isIdxStateToken: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t && c.isString(t.stateToken) && t.stateToken.startsWith("01");
            }
          },
          isPwdExpiringSoon: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return "PASSWORD_WARN" === t.status;
            }
          },
          passwordExpireDays: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t._embedded && t._embedded.policy && t._embedded.policy.expiration ? t._embedded.policy.expiration.passwordExpireDays : null;
            }
          },
          isPwdManagedByOkta: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return !(t._links && t._links.next && t._links.next.title);
            }
          },
          passwordExpiredWebsiteName: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t._links && t._links.next && t._links.next.title ? t._links.next.title : null;
            }
          },
          passwordExpiredLinkUrl: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t._links && t._links.next && t._links.next.title && t._links.next.href ? t._links.next.href : null;
            }
          },
          recoveryType: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t.recoveryType;
            }
          },
          factorType: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t.factorType;
            }
          },
          factor: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t._embedded && t._embedded.factor ? t._embedded.factor : null;
            }
          },
          activatedFactorId: {
            deps: ["factor"],
            fn: function fn(t) {
              return t ? t.id : null;
            }
          },
          activatedFactorType: {
            deps: ["factor"],
            fn: function fn(t) {
              return t ? t.factorType : null;
            }
          },
          activatedFactorProvider: {
            deps: ["factor"],
            fn: function fn(t) {
              return t ? t.provider : null;
            }
          },
          qrcode: {
            deps: ["factor"],
            fn: function fn(t) {
              try {
                return t._embedded.activation._links.qrcode.href;
              } catch (t) {
                return null;
              }
            }
          },
          activationSendLinks: {
            deps: ["factor"],
            fn: function fn(t) {
              var e;
              try {
                e = t._embedded.activation._links.send;
              } catch (t) {
                e = [];
              }
              return e;
            }
          },
          textActivationLinkUrl: {
            deps: ["activationSendLinks"],
            fn: function fn(t) {
              var e = c.findWhere(t, {
                name: "sms"
              });
              return e ? e.href : null;
            }
          },
          emailActivationLinkUrl: {
            deps: ["activationSendLinks"],
            fn: function fn(t) {
              var e = c.findWhere(t, {
                name: "email"
              });
              return e ? e.href : null;
            }
          },
          sharedSecret: {
            deps: ["factor"],
            fn: function fn(t) {
              try {
                return t._embedded.activation.sharedSecret;
              } catch (t) {
                return null;
              }
            }
          },
          duoEnrollActivation: {
            deps: ["factor"],
            fn: function fn(t) {
              return t && t._embedded && t._embedded.activation ? t._embedded.activation : null;
            }
          },
          prevLink: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t._links && t._links.prev ? t._links.prev.href : null;
            }
          },
          skipLink: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t._links && t._links.skip ? t._links.skip.href : null;
            }
          },
          gracePeriodRemainingDays: {
            deps: ["policy"],
            fn: function fn(t) {
              return t && t.gracePeriod && t.gracePeriod.endDate ? s(t.gracePeriod.endDate) : null;
            }
          },
          user: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t._embedded && t._embedded.user ? t._embedded.user : null;
            }
          },
          recoveryQuestion: {
            deps: ["user"],
            fn: function fn(t) {
              return t && t.recovery_question ? t.recovery_question.question : null;
            }
          },
          userProfile: {
            deps: ["user"],
            fn: function fn(t) {
              return t && t.profile ? t.profile : null;
            }
          },
          userConsentName: {
            deps: ["userProfile", "username"],
            fn: function fn(t, e) {
              return !t || c.isEmpty(t.firstName) ? e : c.isEmpty(t.lastName) ? t.firstName : t.firstName + " " + t.lastName.charAt(0) + ".";
            }
          },
          userEmail: {
            deps: ["userProfile"],
            fn: function fn(t) {
              return t && t.login ? t.login : null;
            }
          },
          userFullName: {
            deps: ["userProfile"],
            fn: function fn(t) {
              return t && (t.firstName || t.lastName) ? t.firstName + " " + t.lastName : "";
            }
          },
          defaultAppLogo: {
            deps: ["baseUrl"],
            fn: function fn(t) {
              return t + "/img/logos/default.png";
            }
          },
          expiresAt: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t.expiresAt;
            }
          },
          target: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t._embedded ? t._embedded.target : null;
            }
          },
          targetLabel: {
            deps: ["target"],
            fn: function fn(t) {
              return t ? t.label : null;
            }
          },
          targetLogo: {
            deps: ["target"],
            fn: function fn(t) {
              return t && t._links ? t._links.logo : null;
            }
          },
          targetTermsOfService: {
            deps: ["target"],
            fn: function fn(t) {
              return t && t._links ? t._links["terms-of-service"] : null;
            }
          },
          targetPrivacyPolicy: {
            deps: ["target"],
            fn: function fn(t) {
              return t && t._links ? t._links["privacy-policy"] : null;
            }
          },
          targetClientURI: {
            deps: ["target"],
            fn: function fn(t) {
              return t && t._links ? t._links["client-uri"] : null;
            }
          },
          scopes: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t._embedded ? t._embedded.scopes : null;
            }
          },
          hasExistingPhones: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              if (!t._embedded || !t._embedded.factors) return !1;
              var e = t._embedded.factors,
                n = c.findWhere(e, {
                  factorType: "sms",
                  provider: "OKTA"
                });
              return !(!n || !n._embedded) && !!n._embedded.phones.length;
            }
          },
          hasExistingPhonesForCall: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              if (!t._embedded || !t._embedded.factors) return !1;
              var e = t._embedded.factors,
                n = c.findWhere(e, {
                  factorType: "call",
                  provider: "OKTA"
                });
              return !(!n || !n._embedded) && !!n._embedded.phones.length;
            }
          },
          isUndefinedUser: {
            deps: ["securityImage"],
            fn: function fn(t) {
              return t === p;
            }
          },
          isNewUser: {
            deps: ["securityImage"],
            fn: function fn(t) {
              return t === d;
            }
          },
          allowRememberDevice: {
            deps: ["policy"],
            fn: function fn(t) {
              return t && t.allowRememberDevice;
            }
          },
          rememberDeviceLabel: {
            deps: ["policy"],
            fn: function fn(e) {
              if (e && e.rememberDeviceLifetimeInMinutes > 0) {
                var n = a(e.rememberDeviceLifetimeInMinutes);
                return t.loc("rememberDevice.timebased", "login", [n]);
              }
              return e && 0 === e.rememberDeviceLifetimeInMinutes ? t.loc("rememberDevice.devicebased", "login") : t.loc("rememberDevice", "login");
            }
          },
          rememberDeviceByDefault: {
            deps: ["policy"],
            fn: function fn(t) {
              return t && t.rememberDeviceByDefault;
            }
          },
          factorsPolicyInfo: {
            deps: ["policy"],
            fn: function fn(t) {
              return t && t.factorsPolicyInfo ? t.factorsPolicyInfo : null;
            }
          },
          verifyCustomFactorRedirectUrl: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t._links && t._links.next && "redirect" === t._links.next.name && t._links.next.href ? t._links.next.href : null;
            }
          },
          enrollCustomFactorRedirectUrl: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return t._links && t._links.next && "activate" === t._links.next.name && t._links.next.href ? t._links.next.href : null;
            }
          },
          isFactorResultFailed: {
            deps: ["lastAuthResponse"],
            fn: function fn(t) {
              return "FAILED" === t.factorResult;
            }
          },
          factorResultErrorMessage: {
            deps: ["lastAuthResponse", "isFactorResultFailed"],
            fn: function fn(e, n) {
              return n ? e.factorResultMessage || t.loc("oform.error.unexpected", "login") : null;
            }
          }
        },
        parse: function parse(t) {
          return this.settings = t.settings, c.extend(c.omit(t, "settings"), {
            languageCode: this.settings.get("languageCode")
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(18), n(2), n(4), n(24), n(182), n(19)], void 0 !== (i = function (t, e, n, r, i, o, a) {
      var s = t._;
      return n.extend({
        className: "barcode-push",
        Model: function Model() {
          return {
            local: {
              __factorType__: ["string", !1, this.options.factorType],
              __provider__: ["string", !1, this.options.provider]
            }
          };
        },
        Form: {
          title: function title() {
            var n = e.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
            return t.loc("enroll.totp.title", "login", [n]);
          },
          subtitle: s.partial(t.loc, "mfa.scanBarcode", "login"),
          noButtonBar: !0,
          attributes: {
            "data-se": "step-scan"
          },
          className: "barcode-scan",
          initialize: function initialize() {
            this.listenTo(this.model, "error errors:clear", function () {
              this.clearErrors();
            });
          },
          formChildren: [r.View({
            View: o
          })]
        },
        Footer: a,
        initialize: function initialize() {
          this.pollForEnrollment();
        },
        pollForEnrollment: function pollForEnrollment() {
          return this.model.doTransaction(function (t) {
            return t.poll(6e3);
          });
        },
        trapAuthResponse: function trapAuthResponse() {
          if (this.options.appState.get("isMfaEnrollActivate")) return !0;
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(261), n(19)], void 0 !== (i = function (t, e, n, r) {
      return e.extend({
        className: "activate-totp",
        Model: function Model() {
          return {
            props: {
              factorId: ["string", !0, this.options.appState.get("activatedFactorId")],
              passCode: ["string", !0]
            },
            local: {
              __factorType__: ["string", !1, this.options.factorType],
              __provider__: ["string", !1, this.options.provider]
            },
            save: function save() {
              return this.doTransaction(function (t) {
                return t.activate({
                  passCode: this.get("passCode")
                });
              });
            }
          };
        },
        Form: n,
        Footer: r
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(18), n(2), n(4), n(24), n(613), n(14)], void 0 !== (i = function (t, e, n, r, i, o, a) {
      var s = t._;
      return n.extend({
        className: "enroll-manual-totp",
        Model: function Model() {
          return {
            local: {
              sharedSecret: ["string", !1, this.options.appState.get("sharedSecret")],
              __factorType__: ["string", !1, this.options.factorType],
              __provider__: ["string", !1, this.options.provider]
            }
          };
        },
        Form: {
          title: function title() {
            var n = e.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
            return t.loc("enroll.totp.title", "login", [n]);
          },
          subtitle: s.partial(t.loc, "enroll.totp.cannotScanBarcode", "login"),
          noButtonBar: !0,
          attributes: {
            "data-se": "step-manual-setup"
          },
          formChildren: function formChildren() {
            var e = this.settings.get("brandName") ? t.loc("enroll.totp.manualSetupInstructions.specific", "login", [this.settings.get("brandName")]) : t.loc("enroll.totp.manualSetupInstructions.generic", "login");
            return [r.View({
              View: t.View.extend({
                template: '                <p class="okta-form-subtitle o-form-explain text-align-c">                  {{instructions}}                </p>              ',
                getTemplateData: function getTemplateData() {
                  return {
                    instructions: e
                  };
                }
              })
            }), r.Input({
              name: "sharedSecret",
              input: a,
              type: "text",
              disabled: !0
            }), r.Toolbar({
              noCancelButton: !0,
              save: t.loc("oform.next", "login")
            })];
          }
        },
        Footer: o,
        initialize: function initialize() {
          this.listenTo(this.form, "save", function () {
            var t = i.createActivateFactorUrl(this.model.get("__provider__"), this.model.get("__factorType__"), "activate");
            this.options.appState.trigger("navigate", t);
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(24), n(6)], void 0 !== (i = function (t, e, n) {
      return t.View.extend({
        template: '      <a href="#" class="link help js-back" data-se="back-link">        {{i18n code="mfa.backToFactors" bundle="login"}}      </a>      <a href="#" class="link help goto js-goto" data-se="goto-link">        {{i18n code="mfa.scanBarcode" bundle="login"}}      </a>    ',
        className: "auth-footer",
        events: {
          "click .js-back": function clickJsBack(t) {
            t.preventDefault(), this.back();
          },
          "click .js-goto": function clickJsGoto(t) {
            t.preventDefault(), this.model.startTransaction(function (t) {
              return t.tx.resume();
            });
          }
        },
        back: function back() {
          this.state.set("navigateDir", n.DIRECTION_BACK), this.options.appState.get("prevLink") ? this.model.doTransaction(function (t) {
            return t.prev();
          }) : this.options.appState.trigger("navigate", "signin/enroll");
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(181), n(18), n(2), n(4), n(24), n(615), n(254), n(14)], void 0 !== (i = function (t, e, n, r, i, o, a, s, u) {
      function c(t, e) {
        var n = o.createActivateFactorUrl(t.options.appState.get("activatedFactorProvider"), t.options.appState.get("activatedFactorType"), e);
        t.options.appState.trigger("navigate", n);
      }
      function l(t) {
        var e, n;
        "SMS" === t.model.get("activationType") && (n = t.model.get("countryCode"), e = t.model.get("phoneNumber")), t.options.appState.set({
          factorActivationType: t.model.get("activationType"),
          userCountryCode: n,
          userPhoneNumber: e
        });
      }
      function f(t, e) {
        return t.model.doTransaction(function (n) {
          return n.prev().then(function (t) {
            return p.findWhere(t.factors, {
              factorType: e,
              provider: "OKTA"
            }).enroll();
          }).then(function (e) {
            var n,
              r,
              i,
              o = e.data;
            if (o && o._embedded && o._embedded.factor && o._embedded.factor._embedded && o._embedded.factor._embedded.activation) {
              var a = o._embedded.factor;
              if (i = a._embedded.activation.sharedSecret, a._embedded.activation._links && a._embedded.activation._links.send) {
                var s = a._embedded.activation._links.send,
                  u = p.findWhere(s, {
                    name: "sms"
                  });
                n = u ? u.href : null;
                var c = p.findWhere(s, {
                  name: "email"
                });
                r = c ? c.href : null;
              }
            }
            return t.model.set({
              SMS: n,
              EMAIL: r,
              sharedSecret: i
            }), e;
          });
        });
      }
      var p = t._;
      return r.extend({
        className: "enroll-manual-push",
        Model: function Model() {
          return {
            local: {
              activationType: ["string", !0, this.options.appState.get("factorActivationType") || "SMS"],
              countryCode: ["string", !1, "US"],
              phoneNumber: "string",
              SMS: ["string", !1, this.options.appState.get("textActivationLinkUrl")],
              EMAIL: ["string", !1, this.options.appState.get("emailActivationLinkUrl")],
              sharedSecret: ["string", !1, this.options.appState.get("sharedSecret")],
              __factorType__: ["string", !1, this.options.factorType],
              __provider__: ["string", !1, this.options.provider]
            },
            derived: {
              countryCallingCode: {
                deps: ["countryCode"],
                fn: function fn(t) {
                  return "+" + e.getCallingCodeForCountry(t);
                }
              },
              fullPhoneNumber: {
                deps: ["countryCallingCode", "phoneNumber"],
                fn: function fn(t, e) {
                  return t + e;
                }
              }
            }
          };
        },
        Form: {
          title: function title() {
            var e = n.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
            return t.loc("enroll.totp.title", "login", [e]);
          },
          subtitle: p.partial(t.loc, "enroll.totp.cannotScanBarcode", "login"),
          noButtonBar: !0,
          attributes: {
            "data-se": "step-manual-setup"
          },
          formChildren: function formChildren() {
            var n = this.settings.get("brandName") ? t.loc("enroll.totp.sharedSecretInstructions.specific", "login", [this.settings.get("brandName")]) : t.loc("enroll.totp.sharedSecretInstructions.generic", "login");
            return [i.Input({
              name: "activationType",
              type: "select",
              wide: !0,
              options: {
                SMS: t.loc("enroll.totp.sendSms", "login"),
                EMAIL: t.loc("enroll.totp.sendEmail", "login"),
                MANUAL: t.loc("enroll.totp.setupManually", "login")
              }
            }), i.Input({
              name: "countryCode",
              type: "select",
              wide: !0,
              options: e.getCountries(),
              showWhen: {
                activationType: "SMS"
              }
            }), i.Input({
              label: t.loc("mfa.phoneNumber.placeholder", "login"),
              "label-top": !0,
              className: "enroll-sms-phone",
              name: "phoneNumber",
              input: s,
              type: "text",
              showWhen: {
                activationType: "SMS"
              }
            }), i.View({
              View: t.View.extend({
                template: '                <p class="okta-form-subtitle o-form-explain text-align-c">                  {{instructions}}                </p>              ',
                getTemplateData: function getTemplateData() {
                  return {
                    instructions: n
                  };
                }
              }),
              showWhen: {
                activationType: "MANUAL"
              }
            }), i.Input({
              name: "sharedSecret",
              input: u,
              type: "text",
              disabled: !0,
              showWhen: {
                activationType: "MANUAL"
              },
              initialize: function initialize() {
                this.listenTo(this.model, "change:sharedSecret", this.render);
              }
            }), i.View({
              View: '<div data-type="next-button-wrap"></div>',
              showWhen: {
                activationType: "MANUAL"
              }
            }), i.Button({
              title: t.loc("oform.next", "login"),
              className: "button button-primary button-wide button-next",
              attributes: {
                "data-se": "next-button"
              },
              click: p.bind(function () {
                l(this), c(this, "passcode");
              }, this)
            }, '[data-type="next-button-wrap"]'), i.Toolbar({
              noCancelButton: !0,
              save: t.loc("oform.send", "login"),
              showWhen: {
                activationType: function activationType(t) {
                  return "SMS" === t || "EMAIL" === t;
                }
              }
            })];
          }
        },
        Footer: a,
        initialize: function initialize() {
          this.setInitialModel(), this.listenTo(this.form, "save", function () {
            var t = this;
            this.model.doTransaction(function (e) {
              var n = this.get("activationType").toLowerCase(),
                r = {};
              return "sms" === n && (r.profile = {
                phoneNumber: this.get("fullPhoneNumber")
              }), e.factor.activation.send(n, r).then(function (e) {
                return l(t), p.defer(function () {
                  c(t, "sent");
                }), e;
              });
            });
          }), this.listenTo(this.model, "change:activationType", function (t, e) {
            this.form.clearErrors(), "MANUAL" === e && "token:software:totp" !== this.options.appState.get("activatedFactorType") ? f(this, "token:software:totp") : "push" !== this.options.appState.get("activatedFactorType") && f(this, "push");
          });
        },
        setInitialModel: function setInitialModel() {
          "SMS" === this.options.appState.get("factorActivationType") && this.model.set({
            countryCode: this.options.appState.get("userCountryCode") || "US",
            phoneNumber: this.options.appState.get("userPhoneNumber")
          });
        },
        trapAuthResponse: function trapAuthResponse() {
          if (this.options.appState.get("isMfaEnrollActivate") || this.options.appState.get("isMfaEnroll")) return !0;
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(24)], void 0 !== (i = function (t, e) {
      function n(t) {
        var n = e.createActivateFactorUrl(t.get("activatedFactorProvider"), t.get("activatedFactorType"));
        t.trigger("navigate", n);
      }
      var r = t._;
      return t.View.extend({
        template: '      <a href="#" class="link help js-back" data-se="back-link">        {{i18n code="mfa.backToFactors" bundle="login"}}      </a>      <a href="#" class="link help goto js-goto" data-se="goto-link">        {{i18n code="mfa.scanBarcode" bundle="login"}}      </a>    ',
        className: "auth-footer",
        events: {
          "click .js-back": function clickJsBack(t) {
            t.preventDefault(), this.back();
          },
          "click .js-goto": function clickJsGoto(t) {
            t.preventDefault();
            var e = r.partial(n, this.options.appState);
            this.options.appState.unset("factorActivationType"), this.model.doTransaction(function (t) {
              return t.prev().then(function (t) {
                return r.findWhere(t.factors, {
                  factorType: "push",
                  provider: "OKTA"
                }).enroll();
              });
            }).then(e);
          }
        },
        back: function back() {
          var t = this;
          t.options.appState.unset("factorActivationType"), t.options.appState.get("prevLink") ? this.model.doTransaction(function (t) {
            return t.prev();
          }).then(function () {
            t.options.appState.trigger("navigate", "signin/enroll");
          }) : t.options.appState.trigger("navigate", "signin/enroll");
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(181), n(2), n(4), n(24)], void 0 !== (i = function (t, e, n, r, i) {
      var o = t._,
        a = t.View.extend({
          template: '      <a href="#" class="link help js-back" data-se="back-link">        {{i18n code="oform.back" bundle="login"}}      </a>    ',
          className: "auth-footer",
          events: {
            "click .js-back": function clickJsBack(t) {
              t.preventDefault(), this.back();
            }
          },
          back: function back() {
            var t = i.createActivateFactorUrl(this.options.appState.get("activatedFactorProvider"), this.options.appState.get("activatedFactorType"), "manual");
            this.options.appState.trigger("navigate", t);
          }
        }),
        s = {
          title: o.partial(t.loc, "enroll.totp.enrollViaEmail.title", "login"),
          noButtonBar: !0,
          attributes: {
            "data-se": "sent-email-activation-link"
          },
          formChildren: [r.View({
            View: t.View.extend({
              template: '            <p>{{i18n code="enroll.totp.enrollViaEmail.msg" bundle="login"}}</p>            <p class="email-address">{{email}}</p>          ',
              getTemplateData: function getTemplateData() {
                return {
                  email: this.options.appState.get("userEmail")
                };
              }
            })
          })]
        },
        u = {
          title: o.partial(t.loc, "enroll.totp.enrollViaSms.title", "login"),
          noButtonBar: !0,
          attributes: {
            "data-se": "sent-sms-activation-link"
          },
          formChildren: [r.View({
            View: t.View.extend({
              template: '            <p>{{i18n code="enroll.totp.enrollViaSms.msg" bundle="login"}}</p>            <p class="phone-number">{{phoneNumber}}</p>          ',
              getTemplateData: function getTemplateData() {
                return {
                  phoneNumber: this.model.get("fullPhoneNumber")
                };
              }
            })
          })]
        };
      return n.extend({
        className: "enroll-activation-link-sent",
        Model: function Model() {
          return {
            local: {
              countryCode: ["string", !1, this.options.appState.get("userCountryCode")],
              phoneNumber: ["string", !1, this.options.appState.get("userPhoneNumber")],
              __factorType__: ["string", !1, this.options.factorType],
              __provider__: ["string", !1, this.options.provider]
            },
            derived: {
              countryCallingCode: {
                deps: ["countryCode"],
                fn: function fn(t) {
                  return "+" + e.getCallingCodeForCountry(t);
                }
              },
              fullPhoneNumber: {
                deps: ["countryCallingCode", "phoneNumber"],
                fn: function fn(t, e) {
                  return t + e;
                }
              }
            }
          };
        },
        Form: function Form() {
          var t = this.options.appState.get("factorActivationType");
          switch (t) {
            case "SMS":
              return u;
            case "EMAIL":
              return s;
            default:
              throw new Error("Unknown activation option: " + t);
          }
        },
        Footer: a,
        initialize: function initialize() {
          this.pollForEnrollment();
        },
        remove: function remove() {
          return n.prototype.remove.apply(this, arguments);
        },
        pollForEnrollment: function pollForEnrollment() {
          return this.model.doTransaction(function (t) {
            return t.poll(6e3);
          });
        },
        trapAuthResponse: function trapAuthResponse() {
          if (this.options.appState.get("isWaitingForActivation")) return this.pollForEnrollment(), !0;
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(24), n(261)], void 0 !== (i = function (t, e, n, r) {
      var i = t.View.extend({
        template: '      <a href="#" class="link help js-back" data-se="back-link">        {{i18n code="oform.back" bundle="login"}}      </a>    ',
        className: "auth-footer",
        events: {
          "click .js-back": function clickJsBack(t) {
            t.preventDefault(), this.back();
          }
        },
        back: function back() {
          var t = n.createActivateFactorUrl(this.options.appState.get("activatedFactorProvider"), "push", "manual");
          this.options.appState.trigger("navigate", t);
        }
      });
      return e.extend({
        className: "activate-push",
        Model: function Model() {
          return {
            props: {
              factorId: ["string", !0, this.options.appState.get("activatedFactorId")],
              passCode: ["string", !0]
            },
            local: {
              __factorType__: ["string", !1, this.options.factorType],
              __provider__: ["string", !1, this.options.provider]
            },
            save: function save() {
              return this.doTransaction(function (t) {
                return t.activate({
                  passCode: this.get("passCode")
                });
              });
            }
          };
        },
        Form: r,
        Footer: i
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(6), n(4), n(98), n(18), n(13), n(262), n(14)], void 0 !== (i = function (t, e, n, r, i, o, a, s, u) {
      var c = t._;
      return e.extend({
        className: "password-expired",
        Model: {
          props: {
            oldPassword: ["string", !0],
            newPassword: ["string", !0],
            confirmPassword: ["string", !0]
          },
          validate: function validate() {
            return i.validatePasswordMatch(this);
          },
          save: function save() {
            return this.trigger("save"), this.doTransaction(function (t) {
              return t.changePassword({
                oldPassword: this.get("oldPassword"),
                newPassword: this.get("newPassword")
              });
            });
          }
        },
        Form: {
          save: c.partial(t.loc, "password.expired.submit", "login"),
          title: function title() {
            var e = this.options.appState.get("isPwdExpiringSoon"),
              n = this.options.appState.get("passwordExpireDays");
            return e && n > 0 ? t.loc("password.expiring.title", "login", [n]) : e && 0 === n ? t.loc("password.expiring.today", "login") : e ? t.loc("password.expiring.soon", "login") : this.settings.get("brandName") ? t.loc("password.expired.title.specific", "login", [this.settings.get("brandName")]) : t.loc("password.expired.title.generic", "login");
          },
          subtitle: function subtitle() {
            if (this.options.appState.get("isPwdExpiringSoon")) return this.settings.get("brandName") ? t.loc("password.expiring.subtitle.specific", "login", [this.settings.get("brandName")]) : t.loc("password.expiring.subtitle.generic", "login");
            var e = this.options.appState.get("policy");
            if (e) return o.getPasswordComplexityDescription(e);
          },
          formChildren: function formChildren() {
            return [r.Input({
              "label-top": !0,
              label: t.loc("password.oldPassword.placeholder", "login"),
              explain: a.createInputExplain("password.oldPassword.tooltip", "password.oldPassword.placeholder", "login"),
              "explain-top": !0,
              name: "oldPassword",
              input: u,
              type: "password"
            }), r.Divider(), r.Input({
              className: "margin-btm-5",
              "label-top": !0,
              label: t.loc("password.newPassword.placeholder", "login"),
              explain: a.createInputExplain("password.newPassword.tooltip", "password.newPassword.placeholder", "login"),
              "explain-top": !0,
              name: "newPassword",
              input: u,
              type: "password"
            }), r.Input({
              "label-top": !0,
              label: t.loc("password.confirmPassword.placeholder", "login"),
              explain: a.createInputExplain("password.confirmPassword.tooltip", "password.confirmPassword.placeholder", "login"),
              "explain-top": !0,
              name: "confirmPassword",
              input: u,
              type: "password"
            })];
          }
        },
        Footer: s,
        initialize: function initialize() {
          this.listenTo(this.form, "save", function () {
            var t = {
              username: this.options.appState.get("userEmail"),
              password: this.model.get("newPassword")
            };
            this.settings.processCreds(t).then(c.bind(this.model.save, this.model));
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(4), n(262)], void 0 !== (i = function (t, e, n, r) {
      var i = t._,
        o = t.internal.util.Util;
      return e.extend({
        className: "custom-password-expired",
        Model: {},
        Form: {
          noButtonBar: !0,
          title: function title() {
            var e = this.options.appState.get("isPwdExpiringSoon"),
              n = this.options.appState.get("passwordExpireDays");
            return e && n > 0 ? t.loc("password.expiring.title", "login", [n]) : e && 0 === n ? t.loc("password.expiring.today", "login") : e ? t.loc("password.expiring.soon", "login") : this.settings.get("brandName") ? t.loc("password.expired.title.specific", "login", [this.settings.get("brandName")]) : t.loc("password.expired.title.generic", "login");
          },
          subtitle: function subtitle() {
            if (this.options.appState.get("isPwdExpiringSoon")) {
              return (this.settings.get("brandName") ? t.loc("password.expiring.subtitle.specific", "login", [this.settings.get("brandName")]) : t.loc("password.expiring.subtitle.generic", "login")) + " " + t.loc("password.expired.custom.subtitle", "login");
            }
            return t.loc("password.expired.custom.subtitle", "login");
          },
          formChildren: function formChildren() {
            return [n.Button({
              title: i.partial(t.loc, "password.expired.custom.submit", "login", [this.options.appState.get("passwordExpiredWebsiteName")]),
              className: "button button-primary button-wide",
              attributes: {
                "data-se": "custom-button"
              },
              click: function click() {
                o.redirect(this.options.appState.get("passwordExpiredLinkUrl"));
              }
            })];
          }
        },
        Footer: r
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(6), n(4), n(98), n(13), n(263), n(14)], void 0 !== (i = function (t, e, n, r, i, o, a, s) {
      var u = t._,
        c = t.View.extend({
          template: '      {{#unless hideBackToSignInForReset}}        <a href="#" class="link help js-back" data-se="back-link">          {{i18n code="goback" bundle="login"}}        </a>      {{/unless}}      {{#if helpSupportNumber}}      <a href="#" class="link goto js-contact-support">        {{i18n code="mfa.noAccessToEmail" bundle="login"}}      </a>      {{/if}}    ',
          className: "auth-footer",
          events: {
            "click .js-back": function clickJsBack(t) {
              t.preventDefault(), this.back();
            },
            "click .js-contact-support": function clickJsContactSupport(t) {
              t.preventDefault(), this.state.trigger("contactSupport"), this.$(".js-contact-support").hide();
            }
          },
          getTemplateData: function getTemplateData() {
            return {
              hideBackToSignInForReset: this.settings.get("features.hideBackToSignInForReset"),
              helpSupportNumber: this.settings.get("helpSupportNumber")
            };
          },
          back: function back() {
            this.state.set("navigateDir", n.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
          }
        });
      return e.extend({
        className: "forgot-password",
        Model: {
          props: {
            username: ["string", !0],
            factorType: ["string", !0]
          },
          validate: function validate() {
            return i.validateUsername(this);
          },
          save: function save() {
            var t = this,
              e = this.settings.get("relayState");
            this.startTransaction(function (r) {
              return r.forgotPassword({
                username: t.settings.transformUsername(t.get("username"), n.FORGOT_PASSWORD),
                factorType: t.get("factorType"),
                relayState: e
              });
            }).fail(function () {});
          }
        },
        Form: {
          noButtonBar: !0,
          title: u.partial(t.loc, "password.reset", "login"),
          formChildren: function formChildren() {
            var e = this.settings.get("features.smsRecovery"),
              i = this.settings.get("features.callRecovery"),
              a = this.settings.get("features.emailRecovery"),
              u = !(e || i || a),
              c = [];
            return u ? this.add('<div class="okta-form-infobox-error infobox infobox-error" role="alert">    <span class="icon error-16"></span>    <p>{{i18n code="password.forgot.noFactorsEnabled" bundle="login"}}</p>  </div>', ".o-form-error-container") : (c.push(r.Input({
              label: t.loc("password.forgot.email.or.username.placeholder", "login"),
              "label-top": !0,
              explain: o.createInputExplain("password.forgot.email.or.username.tooltip", "password.forgot.email.or.username.placeholder", "login"),
              "explain-top": !0,
              name: "username",
              input: s,
              inputId: "account-recovery-username",
              type: "text",
              inlineValidation: !1
            })), (e || i) && c.push(r.View({
              View: t.View.extend({
                template: '                  <p class="mobile-recovery-hint">                    {{i18n code="recovery.mobile.hint" bundle="login" arguments="mobileFactors"}}                  </p>',
                getTemplateData: function getTemplateData() {
                  var n;
                  return n = e && i ? t.loc("recovery.smsOrCall") : i ? t.loc("recovery.call") : t.loc("recovery.sms"), {
                    mobileFactors: n
                  };
                }
              })
            })), e && (this.$el.addClass("forgot-password-sms-enabled"), c.push(this.createRecoveryFactorButton("sms-button", "password.forgot.sendText", n.RECOVERY_FACTOR_TYPE_SMS, this)), this.setDefaultFactorType(n.RECOVERY_FACTOR_TYPE_SMS)), i && (this.$el.addClass("forgot-password-call-enabled"), c.push(this.createRecoveryFactorButton("call-button", "password.forgot.call", n.RECOVERY_FACTOR_TYPE_CALL, this)), this.setDefaultFactorType(n.RECOVERY_FACTOR_TYPE_CALL)), a && (this.$el.addClass("forgot-password-email-enabled"), c.push(this.createRecoveryFactorButton("email-button", "password.forgot.sendEmail", n.RECOVERY_FACTOR_TYPE_EMAIL, this)), this.setDefaultFactorType(n.RECOVERY_FACTOR_TYPE_EMAIL))), c;
          },
          initialize: function initialize() {
            this.listenTo(this.state, "contactSupport", function () {
              this.add(a, ".o-form-error-container");
            }), this.listenTo(this, "save", function () {
              this.options.appState.set("username", this.model.get("username")), this.model.save();
            });
          },
          setDefaultFactorType: function setDefaultFactorType(t) {
            u.isEmpty(this.model.get("factorType")) && this.model.set("factorType", t);
          },
          createRecoveryFactorButton: function createRecoveryFactorButton(e, n, i, o) {
            return r.Button({
              attributes: {
                "data-se": e
              },
              className: "button button-primary button-wide " + e,
              title: t.loc(n, "login"),
              click: function click() {
                o.clearErrors(), this.model.isValid() && (this.model.set("factorType", i), o.trigger("save", this.model));
              }
            });
          }
        },
        Footer: c,
        initialize: function initialize() {
          this.options.appState.unset("username");
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(4), n(6), n(51), n(14)], void 0 !== (i = function (t, e, n, r, i, o) {
      var a = t._;
      return e.extend({
        className: "recovery-challenge",
        Model: {
          props: {
            passCode: ["string", !0]
          },
          local: {
            ableToResend: "boolean"
          },
          resendCode: function resendCode() {
            return this.limitResending(), this.doTransaction(function (t) {
              return t.resend();
            });
          },
          limitResending: function limitResending() {
            this.set({
              ableToResend: !1
            }), a.delay(a.bind(this.set, this), r.API_RATE_LIMIT, {
              ableToResend: !0
            });
          },
          save: function save() {
            return this.doTransaction(function (t) {
              return t.verify({
                passCode: this.get("passCode")
              });
            });
          }
        },
        Form: {
          autoSave: !0,
          save: a.partial(t.loc, "mfa.challenge.verify", "login"),
          title: function title() {
            return this.options.appState.get("factorType") === r.RECOVERY_FACTOR_TYPE_CALL ? t.loc("recoveryChallenge.call.title", "login") : t.loc("recoveryChallenge.sms.title", "login");
          },
          className: "recovery-challenge",
          initialize: function initialize() {
            this.listenTo(this.model, "error", function () {
              this.clearErrors();
            });
          },
          formChildren: function formChildren() {
            return [n.Button({
              title: t.loc("mfa.resendCode", "login"),
              attributes: {
                "data-se": "resend-button"
              },
              className: "button sms-request-button margin-top-30",
              click: function click() {
                this.model.resendCode();
              },
              initialize: function initialize() {
                this.listenTo(this.model, "change:ableToResend", function (e, n) {
                  n ? (this.options.title = t.loc("mfa.resendCode", "login"), this.enable(), this.render()) : (this.options.title = t.loc("mfa.sent", "login"), this.disable(), this.render());
                });
              }
            }), n.Input({
              label: t.loc("mfa.challenge.enterCode.placeholder", "login"),
              "label-top": !0,
              className: "enroll-sms-phone",
              name: "passCode",
              input: o,
              type: "text"
            })];
          }
        },
        events: {
          "click .send-email-link": function clickSendEmailLink(t) {
            t.preventDefault();
            var e = this.model.settings,
              n = this.options.appState.get("username"),
              i = this.options.appState.get("recoveryType");
            this.model.startTransaction(function (t) {
              switch (i) {
                case r.RECOVERY_TYPE_PASSWORD:
                  return t.forgotPassword({
                    username: e.transformUsername(n, r.FORGOT_PASSWORD),
                    factorType: r.RECOVERY_FACTOR_TYPE_EMAIL
                  });
                case r.RECOVERY_TYPE_UNLOCK:
                  return t.unlockAccount({
                    username: e.transformUsername(n, r.UNLOCK_ACCOUNT),
                    factorType: r.RECOVERY_FACTOR_TYPE_EMAIL
                  });
                default:
                  return;
              }
            });
          }
        },
        initialize: function initialize() {
          var e,
            n = this.options.appState.get("recoveryType");
          switch (n) {
            case r.RECOVERY_TYPE_PASSWORD:
              e = '          <a href="#" class="link send-email-link" data-se="send-email-link">            {{i18n code="password.forgot.code.notReceived" bundle="login"}}          </a>';
              break;
            case r.RECOVERY_TYPE_UNLOCK:
              e = '          <a href="#" class="link send-email-link" data-se="send-email-link">            {{i18n code="account.unlock.code.notReceived" bundle="login"}}          </a>';
          }
          e && this.settings.get("features.emailRecovery") && this.add(e), this.settings.get("features.hideBackToSignInForReset") || this.add(new i(a.extend(this.toJSON(), {
            linkText: t.loc("goback", "login"),
            linkClassName: ""
          })));
        },
        postRender: function postRender() {
          this.model.limitResending();
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(6), n(2), n(4)], void 0 !== (i = function (t, e, n, r) {
      var i = t._;
      return n.extend({
        className: "password-reset-email-sent",
        Model: function Model() {
          return {
            local: {
              userFullName: ["string", !1, this.options.appState.get("userFullName")]
            }
          };
        },
        Form: {
          title: i.partial(t.loc, "password.forgot.emailSent.title", "login"),
          subtitle: function subtitle() {
            var e = this.options.appState.get("username");
            return t.loc("password.forgot.emailSent.desc", "login", [e]);
          },
          noButtonBar: !0,
          attributes: {
            "data-se": "pwd-reset-email-sent"
          },
          formChildren: function formChildren() {
            var n = [r.View({
              View: t.View.extend({
                template: '              <span class="accessibility-text" role="status">{{alert}}</span>              ',
                getTemplateData: function getTemplateData() {
                  return {
                    alert: t.loc("password.forgot.emailSent.title", "login")
                  };
                }
              })
            })];
            return this.settings.get("features.hideBackToSignInForReset") || n.push(r.Button({
              title: t.loc("goback", "login"),
              className: "button button-primary button-wide",
              attributes: {
                "data-se": "back-button"
              },
              click: function click() {
                var t = this;
                return this.model.doTransaction(function (t) {
                  return t.cancel();
                }).then(function () {
                  t.state.set("navigateDir", e.DIRECTION_BACK), t.options.appState.trigger("navigate", "");
                });
              }
            })), n;
          }
        },
        initialize: function initialize(t) {
          this.settings.callGlobalSuccess(e.FORGOT_PASSWORD_EMAIL_SENT, {
            username: t.appState.get("username")
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(4), n(51), n(14)], void 0 !== (i = function (t, e, n, r, i) {
      return e.extend({
        className: "recovery-question",
        Model: {
          props: {
            answer: ["string", !0],
            showAnswer: "boolean"
          },
          save: function save() {
            return this.doTransaction(function (t) {
              return t.answer({
                answer: this.get("answer")
              });
            });
          }
        },
        Form: {
          autoSave: !0,
          save: function save() {
            switch (this.options.appState.get("recoveryType")) {
              case "PASSWORD":
                return t.loc("password.forgot.question.submit", "login");
              case "UNLOCK":
                return t.loc("account.unlock.question.submit", "login");
              default:
                return t.loc("mfa.challenge.verify", "login");
            }
          },
          title: function title() {
            switch (this.options.appState.get("recoveryType")) {
              case "PASSWORD":
                return t.loc("password.forgot.question.title", "login");
              case "UNLOCK":
                return t.loc("account.unlock.question.title", "login");
              default:
                return "";
            }
          },
          formChildren: function formChildren() {
            return [n.Input({
              label: this.options.appState.get("recoveryQuestion"),
              placeholder: t.loc("mfa.challenge.answer.placeholder", "login"),
              name: "answer",
              input: i,
              type: "password",
              initialize: function initialize() {
                this.listenTo(this.model, "change:showAnswer", function () {
                  var t = this.model.get("showAnswer") ? "text" : "password";
                  this.getInputs()[0].changeType(t);
                });
              }
            }), n.Input({
              label: !1,
              "label-top": !0,
              placeholder: t.loc("mfa.challenge.answer.showAnswer", "login"),
              className: "recovery-question-show margin-btm-0",
              name: "showAnswer",
              type: "checkbox"
            })];
          }
        },
        initialize: function initialize() {
          this.settings.get("features.hideBackToSignInForReset") || this.addFooter(r, {
            linkText: t.loc("goback", "login"),
            linkClassName: ""
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(4), n(98), n(18), n(13), n(51), n(14)], void 0 !== (i = function (t, e, n, r, i, o, a, s) {
      var u = t._;
      return e.extend({
        className: "password-reset",
        Model: {
          props: {
            newPassword: ["string", !0],
            confirmPassword: ["string", !0]
          },
          validate: function validate() {
            return r.validatePasswordMatch(this);
          },
          save: function save() {
            this.trigger("save");
            var t = this;
            return this.doTransaction(function (e) {
              return e.resetPassword({
                newPassword: t.get("newPassword")
              });
            });
          }
        },
        Form: {
          save: u.partial(t.loc, "password.reset", "login"),
          title: function title() {
            return this.settings.get("brandName") ? t.loc("password.reset.title.specific", "login", [this.settings.get("brandName")]) : t.loc("password.reset.title.generic", "login");
          },
          subtitle: function subtitle() {
            var t = this.options.appState.get("policy");
            if (t) return i.getPasswordComplexityDescription(t);
          },
          formChildren: function formChildren() {
            return [n.Input({
              className: "margin-btm-5",
              label: t.loc("password.newPassword.placeholder", "login"),
              "label-top": !0,
              explain: o.createInputExplain("password.newPassword.tooltip", "password.newPassword.placeholder", "login"),
              "explain-top": !0,
              name: "newPassword",
              input: s,
              type: "password"
            }), n.Input({
              label: t.loc("password.confirmPassword.placeholder", "login"),
              "label-top": !0,
              explain: o.createInputExplain("password.confirmPassword.tooltip", "password.confirmPassword.placeholder", "login"),
              "explain-top": !0,
              name: "confirmPassword",
              input: s,
              type: "password"
            })];
          }
        },
        initialize: function initialize() {
          this.listenTo(this.form, "save", function () {
            var t = {
              username: this.options.appState.get("userEmail"),
              password: this.model.get("newPassword")
            };
            this.settings.processCreds(t).then(u.bind(this.model.save, this.model));
          }), this.settings.get("features.hideBackToSignInForReset") || this.addFooter(a);
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2)], void 0 !== (i = function (t, e) {
      return e.extend({
        className: "recovery-loading",
        Model: {},
        Form: {
          noButtonBar: !0
        },
        initialize: function initialize(t) {
          var e = this;
          return this.model.startTransaction(function (e) {
            return e.verifyRecoveryToken({
              recoveryToken: t.token
            });
          }).fail(function () {
            e.options.appState.trigger("loading", !1), e.options.appState.trigger("removeLoading");
          });
        },
        preRender: function preRender() {
          this.options.appState.trigger("loading", !0);
        },
        trapAuthResponse: function trapAuthResponse() {
          return this.options.appState.trigger("loading", !1), !1;
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(6), n(4), n(13), n(98), n(263), n(14)], void 0 !== (i = function (t, e, n, r, i, o, a, s) {
      var u = t._,
        c = t.View.extend({
          template: '      <a href="#" class="link help js-back" data-se="back-link">        {{i18n code="goback" bundle="login"}}      </a>      {{#if helpSupportNumber}}      <a href="#" class="link goto js-contact-support">        {{i18n code="mfa.noAccessToEmail" bundle="login"}}      </a>      {{/if}}    ',
          className: "auth-footer",
          events: {
            "click .js-back": function clickJsBack(t) {
              t.preventDefault(), this.back();
            },
            "click .js-contact-support": function clickJsContactSupport(t) {
              t.preventDefault(), this.state.trigger("contactSupport"), this.$(".js-contact-support").hide();
            }
          },
          getTemplateData: function getTemplateData() {
            return this.settings.pick("helpSupportNumber");
          },
          back: function back() {
            this.state.set("navigateDir", n.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
          }
        });
      return e.extend({
        className: "account-unlock",
        Model: {
          props: {
            username: ["string", !0],
            factorType: ["string", !0]
          },
          validate: function validate() {
            return o.validateUsername(this);
          },
          save: function save() {
            var t = this;
            return this.startTransaction(function (e) {
              return e.unlockAccount({
                username: t.settings.transformUsername(t.get("username"), n.UNLOCK_ACCOUNT),
                factorType: t.get("factorType")
              });
            }).fail(function () {});
          }
        },
        Form: {
          noButtonBar: !0,
          title: u.partial(t.loc, "account.unlock.title", "login"),
          formChildren: function formChildren() {
            var e = this.settings.get("features.smsRecovery"),
              o = this.settings.get("features.callRecovery"),
              a = this.settings.get("features.emailRecovery"),
              u = !(e || o || a),
              c = [],
              l = this;
            return u ? this.add('<div class="okta-form-infobox-error infobox infobox-error" role="alert">    <span class="icon error-16"></span>    <p>{{i18n code="account.unlock.noFactorsEnabled" bundle="login"}}</p>  </div>', ".o-form-error-container") : (c.push(r.Input({
              label: t.loc("account.unlock.email.or.username.placeholder", "login"),
              "label-top": !0,
              explain: i.createInputExplain("account.unlock.email.or.username.tooltip", "account.unlock.email.or.username.placeholder", "login"),
              "explain-top": !0,
              name: "username",
              input: s,
              inputId: "account-recovery-username",
              type: "text",
              inlineValidation: !1
            })), (e || o) && c.push(r.View({
              View: t.View.extend({
                template: '                  <p class="mobile-recovery-hint">                    {{i18n code="recovery.mobile.hint" bundle="login" arguments="mobileFactors"}}                  </p>',
                getTemplateData: function getTemplateData() {
                  var n;
                  return n = e && o ? t.loc("recovery.smsOrCall") : o ? t.loc("recovery.call") : t.loc("recovery.sms"), {
                    mobileFactors: n
                  };
                }
              })
            })), e && (this.$el.addClass("forgot-password-sms-enabled"), c.push(this.createRecoveryFactorButton("sms-button", "account.unlock.sendText", n.RECOVERY_FACTOR_TYPE_SMS, l)), this.setDefaultFactorType(n.RECOVERY_FACTOR_TYPE_SMS)), o && (this.$el.addClass("forgot-password-call-enabled"), c.push(this.createRecoveryFactorButton("call-button", "account.unlock.voiceCall", n.RECOVERY_FACTOR_TYPE_CALL, l)), this.setDefaultFactorType(n.RECOVERY_FACTOR_TYPE_CALL)), a && (this.$el.addClass("forgot-password-email-enabled"), c.push(this.createRecoveryFactorButton("email-button", "account.unlock.sendEmail", n.RECOVERY_FACTOR_TYPE_EMAIL, l)), this.setDefaultFactorType(n.RECOVERY_FACTOR_TYPE_EMAIL))), c;
          },
          initialize: function initialize() {
            this.listenTo(this, "save", function () {
              this.options.appState.set("username", this.model.get("username")), this.model.save();
            }), this.listenTo(this.state, "contactSupport", function () {
              this.add(a, ".o-form-error-container");
            });
          },
          setDefaultFactorType: function setDefaultFactorType(t) {
            u.isEmpty(this.model.get("factorType")) && this.model.set("factorType", t);
          },
          createRecoveryFactorButton: function createRecoveryFactorButton(e, n, i, o) {
            return r.Button({
              attributes: {
                "data-se": e
              },
              className: "button button-primary button-wide " + e,
              title: t.loc(n, "login"),
              click: function click() {
                o.clearErrors(), this.model.isValid() && (this.model.set("factorType", i), o.trigger("save", this.model));
              }
            });
          }
        },
        Footer: c
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(6), n(2), n(4)], void 0 !== (i = function (t, e, n, r) {
      var i = t._;
      return n.extend({
        className: "account-unlocked",
        Model: function Model() {
          return {
            local: {
              userFullName: ["string", !1, this.options.appState.get("userFullName")]
            }
          };
        },
        Form: {
          title: i.partial(t.loc, "account.unlock.unlocked.title", "login"),
          subtitle: i.partial(t.loc, "account.unlock.unlocked.desc", "login"),
          noButtonBar: !0,
          attributes: {
            "data-se": "account-unlocked"
          },
          formChildren: function formChildren() {
            return [r.Button({
              title: t.loc("goback", "login"),
              className: "button button-primary button-wide",
              attributes: {
                "data-se": "back-button"
              },
              click: function click() {
                this.state.set("navigateDir", e.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
              }
            })];
          }
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(6), n(2), n(4)], void 0 !== (i = function (t, e, n, r) {
      var i = t._;
      return n.extend({
        className: "account-unlock-email-sent",
        Model: function Model() {
          return {
            local: {
              userFullName: ["string", !1, this.options.appState.get("userFullName")]
            }
          };
        },
        Form: {
          title: i.partial(t.loc, "account.unlock.emailSent.title", "login"),
          subtitle: function subtitle() {
            var e = this.options.appState.get("username");
            return t.loc("account.unlock.emailSent.desc", "login", [e]);
          },
          noButtonBar: !0,
          attributes: {
            "data-se": "unlock-email-sent"
          },
          formChildren: function formChildren() {
            return [r.Button({
              title: t.loc("goback", "login"),
              className: "button button-primary button-wide",
              attributes: {
                "data-se": "back-button"
              },
              click: function click() {
                this.state.set("navigateDir", e.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
              }
            })];
          }
        },
        initialize: function initialize(t) {
          this.settings.callGlobalSuccess(e.UNLOCK_ACCOUNT_EMAIL_SENT, {
            username: t.appState.get("username")
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(17), n(0), n(2)], void 0 !== (i = function (t, e, n) {
      return n.extend({
        className: "refresh-auth-state",
        Model: {},
        Form: {
          noButtonBar: !0
        },
        preRender: function preRender() {
          var e = this.options.appState,
            n = this.options.token;
          this.model.startTransaction(function (r) {
            if (e.trigger("loading", !0), this.options.appState.get("introspectSuccess") || this.options.appState.get("introspectError")) {
              this.settings.unset("stateToken");
              var i = this.options.appState.get("introspectSuccess"),
                o = this.options.appState.get("introspectError");
              return i && i.data ? t.resolve(i) : t.reject(o);
            }
            return n ? r.tx.resume({
              stateToken: n
            }) : r.tx.exists() ? r.tx.resume() : void e.trigger("navigate", "");
          });
        },
        remove: function remove() {
          return this.options.appState.trigger("loading", !1), n.prototype.remove.apply(this, arguments);
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(631), n(632), n(83), n(6), n(264), n(633), n(33), n(13)], void 0 !== (i = function (t, e, n, r, i, o, a, s, u) {
      var c = t._,
        l = t.Backbone,
        f = t.View.extend({
          template: '      <a href="#" class="link help" data-se="back-link">        {{i18n code="goback" bundle="login"}}      </a>    ',
          className: "auth-footer",
          events: {
            "click .help": function clickHelp(t) {
              t.preventDefault(), this.back();
            }
          },
          back: function back() {
            this.state.set("navigateDir", i.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
          }
        });
      return r.extend({
        className: "registration",
        initialize: function initialize() {
          var t = e.extend({
              settings: this.options.settings,
              url: this.options.settings.get("baseUrl") + "/api/v1/registration/form"
            }),
            n = new t();
          this.state.set("schema", n);
        },
        getRegistrationApiUrl: function getRegistrationApiUrl() {
          var t = this.settings.get("defaultPolicyId"),
            e = this.options.settings.get("policyId");
          return t ? this.getRegistrationPolicyApi(t) : this.getRegistrationPolicyApi(e);
        },
        getRegistrationPolicyApi: function getRegistrationPolicyApi(t) {
          return this.options.settings.get("baseUrl") + "/api/v1/registration/" + t;
        },
        doPostSubmit: function doPostSubmit() {
          if (this.model.get("activationToken")) {
            var t = this;
            t.settings.callGlobalSuccess(i.REGISTRATION_COMPLETE, {
              activationToken: this.model.get("activationToken")
            });
            new n({
              settings: t.model.appState.settings
            }).loginWithActivationToken(this.model.get("activationToken")).then(function (e) {
              t.model.trigger("setTransaction", e);
            });
          } else this.model.appState.set("username", this.model.get("email")), this.model.appState.trigger("navigate", "signin/register-complete");
        },
        registerUser: function registerUser(t) {
          var e = this;
          this.model.attributes = t, l.Model.prototype.save.call(this.model).then(function () {
            var t = e.model.get("activationToken"),
              n = t || e.model.get("email");
            e.settings.postSubmit(n, function () {
              e.doPostSubmit();
            }, function (t) {
              e.showErrors(t);
            });
          }).fail(function (t) {
            var n = t.responseJSON;
            if (n && n.errorCauses.length) {
              var r = n.errorCauses[0].errorSummary;
              u.triggerAfterError(e, new s.RegistrationError(r));
            }
          });
        },
        createRegistrationModel: function createRegistrationModel(e) {
          var n = this;
          return new (t.Model.extend({
            url: n.getRegistrationApiUrl() + "/register",
            settings: this.settings,
            appState: this.options.appState,
            props: e,
            local: {
              activationToken: "string"
            },
            toJSON: function toJSON() {
              return {
                userProfile: t.Model.prototype.toJSON.apply(this, arguments),
                relayState: this.settings.get("relayState")
              };
            },
            parse: function parse(t) {
              return this.set("activationToken", t.activationToken), delete t.activationToken, t;
            },
            save: function save() {
              this.settings.preSubmit(this.attributes, function (t) {
                n.registerUser(t);
              }, function (t) {
                n.showErrors(t);
              });
            }
          }))();
        },
        showErrors: function showErrors(t, e) {
          "parseSchema" === t.callback && t.errorCauses && (t.errorSummary = c.clone(t.errorCauses[0].errorSummary), delete t.errorCauses), this.model.trigger("error", this.model, {
            responseJSON: t
          });
          var n = t.callback ? t.callback + ":" + t.errorSummary : t.errorSummary;
          u.triggerAfterError(this, new s.RegistrationError(n)), e && this.$el.find(".button-primary").hide();
        },
        fetchInitialData: function fetchInitialData() {
          var e = this;
          return e.state.get("schema").on("parseComplete", function (n) {
            var r = n.properties.createModelProperties();
            e.settings.set("defaultPolicyId", n.properties.defaultPolicyId), e.model = e.createRegistrationModel(r);
            var i = t.Form.extend({
                layout: "o-form-theme",
                autoSave: !0,
                noCancelButton: !0,
                title: t.loc("registration.form.title", "login"),
                save: t.loc("registration.form.submit", "login")
              }),
              s = new i(e.toJSON());
            if (e.add(s), e.footer = new e.Footer(e.toJSON()), e.add(e.footer), e.addListeners(), n.error) e.showErrors(n.error, !0);else {
              n.properties.each(function (t) {
                var e = o.createInputOptions(t),
                  n = t.get("subSchemas"),
                  r = t.get("name");
                s.addInput(e), "password" === r && n && s.add(a.extend({
                  id: "subschemas-" + r,
                  subSchemas: n
                }));
              });
              var u = t.tpl('<span class="required-fields-label">{{label}}</span>')({
                label: t.loc("registration.required.fields.label", "login")
              });
              s.add(u);
            }
          }), this.state.get("schema").fetch();
        },
        Footer: f
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      var e = t._,
        n = t.internal.models,
        r = n.BaseSchema,
        i = n.SchemaProperty,
        o = i.Collection.extend({
          createModelProperties: function createModelProperties() {
            var t = i.Collection.prototype.createModelProperties.apply(this);
            return e.each(t, function (t, e) {
              t.required = !!this.get(e).get("required");
            }, this), t;
          }
        });
      return r.Model.extend({
        expand: ["schema"],
        constructor: function constructor() {
          this.properties = new o(), t.BaseModel.apply(this, arguments);
        },
        parse: function parse(t) {
          var n = e.bind(function (t) {
              var n = t.schema.required;
              e.isArray(n) && e.each(n, function (t) {
                var e = this.properties.get(t);
                e && e.set("required", !0);
              }, this);
              var r = t.schema.fieldOrder;
              return e.isArray(r) && (e.each(r, function (t, e) {
                var n = this.properties.get(t);
                n && n.set("sortOrder", e);
              }, this), this.properties.comparator = "sortOrder", this.properties.sort()), this.properties.defaultPolicyId = t.policyId, t;
            }, this),
            i = this;
          this.settings.parseSchema(t, function (t) {
            t.profileSchema && (t.schema = t.profileSchema, r.Model.prototype.parse.apply(i, [t]), t = n(t)), i.trigger("parseComplete", {
              properties: i.properties
            });
          }, function (t) {
            i.trigger("parseComplete", {
              properties: i.properties,
              error: t
            });
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(96)], void 0 !== (i = function (t, e) {
      return e.extend({
        constructor: function constructor(e) {
          this.settings = e && e.settings, t.Model.apply(this, arguments);
        },
        loginWithActivationToken: function loginWithActivationToken(t) {
          return this.startTransaction(function (e) {
            return e.signIn({
              token: t
            });
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      var e = t.View.extend({
        index: "",
        message: "",
        class: function _class() {},
        className: function className() {
          return "subschema-unsatisfied subschema-" + this.index;
        },
        template: '      <p class="default-schema">        <span class="icon icon-16"/>        {{message}}      </p>    ',
        getTemplateData: function getTemplateData() {
          return {
            message: this.message
          };
        }
      });
      return t.View.extend({
        className: "subschema",
        children: function children() {
          return this.subSchemas.map(function (t, n) {
            var r = t.get("description"),
              i = r;
            return e.extend({
              index: n,
              message: i
            });
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(6), n(2), n(4)], void 0 !== (i = function (t, e, n, r) {
      return n.extend({
        events: {
          "click .back-btn": function clickBackBtn(t) {
            t.preventDefault(), this.back();
          }
        },
        back: function back() {
          this.state.set("navigateDir", e.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
        },
        className: "registration-complete",
        Model: function Model() {},
        initialize: function initialize() {
          this.settings.callGlobalSuccess(e.ACTIVATION_EMAIL_SENT, {
            username: this.options.appState.get("username")
          });
        },
        Form: {
          noButtonBar: !0,
          formChildren: function formChildren() {
            return [r.View({
              View: t.View.extend({
                template: '              <div class="container">              <span class="title-icon icon icon-16 confirm-16-green"></span>              <h2 class="title">{{title}}</h2>              <div class="desc">{{desc}}</div>              </div>              <a href="#" class="back-btn" data-se="back-link">                {{i18n code="goback" bundle="login"}}              </a>              ',
                getTemplateData: function getTemplateData() {
                  return {
                    desc: t.loc("registration.complete.confirm.text", "login"),
                    title: t.loc("registration.complete.title", "login")
                  };
                }
              })
            })];
          }
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2), n(4), n(636)], void 0 !== (i = function (t, e, n, r) {
      var i = t._;
      return e.extend({
        className: "consent-required",
        initialize: function initialize() {
          this.model.set("expiresAt", this.options.appState.get("expiresAt")), this.model.set("scopes", this.options.appState.get("scopes")), this.listenTo(this.form, "cancel", i.bind(this.model.cancel, this.model));
        },
        postRender: function postRender() {
          e.prototype.postRender.apply(this, arguments), this.$(".o-form-button-bar .button-primary").removeClass("button-primary");
        },
        Model: {
          props: {
            expiresAt: ["string", !0],
            scopes: ["array", !0]
          },
          save: function save() {
            return this.doTransaction(function (t) {
              return t.consent({
                consent: {
                  expiresAt: this.get("expiresAt"),
                  scopes: i.pluck(this.get("scopes"), "name")
                }
              });
            });
          },
          cancel: function cancel() {
            var t = this;
            return this.doTransaction(function (t) {
              return t.cancel();
            }).then(function () {
              var e = t.settings.get("consent.cancel");
              i.isFunction(e) && e();
            });
          }
        },
        Form: {
          noCancelButton: !1,
          autoSave: !0,
          save: i.partial(t.loc, "consent.required.consentButton", "login"),
          cancel: i.partial(t.loc, "consent.required.cancelButton", "login"),
          formChildren: function formChildren() {
            return [n.View({
              View: t.View.extend({
                className: "consent-title detail-row",
                template: '                {{#if clientURI}}                  <a href="{{clientURI}}" class="client-logo-link" target="_blank">                {{/if}}                {{#if customLogo}}                  <img class="client-logo custom-logo" src="{{customLogo}}" />                {{else}}                  <img class="client-logo default-logo" src="{{defaultLogo}}" />                {{/if}}                {{#if clientURI}}                  </a>                {{/if}}                <span>{{{i18n code="consent.required.text" bundle="login" arguments="appName"}}}</span>              ',
                getTemplateData: function getTemplateData() {
                  var t = this.options.appState;
                  return {
                    appName: t.escape("targetLabel"),
                    customLogo: t.get("targetLogo") && t.get("targetLogo").href,
                    defaultLogo: t.get("defaultAppLogo"),
                    clientURI: t.get("targetClientURI") && t.get("targetClientURI").href
                  };
                }
              })
            }), n.View({
              View: new r({
                model: this.model
              })
            }), n.View({
              View: t.View.extend({
                className: "consent-description detail-row",
                template: '                <p>{{i18n code="consent.required.description" bundle="login"}}</p>              '
              })
            })];
          }
        },
        Footer: t.View.extend({
          className: "consent-footer",
          template: '        {{#if termsOfService}}          <a class="terms-of-service" href="{{termsOfService}}" target="_blank">{{i18n code="consent.required.termsOfService" bundle="login"}}</a>          {{#if privacyPolicy}}            &#8226          {{/if}}        {{/if}}        {{#if privacyPolicy}}          <a class="privacy-policy" href="{{privacyPolicy}}" target="_blank">{{i18n code="consent.required.privacyPolicy" bundle="login"}}</a>        {{/if}}      ',
          getTemplateData: function getTemplateData() {
            var t = this.options.appState;
            return {
              termsOfService: t.get("targetTermsOfService") && t.get("targetTermsOfService").href,
              privacyPolicy: t.get("targetPrivacyPolicy") && t.get("targetPrivacyPolicy").href
            };
          }
        })
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(637)], void 0 !== (i = function (t, e) {
      return t.View.extend({
        className: "scope-list detail-row",
        postRender: function postRender() {
          var t = this;
          this.model.get("scopes").forEach(function (n) {
            t.add(e, {
              options: {
                name: n.displayName || n.name,
                description: n.description
              }
            });
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(168)], void 0 !== (i = function (t) {
      return t.View.extend({
        className: "scope-item",
        template: '      <div class="scope-item-text">        <p>{{name}}</p>      </div>      {{#if description}}        <span class="scope-item-tooltip icon form-help-16" />      {{/if}}    ',
        postRender: function postRender() {
          this.$(".scope-item-tooltip").qtip({
            content: {
              text: this.options.description
            },
            style: {
              classes: "okta-sign-in-tooltip qtip-custom qtip-shadow"
            },
            position: {
              my: "bottom right",
              target: "mouse"
            }
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(639), n(83), n(640), n(178)], void 0 !== (i = function (t, e, n, r, i) {
      return n.extend({
        className: "enroll-user",
        initialize: function initialize(t) {
          this.options = t || {}, this.model = new e(this.options);
        },
        fetchInitialData: function fetchInitialData() {
          return this.options.appState.get("isUnauthenticated") ? this.model.getEnrollFormData() : n.prototype.fetchInitialData.call();
        },
        trapAuthResponse: function trapAuthResponse() {
          if (this.options.appState.get("isProfileRequired")) return !0;
        },
        postRender: function postRender() {
          var t = new r(this.toJSON());
          this.add(t), this.add(new i(this.toJSON())), this.addListeners();
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(96)], void 0 !== (i = function (t, e) {
      var n = t._;
      return e.extend({
        initialize: function initialize(t) {
          this.options = t || {}, this.appState = this.options.appState;
        },
        constructPostData: function constructPostData(t) {
          var e = {
            registration: {
              profile: t
            }
          };
          return this.appState.get("policy").registration.createNewAccount && (e.registration.createNewAccount = !0), e;
        },
        getEnrollFormData: function getEnrollFormData() {
          return this.manageTransaction(function (t, e) {
            return t.enroll().then(function (t) {
              e(t);
            });
          });
        },
        save: function save() {
          var r = e.prototype.toJSON.apply(this, arguments);
          if (r = n.omit(r, ["appState", "settings", "createNewAccount"]), !n.isEmpty(r)) return this.manageTransaction(function (t, e) {
            t.enroll(this.constructPostData(r)).then(function (t) {
              e(t);
            });
          });
          var i = {
            errorSummary: t.loc("oform.errorbanner.title", "login")
          };
          this.trigger("error", this, {
            responseJSON: i
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(264), n(641)], void 0 !== (i = function (t, e, n) {
      return t.Form.extend({
        layout: "o-form-theme",
        autoSave: !0,
        noCancelButton: !0,
        title: t.loc("registration.form.title", "login"),
        save: t.loc("registration.form.submit", "login"),
        initialize: function initialize(r) {
          var i = this;
          this.options = r || {}, this.schema = new n({
            profileSchemaAttributes: this.options.appState.get("policy").registration.profile
          }), this.schema.properties.each(function (t) {
            var n = e.createInputOptions(t);
            i.addInput(n);
          });
          var o = t.tpl('<span class="required-fields-label">{{label}}</span>')({
            label: t.loc("registration.required.fields.label", "login")
          });
          this.add(o);
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      var e = t._;
      return t.internal.models.BaseSchema.Model.extend({
        expand: ["schema"],
        setFieldPlaceholder: function setFieldPlaceholder(t) {
          return e.each(t, function (t) {
            t.title = t.label;
          }), t;
        },
        initialize: function initialize(t) {
          var e = t.profileSchemaAttributes;
          if (e = this.setFieldPlaceholder(e)) {
            for (var n = {
                properties: {}
              }, r = 0; r < e.length; r++) {
              var i = e[r];
              n.properties[i.name] = i;
            }
            this.parse.apply(this, [{
              schema: n
            }]);
          }
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(17), n(18), n(643), n(122)], void 0 !== (i = function (t, e, n, r, i) {
      return t.View.extend({
        template: '      <div class="beacon-blank auth-beacon">        <div class="beacon-blank js-blank-beacon-border auth-beacon-border"></div>      </div>      <div class="bg-helper auth-beacon auth-beacon-factor {{className}}" data-se="factor-beacon">        <div class="okta-sign-in-beacon-border auth-beacon-border"></div>      </div>      <div data-type="factor-types-dropdown" class="factors-dropdown-wrap"></div>    ',
        events: {
          "click .auth-beacon-factor": function clickAuthBeaconFactor(t) {
            t.preventDefault(), t.stopPropagation();
            var e = this.$(".dropdown .options").toggle().is(":visible");
            this.$("a.option-selected").attr("aria-expanded", e), e && this.$("#okta-dropdown-options").find("li.factor-option:first a").focus();
          }
        },
        initialize: function initialize() {
          this.options.appState.set("beaconType", "factor");
        },
        getTemplateData: function getTemplateData() {
          var t,
            e,
            r = this.options.appState.get("factors");
          return t = r ? n.findFactorInFactorsArray(r, this.options.provider, this.options.factorType) : new i.Model(this.options.appState.get("factor")), e = t.get("iconClassName"), {
            className: e || ""
          };
        },
        postRender: function postRender() {
          this.options.animate && this.$(".auth-beacon-factor").fadeIn(200), this.options.appState.get("hasMultipleFactorsAvailable") && this.add(r, '[data-type="factor-types-dropdown"]');
        },
        fadeOut: function fadeOut() {
          var t = e.defer();
          return this.$(".auth-beacon-factor").fadeOut(200, function () {
            t.resolve();
          }), t.promise;
        },
        equals: function equals(t, e) {
          return t && this instanceof t && e.provider === this.options.provider && (e.factorType === this.options.factorType || n.isOktaVerify(e.provider, e.factorType) && n.isOktaVerify(this.options.provider, this.options.factorType));
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(18), n(122), n(644)], void 0 !== (i = function (t, e, n, r) {
      var i = t._,
        o = t.$,
        a = t.internal.views.components.BaseDropDown;
      return o(document).click(function (t) {
        var e = o(t.target);
        e.closest(".option-selected").length > 0 && e.closest(".dropdown").length > 0 || (o(".dropdown .options").hide(), o(".dropdown a.option-selected").attr("aria-expanded", !1));
      }), a.extend({
        className: "bg-helper icon-button",
        screenReaderText: function screenReaderText() {
          var r,
            i,
            o = this.options.appState.get("factors");
          return r = o ? e.findFactorInFactorsArray(o, this.options.provider, this.options.factorType) : new n.Model(this.options.appState.get("factor"), this.toJSON()), i = r.get("factorLabel"), t.loc("mfa.factors.dropdown.sr.text", "login", [i]);
        },
        events: {
          "click a.option-selected": function clickAOptionSelected(t) {
            if (t.preventDefault(), i.result(this, "disabled")) t.stopPropagation();else {
              var e = this.$(".options").toggle().is(":visible");
              this.$("a.option-selected").attr("aria-expanded", e), e && this.$("#okta-dropdown-options").find("li.factor-option:first a").focus();
            }
          },
          "click .dropdown-disabled": function clickDropdownDisabled(t) {
            t.preventDefault(), t.stopPropagation();
          }
        },
        initialize: function initialize() {
          this.addOption(r.getDropdownOption("TITLE"));
          var t = this.options.appState.get("factors"),
            e = t.hasMultipleFactorsOfSameType("push");
          t.each(function (t) {
            "token:software:totp" === t.get("factorType") && e || (this.addOption(r.getDropdownOption(t.get("factorName")), {
              model: t
            }), this.listenTo(this.last(), "options:toggle", function () {
              this.$(".options").hide(), this.$("a.option-selected").attr("aria-expanded", !1);
            }));
          }, this);
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(24)], void 0 !== (i = function (t, e) {
      var n = t._,
        r = t.tpl("{{factorName}} ({{{deviceName}}})"),
        i = function i(t) {
          var n,
            r = t.get("factorType"),
            i = this.options.appState.get("factors");
          i.hasMultipleFactorsOfSameType(r) && (n = i.getFactorIndex(r, t.get("id")));
          var o = e.createVerifyUrl(t.get("provider"), r, n),
            a = this;
          this.options.appState.trigger("factorSwitched"), this.model.manageTransaction(function (t, e) {
            if ("FACTOR_CHALLENGE" === t.status && this.options.appState.set("trapMfaRequiredResponse", !0), "MFA_CHALLENGE" === t.status && t.prev) return this.options.appState.set("trapMfaRequiredResponse", !0), t.prev().then(function (t) {
              a.trigger("options:toggle"), e(t), a.options.appState.trigger("navigate", o);
            });
            a.trigger("options:toggle"), a.options.appState.trigger("navigate", o);
          });
        },
        o = {
          TITLE: {
            title: n.partial(t.loc, "mfa.factors.dropdown.title", "login"),
            className: "dropdown-list-title",
            disabled: !0
          },
          OKTA_VERIFY: {
            icon: "factor-icon mfa-okta-verify-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          OKTA_VERIFY_PUSH: {
            icon: "factor-icon mfa-okta-verify-30",
            className: "factor-option",
            title: function title() {
              return r({
                factorName: this.model.get("factorLabel"),
                deviceName: this.model.get("deviceName")
              });
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          GOOGLE_AUTH: {
            icon: "factor-icon mfa-google-auth-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          CUSTOM_HOTP: {
            icon: "factor-icon mfa-hotp-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          SYMANTEC_VIP: {
            icon: "factor-icon mfa-symantec-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          RSA_SECURID: {
            icon: "factor-icon mfa-rsa-30",
            className: "factor-option",
            title: n.partial(t.loc, "factor.totpHard.rsaSecurId", "login"),
            action: function action() {
              i.call(this, this.model);
            }
          },
          ON_PREM: {
            icon: "factor-icon mfa-onprem-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          DUO: {
            icon: "factor-icon mfa-duo-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          DUO_PUSH: {
            icon: "duo-push-16",
            className: "suboption factor-option",
            title: n.partial(t.loc, "mfa.duoSecurity.push", "login", ["XXX-XXX-7890"])
          },
          DUO_SMS: {
            icon: "duo-sms-16",
            className: "suboption factor-option",
            title: n.partial(t.loc, "mfa.duoSecurity.sms", "login", ["XXX-XXX-7890"])
          },
          DUO_CALL: {
            icon: "duo-call-16",
            className: "suboption factor-option",
            title: n.partial(t.loc, "mfa.duoSecurity.call", "login", ["XXX-XXX-7890"])
          },
          YUBIKEY: {
            icon: "factor-icon mfa-yubikey-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          SMS: {
            icon: "factor-icon mfa-sms-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          CALL: {
            icon: "factor-icon mfa-call-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          QUESTION: {
            icon: "factor-icon mfa-question-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          PASSWORD: {
            icon: "factor-icon mfa-password-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          WINDOWS_HELLO: {
            icon: "factor-icon mfa-windows-hello-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          U2F: {
            icon: "factor-icon mfa-u2f-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          WEBAUTHN: {
            icon: "factor-icon mfa-webauthn-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          EMAIL: {
            icon: "factor-icon mfa-email-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          GENERIC_SAML: {
            icon: "factor-icon mfa-custom-factor-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          GENERIC_OIDC: {
            icon: "factor-icon mfa-custom-factor-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          },
          CUSTOM_CLAIMS: {
            icon: "factor-icon mfa-custom-factor-30",
            className: "factor-option",
            title: function title() {
              return this.model.get("factorLabel");
            },
            action: function action() {
              i.call(this, this.model);
            }
          }
        };
      return {
        getDropdownOption: function getDropdownOption(t) {
          return o[t];
        }
      };
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0)], void 0 !== (i = function (t) {
      return t.View.extend({
        className: "piv-beacon",
        template: '      <div class="beacon-blank auth-beacon">        <div class="beacon-blank js-blank-beacon-border auth-beacon-border"></div>      </div>      <div class="bg-helper auth-beacon smartcard" data-se="piv-beacon">        <div class="okta-sign-in-beacon-border auth-beacon-border"></div>      </div>    ',
        equals: function equals(t) {
          return t && this instanceof t;
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(2)], void 0 !== (i = function (t, e) {
      return e.extend({
        className: "poll",
        Model: {
          save: function save() {
            var t = this;
            return this.trigger("cancelRequest"), this.appState.get("transaction").cancel().then(function () {
              t.options.appState.trigger("navigate", "");
            }).fail(function () {
              t._stopPolling();
            });
          }
        },
        Form: {
          autoSave: !0,
          hasSavingState: !1,
          title: function title() {
            return this.title;
          },
          className: "poll-controller",
          noCancelButton: !0,
          save: t.loc("oform.cancel", "login"),
          modelEvents: {
            cancelRequest: "_stopPolling"
          },
          _startPolling: function _startPolling() {
            var e = this;
            this.transaction.poll().then(function (n) {
              e.options.appState.set("transaction", n);
              var r = n.factor.profile.refresh,
                i = Math.floor(r / 1e3);
              e.countDown = setInterval(function () {
                var n = t.loc("polling.title", "login", [i]);
                e.$el.find(".okta-form-title").text(n), 1 === i ? (e._stopPolling(), e._startPolling()) : i -= 1;
              }, 1e3);
            }).fail(function () {
              e._stopPolling();
            });
          },
          _stopPolling: function _stopPolling() {
            this.countDown && clearInterval(this.countDown);
          },
          initialize: function initialize(e) {
            this.transaction = e.appState.get("transaction"), this.factorPollingInterval = this.transaction.factor.profile.refresh;
            var n = Math.floor(this.factorPollingInterval / 1e3);
            this.title = t.loc("polling.title", "login", [n]);
          },
          postRender: function postRender() {
            this._startPolling(this.factorPollingInterval);
          }
        },
        back: function back() {}
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    var r, i;
    r = [n(0), n(18), n(2), n(4), n(24), n(182), n(19)], void 0 !== (i = function (t, e, n, r, i, o, a) {
      var s = t._;
      return n.extend({
        className: "barcode-totp",
        Model: function Model() {
          return {
            local: {
              __factorType__: ["string", !1, this.options.factorType],
              __provider__: ["string", !1, this.options.provider]
            }
          };
        },
        Form: {
          title: function title() {
            var n = e.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
            return t.loc("enroll.totp.title", "login", [n]);
          },
          subtitle: s.partial(t.loc, "mfa.scanBarcode", "login"),
          save: s.partial(t.loc, "oform.next", "login"),
          noCancelButton: !0,
          attributes: {
            "data-se": "step-scan"
          },
          className: "barcode-scan",
          formChildren: [r.View({
            View: o
          })]
        },
        Footer: a,
        initialize: function initialize() {
          this.listenTo(this.form, "save", function () {
            var t = i.createActivateFactorUrl(this.model.get("__provider__"), this.model.get("__factorType__"), "activate");
            this.options.appState.trigger("navigate", t);
          });
        }
      });
    }.apply(e, r)) && (t.exports = i);
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    var i = n(649),
      o = r(i),
      a = n(669),
      s = r(a);
    t.exports = s.default.extend({
      routes: {
        "": "defaultAuth",
        "*wildcard": "defaultAuth"
      },
      defaultAuth: function defaultAuth() {
        this.render(o.default);
      }
    });
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(0);
    n(178);
    var i = n(650),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(i);
    e.default = r.Controller.extend({
      className: "form-controller",
      initialize: function initialize() {
        r.Controller.prototype.initialize.call(this), this.listenTo(this.options.appState, "idxResponseUpdated", this.render), this.listenTo(this.options.appState, "invokeAction", this.invokeAction), this.listenTo(this.options.appState, "switchForm", this.switchForm), this.listenTo(this.options.appState, "saveForm", this.handleFormSave);
      },
      preRender: function preRender() {
        this.removeChildren();
      },
      postRender: function postRender() {
        var t = this.options.appState.getCurrentViewState(),
          e = o.default.create(t.name, this.options.appState.get("factorType"), this.options.appState.get("currentStep"));
        this.formView = this.add(e, {
          options: {
            currentViewState: t,
            messages: this.options.appState.get("messages")
          }
        }).last(), this.listenTo(this.formView, "save", this.handleFormSave);
      },
      invokeAction: function invokeAction() {
        var t = this,
          e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          n = this.options.appState.get("idx");
        if (n.neededToProceed[e]) return void n.proceed(e, {}).then(function (e) {
          t.options.appState.set("idx", e), t.options.appState.trigger("remediationSuccess", e.rawIdxState);
        }).catch(function (t) {
          throw t;
        });
        var i = n.actions[e];
        if (!r._.isFunction(i)) throw "Invalid action selected";
        i().then(function (e) {
          t.options.appState.set("idx", e), t.options.appState.trigger("remediationSuccess", e.rawIdxState);
        }).catch(function (t) {
          throw t;
        });
      },
      switchForm: function switchForm(t) {
        this.options.appState.set("currentFormName", t), this.options.appState.trigger("idxResponseUpdated", t);
      },
      handleFormSave: function handleFormSave(t) {
        var e = this,
          n = t.get("formName"),
          r = this.options.appState.get("idx");
        return r.neededToProceed[n] ? (this.toggleFormButtonState(!0), t.trigger("request"), r.proceed(n, t.toJSON()).then(function (t) {
          return e.updateAppStateWithNewIdx(t);
        }).catch(function (n) {
          n.proceed && n.rawIdxState ? e.updateAppStateWithNewIdx(n) : (t.trigger("error", t, {
            responseJSON: n
          }, !0), e.toggleFormButtonState(!1));
        })) : void t.trigger("error", 'Cannot find http action for "' + n + '".');
      },
      updateAppStateWithNewIdx: function updateAppStateWithNewIdx(t) {
        this.options.appState.set("idx", t), this.options.appState.trigger("remediationSuccess", t.rawIdxState);
      },
      toggleFormButtonState: function toggleFormButtonState(t) {
        this.$el.find(".o-form-button-bar .button").toggleClass("link-button-disabled", t);
      }
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    var i,
      o,
      a = n(177),
      s = r(a),
      u = n(57),
      c = r(u),
      l = n(40),
      f = r(l),
      p = n(655),
      d = r(p),
      h = n(656),
      m = r(h),
      g = n(657),
      v = r(g),
      y = n(658),
      _ = r(y),
      b = n(659),
      w = r(b),
      S = n(660),
      x = r(S),
      E = n(269),
      T = r(E),
      k = n(661),
      A = r(k),
      O = n(662),
      C = r(O),
      I = n(664),
      R = r(I),
      P = n(665),
      N = r(P),
      M = n(666),
      L = r(M),
      F = n(667),
      D = r(F),
      j = n(668),
      U = r(j),
      B = {
        identify: (0, s.default)({}, "_", d.default),
        "device-challenge-poll": (0, s.default)({}, "_", m.default),
        "device-apple-sso-extension": (0, s.default)({}, "_", v.default),
        "cancel-transaction": (0, s.default)({}, "_", v.default),
        "select-factor": {
          authenticate: w.default,
          enroll: _.default
        },
        "select-factor-authenticate": (0, s.default)({}, "_", w.default),
        "select-factor-enroll": (0, s.default)({}, "_", _.default),
        "enroll-profile": (0, s.default)({}, "_", x.default),
        "enroll-factor": {
          email: L.default,
          password: C.default
        },
        "challenge-factor": {
          email: L.default,
          password: R.default,
          webauthn: N.default
        },
        "terminal-transferred": (i = {}, (0, s.default)(i, "_", T.default), (0, s.default)(i, "email", U.default), i),
        "terminal-return": (o = {}, (0, s.default)(o, "_", T.default), (0, s.default)(o, "email", D.default), o),
        "success-redirect": (0, s.default)({}, "_", A.default)
      };
    t.exports = {
      create: function create(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "_",
          n = arguments[2],
          r = B[t];
        if (!r) return c.default.warn("Cannot find customized View (form: " + t + "). Fallback to default configuration."), 0 === t.indexOf("terminal") ? T.default : f.default;
        var i = r[n] || r[e] || r._;
        return i || (c.default.warn("Cannot find customized View (form: " + t + ", factor: " + e + "). Fallback to BaseView."), f.default);
      }
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    var i = n(47),
      o = r(i),
      a = n(0),
      s = n(652),
      u = r(s),
      c = n(265),
      l = r(c),
      f = function f(t) {
        return (0, o.default)({}, t, {
          "label-top": !0
        });
      },
      p = function p(t) {
        var e = (t.options || []).map(function (t) {
          return (0, o.default)({}, l.default.getFactorData(t.factorType), t);
        });
        return {
          View: u.default,
          options: {
            name: t.name,
            collection: new a.Collection(e)
          }
        };
      },
      d = {
        text: f,
        password: f,
        factorType: p
      },
      h = function h(t) {
        return (d[t.type] || a._.identity)(t);
      };
    t.exports = {
      create: h
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(0),
      i = r.View.extend({
        className: "enroll-factor-row clearfix",
        template: '      <div class="enroll-factor-icon-container">        <div class="factor-icon enroll-factor-icon {{iconClassName}}">        </div>      </div>      <div class="enroll-factor-description">        <h3 class="enroll-factor-label">{{label}}</h3>        {{#if factorDescription}}          <p>{{factorDescription}} </p>        {{/if}}        <div class="enroll-factor-button"></div>      </div>    ',
        children: function children() {
          return [[(0, r.createButton)({
            className: "button select-factor",
            title: function title() {
              return "Select";
            },
            click: function click() {
              this.model.trigger("selectFactor", this.model.get("value"));
            }
          }), ".enroll-factor-button"]];
        },
        minimize: function minimize() {
          this.$el.addClass("enroll-factor-row-min");
        }
      });
    e.default = r.ListView.extend({
      className: "enroll-factor-list",
      item: i,
      itemSelector: ".list-content",
      initialize: function initialize() {
        this.listenTo(this.collection, "selectFactor", function (t) {
          this.model.set(this.options.name, t), this.options.appState.trigger("saveForm", this.model);
        });
      },
      template: '<div class="list-content"></div>'
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    var i = n(177),
      o = r(i),
      a = n(47),
      s = r(a),
      u = n(0),
      c = function c(t) {
        var e = (0, s.default)({}, u._.chain(t).pick("minLength", "maxLength", "required").defaults({
          type: "string",
          required: !0
        }).value());
        return (0, o.default)({}, t.name, e);
      },
      l = function l() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = t.uiSchema,
          n = u._.chain(e).map(c).reduce(function (t, e) {
            return (0, s.default)({}, t, e);
          }).value();
        return u.Model.extend({
          props: n,
          local: {
            formName: "string"
          }
        });
      };
    t.exports = {
      create: l
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
      i = r.View.extend({
        template: "{{label}}",
        tagName: "a",
        attributes: function attributes() {
          var t = this.options.href || "#";
          return {
            "data-se": this.options.name,
            href: t
          };
        },
        className: function className() {
          return "link js-" + this.options.name.replace(/[ ]/g, "-");
        },
        postRender: function postRender() {
          var t = this;
          this.options.href || this.$el.click(function (e) {
            var n = t.options.appState;
            e.preventDefault(), t.options.formName ? n.trigger("switchForm", t.options.formName) : n.trigger("invokeAction", t.options.actionPath);
          });
        }
      });
    t.exports = i;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(0),
      o = n(40),
      a = r(o),
      s = n(28),
      u = r(s),
      c = n(59),
      l = r(c),
      f = u.default.extend({
        title: (0, i.loc)("primaryauth.title"),
        save: (0, i.loc)("oform.next", "login"),
        initialize: function initialize() {
          u.default.prototype.initialize.apply(this, arguments), this.options.appState.hasRemediationForm("launch-authenticator") && this.add(i.View.extend({
            className: "sign-in-with-device-option",
            template: '\n          <div class="okta-verify-container"></div>\n          <div class="separation-line"><span>OR</span></div>\n        ',
            initialize: function initialize() {
              var t = this.options.appState;
              this.add((0, i.createButton)({
                className: "button-secondary",
                title: "Sign in using Okta Verify",
                click: function click() {
                  t.trigger("invokeAction", "launch-authenticator");
                }
              }), ".okta-verify-container");
            }
          }), ".o-form-fieldset-container", !1, !0);
        }
      }),
      p = l.default.extend({
        links: function links() {
          var t = this.options.settings.get("baseUrl"),
            e = t + "/help/login";
          this.options.settings.get("helpLinks.help") && (e = this.options.settings.get("helpLinks.help"));
          var n = {
              type: "link",
              label: "Sign up",
              name: "enroll",
              actionPath: "select-enroll-profile"
            },
            r = [{
              name: "help",
              label: "Need help signing in?",
              href: e
            }];
          return this.options.appState.hasRemediationForm("select-enroll-profile") && r.push(n), r;
        }
      });
    e.default = a.default.extend({
      Body: f,
      Footer: p
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(172),
      o = r(i),
      a = n(77),
      s = r(a),
      u = n(47),
      c = r(u),
      l = n(0),
      f = n(40),
      p = r(f),
      d = n(28),
      h = r(d),
      m = n(59),
      g = r(m),
      v = n(57),
      y = r(v),
      _ = n(174),
      b = r(_),
      w = n(268),
      S = r(w),
      x = n(13),
      E = r(x),
      T = function T(t) {
        var e = (0, c.default)({
          method: "GET",
          contentType: "application/json"
        }, t);
        return l.$.ajax(e);
      },
      k = h.default.extend((0, c.default)({
        noButtonBar: !0,
        className: "ion-form device-challenge-poll",
        initialize: function initialize() {
          h.default.prototype.initialize.apply(this, arguments), this.listenTo(this.model, "error", this.onPollingFail), this.deviceChallengePollRemediation = this.options.appState.getCurrentViewState(), this.doChallenge(), this.startDevicePolling();
        },
        onPollingFail: function onPollingFail() {
          this.$(".spinner").hide(), this.stopPolling();
        },
        remove: function remove() {
          h.default.prototype.remove.apply(this, arguments), this.stopPolling();
        },
        doChallenge: function doChallenge() {
          var t = this.options.appState.get(this.deviceChallengePollRemediation.relatesTo);
          switch (t.challengeMethod) {
            case "LOOPBACK":
              this.title = (0, l.loc)("signin.with.fastpass", "login"), this.add('<div class="spinner"></div>'), this.doLoopback(t.domain, t.ports, t.challengeRequest);
              break;
            case "CUSTOM_URI":
              this.title = (0, l.loc)("customUri.title", "login"), this.subtitle = (0, l.loc)("customUri.subtitle", "login"), this.add('\n          {{{i18n code="customUri.content" bundle="login"}}}\n        '), this.customURI = t.href, this.doCustomURI();
              break;
            case "UNIVERSAL_LINK":
              this.title = (0, l.loc)("universalLink.title", "login"), this.add('\n          {{{i18n code="universalLink.content" bundle="login"}}}\n        '), this.add((0, l.createButton)({
                className: "ul-button button button-wide button-primary",
                title: (0, l.loc)("universalLink.button", "login"),
                click: function click() {
                  E.default.redirect(t.href);
                }
              }));
          }
        },
        postRender: function postRender() {
          h.default.prototype.postRender.apply(this, arguments), this.$("#launch-ov").on("click", this.doCustomURI.bind(this));
        },
        doLoopback: function doLoopback() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
            e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
            i = void 0,
            a = !1,
            u = 0,
            c = function c(e) {
              return t + ":" + i + "/" + e;
            },
            l = function l() {
              return T({
                url: c("probe"),
                timeout: b.default.isAndroid() ? 3e3 : 1e3
              });
            },
            f = function f() {
              return a = !0, T({
                url: c("challenge"),
                method: "POST",
                data: (0, s.default)({
                  challengeRequest: r
                }),
                timeout: 3e3
              });
            },
            p = function p() {
              y.default.error("Something unexpected happened while we were checking port " + i + ".");
            },
            d = function d() {
              return l().done(f).fail(p);
            },
            h = o.default.resolve();
          n.forEach(function (t) {
            h = h.then(function () {
              if (!a) return i = t, d();
            }).catch(function () {
              u++, y.default.error("Authenticator is not listening on port " + i + "."), u === n.length && (y.default.error("No available ports. Loopback server failed and polling is cancelled."), e.options.appState.trigger("invokeAction", "authenticatorChallenge-cancel"));
            });
          });
        },
        doCustomURI: function doCustomURI() {
          this.customURI && E.default.redirectWithFormGet(this.customURI);
        }
      }, S.default)),
      A = g.default.extend({
        links: function links() {
          var t = [];
          return "CUSTOM_URI" === this.options.appState.get(this.options.appState.getCurrentViewState().relatesTo).challengeMethod && (t = [{
            name: "sign-in-options",
            type: "link",
            label: (0, l.loc)("goback", "login"),
            href: this.settings.get("baseUrl")
          }]), t;
        }
      });
    e.default = p.default.extend({
      Body: k,
      Footer: A
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(40),
      o = r(i),
      a = n(28),
      s = r(a),
      u = n(13),
      c = r(u),
      l = s.default.extend({
        noButtonBar: !0,
        title: "You are being redirected",
        initialize: function initialize() {
          var t = this;
          s.default.prototype.initialize.apply(this, arguments), "get" === (this.options.appState.get("remediations").filter(function (e) {
            return e.name === t.options.appState.get("currentFormName");
          })[0].method || "").toLowerCase() ? c.default.redirectWithFormGet(this.options.currentViewState.href) : (this.add('<div class="spinner"></div>'), this.options.appState.trigger("saveForm", this.model));
        }
      });
    e.default = o.default.extend({
      Body: l
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(40),
      o = r(i),
      a = n(28),
      s = r(a),
      u = n(0),
      c = s.default.extend({
        title: function title() {
          return (0, u.loc)("enroll.choices.setup", "login");
        },
        subtitle: (0, u.loc)("enroll.choices.description", "login"),
        noButtonBar: !0
      });
    e.default = o.default.extend({
      Body: c
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(40),
      o = r(i),
      a = n(28),
      s = r(a),
      u = n(0),
      c = s.default.extend({
        title: function title() {
          return this.isPasswordRecoveryFlow() ? (0, u.loc)("password.reset.title.generic", "login") : (0, u.loc)("mfa.factors.dropdown.title", "login");
        },
        subtitle: function subtitle() {
          return this.isPasswordRecoveryFlow() ? (0, u.loc)("password.reset.verification", "login") : (0, u.loc)("verify.choices.description", "login");
        },
        isPasswordRecoveryFlow: function isPasswordRecoveryFlow() {
          var t = this.options.appState.get("recoveryFactor");
          return t && "password" === t.factorType;
        },
        noButtonBar: !0
      });
    e.default = o.default.extend({
      Body: c
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(0),
      o = n(40),
      a = r(o),
      s = n(28),
      u = r(s),
      c = n(59),
      l = r(c),
      f = u.default.extend({
        title: function title() {
          return (0, i.loc)("registration.form.title", "login");
        },
        save: (0, i.loc)("registration.form.submit", "login")
      }),
      p = l.default.extend({
        links: function links() {
          var t = [];
          return this.options.appState.hasRemediationForm("select-identify") && t.push({
            type: "link",
            label: "Already have an account ?",
            name: "back",
            actionPath: "select-identify"
          }), t;
        }
      });
    e.default = a.default.extend({
      Body: f,
      Footer: p
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(40),
      o = r(i),
      a = n(28),
      s = r(a),
      u = n(13),
      c = r(u),
      l = s.default.extend({
        title: function title() {
          return "You will be redirected";
        },
        noButtonBar: !0,
        initialize: function initialize() {
          s.default.prototype.initialize.apply(this, arguments);
          var t = this.options.appState.getCurrentViewState().href;
          c.default.redirectWithFormGet(t);
        }
      });
    e.default = o.default.extend({
      Body: l
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(47),
      o = r(i),
      a = n(0),
      s = n(40),
      u = r(s),
      c = n(28),
      l = r(c),
      f = n(99),
      p = r(f),
      d = l.default.extend({
        title: (0, a.loc)("enroll.password.setup", "login"),
        save: (0, a.loc)("save.password", "login"),
        getUISchema: function getUISchema() {
          return l.default.prototype.getUISchema.apply(this, arguments).concat([{
            name: "confirmPassword",
            label: "Repeat Password",
            type: "password",
            params: {
              showPasswordToggle: !0
            }
          }]);
        }
      });
    e.default = p.default.extend({
      Body: d,
      createModelClass: function createModelClass() {
        var t = u.default.prototype.createModelClass.apply(this, arguments),
          e = (0, o.default)({
            confirmPassword: {
              type: "string",
              required: !0
            }
          }, t.prototype.local);
        return t.extend({
          local: e,
          validate: function validate() {
            if (this.get("credentials.passcode") !== this.get("confirmPassword") && this.get("credential.value") !== this.get("confirmPassword")) {
              var t = {};
              return t.confirmPassword = (0, a.loc)("password.error.match", "login"), t;
            }
          }
        });
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(267),
      i = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(r),
      o = n(265),
      a = i.default.extend({
        getBeaconClassName: function getBeaconClassName() {
          var t = this.options.appState.get("factorType");
          return (0, o.getFactorData)(t).iconClassName;
        }
      });
    t.exports = a;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(0),
      o = n(28),
      a = r(o),
      s = n(59),
      u = r(s),
      c = n(99),
      l = r(c),
      f = a.default.extend({
        title: (0, i.loc)("factor.password", "login"),
        save: (0, i.loc)("mfa.challenge.verify", "login")
      }),
      p = u.default.extend({
        links: function links() {
          var t = [];
          return this.options.appState.getActionByPath("factor-recover") && t.push({
            type: "link",
            label: "Forgot Password",
            name: "forgot-password",
            actionPath: "factor-recover"
          }), this.options.appState.hasRemediationForm("select-factor-authenticate") && t.push({
            type: "link",
            label: "Switch Factor",
            name: "switchFactor",
            formName: "select-factor-authenticate"
          }), t;
        }
      });
    e.default = l.default.extend({
      Body: f,
      Footer: p
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(0),
      o = n(28),
      a = r(o),
      s = n(59),
      u = r(s),
      c = n(99),
      l = r(c),
      f = n(180),
      p = r(f),
      d = n(97),
      h = r(d),
      m = a.default.extend({
        title: (0, i.loc)("factor.webauthn.biometric", "login"),
        getUISchema: function getUISchema() {
          var t = this,
            e = [];
          if (h.default.isNewApiAvailable()) {
            var n = (0, i.createButton)({
              className: "retry-webauthn button-primary default-custom-button",
              title: (0, i.loc)("retry", "login"),
              click: function click() {
                t.getCredentialsAndSave();
              }
            });
            e.push({
              View: '<div class="webauthn-verify-text idx-webauthn-verify-text">              <p>{{i18n code="verify.webauthn.biometric.instructions" bundle="login"}}</p>              <div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>            </div>'
            }, {
              View: n
            });
          }
          return e;
        },
        remove: function remove() {
          a.default.prototype.remove.apply(this, arguments), this.webauthnAbortController && (this.webauthnAbortController.abort(), this.webauthnAbortController = null);
        },
        noButtonBar: !0,
        modelEvents: {
          error: "_stopVerification"
        },
        getCredentialsAndSave: function getCredentialsAndSave() {
          var t = this;
          this.clearErrors(), this._startVerification(), this.webauthnAbortController = new AbortController();
          var e = this.options.appState.get("factor"),
            n = [{
              type: "public-key",
              id: p.default.strToBin(e.contextualData.profile.credentialId)
            }],
            r = {
              allowCredentials: n,
              challenge: p.default.strToBin(e.contextualData.challengeData.challenge)
            };
          navigator.credentials.get({
            publicKey: r,
            signal: this.webauthnAbortController.signal
          }).then(function (e) {
            t.model.set({
              credentials: {
                clientData: p.default.binToStr(e.response.clientDataJSON),
                authenticatorData: p.default.binToStr(e.response.authenticatorData),
                signatureData: p.default.binToStr(e.response.signature)
              }
            }), t.saveForm(t.model);
          }, function (e) {
            t.webauthnAbortController && t.model.trigger("error", t.model, {
              responseJSON: {
                errorSummary: e.message
              }
            });
          }).finally(function () {
            t.webauthnAbortController = null;
          });
        },
        postRender: function postRender() {
          var t = this;
          i._.defer(function () {
            h.default.isNewApiAvailable() ? t.getCredentialsAndSave() : (t.model.trigger("error", t.model, {
              responseJSON: {
                errorSummary: (0, i.loc)("webauthn.biometric.error.factorNotSupported", "login")
              }
            }), t.$('[data-se="webauthn-waiting"]').hide());
          });
        },
        _startVerification: function _startVerification() {
          this.$(".okta-waiting-spinner").show(), this.$(".retry-webauthn").hide();
        },
        _stopVerification: function _stopVerification() {
          this.$(".okta-waiting-spinner").hide(), this.$(".retry-webauthn").show();
        }
      }),
      g = u.default.extend({
        links: function links() {
          var t = [];
          return this.options.appState.hasRemediationForm("select-factor") && t.push({
            type: "link",
            label: "Switch Factor",
            name: "switchFactor",
            formName: "select-factor"
          }), t;
        }
      });
    e.default = l.default.extend({
      Body: m,
      Footer: g
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(47),
      o = r(i),
      a = n(0),
      s = n(28),
      u = r(s),
      c = n(59),
      l = r(c),
      f = n(270),
      p = r(f),
      d = n(268),
      h = r(d),
      m = n(99),
      g = r(m),
      v = a.View.extend({
        className: "hide resend-email-view",
        initialize: function initialize() {
          this.add((0, a.createCallout)({
            subtitle: 'Haven\'t received an email? To try again, click "Resend Email"',
            type: "warning"
          })), this.add((0, a.createButton)({
            className: "button",
            title: "Resend Email",
            click: function click() {
              this.options.appState.trigger("invokeAction", "factor-resend");
            }
          }));
        },
        postRender: function postRender() {
          var t = this;
          this.showMeTimeout = a._.delay(function () {
            t.$el.removeClass("hide");
          }, 6e4);
        },
        remove: function remove() {
          a.View.prototype.remove.apply(this, arguments), clearTimeout(this.showMeTimeout);
        }
      }),
      y = u.default.extend((0, o.default)({
        save: (0, a.loc)("mfa.challenge.verify", "login"),
        initialize: function initialize() {
          u.default.prototype.initialize.apply(this, arguments), this.add('<div class="email-verification-description">An email has been sent to you. \n          Please click the link in your email or enter the code from that email below.</div>'), this.listenTo(this.options.model, "error", this.startPolling.bind(this));
        },
        saveForm: function saveForm() {
          u.default.prototype.saveForm.apply(this, arguments), this.stopPolling();
        },
        postRender: function postRender() {
          this.add(v, {
            selector: ".o-form-fieldset-container",
            prepend: !0
          }), this.startPolling();
        },
        remove: function remove() {
          u.default.prototype.remove.apply(this, arguments), this.stopPolling();
        }
      }, p.default, h.default)),
      _ = l.default.extend({
        links: function links() {
          var t = [];
          return this.options.appState.hasRemediationForm("select-factor-authenticate") && t.push({
            type: "link",
            label: "Switch Factor",
            name: "switchFactor",
            formName: "select-factor-authenticate"
          }), t;
        }
      });
    e.default = g.default.extend({
      Body: y,
      Footer: _
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(47),
      o = r(i),
      a = n(270),
      s = r(a),
      u = n(271),
      c = r(u),
      l = c.default.prototype.Body.extend((0, o.default)({
        subtitle: "To finish signing in, return to the screen where you requested the email link."
      }, s.default));
    e.default = c.default.extend({
      Body: l
    });
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(271),
      i = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(r),
      o = i.default.prototype.Body.extend({
        title: function title() {
          return "You can close this window";
        }
      });
    e.default = i.default.extend({
      Body: o
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function i(t, e, n, r, i) {
      var o = setTimeout(function () {
        t.trigger("loading", !0);
      }, 200);
      return f.default.loadLanguage(e, n, {
        baseUrl: r,
        rewrite: i
      }).then(function () {
        clearTimeout(o), t.trigger("loading", !1);
      });
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = n(0),
      a = n(256),
      s = r(a),
      u = n(58),
      c = r(u),
      l = n(121),
      f = r(l),
      p = n(260),
      d = r(p),
      h = n(6),
      m = r(h),
      g = n(33),
      v = r(g),
      y = n(57),
      _ = r(y),
      b = n(259),
      w = r(b),
      S = n(257),
      x = r(S),
      E = n(670),
      T = r(E),
      k = n(671),
      A = r(k),
      O = n(672),
      C = r(O);
    e.default = o.Router.extend({
      Events: o.Backbone.Events,
      initialize: function initialize(t) {
        t.globalSuccessFn || (t.globalSuccessFn = function () {}), t.globalErrorFn || (t.globalErrorFn = function (t) {
          _.default.error(t);
        }), this.settings = new s.default(o._.omit(t, "el", "authClient"), {
          parse: !0
        }), this.settings.setAuthClient(t.authClient), t.el || this.settings.callGlobalError(new v.default.ConfigError((0, o.loc)("error.required.el"))), (0, o.$)("body > div").on("click", function () {}), this.appState = new C.default();
        var e = new w.default({
          appState: this.appState
        });
        (0, o.$)(t.el).append(e.render().$el), this.el = "#" + m.default.WIDGET_CONTAINER_ID, this.header = new x.default({
          el: this.el,
          appState: this.appState,
          settings: this.settings
        }), this.listenTo(this.appState, "change:remediationFailure", function (t, e) {
          if (e.xhr && c.default.corsIsNotEnabled(e.xhr)) return void this.settings.callGlobalError(new v.default.UnsupportedBrowserError((0, o.loc)("error.enabled.cors")));
          this.appState.set("flashError", e), this.defaultAuth();
        }), this.listenTo(this.appState, "change:introspectSuccess", function (t, e) {
          this.appState.trigger("remediationSuccess", o._.omit(e, "data"));
        }), this.listenTo(this.appState, "remediationSuccess", this.handleRemediationSuccess);
      },
      handleRemediationSuccess: function handleRemediationSuccess() {
        var t = o._.compose(A.default, T.default)(this.appState.get("idx"));
        this.appState.setIonResponse(t);
      },
      render: function render(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!f.default.isLoaded(this.settings.get("languageCode"))) return i(this.appState, this.settings.get("languageCode"), this.settings.get("i18n"), this.settings.get("assets.baseUrl"), this.settings.get("assets.rewrite")).then(o._.bind(this.render, this, t, e)).done();
        if (this.settings.get("colors.brand") && !d.default.isLoaded()) {
          var n = {
            brand: this.settings.get("colors.brand")
          };
          d.default.addStyle(n);
        }
        this.header.rendered() || (this.el = this.header.render().getContentEl()), this.unload();
        var r = o._.extend({
          el: this.el,
          settings: this.settings,
          appState: this.appState
        }, e);
        this.controller = new t(r), this.controller.render();
      },
      hide: function hide() {
        this.header.$el.hide();
      },
      show: function show() {
        this.header.$el.show();
      },
      remove: function remove() {
        this.unload(), this.header.$el.remove(), this.stopListening(this.appState), this.stopListening(this.settings), f.default.remove(), o.Backbone.history.stop();
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(47),
      i = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(r),
      o = n(0),
      a = function a(t) {
        return o._.isObject(t);
      },
      s = function s(t) {
        var e = {};
        return o._.each(t, function (t, n) {
          "remediation" !== n && ("array" === t.type && (e[n] = {
            value: t.value
          }), "object" === t.type && (e[n] = t.value));
        }), e;
      },
      u = function u(t) {
        var e = [];
        return o._.isEmpty(t.neededToProceed) && t.context.success && e.push({
          name: t.context.success.name,
          href: t.context.success.href,
          value: []
        }), o._.each(t.neededToProceed, function (n, r) {
          n && n.length ? e.push({
            value: n,
            name: r
          }) : e.push(o._.omit(t.rawIdxState.remediation.value[0], "rel", "value"));
        }), {
          remediations: e
        };
      },
      c = function c(t) {
        if (!a(t && t.rawIdxState)) return null;
        var e = t.rawIdxState,
          n = s(e),
          r = u(t);
        return (0, i.default)({}, n, r, t);
      };
    t.exports = c;
  }, function (t, e, n) {
    "use strict";

    var r = n(47),
      i = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(r),
      o = n(0),
      a = function a(t, e) {
        return o._.each(t, function (t) {
          var n = t.value,
            r = e.find(function (t) {
              return t.factorProfileId === n || t.factorId === n;
            });
          t.factorType = r.factorType;
        }), t;
      },
      s = function s() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
        return t = o._.chain(t).map(function (t) {
          if (t.form) {
            var e = t.name;
            return t.form.value.map(function (t) {
              return (0, i.default)({}, t, {
                name: e + "." + t.name
              });
            });
          }
          return t;
        }).flatten().value(), t.map(function (t) {
          var n = {
            type: "text"
          };
          return !0 === t.secret && (n.type = "password", n.params = {
            showPasswordToggle: !0
          }), "factorId" !== t.name && "factorProfileId" !== t.name || (n.type = "factorType", n.options = a(t.options, e)), (0, i.default)({}, t, n);
        });
      },
      u = function u(t) {
        if (t) {
          var e = t.factors && t.factors.value || [];
          t.remediations = t.remediations.map(function (t) {
            return t.uiSchema = s(t.value, e), t;
          });
        }
        return t;
      };
    t.exports = u;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(171),
      o = r(i),
      a = n(0),
      s = n(57),
      u = r(s);
    e.default = a.Model.extend({
      local: {
        introspectSuccess: "object",
        introspectError: "object",
        factor: "object",
        user: "object",
        currentFormName: "string",
        idx: "object",
        remediations: "array",
        __previousResponse: "object"
      },
      derived: {
        factorProfile: {
          deps: ["factor"],
          fn: function fn() {
            return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).profile || {};
          }
        },
        factorType: {
          deps: ["factor"],
          fn: function fn() {
            return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).factorType;
          }
        },
        currentStep: {
          deps: ["idx"],
          fn: function fn() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (t && t.context && t.context.step) return t.context.step.toLowerCase();
          }
        },
        showSignoutLink: {
          deps: ["idx"],
          fn: function fn() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = ["IDENTIFY", "ENROLL", "SUCCESS"];
            return t.actions && a._.isFunction(t.actions.cancel) && !e.includes(t.context.step);
          }
        }
      },
      hasRemediationForm: function hasRemediationForm(t) {
        return 1 === (0, o.default)(this.get("idx").neededToProceed).filter(function (e) {
          return e === t;
        }).length;
      },
      getActionByPath: function getActionByPath(t) {
        var e = t.split("."),
          n = void 0;
        n = 1 === e.length ? this.get("idx").actions : this.get(e.shift());
        var r = e.shift();
        return n && a._.isFunction(n[r]) ? n[r] : null;
      },
      getCurrentViewState: function getCurrentViewState() {
        var t = this.get("currentFormName"),
          e = void 0;
        return a._.isEmpty(this.get("remediations")) || (e = this.get("remediations").filter(function (e) {
          return e.name === t;
        })[0]), e || (t && u.default.warn("Cannot find view state for form " + t + ". Fall back to terminal state."), e = this.get("terminal")), e;
      },
      setIonResponse: function setIonResponse(t) {
        var e = this.get("idx");
        a._.isEqual(a._.omit(e.rawIdxState, "expiresAt"), a._.omit(this.get("__previousResponse"), "expiresAt")) || (t.currentFormName = null, e.neededToProceed && e.rawIdxState.remediation && (t.currentFormName = e.rawIdxState.remediation.value[0].name), e.rawIdxState.success && (t.currentFormName = e.rawIdxState.success.name), e.context.terminal && a._.isEmpty(e.context.terminal.value) && (t.terminal = {
          name: "terminal",
          value: [],
          uiSchema: []
        }), this.clear({
          silent: !0
        }), this.set(t), this.set("idx", e), this.set("__previousResponse", e.rawIdxState), this.trigger("idxResponseUpdated", t));
      }
    });
  }, function (t, e, n) {
    !function (e, n) {
      t.exports = n();
    }("undefined" != typeof self && self, function () {
      return function (t) {
        function e(r) {
          if (n[r]) return n[r].exports;
          var i = n[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return t[r].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
        }
        var n = {};
        return e.m = t, e.c = n, e.d = function (t, n, r) {
          e.o(t, n) || Object.defineProperty(t, n, {
            configurable: !1,
            enumerable: !0,
            get: r
          });
        }, e.n = function (t) {
          var n = t && t.__esModule ? function () {
            return t.default;
          } : function () {
            return t;
          };
          return e.d(n, "a", n), n;
        }, e.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }, e.p = "", e(e.s = 11);
      }([function (t, e) {
        var n = t.exports;
        n.stringToBase64Url = function (t) {
          var e = btoa(t);
          return n.base64ToBase64Url(e);
        }, n.base64ToBase64Url = function (t) {
          return t.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        }, n.base64UrlToBase64 = function (t) {
          return t.replace(/-/g, "+").replace(/_/g, "/");
        }, n.base64UrlToString = function (t) {
          var e = n.base64UrlToBase64(t);
          switch (e.length % 4) {
            case 0:
              break;
            case 2:
              e += "==";
              break;
            case 3:
              e += "=";
              break;
            default:
              throw "Not a valid Base64Url";
          }
          var r = atob(e);
          try {
            return decodeURIComponent(escape(r));
          } catch (t) {
            return r;
          }
        }, n.stringToBuffer = function (t) {
          for (var e = new Uint8Array(t.length), n = 0; n < t.length; n++) e[n] = t.charCodeAt(n);
          return e;
        }, n.base64UrlDecode = function (t) {
          return atob(n.base64UrlToBase64(t));
        }, n.bind = function (t, e) {
          var n = Array.prototype.slice.call(arguments, 2);
          return function () {
            var r = Array.prototype.slice.call(arguments);
            return r = n.concat(r), t.apply(e, r);
          };
        }, n.isAbsoluteUrl = function (t) {
          return /^(?:[a-z]+:)?\/\//i.test(t);
        }, n.isString = function (t) {
          return "[object String]" === Object.prototype.toString.call(t);
        }, n.isObject = function (t) {
          return "[object Object]" === Object.prototype.toString.call(t);
        }, n.isNumber = function (t) {
          return "[object Number]" === Object.prototype.toString.call(t);
        }, n.isArray = function (t) {
          return "[object Array]" === Object.prototype.toString.call(t);
        }, n.isoToUTCString = function (t) {
          var e = t.match(/\d+/g),
            n = Date.UTC(e[0], e[1] - 1, e[2], e[3], e[4], e[5]);
          return new Date(n).toUTCString();
        }, n.toQueryParams = function (t) {
          var e = [];
          if (null !== t) for (var n in t) t.hasOwnProperty(n) && void 0 !== t[n] && null !== t[n] && e.push(n + "=" + encodeURIComponent(t[n]));
          return e.length ? "?" + e.join("&") : "";
        }, n.genRandomString = function (t) {
          for (var e = "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", n = "", r = 0, i = e.length; r < t; ++r) n += e[Math.floor(Math.random() * i)];
          return n;
        }, n.extend = function () {
          var t = arguments[0];
          return [].slice.call(arguments, 1).forEach(function (e) {
            for (var n in e) e.hasOwnProperty(n) && void 0 !== e[n] && (t[n] = e[n]);
          }), t;
        }, n.removeNils = function (t) {
          var e = {};
          for (var n in t) if (t.hasOwnProperty(n)) {
            var r = t[n];
            null !== r && void 0 !== r && (e[n] = r);
          }
          return e;
        }, n.clone = function (t) {
          if (t) {
            var e = JSON.stringify(t);
            if (e) return JSON.parse(e);
          }
          return t;
        }, n.omit = function (t) {
          var e = Array.prototype.slice.call(arguments, 1),
            r = {};
          for (var i in t) t.hasOwnProperty(i) && -1 == e.indexOf(i) && (r[i] = t[i]);
          return n.clone(r);
        }, n.find = function (t, e) {
          for (var n = t.length; n--;) {
            var r = t[n],
              i = !0;
            for (var o in e) if (e.hasOwnProperty(o) && r[o] !== e[o]) {
              i = !1;
              break;
            }
            if (i) return r;
          }
        }, n.getLink = function (t, e, r) {
          if (t && t._links) {
            var i = n.clone(t._links[e]);
            return i && i.name && r ? i.name === r ? i : void 0 : i;
          }
        }, n.getNativeConsole = function () {
          return "undefined" != typeof window ? window.console : "undefined" != typeof console ? console : void 0;
        }, n.getConsole = function () {
          var t = n.getNativeConsole();
          return t && t.log ? t : {
            log: function log() {}
          };
        }, n.warn = function (t) {
          n.getConsole().log("[okta-auth-sdk] WARN: " + t);
        }, n.deprecate = function (t) {
          n.getConsole().log("[okta-auth-sdk] DEPRECATION: " + t);
        }, n.deprecateWrap = function (t, e) {
          return function () {
            return n.deprecate(t), e.apply(null, arguments);
          };
        }, n.removeTrailingSlash = function (t) {
          if (t) {
            var e = t.replace(/^\s+|\s+$/gm, "");
            return e = e.replace(/\/+$/, "");
          }
        }, n.isIE11OrLess = function () {
          return !!document.documentMode && document.documentMode <= 11;
        }, n.isFunction = function (t) {
          return !!t && "[object Function]" === {}.toString.call(t);
        };
      }, function (t, e) {
        function n(t, e) {
          this.name = "AuthSdkError", this.message = t, this.errorCode = "INTERNAL", this.errorSummary = t, this.errorLink = "INTERNAL", this.errorId = "INTERNAL", this.errorCauses = [], e && (this.xhr = e);
        }
        n.prototype = new Error(), t.exports = n;
      }, function (t, e) {
        t.exports = {
          STATE_TOKEN_KEY_NAME: "oktaStateToken",
          DEFAULT_POLLING_DELAY: 500,
          DEFAULT_MAX_CLOCK_SKEW: 300,
          DEFAULT_CACHE_DURATION: 86400,
          REDIRECT_OAUTH_PARAMS_COOKIE_NAME: "okta-oauth-redirect-params",
          REDIRECT_STATE_COOKIE_NAME: "okta-oauth-state",
          REDIRECT_NONCE_COOKIE_NAME: "okta-oauth-nonce",
          TOKEN_STORAGE_NAME: "okta-token-storage",
          CACHE_STORAGE_NAME: "okta-cache-storage",
          PKCE_STORAGE_NAME: "okta-pkce-storage"
        };
      }, function (t, e, n) {
        function r(t, e) {
          e = e || {};
          var n = e.url,
            r = e.method,
            i = e.args,
            o = e.saveAuthnState,
            l = e.accessToken,
            f = !1 !== e.withCredentials,
            p = t.options.storageUtil,
            d = p.storage,
            h = p.getHttpCache();
          if (e.cacheResponse) {
            var m = h.getStorage(),
              g = m[n];
            if (g && Date.now() / 1e3 < g.expiresAt) return s.resolve(g.response);
          }
          var v = {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Okta-User-Agent-Extended": t.userAgent
          };
          a.extend(v, t.options.headers, e.headers), l && a.isString(l) && (v.Authorization = "Bearer " + l);
          var y,
            _,
            b = {
              headers: v,
              data: i || void 0,
              withCredentials: f
            };
          return new s(t.options.httpRequestClient(r, n, b)).then(function (t) {
            return _ = t.responseText, _ && a.isString(_) && (_ = JSON.parse(_)), o && (_.stateToken || d.delete(c.STATE_TOKEN_KEY_NAME)), _ && _.stateToken && _.expiresAt && d.set(c.STATE_TOKEN_KEY_NAME, _.stateToken, _.expiresAt), _ && e.cacheResponse && h.updateStorage(n, {
              expiresAt: Math.floor(Date.now() / 1e3) + c.DEFAULT_CACHE_DURATION,
              response: _
            }), _;
          }).fail(function (e) {
            var n = e.responseText || {};
            if (a.isString(n)) try {
              n = JSON.parse(n);
            } catch (t) {
              n = {
                errorSummary: "Unknown error"
              };
            }
            throw e.status >= 500 && (n.errorSummary = "Unknown error"), t.options.transformErrorXHR && (e = t.options.transformErrorXHR(a.clone(e))), y = new u(n, e), "E0000011" === y.errorCode && d.delete(c.STATE_TOKEN_KEY_NAME), y;
          });
        }
        function i(t, e, n) {
          e = a.isAbsoluteUrl(e) ? e : t.options.url + e;
          var i = {
            url: e,
            method: "GET"
          };
          return a.extend(i, n), r(t, i);
        }
        function o(t, e, n, i) {
          e = a.isAbsoluteUrl(e) ? e : t.options.url + e;
          var o = {
            url: e,
            method: "POST",
            args: n,
            saveAuthnState: !0
          };
          return a.extend(o, i), r(t, o);
        }
        var a = n(0),
          s = n(5),
          u = n(22),
          c = n(2);
        t.exports = {
          get: i,
          post: o,
          httpRequest: r
        };
      }, function (t, e, n) {
        var r = n(14),
          i = n(6),
          o = n(2),
          a = {};
        a.browserHasLocalStorage = function () {
          try {
            var t = a.getLocalStorage();
            return a.testStorage(t);
          } catch (t) {
            return !1;
          }
        }, a.browserHasSessionStorage = function () {
          try {
            var t = a.getSessionStorage();
            return a.testStorage(t);
          } catch (t) {
            return !1;
          }
        }, a.getPKCEStorage = function () {
          return a.browserHasLocalStorage() ? i(a.getLocalStorage(), o.PKCE_STORAGE_NAME) : a.browserHasSessionStorage() ? i(a.getSessionStorage(), o.PKCE_STORAGE_NAME) : i(a.getCookieStorage({
            secure: "https:" === window.location.protocol
          }), o.PKCE_STORAGE_NAME);
        }, a.getHttpCache = function () {
          return a.browserHasLocalStorage() ? i(a.getLocalStorage(), o.CACHE_STORAGE_NAME) : a.browserHasSessionStorage() ? i(a.getSessionStorage(), o.CACHE_STORAGE_NAME) : i(a.getCookieStorage({
            secure: "https:" === window.location.protocol
          }), o.CACHE_STORAGE_NAME);
        }, a.getLocalStorage = function () {
          return localStorage;
        }, a.getSessionStorage = function () {
          return sessionStorage;
        }, a.getCookieStorage = function (t) {
          t = t || {};
          var e = t.secure || !1,
            n = t.sameSite || (e ? "none" : "lax");
          return {
            getItem: a.storage.get,
            setItem: function setItem(t, r) {
              a.storage.set(t, r, "2200-01-01T00:00:00.000Z", {
                secure: e,
                sameSite: n
              });
            }
          };
        }, a.getInMemoryStorage = function () {
          var t = {};
          return {
            getItem: function getItem(e) {
              return t[e];
            },
            setItem: function setItem(e, n) {
              t[e] = n;
            }
          };
        }, a.testStorage = function (t) {
          var e = "okta-test-storage";
          try {
            return t.setItem(e, e), t.removeItem(e), !0;
          } catch (t) {
            return !1;
          }
        }, a.storage = {
          set: function set(t, e, n, i) {
            i = i || {};
            var o = {
              path: i.path || "/",
              secure: i.secure,
              sameSite: i.sameSite
            };
            return Date.parse(n) && (o.expires = new Date(n)), r.set(t, e, o), a.storage.get(t);
          },
          get: function get(t) {
            return r.get(t);
          },
          delete: function _delete(t) {
            return r.remove(t, {
              path: "/"
            });
          }
        }, t.exports = a;
      }, function (t, e, n) {
        (function (e, n) {
          /*!
          *
          * Copyright 2009-2012 Kris Kowal under the terms of the MIT
          * license found at http://github.com/kriskowal/q/raw/master/LICENSE
          *
          * With parts by Tyler Close
          * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
          * at http://www.opensource.org/licenses/mit-license.html
          * Forked at ref_send.js version: 2009-05-11
          *
          * With parts by Mark Miller
          * Copyright (C) 2011 Google Inc.
          *
          * Licensed under the Apache License, Version 2.0 (the "License");
          * you may not use this file except in compliance with the License.
          * You may obtain a copy of the License at
          *
          * http://www.apache.org/licenses/LICENSE-2.0
          *
          * Unless required by applicable law or agreed to in writing, software
          * distributed under the License is distributed on an "AS IS" BASIS,
          * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
          * See the License for the specific language governing permissions and
          * limitations under the License.
          *
          */
          !function (e) {
            "use strict";

            "function" == typeof bootstrap ? bootstrap("promise", e) : t.exports = e();
          }(function () {
            "use strict";

            function t(t) {
              return function () {
                return K.apply(t, arguments);
              };
            }
            function r(t) {
              return t === Object(t);
            }
            function i(t) {
              return "[object StopIteration]" === nt(t) || t instanceof W;
            }
            function o(t, e) {
              if (q && e.stack && "object" == typeof t && null !== t && t.stack && -1 === t.stack.indexOf(rt)) {
                for (var n = [], r = e; r; r = r.source) r.stack && n.unshift(r.stack);
                n.unshift(t.stack);
                var i = n.join("\n" + rt + "\n");
                t.stack = a(i);
              }
            }
            function a(t) {
              for (var e = t.split("\n"), n = [], r = 0; r < e.length; ++r) {
                var i = e[r];
                c(i) || s(i) || !i || n.push(i);
              }
              return n.join("\n");
            }
            function s(t) {
              return -1 !== t.indexOf("(module.js:") || -1 !== t.indexOf("(node.js:");
            }
            function u(t) {
              var e = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(t);
              if (e) return [e[1], Number(e[2])];
              var n = /at ([^ ]+):(\d+):(?:\d+)$/.exec(t);
              if (n) return [n[1], Number(n[2])];
              var r = /.*@(.+):(\d+)$/.exec(t);
              return r ? [r[1], Number(r[2])] : void 0;
            }
            function c(t) {
              var e = u(t);
              if (!e) return !1;
              var n = e[0],
                r = e[1];
              return n === H && r >= $ && r <= ut;
            }
            function l() {
              if (q) try {
                throw new Error();
              } catch (r) {
                var t = r.stack.split("\n"),
                  e = t[0].indexOf("@") > 0 ? t[1] : t[2],
                  n = u(e);
                if (!n) return;
                return H = n[0], n[1];
              }
            }
            function f(t) {
              return t instanceof m ? t : _(t) ? O(t) : A(t);
            }
            function p() {
              function t(t) {
                e = t, o.source = t, J(n, function (e, n) {
                  f.nextTick(function () {
                    t.promiseDispatch.apply(t, n);
                  });
                }, void 0), n = void 0, r = void 0;
              }
              var e,
                n = [],
                r = [],
                i = Z(p.prototype),
                o = Z(m.prototype);
              if (o.promiseDispatch = function (t, i, o) {
                var a = Y(arguments);
                n ? (n.push(a), "when" === i && o[1] && r.push(o[1])) : f.nextTick(function () {
                  e.promiseDispatch.apply(e, a);
                });
              }, o.valueOf = function () {
                if (n) return o;
                var t = v(e);
                return y(t) && (e = t), t;
              }, o.inspect = function () {
                return e ? e.inspect() : {
                  state: "pending"
                };
              }, f.longStackSupport && q) try {
                throw new Error();
              } catch (t) {
                o.stack = t.stack.substring(t.stack.indexOf("\n") + 1);
              }
              return i.promise = o, i.resolve = function (n) {
                e || t(f(n));
              }, i.fulfill = function (n) {
                e || t(A(n));
              }, i.reject = function (n) {
                e || t(k(n));
              }, i.notify = function (t) {
                e || J(r, function (e, n) {
                  f.nextTick(function () {
                    n(t);
                  });
                }, void 0);
              }, i;
            }
            function d(t) {
              if ("function" != typeof t) throw new TypeError("resolver must be a function.");
              var e = p();
              try {
                t(e.resolve, e.reject, e.notify);
              } catch (t) {
                e.reject(t);
              }
              return e.promise;
            }
            function h(t) {
              return d(function (e, n) {
                for (var r = 0, i = t.length; r < i; r++) f(t[r]).then(e, n);
              });
            }
            function m(t, e, n) {
              void 0 === e && (e = function e(t) {
                return k(new Error("Promise does not support operation: " + t));
              }), void 0 === n && (n = function n() {
                return {
                  state: "unknown"
                };
              });
              var r = Z(m.prototype);
              if (r.promiseDispatch = function (n, i, o) {
                var a;
                try {
                  a = t[i] ? t[i].apply(r, o) : e.call(r, i, o);
                } catch (t) {
                  a = k(t);
                }
                n && n(a);
              }, r.inspect = n, n) {
                var i = n();
                "rejected" === i.state && (r.exception = i.reason), r.valueOf = function () {
                  var t = n();
                  return "pending" === t.state || "rejected" === t.state ? r : t.value;
                };
              }
              return r;
            }
            function g(t, e, n, r) {
              return f(t).then(e, n, r);
            }
            function v(t) {
              if (y(t)) {
                var e = t.inspect();
                if ("fulfilled" === e.state) return e.value;
              }
              return t;
            }
            function y(t) {
              return t instanceof m;
            }
            function _(t) {
              return r(t) && "function" == typeof t.then;
            }
            function b(t) {
              return y(t) && "pending" === t.inspect().state;
            }
            function w(t) {
              return !y(t) || "fulfilled" === t.inspect().state;
            }
            function S(t) {
              return y(t) && "rejected" === t.inspect().state;
            }
            function x() {
              it.length = 0, ot.length = 0, st || (st = !0);
            }
            function E(t, n) {
              st && ("object" == typeof e && "function" == typeof e.emit && f.nextTick.runAfter(function () {
                -1 !== Q(ot, t) && (e.emit("unhandledRejection", n, t), at.push(t));
              }), ot.push(t), n && void 0 !== n.stack ? it.push(n.stack) : it.push("(no stack) " + n));
            }
            function T(t) {
              if (st) {
                var n = Q(ot, t);
                -1 !== n && ("object" == typeof e && "function" == typeof e.emit && f.nextTick.runAfter(function () {
                  var r = Q(at, t);
                  -1 !== r && (e.emit("rejectionHandled", it[n], t), at.splice(r, 1));
                }), ot.splice(n, 1), it.splice(n, 1));
              }
            }
            function k(t) {
              var e = m({
                when: function when(e) {
                  return e && T(this), e ? e(t) : this;
                }
              }, function () {
                return this;
              }, function () {
                return {
                  state: "rejected",
                  reason: t
                };
              });
              return E(e, t), e;
            }
            function A(t) {
              return m({
                when: function when() {
                  return t;
                },
                get: function get(e) {
                  return t[e];
                },
                set: function set(e, n) {
                  t[e] = n;
                },
                delete: function _delete(e) {
                  delete t[e];
                },
                post: function post(e, n) {
                  return null === e || void 0 === e ? t.apply(void 0, n) : t[e].apply(t, n);
                },
                apply: function apply(e, n) {
                  return t.apply(e, n);
                },
                keys: function keys() {
                  return et(t);
                }
              }, void 0, function () {
                return {
                  state: "fulfilled",
                  value: t
                };
              });
            }
            function O(t) {
              var e = p();
              return f.nextTick(function () {
                try {
                  t.then(e.resolve, e.reject, e.notify);
                } catch (t) {
                  e.reject(t);
                }
              }), e.promise;
            }
            function C(t) {
              return m({
                isDef: function isDef() {}
              }, function (e, n) {
                return L(t, e, n);
              }, function () {
                return f(t).inspect();
              });
            }
            function I(t, e, n) {
              return f(t).spread(e, n);
            }
            function R(t) {
              return function () {
                function e(t, e) {
                  var a;
                  if ("undefined" == typeof StopIteration) {
                    try {
                      a = n[t](e);
                    } catch (t) {
                      return k(t);
                    }
                    return a.done ? f(a.value) : g(a.value, r, o);
                  }
                  try {
                    a = n[t](e);
                  } catch (t) {
                    return i(t) ? f(t.value) : k(t);
                  }
                  return g(a, r, o);
                }
                var n = t.apply(this, arguments),
                  r = e.bind(e, "next"),
                  o = e.bind(e, "throw");
                return r();
              };
            }
            function P(t) {
              f.done(f.async(t)());
            }
            function N(t) {
              throw new W(t);
            }
            function M(t) {
              return function () {
                return I([this, F(arguments)], function (e, n) {
                  return t.apply(e, n);
                });
              };
            }
            function L(t, e, n) {
              return f(t).dispatch(e, n);
            }
            function F(t) {
              return g(t, function (t) {
                var e = 0,
                  n = p();
                return J(t, function (r, i, o) {
                  var a;
                  y(i) && "fulfilled" === (a = i.inspect()).state ? t[o] = a.value : (++e, g(i, function (r) {
                    t[o] = r, 0 == --e && n.resolve(t);
                  }, n.reject, function (t) {
                    n.notify({
                      index: o,
                      value: t
                    });
                  }));
                }, void 0), 0 === e && n.resolve(t), n.promise;
              });
            }
            function D(t) {
              if (0 === t.length) return f.resolve();
              var e = f.defer(),
                n = 0;
              return J(t, function (r, i, o) {
                function a(t) {
                  e.resolve(t);
                }
                function s() {
                  0 == --n && e.reject(new Error("Can't get fulfillment value from any promise, all promises were rejected."));
                }
                function u(t) {
                  e.notify({
                    index: o,
                    value: t
                  });
                }
                var c = t[o];
                n++, g(c, a, s, u);
              }, void 0), e.promise;
            }
            function j(t) {
              return g(t, function (t) {
                return t = X(t, f), g(F(X(t, function (t) {
                  return g(t, z, z);
                })), function () {
                  return t;
                });
              });
            }
            function U(t) {
              return f(t).allSettled();
            }
            function B(t, e) {
              return f(t).then(void 0, void 0, e);
            }
            function V(t, e) {
              return f(t).nodeify(e);
            }
            var q = !1;
            try {
              throw new Error();
            } catch (t) {
              q = !!t.stack;
            }
            var H,
              W,
              $ = l(),
              z = function z() {},
              G = function () {
                function t() {
                  for (var t, e; i.next;) i = i.next, t = i.task, i.task = void 0, e = i.domain, e && (i.domain = void 0, e.enter()), r(t, e);
                  for (; c.length;) t = c.pop(), r(t);
                  a = !1;
                }
                function r(e, n) {
                  try {
                    e();
                  } catch (e) {
                    if (u) throw n && n.exit(), setTimeout(t, 0), n && n.enter(), e;
                    setTimeout(function () {
                      throw e;
                    }, 0);
                  }
                  n && n.exit();
                }
                var i = {
                    task: void 0,
                    next: null
                  },
                  o = i,
                  a = !1,
                  s = void 0,
                  u = !1,
                  c = [];
                if (G = function G(t) {
                  o = o.next = {
                    task: t,
                    domain: u && e.domain,
                    next: null
                  }, a || (a = !0, s());
                }, "object" == typeof e && "[object process]" === e.toString() && e.nextTick) u = !0, s = function s() {
                  e.nextTick(t);
                };else if ("function" == typeof n) s = "undefined" != typeof window ? n.bind(window, t) : function () {
                  n(t);
                };else if ("undefined" != typeof MessageChannel) {
                  var l = new MessageChannel();
                  l.port1.onmessage = function () {
                    s = f, l.port1.onmessage = t, t();
                  };
                  var f = function f() {
                    l.port2.postMessage(0);
                  };
                  s = function s() {
                    setTimeout(t, 0), f();
                  };
                } else s = function s() {
                  setTimeout(t, 0);
                };
                return G.runAfter = function (t) {
                  c.push(t), a || (a = !0, s());
                }, G;
              }(),
              K = Function.call,
              Y = t(Array.prototype.slice),
              J = t(Array.prototype.reduce || function (t, e) {
                var n = 0,
                  r = this.length;
                if (1 === arguments.length) for (;;) {
                  if (n in this) {
                    e = this[n++];
                    break;
                  }
                  if (++n >= r) throw new TypeError();
                }
                for (; n < r; n++) n in this && (e = t(e, this[n], n));
                return e;
              }),
              Q = t(Array.prototype.indexOf || function (t) {
                for (var e = 0; e < this.length; e++) if (this[e] === t) return e;
                return -1;
              }),
              X = t(Array.prototype.map || function (t, e) {
                var n = this,
                  r = [];
                return J(n, function (i, o, a) {
                  r.push(t.call(e, o, a, n));
                }, void 0), r;
              }),
              Z = Object.create || function (t) {
                function e() {}
                return e.prototype = t, new e();
              },
              tt = t(Object.prototype.hasOwnProperty),
              et = Object.keys || function (t) {
                var e = [];
                for (var n in t) tt(t, n) && e.push(n);
                return e;
              },
              nt = t(Object.prototype.toString);
            W = "undefined" != typeof ReturnValue ? ReturnValue : function (t) {
              this.value = t;
            };
            var rt = "From previous event:";
            f.resolve = f, f.nextTick = G, f.longStackSupport = !1, "object" == typeof e && e && e.env && e.env.Q_DEBUG && (f.longStackSupport = !0), f.defer = p, p.prototype.makeNodeResolver = function () {
              var t = this;
              return function (e, n) {
                e ? t.reject(e) : arguments.length > 2 ? t.resolve(Y(arguments, 1)) : t.resolve(n);
              };
            }, f.Promise = d, f.promise = d, d.race = h, d.all = F, d.reject = k, d.resolve = f, f.passByCopy = function (t) {
              return t;
            }, m.prototype.passByCopy = function () {
              return this;
            }, f.join = function (t, e) {
              return f(t).join(e);
            }, m.prototype.join = function (t) {
              return f([this, t]).spread(function (t, e) {
                if (t === e) return t;
                throw new Error("Can't join: not the same: " + t + " " + e);
              });
            }, f.race = h, m.prototype.race = function () {
              return this.then(f.race);
            }, f.makePromise = m, m.prototype.toString = function () {
              return "[object Promise]";
            }, m.prototype.then = function (t, e, n) {
              function r(e) {
                try {
                  return "function" == typeof t ? t(e) : e;
                } catch (t) {
                  return k(t);
                }
              }
              function i(t) {
                if ("function" == typeof e) {
                  o(t, s);
                  try {
                    return e(t);
                  } catch (t) {
                    return k(t);
                  }
                }
                return k(t);
              }
              function a(t) {
                return "function" == typeof n ? n(t) : t;
              }
              var s = this,
                u = p(),
                c = !1;
              return f.nextTick(function () {
                s.promiseDispatch(function (t) {
                  c || (c = !0, u.resolve(r(t)));
                }, "when", [function (t) {
                  c || (c = !0, u.resolve(i(t)));
                }]);
              }), s.promiseDispatch(void 0, "when", [void 0, function (t) {
                var e,
                  n = !1;
                try {
                  e = a(t);
                } catch (t) {
                  if (n = !0, !f.onerror) throw t;
                  f.onerror(t);
                }
                n || u.notify(e);
              }]), u.promise;
            }, f.tap = function (t, e) {
              return f(t).tap(e);
            }, m.prototype.tap = function (t) {
              return t = f(t), this.then(function (e) {
                return t.fcall(e).thenResolve(e);
              });
            }, f.when = g, m.prototype.thenResolve = function (t) {
              return this.then(function () {
                return t;
              });
            }, f.thenResolve = function (t, e) {
              return f(t).thenResolve(e);
            }, m.prototype.thenReject = function (t) {
              return this.then(function () {
                throw t;
              });
            }, f.thenReject = function (t, e) {
              return f(t).thenReject(e);
            }, f.nearer = v, f.isPromise = y, f.isPromiseAlike = _, f.isPending = b, m.prototype.isPending = function () {
              return "pending" === this.inspect().state;
            }, f.isFulfilled = w, m.prototype.isFulfilled = function () {
              return "fulfilled" === this.inspect().state;
            }, f.isRejected = S, m.prototype.isRejected = function () {
              return "rejected" === this.inspect().state;
            };
            var it = [],
              ot = [],
              at = [],
              st = !0;
            f.resetUnhandledRejections = x, f.getUnhandledReasons = function () {
              return it.slice();
            }, f.stopUnhandledRejectionTracking = function () {
              x(), st = !1;
            }, x(), f.reject = k, f.fulfill = A, f.master = C, f.spread = I, m.prototype.spread = function (t, e) {
              return this.all().then(function (e) {
                return t.apply(void 0, e);
              }, e);
            }, f.async = R, f.spawn = P, f.return = N, f.promised = M, f.dispatch = L, m.prototype.dispatch = function (t, e) {
              var n = this,
                r = p();
              return f.nextTick(function () {
                n.promiseDispatch(r.resolve, t, e);
              }), r.promise;
            }, f.get = function (t, e) {
              return f(t).dispatch("get", [e]);
            }, m.prototype.get = function (t) {
              return this.dispatch("get", [t]);
            }, f.set = function (t, e, n) {
              return f(t).dispatch("set", [e, n]);
            }, m.prototype.set = function (t, e) {
              return this.dispatch("set", [t, e]);
            }, f.del = f.delete = function (t, e) {
              return f(t).dispatch("delete", [e]);
            }, m.prototype.del = m.prototype.delete = function (t) {
              return this.dispatch("delete", [t]);
            }, f.mapply = f.post = function (t, e, n) {
              return f(t).dispatch("post", [e, n]);
            }, m.prototype.mapply = m.prototype.post = function (t, e) {
              return this.dispatch("post", [t, e]);
            }, f.send = f.mcall = f.invoke = function (t, e) {
              return f(t).dispatch("post", [e, Y(arguments, 2)]);
            }, m.prototype.send = m.prototype.mcall = m.prototype.invoke = function (t) {
              return this.dispatch("post", [t, Y(arguments, 1)]);
            }, f.fapply = function (t, e) {
              return f(t).dispatch("apply", [void 0, e]);
            }, m.prototype.fapply = function (t) {
              return this.dispatch("apply", [void 0, t]);
            }, f.try = f.fcall = function (t) {
              return f(t).dispatch("apply", [void 0, Y(arguments, 1)]);
            }, m.prototype.fcall = function () {
              return this.dispatch("apply", [void 0, Y(arguments)]);
            }, f.fbind = function (t) {
              var e = f(t),
                n = Y(arguments, 1);
              return function () {
                return e.dispatch("apply", [this, n.concat(Y(arguments))]);
              };
            }, m.prototype.fbind = function () {
              var t = this,
                e = Y(arguments);
              return function () {
                return t.dispatch("apply", [this, e.concat(Y(arguments))]);
              };
            }, f.keys = function (t) {
              return f(t).dispatch("keys", []);
            }, m.prototype.keys = function () {
              return this.dispatch("keys", []);
            }, f.all = F, m.prototype.all = function () {
              return F(this);
            }, f.any = D, m.prototype.any = function () {
              return D(this);
            }, f.allResolved = function (t, e, n) {
              return function () {
                return "undefined" != typeof console && console.warn, t.apply(t, arguments);
              };
            }(j), m.prototype.allResolved = function () {
              return j(this);
            }, f.allSettled = U, m.prototype.allSettled = function () {
              return this.then(function (t) {
                return F(X(t, function (t) {
                  function e() {
                    return t.inspect();
                  }
                  return t = f(t), t.then(e, e);
                }));
              });
            }, f.fail = f.catch = function (t, e) {
              return f(t).then(void 0, e);
            }, m.prototype.fail = m.prototype.catch = function (t) {
              return this.then(void 0, t);
            }, f.progress = B, m.prototype.progress = function (t) {
              return this.then(void 0, void 0, t);
            }, f.fin = f.finally = function (t, e) {
              return f(t).finally(e);
            }, m.prototype.fin = m.prototype.finally = function (t) {
              return t = f(t), this.then(function (e) {
                return t.fcall().then(function () {
                  return e;
                });
              }, function (e) {
                return t.fcall().then(function () {
                  throw e;
                });
              });
            }, f.done = function (t, e, n, r) {
              return f(t).done(e, n, r);
            }, m.prototype.done = function (t, n, r) {
              var i = function i(t) {
                  f.nextTick(function () {
                    if (o(t, a), !f.onerror) throw t;
                    f.onerror(t);
                  });
                },
                a = t || n || r ? this.then(t, n, r) : this;
              "object" == typeof e && e && e.domain && (i = e.domain.bind(i)), a.then(void 0, i);
            }, f.timeout = function (t, e, n) {
              return f(t).timeout(e, n);
            }, m.prototype.timeout = function (t, e) {
              var n = p(),
                r = setTimeout(function () {
                  e && "string" != typeof e || (e = new Error(e || "Timed out after " + t + " ms"), e.code = "ETIMEDOUT"), n.reject(e);
                }, t);
              return this.then(function (t) {
                clearTimeout(r), n.resolve(t);
              }, function (t) {
                clearTimeout(r), n.reject(t);
              }, n.notify), n.promise;
            }, f.delay = function (t, e) {
              return void 0 === e && (e = t, t = void 0), f(t).delay(e);
            }, m.prototype.delay = function (t) {
              return this.then(function (e) {
                var n = p();
                return setTimeout(function () {
                  n.resolve(e);
                }, t), n.promise;
              });
            }, f.nfapply = function (t, e) {
              return f(t).nfapply(e);
            }, m.prototype.nfapply = function (t) {
              var e = p(),
                n = Y(t);
              return n.push(e.makeNodeResolver()), this.fapply(n).fail(e.reject), e.promise;
            }, f.nfcall = function (t) {
              var e = Y(arguments, 1);
              return f(t).nfapply(e);
            }, m.prototype.nfcall = function () {
              var t = Y(arguments),
                e = p();
              return t.push(e.makeNodeResolver()), this.fapply(t).fail(e.reject), e.promise;
            }, f.nfbind = f.denodeify = function (t) {
              var e = Y(arguments, 1);
              return function () {
                var n = e.concat(Y(arguments)),
                  r = p();
                return n.push(r.makeNodeResolver()), f(t).fapply(n).fail(r.reject), r.promise;
              };
            }, m.prototype.nfbind = m.prototype.denodeify = function () {
              var t = Y(arguments);
              return t.unshift(this), f.denodeify.apply(void 0, t);
            }, f.nbind = function (t, e) {
              var n = Y(arguments, 2);
              return function () {
                function r() {
                  return t.apply(e, arguments);
                }
                var i = n.concat(Y(arguments)),
                  o = p();
                return i.push(o.makeNodeResolver()), f(r).fapply(i).fail(o.reject), o.promise;
              };
            }, m.prototype.nbind = function () {
              var t = Y(arguments, 0);
              return t.unshift(this), f.nbind.apply(void 0, t);
            }, f.nmapply = f.npost = function (t, e, n) {
              return f(t).npost(e, n);
            }, m.prototype.nmapply = m.prototype.npost = function (t, e) {
              var n = Y(e || []),
                r = p();
              return n.push(r.makeNodeResolver()), this.dispatch("post", [t, n]).fail(r.reject), r.promise;
            }, f.nsend = f.nmcall = f.ninvoke = function (t, e) {
              var n = Y(arguments, 2),
                r = p();
              return n.push(r.makeNodeResolver()), f(t).dispatch("post", [e, n]).fail(r.reject), r.promise;
            }, m.prototype.nsend = m.prototype.nmcall = m.prototype.ninvoke = function (t) {
              var e = Y(arguments, 1),
                n = p();
              return e.push(n.makeNodeResolver()), this.dispatch("post", [t, e]).fail(n.reject), n.promise;
            }, f.nodeify = V, m.prototype.nodeify = function (t) {
              if (!t) return this;
              this.then(function (e) {
                f.nextTick(function () {
                  t(null, e);
                });
              }, function (e) {
                f.nextTick(function () {
                  t(e);
                });
              });
            }, f.noConflict = function () {
              throw new Error("Q.noConflict only works when Q is used as a global");
            };
            var ut = l();
            return f;
          });
        }).call(e, n(8), n(20).setImmediate);
      }, function (t, e, n) {
        function r(t, e) {
          function n() {
            var n = t.getItem(e);
            n = n || "{}";
            try {
              return JSON.parse(n);
            } catch (t) {
              throw new i("Unable to parse storage string: " + e);
            }
          }
          function r(n) {
            try {
              var r = JSON.stringify(n);
              t.setItem(e, r);
            } catch (t) {
              throw new i("Unable to set storage: " + e);
            }
          }
          function o(t) {
            t || r({});
            var e = n();
            delete e[t], r(e);
          }
          function a(t, e) {
            var i = n();
            i[t] = e, r(i);
          }
          if ("string" != typeof e || !e.length) throw new i('"storageName" is required');
          return {
            getStorage: n,
            setStorage: r,
            clearStorage: o,
            updateStorage: a
          };
        }
        var i = n(1);
        t.exports = r;
      }, function (t, e, n) {
        function r(t, e) {
          var n = {};
          return v.extend(n, e), !n.stateToken && t.stateToken && (n.stateToken = t.stateToken), n;
        }
        function i(t) {
          return r(t);
        }
        function o(t, e) {
          return e = r(t, e), g.post(t, t.options.url + "/api/v1/authn", e);
        }
        function a(t, e) {
          if (!e || !e.stateToken) {
            var n = t.tx.exists._get(w.STATE_TOKEN_KEY_NAME);
            if (!n) return y.reject(new _("No transaction to resume"));
            e = {
              stateToken: n
            };
          }
          return t.tx.status(e).then(function (e) {
            return new m(t, e);
          });
        }
        function s(t, e) {
          if (!e || !e.stateToken) {
            var n = t.tx.exists._get(w.STATE_TOKEN_KEY_NAME);
            if (!n) return y.reject(new _("No transaction to evaluate"));
            e = {
              stateToken: n
            };
          }
          return u(t, e).then(function (e) {
            return new m(t, e);
          });
        }
        function u(t, e) {
          return e = r(t, e), g.post(t, t.options.url + "/api/v1/authn/introspect", e);
        }
        function c(t) {
          return !!t.tx.exists._get(w.STATE_TOKEN_KEY_NAME);
        }
        function l(t, e, n, r) {
          return g.post(t, e, n, r).then(function (e) {
            return new m(t, e);
          });
        }
        function f(t, e, n) {
          return function (r) {
            function o() {
              var n = {};
              if ("function" == typeof u) try {
                n.autoPush = !!u();
              } catch (t) {
                return y.reject(new _("AutoPush resulted in an error."));
              } else void 0 !== u && null !== u && (n.autoPush = !!u);
              if ("function" == typeof s) try {
                n.rememberDevice = !!s();
              } catch (t) {
                return y.reject(new _("RememberDevice resulted in an error."));
              } else void 0 !== s && null !== s && (n.rememberDevice = !!s);
              var r = l.href + v.toQueryParams(n);
              return g.post(t, r, i(e), {
                saveAuthnState: !1
              });
            }
            var a, s, u, c;
            v.isNumber(r) ? a = r : v.isObject(r) && (a = r.delay, s = r.rememberDevice, u = r.autoPush, c = r.transactionCallBack), a || 0 === a || (a = w.DEFAULT_POLLING_DELAY);
            var l = v.getLink(e, "next", "poll");
            n.isPolling = !0;
            var f = 0,
              p = function p() {
                return n.isPolling ? o().then(function (e) {
                  if (f = 0, e.factorResult && "WAITING" === e.factorResult) {
                    if (!n.isPolling) throw new b();
                    return "function" == typeof c && c(e), y.delay(a).then(p);
                  }
                  return n.isPolling = !1, new m(t, e);
                }).fail(function (t) {
                  if (t.xhr && (0 === t.xhr.status || 429 === t.xhr.status) && f <= 4) {
                    var e = 1e3 * Math.pow(2, f);
                    return f++, y.delay(e).then(p);
                  }
                  throw t;
                }) : y.reject(new b());
              };
            return p().fail(function (t) {
              throw n.isPolling = !1, t;
            });
          };
        }
        function p(t, e, n, i, o) {
          if (Array.isArray(i)) return function (r, a) {
            if (!r) throw new _("Must provide a link name");
            var s = v.find(i, {
              name: r
            });
            if (!s) throw new _("No link found for that name");
            return p(t, e, n, s, o)(a);
          };
          if (i.hints && i.hints.allow && 1 === i.hints.allow.length) switch (i.hints.allow[0]) {
            case "GET":
              return function () {
                return g.get(t, i.href);
              };
            case "POST":
              return function (a) {
                o && o.isPolling && (o.isPolling = !1);
                var s = r(e, a);
                "MFA_ENROLL" !== e.status && "FACTOR_ENROLL" !== e.status || v.extend(s, {
                  factorType: n.factorType,
                  provider: n.provider
                });
                var u = {},
                  c = s.autoPush;
                if (void 0 !== c) {
                  if ("function" == typeof c) try {
                    u.autoPush = !!c();
                  } catch (t) {
                    return y.reject(new _("AutoPush resulted in an error."));
                  } else null !== c && (u.autoPush = !!c);
                  s = v.omit(s, "autoPush");
                }
                var f = s.rememberDevice;
                if (void 0 !== f) {
                  if ("function" == typeof f) try {
                    u.rememberDevice = !!f();
                  } catch (t) {
                    return y.reject(new _("RememberDevice resulted in an error."));
                  } else null !== f && (u.rememberDevice = !!f);
                  s = v.omit(s, "rememberDevice");
                } else s.profile && void 0 !== s.profile.updatePhone && (s.profile.updatePhone && (u.updatePhone = !0), s.profile = v.omit(s.profile, "updatePhone"));
                var p = i.href + v.toQueryParams(u);
                return l(t, p, s);
              };
          }
        }
        function d(t, e, n, r) {
          var i = {};
          for (var o in n._links) if (n._links.hasOwnProperty(o)) {
            var a = n._links[o];
            if ("next" === o && (o = a.name), a.type) i[o] = a;else switch (o) {
              case "poll":
                i.poll = f(t, e, r);
                break;
              default:
                var s = p(t, e, n, a, r);
                s && (i[o] = s);
            }
          }
          return i;
        }
        function h(t, e, n, r) {
          if (n = n || e, n = v.clone(n), Array.isArray(n)) {
            for (var i = [], o = 0, a = n.length; o < a; o++) i.push(h(t, e, n[o], r));
            return i;
          }
          var s = n._embedded || {};
          for (var u in s) s.hasOwnProperty(u) && (v.isObject(s[u]) || Array.isArray(s[u])) && (s[u] = h(t, e, s[u], r));
          var c = d(t, e, n, r);
          return v.extend(s, c), n = v.omit(n, "_embedded", "_links"), v.extend(n, s), n;
        }
        function m(t, e) {
          e && (this.data = e, v.extend(this, h(t, e, e, {})), delete this.stateToken, "RECOVERY_CHALLENGE" !== e.status || e._links || (this.cancel = function () {
            return new y(new m(t));
          }));
        }
        var g = n(3),
          v = n(0),
          y = n(5),
          _ = n(1),
          b = n(23),
          w = n(2);
        t.exports = {
          transactionStatus: o,
          resumeTransaction: a,
          transactionExists: c,
          postToTransaction: l,
          introspect: s
        };
      }, function (t, e) {
        function n() {
          throw new Error("setTimeout has not been defined");
        }
        function r() {
          throw new Error("clearTimeout has not been defined");
        }
        function i(t) {
          if (l === setTimeout) return setTimeout(t, 0);
          if ((l === n || !l) && setTimeout) return l = setTimeout, setTimeout(t, 0);
          try {
            return l(t, 0);
          } catch (e) {
            try {
              return l.call(null, t, 0);
            } catch (e) {
              return l.call(this, t, 0);
            }
          }
        }
        function o(t) {
          if (f === clearTimeout) return clearTimeout(t);
          if ((f === r || !f) && clearTimeout) return f = clearTimeout, clearTimeout(t);
          try {
            return f(t);
          } catch (e) {
            try {
              return f.call(null, t);
            } catch (e) {
              return f.call(this, t);
            }
          }
        }
        function a() {
          m && d && (m = !1, d.length ? h = d.concat(h) : g = -1, h.length && s());
        }
        function s() {
          if (!m) {
            var t = i(a);
            m = !0;
            for (var e = h.length; e;) {
              for (d = h, h = []; ++g < e;) d && d[g].run();
              g = -1, e = h.length;
            }
            d = null, m = !1, o(t);
          }
        }
        function u(t, e) {
          this.fun = t, this.array = e;
        }
        function c() {}
        var l,
          f,
          p = t.exports = {};
        !function () {
          try {
            l = "function" == typeof setTimeout ? setTimeout : n;
          } catch (t) {
            l = n;
          }
          try {
            f = "function" == typeof clearTimeout ? clearTimeout : r;
          } catch (t) {
            f = r;
          }
        }();
        var d,
          h = [],
          m = !1,
          g = -1;
        p.nextTick = function (t) {
          var e = new Array(arguments.length - 1);
          if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
          h.push(new u(t, e)), 1 !== h.length || m || i(s);
        }, u.prototype.run = function () {
          this.fun.apply(null, this.array);
        }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = c, p.addListener = c, p.once = c, p.off = c, p.removeListener = c, p.removeAllListeners = c, p.emit = c, p.prependListener = c, p.prependOnceListener = c, p.listeners = function (t) {
          return [];
        }, p.binding = function (t) {
          throw new Error("process.binding is not supported");
        }, p.cwd = function () {
          return "/";
        }, p.chdir = function (t) {
          throw new Error("process.chdir is not supported");
        }, p.umask = function () {
          return 0;
        };
      }, function (t, e) {
        var n;
        n = function () {
          return this;
        }();
        try {
          n = n || Function("return this")() || (0, eval)("this");
        } catch (t) {
          "object" == typeof window && (n = window);
        }
        t.exports = n;
      }, function (t, e, n) {
        function r() {
          return g.genRandomString(64);
        }
        function i() {
          return g.genRandomString(64);
        }
        function o(t) {
          return !(!t || !t.accessToken && !t.idToken || !Array.isArray(t.scopes));
        }
        function a(t, e, n) {
          t.addEventListener ? t.addEventListener(e, n) : t.attachEvent("on" + e, n);
        }
        function s(t, e, n) {
          t.removeEventListener ? t.removeEventListener(e, n) : t.detachEvent("on" + e, n);
        }
        function u(t) {
          var e = document.createElement("iframe");
          return e.style.display = "none", e.src = t, document.body.appendChild(e);
        }
        function c(t, e) {
          var n = e.popupTitle || "External Identity Provider User Authentication",
            r = "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600";
          if (g.isIE11OrLess()) {
            var i = window.open("/", n, r);
            return i.location.href = t, i;
          }
          return window.open(t, n, r);
        }
        function l(t, e) {
          var n = e || t.options.issuer || t.options.url;
          return m.get(t, n + "/.well-known/openid-configuration", {
            cacheResponse: !0
          });
        }
        function f(t, e, n) {
          return l(t, e).then(function (e) {
            var r = e.jwks_uri,
              i = _.getStorage(),
              o = i[r];
            if (o && Date.now() / 1e3 < o.expiresAt) {
              var a = g.find(o.response.keys, {
                kid: n
              });
              if (a) return a;
            }
            return _.clearStorage(r), m.get(t, r, {
              cacheResponse: !0
            }).then(function (t) {
              var e = g.find(t.keys, {
                kid: n
              });
              if (e) return e;
              throw new y("The key id, " + n + ", was not found in the server's keys");
            });
          });
        }
        function p(t, e, n) {
          var r = n.clientId,
            i = n.issuer,
            o = n.nonce;
          if (!e || !i || !r) throw new y("The jwt, iss, and aud arguments are all required");
          if (o && e.nonce !== o) throw new y("OAuth flow response nonce doesn't match request nonce");
          var a = Math.floor(Date.now() / 1e3);
          if (e.iss !== i) throw new y("The issuer [" + e.iss + "] does not match [" + i + "]");
          if (e.aud !== r) throw new y("The audience [" + e.aud + "] does not match [" + r + "]");
          if (e.iat > e.exp) throw new y("The JWT expired before it was issued");
          if (a - t.options.maxClockSkew > e.exp) throw new y("The JWT expired and is no longer valid");
          if (e.iat > a + t.options.maxClockSkew) throw new y("The JWT was issued in the future");
        }
        function d(t, e, n) {
          n = n || {};
          var r = g.removeTrailingSlash(n.authorizeUrl) || t.options.authorizeUrl,
            i = g.removeTrailingSlash(n.issuer) || t.options.issuer,
            o = g.removeTrailingSlash(n.userinfoUrl) || t.options.userinfoUrl,
            a = g.removeTrailingSlash(n.tokenUrl) || t.options.tokenUrl,
            s = g.removeTrailingSlash(n.logoutUrl) || t.options.logoutUrl,
            u = g.removeTrailingSlash(n.revokeUrl) || t.options.revokeUrl;
          if (i && !/^https?:/.test(i) && (i = t.options.url + "/oauth2/" + i), !i && r && -1 !== e.responseType.indexOf("id_token")) throw new y("Cannot request idToken with an authorizeUrl without an issuer");
          if (!i && e && -1 !== e.responseType.indexOf("token")) {
            if (r && !o) throw new y("Cannot request accessToken with an authorizeUrl without an issuer or userinfoUrl");
            if (o && !r) throw new y("Cannot request token with an userinfoUrl without an issuer or authorizeUrl");
          }
          i = i || t.options.url, i = g.removeTrailingSlash(i);
          var c = i;
          return new RegExp("^https?://.*?/oauth2/.+").test(c) || c.endsWith("/oauth2") || (c += "/oauth2"), r = r || c + "/v1/authorize", o = o || c + "/v1/userinfo", a = a || c + "/v1/token", u = u || c + "/v1/revoke", s = s || c + "/v1/logout", {
            issuer: i,
            authorizeUrl: r,
            userinfoUrl: o,
            tokenUrl: a,
            revokeUrl: u,
            logoutUrl: s
          };
        }
        function h(t) {
          for (var e, n = /\+/g, r = /([^&=]+)=?([^&]*)/g, i = t.substring(1), o = {}; e = r.exec(i);) {
            var a = e[1],
              s = e[2];
            o[a] = "id_token" === a || "access_token" === a || "code" === a ? s : decodeURIComponent(s.replace(n, " "));
          }
          return o;
        }
        var m = n(3),
          g = n(0),
          v = n(4),
          y = n(1),
          _ = v.getHttpCache();
        t.exports = {
          generateState: r,
          generateNonce: i,
          getWellKnown: l,
          getKey: f,
          validateClaims: p,
          getOAuthUrls: d,
          loadFrame: u,
          loadPopup: c,
          urlParamsToObject: h,
          isToken: o,
          addListener: a,
          removeListener: s
        };
      }, function (t, e, n) {
        var r = n(12),
          i = n(4);
        t.exports = n(15)(i, r);
      }, function (t, e, n) {
        function r(t, e, n) {
          var r = n.data,
            o = n.headers || {};
          return "application/json" === (o["Content-Type"] || o["content-type"] || "") && r && "string" != typeof r && (r = JSON.stringify(r)), i(e, {
            method: t,
            headers: n.headers,
            body: r,
            credentials: !1 === n.withCredentials ? "omit" : "include"
          }).then(function (t) {
            var e = !t.ok,
              n = t.status,
              r = function r(t) {
                var r = {
                  responseText: t,
                  status: n
                };
                if (e) throw r;
                return r;
              };
            return t.headers.get("Content-Type") && t.headers.get("Content-Type").toLowerCase().indexOf("application/json") >= 0 ? t.json().then(r) : t.text().then(r);
          });
        }
        var i = n(13);
        t.exports = r;
      }, function (t, e) {
        var n = function (t) {
          function e() {
            this.fetch = !1, this.DOMException = t.DOMException;
          }
          return e.prototype = t, new e();
        }("undefined" != typeof self ? self : this);
        !function (t) {
          !function (e) {
            function n(t) {
              return t && DataView.prototype.isPrototypeOf(t);
            }
            function r(t) {
              if ("string" != typeof t && (t = String(t)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(t)) throw new TypeError("Invalid character in header field name");
              return t.toLowerCase();
            }
            function i(t) {
              return "string" != typeof t && (t = String(t)), t;
            }
            function o(t) {
              var e = {
                next: function next() {
                  var e = t.shift();
                  return {
                    done: void 0 === e,
                    value: e
                  };
                }
              };
              return b.iterable && (e[Symbol.iterator] = function () {
                return e;
              }), e;
            }
            function a(t) {
              this.map = {}, t instanceof a ? t.forEach(function (t, e) {
                this.append(e, t);
              }, this) : Array.isArray(t) ? t.forEach(function (t) {
                this.append(t[0], t[1]);
              }, this) : t && Object.getOwnPropertyNames(t).forEach(function (e) {
                this.append(e, t[e]);
              }, this);
            }
            function s(t) {
              if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
              t.bodyUsed = !0;
            }
            function u(t) {
              return new Promise(function (e, n) {
                t.onload = function () {
                  e(t.result);
                }, t.onerror = function () {
                  n(t.error);
                };
              });
            }
            function c(t) {
              var e = new FileReader(),
                n = u(e);
              return e.readAsArrayBuffer(t), n;
            }
            function l(t) {
              var e = new FileReader(),
                n = u(e);
              return e.readAsText(t), n;
            }
            function f(t) {
              for (var e = new Uint8Array(t), n = new Array(e.length), r = 0; r < e.length; r++) n[r] = String.fromCharCode(e[r]);
              return n.join("");
            }
            function p(t) {
              if (t.slice) return t.slice(0);
              var e = new Uint8Array(t.byteLength);
              return e.set(new Uint8Array(t)), e.buffer;
            }
            function d() {
              return this.bodyUsed = !1, this._initBody = function (t) {
                this._bodyInit = t, t ? "string" == typeof t ? this._bodyText = t : b.blob && Blob.prototype.isPrototypeOf(t) ? this._bodyBlob = t : b.formData && FormData.prototype.isPrototypeOf(t) ? this._bodyFormData = t : b.searchParams && URLSearchParams.prototype.isPrototypeOf(t) ? this._bodyText = t.toString() : b.arrayBuffer && b.blob && n(t) ? (this._bodyArrayBuffer = p(t.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : b.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(t) || S(t)) ? this._bodyArrayBuffer = p(t) : this._bodyText = t = Object.prototype.toString.call(t) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof t ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : b.searchParams && URLSearchParams.prototype.isPrototypeOf(t) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
              }, b.blob && (this.blob = function () {
                var t = s(this);
                if (t) return t;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                return Promise.resolve(new Blob([this._bodyText]));
              }, this.arrayBuffer = function () {
                return this._bodyArrayBuffer ? s(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(c);
              }), this.text = function () {
                var t = s(this);
                if (t) return t;
                if (this._bodyBlob) return l(this._bodyBlob);
                if (this._bodyArrayBuffer) return Promise.resolve(f(this._bodyArrayBuffer));
                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                return Promise.resolve(this._bodyText);
              }, b.formData && (this.formData = function () {
                return this.text().then(g);
              }), this.json = function () {
                return this.text().then(JSON.parse);
              }, this;
            }
            function h(t) {
              var e = t.toUpperCase();
              return x.indexOf(e) > -1 ? e : t;
            }
            function m(t, e) {
              e = e || {};
              var n = e.body;
              if (t instanceof m) {
                if (t.bodyUsed) throw new TypeError("Already read");
                this.url = t.url, this.credentials = t.credentials, e.headers || (this.headers = new a(t.headers)), this.method = t.method, this.mode = t.mode, this.signal = t.signal, n || null == t._bodyInit || (n = t._bodyInit, t.bodyUsed = !0);
              } else this.url = String(t);
              if (this.credentials = e.credentials || this.credentials || "same-origin", !e.headers && this.headers || (this.headers = new a(e.headers)), this.method = h(e.method || this.method || "GET"), this.mode = e.mode || this.mode || null, this.signal = e.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && n) throw new TypeError("Body not allowed for GET or HEAD requests");
              this._initBody(n);
            }
            function g(t) {
              var e = new FormData();
              return t.trim().split("&").forEach(function (t) {
                if (t) {
                  var n = t.split("="),
                    r = n.shift().replace(/\+/g, " "),
                    i = n.join("=").replace(/\+/g, " ");
                  e.append(decodeURIComponent(r), decodeURIComponent(i));
                }
              }), e;
            }
            function v(t) {
              var e = new a();
              return t.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (t) {
                var n = t.split(":"),
                  r = n.shift().trim();
                if (r) {
                  var i = n.join(":").trim();
                  e.append(r, i);
                }
              }), e;
            }
            function y(t, e) {
              e || (e = {}), this.type = "default", this.status = void 0 === e.status ? 200 : e.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in e ? e.statusText : "OK", this.headers = new a(e.headers), this.url = e.url || "", this._initBody(t);
            }
            function _(t, n) {
              return new Promise(function (r, i) {
                function o() {
                  s.abort();
                }
                var a = new m(t, n);
                if (a.signal && a.signal.aborted) return i(new e.DOMException("Aborted", "AbortError"));
                var s = new XMLHttpRequest();
                s.onload = function () {
                  var t = {
                    status: s.status,
                    statusText: s.statusText,
                    headers: v(s.getAllResponseHeaders() || "")
                  };
                  t.url = "responseURL" in s ? s.responseURL : t.headers.get("X-Request-URL");
                  var e = "response" in s ? s.response : s.responseText;
                  r(new y(e, t));
                }, s.onerror = function () {
                  i(new TypeError("Network request failed"));
                }, s.ontimeout = function () {
                  i(new TypeError("Network request failed"));
                }, s.onabort = function () {
                  i(new e.DOMException("Aborted", "AbortError"));
                }, s.open(a.method, a.url, !0), "include" === a.credentials ? s.withCredentials = !0 : "omit" === a.credentials && (s.withCredentials = !1), "responseType" in s && b.blob && (s.responseType = "blob"), a.headers.forEach(function (t, e) {
                  s.setRequestHeader(e, t);
                }), a.signal && (a.signal.addEventListener("abort", o), s.onreadystatechange = function () {
                  4 === s.readyState && a.signal.removeEventListener("abort", o);
                }), s.send(void 0 === a._bodyInit ? null : a._bodyInit);
              });
            }
            var b = {
              searchParams: "URLSearchParams" in t,
              iterable: "Symbol" in t && "iterator" in Symbol,
              blob: "FileReader" in t && "Blob" in t && function () {
                try {
                  return new Blob(), !0;
                } catch (t) {
                  return !1;
                }
              }(),
              formData: "FormData" in t,
              arrayBuffer: "ArrayBuffer" in t
            };
            if (b.arrayBuffer) var w = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
              S = ArrayBuffer.isView || function (t) {
                return t && w.indexOf(Object.prototype.toString.call(t)) > -1;
              };
            a.prototype.append = function (t, e) {
              t = r(t), e = i(e);
              var n = this.map[t];
              this.map[t] = n ? n + ", " + e : e;
            }, a.prototype.delete = function (t) {
              delete this.map[r(t)];
            }, a.prototype.get = function (t) {
              return t = r(t), this.has(t) ? this.map[t] : null;
            }, a.prototype.has = function (t) {
              return this.map.hasOwnProperty(r(t));
            }, a.prototype.set = function (t, e) {
              this.map[r(t)] = i(e);
            }, a.prototype.forEach = function (t, e) {
              for (var n in this.map) this.map.hasOwnProperty(n) && t.call(e, this.map[n], n, this);
            }, a.prototype.keys = function () {
              var t = [];
              return this.forEach(function (e, n) {
                t.push(n);
              }), o(t);
            }, a.prototype.values = function () {
              var t = [];
              return this.forEach(function (e) {
                t.push(e);
              }), o(t);
            }, a.prototype.entries = function () {
              var t = [];
              return this.forEach(function (e, n) {
                t.push([n, e]);
              }), o(t);
            }, b.iterable && (a.prototype[Symbol.iterator] = a.prototype.entries);
            var x = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
            m.prototype.clone = function () {
              return new m(this, {
                body: this._bodyInit
              });
            }, d.call(m.prototype), d.call(y.prototype), y.prototype.clone = function () {
              return new y(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new a(this.headers),
                url: this.url
              });
            }, y.error = function () {
              var t = new y(null, {
                status: 0,
                statusText: ""
              });
              return t.type = "error", t;
            };
            var E = [301, 302, 303, 307, 308];
            y.redirect = function (t, e) {
              if (-1 === E.indexOf(e)) throw new RangeError("Invalid status code");
              return new y(null, {
                status: e,
                headers: {
                  location: t
                }
              });
            }, e.DOMException = t.DOMException;
            try {
              new e.DOMException();
            } catch (t) {
              e.DOMException = function (t, e) {
                this.message = t, this.name = e;
                var n = Error(t);
                this.stack = n.stack;
              }, e.DOMException.prototype = Object.create(Error.prototype), e.DOMException.prototype.constructor = e.DOMException;
            }
            _.polyfill = !0, t.fetch || (t.fetch = _, t.Headers = a, t.Request = m, t.Response = y), e.Headers = a, e.Request = m, e.Response = y, e.fetch = _;
          }({});
        }(n), delete n.fetch.polyfill, e = n.fetch, e.default = n.fetch, e.fetch = n.fetch, e.Headers = n.Headers, e.Request = n.Request, e.Response = n.Response, t.exports = e;
      }, function (t, e, n) {
        var r, i;
        !function (o) {
          if (r = o, void 0 !== (i = "function" == typeof r ? r.call(e, n, e, t) : r) && (t.exports = i), !0, t.exports = o(), !!0) {
            var a = window.Cookies,
              s = window.Cookies = o();
            s.noConflict = function () {
              return window.Cookies = a, s;
            };
          }
        }(function () {
          function t() {
            for (var t = 0, e = {}; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) e[r] = n[r];
            }
            return e;
          }
          function e(n) {
            function r(e, i, o) {
              var a;
              if ("undefined" != typeof document) {
                if (arguments.length > 1) {
                  if (o = t({
                    path: "/"
                  }, r.defaults, o), "number" == typeof o.expires) {
                    var s = new Date();
                    s.setMilliseconds(s.getMilliseconds() + 864e5 * o.expires), o.expires = s;
                  }
                  o.expires = o.expires ? o.expires.toUTCString() : "";
                  try {
                    a = JSON.stringify(i), /^[\{\[]/.test(a) && (i = a);
                  } catch (t) {}
                  i = n.write ? n.write(i, e) : encodeURIComponent(String(i)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), e = encodeURIComponent(String(e)), e = e.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent), e = e.replace(/[\(\)]/g, escape);
                  var u = "";
                  for (var c in o) o[c] && (u += "; " + c, !0 !== o[c] && (u += "=" + o[c]));
                  return document.cookie = e + "=" + i + u;
                }
                e || (a = {});
                for (var l = document.cookie ? document.cookie.split("; ") : [], f = /(%[0-9A-Z]{2})+/g, p = 0; p < l.length; p++) {
                  var d = l[p].split("="),
                    h = d.slice(1).join("=");
                  this.json || '"' !== h.charAt(0) || (h = h.slice(1, -1));
                  try {
                    var m = d[0].replace(f, decodeURIComponent);
                    if (h = n.read ? n.read(h, m) : n(h, m) || h.replace(f, decodeURIComponent), this.json) try {
                      h = JSON.parse(h);
                    } catch (t) {}
                    if (e === m) {
                      a = h;
                      break;
                    }
                    e || (a[m] = h);
                  } catch (t) {}
                }
                return a;
              }
            }
            return r.set = r, r.get = function (t) {
              return r.call(r, t);
            }, r.getJSON = function () {
              return r.apply({
                json: !0
              }, [].slice.call(arguments));
            }, r.defaults = {}, r.remove = function (e, n) {
              r(e, "", t(n, {
                expires: -1
              }));
            }, r.withConverter = e, r;
          }
          return e(function () {});
        });
      }, function (t, e, n) {
        function r(t) {
          var e = this,
            n = a.getValidUrl(t),
            r = t.pkce || "authorization_code" === t.grantType;
          if (this.options = {
            url: g.removeTrailingSlash(n),
            clientId: t.clientId,
            issuer: g.removeTrailingSlash(t.issuer),
            authorizeUrl: g.removeTrailingSlash(t.authorizeUrl),
            userinfoUrl: g.removeTrailingSlash(t.userinfoUrl),
            tokenUrl: g.removeTrailingSlash(t.tokenUrl),
            revokeUrl: g.removeTrailingSlash(t.revokeUrl),
            logoutUrl: g.removeTrailingSlash(t.logoutUrl),
            pkce: r,
            redirectUri: t.redirectUri,
            postLogoutRedirectUri: t.postLogoutRedirectUri,
            responseMode: t.responseMode,
            httpRequestClient: t.httpRequestClient,
            storageUtil: t.storageUtil,
            transformErrorXHR: t.transformErrorXHR,
            headers: t.headers,
            onSessionExpired: t.onSessionExpired
          }, this.options.pkce && !e.features.isPKCESupported()) {
            var c = "PKCE requires a modern browser with encryption support running in a secure context.";
            throw e.features.isHTTPS() || (c += "\nThe current page is not being served with HTTPS protocol. Try using HTTPS."), e.features.hasTextEncoder() || (c += '\n"TextEncoder" is not defined. You may need a polyfill/shim for this browser.'), new o(c);
          }
          this.userAgent = "okta-auth-js-2.13.2", t.maxClockSkew || 0 === t.maxClockSkew ? this.options.maxClockSkew = t.maxClockSkew : this.options.maxClockSkew = s.DEFAULT_MAX_CLOCK_SKEW, this.options.ignoreSignature = !!t.ignoreSignature, e.session = {
            close: g.bind(p.closeSession, null, e),
            exists: g.bind(p.sessionExists, null, e),
            get: g.bind(p.getSession, null, e),
            refresh: g.bind(p.refreshSession, null, e),
            setCookieAndRedirect: g.bind(p.setCookieAndRedirect, null, e)
          }, e.tx = {
            status: g.bind(m.transactionStatus, null, e),
            resume: g.bind(m.resumeTransaction, null, e),
            exists: g.bind(m.transactionExists, null, e),
            introspect: g.bind(m.introspect, null, e)
          }, e.tx.exists._get = function (t) {
            return u.get(t);
          }, e.idToken = {
            authorize: {
              _getLocationHref: function _getLocationHref() {
                return window.location.href;
              }
            }
          }, e.token = {
            getWithoutPrompt: g.bind(d.getWithoutPrompt, null, e),
            getWithPopup: g.bind(d.getWithPopup, null, e),
            getWithRedirect: g.bind(d.getWithRedirect, null, e),
            parseFromUrl: g.bind(d.parseFromUrl, null, e),
            decode: d.decodeToken,
            revoke: g.bind(d.revokeToken, null, e),
            renew: g.bind(d.renewToken, null, e),
            getUserInfo: g.bind(d.getUserInfo, null, e),
            verify: g.bind(d.verifyToken, null, e)
          }, e.token.getWithRedirect._setLocation = function (t) {
            window.location = t;
          }, e.token.parseFromUrl._getHistory = function () {
            return window.history;
          }, e.token.parseFromUrl._getLocation = function () {
            return window.location;
          }, e.token.parseFromUrl._getDocument = function () {
            return window.document;
          }, e.fingerprint._getUserAgent = function () {
            return navigator.userAgent;
          };
          var l = /windows phone|iemobile|wpdesktop/i;
          e.features.isFingerprintSupported = function () {
            var t = e.fingerprint._getUserAgent();
            return t && !l.test(t);
          }, e.emitter = new i(), e.tokenManager = new h(e, t.tokenManager), e.tokenManager.on("error", this._onTokenManagerError, this);
        }
        n(16);
        var i = n(18),
          o = n(1),
          a = n(19),
          s = n(2),
          u = n(4).storage,
          c = n(3),
          l = n(10),
          f = n(5),
          p = n(24),
          d = n(25),
          h = n(29),
          m = n(7),
          g = n(0),
          v = r.prototype;
        v._onTokenManagerError = function (t) {
          "login_required" === t.errorCode && t.accessToken && this.options.onSessionExpired && this.options.onSessionExpired();
        }, v.features = {}, v.features.isPopupPostMessageSupported = function () {
          var t = document.documentMode && document.documentMode < 10;
          return !(!window.postMessage || t);
        }, v.features.isTokenVerifySupported = function () {
          return "undefined" != typeof crypto && crypto.subtle && "undefined" != typeof Uint8Array;
        }, v.features.hasTextEncoder = function () {
          return "undefined" != typeof TextEncoder;
        }, v.features.isPKCESupported = function () {
          return v.features.isTokenVerifySupported() && v.features.hasTextEncoder();
        }, v.features.isHTTPS = function () {
          return "https:" === window.location.protocol;
        }, v.signIn = function (t) {
          function e(e) {
            return delete t.sendFingerprint, m.postToTransaction(n, "/api/v1/authn", t, e);
          }
          var n = this;
          return t = g.clone(t || {}), t.sendFingerprint ? n.fingerprint().then(function (t) {
            return e({
              headers: {
                "X-Device-Fingerprint": t
              }
            });
          }) : e();
        }, v.signOut = function (t) {
          function e() {
            return a.session.close().catch(function (t) {
              if ("AuthApiError" !== t.name) throw t;
            });
          }
          t = g.extend({}, t);
          var n = t.postLogoutRedirectUri || this.options.postLogoutRedirectUri,
            r = t.accessToken,
            i = t.revokeAccessToken,
            o = t.idToken,
            a = this,
            s = l.getOAuthUrls(a).logoutUrl;
          return f.allSettled([function () {
            return new f().then(function () {
              return i && void 0 === r ? a.tokenManager.get("token") : r;
            });
          }(), function () {
            return new f().then(function () {
              return n && void 0 === o ? a.tokenManager.get("idToken") : o;
            });
          }()]).then(function (t) {
            if (r = t[0].value, o = t[1].value, a.tokenManager.clear(), i && r) return a.token.revoke(r).catch(function (t) {
              if ("AuthApiError" !== t.name) throw t;
            });
          }).then(function () {
            if (!n) return e();
            if (!o) return e().catch(function (t) {}).then(function () {
              window.location.assign(n);
            });
            var r = t.state,
              i = o.idToken,
              a = s + "?id_token_hint=" + encodeURIComponent(i) + "&post_logout_redirect_uri=" + encodeURIComponent(n);
            r && (a += "&state=" + encodeURIComponent(r)), window.location.assign(a);
          });
        }, a.addSharedPrototypes(v), v.webfinger = function (t) {
          var e = "/.well-known/webfinger" + g.toQueryParams(t),
            n = {
              headers: {
                Accept: "application/jrd+json"
              }
            };
          return c.get(this, e, n);
        }, v.fingerprint = function (t) {
          function e(t) {
            if (t && t.data && t.origin === n.options.url) {
              try {
                var e = JSON.parse(t.data);
              } catch (t) {
                return r.reject(new o("Unable to parse iframe response"));
              }
              if (e) return "FingerprintAvailable" === e.type ? r.resolve(e.fingerprint) : void ("FingerprintServiceReady" === e.type && t.source.postMessage(JSON.stringify({
                type: "GetFingerprint"
              }), t.origin));
            }
          }
          t = t || {};
          var n = this;
          if (!n.features.isFingerprintSupported()) return f.reject(new o("Fingerprinting is not supported on this device"));
          var r = f.defer(),
            i = document.createElement("iframe");
          i.style.display = "none", l.addListener(window, "message", e), i.src = n.options.url + "/auth/services/devicefingerprint", document.body.appendChild(i);
          var a = setTimeout(function () {
            r.reject(new o("Fingerprinting timed out"));
          }, t.timeout || 15e3);
          return r.promise.fin(function () {
            clearTimeout(a), l.removeListener(window, "message", e), document.body.contains(i) && i.parentElement.removeChild(i);
          });
        }, t.exports = a.buildOktaAuth(r);
      }, function (t, e, n) {
        n(17), Array.prototype.indexOf || (Array.prototype.indexOf = function (t, e) {
          var n;
          if (null == this) throw new TypeError('"this" is null or not defined');
          var r = Object(this),
            i = r.length >>> 0;
          if (0 === i) return -1;
          var o = +e || 0;
          if (Math.abs(o) === 1 / 0 && (o = 0), o >= i) return -1;
          for (n = Math.max(o >= 0 ? o : i - Math.abs(o), 0); n < i;) {
            if (n in r && r[n] === t) return n;
            n++;
          }
          return -1;
        }), Array.isArray || (Array.isArray = function (t) {
          return "[object Array]" === Object.prototype.toString.call(t);
        });
      }, function (t, e, n) {
        !function () {
          function t(t) {
            this.message = t;
          }
          var n = e,
            r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          t.prototype = new Error(), t.prototype.name = "InvalidCharacterError", n.btoa || (n.btoa = function (e) {
            for (var n, i, o = String(e), a = 0, s = r, u = ""; o.charAt(0 | a) || (s = "=", a % 1); u += s.charAt(63 & n >> 8 - a % 1 * 8)) {
              if ((i = o.charCodeAt(a += .75)) > 255) throw new t("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
              n = n << 8 | i;
            }
            return u;
          }), n.atob || (n.atob = function (e) {
            var n = String(e).replace(/=+$/, "");
            if (n.length % 4 == 1) throw new t("'atob' failed: The string to be decoded is not correctly encoded.");
            for (var i, o, a = 0, s = 0, u = ""; o = n.charAt(s++); ~o && (i = a % 4 ? 64 * i + o : o, a++ % 4) ? u += String.fromCharCode(255 & i >> (-2 * a & 6)) : 0) o = r.indexOf(o);
            return u;
          });
        }();
      }, function (t, e) {
        function n() {}
        n.prototype = {
          on: function on(t, e, n) {
            var r = this.e || (this.e = {});
            return (r[t] || (r[t] = [])).push({
              fn: e,
              ctx: n
            }), this;
          },
          once: function once(t, e, n) {
            function r() {
              i.off(t, r), e.apply(n, arguments);
            }
            var i = this;
            return r._ = e, this.on(t, r, n);
          },
          emit: function emit(t) {
            var e = [].slice.call(arguments, 1),
              n = ((this.e || (this.e = {}))[t] || []).slice(),
              r = 0,
              i = n.length;
            for (r; r < i; r++) n[r].fn.apply(n[r].ctx, e);
            return this;
          },
          off: function off(t, e) {
            var n = this.e || (this.e = {}),
              r = n[t],
              i = [];
            if (r && e) for (var o = 0, a = r.length; o < a; o++) r[o].fn !== e && r[o].fn._ !== e && i.push(r[o]);
            return i.length ? n[t] = i : delete n[t], this;
          }
        }, t.exports = n;
      }, function (t, e, n) {
        function r(t) {
          if (!t) throw new a("No arguments passed to constructor. Required usage: new OktaAuth(args)");
          var e = t.url;
          if (!e) {
            var n = new RegExp("^http?s?://.+");
            if (!t.issuer || !n.test(t.issuer)) throw new a('No url passed to constructor. Required usage: new OktaAuth({url: "https://{yourOktaDomain}.com"})');
            e = t.issuer.split("/oauth2/")[0];
          }
          if (-1 !== e.indexOf("-admin.")) throw new a('URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({url: "https://{yourOktaDomain}.com})');
          return e;
        }
        function i(t) {
          t.forgotPassword = function (t) {
            return s.postToTransaction(this, "/api/v1/authn/recovery/password", t);
          }, t.unlockAccount = function (t) {
            return s.postToTransaction(this, "/api/v1/authn/recovery/unlock", t);
          }, t.verifyRecoveryToken = function (t) {
            return s.postToTransaction(this, "/api/v1/authn/recovery/token", t);
          };
        }
        function o(t) {
          return function (e, n) {
            function r(i) {
              if (!(this instanceof r)) return new r(i);
              i && (i.storageUtil = e, i.ajaxRequest ? (u.deprecate("ajaxRequest is being deprecated, use httpRequestClient attribute instead."), i.httpRequestClient = i.ajaxRequest) : i.httpRequestClient || (i.httpRequestClient = n)), u.bind(t, this)(i);
            }
            return r.prototype = t.prototype, r.prototype.constructor = r, r.features = t.prototype.features, r;
          };
        }
        var a = n(1),
          s = n(7),
          u = n(0);
        t.exports = {
          addSharedPrototypes: i,
          buildOktaAuth: o,
          getValidUrl: r
        };
      }, function (t, e, n) {
        (function (t) {
          function r(t, e) {
            this._id = t, this._clearFn = e;
          }
          var i = void 0 !== t && t || "undefined" != typeof self && self || window,
            o = Function.prototype.apply;
          e.setTimeout = function () {
            return new r(o.call(setTimeout, i, arguments), clearTimeout);
          }, e.setInterval = function () {
            return new r(o.call(setInterval, i, arguments), clearInterval);
          }, e.clearTimeout = e.clearInterval = function (t) {
            t && t.close();
          }, r.prototype.unref = r.prototype.ref = function () {}, r.prototype.close = function () {
            this._clearFn.call(i, this._id);
          }, e.enroll = function (t, e) {
            clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
          }, e.unenroll = function (t) {
            clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
          }, e._unrefActive = e.active = function (t) {
            clearTimeout(t._idleTimeoutId);
            var e = t._idleTimeout;
            e >= 0 && (t._idleTimeoutId = setTimeout(function () {
              t._onTimeout && t._onTimeout();
            }, e));
          }, n(21), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
        }).call(e, n(9));
      }, function (t, e, n) {
        (function (t, e) {
          !function (t, n) {
            "use strict";

            function r(t) {
              "function" != typeof t && (t = new Function("" + t));
              for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) e[n] = arguments[n + 1];
              var r = {
                callback: t,
                args: e
              };
              return c[u] = r, s(u), u++;
            }
            function i(t) {
              delete c[t];
            }
            function o(t) {
              var e = t.callback,
                r = t.args;
              switch (r.length) {
                case 0:
                  e();
                  break;
                case 1:
                  e(r[0]);
                  break;
                case 2:
                  e(r[0], r[1]);
                  break;
                case 3:
                  e(r[0], r[1], r[2]);
                  break;
                default:
                  e.apply(n, r);
              }
            }
            function a(t) {
              if (l) setTimeout(a, 0, t);else {
                var e = c[t];
                if (e) {
                  l = !0;
                  try {
                    o(e);
                  } finally {
                    i(t), l = !1;
                  }
                }
              }
            }
            if (!t.setImmediate) {
              var s,
                u = 1,
                c = {},
                l = !1,
                f = t.document,
                p = Object.getPrototypeOf && Object.getPrototypeOf(t);
              p = p && p.setTimeout ? p : t, "[object process]" === {}.toString.call(t.process) ? function () {
                s = function s(t) {
                  e.nextTick(function () {
                    a(t);
                  });
                };
              }() : function () {
                if (t.postMessage && !t.importScripts) {
                  var e = !0,
                    n = t.onmessage;
                  return t.onmessage = function () {
                    e = !1;
                  }, t.postMessage("", "*"), t.onmessage = n, e;
                }
              }() ? function () {
                var e = "setImmediate$" + Math.random() + "$",
                  n = function n(_n) {
                    _n.source === t && "string" == typeof _n.data && 0 === _n.data.indexOf(e) && a(+_n.data.slice(e.length));
                  };
                t.addEventListener ? t.addEventListener("message", n, !1) : t.attachEvent("onmessage", n), s = function s(n) {
                  t.postMessage(e + n, "*");
                };
              }() : t.MessageChannel ? function () {
                var t = new MessageChannel();
                t.port1.onmessage = function (t) {
                  a(t.data);
                }, s = function s(e) {
                  t.port2.postMessage(e);
                };
              }() : f && "onreadystatechange" in f.createElement("script") ? function () {
                var t = f.documentElement;
                s = function s(e) {
                  var n = f.createElement("script");
                  n.onreadystatechange = function () {
                    a(e), n.onreadystatechange = null, t.removeChild(n), n = null;
                  }, t.appendChild(n);
                };
              }() : function () {
                s = function s(t) {
                  setTimeout(a, 0, t);
                };
              }(), p.setImmediate = r, p.clearImmediate = i;
            }
          }("undefined" == typeof self ? void 0 === t ? this : t : self);
        }).call(e, n(9), n(8));
      }, function (t, e) {
        function n(t, e) {
          this.name = "AuthApiError", this.message = t.errorSummary, this.errorSummary = t.errorSummary, this.errorCode = t.errorCode, this.errorLink = t.errorLink, this.errorId = t.errorId, this.errorCauses = t.errorCauses, e && (this.xhr = e);
        }
        n.prototype = new Error(), t.exports = n;
      }, function (t, e) {
        function n() {
          this.name = "AuthPollStopError", this.message = "The poll was stopped by the sdk";
        }
        n.prototype = new Error(), t.exports = n;
      }, function (t, e, n) {
        function r(t) {
          return t.session.get().then(function (t) {
            return "ACTIVE" === t.status;
          }).fail(function () {
            return !1;
          });
        }
        function i(t) {
          return c.get(t, "/api/v1/sessions/me").then(function (e) {
            var n = u.omit(e, "_links");
            return n.refresh = function () {
              return c.post(t, u.getLink(e, "refresh").href);
            }, n.user = function () {
              return c.get(t, u.getLink(e, "user").href);
            }, n;
          }).fail(function () {
            return {
              status: "INACTIVE"
            };
          });
        }
        function o(t) {
          return c.httpRequest(t, {
            url: t.options.url + "/api/v1/sessions/me",
            method: "DELETE"
          });
        }
        function a(t) {
          return c.post(t, "/api/v1/sessions/me/lifecycle/refresh");
        }
        function s(t, e, n) {
          n = n || window.location.href, window.location = t.options.url + "/login/sessionCookieRedirect" + u.toQueryParams({
            checkAccountSetupComplete: !0,
            token: e,
            redirectUrl: n
          });
        }
        var u = n(0),
          c = n(3);
        t.exports = {
          sessionExists: r,
          getSession: i,
          closeSession: o,
          refreshSession: a,
          setCookieAndRedirect: s
        };
      }, function (t, e, n) {
        function r(t, e) {
          return new A().then(function () {
            if (!e || !e.accessToken) throw new C("A valid access token object is required");
            var n = t.options.clientId;
            if (!n) throw new C("A clientId must be specified in the OktaAuth constructor to revoke a token");
            var r = k.getOAuthUrls(t).revokeUrl,
              i = e.accessToken,
              o = T.toQueryParams({
                token_type_hint: "access_token",
                token: i
              }).slice(1),
              a = btoa(n);
            return E.post(t, r, o, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Basic " + a
              }
            });
          });
        }
        function i(t) {
          var e,
            n = t.split(".");
          try {
            e = {
              header: JSON.parse(T.base64UrlToString(n[0])),
              payload: JSON.parse(T.base64UrlToString(n[1])),
              signature: n[2]
            };
          } catch (t) {
            throw new C("Malformed token");
          }
          return e;
        }
        function o(t, e, n) {
          return new A().then(function () {
            if (!e || !e.idToken) throw new C("Only idTokens may be verified");
            var r = i(e.idToken),
              o = {
                clientId: t.options.clientId,
                issuer: t.options.issuer || t.options.url,
                ignoreSignature: t.options.ignoreSignature
              };
            return T.extend(o, n), k.validateClaims(t, r.payload, o), 1 != o.ignoreSignature && t.features.isTokenVerifySupported() ? k.getKey(t, e.issuer, r.header.kid).then(function (t) {
              return O.verifyToken(e.idToken, t);
            }).then(function (t) {
              if (!t) throw new C("The token signature is not valid");
              return e;
            }) : e;
          });
        }
        function a(t, e, n) {
          function r(e) {
            if (e.data && e.data.state === n) return e.origin !== t.options.url ? i.reject(new C("The request does not match client configuration")) : void i.resolve(e.data);
          }
          var i = A.defer();
          return k.addListener(window, "message", r), i.promise.timeout(e || 12e4, new C("OAuth flow timed out")).fin(function () {
            k.removeListener(window, "message", r);
          });
        }
        function s(t, e, n) {
          function r() {
            try {
              e && e.location && e.location.hash ? i.resolve(k.hashToObject(e.location.hash)) : e && !e.closed && setTimeout(r, 500);
            } catch (t) {
              setTimeout(r, 500);
            }
          }
          var i = A.defer();
          return r(), i.promise.timeout(n || 12e4, new C("OAuth flow timed out"));
        }
        function u(t, e, n, r) {
          var i = N.loadMeta(t),
            o = {
              clientId: e.clientId,
              authorizationCode: n,
              codeVerifier: i.codeVerifier,
              redirectUri: i.redirectUri
            };
          return N.getToken(t, o, r).then(function (t) {
            return c(t, o), t;
          }).fin(function () {
            N.clearMeta(t);
          });
        }
        function c(t, e) {
          if (t.error || t.error_description) throw new I(t.error, t.error_description);
          if (t.state !== e.state) throw new C("OAuth flow response state doesn't match request state");
        }
        function l(t, e, n, r) {
          r = r || {};
          var i = e.responseType,
            a = T.clone(e.scopes),
            s = e.clientId || t.options.clientId;
          return new A().then(function () {
            return c(n, e), n.code ? (i = ["token", "id_token"], u(t, e, n.code, r)) : n;
          }).then(function (n) {
            var i = {};
            if (n.access_token && (i.token = {
              accessToken: n.access_token,
              expiresAt: Number(n.expires_in) + Math.floor(Date.now() / 1e3),
              tokenType: n.token_type,
              scopes: a,
              authorizeUrl: r.authorizeUrl,
              userinfoUrl: r.userinfoUrl
            }), n.id_token) {
              var u = t.token.decode(n.id_token),
                c = {
                  idToken: n.id_token,
                  claims: u.payload,
                  expiresAt: u.payload.exp,
                  scopes: a,
                  authorizeUrl: r.authorizeUrl,
                  issuer: r.issuer,
                  clientId: s
                },
                l = {
                  clientId: s,
                  issuer: r.issuer,
                  nonce: e.nonce
                };
              return void 0 !== e.ignoreSignature && (l.ignoreSignature = e.ignoreSignature), o(t, c, l).then(function () {
                return i.id_token = c, i;
              });
            }
            return i;
          }).then(function (t) {
            return Array.isArray(i) ? (["token", "id_token"].filter(function (t) {
              return -1 !== i.indexOf(t);
            }).forEach(function (e) {
              if (!t[e]) throw new C("Unable to parse OAuth flow response: " + e + " was not returned.");
            }), i.map(function (e) {
              return t[e];
            })) : t[i];
          });
        }
        function f(t) {
          return {
            pkce: t.options.pkce || !1,
            clientId: t.options.clientId,
            redirectUri: t.options.redirectUri || window.location.href,
            responseType: "id_token",
            responseMode: "okta_post_message",
            state: k.generateState(),
            nonce: k.generateNonce(),
            scopes: ["openid", "email"],
            ignoreSignature: t.options.ignoreSignature
          };
        }
        function p(t) {
          if (!t.clientId) throw new C("A clientId must be specified in the OktaAuth constructor to get a token");
          if (T.isString(t.responseType) && -1 !== t.responseType.indexOf(" ")) throw new C("Multiple OAuth responseTypes must be defined as an array");
          var e = T.removeNils({
            client_id: t.clientId,
            code_challenge: t.codeChallenge,
            code_challenge_method: t.codeChallengeMethod,
            display: t.display,
            idp: t.idp,
            idp_scope: t.idpScope,
            login_hint: t.loginHint,
            max_age: t.maxAge,
            nonce: t.nonce,
            prompt: t.prompt,
            redirect_uri: t.redirectUri,
            response_mode: t.responseMode,
            response_type: t.responseType,
            sessionToken: t.sessionToken,
            state: t.state
          });
          if (["idp_scope", "response_type"].forEach(function (t) {
            Array.isArray(e[t]) && (e[t] = e[t].join(" "));
          }), -1 !== t.responseType.indexOf("id_token") && -1 === t.scopes.indexOf("openid")) throw new C("openid scope must be specified in the scopes argument when requesting an id_token");
          return e.scope = t.scopes.join(" "), e;
        }
        function d(t) {
          var e = p(t);
          return T.toQueryParams(e);
        }
        function h(t, e, n) {
          return e = e || {}, n = n || {}, v(t, e).then(function (r) {
            function i(t) {
              return /^(https?\:\/\/)?([^:\/?#]*(?:\:[0-9]+)?)/.exec(t)[0];
            }
            function o(t) {
              if (!t || t.closed) return S.reject(new C("Unable to parse OAuth flow response")), !0;
            }
            var u = {
                prompt: "none",
                responseMode: "okta_post_message",
                display: null
              },
              c = {
                display: "popup"
              };
            e.sessionToken ? T.extend(r, u) : e.idp && T.extend(r, c);
            var f, p, h;
            try {
              h = k.getOAuthUrls(t, r, n), p = e.codeVerifier ? h.tokenUrl : h.authorizeUrl, f = p + d(r);
            } catch (t) {
              return A.reject(t);
            }
            switch (r.sessionToken || null === r.display ? "IFRAME" : "popup" === r.display ? "POPUP" : "IMPLICIT") {
              case "IFRAME":
                var m = a(t, n.timeout, r.state),
                  g = k.loadFrame(f);
                return m.then(function (e) {
                  return l(t, r, e, h);
                }).fin(function () {
                  document.body.contains(g) && g.parentElement.removeChild(g);
                });
              case "POPUP":
                var v;
                if ("okta_post_message" === r.responseMode) {
                  if (!t.features.isPopupPostMessageSupported()) return A.reject(new C("This browser doesn't have full postMessage support"));
                  v = a(t, n.timeout, r.state);
                }
                var y = {
                    popupTitle: n.popupTitle
                  },
                  _ = k.loadPopup(f, y);
                if ("fragment" === r.responseMode) {
                  var b = i(t.idToken.authorize._getLocationHref()),
                    w = i(r.redirectUri);
                  if (b !== w) return A.reject(new C("Using fragment, the redirectUri origin (" + w + ") must match the origin of this page (" + b + ")"));
                  v = s(t, _, n.timeout);
                }
                var S = A.defer(),
                  x = setInterval(function () {
                    o(_) && clearInterval(x);
                  }, 500);
                return v.then(function (t) {
                  S.resolve(t);
                }).fail(function (t) {
                  S.reject(t);
                }), S.promise.then(function (e) {
                  return l(t, r, e, h);
                }).fin(function () {
                  clearInterval(x), _ && !_.closed && _.close();
                });
              default:
                return A.reject(new C("The full page redirect flow is not supported"));
            }
          });
        }
        function m(t, e, n) {
          var r = T.clone(e) || {};
          return T.extend(r, {
            prompt: "none",
            responseMode: "okta_post_message",
            display: null
          }), h(t, r, n);
        }
        function g(t, e, n) {
          var r = T.clone(e) || {};
          return T.extend(r, {
            display: "popup",
            responseMode: "okta_post_message"
          }), h(t, r, n);
        }
        function v(t, e) {
          e = T.clone(e) || {}, "authorization_code" === e.grantType && (e.pkce = !0);
          var n = f(t);
          return T.extend(n, e), !0 !== n.pkce ? A.resolve(n) : t.features.isPKCESupported() ? (n.codeChallengeMethod || (n.codeChallengeMethod = N.DEFAULT_CODE_CHALLENGE_METHOD), n.responseType = "code", k.getWellKnown(t, null).then(function (t) {
            if (-1 === (t.code_challenge_methods_supported || []).indexOf(n.codeChallengeMethod)) throw new C("Invalid code_challenge_method");
          }).then(function () {
            var e = N.generateVerifier(n.codeVerifier),
              r = {
                codeVerifier: e,
                redirectUri: n.redirectUri
              };
            return N.saveMeta(t, r), N.computeChallenge(e);
          }).then(function (t) {
            var e = T.clone(n) || {};
            return T.extend(e, n, {
              codeChallenge: t
            }), e;
          })) : A.reject(new C("This browser doesn't support PKCE"));
        }
        function y(t, e, n) {
          return e = T.clone(e) || {}, v(t, e).then(function (r) {
            e.responseMode || (r.responseType.includes("code") && !r.pkce ? r.responseMode = "query" : r.responseMode = t.options.responseMode || "fragment");
            var i = k.getOAuthUrls(t, r, n),
              o = i.authorizeUrl + d(r),
              a = "https:" === window.location.protocol,
              s = {
                secure: a,
                sameSite: a ? "none" : "lax"
              };
            P.set(R.REDIRECT_OAUTH_PARAMS_COOKIE_NAME, JSON.stringify({
              responseType: r.responseType,
              state: r.state,
              nonce: r.nonce,
              scopes: r.scopes,
              clientId: r.clientId,
              urls: i,
              ignoreSignature: r.ignoreSignature
            }), null, s), P.set(R.REDIRECT_NONCE_COOKIE_NAME, r.nonce, null, s), P.set(R.REDIRECT_STATE_COOKIE_NAME, r.state, null, s), t.token.getWithRedirect._setLocation(o);
          });
        }
        function _(t, e) {
          if (!k.isToken(e)) return A.reject(new C("Renew must be passed a token with an array of scopes and an accessToken or idToken"));
          var n;
          return n = t.options.pkce ? "code" : e.accessToken ? "token" : "id_token", t.token.getWithoutPrompt({
            responseType: n,
            scopes: e.scopes
          }, {
            authorizeUrl: e.authorizeUrl,
            userinfoUrl: e.userinfoUrl,
            issuer: e.issuer
          });
        }
        function b(t) {
          var e = t.token.parseFromUrl._getHistory(),
            n = t.token.parseFromUrl._getDocument(),
            r = t.token.parseFromUrl._getLocation();
          e && e.replaceState ? e.replaceState(null, n.title, r.pathname + r.search) : r.hash = "";
        }
        function w(t) {
          var e = t.token.parseFromUrl._getHistory(),
            n = t.token.parseFromUrl._getDocument(),
            r = t.token.parseFromUrl._getLocation();
          e && e.replaceState ? e.replaceState(null, n.title, r.pathname + r.hash) : r.search = "";
        }
        function S(t, e) {
          e = e || {}, T.isString(e) && (e = {
            url: e
          });
          var n,
            r = e.url,
            i = e.responseMode || t.options.responseMode || "fragment",
            o = t.token.parseFromUrl._getLocation();
          if (!(n = "query" === i ? r ? r.substring(r.indexOf("?")) : o.search : r ? r.substring(r.indexOf("#")) : o.hash)) return A.reject(new C("Unable to parse a token from the url"));
          var a = P.get(R.REDIRECT_OAUTH_PARAMS_COOKIE_NAME);
          if (!a) return A.reject(new C("Unable to retrieve OAuth redirect params cookie"));
          try {
            var s = JSON.parse(a),
              u = s.urls;
            delete s.urls, P.delete(R.REDIRECT_OAUTH_PARAMS_COOKIE_NAME);
          } catch (t) {
            return A.reject(new C("Unable to parse the " + R.REDIRECT_OAUTH_PARAMS_COOKIE_NAME + " cookie: " + t.message));
          }
          return A.resolve(k.urlParamsToObject(n)).then(function (e) {
            return r || ("query" === i ? w(t) : b(t)), l(t, s, e, u);
          });
        }
        function x(t, e) {
          return e && (k.isToken(e) || e.accessToken || e.userinfoUrl) ? E.httpRequest(t, {
            url: e.userinfoUrl,
            method: "GET",
            accessToken: e.accessToken
          }).fail(function (t) {
            if (t.xhr && (401 === t.xhr.status || 403 === t.xhr.status)) {
              var e;
              if (t.xhr.headers && T.isFunction(t.xhr.headers.get) && t.xhr.headers.get("WWW-Authenticate") ? e = t.xhr.headers.get("WWW-Authenticate") : T.isFunction(t.xhr.getResponseHeader) && (e = t.xhr.getResponseHeader("WWW-Authenticate")), e) {
                var n = e.match(/error="(.*?)"/) || [],
                  r = e.match(/error_description="(.*?)"/) || [],
                  i = n[1],
                  o = r[1];
                i && o && (t = new I(i, o));
              }
            }
            throw t;
          }) : A.reject(new C("getUserInfo requires an access token object"));
        }
        var E = n(3),
          T = n(0),
          k = n(10),
          A = n(5),
          O = n(26),
          C = n(1),
          I = n(27),
          R = n(2),
          P = n(4).storage,
          N = n(28);
        t.exports = {
          revokeToken: r,
          getToken: h,
          getWithoutPrompt: m,
          getWithPopup: g,
          getWithRedirect: y,
          parseFromUrl: S,
          decodeToken: i,
          renewToken: _,
          getUserInfo: x,
          verifyToken: o,
          handleOAuthResponse: l,
          prepareOauthParams: v
        };
      }, function (t, e, n) {
        function r(t, e) {
          e = i.clone(e);
          var n = {
              name: "RSASSA-PKCS1-v1_5",
              hash: {
                name: "SHA-256"
              }
            },
            r = ["verify"];
          return delete e.use, crypto.subtle.importKey("jwk", e, n, !0, r).then(function (e) {
            var r = t.split("."),
              o = i.stringToBuffer(r[0] + "." + r[1]),
              a = i.base64UrlDecode(r[2]),
              s = i.stringToBuffer(a);
            return crypto.subtle.verify(n, e, s, o);
          });
        }
        var i = n(0);
        t.exports = {
          verifyToken: r
        };
      }, function (t, e) {
        function n(t, e) {
          this.name = "OAuthError", this.message = e, this.errorCode = t, this.errorSummary = e;
        }
        n.prototype = new Error(), t.exports = n;
      }, function (t, e, n) {
        function r(t) {
          return ("0" + t.toString(16)).substr(-2);
        }
        function i(t) {
          var e = new Uint8Array(Math.ceil(t / 2));
          return crypto.getRandomValues(e), Array.from(e, r).join("").slice(0, t);
        }
        function o(t) {
          var e = t || "";
          return e.length < g && (e += i(g - e.length)), encodeURIComponent(e).slice(0, v);
        }
        function a(t, e) {
          t.options.storageUtil.getPKCEStorage().setStorage(e);
        }
        function s(t) {
          return t.options.storageUtil.getPKCEStorage().getStorage();
        }
        function u(t) {
          t.options.storageUtil.getPKCEStorage().clearStorage();
        }
        function c(t) {
          var e = new TextEncoder().encode(t);
          return crypto.subtle.digest("SHA-256", e).then(function (t) {
            var e = String.fromCharCode.apply(null, new Uint8Array(t));
            return m.stringToBase64Url(e);
          });
        }
        function l(t) {
          if (!t.clientId) throw new d("A clientId must be specified in the OktaAuth constructor to get a token");
          if (!t.redirectUri) throw new d("The redirectUri passed to /authorize must also be passed to /token");
          if (!t.authorizationCode) throw new d("An authorization code (returned from /authorize) must be passed to /token");
          if (!t.codeVerifier) throw new d('The "codeVerifier" (generated and saved by your app) must be passed to /token');
        }
        function f(t) {
          var e = m.removeNils({
            client_id: t.clientId,
            redirect_uri: t.redirectUri,
            grant_type: "authorization_code",
            code: t.authorizationCode,
            code_verifier: t.codeVerifier
          });
          return m.toQueryParams(e).slice(1);
        }
        function p(t, e, n) {
          l(e);
          var r = f(e);
          return h.httpRequest(t, {
            url: n.tokenUrl,
            method: "POST",
            args: r,
            withCredentials: !1,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          });
        }
        var d = n(1),
          h = n(3),
          m = n(0),
          g = 43,
          v = 128;
        t.exports = {
          DEFAULT_CODE_CHALLENGE_METHOD: "S256",
          generateVerifier: o,
          clearMeta: u,
          saveMeta: a,
          loadMeta: s,
          computeChallenge: c,
          getToken: p
        };
      }, function (t, e, n) {
        function r(t, e) {
          return e.expiresAt - t.options.expireEarlySeconds;
        }
        function i(t, e) {
          return r(t, e) <= t.clock.now();
        }
        function o(t, e, n) {
          t.emitter.emit("expired", e, n);
        }
        function a(t, e) {
          t.emitter.emit("error", e);
        }
        function s(t, e) {
          clearTimeout(t.expireTimeouts[e]), delete t.expireTimeouts[e], delete t.renewPromise[e];
        }
        function u(t) {
          var e = t.expireTimeouts;
          for (var n in e) e.hasOwnProperty(n) && s(t, n);
        }
        function c(t, e, n, i) {
          var a = r(e, i),
            u = 1e3 * Math.max(a - e.clock.now(), 0);
          s(e, n);
          var c = setTimeout(function () {
            o(e, n, i);
          }, u);
          e.expireTimeouts[n] = c;
        }
        function l(t, e, n) {
          try {
            var r = n.getStorage();
          } catch (t) {
            return void a(e, t);
          }
          for (var i in r) if (r.hasOwnProperty(i)) {
            var o = r[i];
            c(t, e, i, o);
          }
        }
        function f(t, e, n, r, i) {
          var o = n.getStorage();
          if (!y.isObject(i) || !i.scopes || !i.expiresAt && 0 !== i.expiresAt || !i.idToken && !i.accessToken) throw new _("Token must be an Object with scopes, expiresAt, and an idToken or accessToken properties");
          o[r] = i, n.setStorage(o), c(t, e, r, i);
        }
        function p(t, e) {
          return t.getStorage()[e];
        }
        function d(t, e, n, r) {
          return w.Promise(function (o) {
            var a = p(n, r);
            return o(a && i(e, a) ? e.options.autoRenew ? m(t, e, n, r) : h(e, n, r) : a);
          });
        }
        function h(t, e, n) {
          s(t, n);
          var r = e.getStorage();
          delete r[n], e.setStorage(r);
        }
        function m(t, e, n, r) {
          var i = e.renewPromise[r];
          if (i) return i;
          try {
            var o = p(n, r);
            if (!o) throw new _("The tokenManager has no token for the key: " + r);
          } catch (t) {
            return w.reject(t);
          }
          return s(e, r), e.renewPromise[r] = t.token.renew(o).then(function (i) {
            var a = i;
            i instanceof Array && (a = i.find(function (t) {
              return t.idToken && o.idToken || t.accessToken && o.accessToken;
            }));
            var s = p(n, r);
            if (s) return f(t, e, n, r, a), e.emitter.emit("renewed", r, a, s), a;
          }).catch(function (t) {
            throw "OAuthError" !== t.name && "AuthSdkError" !== t.name || (h(e, n, r), t.tokenKey = r, t.accessToken = !!o.accessToken, a(e, t)), t;
          }).finally(function () {
            delete e.renewPromise[r];
          }), e.renewPromise[r];
        }
        function g(t, e) {
          u(t), e.clearStorage();
        }
        function v(t, e) {
          e = y.extend({}, T, y.removeNils(e)), "localStorage" !== e.storage || b.browserHasLocalStorage() || (y.warn("This browser doesn't support localStorage. Switching to sessionStorage."), e.storage = "sessionStorage"), "sessionStorage" !== e.storage || b.browserHasSessionStorage() || (y.warn("This browser doesn't support sessionStorage. Switching to cookie-based storage."), e.storage = "cookie");
          var n;
          if ("object" == typeof e.storage) n = e.storage;else switch (e.storage) {
            case "localStorage":
              n = localStorage;
              break;
            case "sessionStorage":
              n = sessionStorage;
              break;
            case "cookie":
              n = b.getCookieStorage(e);
              break;
            case "memory":
              n = b.getInMemoryStorage();
              break;
            default:
              throw new _("Unrecognized storage option");
          }
          var r = e.storageKey || S.TOKEN_STORAGE_NAME,
            i = x(n, r),
            o = E.create(t, e),
            a = {
              clock: o,
              options: e,
              emitter: t.emitter,
              expireTimeouts: {},
              renewPromise: {}
            };
          this.add = y.bind(f, this, t, a, i), this.get = y.bind(d, this, t, a, i), this.remove = y.bind(h, this, a, i), this.clear = y.bind(g, this, a, i), this.renew = y.bind(m, this, t, a, i), this.on = y.bind(a.emitter.on, a.emitter), this.off = y.bind(a.emitter.off, a.emitter), l(t, a, i);
        }
        var y = n(0),
          _ = n(1),
          b = n(4),
          w = n(5),
          S = n(2),
          x = n(6),
          E = n(30),
          T = {
            autoRenew: !0,
            storage: "localStorage",
            expireEarlySeconds: 30
          };
        t.exports = v;
      }, function (t, e, n) {
        function r(t) {
          this.localOffset = parseInt(t || 0);
        }
        n(0).extend(r.prototype, {
          now: function now() {
            return (Date.now() + this.localOffset) / 1e3;
          }
        }), r.create = function () {
          return new r(0);
        }, t.exports = r;
      }]);
    });
  }]);
});